var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));

// ../../node_modules/lodash/lodash.js
var require_lodash = __commonJS({
  "../../node_modules/lodash/lodash.js"(exports, module) {
    "use strict";
    (function() {
      var undefined2;
      var VERSION = "4.17.21";
      var LARGE_ARRAY_SIZE = 200;
      var CORE_ERROR_TEXT = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", FUNC_ERROR_TEXT = "Expected a function", INVALID_TEMPL_VAR_ERROR_TEXT = "Invalid `variable` option passed into `_.template`";
      var HASH_UNDEFINED = "__lodash_hash_undefined__";
      var MAX_MEMOIZE_SIZE = 500;
      var PLACEHOLDER = "__lodash_placeholder__";
      var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
      var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
      var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
      var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = "...";
      var HOT_COUNT = 800, HOT_SPAN = 16;
      var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
      var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 17976931348623157e292, NAN2 = 0 / 0;
      var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
      var wrapFlags = [
        ["ary", WRAP_ARY_FLAG],
        ["bind", WRAP_BIND_FLAG],
        ["bindKey", WRAP_BIND_KEY_FLAG],
        ["curry", WRAP_CURRY_FLAG],
        ["curryRight", WRAP_CURRY_RIGHT_FLAG],
        ["flip", WRAP_FLIP_FLAG],
        ["partial", WRAP_PARTIAL_FLAG],
        ["partialRight", WRAP_PARTIAL_RIGHT_FLAG],
        ["rearg", WRAP_REARG_FLAG]
      ];
      var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", domExcTag = "[object DOMException]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]", weakSetTag = "[object WeakSet]";
      var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
      var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
      var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
      var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
      var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
      var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
      var reTrimStart = /^\s+/;
      var reWhitespace = /\s/;
      var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
      var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
      var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
      var reEscapeChar = /\\(\\)?/g;
      var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
      var reFlags = /\w*$/;
      var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
      var reIsBinary = /^0b[01]+$/i;
      var reIsHostCtor = /^\[object .+?Constructor\]$/;
      var reIsOctal = /^0o[0-7]+$/i;
      var reIsUint = /^(?:0|[1-9]\d*)$/;
      var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
      var reNoMatch = /($^)/;
      var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
      var rsAstralRange = "\\ud800-\\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = "\\u2700-\\u27bf", rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rsPunctuationRange = "\\u2000-\\u206f", rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", rsVarRange = "\\ufe0e\\ufe0f", rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
      var rsApos = "['\u2019]", rsAstral = "[" + rsAstralRange + "]", rsBreak = "[" + rsBreakRange + "]", rsCombo = "[" + rsComboRange + "]", rsDigits = "\\d+", rsDingbat = "[" + rsDingbatRange + "]", rsLower = "[" + rsLowerRange + "]", rsMisc = "[^" + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]", rsFitz = "\\ud83c[\\udffb-\\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\\ud83c[\\udde6-\\uddff]){2}", rsSurrPair = "[\\ud800-\\udbff][\\udc00-\\udfff]", rsUpper = "[" + rsUpperRange + "]", rsZWJ = "\\u200d";
      var rsMiscLower = "(?:" + rsLower + "|" + rsMisc + ")", rsMiscUpper = "(?:" + rsUpper + "|" + rsMisc + ")", rsOptContrLower = "(?:" + rsApos + "(?:d|ll|m|re|s|t|ve))?", rsOptContrUpper = "(?:" + rsApos + "(?:D|LL|M|RE|S|T|VE))?", reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [rsNonAstral, rsRegional, rsSurrPair].join("|") + ")" + rsOptVar + reOptMod + ")*", rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = "(?:" + [rsDingbat, rsRegional, rsSurrPair].join("|") + ")" + rsSeq, rsSymbol = "(?:" + [rsNonAstral + rsCombo + "?", rsCombo, rsRegional, rsSurrPair, rsAstral].join("|") + ")";
      var reApos = RegExp(rsApos, "g");
      var reComboMark = RegExp(rsCombo, "g");
      var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
      var reUnicodeWord = RegExp([
        rsUpper + "?" + rsLower + "+" + rsOptContrLower + "(?=" + [rsBreak, rsUpper, "$"].join("|") + ")",
        rsMiscUpper + "+" + rsOptContrUpper + "(?=" + [rsBreak, rsUpper + rsMiscLower, "$"].join("|") + ")",
        rsUpper + "?" + rsMiscLower + "+" + rsOptContrLower,
        rsUpper + "+" + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
      ].join("|"), "g");
      var reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + "]");
      var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
      var contextProps = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
      ];
      var templateCounter = -1;
      var typedArrayTags = {};
      typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
      typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
      var cloneableTags = {};
      cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
      cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
      var deburredLetters = {
        // Latin-1 Supplement block.
        "\xC0": "A",
        "\xC1": "A",
        "\xC2": "A",
        "\xC3": "A",
        "\xC4": "A",
        "\xC5": "A",
        "\xE0": "a",
        "\xE1": "a",
        "\xE2": "a",
        "\xE3": "a",
        "\xE4": "a",
        "\xE5": "a",
        "\xC7": "C",
        "\xE7": "c",
        "\xD0": "D",
        "\xF0": "d",
        "\xC8": "E",
        "\xC9": "E",
        "\xCA": "E",
        "\xCB": "E",
        "\xE8": "e",
        "\xE9": "e",
        "\xEA": "e",
        "\xEB": "e",
        "\xCC": "I",
        "\xCD": "I",
        "\xCE": "I",
        "\xCF": "I",
        "\xEC": "i",
        "\xED": "i",
        "\xEE": "i",
        "\xEF": "i",
        "\xD1": "N",
        "\xF1": "n",
        "\xD2": "O",
        "\xD3": "O",
        "\xD4": "O",
        "\xD5": "O",
        "\xD6": "O",
        "\xD8": "O",
        "\xF2": "o",
        "\xF3": "o",
        "\xF4": "o",
        "\xF5": "o",
        "\xF6": "o",
        "\xF8": "o",
        "\xD9": "U",
        "\xDA": "U",
        "\xDB": "U",
        "\xDC": "U",
        "\xF9": "u",
        "\xFA": "u",
        "\xFB": "u",
        "\xFC": "u",
        "\xDD": "Y",
        "\xFD": "y",
        "\xFF": "y",
        "\xC6": "Ae",
        "\xE6": "ae",
        "\xDE": "Th",
        "\xFE": "th",
        "\xDF": "ss",
        // Latin Extended-A block.
        "\u0100": "A",
        "\u0102": "A",
        "\u0104": "A",
        "\u0101": "a",
        "\u0103": "a",
        "\u0105": "a",
        "\u0106": "C",
        "\u0108": "C",
        "\u010A": "C",
        "\u010C": "C",
        "\u0107": "c",
        "\u0109": "c",
        "\u010B": "c",
        "\u010D": "c",
        "\u010E": "D",
        "\u0110": "D",
        "\u010F": "d",
        "\u0111": "d",
        "\u0112": "E",
        "\u0114": "E",
        "\u0116": "E",
        "\u0118": "E",
        "\u011A": "E",
        "\u0113": "e",
        "\u0115": "e",
        "\u0117": "e",
        "\u0119": "e",
        "\u011B": "e",
        "\u011C": "G",
        "\u011E": "G",
        "\u0120": "G",
        "\u0122": "G",
        "\u011D": "g",
        "\u011F": "g",
        "\u0121": "g",
        "\u0123": "g",
        "\u0124": "H",
        "\u0126": "H",
        "\u0125": "h",
        "\u0127": "h",
        "\u0128": "I",
        "\u012A": "I",
        "\u012C": "I",
        "\u012E": "I",
        "\u0130": "I",
        "\u0129": "i",
        "\u012B": "i",
        "\u012D": "i",
        "\u012F": "i",
        "\u0131": "i",
        "\u0134": "J",
        "\u0135": "j",
        "\u0136": "K",
        "\u0137": "k",
        "\u0138": "k",
        "\u0139": "L",
        "\u013B": "L",
        "\u013D": "L",
        "\u013F": "L",
        "\u0141": "L",
        "\u013A": "l",
        "\u013C": "l",
        "\u013E": "l",
        "\u0140": "l",
        "\u0142": "l",
        "\u0143": "N",
        "\u0145": "N",
        "\u0147": "N",
        "\u014A": "N",
        "\u0144": "n",
        "\u0146": "n",
        "\u0148": "n",
        "\u014B": "n",
        "\u014C": "O",
        "\u014E": "O",
        "\u0150": "O",
        "\u014D": "o",
        "\u014F": "o",
        "\u0151": "o",
        "\u0154": "R",
        "\u0156": "R",
        "\u0158": "R",
        "\u0155": "r",
        "\u0157": "r",
        "\u0159": "r",
        "\u015A": "S",
        "\u015C": "S",
        "\u015E": "S",
        "\u0160": "S",
        "\u015B": "s",
        "\u015D": "s",
        "\u015F": "s",
        "\u0161": "s",
        "\u0162": "T",
        "\u0164": "T",
        "\u0166": "T",
        "\u0163": "t",
        "\u0165": "t",
        "\u0167": "t",
        "\u0168": "U",
        "\u016A": "U",
        "\u016C": "U",
        "\u016E": "U",
        "\u0170": "U",
        "\u0172": "U",
        "\u0169": "u",
        "\u016B": "u",
        "\u016D": "u",
        "\u016F": "u",
        "\u0171": "u",
        "\u0173": "u",
        "\u0174": "W",
        "\u0175": "w",
        "\u0176": "Y",
        "\u0177": "y",
        "\u0178": "Y",
        "\u0179": "Z",
        "\u017B": "Z",
        "\u017D": "Z",
        "\u017A": "z",
        "\u017C": "z",
        "\u017E": "z",
        "\u0132": "IJ",
        "\u0133": "ij",
        "\u0152": "Oe",
        "\u0153": "oe",
        "\u0149": "'n",
        "\u017F": "s"
      };
      var htmlEscapes = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
      };
      var htmlUnescapes = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
      };
      var stringEscapes = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
      };
      var freeParseFloat = parseFloat, freeParseInt = parseInt;
      var freeGlobal2 = typeof global == "object" && global && global.Object === Object && global;
      var freeSelf2 = typeof self == "object" && self && self.Object === Object && self;
      var root2 = freeGlobal2 || freeSelf2 || Function("return this")();
      var freeExports = typeof exports == "object" && exports && !exports.nodeType && exports;
      var freeModule = freeExports && typeof module == "object" && module && !module.nodeType && module;
      var moduleExports = freeModule && freeModule.exports === freeExports;
      var freeProcess = moduleExports && freeGlobal2.process;
      var nodeUtil = function() {
        try {
          var types = freeModule && freeModule.require && freeModule.require("util").types;
          if (types) {
            return types;
          }
          return freeProcess && freeProcess.binding && freeProcess.binding("util");
        } catch (e) {
        }
      }();
      var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
      function apply(func, thisArg, args) {
        switch (args.length) {
          case 0:
            return func.call(thisArg);
          case 1:
            return func.call(thisArg, args[0]);
          case 2:
            return func.call(thisArg, args[0], args[1]);
          case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
      }
      function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while (++index < length) {
          var value = array[index];
          setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
      }
      function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while (++index < length) {
          if (iteratee(array[index], index, array) === false) {
            break;
          }
        }
        return array;
      }
      function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while (length--) {
          if (iteratee(array[length], length, array) === false) {
            break;
          }
        }
        return array;
      }
      function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while (++index < length) {
          if (!predicate(array[index], index, array)) {
            return false;
          }
        }
        return true;
      }
      function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while (++index < length) {
          var value = array[index];
          if (predicate(value, index, array)) {
            result[resIndex++] = value;
          }
        }
        return result;
      }
      function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
      }
      function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while (++index < length) {
          if (comparator(value, array[index])) {
            return true;
          }
        }
        return false;
      }
      function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while (++index < length) {
          result[index] = iteratee(array[index], index, array);
        }
        return result;
      }
      function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while (++index < length) {
          array[offset + index] = values[index];
        }
        return array;
      }
      function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) {
          accumulator = array[++index];
        }
        while (++index < length) {
          accumulator = iteratee(accumulator, array[index], index, array);
        }
        return accumulator;
      }
      function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) {
          accumulator = array[--length];
        }
        while (length--) {
          accumulator = iteratee(accumulator, array[length], length, array);
        }
        return accumulator;
      }
      function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while (++index < length) {
          if (predicate(array[index], index, array)) {
            return true;
          }
        }
        return false;
      }
      var asciiSize = baseProperty("length");
      function asciiToArray(string7) {
        return string7.split("");
      }
      function asciiWords(string7) {
        return string7.match(reAsciiWord) || [];
      }
      function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection2) {
          if (predicate(value, key, collection2)) {
            result = key;
            return false;
          }
        });
        return result;
      }
      function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while (fromRight ? index-- : ++index < length) {
          if (predicate(array[index], index, array)) {
            return index;
          }
        }
        return -1;
      }
      function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
      }
      function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while (++index < length) {
          if (comparator(array[index], value)) {
            return index;
          }
        }
        return -1;
      }
      function baseIsNaN(value) {
        return value !== value;
      }
      function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN2;
      }
      function baseProperty(key) {
        return function(object7) {
          return object7 == null ? undefined2 : object7[key];
        };
      }
      function basePropertyOf(object7) {
        return function(key) {
          return object7 == null ? undefined2 : object7[key];
        };
      }
      function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection2) {
          accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection2);
        });
        return accumulator;
      }
      function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while (length--) {
          array[length] = array[length].value;
        }
        return array;
      }
      function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while (++index < length) {
          var current = iteratee(array[index]);
          if (current !== undefined2) {
            result = result === undefined2 ? current : result + current;
          }
        }
        return result;
      }
      function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while (++index < n) {
          result[index] = iteratee(index);
        }
        return result;
      }
      function baseToPairs(object7, props) {
        return arrayMap(props, function(key) {
          return [key, object7[key]];
        });
      }
      function baseTrim(string7) {
        return string7 ? string7.slice(0, trimmedEndIndex(string7) + 1).replace(reTrimStart, "") : string7;
      }
      function baseUnary(func) {
        return function(value) {
          return func(value);
        };
      }
      function baseValues(object7, props) {
        return arrayMap(props, function(key) {
          return object7[key];
        });
      }
      function cacheHas(cache, key) {
        return cache.has(key);
      }
      function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {
        }
        return index;
      }
      function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {
        }
        return index;
      }
      function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while (length--) {
          if (array[length] === placeholder) {
            ++result;
          }
        }
        return result;
      }
      var deburrLetter = basePropertyOf(deburredLetters);
      var escapeHtmlChar = basePropertyOf(htmlEscapes);
      function escapeStringChar(chr) {
        return "\\" + stringEscapes[chr];
      }
      function getValue(object7, key) {
        return object7 == null ? undefined2 : object7[key];
      }
      function hasUnicode(string7) {
        return reHasUnicode.test(string7);
      }
      function hasUnicodeWord(string7) {
        return reHasUnicodeWord.test(string7);
      }
      function iteratorToArray(iterator) {
        var data, result = [];
        while (!(data = iterator.next()).done) {
          result.push(data.value);
        }
        return result;
      }
      function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
          result[++index] = [key, value];
        });
        return result;
      }
      function overArg(func, transform) {
        return function(arg) {
          return func(transform(arg));
        };
      }
      function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while (++index < length) {
          var value = array[index];
          if (value === placeholder || value === PLACEHOLDER) {
            array[index] = PLACEHOLDER;
            result[resIndex++] = index;
          }
        }
        return result;
      }
      function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
          result[++index] = value;
        });
        return result;
      }
      function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
          result[++index] = [value, value];
        });
        return result;
      }
      function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while (++index < length) {
          if (array[index] === value) {
            return index;
          }
        }
        return -1;
      }
      function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while (index--) {
          if (array[index] === value) {
            return index;
          }
        }
        return index;
      }
      function stringSize(string7) {
        return hasUnicode(string7) ? unicodeSize(string7) : asciiSize(string7);
      }
      function stringToArray(string7) {
        return hasUnicode(string7) ? unicodeToArray(string7) : asciiToArray(string7);
      }
      function trimmedEndIndex(string7) {
        var index = string7.length;
        while (index-- && reWhitespace.test(string7.charAt(index))) {
        }
        return index;
      }
      var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
      function unicodeSize(string7) {
        var result = reUnicode.lastIndex = 0;
        while (reUnicode.test(string7)) {
          ++result;
        }
        return result;
      }
      function unicodeToArray(string7) {
        return string7.match(reUnicode) || [];
      }
      function unicodeWords(string7) {
        return string7.match(reUnicodeWord) || [];
      }
      var runInContext = function runInContext2(context) {
        context = context == null ? root2 : _.defaults(root2.Object(), context, _.pick(root2, contextProps));
        var Array2 = context.Array, Date2 = context.Date, Error2 = context.Error, Function2 = context.Function, Math2 = context.Math, Object2 = context.Object, RegExp2 = context.RegExp, String2 = context.String, TypeError2 = context.TypeError;
        var arrayProto = Array2.prototype, funcProto = Function2.prototype, objectProto3 = Object2.prototype;
        var coreJsData = context["__core-js_shared__"];
        var funcToString = funcProto.toString;
        var hasOwnProperty2 = objectProto3.hasOwnProperty;
        var idCounter = 0;
        var maskSrcKey = function() {
          var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
          return uid ? "Symbol(src)_1." + uid : "";
        }();
        var nativeObjectToString3 = objectProto3.toString;
        var objectCtorString = funcToString.call(Object2);
        var oldDash = root2._;
        var reIsNative = RegExp2(
          "^" + funcToString.call(hasOwnProperty2).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
        );
        var Buffer2 = moduleExports ? context.Buffer : undefined2, Symbol3 = context.Symbol, Uint8Array2 = context.Uint8Array, allocUnsafe = Buffer2 ? Buffer2.allocUnsafe : undefined2, getPrototype = overArg(Object2.getPrototypeOf, Object2), objectCreate = Object2.create, propertyIsEnumerable = objectProto3.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol3 ? Symbol3.isConcatSpreadable : undefined2, symIterator = Symbol3 ? Symbol3.iterator : undefined2, symToStringTag3 = Symbol3 ? Symbol3.toStringTag : undefined2;
        var defineProperty = function() {
          try {
            var func = getNative(Object2, "defineProperty");
            func({}, "", {});
            return func;
          } catch (e) {
          }
        }();
        var ctxClearTimeout = context.clearTimeout !== root2.clearTimeout && context.clearTimeout, ctxNow = Date2 && Date2.now !== root2.Date.now && Date2.now, ctxSetTimeout = context.setTimeout !== root2.setTimeout && context.setTimeout;
        var nativeCeil = Math2.ceil, nativeFloor = Math2.floor, nativeGetSymbols = Object2.getOwnPropertySymbols, nativeIsBuffer = Buffer2 ? Buffer2.isBuffer : undefined2, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object2.keys, Object2), nativeMax = Math2.max, nativeMin = Math2.min, nativeNow = Date2.now, nativeParseInt = context.parseInt, nativeRandom = Math2.random, nativeReverse = arrayProto.reverse;
        var DataView2 = getNative(context, "DataView"), Map2 = getNative(context, "Map"), Promise2 = getNative(context, "Promise"), Set2 = getNative(context, "Set"), WeakMap2 = getNative(context, "WeakMap"), nativeCreate = getNative(Object2, "create");
        var metaMap = WeakMap2 && new WeakMap2();
        var realNames = {};
        var dataViewCtorString = toSource(DataView2), mapCtorString = toSource(Map2), promiseCtorString = toSource(Promise2), setCtorString = toSource(Set2), weakMapCtorString = toSource(WeakMap2);
        var symbolProto = Symbol3 ? Symbol3.prototype : undefined2, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined2, symbolToString = symbolProto ? symbolProto.toString : undefined2;
        function lodash(value) {
          if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
            if (value instanceof LodashWrapper) {
              return value;
            }
            if (hasOwnProperty2.call(value, "__wrapped__")) {
              return wrapperClone(value);
            }
          }
          return new LodashWrapper(value);
        }
        var baseCreate = function() {
          function object7() {
          }
          return function(proto) {
            if (!isObject(proto)) {
              return {};
            }
            if (objectCreate) {
              return objectCreate(proto);
            }
            object7.prototype = proto;
            var result2 = new object7();
            object7.prototype = undefined2;
            return result2;
          };
        }();
        function baseLodash() {
        }
        function LodashWrapper(value, chainAll) {
          this.__wrapped__ = value;
          this.__actions__ = [];
          this.__chain__ = !!chainAll;
          this.__index__ = 0;
          this.__values__ = undefined2;
        }
        lodash.templateSettings = {
          /**
           * Used to detect `data` property values to be HTML-escaped.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          "escape": reEscape,
          /**
           * Used to detect code to be evaluated.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          "evaluate": reEvaluate,
          /**
           * Used to detect `data` property values to inject.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          "interpolate": reInterpolate,
          /**
           * Used to reference the data object in the template text.
           *
           * @memberOf _.templateSettings
           * @type {string}
           */
          "variable": "",
          /**
           * Used to import variables into the compiled template.
           *
           * @memberOf _.templateSettings
           * @type {Object}
           */
          "imports": {
            /**
             * A reference to the `lodash` function.
             *
             * @memberOf _.templateSettings.imports
             * @type {Function}
             */
            "_": lodash
          }
        };
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        function LazyWrapper(value) {
          this.__wrapped__ = value;
          this.__actions__ = [];
          this.__dir__ = 1;
          this.__filtered__ = false;
          this.__iteratees__ = [];
          this.__takeCount__ = MAX_ARRAY_LENGTH;
          this.__views__ = [];
        }
        function lazyClone() {
          var result2 = new LazyWrapper(this.__wrapped__);
          result2.__actions__ = copyArray(this.__actions__);
          result2.__dir__ = this.__dir__;
          result2.__filtered__ = this.__filtered__;
          result2.__iteratees__ = copyArray(this.__iteratees__);
          result2.__takeCount__ = this.__takeCount__;
          result2.__views__ = copyArray(this.__views__);
          return result2;
        }
        function lazyReverse() {
          if (this.__filtered__) {
            var result2 = new LazyWrapper(this);
            result2.__dir__ = -1;
            result2.__filtered__ = true;
          } else {
            result2 = this.clone();
            result2.__dir__ *= -1;
          }
          return result2;
        }
        function lazyValue() {
          var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
          if (!isArr || !isRight && arrLength == length && takeCount == length) {
            return baseWrapperValue(array, this.__actions__);
          }
          var result2 = [];
          outer:
            while (length-- && resIndex < takeCount) {
              index += dir;
              var iterIndex = -1, value = array[index];
              while (++iterIndex < iterLength) {
                var data = iteratees[iterIndex], iteratee2 = data.iteratee, type = data.type, computed = iteratee2(value);
                if (type == LAZY_MAP_FLAG) {
                  value = computed;
                } else if (!computed) {
                  if (type == LAZY_FILTER_FLAG) {
                    continue outer;
                  } else {
                    break outer;
                  }
                }
              }
              result2[resIndex++] = value;
            }
          return result2;
        }
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        function Hash(entries) {
          var index = -1, length = entries == null ? 0 : entries.length;
          this.clear();
          while (++index < length) {
            var entry = entries[index];
            this.set(entry[0], entry[1]);
          }
        }
        function hashClear() {
          this.__data__ = nativeCreate ? nativeCreate(null) : {};
          this.size = 0;
        }
        function hashDelete(key) {
          var result2 = this.has(key) && delete this.__data__[key];
          this.size -= result2 ? 1 : 0;
          return result2;
        }
        function hashGet(key) {
          var data = this.__data__;
          if (nativeCreate) {
            var result2 = data[key];
            return result2 === HASH_UNDEFINED ? undefined2 : result2;
          }
          return hasOwnProperty2.call(data, key) ? data[key] : undefined2;
        }
        function hashHas(key) {
          var data = this.__data__;
          return nativeCreate ? data[key] !== undefined2 : hasOwnProperty2.call(data, key);
        }
        function hashSet(key, value) {
          var data = this.__data__;
          this.size += this.has(key) ? 0 : 1;
          data[key] = nativeCreate && value === undefined2 ? HASH_UNDEFINED : value;
          return this;
        }
        Hash.prototype.clear = hashClear;
        Hash.prototype["delete"] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        function ListCache(entries) {
          var index = -1, length = entries == null ? 0 : entries.length;
          this.clear();
          while (++index < length) {
            var entry = entries[index];
            this.set(entry[0], entry[1]);
          }
        }
        function listCacheClear() {
          this.__data__ = [];
          this.size = 0;
        }
        function listCacheDelete(key) {
          var data = this.__data__, index = assocIndexOf(data, key);
          if (index < 0) {
            return false;
          }
          var lastIndex = data.length - 1;
          if (index == lastIndex) {
            data.pop();
          } else {
            splice.call(data, index, 1);
          }
          --this.size;
          return true;
        }
        function listCacheGet(key) {
          var data = this.__data__, index = assocIndexOf(data, key);
          return index < 0 ? undefined2 : data[index][1];
        }
        function listCacheHas(key) {
          return assocIndexOf(this.__data__, key) > -1;
        }
        function listCacheSet(key, value) {
          var data = this.__data__, index = assocIndexOf(data, key);
          if (index < 0) {
            ++this.size;
            data.push([key, value]);
          } else {
            data[index][1] = value;
          }
          return this;
        }
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype["delete"] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        function MapCache2(entries) {
          var index = -1, length = entries == null ? 0 : entries.length;
          this.clear();
          while (++index < length) {
            var entry = entries[index];
            this.set(entry[0], entry[1]);
          }
        }
        function mapCacheClear() {
          this.size = 0;
          this.__data__ = {
            "hash": new Hash(),
            "map": new (Map2 || ListCache)(),
            "string": new Hash()
          };
        }
        function mapCacheDelete(key) {
          var result2 = getMapData(this, key)["delete"](key);
          this.size -= result2 ? 1 : 0;
          return result2;
        }
        function mapCacheGet(key) {
          return getMapData(this, key).get(key);
        }
        function mapCacheHas(key) {
          return getMapData(this, key).has(key);
        }
        function mapCacheSet(key, value) {
          var data = getMapData(this, key), size2 = data.size;
          data.set(key, value);
          this.size += data.size == size2 ? 0 : 1;
          return this;
        }
        MapCache2.prototype.clear = mapCacheClear;
        MapCache2.prototype["delete"] = mapCacheDelete;
        MapCache2.prototype.get = mapCacheGet;
        MapCache2.prototype.has = mapCacheHas;
        MapCache2.prototype.set = mapCacheSet;
        function SetCache(values2) {
          var index = -1, length = values2 == null ? 0 : values2.length;
          this.__data__ = new MapCache2();
          while (++index < length) {
            this.add(values2[index]);
          }
        }
        function setCacheAdd(value) {
          this.__data__.set(value, HASH_UNDEFINED);
          return this;
        }
        function setCacheHas(value) {
          return this.__data__.has(value);
        }
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        function Stack(entries) {
          var data = this.__data__ = new ListCache(entries);
          this.size = data.size;
        }
        function stackClear() {
          this.__data__ = new ListCache();
          this.size = 0;
        }
        function stackDelete(key) {
          var data = this.__data__, result2 = data["delete"](key);
          this.size = data.size;
          return result2;
        }
        function stackGet(key) {
          return this.__data__.get(key);
        }
        function stackHas(key) {
          return this.__data__.has(key);
        }
        function stackSet(key, value) {
          var data = this.__data__;
          if (data instanceof ListCache) {
            var pairs = data.__data__;
            if (!Map2 || pairs.length < LARGE_ARRAY_SIZE - 1) {
              pairs.push([key, value]);
              this.size = ++data.size;
              return this;
            }
            data = this.__data__ = new MapCache2(pairs);
          }
          data.set(key, value);
          this.size = data.size;
          return this;
        }
        Stack.prototype.clear = stackClear;
        Stack.prototype["delete"] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        function arrayLikeKeys(value, inherited) {
          var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result2 = skipIndexes ? baseTimes(value.length, String2) : [], length = result2.length;
          for (var key in value) {
            if ((inherited || hasOwnProperty2.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
            isIndex(key, length)))) {
              result2.push(key);
            }
          }
          return result2;
        }
        function arraySample(array) {
          var length = array.length;
          return length ? array[baseRandom(0, length - 1)] : undefined2;
        }
        function arraySampleSize(array, n) {
          return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        function arrayShuffle(array) {
          return shuffleSelf(copyArray(array));
        }
        function assignMergeValue(object7, key, value) {
          if (value !== undefined2 && !eq(object7[key], value) || value === undefined2 && !(key in object7)) {
            baseAssignValue(object7, key, value);
          }
        }
        function assignValue(object7, key, value) {
          var objValue = object7[key];
          if (!(hasOwnProperty2.call(object7, key) && eq(objValue, value)) || value === undefined2 && !(key in object7)) {
            baseAssignValue(object7, key, value);
          }
        }
        function assocIndexOf(array, key) {
          var length = array.length;
          while (length--) {
            if (eq(array[length][0], key)) {
              return length;
            }
          }
          return -1;
        }
        function baseAggregator(collection, setter, iteratee2, accumulator) {
          baseEach(collection, function(value, key, collection2) {
            setter(accumulator, value, iteratee2(value), collection2);
          });
          return accumulator;
        }
        function baseAssign(object7, source) {
          return object7 && copyObject(source, keys(source), object7);
        }
        function baseAssignIn(object7, source) {
          return object7 && copyObject(source, keysIn(source), object7);
        }
        function baseAssignValue(object7, key, value) {
          if (key == "__proto__" && defineProperty) {
            defineProperty(object7, key, {
              "configurable": true,
              "enumerable": true,
              "value": value,
              "writable": true
            });
          } else {
            object7[key] = value;
          }
        }
        function baseAt(object7, paths) {
          var index = -1, length = paths.length, result2 = Array2(length), skip = object7 == null;
          while (++index < length) {
            result2[index] = skip ? undefined2 : get(object7, paths[index]);
          }
          return result2;
        }
        function baseClamp(number2, lower, upper) {
          if (number2 === number2) {
            if (upper !== undefined2) {
              number2 = number2 <= upper ? number2 : upper;
            }
            if (lower !== undefined2) {
              number2 = number2 >= lower ? number2 : lower;
            }
          }
          return number2;
        }
        function baseClone(value, bitmask, customizer, key, object7, stack) {
          var result2, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
          if (customizer) {
            result2 = object7 ? customizer(value, key, object7, stack) : customizer(value);
          }
          if (result2 !== undefined2) {
            return result2;
          }
          if (!isObject(value)) {
            return value;
          }
          var isArr = isArray(value);
          if (isArr) {
            result2 = initCloneArray(value);
            if (!isDeep) {
              return copyArray(value, result2);
            }
          } else {
            var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
            if (isBuffer(value)) {
              return cloneBuffer(value, isDeep);
            }
            if (tag == objectTag || tag == argsTag || isFunc && !object7) {
              result2 = isFlat || isFunc ? {} : initCloneObject(value);
              if (!isDeep) {
                return isFlat ? copySymbolsIn(value, baseAssignIn(result2, value)) : copySymbols(value, baseAssign(result2, value));
              }
            } else {
              if (!cloneableTags[tag]) {
                return object7 ? value : {};
              }
              result2 = initCloneByTag(value, tag, isDeep);
            }
          }
          stack || (stack = new Stack());
          var stacked = stack.get(value);
          if (stacked) {
            return stacked;
          }
          stack.set(value, result2);
          if (isSet(value)) {
            value.forEach(function(subValue) {
              result2.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
          } else if (isMap(value)) {
            value.forEach(function(subValue, key2) {
              result2.set(key2, baseClone(subValue, bitmask, customizer, key2, value, stack));
            });
          }
          var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
          var props = isArr ? undefined2 : keysFunc(value);
          arrayEach(props || value, function(subValue, key2) {
            if (props) {
              key2 = subValue;
              subValue = value[key2];
            }
            assignValue(result2, key2, baseClone(subValue, bitmask, customizer, key2, value, stack));
          });
          return result2;
        }
        function baseConforms(source) {
          var props = keys(source);
          return function(object7) {
            return baseConformsTo(object7, source, props);
          };
        }
        function baseConformsTo(object7, source, props) {
          var length = props.length;
          if (object7 == null) {
            return !length;
          }
          object7 = Object2(object7);
          while (length--) {
            var key = props[length], predicate = source[key], value = object7[key];
            if (value === undefined2 && !(key in object7) || !predicate(value)) {
              return false;
            }
          }
          return true;
        }
        function baseDelay(func, wait, args) {
          if (typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          return setTimeout2(function() {
            func.apply(undefined2, args);
          }, wait);
        }
        function baseDifference(array, values2, iteratee2, comparator) {
          var index = -1, includes2 = arrayIncludes, isCommon = true, length = array.length, result2 = [], valuesLength = values2.length;
          if (!length) {
            return result2;
          }
          if (iteratee2) {
            values2 = arrayMap(values2, baseUnary(iteratee2));
          }
          if (comparator) {
            includes2 = arrayIncludesWith;
            isCommon = false;
          } else if (values2.length >= LARGE_ARRAY_SIZE) {
            includes2 = cacheHas;
            isCommon = false;
            values2 = new SetCache(values2);
          }
          outer:
            while (++index < length) {
              var value = array[index], computed = iteratee2 == null ? value : iteratee2(value);
              value = comparator || value !== 0 ? value : 0;
              if (isCommon && computed === computed) {
                var valuesIndex = valuesLength;
                while (valuesIndex--) {
                  if (values2[valuesIndex] === computed) {
                    continue outer;
                  }
                }
                result2.push(value);
              } else if (!includes2(values2, computed, comparator)) {
                result2.push(value);
              }
            }
          return result2;
        }
        var baseEach = createBaseEach(baseForOwn);
        var baseEachRight = createBaseEach(baseForOwnRight, true);
        function baseEvery(collection, predicate) {
          var result2 = true;
          baseEach(collection, function(value, index, collection2) {
            result2 = !!predicate(value, index, collection2);
            return result2;
          });
          return result2;
        }
        function baseExtremum(array, iteratee2, comparator) {
          var index = -1, length = array.length;
          while (++index < length) {
            var value = array[index], current = iteratee2(value);
            if (current != null && (computed === undefined2 ? current === current && !isSymbol(current) : comparator(current, computed))) {
              var computed = current, result2 = value;
            }
          }
          return result2;
        }
        function baseFill(array, value, start, end) {
          var length = array.length;
          start = toInteger(start);
          if (start < 0) {
            start = -start > length ? 0 : length + start;
          }
          end = end === undefined2 || end > length ? length : toInteger(end);
          if (end < 0) {
            end += length;
          }
          end = start > end ? 0 : toLength(end);
          while (start < end) {
            array[start++] = value;
          }
          return array;
        }
        function baseFilter(collection, predicate) {
          var result2 = [];
          baseEach(collection, function(value, index, collection2) {
            if (predicate(value, index, collection2)) {
              result2.push(value);
            }
          });
          return result2;
        }
        function baseFlatten(array, depth, predicate, isStrict, result2) {
          var index = -1, length = array.length;
          predicate || (predicate = isFlattenable);
          result2 || (result2 = []);
          while (++index < length) {
            var value = array[index];
            if (depth > 0 && predicate(value)) {
              if (depth > 1) {
                baseFlatten(value, depth - 1, predicate, isStrict, result2);
              } else {
                arrayPush(result2, value);
              }
            } else if (!isStrict) {
              result2[result2.length] = value;
            }
          }
          return result2;
        }
        var baseFor = createBaseFor();
        var baseForRight = createBaseFor(true);
        function baseForOwn(object7, iteratee2) {
          return object7 && baseFor(object7, iteratee2, keys);
        }
        function baseForOwnRight(object7, iteratee2) {
          return object7 && baseForRight(object7, iteratee2, keys);
        }
        function baseFunctions(object7, props) {
          return arrayFilter(props, function(key) {
            return isFunction(object7[key]);
          });
        }
        function baseGet(object7, path) {
          path = castPath(path, object7);
          var index = 0, length = path.length;
          while (object7 != null && index < length) {
            object7 = object7[toKey(path[index++])];
          }
          return index && index == length ? object7 : undefined2;
        }
        function baseGetAllKeys(object7, keysFunc, symbolsFunc) {
          var result2 = keysFunc(object7);
          return isArray(object7) ? result2 : arrayPush(result2, symbolsFunc(object7));
        }
        function baseGetTag(value) {
          if (value == null) {
            return value === undefined2 ? undefinedTag : nullTag;
          }
          return symToStringTag3 && symToStringTag3 in Object2(value) ? getRawTag(value) : objectToString(value);
        }
        function baseGt(value, other) {
          return value > other;
        }
        function baseHas(object7, key) {
          return object7 != null && hasOwnProperty2.call(object7, key);
        }
        function baseHasIn(object7, key) {
          return object7 != null && key in Object2(object7);
        }
        function baseInRange(number2, start, end) {
          return number2 >= nativeMin(start, end) && number2 < nativeMax(start, end);
        }
        function baseIntersection(arrays, iteratee2, comparator) {
          var includes2 = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array2(othLength), maxLength = Infinity, result2 = [];
          while (othIndex--) {
            var array = arrays[othIndex];
            if (othIndex && iteratee2) {
              array = arrayMap(array, baseUnary(iteratee2));
            }
            maxLength = nativeMin(array.length, maxLength);
            caches[othIndex] = !comparator && (iteratee2 || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined2;
          }
          array = arrays[0];
          var index = -1, seen = caches[0];
          outer:
            while (++index < length && result2.length < maxLength) {
              var value = array[index], computed = iteratee2 ? iteratee2(value) : value;
              value = comparator || value !== 0 ? value : 0;
              if (!(seen ? cacheHas(seen, computed) : includes2(result2, computed, comparator))) {
                othIndex = othLength;
                while (--othIndex) {
                  var cache = caches[othIndex];
                  if (!(cache ? cacheHas(cache, computed) : includes2(arrays[othIndex], computed, comparator))) {
                    continue outer;
                  }
                }
                if (seen) {
                  seen.push(computed);
                }
                result2.push(value);
              }
            }
          return result2;
        }
        function baseInverter(object7, setter, iteratee2, accumulator) {
          baseForOwn(object7, function(value, key, object8) {
            setter(accumulator, iteratee2(value), key, object8);
          });
          return accumulator;
        }
        function baseInvoke(object7, path, args) {
          path = castPath(path, object7);
          object7 = parent(object7, path);
          var func = object7 == null ? object7 : object7[toKey(last(path))];
          return func == null ? undefined2 : apply(func, object7, args);
        }
        function baseIsArguments(value) {
          return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        function baseIsArrayBuffer(value) {
          return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        function baseIsDate(value) {
          return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        function baseIsEqual(value, other, bitmask, customizer, stack) {
          if (value === other) {
            return true;
          }
          if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) {
            return value !== value && other !== other;
          }
          return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        function baseIsEqualDeep(object7, other, bitmask, customizer, equalFunc, stack) {
          var objIsArr = isArray(object7), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object7), othTag = othIsArr ? arrayTag : getTag(other);
          objTag = objTag == argsTag ? objectTag : objTag;
          othTag = othTag == argsTag ? objectTag : othTag;
          var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
          if (isSameTag && isBuffer(object7)) {
            if (!isBuffer(other)) {
              return false;
            }
            objIsArr = true;
            objIsObj = false;
          }
          if (isSameTag && !objIsObj) {
            stack || (stack = new Stack());
            return objIsArr || isTypedArray(object7) ? equalArrays(object7, other, bitmask, customizer, equalFunc, stack) : equalByTag(object7, other, objTag, bitmask, customizer, equalFunc, stack);
          }
          if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
            var objIsWrapped = objIsObj && hasOwnProperty2.call(object7, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty2.call(other, "__wrapped__");
            if (objIsWrapped || othIsWrapped) {
              var objUnwrapped = objIsWrapped ? object7.value() : object7, othUnwrapped = othIsWrapped ? other.value() : other;
              stack || (stack = new Stack());
              return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
            }
          }
          if (!isSameTag) {
            return false;
          }
          stack || (stack = new Stack());
          return equalObjects(object7, other, bitmask, customizer, equalFunc, stack);
        }
        function baseIsMap(value) {
          return isObjectLike(value) && getTag(value) == mapTag;
        }
        function baseIsMatch(object7, source, matchData, customizer) {
          var index = matchData.length, length = index, noCustomizer = !customizer;
          if (object7 == null) {
            return !length;
          }
          object7 = Object2(object7);
          while (index--) {
            var data = matchData[index];
            if (noCustomizer && data[2] ? data[1] !== object7[data[0]] : !(data[0] in object7)) {
              return false;
            }
          }
          while (++index < length) {
            data = matchData[index];
            var key = data[0], objValue = object7[key], srcValue = data[1];
            if (noCustomizer && data[2]) {
              if (objValue === undefined2 && !(key in object7)) {
                return false;
              }
            } else {
              var stack = new Stack();
              if (customizer) {
                var result2 = customizer(objValue, srcValue, key, object7, source, stack);
              }
              if (!(result2 === undefined2 ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result2)) {
                return false;
              }
            }
          }
          return true;
        }
        function baseIsNative(value) {
          if (!isObject(value) || isMasked(value)) {
            return false;
          }
          var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
          return pattern.test(toSource(value));
        }
        function baseIsRegExp(value) {
          return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        function baseIsSet(value) {
          return isObjectLike(value) && getTag(value) == setTag;
        }
        function baseIsTypedArray(value) {
          return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        function baseIteratee(value) {
          if (typeof value == "function") {
            return value;
          }
          if (value == null) {
            return identity;
          }
          if (typeof value == "object") {
            return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
          }
          return property(value);
        }
        function baseKeys(object7) {
          if (!isPrototype(object7)) {
            return nativeKeys(object7);
          }
          var result2 = [];
          for (var key in Object2(object7)) {
            if (hasOwnProperty2.call(object7, key) && key != "constructor") {
              result2.push(key);
            }
          }
          return result2;
        }
        function baseKeysIn(object7) {
          if (!isObject(object7)) {
            return nativeKeysIn(object7);
          }
          var isProto = isPrototype(object7), result2 = [];
          for (var key in object7) {
            if (!(key == "constructor" && (isProto || !hasOwnProperty2.call(object7, key)))) {
              result2.push(key);
            }
          }
          return result2;
        }
        function baseLt(value, other) {
          return value < other;
        }
        function baseMap(collection, iteratee2) {
          var index = -1, result2 = isArrayLike(collection) ? Array2(collection.length) : [];
          baseEach(collection, function(value, key, collection2) {
            result2[++index] = iteratee2(value, key, collection2);
          });
          return result2;
        }
        function baseMatches(source) {
          var matchData = getMatchData(source);
          if (matchData.length == 1 && matchData[0][2]) {
            return matchesStrictComparable(matchData[0][0], matchData[0][1]);
          }
          return function(object7) {
            return object7 === source || baseIsMatch(object7, source, matchData);
          };
        }
        function baseMatchesProperty(path, srcValue) {
          if (isKey(path) && isStrictComparable(srcValue)) {
            return matchesStrictComparable(toKey(path), srcValue);
          }
          return function(object7) {
            var objValue = get(object7, path);
            return objValue === undefined2 && objValue === srcValue ? hasIn(object7, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
          };
        }
        function baseMerge(object7, source, srcIndex, customizer, stack) {
          if (object7 === source) {
            return;
          }
          baseFor(source, function(srcValue, key) {
            stack || (stack = new Stack());
            if (isObject(srcValue)) {
              baseMergeDeep(object7, source, key, srcIndex, baseMerge, customizer, stack);
            } else {
              var newValue = customizer ? customizer(safeGet(object7, key), srcValue, key + "", object7, source, stack) : undefined2;
              if (newValue === undefined2) {
                newValue = srcValue;
              }
              assignMergeValue(object7, key, newValue);
            }
          }, keysIn);
        }
        function baseMergeDeep(object7, source, key, srcIndex, mergeFunc, customizer, stack) {
          var objValue = safeGet(object7, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
          if (stacked) {
            assignMergeValue(object7, key, stacked);
            return;
          }
          var newValue = customizer ? customizer(objValue, srcValue, key + "", object7, source, stack) : undefined2;
          var isCommon = newValue === undefined2;
          if (isCommon) {
            var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
            newValue = srcValue;
            if (isArr || isBuff || isTyped) {
              if (isArray(objValue)) {
                newValue = objValue;
              } else if (isArrayLikeObject(objValue)) {
                newValue = copyArray(objValue);
              } else if (isBuff) {
                isCommon = false;
                newValue = cloneBuffer(srcValue, true);
              } else if (isTyped) {
                isCommon = false;
                newValue = cloneTypedArray(srcValue, true);
              } else {
                newValue = [];
              }
            } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
              newValue = objValue;
              if (isArguments(objValue)) {
                newValue = toPlainObject(objValue);
              } else if (!isObject(objValue) || isFunction(objValue)) {
                newValue = initCloneObject(srcValue);
              }
            } else {
              isCommon = false;
            }
          }
          if (isCommon) {
            stack.set(srcValue, newValue);
            mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
            stack["delete"](srcValue);
          }
          assignMergeValue(object7, key, newValue);
        }
        function baseNth(array, n) {
          var length = array.length;
          if (!length) {
            return;
          }
          n += n < 0 ? length : 0;
          return isIndex(n, length) ? array[n] : undefined2;
        }
        function baseOrderBy(collection, iteratees, orders) {
          if (iteratees.length) {
            iteratees = arrayMap(iteratees, function(iteratee2) {
              if (isArray(iteratee2)) {
                return function(value) {
                  return baseGet(value, iteratee2.length === 1 ? iteratee2[0] : iteratee2);
                };
              }
              return iteratee2;
            });
          } else {
            iteratees = [identity];
          }
          var index = -1;
          iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
          var result2 = baseMap(collection, function(value, key, collection2) {
            var criteria = arrayMap(iteratees, function(iteratee2) {
              return iteratee2(value);
            });
            return { "criteria": criteria, "index": ++index, "value": value };
          });
          return baseSortBy(result2, function(object7, other) {
            return compareMultiple(object7, other, orders);
          });
        }
        function basePick(object7, paths) {
          return basePickBy(object7, paths, function(value, path) {
            return hasIn(object7, path);
          });
        }
        function basePickBy(object7, paths, predicate) {
          var index = -1, length = paths.length, result2 = {};
          while (++index < length) {
            var path = paths[index], value = baseGet(object7, path);
            if (predicate(value, path)) {
              baseSet(result2, castPath(path, object7), value);
            }
          }
          return result2;
        }
        function basePropertyDeep(path) {
          return function(object7) {
            return baseGet(object7, path);
          };
        }
        function basePullAll(array, values2, iteratee2, comparator) {
          var indexOf2 = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values2.length, seen = array;
          if (array === values2) {
            values2 = copyArray(values2);
          }
          if (iteratee2) {
            seen = arrayMap(array, baseUnary(iteratee2));
          }
          while (++index < length) {
            var fromIndex = 0, value = values2[index], computed = iteratee2 ? iteratee2(value) : value;
            while ((fromIndex = indexOf2(seen, computed, fromIndex, comparator)) > -1) {
              if (seen !== array) {
                splice.call(seen, fromIndex, 1);
              }
              splice.call(array, fromIndex, 1);
            }
          }
          return array;
        }
        function basePullAt(array, indexes) {
          var length = array ? indexes.length : 0, lastIndex = length - 1;
          while (length--) {
            var index = indexes[length];
            if (length == lastIndex || index !== previous) {
              var previous = index;
              if (isIndex(index)) {
                splice.call(array, index, 1);
              } else {
                baseUnset(array, index);
              }
            }
          }
          return array;
        }
        function baseRandom(lower, upper) {
          return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        function baseRange(start, end, step, fromRight) {
          var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result2 = Array2(length);
          while (length--) {
            result2[fromRight ? length : ++index] = start;
            start += step;
          }
          return result2;
        }
        function baseRepeat(string7, n) {
          var result2 = "";
          if (!string7 || n < 1 || n > MAX_SAFE_INTEGER) {
            return result2;
          }
          do {
            if (n % 2) {
              result2 += string7;
            }
            n = nativeFloor(n / 2);
            if (n) {
              string7 += string7;
            }
          } while (n);
          return result2;
        }
        function baseRest(func, start) {
          return setToString(overRest(func, start, identity), func + "");
        }
        function baseSample(collection) {
          return arraySample(values(collection));
        }
        function baseSampleSize(collection, n) {
          var array = values(collection);
          return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        function baseSet(object7, path, value, customizer) {
          if (!isObject(object7)) {
            return object7;
          }
          path = castPath(path, object7);
          var index = -1, length = path.length, lastIndex = length - 1, nested = object7;
          while (nested != null && ++index < length) {
            var key = toKey(path[index]), newValue = value;
            if (key === "__proto__" || key === "constructor" || key === "prototype") {
              return object7;
            }
            if (index != lastIndex) {
              var objValue = nested[key];
              newValue = customizer ? customizer(objValue, key, nested) : undefined2;
              if (newValue === undefined2) {
                newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
              }
            }
            assignValue(nested, key, newValue);
            nested = nested[key];
          }
          return object7;
        }
        var baseSetData = !metaMap ? identity : function(func, data) {
          metaMap.set(func, data);
          return func;
        };
        var baseSetToString = !defineProperty ? identity : function(func, string7) {
          return defineProperty(func, "toString", {
            "configurable": true,
            "enumerable": false,
            "value": constant(string7),
            "writable": true
          });
        };
        function baseShuffle(collection) {
          return shuffleSelf(values(collection));
        }
        function baseSlice(array, start, end) {
          var index = -1, length = array.length;
          if (start < 0) {
            start = -start > length ? 0 : length + start;
          }
          end = end > length ? length : end;
          if (end < 0) {
            end += length;
          }
          length = start > end ? 0 : end - start >>> 0;
          start >>>= 0;
          var result2 = Array2(length);
          while (++index < length) {
            result2[index] = array[index + start];
          }
          return result2;
        }
        function baseSome(collection, predicate) {
          var result2;
          baseEach(collection, function(value, index, collection2) {
            result2 = predicate(value, index, collection2);
            return !result2;
          });
          return !!result2;
        }
        function baseSortedIndex(array, value, retHighest) {
          var low = 0, high = array == null ? low : array.length;
          if (typeof value == "number" && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
            while (low < high) {
              var mid = low + high >>> 1, computed = array[mid];
              if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) {
                low = mid + 1;
              } else {
                high = mid;
              }
            }
            return high;
          }
          return baseSortedIndexBy(array, value, identity, retHighest);
        }
        function baseSortedIndexBy(array, value, iteratee2, retHighest) {
          var low = 0, high = array == null ? 0 : array.length;
          if (high === 0) {
            return 0;
          }
          value = iteratee2(value);
          var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined2;
          while (low < high) {
            var mid = nativeFloor((low + high) / 2), computed = iteratee2(array[mid]), othIsDefined = computed !== undefined2, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
            if (valIsNaN) {
              var setLow = retHighest || othIsReflexive;
            } else if (valIsUndefined) {
              setLow = othIsReflexive && (retHighest || othIsDefined);
            } else if (valIsNull) {
              setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
            } else if (valIsSymbol) {
              setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
            } else if (othIsNull || othIsSymbol) {
              setLow = false;
            } else {
              setLow = retHighest ? computed <= value : computed < value;
            }
            if (setLow) {
              low = mid + 1;
            } else {
              high = mid;
            }
          }
          return nativeMin(high, MAX_ARRAY_INDEX);
        }
        function baseSortedUniq(array, iteratee2) {
          var index = -1, length = array.length, resIndex = 0, result2 = [];
          while (++index < length) {
            var value = array[index], computed = iteratee2 ? iteratee2(value) : value;
            if (!index || !eq(computed, seen)) {
              var seen = computed;
              result2[resIndex++] = value === 0 ? 0 : value;
            }
          }
          return result2;
        }
        function baseToNumber(value) {
          if (typeof value == "number") {
            return value;
          }
          if (isSymbol(value)) {
            return NAN2;
          }
          return +value;
        }
        function baseToString(value) {
          if (typeof value == "string") {
            return value;
          }
          if (isArray(value)) {
            return arrayMap(value, baseToString) + "";
          }
          if (isSymbol(value)) {
            return symbolToString ? symbolToString.call(value) : "";
          }
          var result2 = value + "";
          return result2 == "0" && 1 / value == -INFINITY ? "-0" : result2;
        }
        function baseUniq(array, iteratee2, comparator) {
          var index = -1, includes2 = arrayIncludes, length = array.length, isCommon = true, result2 = [], seen = result2;
          if (comparator) {
            isCommon = false;
            includes2 = arrayIncludesWith;
          } else if (length >= LARGE_ARRAY_SIZE) {
            var set2 = iteratee2 ? null : createSet(array);
            if (set2) {
              return setToArray(set2);
            }
            isCommon = false;
            includes2 = cacheHas;
            seen = new SetCache();
          } else {
            seen = iteratee2 ? [] : result2;
          }
          outer:
            while (++index < length) {
              var value = array[index], computed = iteratee2 ? iteratee2(value) : value;
              value = comparator || value !== 0 ? value : 0;
              if (isCommon && computed === computed) {
                var seenIndex = seen.length;
                while (seenIndex--) {
                  if (seen[seenIndex] === computed) {
                    continue outer;
                  }
                }
                if (iteratee2) {
                  seen.push(computed);
                }
                result2.push(value);
              } else if (!includes2(seen, computed, comparator)) {
                if (seen !== result2) {
                  seen.push(computed);
                }
                result2.push(value);
              }
            }
          return result2;
        }
        function baseUnset(object7, path) {
          path = castPath(path, object7);
          object7 = parent(object7, path);
          return object7 == null || delete object7[toKey(last(path))];
        }
        function baseUpdate(object7, path, updater, customizer) {
          return baseSet(object7, path, updater(baseGet(object7, path)), customizer);
        }
        function baseWhile(array, predicate, isDrop, fromRight) {
          var length = array.length, index = fromRight ? length : -1;
          while ((fromRight ? index-- : ++index < length) && predicate(array[index], index, array)) {
          }
          return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        function baseWrapperValue(value, actions) {
          var result2 = value;
          if (result2 instanceof LazyWrapper) {
            result2 = result2.value();
          }
          return arrayReduce(actions, function(result3, action) {
            return action.func.apply(action.thisArg, arrayPush([result3], action.args));
          }, result2);
        }
        function baseXor(arrays, iteratee2, comparator) {
          var length = arrays.length;
          if (length < 2) {
            return length ? baseUniq(arrays[0]) : [];
          }
          var index = -1, result2 = Array2(length);
          while (++index < length) {
            var array = arrays[index], othIndex = -1;
            while (++othIndex < length) {
              if (othIndex != index) {
                result2[index] = baseDifference(result2[index] || array, arrays[othIndex], iteratee2, comparator);
              }
            }
          }
          return baseUniq(baseFlatten(result2, 1), iteratee2, comparator);
        }
        function baseZipObject(props, values2, assignFunc) {
          var index = -1, length = props.length, valsLength = values2.length, result2 = {};
          while (++index < length) {
            var value = index < valsLength ? values2[index] : undefined2;
            assignFunc(result2, props[index], value);
          }
          return result2;
        }
        function castArrayLikeObject(value) {
          return isArrayLikeObject(value) ? value : [];
        }
        function castFunction(value) {
          return typeof value == "function" ? value : identity;
        }
        function castPath(value, object7) {
          if (isArray(value)) {
            return value;
          }
          return isKey(value, object7) ? [value] : stringToPath(toString(value));
        }
        var castRest = baseRest;
        function castSlice(array, start, end) {
          var length = array.length;
          end = end === undefined2 ? length : end;
          return !start && end >= length ? array : baseSlice(array, start, end);
        }
        var clearTimeout2 = ctxClearTimeout || function(id) {
          return root2.clearTimeout(id);
        };
        function cloneBuffer(buffer, isDeep) {
          if (isDeep) {
            return buffer.slice();
          }
          var length = buffer.length, result2 = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
          buffer.copy(result2);
          return result2;
        }
        function cloneArrayBuffer(arrayBuffer) {
          var result2 = new arrayBuffer.constructor(arrayBuffer.byteLength);
          new Uint8Array2(result2).set(new Uint8Array2(arrayBuffer));
          return result2;
        }
        function cloneDataView(dataView, isDeep) {
          var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
          return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        function cloneRegExp(regexp) {
          var result2 = new regexp.constructor(regexp.source, reFlags.exec(regexp));
          result2.lastIndex = regexp.lastIndex;
          return result2;
        }
        function cloneSymbol(symbol) {
          return symbolValueOf ? Object2(symbolValueOf.call(symbol)) : {};
        }
        function cloneTypedArray(typedArray, isDeep) {
          var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
          return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        function compareAscending(value, other) {
          if (value !== other) {
            var valIsDefined = value !== undefined2, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
            var othIsDefined = other !== undefined2, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
            if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) {
              return 1;
            }
            if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) {
              return -1;
            }
          }
          return 0;
        }
        function compareMultiple(object7, other, orders) {
          var index = -1, objCriteria = object7.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
          while (++index < length) {
            var result2 = compareAscending(objCriteria[index], othCriteria[index]);
            if (result2) {
              if (index >= ordersLength) {
                return result2;
              }
              var order2 = orders[index];
              return result2 * (order2 == "desc" ? -1 : 1);
            }
          }
          return object7.index - other.index;
        }
        function composeArgs(args, partials, holders, isCurried) {
          var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result2 = Array2(leftLength + rangeLength), isUncurried = !isCurried;
          while (++leftIndex < leftLength) {
            result2[leftIndex] = partials[leftIndex];
          }
          while (++argsIndex < holdersLength) {
            if (isUncurried || argsIndex < argsLength) {
              result2[holders[argsIndex]] = args[argsIndex];
            }
          }
          while (rangeLength--) {
            result2[leftIndex++] = args[argsIndex++];
          }
          return result2;
        }
        function composeArgsRight(args, partials, holders, isCurried) {
          var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result2 = Array2(rangeLength + rightLength), isUncurried = !isCurried;
          while (++argsIndex < rangeLength) {
            result2[argsIndex] = args[argsIndex];
          }
          var offset = argsIndex;
          while (++rightIndex < rightLength) {
            result2[offset + rightIndex] = partials[rightIndex];
          }
          while (++holdersIndex < holdersLength) {
            if (isUncurried || argsIndex < argsLength) {
              result2[offset + holders[holdersIndex]] = args[argsIndex++];
            }
          }
          return result2;
        }
        function copyArray(source, array) {
          var index = -1, length = source.length;
          array || (array = Array2(length));
          while (++index < length) {
            array[index] = source[index];
          }
          return array;
        }
        function copyObject(source, props, object7, customizer) {
          var isNew = !object7;
          object7 || (object7 = {});
          var index = -1, length = props.length;
          while (++index < length) {
            var key = props[index];
            var newValue = customizer ? customizer(object7[key], source[key], key, object7, source) : undefined2;
            if (newValue === undefined2) {
              newValue = source[key];
            }
            if (isNew) {
              baseAssignValue(object7, key, newValue);
            } else {
              assignValue(object7, key, newValue);
            }
          }
          return object7;
        }
        function copySymbols(source, object7) {
          return copyObject(source, getSymbols(source), object7);
        }
        function copySymbolsIn(source, object7) {
          return copyObject(source, getSymbolsIn(source), object7);
        }
        function createAggregator(setter, initializer) {
          return function(collection, iteratee2) {
            var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
            return func(collection, setter, getIteratee(iteratee2, 2), accumulator);
          };
        }
        function createAssigner(assigner) {
          return baseRest(function(object7, sources) {
            var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined2, guard = length > 2 ? sources[2] : undefined2;
            customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined2;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) {
              customizer = length < 3 ? undefined2 : customizer;
              length = 1;
            }
            object7 = Object2(object7);
            while (++index < length) {
              var source = sources[index];
              if (source) {
                assigner(object7, source, index, customizer);
              }
            }
            return object7;
          });
        }
        function createBaseEach(eachFunc, fromRight) {
          return function(collection, iteratee2) {
            if (collection == null) {
              return collection;
            }
            if (!isArrayLike(collection)) {
              return eachFunc(collection, iteratee2);
            }
            var length = collection.length, index = fromRight ? length : -1, iterable = Object2(collection);
            while (fromRight ? index-- : ++index < length) {
              if (iteratee2(iterable[index], index, iterable) === false) {
                break;
              }
            }
            return collection;
          };
        }
        function createBaseFor(fromRight) {
          return function(object7, iteratee2, keysFunc) {
            var index = -1, iterable = Object2(object7), props = keysFunc(object7), length = props.length;
            while (length--) {
              var key = props[fromRight ? length : ++index];
              if (iteratee2(iterable[key], key, iterable) === false) {
                break;
              }
            }
            return object7;
          };
        }
        function createBind(func, bitmask, thisArg) {
          var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
          function wrapper() {
            var fn = this && this !== root2 && this instanceof wrapper ? Ctor : func;
            return fn.apply(isBind ? thisArg : this, arguments);
          }
          return wrapper;
        }
        function createCaseFirst(methodName) {
          return function(string7) {
            string7 = toString(string7);
            var strSymbols = hasUnicode(string7) ? stringToArray(string7) : undefined2;
            var chr = strSymbols ? strSymbols[0] : string7.charAt(0);
            var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string7.slice(1);
            return chr[methodName]() + trailing;
          };
        }
        function createCompounder(callback) {
          return function(string7) {
            return arrayReduce(words(deburr(string7).replace(reApos, "")), callback, "");
          };
        }
        function createCtor(Ctor) {
          return function() {
            var args = arguments;
            switch (args.length) {
              case 0:
                return new Ctor();
              case 1:
                return new Ctor(args[0]);
              case 2:
                return new Ctor(args[0], args[1]);
              case 3:
                return new Ctor(args[0], args[1], args[2]);
              case 4:
                return new Ctor(args[0], args[1], args[2], args[3]);
              case 5:
                return new Ctor(args[0], args[1], args[2], args[3], args[4]);
              case 6:
                return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
              case 7:
                return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
            }
            var thisBinding = baseCreate(Ctor.prototype), result2 = Ctor.apply(thisBinding, args);
            return isObject(result2) ? result2 : thisBinding;
          };
        }
        function createCurry(func, bitmask, arity) {
          var Ctor = createCtor(func);
          function wrapper() {
            var length = arguments.length, args = Array2(length), index = length, placeholder = getHolder(wrapper);
            while (index--) {
              args[index] = arguments[index];
            }
            var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
            length -= holders.length;
            if (length < arity) {
              return createRecurry(
                func,
                bitmask,
                createHybrid,
                wrapper.placeholder,
                undefined2,
                args,
                holders,
                undefined2,
                undefined2,
                arity - length
              );
            }
            var fn = this && this !== root2 && this instanceof wrapper ? Ctor : func;
            return apply(fn, this, args);
          }
          return wrapper;
        }
        function createFind(findIndexFunc) {
          return function(collection, predicate, fromIndex) {
            var iterable = Object2(collection);
            if (!isArrayLike(collection)) {
              var iteratee2 = getIteratee(predicate, 3);
              collection = keys(collection);
              predicate = function(key) {
                return iteratee2(iterable[key], key, iterable);
              };
            }
            var index = findIndexFunc(collection, predicate, fromIndex);
            return index > -1 ? iterable[iteratee2 ? collection[index] : index] : undefined2;
          };
        }
        function createFlow(fromRight) {
          return flatRest(function(funcs) {
            var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
            if (fromRight) {
              funcs.reverse();
            }
            while (index--) {
              var func = funcs[index];
              if (typeof func != "function") {
                throw new TypeError2(FUNC_ERROR_TEXT);
              }
              if (prereq && !wrapper && getFuncName(func) == "wrapper") {
                var wrapper = new LodashWrapper([], true);
              }
            }
            index = wrapper ? index : length;
            while (++index < length) {
              func = funcs[index];
              var funcName = getFuncName(func), data = funcName == "wrapper" ? getData(func) : undefined2;
              if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) {
                wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
              } else {
                wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
              }
            }
            return function() {
              var args = arguments, value = args[0];
              if (wrapper && args.length == 1 && isArray(value)) {
                return wrapper.plant(value).value();
              }
              var index2 = 0, result2 = length ? funcs[index2].apply(this, args) : value;
              while (++index2 < length) {
                result2 = funcs[index2].call(this, result2);
              }
              return result2;
            };
          });
        }
        function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary2, arity) {
          var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined2 : createCtor(func);
          function wrapper() {
            var length = arguments.length, args = Array2(length), index = length;
            while (index--) {
              args[index] = arguments[index];
            }
            if (isCurried) {
              var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
            }
            if (partials) {
              args = composeArgs(args, partials, holders, isCurried);
            }
            if (partialsRight) {
              args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
            }
            length -= holdersCount;
            if (isCurried && length < arity) {
              var newHolders = replaceHolders(args, placeholder);
              return createRecurry(
                func,
                bitmask,
                createHybrid,
                wrapper.placeholder,
                thisArg,
                args,
                newHolders,
                argPos,
                ary2,
                arity - length
              );
            }
            var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
            length = args.length;
            if (argPos) {
              args = reorder(args, argPos);
            } else if (isFlip && length > 1) {
              args.reverse();
            }
            if (isAry && ary2 < length) {
              args.length = ary2;
            }
            if (this && this !== root2 && this instanceof wrapper) {
              fn = Ctor || createCtor(fn);
            }
            return fn.apply(thisBinding, args);
          }
          return wrapper;
        }
        function createInverter(setter, toIteratee) {
          return function(object7, iteratee2) {
            return baseInverter(object7, setter, toIteratee(iteratee2), {});
          };
        }
        function createMathOperation(operator, defaultValue) {
          return function(value, other) {
            var result2;
            if (value === undefined2 && other === undefined2) {
              return defaultValue;
            }
            if (value !== undefined2) {
              result2 = value;
            }
            if (other !== undefined2) {
              if (result2 === undefined2) {
                return other;
              }
              if (typeof value == "string" || typeof other == "string") {
                value = baseToString(value);
                other = baseToString(other);
              } else {
                value = baseToNumber(value);
                other = baseToNumber(other);
              }
              result2 = operator(value, other);
            }
            return result2;
          };
        }
        function createOver(arrayFunc) {
          return flatRest(function(iteratees) {
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            return baseRest(function(args) {
              var thisArg = this;
              return arrayFunc(iteratees, function(iteratee2) {
                return apply(iteratee2, thisArg, args);
              });
            });
          });
        }
        function createPadding(length, chars) {
          chars = chars === undefined2 ? " " : baseToString(chars);
          var charsLength = chars.length;
          if (charsLength < 2) {
            return charsLength ? baseRepeat(chars, length) : chars;
          }
          var result2 = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
          return hasUnicode(chars) ? castSlice(stringToArray(result2), 0, length).join("") : result2.slice(0, length);
        }
        function createPartial(func, bitmask, thisArg, partials) {
          var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
          function wrapper() {
            var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array2(leftLength + argsLength), fn = this && this !== root2 && this instanceof wrapper ? Ctor : func;
            while (++leftIndex < leftLength) {
              args[leftIndex] = partials[leftIndex];
            }
            while (argsLength--) {
              args[leftIndex++] = arguments[++argsIndex];
            }
            return apply(fn, isBind ? thisArg : this, args);
          }
          return wrapper;
        }
        function createRange(fromRight) {
          return function(start, end, step) {
            if (step && typeof step != "number" && isIterateeCall(start, end, step)) {
              end = step = undefined2;
            }
            start = toFinite(start);
            if (end === undefined2) {
              end = start;
              start = 0;
            } else {
              end = toFinite(end);
            }
            step = step === undefined2 ? start < end ? 1 : -1 : toFinite(step);
            return baseRange(start, end, step, fromRight);
          };
        }
        function createRelationalOperation(operator) {
          return function(value, other) {
            if (!(typeof value == "string" && typeof other == "string")) {
              value = toNumber(value);
              other = toNumber(other);
            }
            return operator(value, other);
          };
        }
        function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary2, arity) {
          var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined2, newHoldersRight = isCurry ? undefined2 : holders, newPartials = isCurry ? partials : undefined2, newPartialsRight = isCurry ? undefined2 : partials;
          bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
          bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
          if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
            bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
          }
          var newData = [
            func,
            bitmask,
            thisArg,
            newPartials,
            newHolders,
            newPartialsRight,
            newHoldersRight,
            argPos,
            ary2,
            arity
          ];
          var result2 = wrapFunc.apply(undefined2, newData);
          if (isLaziable(func)) {
            setData(result2, newData);
          }
          result2.placeholder = placeholder;
          return setWrapToString(result2, func, bitmask);
        }
        function createRound(methodName) {
          var func = Math2[methodName];
          return function(number2, precision) {
            number2 = toNumber(number2);
            precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
            if (precision && nativeIsFinite(number2)) {
              var pair = (toString(number2) + "e").split("e"), value = func(pair[0] + "e" + (+pair[1] + precision));
              pair = (toString(value) + "e").split("e");
              return +(pair[0] + "e" + (+pair[1] - precision));
            }
            return func(number2);
          };
        }
        var createSet = !(Set2 && 1 / setToArray(new Set2([, -0]))[1] == INFINITY) ? noop2 : function(values2) {
          return new Set2(values2);
        };
        function createToPairs(keysFunc) {
          return function(object7) {
            var tag = getTag(object7);
            if (tag == mapTag) {
              return mapToArray(object7);
            }
            if (tag == setTag) {
              return setToPairs(object7);
            }
            return baseToPairs(object7, keysFunc(object7));
          };
        }
        function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary2, arity) {
          var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
          if (!isBindKey && typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          var length = partials ? partials.length : 0;
          if (!length) {
            bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
            partials = holders = undefined2;
          }
          ary2 = ary2 === undefined2 ? ary2 : nativeMax(toInteger(ary2), 0);
          arity = arity === undefined2 ? arity : toInteger(arity);
          length -= holders ? holders.length : 0;
          if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
            var partialsRight = partials, holdersRight = holders;
            partials = holders = undefined2;
          }
          var data = isBindKey ? undefined2 : getData(func);
          var newData = [
            func,
            bitmask,
            thisArg,
            partials,
            holders,
            partialsRight,
            holdersRight,
            argPos,
            ary2,
            arity
          ];
          if (data) {
            mergeData(newData, data);
          }
          func = newData[0];
          bitmask = newData[1];
          thisArg = newData[2];
          partials = newData[3];
          holders = newData[4];
          arity = newData[9] = newData[9] === undefined2 ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
          if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
            bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
          }
          if (!bitmask || bitmask == WRAP_BIND_FLAG) {
            var result2 = createBind(func, bitmask, thisArg);
          } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
            result2 = createCurry(func, bitmask, arity);
          } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
            result2 = createPartial(func, bitmask, thisArg, partials);
          } else {
            result2 = createHybrid.apply(undefined2, newData);
          }
          var setter = data ? baseSetData : setData;
          return setWrapToString(setter(result2, newData), func, bitmask);
        }
        function customDefaultsAssignIn(objValue, srcValue, key, object7) {
          if (objValue === undefined2 || eq(objValue, objectProto3[key]) && !hasOwnProperty2.call(object7, key)) {
            return srcValue;
          }
          return objValue;
        }
        function customDefaultsMerge(objValue, srcValue, key, object7, source, stack) {
          if (isObject(objValue) && isObject(srcValue)) {
            stack.set(srcValue, objValue);
            baseMerge(objValue, srcValue, undefined2, customDefaultsMerge, stack);
            stack["delete"](srcValue);
          }
          return objValue;
        }
        function customOmitClone(value) {
          return isPlainObject(value) ? undefined2 : value;
        }
        function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
          if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
            return false;
          }
          var arrStacked = stack.get(array);
          var othStacked = stack.get(other);
          if (arrStacked && othStacked) {
            return arrStacked == other && othStacked == array;
          }
          var index = -1, result2 = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache() : undefined2;
          stack.set(array, other);
          stack.set(other, array);
          while (++index < arrLength) {
            var arrValue = array[index], othValue = other[index];
            if (customizer) {
              var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
            }
            if (compared !== undefined2) {
              if (compared) {
                continue;
              }
              result2 = false;
              break;
            }
            if (seen) {
              if (!arraySome(other, function(othValue2, othIndex) {
                if (!cacheHas(seen, othIndex) && (arrValue === othValue2 || equalFunc(arrValue, othValue2, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
                result2 = false;
                break;
              }
            } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              result2 = false;
              break;
            }
          }
          stack["delete"](array);
          stack["delete"](other);
          return result2;
        }
        function equalByTag(object7, other, tag, bitmask, customizer, equalFunc, stack) {
          switch (tag) {
            case dataViewTag:
              if (object7.byteLength != other.byteLength || object7.byteOffset != other.byteOffset) {
                return false;
              }
              object7 = object7.buffer;
              other = other.buffer;
            case arrayBufferTag:
              if (object7.byteLength != other.byteLength || !equalFunc(new Uint8Array2(object7), new Uint8Array2(other))) {
                return false;
              }
              return true;
            case boolTag:
            case dateTag:
            case numberTag:
              return eq(+object7, +other);
            case errorTag:
              return object7.name == other.name && object7.message == other.message;
            case regexpTag:
            case stringTag:
              return object7 == other + "";
            case mapTag:
              var convert = mapToArray;
            case setTag:
              var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
              convert || (convert = setToArray);
              if (object7.size != other.size && !isPartial) {
                return false;
              }
              var stacked = stack.get(object7);
              if (stacked) {
                return stacked == other;
              }
              bitmask |= COMPARE_UNORDERED_FLAG;
              stack.set(object7, other);
              var result2 = equalArrays(convert(object7), convert(other), bitmask, customizer, equalFunc, stack);
              stack["delete"](object7);
              return result2;
            case symbolTag:
              if (symbolValueOf) {
                return symbolValueOf.call(object7) == symbolValueOf.call(other);
              }
          }
          return false;
        }
        function equalObjects(object7, other, bitmask, customizer, equalFunc, stack) {
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object7), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
          if (objLength != othLength && !isPartial) {
            return false;
          }
          var index = objLength;
          while (index--) {
            var key = objProps[index];
            if (!(isPartial ? key in other : hasOwnProperty2.call(other, key))) {
              return false;
            }
          }
          var objStacked = stack.get(object7);
          var othStacked = stack.get(other);
          if (objStacked && othStacked) {
            return objStacked == other && othStacked == object7;
          }
          var result2 = true;
          stack.set(object7, other);
          stack.set(other, object7);
          var skipCtor = isPartial;
          while (++index < objLength) {
            key = objProps[index];
            var objValue = object7[key], othValue = other[key];
            if (customizer) {
              var compared = isPartial ? customizer(othValue, objValue, key, other, object7, stack) : customizer(objValue, othValue, key, object7, other, stack);
            }
            if (!(compared === undefined2 ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
              result2 = false;
              break;
            }
            skipCtor || (skipCtor = key == "constructor");
          }
          if (result2 && !skipCtor) {
            var objCtor = object7.constructor, othCtor = other.constructor;
            if (objCtor != othCtor && ("constructor" in object7 && "constructor" in other) && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) {
              result2 = false;
            }
          }
          stack["delete"](object7);
          stack["delete"](other);
          return result2;
        }
        function flatRest(func) {
          return setToString(overRest(func, undefined2, flatten), func + "");
        }
        function getAllKeys(object7) {
          return baseGetAllKeys(object7, keys, getSymbols);
        }
        function getAllKeysIn(object7) {
          return baseGetAllKeys(object7, keysIn, getSymbolsIn);
        }
        var getData = !metaMap ? noop2 : function(func) {
          return metaMap.get(func);
        };
        function getFuncName(func) {
          var result2 = func.name + "", array = realNames[result2], length = hasOwnProperty2.call(realNames, result2) ? array.length : 0;
          while (length--) {
            var data = array[length], otherFunc = data.func;
            if (otherFunc == null || otherFunc == func) {
              return data.name;
            }
          }
          return result2;
        }
        function getHolder(func) {
          var object7 = hasOwnProperty2.call(lodash, "placeholder") ? lodash : func;
          return object7.placeholder;
        }
        function getIteratee() {
          var result2 = lodash.iteratee || iteratee;
          result2 = result2 === iteratee ? baseIteratee : result2;
          return arguments.length ? result2(arguments[0], arguments[1]) : result2;
        }
        function getMapData(map2, key) {
          var data = map2.__data__;
          return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
        }
        function getMatchData(object7) {
          var result2 = keys(object7), length = result2.length;
          while (length--) {
            var key = result2[length], value = object7[key];
            result2[length] = [key, value, isStrictComparable(value)];
          }
          return result2;
        }
        function getNative(object7, key) {
          var value = getValue(object7, key);
          return baseIsNative(value) ? value : undefined2;
        }
        function getRawTag(value) {
          var isOwn = hasOwnProperty2.call(value, symToStringTag3), tag = value[symToStringTag3];
          try {
            value[symToStringTag3] = undefined2;
            var unmasked = true;
          } catch (e) {
          }
          var result2 = nativeObjectToString3.call(value);
          if (unmasked) {
            if (isOwn) {
              value[symToStringTag3] = tag;
            } else {
              delete value[symToStringTag3];
            }
          }
          return result2;
        }
        var getSymbols = !nativeGetSymbols ? stubArray : function(object7) {
          if (object7 == null) {
            return [];
          }
          object7 = Object2(object7);
          return arrayFilter(nativeGetSymbols(object7), function(symbol) {
            return propertyIsEnumerable.call(object7, symbol);
          });
        };
        var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object7) {
          var result2 = [];
          while (object7) {
            arrayPush(result2, getSymbols(object7));
            object7 = getPrototype(object7);
          }
          return result2;
        };
        var getTag = baseGetTag;
        if (DataView2 && getTag(new DataView2(new ArrayBuffer(1))) != dataViewTag || Map2 && getTag(new Map2()) != mapTag || Promise2 && getTag(Promise2.resolve()) != promiseTag || Set2 && getTag(new Set2()) != setTag || WeakMap2 && getTag(new WeakMap2()) != weakMapTag) {
          getTag = function(value) {
            var result2 = baseGetTag(value), Ctor = result2 == objectTag ? value.constructor : undefined2, ctorString = Ctor ? toSource(Ctor) : "";
            if (ctorString) {
              switch (ctorString) {
                case dataViewCtorString:
                  return dataViewTag;
                case mapCtorString:
                  return mapTag;
                case promiseCtorString:
                  return promiseTag;
                case setCtorString:
                  return setTag;
                case weakMapCtorString:
                  return weakMapTag;
              }
            }
            return result2;
          };
        }
        function getView(start, end, transforms) {
          var index = -1, length = transforms.length;
          while (++index < length) {
            var data = transforms[index], size2 = data.size;
            switch (data.type) {
              case "drop":
                start += size2;
                break;
              case "dropRight":
                end -= size2;
                break;
              case "take":
                end = nativeMin(end, start + size2);
                break;
              case "takeRight":
                start = nativeMax(start, end - size2);
                break;
            }
          }
          return { "start": start, "end": end };
        }
        function getWrapDetails(source) {
          var match = source.match(reWrapDetails);
          return match ? match[1].split(reSplitDetails) : [];
        }
        function hasPath(object7, path, hasFunc) {
          path = castPath(path, object7);
          var index = -1, length = path.length, result2 = false;
          while (++index < length) {
            var key = toKey(path[index]);
            if (!(result2 = object7 != null && hasFunc(object7, key))) {
              break;
            }
            object7 = object7[key];
          }
          if (result2 || ++index != length) {
            return result2;
          }
          length = object7 == null ? 0 : object7.length;
          return !!length && isLength(length) && isIndex(key, length) && (isArray(object7) || isArguments(object7));
        }
        function initCloneArray(array) {
          var length = array.length, result2 = new array.constructor(length);
          if (length && typeof array[0] == "string" && hasOwnProperty2.call(array, "index")) {
            result2.index = array.index;
            result2.input = array.input;
          }
          return result2;
        }
        function initCloneObject(object7) {
          return typeof object7.constructor == "function" && !isPrototype(object7) ? baseCreate(getPrototype(object7)) : {};
        }
        function initCloneByTag(object7, tag, isDeep) {
          var Ctor = object7.constructor;
          switch (tag) {
            case arrayBufferTag:
              return cloneArrayBuffer(object7);
            case boolTag:
            case dateTag:
              return new Ctor(+object7);
            case dataViewTag:
              return cloneDataView(object7, isDeep);
            case float32Tag:
            case float64Tag:
            case int8Tag:
            case int16Tag:
            case int32Tag:
            case uint8Tag:
            case uint8ClampedTag:
            case uint16Tag:
            case uint32Tag:
              return cloneTypedArray(object7, isDeep);
            case mapTag:
              return new Ctor();
            case numberTag:
            case stringTag:
              return new Ctor(object7);
            case regexpTag:
              return cloneRegExp(object7);
            case setTag:
              return new Ctor();
            case symbolTag:
              return cloneSymbol(object7);
          }
        }
        function insertWrapDetails(source, details) {
          var length = details.length;
          if (!length) {
            return source;
          }
          var lastIndex = length - 1;
          details[lastIndex] = (length > 1 ? "& " : "") + details[lastIndex];
          details = details.join(length > 2 ? ", " : " ");
          return source.replace(reWrapComment, "{\n/* [wrapped with " + details + "] */\n");
        }
        function isFlattenable(value) {
          return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        function isIndex(value, length) {
          var type = typeof value;
          length = length == null ? MAX_SAFE_INTEGER : length;
          return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && (value > -1 && value % 1 == 0 && value < length);
        }
        function isIterateeCall(value, index, object7) {
          if (!isObject(object7)) {
            return false;
          }
          var type = typeof index;
          if (type == "number" ? isArrayLike(object7) && isIndex(index, object7.length) : type == "string" && index in object7) {
            return eq(object7[index], value);
          }
          return false;
        }
        function isKey(value, object7) {
          if (isArray(value)) {
            return false;
          }
          var type = typeof value;
          if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) {
            return true;
          }
          return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object7 != null && value in Object2(object7);
        }
        function isKeyable(value) {
          var type = typeof value;
          return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
        }
        function isLaziable(func) {
          var funcName = getFuncName(func), other = lodash[funcName];
          if (typeof other != "function" || !(funcName in LazyWrapper.prototype)) {
            return false;
          }
          if (func === other) {
            return true;
          }
          var data = getData(other);
          return !!data && func === data[0];
        }
        function isMasked(func) {
          return !!maskSrcKey && maskSrcKey in func;
        }
        var isMaskable = coreJsData ? isFunction : stubFalse;
        function isPrototype(value) {
          var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto3;
          return value === proto;
        }
        function isStrictComparable(value) {
          return value === value && !isObject(value);
        }
        function matchesStrictComparable(key, srcValue) {
          return function(object7) {
            if (object7 == null) {
              return false;
            }
            return object7[key] === srcValue && (srcValue !== undefined2 || key in Object2(object7));
          };
        }
        function memoizeCapped(func) {
          var result2 = memoize(func, function(key) {
            if (cache.size === MAX_MEMOIZE_SIZE) {
              cache.clear();
            }
            return key;
          });
          var cache = result2.cache;
          return result2;
        }
        function mergeData(data, source) {
          var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
          var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
          if (!(isCommon || isCombo)) {
            return data;
          }
          if (srcBitmask & WRAP_BIND_FLAG) {
            data[2] = source[2];
            newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
          }
          var value = source[3];
          if (value) {
            var partials = data[3];
            data[3] = partials ? composeArgs(partials, value, source[4]) : value;
            data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
          }
          value = source[5];
          if (value) {
            partials = data[5];
            data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
            data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
          }
          value = source[7];
          if (value) {
            data[7] = value;
          }
          if (srcBitmask & WRAP_ARY_FLAG) {
            data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
          }
          if (data[9] == null) {
            data[9] = source[9];
          }
          data[0] = source[0];
          data[1] = newBitmask;
          return data;
        }
        function nativeKeysIn(object7) {
          var result2 = [];
          if (object7 != null) {
            for (var key in Object2(object7)) {
              result2.push(key);
            }
          }
          return result2;
        }
        function objectToString(value) {
          return nativeObjectToString3.call(value);
        }
        function overRest(func, start, transform2) {
          start = nativeMax(start === undefined2 ? func.length - 1 : start, 0);
          return function() {
            var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array2(length);
            while (++index < length) {
              array[index] = args[start + index];
            }
            index = -1;
            var otherArgs = Array2(start + 1);
            while (++index < start) {
              otherArgs[index] = args[index];
            }
            otherArgs[start] = transform2(array);
            return apply(func, this, otherArgs);
          };
        }
        function parent(object7, path) {
          return path.length < 2 ? object7 : baseGet(object7, baseSlice(path, 0, -1));
        }
        function reorder(array, indexes) {
          var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
          while (length--) {
            var index = indexes[length];
            array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined2;
          }
          return array;
        }
        function safeGet(object7, key) {
          if (key === "constructor" && typeof object7[key] === "function") {
            return;
          }
          if (key == "__proto__") {
            return;
          }
          return object7[key];
        }
        var setData = shortOut(baseSetData);
        var setTimeout2 = ctxSetTimeout || function(func, wait) {
          return root2.setTimeout(func, wait);
        };
        var setToString = shortOut(baseSetToString);
        function setWrapToString(wrapper, reference, bitmask) {
          var source = reference + "";
          return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        function shortOut(func) {
          var count = 0, lastCalled = 0;
          return function() {
            var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
            lastCalled = stamp;
            if (remaining > 0) {
              if (++count >= HOT_COUNT) {
                return arguments[0];
              }
            } else {
              count = 0;
            }
            return func.apply(undefined2, arguments);
          };
        }
        function shuffleSelf(array, size2) {
          var index = -1, length = array.length, lastIndex = length - 1;
          size2 = size2 === undefined2 ? length : size2;
          while (++index < size2) {
            var rand = baseRandom(index, lastIndex), value = array[rand];
            array[rand] = array[index];
            array[index] = value;
          }
          array.length = size2;
          return array;
        }
        var stringToPath = memoizeCapped(function(string7) {
          var result2 = [];
          if (string7.charCodeAt(0) === 46) {
            result2.push("");
          }
          string7.replace(rePropName, function(match, number2, quote, subString) {
            result2.push(quote ? subString.replace(reEscapeChar, "$1") : number2 || match);
          });
          return result2;
        });
        function toKey(value) {
          if (typeof value == "string" || isSymbol(value)) {
            return value;
          }
          var result2 = value + "";
          return result2 == "0" && 1 / value == -INFINITY ? "-0" : result2;
        }
        function toSource(func) {
          if (func != null) {
            try {
              return funcToString.call(func);
            } catch (e) {
            }
            try {
              return func + "";
            } catch (e) {
            }
          }
          return "";
        }
        function updateWrapDetails(details, bitmask) {
          arrayEach(wrapFlags, function(pair) {
            var value = "_." + pair[0];
            if (bitmask & pair[1] && !arrayIncludes(details, value)) {
              details.push(value);
            }
          });
          return details.sort();
        }
        function wrapperClone(wrapper) {
          if (wrapper instanceof LazyWrapper) {
            return wrapper.clone();
          }
          var result2 = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
          result2.__actions__ = copyArray(wrapper.__actions__);
          result2.__index__ = wrapper.__index__;
          result2.__values__ = wrapper.__values__;
          return result2;
        }
        function chunk(array, size2, guard) {
          if (guard ? isIterateeCall(array, size2, guard) : size2 === undefined2) {
            size2 = 1;
          } else {
            size2 = nativeMax(toInteger(size2), 0);
          }
          var length = array == null ? 0 : array.length;
          if (!length || size2 < 1) {
            return [];
          }
          var index = 0, resIndex = 0, result2 = Array2(nativeCeil(length / size2));
          while (index < length) {
            result2[resIndex++] = baseSlice(array, index, index += size2);
          }
          return result2;
        }
        function compact(array) {
          var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result2 = [];
          while (++index < length) {
            var value = array[index];
            if (value) {
              result2[resIndex++] = value;
            }
          }
          return result2;
        }
        function concat() {
          var length = arguments.length;
          if (!length) {
            return [];
          }
          var args = Array2(length - 1), array = arguments[0], index = length;
          while (index--) {
            args[index - 1] = arguments[index];
          }
          return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
        }
        var difference = baseRest(function(array, values2) {
          return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values2, 1, isArrayLikeObject, true)) : [];
        });
        var differenceBy = baseRest(function(array, values2) {
          var iteratee2 = last(values2);
          if (isArrayLikeObject(iteratee2)) {
            iteratee2 = undefined2;
          }
          return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values2, 1, isArrayLikeObject, true), getIteratee(iteratee2, 2)) : [];
        });
        var differenceWith = baseRest(function(array, values2) {
          var comparator = last(values2);
          if (isArrayLikeObject(comparator)) {
            comparator = undefined2;
          }
          return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values2, 1, isArrayLikeObject, true), undefined2, comparator) : [];
        });
        function drop(array, n, guard) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return [];
          }
          n = guard || n === undefined2 ? 1 : toInteger(n);
          return baseSlice(array, n < 0 ? 0 : n, length);
        }
        function dropRight(array, n, guard) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return [];
          }
          n = guard || n === undefined2 ? 1 : toInteger(n);
          n = length - n;
          return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        function dropRightWhile(array, predicate) {
          return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        function dropWhile(array, predicate) {
          return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        function fill(array, value, start, end) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return [];
          }
          if (start && typeof start != "number" && isIterateeCall(array, value, start)) {
            start = 0;
            end = length;
          }
          return baseFill(array, value, start, end);
        }
        function findIndex(array, predicate, fromIndex) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return -1;
          }
          var index = fromIndex == null ? 0 : toInteger(fromIndex);
          if (index < 0) {
            index = nativeMax(length + index, 0);
          }
          return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        function findLastIndex(array, predicate, fromIndex) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return -1;
          }
          var index = length - 1;
          if (fromIndex !== undefined2) {
            index = toInteger(fromIndex);
            index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
          }
          return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        function flatten(array) {
          var length = array == null ? 0 : array.length;
          return length ? baseFlatten(array, 1) : [];
        }
        function flattenDeep(array) {
          var length = array == null ? 0 : array.length;
          return length ? baseFlatten(array, INFINITY) : [];
        }
        function flattenDepth(array, depth) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return [];
          }
          depth = depth === undefined2 ? 1 : toInteger(depth);
          return baseFlatten(array, depth);
        }
        function fromPairs(pairs) {
          var index = -1, length = pairs == null ? 0 : pairs.length, result2 = {};
          while (++index < length) {
            var pair = pairs[index];
            result2[pair[0]] = pair[1];
          }
          return result2;
        }
        function head(array) {
          return array && array.length ? array[0] : undefined2;
        }
        function indexOf(array, value, fromIndex) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return -1;
          }
          var index = fromIndex == null ? 0 : toInteger(fromIndex);
          if (index < 0) {
            index = nativeMax(length + index, 0);
          }
          return baseIndexOf(array, value, index);
        }
        function initial(array) {
          var length = array == null ? 0 : array.length;
          return length ? baseSlice(array, 0, -1) : [];
        }
        var intersection = baseRest(function(arrays) {
          var mapped = arrayMap(arrays, castArrayLikeObject);
          return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        var intersectionBy = baseRest(function(arrays) {
          var iteratee2 = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
          if (iteratee2 === last(mapped)) {
            iteratee2 = undefined2;
          } else {
            mapped.pop();
          }
          return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee2, 2)) : [];
        });
        var intersectionWith = baseRest(function(arrays) {
          var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
          comparator = typeof comparator == "function" ? comparator : undefined2;
          if (comparator) {
            mapped.pop();
          }
          return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined2, comparator) : [];
        });
        function join(array, separator) {
          return array == null ? "" : nativeJoin.call(array, separator);
        }
        function last(array) {
          var length = array == null ? 0 : array.length;
          return length ? array[length - 1] : undefined2;
        }
        function lastIndexOf(array, value, fromIndex) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return -1;
          }
          var index = length;
          if (fromIndex !== undefined2) {
            index = toInteger(fromIndex);
            index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
          }
          return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        function nth(array, n) {
          return array && array.length ? baseNth(array, toInteger(n)) : undefined2;
        }
        var pull = baseRest(pullAll);
        function pullAll(array, values2) {
          return array && array.length && values2 && values2.length ? basePullAll(array, values2) : array;
        }
        function pullAllBy(array, values2, iteratee2) {
          return array && array.length && values2 && values2.length ? basePullAll(array, values2, getIteratee(iteratee2, 2)) : array;
        }
        function pullAllWith(array, values2, comparator) {
          return array && array.length && values2 && values2.length ? basePullAll(array, values2, undefined2, comparator) : array;
        }
        var pullAt = flatRest(function(array, indexes) {
          var length = array == null ? 0 : array.length, result2 = baseAt(array, indexes);
          basePullAt(array, arrayMap(indexes, function(index) {
            return isIndex(index, length) ? +index : index;
          }).sort(compareAscending));
          return result2;
        });
        function remove(array, predicate) {
          var result2 = [];
          if (!(array && array.length)) {
            return result2;
          }
          var index = -1, indexes = [], length = array.length;
          predicate = getIteratee(predicate, 3);
          while (++index < length) {
            var value = array[index];
            if (predicate(value, index, array)) {
              result2.push(value);
              indexes.push(index);
            }
          }
          basePullAt(array, indexes);
          return result2;
        }
        function reverse(array) {
          return array == null ? array : nativeReverse.call(array);
        }
        function slice(array, start, end) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return [];
          }
          if (end && typeof end != "number" && isIterateeCall(array, start, end)) {
            start = 0;
            end = length;
          } else {
            start = start == null ? 0 : toInteger(start);
            end = end === undefined2 ? length : toInteger(end);
          }
          return baseSlice(array, start, end);
        }
        function sortedIndex(array, value) {
          return baseSortedIndex(array, value);
        }
        function sortedIndexBy(array, value, iteratee2) {
          return baseSortedIndexBy(array, value, getIteratee(iteratee2, 2));
        }
        function sortedIndexOf(array, value) {
          var length = array == null ? 0 : array.length;
          if (length) {
            var index = baseSortedIndex(array, value);
            if (index < length && eq(array[index], value)) {
              return index;
            }
          }
          return -1;
        }
        function sortedLastIndex(array, value) {
          return baseSortedIndex(array, value, true);
        }
        function sortedLastIndexBy(array, value, iteratee2) {
          return baseSortedIndexBy(array, value, getIteratee(iteratee2, 2), true);
        }
        function sortedLastIndexOf(array, value) {
          var length = array == null ? 0 : array.length;
          if (length) {
            var index = baseSortedIndex(array, value, true) - 1;
            if (eq(array[index], value)) {
              return index;
            }
          }
          return -1;
        }
        function sortedUniq(array) {
          return array && array.length ? baseSortedUniq(array) : [];
        }
        function sortedUniqBy(array, iteratee2) {
          return array && array.length ? baseSortedUniq(array, getIteratee(iteratee2, 2)) : [];
        }
        function tail(array) {
          var length = array == null ? 0 : array.length;
          return length ? baseSlice(array, 1, length) : [];
        }
        function take(array, n, guard) {
          if (!(array && array.length)) {
            return [];
          }
          n = guard || n === undefined2 ? 1 : toInteger(n);
          return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        function takeRight(array, n, guard) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return [];
          }
          n = guard || n === undefined2 ? 1 : toInteger(n);
          n = length - n;
          return baseSlice(array, n < 0 ? 0 : n, length);
        }
        function takeRightWhile(array, predicate) {
          return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        function takeWhile(array, predicate) {
          return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        var union = baseRest(function(arrays) {
          return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        var unionBy = baseRest(function(arrays) {
          var iteratee2 = last(arrays);
          if (isArrayLikeObject(iteratee2)) {
            iteratee2 = undefined2;
          }
          return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee2, 2));
        });
        var unionWith = baseRest(function(arrays) {
          var comparator = last(arrays);
          comparator = typeof comparator == "function" ? comparator : undefined2;
          return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined2, comparator);
        });
        function uniq(array) {
          return array && array.length ? baseUniq(array) : [];
        }
        function uniqBy(array, iteratee2) {
          return array && array.length ? baseUniq(array, getIteratee(iteratee2, 2)) : [];
        }
        function uniqWith(array, comparator) {
          comparator = typeof comparator == "function" ? comparator : undefined2;
          return array && array.length ? baseUniq(array, undefined2, comparator) : [];
        }
        function unzip(array) {
          if (!(array && array.length)) {
            return [];
          }
          var length = 0;
          array = arrayFilter(array, function(group) {
            if (isArrayLikeObject(group)) {
              length = nativeMax(group.length, length);
              return true;
            }
          });
          return baseTimes(length, function(index) {
            return arrayMap(array, baseProperty(index));
          });
        }
        function unzipWith(array, iteratee2) {
          if (!(array && array.length)) {
            return [];
          }
          var result2 = unzip(array);
          if (iteratee2 == null) {
            return result2;
          }
          return arrayMap(result2, function(group) {
            return apply(iteratee2, undefined2, group);
          });
        }
        var without = baseRest(function(array, values2) {
          return isArrayLikeObject(array) ? baseDifference(array, values2) : [];
        });
        var xor = baseRest(function(arrays) {
          return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        var xorBy = baseRest(function(arrays) {
          var iteratee2 = last(arrays);
          if (isArrayLikeObject(iteratee2)) {
            iteratee2 = undefined2;
          }
          return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee2, 2));
        });
        var xorWith = baseRest(function(arrays) {
          var comparator = last(arrays);
          comparator = typeof comparator == "function" ? comparator : undefined2;
          return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined2, comparator);
        });
        var zip = baseRest(unzip);
        function zipObject(props, values2) {
          return baseZipObject(props || [], values2 || [], assignValue);
        }
        function zipObjectDeep(props, values2) {
          return baseZipObject(props || [], values2 || [], baseSet);
        }
        var zipWith = baseRest(function(arrays) {
          var length = arrays.length, iteratee2 = length > 1 ? arrays[length - 1] : undefined2;
          iteratee2 = typeof iteratee2 == "function" ? (arrays.pop(), iteratee2) : undefined2;
          return unzipWith(arrays, iteratee2);
        });
        function chain(value) {
          var result2 = lodash(value);
          result2.__chain__ = true;
          return result2;
        }
        function tap(value, interceptor) {
          interceptor(value);
          return value;
        }
        function thru(value, interceptor) {
          return interceptor(value);
        }
        var wrapperAt = flatRest(function(paths) {
          var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object7) {
            return baseAt(object7, paths);
          };
          if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) {
            return this.thru(interceptor);
          }
          value = value.slice(start, +start + (length ? 1 : 0));
          value.__actions__.push({
            "func": thru,
            "args": [interceptor],
            "thisArg": undefined2
          });
          return new LodashWrapper(value, this.__chain__).thru(function(array) {
            if (length && !array.length) {
              array.push(undefined2);
            }
            return array;
          });
        });
        function wrapperChain() {
          return chain(this);
        }
        function wrapperCommit() {
          return new LodashWrapper(this.value(), this.__chain__);
        }
        function wrapperNext() {
          if (this.__values__ === undefined2) {
            this.__values__ = toArray(this.value());
          }
          var done = this.__index__ >= this.__values__.length, value = done ? undefined2 : this.__values__[this.__index__++];
          return { "done": done, "value": value };
        }
        function wrapperToIterator() {
          return this;
        }
        function wrapperPlant(value) {
          var result2, parent2 = this;
          while (parent2 instanceof baseLodash) {
            var clone2 = wrapperClone(parent2);
            clone2.__index__ = 0;
            clone2.__values__ = undefined2;
            if (result2) {
              previous.__wrapped__ = clone2;
            } else {
              result2 = clone2;
            }
            var previous = clone2;
            parent2 = parent2.__wrapped__;
          }
          previous.__wrapped__ = value;
          return result2;
        }
        function wrapperReverse() {
          var value = this.__wrapped__;
          if (value instanceof LazyWrapper) {
            var wrapped = value;
            if (this.__actions__.length) {
              wrapped = new LazyWrapper(this);
            }
            wrapped = wrapped.reverse();
            wrapped.__actions__.push({
              "func": thru,
              "args": [reverse],
              "thisArg": undefined2
            });
            return new LodashWrapper(wrapped, this.__chain__);
          }
          return this.thru(reverse);
        }
        function wrapperValue() {
          return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        var countBy = createAggregator(function(result2, value, key) {
          if (hasOwnProperty2.call(result2, key)) {
            ++result2[key];
          } else {
            baseAssignValue(result2, key, 1);
          }
        });
        function every(collection, predicate, guard) {
          var func = isArray(collection) ? arrayEvery : baseEvery;
          if (guard && isIterateeCall(collection, predicate, guard)) {
            predicate = undefined2;
          }
          return func(collection, getIteratee(predicate, 3));
        }
        function filter(collection, predicate) {
          var func = isArray(collection) ? arrayFilter : baseFilter;
          return func(collection, getIteratee(predicate, 3));
        }
        var find = createFind(findIndex);
        var findLast = createFind(findLastIndex);
        function flatMap(collection, iteratee2) {
          return baseFlatten(map(collection, iteratee2), 1);
        }
        function flatMapDeep(collection, iteratee2) {
          return baseFlatten(map(collection, iteratee2), INFINITY);
        }
        function flatMapDepth(collection, iteratee2, depth) {
          depth = depth === undefined2 ? 1 : toInteger(depth);
          return baseFlatten(map(collection, iteratee2), depth);
        }
        function forEach(collection, iteratee2) {
          var func = isArray(collection) ? arrayEach : baseEach;
          return func(collection, getIteratee(iteratee2, 3));
        }
        function forEachRight(collection, iteratee2) {
          var func = isArray(collection) ? arrayEachRight : baseEachRight;
          return func(collection, getIteratee(iteratee2, 3));
        }
        var groupBy = createAggregator(function(result2, value, key) {
          if (hasOwnProperty2.call(result2, key)) {
            result2[key].push(value);
          } else {
            baseAssignValue(result2, key, [value]);
          }
        });
        function includes(collection, value, fromIndex, guard) {
          collection = isArrayLike(collection) ? collection : values(collection);
          fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
          var length = collection.length;
          if (fromIndex < 0) {
            fromIndex = nativeMax(length + fromIndex, 0);
          }
          return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        var invokeMap = baseRest(function(collection, path, args) {
          var index = -1, isFunc = typeof path == "function", result2 = isArrayLike(collection) ? Array2(collection.length) : [];
          baseEach(collection, function(value) {
            result2[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
          });
          return result2;
        });
        var keyBy = createAggregator(function(result2, value, key) {
          baseAssignValue(result2, key, value);
        });
        function map(collection, iteratee2) {
          var func = isArray(collection) ? arrayMap : baseMap;
          return func(collection, getIteratee(iteratee2, 3));
        }
        function orderBy(collection, iteratees, orders, guard) {
          if (collection == null) {
            return [];
          }
          if (!isArray(iteratees)) {
            iteratees = iteratees == null ? [] : [iteratees];
          }
          orders = guard ? undefined2 : orders;
          if (!isArray(orders)) {
            orders = orders == null ? [] : [orders];
          }
          return baseOrderBy(collection, iteratees, orders);
        }
        var partition = createAggregator(function(result2, value, key) {
          result2[key ? 0 : 1].push(value);
        }, function() {
          return [[], []];
        });
        function reduce(collection, iteratee2, accumulator) {
          var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
          return func(collection, getIteratee(iteratee2, 4), accumulator, initAccum, baseEach);
        }
        function reduceRight(collection, iteratee2, accumulator) {
          var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
          return func(collection, getIteratee(iteratee2, 4), accumulator, initAccum, baseEachRight);
        }
        function reject2(collection, predicate) {
          var func = isArray(collection) ? arrayFilter : baseFilter;
          return func(collection, negate(getIteratee(predicate, 3)));
        }
        function sample(collection) {
          var func = isArray(collection) ? arraySample : baseSample;
          return func(collection);
        }
        function sampleSize(collection, n, guard) {
          if (guard ? isIterateeCall(collection, n, guard) : n === undefined2) {
            n = 1;
          } else {
            n = toInteger(n);
          }
          var func = isArray(collection) ? arraySampleSize : baseSampleSize;
          return func(collection, n);
        }
        function shuffle(collection) {
          var func = isArray(collection) ? arrayShuffle : baseShuffle;
          return func(collection);
        }
        function size(collection) {
          if (collection == null) {
            return 0;
          }
          if (isArrayLike(collection)) {
            return isString(collection) ? stringSize(collection) : collection.length;
          }
          var tag = getTag(collection);
          if (tag == mapTag || tag == setTag) {
            return collection.size;
          }
          return baseKeys(collection).length;
        }
        function some(collection, predicate, guard) {
          var func = isArray(collection) ? arraySome : baseSome;
          if (guard && isIterateeCall(collection, predicate, guard)) {
            predicate = undefined2;
          }
          return func(collection, getIteratee(predicate, 3));
        }
        var sortBy = baseRest(function(collection, iteratees) {
          if (collection == null) {
            return [];
          }
          var length = iteratees.length;
          if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
            iteratees = [];
          } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
            iteratees = [iteratees[0]];
          }
          return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        var now = ctxNow || function() {
          return root2.Date.now();
        };
        function after(n, func) {
          if (typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          n = toInteger(n);
          return function() {
            if (--n < 1) {
              return func.apply(this, arguments);
            }
          };
        }
        function ary(func, n, guard) {
          n = guard ? undefined2 : n;
          n = func && n == null ? func.length : n;
          return createWrap(func, WRAP_ARY_FLAG, undefined2, undefined2, undefined2, undefined2, n);
        }
        function before(n, func) {
          var result2;
          if (typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          n = toInteger(n);
          return function() {
            if (--n > 0) {
              result2 = func.apply(this, arguments);
            }
            if (n <= 1) {
              func = undefined2;
            }
            return result2;
          };
        }
        var bind = baseRest(function(func, thisArg, partials) {
          var bitmask = WRAP_BIND_FLAG;
          if (partials.length) {
            var holders = replaceHolders(partials, getHolder(bind));
            bitmask |= WRAP_PARTIAL_FLAG;
          }
          return createWrap(func, bitmask, thisArg, partials, holders);
        });
        var bindKey = baseRest(function(object7, key, partials) {
          var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
          if (partials.length) {
            var holders = replaceHolders(partials, getHolder(bindKey));
            bitmask |= WRAP_PARTIAL_FLAG;
          }
          return createWrap(key, bitmask, object7, partials, holders);
        });
        function curry(func, arity, guard) {
          arity = guard ? undefined2 : arity;
          var result2 = createWrap(func, WRAP_CURRY_FLAG, undefined2, undefined2, undefined2, undefined2, undefined2, arity);
          result2.placeholder = curry.placeholder;
          return result2;
        }
        function curryRight(func, arity, guard) {
          arity = guard ? undefined2 : arity;
          var result2 = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined2, undefined2, undefined2, undefined2, undefined2, arity);
          result2.placeholder = curryRight.placeholder;
          return result2;
        }
        function debounce2(func, wait, options) {
          var lastArgs, lastThis, maxWait, result2, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
          if (typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          wait = toNumber(wait) || 0;
          if (isObject(options)) {
            leading = !!options.leading;
            maxing = "maxWait" in options;
            maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
            trailing = "trailing" in options ? !!options.trailing : trailing;
          }
          function invokeFunc(time) {
            var args = lastArgs, thisArg = lastThis;
            lastArgs = lastThis = undefined2;
            lastInvokeTime = time;
            result2 = func.apply(thisArg, args);
            return result2;
          }
          function leadingEdge(time) {
            lastInvokeTime = time;
            timerId = setTimeout2(timerExpired, wait);
            return leading ? invokeFunc(time) : result2;
          }
          function remainingWait(time) {
            var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
            return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
          }
          function shouldInvoke(time) {
            var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
            return lastCallTime === undefined2 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
          }
          function timerExpired() {
            var time = now();
            if (shouldInvoke(time)) {
              return trailingEdge(time);
            }
            timerId = setTimeout2(timerExpired, remainingWait(time));
          }
          function trailingEdge(time) {
            timerId = undefined2;
            if (trailing && lastArgs) {
              return invokeFunc(time);
            }
            lastArgs = lastThis = undefined2;
            return result2;
          }
          function cancel() {
            if (timerId !== undefined2) {
              clearTimeout2(timerId);
            }
            lastInvokeTime = 0;
            lastArgs = lastCallTime = lastThis = timerId = undefined2;
          }
          function flush() {
            return timerId === undefined2 ? result2 : trailingEdge(now());
          }
          function debounced() {
            var time = now(), isInvoking = shouldInvoke(time);
            lastArgs = arguments;
            lastThis = this;
            lastCallTime = time;
            if (isInvoking) {
              if (timerId === undefined2) {
                return leadingEdge(lastCallTime);
              }
              if (maxing) {
                clearTimeout2(timerId);
                timerId = setTimeout2(timerExpired, wait);
                return invokeFunc(lastCallTime);
              }
            }
            if (timerId === undefined2) {
              timerId = setTimeout2(timerExpired, wait);
            }
            return result2;
          }
          debounced.cancel = cancel;
          debounced.flush = flush;
          return debounced;
        }
        var defer = baseRest(function(func, args) {
          return baseDelay(func, 1, args);
        });
        var delay = baseRest(function(func, wait, args) {
          return baseDelay(func, toNumber(wait) || 0, args);
        });
        function flip(func) {
          return createWrap(func, WRAP_FLIP_FLAG);
        }
        function memoize(func, resolver) {
          if (typeof func != "function" || resolver != null && typeof resolver != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          var memoized = function() {
            var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
            if (cache.has(key)) {
              return cache.get(key);
            }
            var result2 = func.apply(this, args);
            memoized.cache = cache.set(key, result2) || cache;
            return result2;
          };
          memoized.cache = new (memoize.Cache || MapCache2)();
          return memoized;
        }
        memoize.Cache = MapCache2;
        function negate(predicate) {
          if (typeof predicate != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          return function() {
            var args = arguments;
            switch (args.length) {
              case 0:
                return !predicate.call(this);
              case 1:
                return !predicate.call(this, args[0]);
              case 2:
                return !predicate.call(this, args[0], args[1]);
              case 3:
                return !predicate.call(this, args[0], args[1], args[2]);
            }
            return !predicate.apply(this, args);
          };
        }
        function once(func) {
          return before(2, func);
        }
        var overArgs = castRest(function(func, transforms) {
          transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
          var funcsLength = transforms.length;
          return baseRest(function(args) {
            var index = -1, length = nativeMin(args.length, funcsLength);
            while (++index < length) {
              args[index] = transforms[index].call(this, args[index]);
            }
            return apply(func, this, args);
          });
        });
        var partial = baseRest(function(func, partials) {
          var holders = replaceHolders(partials, getHolder(partial));
          return createWrap(func, WRAP_PARTIAL_FLAG, undefined2, partials, holders);
        });
        var partialRight = baseRest(function(func, partials) {
          var holders = replaceHolders(partials, getHolder(partialRight));
          return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined2, partials, holders);
        });
        var rearg = flatRest(function(func, indexes) {
          return createWrap(func, WRAP_REARG_FLAG, undefined2, undefined2, undefined2, indexes);
        });
        function rest(func, start) {
          if (typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          start = start === undefined2 ? start : toInteger(start);
          return baseRest(func, start);
        }
        function spread(func, start) {
          if (typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          start = start == null ? 0 : nativeMax(toInteger(start), 0);
          return baseRest(function(args) {
            var array = args[start], otherArgs = castSlice(args, 0, start);
            if (array) {
              arrayPush(otherArgs, array);
            }
            return apply(func, this, otherArgs);
          });
        }
        function throttle(func, wait, options) {
          var leading = true, trailing = true;
          if (typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          if (isObject(options)) {
            leading = "leading" in options ? !!options.leading : leading;
            trailing = "trailing" in options ? !!options.trailing : trailing;
          }
          return debounce2(func, wait, {
            "leading": leading,
            "maxWait": wait,
            "trailing": trailing
          });
        }
        function unary(func) {
          return ary(func, 1);
        }
        function wrap(value, wrapper) {
          return partial(castFunction(wrapper), value);
        }
        function castArray() {
          if (!arguments.length) {
            return [];
          }
          var value = arguments[0];
          return isArray(value) ? value : [value];
        }
        function clone(value) {
          return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        function cloneWith(value, customizer) {
          customizer = typeof customizer == "function" ? customizer : undefined2;
          return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        function cloneDeep(value) {
          return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        function cloneDeepWith(value, customizer) {
          customizer = typeof customizer == "function" ? customizer : undefined2;
          return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        function conformsTo(object7, source) {
          return source == null || baseConformsTo(object7, source, keys(source));
        }
        function eq(value, other) {
          return value === other || value !== value && other !== other;
        }
        var gt = createRelationalOperation(baseGt);
        var gte = createRelationalOperation(function(value, other) {
          return value >= other;
        });
        var isArguments = baseIsArguments(function() {
          return arguments;
        }()) ? baseIsArguments : function(value) {
          return isObjectLike(value) && hasOwnProperty2.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
        };
        var isArray = Array2.isArray;
        var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        function isArrayLike(value) {
          return value != null && isLength(value.length) && !isFunction(value);
        }
        function isArrayLikeObject(value) {
          return isObjectLike(value) && isArrayLike(value);
        }
        function isBoolean(value) {
          return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        var isBuffer = nativeIsBuffer || stubFalse;
        var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        function isElement(value) {
          return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        function isEmpty(value) {
          if (value == null) {
            return true;
          }
          if (isArrayLike(value) && (isArray(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer(value) || isTypedArray(value) || isArguments(value))) {
            return !value.length;
          }
          var tag = getTag(value);
          if (tag == mapTag || tag == setTag) {
            return !value.size;
          }
          if (isPrototype(value)) {
            return !baseKeys(value).length;
          }
          for (var key in value) {
            if (hasOwnProperty2.call(value, key)) {
              return false;
            }
          }
          return true;
        }
        function isEqual(value, other) {
          return baseIsEqual(value, other);
        }
        function isEqualWith(value, other, customizer) {
          customizer = typeof customizer == "function" ? customizer : undefined2;
          var result2 = customizer ? customizer(value, other) : undefined2;
          return result2 === undefined2 ? baseIsEqual(value, other, undefined2, customizer) : !!result2;
        }
        function isError2(value) {
          if (!isObjectLike(value)) {
            return false;
          }
          var tag = baseGetTag(value);
          return tag == errorTag || tag == domExcTag || typeof value.message == "string" && typeof value.name == "string" && !isPlainObject(value);
        }
        function isFinite2(value) {
          return typeof value == "number" && nativeIsFinite(value);
        }
        function isFunction(value) {
          if (!isObject(value)) {
            return false;
          }
          var tag = baseGetTag(value);
          return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        function isInteger(value) {
          return typeof value == "number" && value == toInteger(value);
        }
        function isLength(value) {
          return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        function isObject(value) {
          var type = typeof value;
          return value != null && (type == "object" || type == "function");
        }
        function isObjectLike(value) {
          return value != null && typeof value == "object";
        }
        var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        function isMatch(object7, source) {
          return object7 === source || baseIsMatch(object7, source, getMatchData(source));
        }
        function isMatchWith(object7, source, customizer) {
          customizer = typeof customizer == "function" ? customizer : undefined2;
          return baseIsMatch(object7, source, getMatchData(source), customizer);
        }
        function isNaN2(value) {
          return isNumber(value) && value != +value;
        }
        function isNative(value) {
          if (isMaskable(value)) {
            throw new Error2(CORE_ERROR_TEXT);
          }
          return baseIsNative(value);
        }
        function isNull(value) {
          return value === null;
        }
        function isNil(value) {
          return value == null;
        }
        function isNumber(value) {
          return typeof value == "number" || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        function isPlainObject(value) {
          if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
            return false;
          }
          var proto = getPrototype(value);
          if (proto === null) {
            return true;
          }
          var Ctor = hasOwnProperty2.call(proto, "constructor") && proto.constructor;
          return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        function isSafeInteger(value) {
          return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        function isString(value) {
          return typeof value == "string" || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        function isSymbol(value) {
          return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        function isUndefined(value) {
          return value === undefined2;
        }
        function isWeakMap(value) {
          return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        function isWeakSet(value) {
          return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        var lt = createRelationalOperation(baseLt);
        var lte = createRelationalOperation(function(value, other) {
          return value <= other;
        });
        function toArray(value) {
          if (!value) {
            return [];
          }
          if (isArrayLike(value)) {
            return isString(value) ? stringToArray(value) : copyArray(value);
          }
          if (symIterator && value[symIterator]) {
            return iteratorToArray(value[symIterator]());
          }
          var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
          return func(value);
        }
        function toFinite(value) {
          if (!value) {
            return value === 0 ? value : 0;
          }
          value = toNumber(value);
          if (value === INFINITY || value === -INFINITY) {
            var sign = value < 0 ? -1 : 1;
            return sign * MAX_INTEGER;
          }
          return value === value ? value : 0;
        }
        function toInteger(value) {
          var result2 = toFinite(value), remainder = result2 % 1;
          return result2 === result2 ? remainder ? result2 - remainder : result2 : 0;
        }
        function toLength(value) {
          return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        function toNumber(value) {
          if (typeof value == "number") {
            return value;
          }
          if (isSymbol(value)) {
            return NAN2;
          }
          if (isObject(value)) {
            var other = typeof value.valueOf == "function" ? value.valueOf() : value;
            value = isObject(other) ? other + "" : other;
          }
          if (typeof value != "string") {
            return value === 0 ? value : +value;
          }
          value = baseTrim(value);
          var isBinary = reIsBinary.test(value);
          return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN2 : +value;
        }
        function toPlainObject(value) {
          return copyObject(value, keysIn(value));
        }
        function toSafeInteger(value) {
          return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        function toString(value) {
          return value == null ? "" : baseToString(value);
        }
        var assign = createAssigner(function(object7, source) {
          if (isPrototype(source) || isArrayLike(source)) {
            copyObject(source, keys(source), object7);
            return;
          }
          for (var key in source) {
            if (hasOwnProperty2.call(source, key)) {
              assignValue(object7, key, source[key]);
            }
          }
        });
        var assignIn = createAssigner(function(object7, source) {
          copyObject(source, keysIn(source), object7);
        });
        var assignInWith = createAssigner(function(object7, source, srcIndex, customizer) {
          copyObject(source, keysIn(source), object7, customizer);
        });
        var assignWith = createAssigner(function(object7, source, srcIndex, customizer) {
          copyObject(source, keys(source), object7, customizer);
        });
        var at = flatRest(baseAt);
        function create(prototype, properties) {
          var result2 = baseCreate(prototype);
          return properties == null ? result2 : baseAssign(result2, properties);
        }
        var defaults = baseRest(function(object7, sources) {
          object7 = Object2(object7);
          var index = -1;
          var length = sources.length;
          var guard = length > 2 ? sources[2] : undefined2;
          if (guard && isIterateeCall(sources[0], sources[1], guard)) {
            length = 1;
          }
          while (++index < length) {
            var source = sources[index];
            var props = keysIn(source);
            var propsIndex = -1;
            var propsLength = props.length;
            while (++propsIndex < propsLength) {
              var key = props[propsIndex];
              var value = object7[key];
              if (value === undefined2 || eq(value, objectProto3[key]) && !hasOwnProperty2.call(object7, key)) {
                object7[key] = source[key];
              }
            }
          }
          return object7;
        });
        var defaultsDeep = baseRest(function(args) {
          args.push(undefined2, customDefaultsMerge);
          return apply(mergeWith, undefined2, args);
        });
        function findKey(object7, predicate) {
          return baseFindKey(object7, getIteratee(predicate, 3), baseForOwn);
        }
        function findLastKey(object7, predicate) {
          return baseFindKey(object7, getIteratee(predicate, 3), baseForOwnRight);
        }
        function forIn(object7, iteratee2) {
          return object7 == null ? object7 : baseFor(object7, getIteratee(iteratee2, 3), keysIn);
        }
        function forInRight(object7, iteratee2) {
          return object7 == null ? object7 : baseForRight(object7, getIteratee(iteratee2, 3), keysIn);
        }
        function forOwn(object7, iteratee2) {
          return object7 && baseForOwn(object7, getIteratee(iteratee2, 3));
        }
        function forOwnRight(object7, iteratee2) {
          return object7 && baseForOwnRight(object7, getIteratee(iteratee2, 3));
        }
        function functions(object7) {
          return object7 == null ? [] : baseFunctions(object7, keys(object7));
        }
        function functionsIn(object7) {
          return object7 == null ? [] : baseFunctions(object7, keysIn(object7));
        }
        function get(object7, path, defaultValue) {
          var result2 = object7 == null ? undefined2 : baseGet(object7, path);
          return result2 === undefined2 ? defaultValue : result2;
        }
        function has(object7, path) {
          return object7 != null && hasPath(object7, path, baseHas);
        }
        function hasIn(object7, path) {
          return object7 != null && hasPath(object7, path, baseHasIn);
        }
        var invert = createInverter(function(result2, value, key) {
          if (value != null && typeof value.toString != "function") {
            value = nativeObjectToString3.call(value);
          }
          result2[value] = key;
        }, constant(identity));
        var invertBy = createInverter(function(result2, value, key) {
          if (value != null && typeof value.toString != "function") {
            value = nativeObjectToString3.call(value);
          }
          if (hasOwnProperty2.call(result2, value)) {
            result2[value].push(key);
          } else {
            result2[value] = [key];
          }
        }, getIteratee);
        var invoke = baseRest(baseInvoke);
        function keys(object7) {
          return isArrayLike(object7) ? arrayLikeKeys(object7) : baseKeys(object7);
        }
        function keysIn(object7) {
          return isArrayLike(object7) ? arrayLikeKeys(object7, true) : baseKeysIn(object7);
        }
        function mapKeys(object7, iteratee2) {
          var result2 = {};
          iteratee2 = getIteratee(iteratee2, 3);
          baseForOwn(object7, function(value, key, object8) {
            baseAssignValue(result2, iteratee2(value, key, object8), value);
          });
          return result2;
        }
        function mapValues(object7, iteratee2) {
          var result2 = {};
          iteratee2 = getIteratee(iteratee2, 3);
          baseForOwn(object7, function(value, key, object8) {
            baseAssignValue(result2, key, iteratee2(value, key, object8));
          });
          return result2;
        }
        var merge = createAssigner(function(object7, source, srcIndex) {
          baseMerge(object7, source, srcIndex);
        });
        var mergeWith = createAssigner(function(object7, source, srcIndex, customizer) {
          baseMerge(object7, source, srcIndex, customizer);
        });
        var omit = flatRest(function(object7, paths) {
          var result2 = {};
          if (object7 == null) {
            return result2;
          }
          var isDeep = false;
          paths = arrayMap(paths, function(path) {
            path = castPath(path, object7);
            isDeep || (isDeep = path.length > 1);
            return path;
          });
          copyObject(object7, getAllKeysIn(object7), result2);
          if (isDeep) {
            result2 = baseClone(result2, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
          }
          var length = paths.length;
          while (length--) {
            baseUnset(result2, paths[length]);
          }
          return result2;
        });
        function omitBy(object7, predicate) {
          return pickBy(object7, negate(getIteratee(predicate)));
        }
        var pick = flatRest(function(object7, paths) {
          return object7 == null ? {} : basePick(object7, paths);
        });
        function pickBy(object7, predicate) {
          if (object7 == null) {
            return {};
          }
          var props = arrayMap(getAllKeysIn(object7), function(prop) {
            return [prop];
          });
          predicate = getIteratee(predicate);
          return basePickBy(object7, props, function(value, path) {
            return predicate(value, path[0]);
          });
        }
        function result(object7, path, defaultValue) {
          path = castPath(path, object7);
          var index = -1, length = path.length;
          if (!length) {
            length = 1;
            object7 = undefined2;
          }
          while (++index < length) {
            var value = object7 == null ? undefined2 : object7[toKey(path[index])];
            if (value === undefined2) {
              index = length;
              value = defaultValue;
            }
            object7 = isFunction(value) ? value.call(object7) : value;
          }
          return object7;
        }
        function set(object7, path, value) {
          return object7 == null ? object7 : baseSet(object7, path, value);
        }
        function setWith(object7, path, value, customizer) {
          customizer = typeof customizer == "function" ? customizer : undefined2;
          return object7 == null ? object7 : baseSet(object7, path, value, customizer);
        }
        var toPairs = createToPairs(keys);
        var toPairsIn = createToPairs(keysIn);
        function transform(object7, iteratee2, accumulator) {
          var isArr = isArray(object7), isArrLike = isArr || isBuffer(object7) || isTypedArray(object7);
          iteratee2 = getIteratee(iteratee2, 4);
          if (accumulator == null) {
            var Ctor = object7 && object7.constructor;
            if (isArrLike) {
              accumulator = isArr ? new Ctor() : [];
            } else if (isObject(object7)) {
              accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object7)) : {};
            } else {
              accumulator = {};
            }
          }
          (isArrLike ? arrayEach : baseForOwn)(object7, function(value, index, object8) {
            return iteratee2(accumulator, value, index, object8);
          });
          return accumulator;
        }
        function unset(object7, path) {
          return object7 == null ? true : baseUnset(object7, path);
        }
        function update(object7, path, updater) {
          return object7 == null ? object7 : baseUpdate(object7, path, castFunction(updater));
        }
        function updateWith(object7, path, updater, customizer) {
          customizer = typeof customizer == "function" ? customizer : undefined2;
          return object7 == null ? object7 : baseUpdate(object7, path, castFunction(updater), customizer);
        }
        function values(object7) {
          return object7 == null ? [] : baseValues(object7, keys(object7));
        }
        function valuesIn(object7) {
          return object7 == null ? [] : baseValues(object7, keysIn(object7));
        }
        function clamp(number2, lower, upper) {
          if (upper === undefined2) {
            upper = lower;
            lower = undefined2;
          }
          if (upper !== undefined2) {
            upper = toNumber(upper);
            upper = upper === upper ? upper : 0;
          }
          if (lower !== undefined2) {
            lower = toNumber(lower);
            lower = lower === lower ? lower : 0;
          }
          return baseClamp(toNumber(number2), lower, upper);
        }
        function inRange(number2, start, end) {
          start = toFinite(start);
          if (end === undefined2) {
            end = start;
            start = 0;
          } else {
            end = toFinite(end);
          }
          number2 = toNumber(number2);
          return baseInRange(number2, start, end);
        }
        function random(lower, upper, floating) {
          if (floating && typeof floating != "boolean" && isIterateeCall(lower, upper, floating)) {
            upper = floating = undefined2;
          }
          if (floating === undefined2) {
            if (typeof upper == "boolean") {
              floating = upper;
              upper = undefined2;
            } else if (typeof lower == "boolean") {
              floating = lower;
              lower = undefined2;
            }
          }
          if (lower === undefined2 && upper === undefined2) {
            lower = 0;
            upper = 1;
          } else {
            lower = toFinite(lower);
            if (upper === undefined2) {
              upper = lower;
              lower = 0;
            } else {
              upper = toFinite(upper);
            }
          }
          if (lower > upper) {
            var temp = lower;
            lower = upper;
            upper = temp;
          }
          if (floating || lower % 1 || upper % 1) {
            var rand = nativeRandom();
            return nativeMin(lower + rand * (upper - lower + freeParseFloat("1e-" + ((rand + "").length - 1))), upper);
          }
          return baseRandom(lower, upper);
        }
        var camelCase = createCompounder(function(result2, word, index) {
          word = word.toLowerCase();
          return result2 + (index ? capitalize(word) : word);
        });
        function capitalize(string7) {
          return upperFirst(toString(string7).toLowerCase());
        }
        function deburr(string7) {
          string7 = toString(string7);
          return string7 && string7.replace(reLatin, deburrLetter).replace(reComboMark, "");
        }
        function endsWith(string7, target, position) {
          string7 = toString(string7);
          target = baseToString(target);
          var length = string7.length;
          position = position === undefined2 ? length : baseClamp(toInteger(position), 0, length);
          var end = position;
          position -= target.length;
          return position >= 0 && string7.slice(position, end) == target;
        }
        function escape2(string7) {
          string7 = toString(string7);
          return string7 && reHasUnescapedHtml.test(string7) ? string7.replace(reUnescapedHtml, escapeHtmlChar) : string7;
        }
        function escapeRegExp(string7) {
          string7 = toString(string7);
          return string7 && reHasRegExpChar.test(string7) ? string7.replace(reRegExpChar, "\\$&") : string7;
        }
        var kebabCase = createCompounder(function(result2, word, index) {
          return result2 + (index ? "-" : "") + word.toLowerCase();
        });
        var lowerCase = createCompounder(function(result2, word, index) {
          return result2 + (index ? " " : "") + word.toLowerCase();
        });
        var lowerFirst = createCaseFirst("toLowerCase");
        function pad(string7, length, chars) {
          string7 = toString(string7);
          length = toInteger(length);
          var strLength = length ? stringSize(string7) : 0;
          if (!length || strLength >= length) {
            return string7;
          }
          var mid = (length - strLength) / 2;
          return createPadding(nativeFloor(mid), chars) + string7 + createPadding(nativeCeil(mid), chars);
        }
        function padEnd(string7, length, chars) {
          string7 = toString(string7);
          length = toInteger(length);
          var strLength = length ? stringSize(string7) : 0;
          return length && strLength < length ? string7 + createPadding(length - strLength, chars) : string7;
        }
        function padStart(string7, length, chars) {
          string7 = toString(string7);
          length = toInteger(length);
          var strLength = length ? stringSize(string7) : 0;
          return length && strLength < length ? createPadding(length - strLength, chars) + string7 : string7;
        }
        function parseInt2(string7, radix, guard) {
          if (guard || radix == null) {
            radix = 0;
          } else if (radix) {
            radix = +radix;
          }
          return nativeParseInt(toString(string7).replace(reTrimStart, ""), radix || 0);
        }
        function repeat(string7, n, guard) {
          if (guard ? isIterateeCall(string7, n, guard) : n === undefined2) {
            n = 1;
          } else {
            n = toInteger(n);
          }
          return baseRepeat(toString(string7), n);
        }
        function replace() {
          var args = arguments, string7 = toString(args[0]);
          return args.length < 3 ? string7 : string7.replace(args[1], args[2]);
        }
        var snakeCase = createCompounder(function(result2, word, index) {
          return result2 + (index ? "_" : "") + word.toLowerCase();
        });
        function split(string7, separator, limit) {
          if (limit && typeof limit != "number" && isIterateeCall(string7, separator, limit)) {
            separator = limit = undefined2;
          }
          limit = limit === undefined2 ? MAX_ARRAY_LENGTH : limit >>> 0;
          if (!limit) {
            return [];
          }
          string7 = toString(string7);
          if (string7 && (typeof separator == "string" || separator != null && !isRegExp(separator))) {
            separator = baseToString(separator);
            if (!separator && hasUnicode(string7)) {
              return castSlice(stringToArray(string7), 0, limit);
            }
          }
          return string7.split(separator, limit);
        }
        var startCase = createCompounder(function(result2, word, index) {
          return result2 + (index ? " " : "") + upperFirst(word);
        });
        function startsWith(string7, target, position) {
          string7 = toString(string7);
          position = position == null ? 0 : baseClamp(toInteger(position), 0, string7.length);
          target = baseToString(target);
          return string7.slice(position, position + target.length) == target;
        }
        function template(string7, options, guard) {
          var settings = lodash.templateSettings;
          if (guard && isIterateeCall(string7, options, guard)) {
            options = undefined2;
          }
          string7 = toString(string7);
          options = assignInWith({}, options, settings, customDefaultsAssignIn);
          var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
          var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
          var reDelimiters = RegExp2(
            (options.escape || reNoMatch).source + "|" + interpolate.source + "|" + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + "|" + (options.evaluate || reNoMatch).source + "|$",
            "g"
          );
          var sourceURL = "//# sourceURL=" + (hasOwnProperty2.call(options, "sourceURL") ? (options.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++templateCounter + "]") + "\n";
          string7.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
            interpolateValue || (interpolateValue = esTemplateValue);
            source += string7.slice(index, offset).replace(reUnescapedString, escapeStringChar);
            if (escapeValue) {
              isEscaping = true;
              source += "' +\n__e(" + escapeValue + ") +\n'";
            }
            if (evaluateValue) {
              isEvaluating = true;
              source += "';\n" + evaluateValue + ";\n__p += '";
            }
            if (interpolateValue) {
              source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
            }
            index = offset + match.length;
            return match;
          });
          source += "';\n";
          var variable = hasOwnProperty2.call(options, "variable") && options.variable;
          if (!variable) {
            source = "with (obj) {\n" + source + "\n}\n";
          } else if (reForbiddenIdentifierChars.test(variable)) {
            throw new Error2(INVALID_TEMPL_VAR_ERROR_TEXT);
          }
          source = (isEvaluating ? source.replace(reEmptyStringLeading, "") : source).replace(reEmptyStringMiddle, "$1").replace(reEmptyStringTrailing, "$1;");
          source = "function(" + (variable || "obj") + ") {\n" + (variable ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (isEscaping ? ", __e = _.escape" : "") + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + source + "return __p\n}";
          var result2 = attempt(function() {
            return Function2(importsKeys, sourceURL + "return " + source).apply(undefined2, importsValues);
          });
          result2.source = source;
          if (isError2(result2)) {
            throw result2;
          }
          return result2;
        }
        function toLower(value) {
          return toString(value).toLowerCase();
        }
        function toUpper(value) {
          return toString(value).toUpperCase();
        }
        function trim(string7, chars, guard) {
          string7 = toString(string7);
          if (string7 && (guard || chars === undefined2)) {
            return baseTrim(string7);
          }
          if (!string7 || !(chars = baseToString(chars))) {
            return string7;
          }
          var strSymbols = stringToArray(string7), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
          return castSlice(strSymbols, start, end).join("");
        }
        function trimEnd(string7, chars, guard) {
          string7 = toString(string7);
          if (string7 && (guard || chars === undefined2)) {
            return string7.slice(0, trimmedEndIndex(string7) + 1);
          }
          if (!string7 || !(chars = baseToString(chars))) {
            return string7;
          }
          var strSymbols = stringToArray(string7), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
          return castSlice(strSymbols, 0, end).join("");
        }
        function trimStart(string7, chars, guard) {
          string7 = toString(string7);
          if (string7 && (guard || chars === undefined2)) {
            return string7.replace(reTrimStart, "");
          }
          if (!string7 || !(chars = baseToString(chars))) {
            return string7;
          }
          var strSymbols = stringToArray(string7), start = charsStartIndex(strSymbols, stringToArray(chars));
          return castSlice(strSymbols, start).join("");
        }
        function truncate(string7, options) {
          var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
          if (isObject(options)) {
            var separator = "separator" in options ? options.separator : separator;
            length = "length" in options ? toInteger(options.length) : length;
            omission = "omission" in options ? baseToString(options.omission) : omission;
          }
          string7 = toString(string7);
          var strLength = string7.length;
          if (hasUnicode(string7)) {
            var strSymbols = stringToArray(string7);
            strLength = strSymbols.length;
          }
          if (length >= strLength) {
            return string7;
          }
          var end = length - stringSize(omission);
          if (end < 1) {
            return omission;
          }
          var result2 = strSymbols ? castSlice(strSymbols, 0, end).join("") : string7.slice(0, end);
          if (separator === undefined2) {
            return result2 + omission;
          }
          if (strSymbols) {
            end += result2.length - end;
          }
          if (isRegExp(separator)) {
            if (string7.slice(end).search(separator)) {
              var match, substring = result2;
              if (!separator.global) {
                separator = RegExp2(separator.source, toString(reFlags.exec(separator)) + "g");
              }
              separator.lastIndex = 0;
              while (match = separator.exec(substring)) {
                var newEnd = match.index;
              }
              result2 = result2.slice(0, newEnd === undefined2 ? end : newEnd);
            }
          } else if (string7.indexOf(baseToString(separator), end) != end) {
            var index = result2.lastIndexOf(separator);
            if (index > -1) {
              result2 = result2.slice(0, index);
            }
          }
          return result2 + omission;
        }
        function unescape2(string7) {
          string7 = toString(string7);
          return string7 && reHasEscapedHtml.test(string7) ? string7.replace(reEscapedHtml, unescapeHtmlChar) : string7;
        }
        var upperCase = createCompounder(function(result2, word, index) {
          return result2 + (index ? " " : "") + word.toUpperCase();
        });
        var upperFirst = createCaseFirst("toUpperCase");
        function words(string7, pattern, guard) {
          string7 = toString(string7);
          pattern = guard ? undefined2 : pattern;
          if (pattern === undefined2) {
            return hasUnicodeWord(string7) ? unicodeWords(string7) : asciiWords(string7);
          }
          return string7.match(pattern) || [];
        }
        var attempt = baseRest(function(func, args) {
          try {
            return apply(func, undefined2, args);
          } catch (e) {
            return isError2(e) ? e : new Error2(e);
          }
        });
        var bindAll = flatRest(function(object7, methodNames) {
          arrayEach(methodNames, function(key) {
            key = toKey(key);
            baseAssignValue(object7, key, bind(object7[key], object7));
          });
          return object7;
        });
        function cond(pairs) {
          var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
          pairs = !length ? [] : arrayMap(pairs, function(pair) {
            if (typeof pair[1] != "function") {
              throw new TypeError2(FUNC_ERROR_TEXT);
            }
            return [toIteratee(pair[0]), pair[1]];
          });
          return baseRest(function(args) {
            var index = -1;
            while (++index < length) {
              var pair = pairs[index];
              if (apply(pair[0], this, args)) {
                return apply(pair[1], this, args);
              }
            }
          });
        }
        function conforms(source) {
          return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        function constant(value) {
          return function() {
            return value;
          };
        }
        function defaultTo(value, defaultValue) {
          return value == null || value !== value ? defaultValue : value;
        }
        var flow = createFlow();
        var flowRight = createFlow(true);
        function identity(value) {
          return value;
        }
        function iteratee(func) {
          return baseIteratee(typeof func == "function" ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        function matches(source) {
          return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        function matchesProperty(path, srcValue) {
          return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        var method = baseRest(function(path, args) {
          return function(object7) {
            return baseInvoke(object7, path, args);
          };
        });
        var methodOf = baseRest(function(object7, args) {
          return function(path) {
            return baseInvoke(object7, path, args);
          };
        });
        function mixin(object7, source, options) {
          var props = keys(source), methodNames = baseFunctions(source, props);
          if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
            options = source;
            source = object7;
            object7 = this;
            methodNames = baseFunctions(source, keys(source));
          }
          var chain2 = !(isObject(options) && "chain" in options) || !!options.chain, isFunc = isFunction(object7);
          arrayEach(methodNames, function(methodName) {
            var func = source[methodName];
            object7[methodName] = func;
            if (isFunc) {
              object7.prototype[methodName] = function() {
                var chainAll = this.__chain__;
                if (chain2 || chainAll) {
                  var result2 = object7(this.__wrapped__), actions = result2.__actions__ = copyArray(this.__actions__);
                  actions.push({ "func": func, "args": arguments, "thisArg": object7 });
                  result2.__chain__ = chainAll;
                  return result2;
                }
                return func.apply(object7, arrayPush([this.value()], arguments));
              };
            }
          });
          return object7;
        }
        function noConflict() {
          if (root2._ === this) {
            root2._ = oldDash;
          }
          return this;
        }
        function noop2() {
        }
        function nthArg(n) {
          n = toInteger(n);
          return baseRest(function(args) {
            return baseNth(args, n);
          });
        }
        var over = createOver(arrayMap);
        var overEvery = createOver(arrayEvery);
        var overSome = createOver(arraySome);
        function property(path) {
          return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        function propertyOf(object7) {
          return function(path) {
            return object7 == null ? undefined2 : baseGet(object7, path);
          };
        }
        var range = createRange();
        var rangeRight = createRange(true);
        function stubArray() {
          return [];
        }
        function stubFalse() {
          return false;
        }
        function stubObject() {
          return {};
        }
        function stubString() {
          return "";
        }
        function stubTrue() {
          return true;
        }
        function times(n, iteratee2) {
          n = toInteger(n);
          if (n < 1 || n > MAX_SAFE_INTEGER) {
            return [];
          }
          var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
          iteratee2 = getIteratee(iteratee2);
          n -= MAX_ARRAY_LENGTH;
          var result2 = baseTimes(length, iteratee2);
          while (++index < n) {
            iteratee2(index);
          }
          return result2;
        }
        function toPath(value) {
          if (isArray(value)) {
            return arrayMap(value, toKey);
          }
          return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
        }
        function uniqueId(prefix) {
          var id = ++idCounter;
          return toString(prefix) + id;
        }
        var add = createMathOperation(function(augend, addend) {
          return augend + addend;
        }, 0);
        var ceil = createRound("ceil");
        var divide = createMathOperation(function(dividend, divisor) {
          return dividend / divisor;
        }, 1);
        var floor = createRound("floor");
        function max(array) {
          return array && array.length ? baseExtremum(array, identity, baseGt) : undefined2;
        }
        function maxBy(array, iteratee2) {
          return array && array.length ? baseExtremum(array, getIteratee(iteratee2, 2), baseGt) : undefined2;
        }
        function mean(array) {
          return baseMean(array, identity);
        }
        function meanBy(array, iteratee2) {
          return baseMean(array, getIteratee(iteratee2, 2));
        }
        function min(array) {
          return array && array.length ? baseExtremum(array, identity, baseLt) : undefined2;
        }
        function minBy(array, iteratee2) {
          return array && array.length ? baseExtremum(array, getIteratee(iteratee2, 2), baseLt) : undefined2;
        }
        var multiply = createMathOperation(function(multiplier, multiplicand) {
          return multiplier * multiplicand;
        }, 1);
        var round = createRound("round");
        var subtract = createMathOperation(function(minuend, subtrahend) {
          return minuend - subtrahend;
        }, 0);
        function sum(array) {
          return array && array.length ? baseSum(array, identity) : 0;
        }
        function sumBy(array, iteratee2) {
          return array && array.length ? baseSum(array, getIteratee(iteratee2, 2)) : 0;
        }
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce2;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject2;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        mixin(lodash, lodash);
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape2;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError2;
        lodash.isFinite = isFinite2;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN2;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop2;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt2;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext2;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape2;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
          var source = {};
          baseForOwn(lodash, function(func, methodName) {
            if (!hasOwnProperty2.call(lodash.prototype, methodName)) {
              source[methodName] = func;
            }
          });
          return source;
        }(), { "chain": false });
        lodash.VERSION = VERSION;
        arrayEach(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(methodName) {
          lodash[methodName].placeholder = lodash;
        });
        arrayEach(["drop", "take"], function(methodName, index) {
          LazyWrapper.prototype[methodName] = function(n) {
            n = n === undefined2 ? 1 : nativeMax(toInteger(n), 0);
            var result2 = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
            if (result2.__filtered__) {
              result2.__takeCount__ = nativeMin(n, result2.__takeCount__);
            } else {
              result2.__views__.push({
                "size": nativeMin(n, MAX_ARRAY_LENGTH),
                "type": methodName + (result2.__dir__ < 0 ? "Right" : "")
              });
            }
            return result2;
          };
          LazyWrapper.prototype[methodName + "Right"] = function(n) {
            return this.reverse()[methodName](n).reverse();
          };
        });
        arrayEach(["filter", "map", "takeWhile"], function(methodName, index) {
          var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
          LazyWrapper.prototype[methodName] = function(iteratee2) {
            var result2 = this.clone();
            result2.__iteratees__.push({
              "iteratee": getIteratee(iteratee2, 3),
              "type": type
            });
            result2.__filtered__ = result2.__filtered__ || isFilter;
            return result2;
          };
        });
        arrayEach(["head", "last"], function(methodName, index) {
          var takeName = "take" + (index ? "Right" : "");
          LazyWrapper.prototype[methodName] = function() {
            return this[takeName](1).value()[0];
          };
        });
        arrayEach(["initial", "tail"], function(methodName, index) {
          var dropName = "drop" + (index ? "" : "Right");
          LazyWrapper.prototype[methodName] = function() {
            return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
          };
        });
        LazyWrapper.prototype.compact = function() {
          return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
          return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
          return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
          if (typeof path == "function") {
            return new LazyWrapper(this);
          }
          return this.map(function(value) {
            return baseInvoke(value, path, args);
          });
        });
        LazyWrapper.prototype.reject = function(predicate) {
          return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
          start = toInteger(start);
          var result2 = this;
          if (result2.__filtered__ && (start > 0 || end < 0)) {
            return new LazyWrapper(result2);
          }
          if (start < 0) {
            result2 = result2.takeRight(-start);
          } else if (start) {
            result2 = result2.drop(start);
          }
          if (end !== undefined2) {
            end = toInteger(end);
            result2 = end < 0 ? result2.dropRight(-end) : result2.take(end - start);
          }
          return result2;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
          return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
          return this.take(MAX_ARRAY_LENGTH);
        };
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
          var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? "take" + (methodName == "last" ? "Right" : "") : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
          if (!lodashFunc) {
            return;
          }
          lodash.prototype[methodName] = function() {
            var value = this.__wrapped__, args = isTaker ? [1] : arguments, isLazy = value instanceof LazyWrapper, iteratee2 = args[0], useLazy = isLazy || isArray(value);
            var interceptor = function(value2) {
              var result3 = lodashFunc.apply(lodash, arrayPush([value2], args));
              return isTaker && chainAll ? result3[0] : result3;
            };
            if (useLazy && checkIteratee && typeof iteratee2 == "function" && iteratee2.length != 1) {
              isLazy = useLazy = false;
            }
            var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
            if (!retUnwrapped && useLazy) {
              value = onlyLazy ? value : new LazyWrapper(this);
              var result2 = func.apply(value, args);
              result2.__actions__.push({ "func": thru, "args": [interceptor], "thisArg": undefined2 });
              return new LodashWrapper(result2, chainAll);
            }
            if (isUnwrapped && onlyLazy) {
              return func.apply(this, args);
            }
            result2 = this.thru(interceptor);
            return isUnwrapped ? isTaker ? result2.value()[0] : result2.value() : result2;
          };
        });
        arrayEach(["pop", "push", "shift", "sort", "splice", "unshift"], function(methodName) {
          var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? "tap" : "thru", retUnwrapped = /^(?:pop|shift)$/.test(methodName);
          lodash.prototype[methodName] = function() {
            var args = arguments;
            if (retUnwrapped && !this.__chain__) {
              var value = this.value();
              return func.apply(isArray(value) ? value : [], args);
            }
            return this[chainName](function(value2) {
              return func.apply(isArray(value2) ? value2 : [], args);
            });
          };
        });
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
          var lodashFunc = lodash[methodName];
          if (lodashFunc) {
            var key = lodashFunc.name + "";
            if (!hasOwnProperty2.call(realNames, key)) {
              realNames[key] = [];
            }
            realNames[key].push({ "name": methodName, "func": lodashFunc });
          }
        });
        realNames[createHybrid(undefined2, WRAP_BIND_KEY_FLAG).name] = [{
          "name": "wrapper",
          "func": undefined2
        }];
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) {
          lodash.prototype[symIterator] = wrapperToIterator;
        }
        return lodash;
      };
      var _ = runInContext();
      if (typeof define == "function" && typeof define.amd == "object" && define.amd) {
        root2._ = _;
        define(function() {
          return _;
        });
      } else if (freeModule) {
        (freeModule.exports = _)._ = _;
        freeExports._ = _;
      } else {
        root2._ = _;
      }
    }).call(exports);
  }
});

// src/components/account/components/__generated__/CandidateAccountChecklist_data.graphql.ts
var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CandidateAccountChecklist_data",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasAgreedToTerms",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isGdprConsented",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isEmailVerified",
      "storageKey": null
    }
  ],
  "type": "AccountsCandidateAccount",
  "abstractKey": null
};
node.hash = "1dc0276ceff41396fb648ab82071de22";
var CandidateAccountChecklist_data_graphql_default = node;

// src/components/account/components/CandidateAccountChecklist.tsx
import { useState, useMemo } from "react";
import { useFragment } from "react-relay";
import { useMachine } from "@xstate/react";
import { createMachine, State } from "xstate";
import { Link } from "react-router-dom";
import { Button, CheckBox, Input } from "shared-ui";
import { getPlatformLinks } from "shared-lib";
import { jsx, jsxs } from "react/jsx-runtime";
var machine = createMachine({
  id: "candidateAccountChecklist",
  initial: "account",
  states: {
    account: {
      id: "account",
      on: {
        VIEW: { target: "account" }
      }
    },
    terms: {
      id: "terms",
      on: {
        VIEW: { target: "account" }
      }
    },
    gdpr: {
      id: "gdpr",
      on: {
        VIEW: { target: "account" }
      }
    },
    email: {
      id: "email",
      on: {
        VIEW: { target: "#account" }
      }
    }
  }
});
function getStateFromStatus(data) {
  if (!data.hasAgreedToTerms) {
    return "terms";
  }
  if (!data.isGdprConsented) {
    return "gdpr";
  }
  if (!data.isEmailVerified) {
    return "email";
  }
  return "account";
}
var fragmentDef = CandidateAccountChecklist_data_graphql_default;
var CandidateAccountChecklist = ({ fragmentRef }) => {
  const [showEmailVerificationBox, setShowEmailVerificationBox] = useState(false);
  const data = useFragment(
    fragmentDef,
    fragmentRef
  );
  const initialState = useMemo(() => {
    return machine.resolveState(
      State.from(getStateFromStatus(data) ?? machine.initialState)
    );
  }, [data]);
  const [state, send] = useMachine(machine, {
    state: initialState
  });
  const platformLinks = getPlatformLinks();
  return /* @__PURE__ */ jsx("div", { className: "container mx-auto", children: /* @__PURE__ */ jsxs("div", { className: "bg-white px-6 py-4 pb-10 pt-5 shadow", children: [
    /* @__PURE__ */ jsx("h1", { className: "text-2xl", children: "Account Verification" }),
    /* @__PURE__ */ jsx("h2", { className: "pt-5 text-xl", children: "Todo:" }),
    /* @__PURE__ */ jsxs("div", { className: "flex flex-col gap-1 pt-3 lg:w-1/3", children: [
      /* @__PURE__ */ jsx(
        CheckBox,
        {
          checked: !!data.hasAgreedToTerms,
          title: /* @__PURE__ */ jsxs("span", { children: [
            "I accept the",
            " ",
            /* @__PURE__ */ jsx(
              Link,
              {
                to: platformLinks.termsAndConditions,
                target: `_blank`,
                className: `underline`,
                children: "Terms and Conditions"
              }
            )
          ] }),
          readonly: true
        }
      ),
      /* @__PURE__ */ jsx(
        CheckBox,
        {
          checked: !!data.isGdprConsented,
          title: /* @__PURE__ */ jsxs("span", { children: [
            "I accept the",
            " ",
            /* @__PURE__ */ jsx(
              Link,
              {
                to: platformLinks.privacyPolicy,
                target: `_blank`,
                className: `underline`,
                children: "Privacy Policy"
              }
            )
          ] }),
          readonly: true
        }
      ),
      /* @__PURE__ */ jsxs("div", { children: [
        /* @__PURE__ */ jsx(
          CheckBox,
          {
            checked: !!data.isEmailVerified,
            title: "Email Verification Code",
            readonly: true
          }
        ),
        /* @__PURE__ */ jsxs(
          "div",
          {
            className: "text-info-500 cursor-pointer text-xs",
            onClick: () => setShowEmailVerificationBox(!showEmailVerificationBox),
            children: [
              showEmailVerificationBox ? "Hide verify" : "Verify",
              " with email code"
            ]
          }
        )
      ] }),
      showEmailVerificationBox && /* @__PURE__ */ jsxs("div", { className: "mt-5 flex flex-col gap-3 rounded border border-solid p-4", children: [
        /* @__PURE__ */ jsx(Input, { label: "Email Verification Code" }),
        /* @__PURE__ */ jsx("div", { className: "", children: /* @__PURE__ */ jsx(Button, { color: "primary", children: "Verify" }) })
      ] })
    ] })
  ] }) });
};

// src/components/account/components/__generated__/CandidateAccountEmailEditor_account.graphql.ts
var node2 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CandidateAccountEmailEditor_account",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isEmailVerified",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedAt",
      "storageKey": null
    }
  ],
  "type": "AccountsCandidateAccount",
  "abstractKey": null
};
node2.hash = "8fc1fba4eaea27ca9858878d11326d46";
var CandidateAccountEmailEditor_account_graphql_default = node2;

// src/components/account/components/CandidateAccountEmailEditor.tsx
import { useCallback as useCallback3 } from "react";
import { useFragment as useFragment2 } from "react-relay";
import { z as zod } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { createClientMutationId as createClientMutationId3, useUserErrorCode } from "shared-lib";
import {
  AlertMessage,
  FormInputRow,
  FormInput,
  ErrorField,
  ActionContainer
} from "shared-ui";

// src/mutations/__generated__/SendEmailVerificationMutation.graphql.ts
var node3 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "__typename",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfCandidateAccount",
    "kind": "LinkedField",
    "name": "candidateAccount",
    "plural": false,
    "selections": [
      v2,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cursor",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountsCandidateAccount",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isEmailVerified",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "message",
    "storageKey": null
  }, v5 = {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      v4,
      {
        "alias": null,
        "args": null,
        "concreteType": "ValidationItem",
        "kind": "LinkedField",
        "name": "validations",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          v4
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "data",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "SendEmailVerificationMutation",
      "selections": [
        {
          "alias": null,
          "args": v1,
          "concreteType": "AccountsCandidateAccountSendEmailVerificationPayload",
          "kind": "LinkedField",
          "name": "accountsCandidateAccountSendEmailVerification",
          "plural": false,
          "selections": [
            v3,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v5
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "SendEmailVerificationMutation",
      "selections": [
        {
          "alias": null,
          "args": v1,
          "concreteType": "AccountsCandidateAccountSendEmailVerificationPayload",
          "kind": "LinkedField",
          "name": "accountsCandidateAccountSendEmailVerification",
          "plural": false,
          "selections": [
            v3,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v2,
                v5
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "c89b82b061e7444ffdbaf0b0149d6483",
      "id": null,
      "metadata": {},
      "name": "SendEmailVerificationMutation",
      "operationKind": "mutation",
      "text": "mutation SendEmailVerificationMutation(\n  $input: AccountsCandidateAccountSendEmailVerificationInput!\n) {\n  accountsCandidateAccountSendEmailVerification(input: $input) {\n    candidateAccount {\n      __typename\n      cursor\n      node {\n        id\n        updatedAt\n        isEmailVerified\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n        validations {\n          name\n          message\n        }\n        data\n      }\n    }\n  }\n}\n"
    }
  };
}();
node3.hash = "4489f32270279f7da538a27abea4d6cb";
var SendEmailVerificationMutation_graphql_default = node3;

// src/mutations/SendEmailVerification.ts
import { useCallback } from "react";
import { useMutation } from "react-relay";
import { createClientMutationId } from "shared-lib";
var mutationDef = SendEmailVerificationMutation_graphql_default;
var useSendEmailVerificationCode = (candidateId, onDone, onUserError, onError) => {
  const [commitMutation, isMutationInFlight] = useMutation(mutationDef);
  const invokeMutation = useCallback(() => {
    const clientMutationId = createClientMutationId();
    commitMutation({
      variables: {
        input: { clientMutationId, candidateId }
      },
      onError: (e) => {
        if (onError) {
          onError(e);
        }
      },
      onCompleted: (response) => {
        if (response.accountsCandidateAccountSendEmailVerification.candidateAccount?.node) {
          if (onDone) {
            onDone();
          }
        }
        if (response.accountsCandidateAccountSendEmailVerification.userErrors && response.accountsCandidateAccountSendEmailVerification.userErrors.length > 0) {
          const userError = response.accountsCandidateAccountSendEmailVerification.userErrors[0];
          if (userError.code) {
            if (onUserError) {
              onUserError(userError.code);
            }
          }
        }
      }
    });
  }, [commitMutation]);
  return [invokeMutation, isMutationInFlight];
};

// src/mutations/__generated__/UseCandidateChangeEmailMutation.graphql.ts
var node4 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfCandidateAccount",
    "kind": "LinkedField",
    "name": "candidateAccount",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountsCandidateAccount",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "accountId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v3 = {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseCandidateChangeEmailMutation",
      "selections": [
        {
          "alias": "task",
          "args": v1,
          "concreteType": "AccountsCandidateAccountChangeEmailPayload",
          "kind": "LinkedField",
          "name": "accountsCandidateAccountChangeEmail",
          "plural": false,
          "selections": [
            v2,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v3
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseCandidateChangeEmailMutation",
      "selections": [
        {
          "alias": "task",
          "args": v1,
          "concreteType": "AccountsCandidateAccountChangeEmailPayload",
          "kind": "LinkedField",
          "name": "accountsCandidateAccountChangeEmail",
          "plural": false,
          "selections": [
            v2,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v3
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "e88a163b46d325e175768e53cc1984bb",
      "id": null,
      "metadata": {},
      "name": "UseCandidateChangeEmailMutation",
      "operationKind": "mutation",
      "text": "mutation UseCandidateChangeEmailMutation(\n  $input: AccountsCandidateAccountChangeEmailInput!\n) {\n  task: accountsCandidateAccountChangeEmail(input: $input) {\n    candidateAccount {\n      node {\n        id\n        accountId\n        email\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node4.hash = "08588f7e3d45d174a3cab80610758525";
var UseCandidateChangeEmailMutation_graphql_default = node4;

// src/mutations/UseCandidateChangeEmail.ts
import { useAsyncMutation } from "shared-lib";
var mutationDef2 = UseCandidateChangeEmailMutation_graphql_default;
function useCandidateChangeEmail() {
  const [commit, isBusy] = useAsyncMutation(mutationDef2);
  return [commit, isBusy];
}

// src/mutations/__generated__/UseCandidateChangeNameMutation.graphql.ts
var node5 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfCandidateAccount",
    "kind": "LinkedField",
    "name": "candidateAccount",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountsCandidateAccount",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "accountId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v3 = {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseCandidateChangeNameMutation",
      "selections": [
        {
          "alias": "task",
          "args": v1,
          "concreteType": "AccountsCandidateAccountChangeNamePayload",
          "kind": "LinkedField",
          "name": "accountsCandidateAccountChangeName",
          "plural": false,
          "selections": [
            v2,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v3
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseCandidateChangeNameMutation",
      "selections": [
        {
          "alias": "task",
          "args": v1,
          "concreteType": "AccountsCandidateAccountChangeNamePayload",
          "kind": "LinkedField",
          "name": "accountsCandidateAccountChangeName",
          "plural": false,
          "selections": [
            v2,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v3
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "f530094739ec0997209ff15d3d18b3d6",
      "id": null,
      "metadata": {},
      "name": "UseCandidateChangeNameMutation",
      "operationKind": "mutation",
      "text": "mutation UseCandidateChangeNameMutation(\n  $input: AccountsCandidateAccountChangeNameInput!\n) {\n  task: accountsCandidateAccountChangeName(input: $input) {\n    candidateAccount {\n      node {\n        id\n        accountId\n        firstName\n        lastName\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node5.hash = "3466fdeb2b7688d0735e500916432bf9";
var UseCandidateChangeNameMutation_graphql_default = node5;

// src/mutations/UseCandidateChangeName.ts
import { useAsyncMutation as useAsyncMutation2 } from "shared-lib";
var mutationDef3 = UseCandidateChangeNameMutation_graphql_default;
function useCandidateChangeName() {
  const [commit, isBusy] = useAsyncMutation2(mutationDef3);
  return [commit, isBusy];
}

// src/mutations/__generated__/UseCandidateChangePhoneNumberMutation.graphql.ts
var node6 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfCandidateAccount",
    "kind": "LinkedField",
    "name": "candidateAccount",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountsCandidateAccount",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CandidatePhoneVerification",
            "kind": "LinkedField",
            "name": "phone",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "phoneNumber",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "phoneCountryCode",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "phoneCountryPrefix",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "phoneVerificationStatus",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v3 = {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseCandidateChangePhoneNumberMutation",
      "selections": [
        {
          "alias": "task",
          "args": v1,
          "concreteType": "AccountsCandidateAccountChangePhoneNumberPayload",
          "kind": "LinkedField",
          "name": "accountsCandidateAccountChangePhoneNumber",
          "plural": false,
          "selections": [
            v2,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v3
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseCandidateChangePhoneNumberMutation",
      "selections": [
        {
          "alias": "task",
          "args": v1,
          "concreteType": "AccountsCandidateAccountChangePhoneNumberPayload",
          "kind": "LinkedField",
          "name": "accountsCandidateAccountChangePhoneNumber",
          "plural": false,
          "selections": [
            v2,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v3
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "ff9fb9f31847a9f6ef090cdbcd78e5a8",
      "id": null,
      "metadata": {},
      "name": "UseCandidateChangePhoneNumberMutation",
      "operationKind": "mutation",
      "text": "mutation UseCandidateChangePhoneNumberMutation(\n  $input: AccountsCandidateAccountChangePhoneNumberInput!\n) {\n  task: accountsCandidateAccountChangePhoneNumber(input: $input) {\n    candidateAccount {\n      node {\n        id\n        firstName\n        lastName\n        email\n        phone {\n          phoneNumber\n          phoneCountryCode\n          phoneCountryPrefix\n          phoneVerificationStatus\n        }\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node6.hash = "4bb9c4b84bb9b9a0f0c979372482b627";
var UseCandidateChangePhoneNumberMutation_graphql_default = node6;

// src/mutations/UseCandidateChangePhoneNumber.ts
import { useAsyncMutation as useAsyncMutation3 } from "shared-lib";
var mutationDef4 = UseCandidateChangePhoneNumberMutation_graphql_default;
function useCandidateChangePhoneNumber() {
  const [commit, isBusy] = useAsyncMutation3(mutationDef4);
  return [commit, isBusy];
}

// src/mutations/__generated__/UseCandidatePhoneResendCodeMutation.graphql.ts
var node7 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfCandidateAccount",
    "kind": "LinkedField",
    "name": "candidateAccount",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountsCandidateAccount",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CandidatePhoneVerification",
            "kind": "LinkedField",
            "name": "phone",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "phoneNumber",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "phoneCountryCode",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "phoneCountryPrefix",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "phoneVerificationStatus",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v3 = {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseCandidatePhoneResendCodeMutation",
      "selections": [
        {
          "alias": "task",
          "args": v1,
          "concreteType": "AccountsCandidateAccountResendPhoneVerificationCodePayload",
          "kind": "LinkedField",
          "name": "accountsCandidateAccountResendPhoneVerificationCode",
          "plural": false,
          "selections": [
            v2,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v3
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseCandidatePhoneResendCodeMutation",
      "selections": [
        {
          "alias": "task",
          "args": v1,
          "concreteType": "AccountsCandidateAccountResendPhoneVerificationCodePayload",
          "kind": "LinkedField",
          "name": "accountsCandidateAccountResendPhoneVerificationCode",
          "plural": false,
          "selections": [
            v2,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v3
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "f1e07fa55cdc06ed82231a20043a2b85",
      "id": null,
      "metadata": {},
      "name": "UseCandidatePhoneResendCodeMutation",
      "operationKind": "mutation",
      "text": "mutation UseCandidatePhoneResendCodeMutation(\n  $input: AccountsCandidateAccountResendPhoneVerificationCodeInput!\n) {\n  task: accountsCandidateAccountResendPhoneVerificationCode(input: $input) {\n    candidateAccount {\n      node {\n        id\n        firstName\n        lastName\n        email\n        phone {\n          phoneNumber\n          phoneCountryCode\n          phoneCountryPrefix\n          phoneVerificationStatus\n        }\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node7.hash = "55b8c8d6cf1f41d347d832ef566a3cc8";
var UseCandidatePhoneResendCodeMutation_graphql_default = node7;

// src/mutations/UseCandidatePhoneResendCode.ts
import { useAsyncMutation as useAsyncMutation4 } from "shared-lib";
var mutationDef5 = UseCandidatePhoneResendCodeMutation_graphql_default;
function useCandidateResendPhoneVerificationCode() {
  const [commit, isBusy] = useAsyncMutation4(mutationDef5);
  return [commit, isBusy];
}

// src/mutations/__generated__/UseCandidatePhoneSendVerificationMutation.graphql.ts
var node8 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfCandidateAccount",
    "kind": "LinkedField",
    "name": "candidateAccount",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountsCandidateAccount",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CandidatePhoneVerification",
            "kind": "LinkedField",
            "name": "phone",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "phoneNumber",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "phoneCountryCode",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "phoneCountryPrefix",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "phoneVerificationStatus",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v3 = {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseCandidatePhoneSendVerificationMutation",
      "selections": [
        {
          "alias": "task",
          "args": v1,
          "concreteType": "AccountsCandidateAccountResendPhoneVerificationCodePayload",
          "kind": "LinkedField",
          "name": "accountsCandidateAccountResendPhoneVerificationCode",
          "plural": false,
          "selections": [
            v2,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v3
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseCandidatePhoneSendVerificationMutation",
      "selections": [
        {
          "alias": "task",
          "args": v1,
          "concreteType": "AccountsCandidateAccountResendPhoneVerificationCodePayload",
          "kind": "LinkedField",
          "name": "accountsCandidateAccountResendPhoneVerificationCode",
          "plural": false,
          "selections": [
            v2,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v3
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "25ccbdbc1a7abbc33da79c0bcddc39d4",
      "id": null,
      "metadata": {},
      "name": "UseCandidatePhoneSendVerificationMutation",
      "operationKind": "mutation",
      "text": "mutation UseCandidatePhoneSendVerificationMutation(\n  $input: AccountsCandidateAccountResendPhoneVerificationCodeInput!\n) {\n  task: accountsCandidateAccountResendPhoneVerificationCode(input: $input) {\n    candidateAccount {\n      node {\n        id\n        firstName\n        lastName\n        email\n        phone {\n          phoneNumber\n          phoneCountryCode\n          phoneCountryPrefix\n          phoneVerificationStatus\n        }\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node8.hash = "55f2135b675fc7c13fe6bc4b84333277";
var UseCandidatePhoneSendVerificationMutation_graphql_default = node8;

// src/mutations/UseCandidatePhoneSendVerification.ts
import { useAsyncMutation as useAsyncMutation5 } from "shared-lib";
var mutationDef6 = UseCandidatePhoneSendVerificationMutation_graphql_default;
function useCandidatePhoneSendVerification() {
  const [commit, isBusy] = useAsyncMutation5(mutationDef6);
  return [commit, isBusy];
}

// src/mutations/__generated__/UseCandidatePhoneVerifyMutation.graphql.ts
var node9 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "concreteType": "CandidatePhoneVerificationResult",
    "kind": "LinkedField",
    "name": "candidateAccount",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isValidVerificationCode",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "EdgeOfCandidateAccount",
        "kind": "LinkedField",
        "name": "candidate",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountsCandidateAccount",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "firstName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lastName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "email",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "CandidatePhoneVerification",
                "kind": "LinkedField",
                "name": "phone",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "phoneNumber",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "phoneCountryCode",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "phoneCountryPrefix",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "phoneVerificationStatus",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v3 = {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseCandidatePhoneVerifyMutation",
      "selections": [
        {
          "alias": "task",
          "args": v1,
          "concreteType": "AccountsCandidateAccountVerifyPhoneVerificationCodePayload",
          "kind": "LinkedField",
          "name": "accountsCandidateAccountVerifyPhoneVerificationCode",
          "plural": false,
          "selections": [
            v2,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v3
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseCandidatePhoneVerifyMutation",
      "selections": [
        {
          "alias": "task",
          "args": v1,
          "concreteType": "AccountsCandidateAccountVerifyPhoneVerificationCodePayload",
          "kind": "LinkedField",
          "name": "accountsCandidateAccountVerifyPhoneVerificationCode",
          "plural": false,
          "selections": [
            v2,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v3
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "0552853f7ea2ce508eb6f823dd3d40b2",
      "id": null,
      "metadata": {},
      "name": "UseCandidatePhoneVerifyMutation",
      "operationKind": "mutation",
      "text": "mutation UseCandidatePhoneVerifyMutation(\n  $input: AccountsCandidateAccountVerifyPhoneVerificationCodeInput!\n) {\n  task: accountsCandidateAccountVerifyPhoneVerificationCode(input: $input) {\n    candidateAccount {\n      isValidVerificationCode\n      candidate {\n        node {\n          id\n          firstName\n          lastName\n          email\n          phone {\n            phoneNumber\n            phoneCountryCode\n            phoneCountryPrefix\n            phoneVerificationStatus\n          }\n        }\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node9.hash = "a328bb19e16bdd89a7b53c3c440f54d4";
var UseCandidatePhoneVerifyMutation_graphql_default = node9;

// src/mutations/UseCandidatePhoneVerify.ts
import { useAsyncMutation as useAsyncMutation6 } from "shared-lib";
var mutationDef7 = UseCandidatePhoneVerifyMutation_graphql_default;
function useCandidatePhoneVerify() {
  const [commit, isBusy] = useAsyncMutation6(mutationDef7);
  return [commit, isBusy];
}

// src/mutations/__generated__/UseCandidateResetPasswordAcceptTermsMutation.graphql.ts
var node10 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "concreteType": "CandidateWithOtacCode",
    "kind": "LinkedField",
    "name": "payload",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "EdgeOfCandidateAccount",
        "kind": "LinkedField",
        "name": "candidate",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountsCandidateAccount",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "accountId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "email",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "otacCode",
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "message",
    "storageKey": null
  }, v4 = {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      v3,
      {
        "alias": null,
        "args": null,
        "concreteType": "ValidationItem",
        "kind": "LinkedField",
        "name": "validations",
        "plural": true,
        "selections": [
          v3,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseCandidateResetPasswordAcceptTermsMutation",
      "selections": [
        {
          "alias": "task",
          "args": v1,
          "concreteType": "AccountsCandidateAccountResetPasswordAcceptTermsPayload",
          "kind": "LinkedField",
          "name": "accountsCandidateAccountResetPasswordAcceptTerms",
          "plural": false,
          "selections": [
            v2,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseCandidateResetPasswordAcceptTermsMutation",
      "selections": [
        {
          "alias": "task",
          "args": v1,
          "concreteType": "AccountsCandidateAccountResetPasswordAcceptTermsPayload",
          "kind": "LinkedField",
          "name": "accountsCandidateAccountResetPasswordAcceptTerms",
          "plural": false,
          "selections": [
            v2,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "d23ca3bdb31efa97130c201431c6b58d",
      "id": null,
      "metadata": {},
      "name": "UseCandidateResetPasswordAcceptTermsMutation",
      "operationKind": "mutation",
      "text": "mutation UseCandidateResetPasswordAcceptTermsMutation(\n  $input: AccountsCandidateAccountResetPasswordAcceptTermsInput!\n) {\n  task: accountsCandidateAccountResetPasswordAcceptTerms(input: $input) {\n    payload {\n      candidate {\n        node {\n          id\n          accountId\n          email\n        }\n      }\n      otacCode\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n        validations {\n          message\n          name\n        }\n      }\n    }\n  }\n}\n"
    }
  };
}();
node10.hash = "9a13ca5f8fa453e896d9f7360aeee39c";
var UseCandidateResetPasswordAcceptTermsMutation_graphql_default = node10;

// src/mutations/UseCandidateResetPasswordAcceptTerms.ts
import { useAsyncMutation as useAsyncMutation7 } from "shared-lib";
var mutationDef8 = UseCandidateResetPasswordAcceptTermsMutation_graphql_default;
function useCandidateResetPasswordAcceptTerms() {
  const [commit, isBusy] = useAsyncMutation7(mutationDef8);
  return [commit, isBusy];
}

// src/mutations/__generated__/UseCandidateSetGDPRConsentMutation.graphql.ts
var node11 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "__typename",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfCandidateAccount",
    "kind": "LinkedField",
    "name": "payload",
    "plural": false,
    "selections": [
      v2,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cursor",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountsCandidateAccount",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isGdprConsented",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "message",
    "storageKey": null
  }, v5 = {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      v4,
      {
        "alias": null,
        "args": null,
        "concreteType": "ValidationItem",
        "kind": "LinkedField",
        "name": "validations",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          v4
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "data",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseCandidateSetGDPRConsentMutation",
      "selections": [
        {
          "alias": null,
          "args": v1,
          "concreteType": "AccountsCandidateAccountSetGDPRConsentPayload",
          "kind": "LinkedField",
          "name": "accountsCandidateAccountSetGDPRConsent",
          "plural": false,
          "selections": [
            v3,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v5
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseCandidateSetGDPRConsentMutation",
      "selections": [
        {
          "alias": null,
          "args": v1,
          "concreteType": "AccountsCandidateAccountSetGDPRConsentPayload",
          "kind": "LinkedField",
          "name": "accountsCandidateAccountSetGDPRConsent",
          "plural": false,
          "selections": [
            v3,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v2,
                v5
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "436fd53bdf24703e79daef947f9f4e5d",
      "id": null,
      "metadata": {},
      "name": "UseCandidateSetGDPRConsentMutation",
      "operationKind": "mutation",
      "text": "mutation UseCandidateSetGDPRConsentMutation(\n  $input: AccountsCandidateAccountSetGDPRConsentInput!\n) {\n  accountsCandidateAccountSetGDPRConsent(input: $input) {\n    payload {\n      __typename\n      cursor\n      node {\n        id\n        updatedAt\n        isGdprConsented\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n        validations {\n          name\n          message\n        }\n        data\n      }\n    }\n  }\n}\n"
    }
  };
}();
node11.hash = "d56f58a3c74041f710e97c4e08a4ae47";
var UseCandidateSetGDPRConsentMutation_graphql_default = node11;

// src/mutations/UseCandidateSetGDPRConsent.ts
import { useAsyncMutation as useAsyncMutation8 } from "shared-lib";
var mutationDef9 = UseCandidateSetGDPRConsentMutation_graphql_default;
function useCandidateSetGDPRConsent() {
  const [commit, isBusy] = useAsyncMutation8(mutationDef9);
  return [commit, isBusy];
}

// src/mutations/__generated__/VerifyEmailMutation.graphql.ts
var node12 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "__typename",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfCandidateAccount",
    "kind": "LinkedField",
    "name": "payload",
    "plural": false,
    "selections": [
      v2,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cursor",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountsCandidateAccount",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isEmailVerified",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "message",
    "storageKey": null
  }, v5 = {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      v4,
      {
        "alias": null,
        "args": null,
        "concreteType": "ValidationItem",
        "kind": "LinkedField",
        "name": "validations",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          v4
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "data",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "VerifyEmailMutation",
      "selections": [
        {
          "alias": null,
          "args": v1,
          "concreteType": "AccountsCandidateAccountVerifyEmailPayload",
          "kind": "LinkedField",
          "name": "accountsCandidateAccountVerifyEmail",
          "plural": false,
          "selections": [
            v3,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v5
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "VerifyEmailMutation",
      "selections": [
        {
          "alias": null,
          "args": v1,
          "concreteType": "AccountsCandidateAccountVerifyEmailPayload",
          "kind": "LinkedField",
          "name": "accountsCandidateAccountVerifyEmail",
          "plural": false,
          "selections": [
            v3,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v2,
                v5
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "5c8f6061e4186c6ff8ccc98eb2a24903",
      "id": null,
      "metadata": {},
      "name": "VerifyEmailMutation",
      "operationKind": "mutation",
      "text": "mutation VerifyEmailMutation(\n  $input: AccountsCandidateAccountVerifyEmailInput!\n) {\n  accountsCandidateAccountVerifyEmail(input: $input) {\n    payload {\n      __typename\n      cursor\n      node {\n        id\n        updatedAt\n        isEmailVerified\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n        validations {\n          name\n          message\n        }\n        data\n      }\n    }\n  }\n}\n"
    }
  };
}();
node12.hash = "671821cf995dfc1398aa90b7ff6f5526";
var VerifyEmailMutation_graphql_default = node12;

// src/mutations/VerifyEmail.ts
import { useCallback as useCallback2 } from "react";
import { useMutation as useMutation2 } from "react-relay";
import { createClientMutationId as createClientMutationId2 } from "shared-lib";
var mutationDef10 = VerifyEmailMutation_graphql_default;
var useVerifyEmail = (onDone, onUserError, onError) => {
  const [commitMutation, isMutationInFlight] = useMutation2(mutationDef10);
  const invokeMutation = useCallback2(
    (code) => {
      const clientMutationId = createClientMutationId2();
      commitMutation({
        variables: {
          input: { code, clientMutationId }
        },
        onError: (e) => {
          if (onError) {
            onError(e);
          }
        },
        onCompleted: (response) => {
          if (response.accountsCandidateAccountVerifyEmail.payload?.node) {
            if (onDone) {
              onDone();
            }
          }
          if (response.accountsCandidateAccountVerifyEmail.userErrors && response.accountsCandidateAccountVerifyEmail.userErrors.length > 0) {
            const userError = response.accountsCandidateAccountVerifyEmail.userErrors[0];
            if (userError.code) {
              if (onUserError) {
                onUserError(userError.code);
              }
            }
          }
        }
      });
    },
    [commitMutation]
  );
  return [invokeMutation, isMutationInFlight];
};

// src/components/account/components/CandidateAccountEmailEditor.tsx
import { jsx as jsx2, jsxs as jsxs2 } from "react/jsx-runtime";
var fragmentDef2 = CandidateAccountEmailEditor_account_graphql_default;
var FormSchema = zod.object({
  email: zod.string().email().min(5),
  confirmEmail: zod.string().email()
}).refine(
  (obj) => {
    return obj.email === obj.confirmEmail;
  },
  {
    message: "Email addresses must be the same",
    path: ["confirmEmail"]
  }
);
var CandidateAccountEmailEditor = ({
  candidateId,
  fragmentRef,
  onSaved,
  onCancel
}) => {
  const data = useFragment2(
    fragmentDef2,
    fragmentRef
  );
  const defaultValues = {
    email: data.email || "",
    confirmEmail: ""
  };
  const errorCode = useUserErrorCode();
  const [save, isSaving] = useCandidateChangeEmail();
  const onSave = useCallback3((form) => {
    async function saveAsync() {
      await save({
        input: {
          candidateId,
          clientMutationId: createClientMutationId3(),
          email: form.email,
          confirmEmail: form.confirmEmail
        }
      });
      onSaved();
    }
    saveAsync();
  }, []);
  const { register, handleSubmit, formState } = useForm({
    resolver: zodResolver(FormSchema),
    defaultValues
  });
  const { errors, isDirty } = formState;
  return /* @__PURE__ */ jsxs2(
    ActionContainer,
    {
      onSubmit: handleSubmit(onSave),
      onCancel,
      isSaving,
      isDirty,
      showCancel: true,
      titleTop: "Update email address",
      children: [
        errorCode && /* @__PURE__ */ jsx2(AlertMessage, { message: "An error has occurred" }),
        /* @__PURE__ */ jsxs2(FormInputRow, { name: "email", title: "Email", children: [
          /* @__PURE__ */ jsx2(
            FormInput,
            {
              type: "text",
              name: "email",
              required: true,
              register
            }
          ),
          /* @__PURE__ */ jsx2(ErrorField, { field: errors.email })
        ] }),
        /* @__PURE__ */ jsxs2(FormInputRow, { name: "confirmEmail", title: "Confirm Email", children: [
          /* @__PURE__ */ jsx2(
            FormInput,
            {
              type: "text",
              name: "confirmEmail",
              required: true,
              register
            }
          ),
          /* @__PURE__ */ jsx2(ErrorField, { field: errors.confirmEmail })
        ] })
      ]
    }
  );
};

// src/components/account/components/__generated__/CandidateAccountEmailVerifyForm_account.graphql.ts
var node13 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CandidateAccountEmailVerifyForm_account",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "accountId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasAgreedToTerms",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isGdprConsented",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isEmailVerified",
      "storageKey": null
    }
  ],
  "type": "AccountsCandidateAccount",
  "abstractKey": null
};
node13.hash = "8fb7ab00254ec2d569dffc786f0b6f7c";
var CandidateAccountEmailVerifyForm_account_graphql_default = node13;

// src/components/account/components/CandidateAccountEmailVerifyForm.tsx
import { useState as useState2 } from "react";
import { useFragment as useFragment3 } from "react-relay";
import {
  ElevateBox,
  ElevateHeader,
  Button as Button2,
  Input as Input2,
  Size,
  ButtonList,
  AlertMessage as AlertMessage2
} from "shared-ui";
import { jsx as jsx3, jsxs as jsxs3 } from "react/jsx-runtime";
var fragmentDef3 = CandidateAccountEmailVerifyForm_account_graphql_default;
var CandidateAccountEmailVerifyForm = ({
  fragmentRef,
  onCompleted,
  onError
}) => {
  const data = useFragment3(
    fragmentDef3,
    fragmentRef
  );
  const [errorCode, setErrorCode] = useState2(null);
  const [code, setCode] = useState2("");
  const [verifyEmailCode, isMutationInFlight] = useVerifyEmail(
    () => {
      if (onCompleted) {
        onCompleted();
      }
    },
    (code2) => {
      setErrorCode(code2);
    },
    (e) => {
      if (onError) {
        onError(e);
      }
    }
  );
  const [sendVerification, isSendVerificationInFlight] = useSendEmailVerificationCode(
    data.accountId,
    () => {
      if (onCompleted) {
        onCompleted();
      }
    },
    (code2) => {
      setErrorCode(code2);
    },
    (e) => {
      if (onError) {
        onError(e);
      }
    }
  );
  return /* @__PURE__ */ jsxs3(ElevateBox, { classes: "", children: [
    /* @__PURE__ */ jsxs3("div", { children: [
      /* @__PURE__ */ jsx3(
        ElevateHeader,
        {
          title: `Hi ${data.firstName}`,
          subTitle: `We need to verify your email`
        }
      ),
      /* @__PURE__ */ jsxs3("div", { className: "mt-2 py-2 text-gray-700", children: [
        /* @__PURE__ */ jsx3("p", { children: "We've sent a code to " }),
        /* @__PURE__ */ jsx3("p", { children: /* @__PURE__ */ jsx3("span", { className: "font-medium", children: data.email }) }),
        /* @__PURE__ */ jsx3("p", { className: "mt-2", children: "Please enter the code below" })
      ] })
    ] }),
    errorCode && errorCode === "ACCOUNTS_CANDIDATE_ACCOUNT_EMAIL_VALIDATION_CODE_INVALID" && /* @__PURE__ */ jsx3(AlertMessage2, { message: "Invalid Validation Code" }),
    /* @__PURE__ */ jsx3("div", { className: "py-4", children: /* @__PURE__ */ jsx3(
      Input2,
      {
        placeholder: " Enter Code ",
        name: "code",
        value: code,
        onValueChange: setCode
      },
      "code"
    ) }),
    /* @__PURE__ */ jsx3("div", { className: "mt-2", children: /* @__PURE__ */ jsxs3(ButtonList, { children: [
      /* @__PURE__ */ jsx3(
        Button2,
        {
          className: "flex-grow",
          size: Size.md,
          color: "primary",
          disabled: isMutationInFlight || !code || code === "",
          clicked: () => verifyEmailCode(code),
          children: "Verify your Email"
        }
      ),
      /* @__PURE__ */ jsx3(
        Button2,
        {
          className: "flex-grow",
          size: Size.md,
          color: "secondary",
          disabled: isSendVerificationInFlight,
          clicked: sendVerification,
          children: "Send the Email again"
        }
      )
    ] }) })
  ] });
};

// src/components/account/components/__generated__/CandidateAccountGDPRConsentForm_account.graphql.ts
var node14 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CandidateAccountGDPRConsentForm_account",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "accountId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasAgreedToTerms",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isGdprConsented",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isEmailVerified",
      "storageKey": null
    }
  ],
  "type": "AccountsCandidateAccount",
  "abstractKey": null
};
node14.hash = "82492111c2389284ad75731ff405ee0c";
var CandidateAccountGDPRConsentForm_account_graphql_default = node14;

// src/components/account/components/CandidateAccountGDPRConsentForm.tsx
import { useCallback as useCallback4, useState as useState3 } from "react";
import { useFragment as useFragment4 } from "react-relay";
import { Switch } from "@headlessui/react";
import { ElevateBox as ElevateBox2, ElevateHeader as ElevateHeader2, Button as Button3, Size as Size2 } from "shared-ui";
import { createClientMutationId as createClientMutationId4 } from "shared-lib";
import { jsx as jsx4, jsxs as jsxs4 } from "react/jsx-runtime";
var fragmentDef4 = CandidateAccountGDPRConsentForm_account_graphql_default;
var CandidateAccountGDPRConsentForm = ({
  fragmentRef
}) => {
  const data = useFragment4(
    fragmentDef4,
    fragmentRef
  );
  const [setConsent, isSetConsenting] = useCandidateSetGDPRConsent();
  const [isConsenting, setIsConsenting] = useState3(true);
  const [hasChanged, setHasChanged] = useState3(false);
  const setConsenting = useCallback4(
    (is) => {
      setHasChanged(true);
      setIsConsenting(is);
    },
    [isConsenting]
  );
  async function save() {
    const input = {
      candidateId: data.accountId,
      clientMutationId: createClientMutationId4(),
      isConsenting
    };
    await setConsent({ input });
  }
  return /* @__PURE__ */ jsxs4(ElevateBox2, { classes: "lg:m-8 xl:m-16", children: [
    /* @__PURE__ */ jsx4(
      ElevateHeader2,
      {
        title: `Hi ${data.firstName}`,
        subTitle: `We need your consent to our GDPR policy`
      }
    ),
    /* @__PURE__ */ jsxs4("div", { className: "flex items-center space-x-2 py-4", children: [
      /* @__PURE__ */ jsxs4(
        Switch,
        {
          checked: isConsenting,
          onChange: setConsenting,
          className: `${isConsenting ? "bg-info-600" : "bg-gray-200"} relative inline-flex h-6 w-11 items-center rounded-full`,
          children: [
            /* @__PURE__ */ jsx4("span", { className: "sr-only", children: "Consent To GDPR" }),
            /* @__PURE__ */ jsx4(
              "span",
              {
                className: `${isConsenting ? "translate-x-6" : "translate-x-1"} inline-block h-4 w-4 transform rounded-full bg-white`
              }
            )
          ]
        }
      ),
      /* @__PURE__ */ jsx4("div", { children: isConsenting ? "I consent" : "I dont consent" })
    ] }),
    hasChanged && !isConsenting && /* @__PURE__ */ jsx4("p", { className: "text-primary-500 p-4 text-lg font-bold", children: "We're sorry, but unfortunately you cannot sign up without consenting to our GDPR terms" }),
    /* @__PURE__ */ jsx4("div", { className: "mt-2 flex", children: /* @__PURE__ */ jsx4(
      Button3,
      {
        className: "flex-grow",
        size: Size2.lg,
        color: "primary",
        disabled: isSetConsenting,
        clicked: save,
        children: "Confirm my consent"
      }
    ) })
  ] });
};

// src/components/account/components/__generated__/CandidateAccountSetupContainer_account.graphql.ts
var node15 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CandidateAccountSetupContainer_account",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasAgreedToTerms",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isGdprConsented",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isEmailVerified",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CandidateAccountEmailVerifyForm_account"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CandidateAccountGDPRConsentForm_account"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CandidateAccountTermsForm_account"
    }
  ],
  "type": "AccountsCandidateAccount",
  "abstractKey": null
};
node15.hash = "7a47a1e584c6758075987970592e27ad";
var CandidateAccountSetupContainer_account_graphql_default = node15;

// src/components/account/components/CandidateAccountSetupContainer.tsx
import { Suspense, useMemo as useMemo2 } from "react";
import { useFragment as useFragment6 } from "react-relay";
import { ElevateCentered, EdSkeleton } from "shared-ui";

// src/components/account/components/__generated__/CandidateAccountTermsForm_account.graphql.ts
var node16 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CandidateAccountTermsForm_account",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "accountId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasAgreedToTerms",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isGdprConsented",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isEmailVerified",
      "storageKey": null
    }
  ],
  "type": "AccountsCandidateAccount",
  "abstractKey": null
};
node16.hash = "0cbf76bf101f574c6f5a9c864716de43";
var CandidateAccountTermsForm_account_graphql_default = node16;

// src/components/account/components/__generated__/CandidateAccountTermsFormMutation.graphql.ts
var node17 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "__typename",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfCandidateAccount",
    "kind": "LinkedField",
    "name": "payload",
    "plural": false,
    "selections": [
      v2,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cursor",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountsCandidateAccount",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasAgreedToTerms",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "message",
    "storageKey": null
  }, v5 = {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      v4,
      {
        "alias": null,
        "args": null,
        "concreteType": "ValidationItem",
        "kind": "LinkedField",
        "name": "validations",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          v4
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "data",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "CandidateAccountTermsFormMutation",
      "selections": [
        {
          "alias": null,
          "args": v1,
          "concreteType": "AccountsCandidateAccountSetTermsPayload",
          "kind": "LinkedField",
          "name": "accountsCandidateAccountSetTerms",
          "plural": false,
          "selections": [
            v3,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v5
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "CandidateAccountTermsFormMutation",
      "selections": [
        {
          "alias": null,
          "args": v1,
          "concreteType": "AccountsCandidateAccountSetTermsPayload",
          "kind": "LinkedField",
          "name": "accountsCandidateAccountSetTerms",
          "plural": false,
          "selections": [
            v3,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v2,
                v5
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "65cf3fc5d9a30dfd3c7da6e08876f3f9",
      "id": null,
      "metadata": {},
      "name": "CandidateAccountTermsFormMutation",
      "operationKind": "mutation",
      "text": "mutation CandidateAccountTermsFormMutation(\n  $input: AccountsCandidateAccountSetTermsInput!\n) {\n  accountsCandidateAccountSetTerms(input: $input) {\n    payload {\n      __typename\n      cursor\n      node {\n        id\n        updatedAt\n        hasAgreedToTerms\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n        validations {\n          name\n          message\n        }\n        data\n      }\n    }\n  }\n}\n"
    }
  };
}();
node17.hash = "cb62ed897c82e38e0a5cd74d36c52c6d";
var CandidateAccountTermsFormMutation_graphql_default = node17;

// src/components/account/components/CandidateAccountTermsForm.tsx
import { useCallback as useCallback5, useState as useState4 } from "react";
import { useFragment as useFragment5, useMutation as useMutation3 } from "react-relay";
import { Switch as Switch2 } from "@headlessui/react";
import { ElevateBox as ElevateBox3, ElevateHeader as ElevateHeader3, Button as Button4, TextArea } from "shared-ui";
import { createClientMutationId as createClientMutationId5 } from "shared-lib";
import { jsx as jsx5, jsxs as jsxs5 } from "react/jsx-runtime";
var fragmentDef5 = CandidateAccountTermsForm_account_graphql_default;
var CandidateAccountTermsForm = ({
  fragmentRef,
  onCompleted,
  onError
}) => {
  const data = useFragment5(
    fragmentDef5,
    fragmentRef
  );
  const [commitMutation, isMutationInFlight] = useMutation3(CandidateAccountTermsFormMutation_graphql_default);
  const [hasAgreed, setHasAgreed] = useState4(false);
  const [reason, setReason] = useState4("");
  const [hasChanged, setHasChanged] = useState4(false);
  const setAgreed = useCallback5(
    (is) => {
      setHasChanged(true);
      setHasAgreed(is);
    },
    [hasAgreed]
  );
  function save() {
    const clientMutationId = createClientMutationId5();
    commitMutation({
      variables: {
        input: {
          hasAgreed,
          message: "",
          reason,
          clientMutationId,
          candidateId: data.accountId
        }
      },
      onError,
      onCompleted
    });
  }
  return /* @__PURE__ */ jsxs5(ElevateBox3, { classes: "lg:m-8 xl:m-16", children: [
    /* @__PURE__ */ jsx5(
      ElevateHeader3,
      {
        title: `Hi ${data.firstName}`,
        subTitle: `We need you to agree to our Terms`
      }
    ),
    /* @__PURE__ */ jsxs5("div", { className: "flex items-center space-x-2 py-2", children: [
      /* @__PURE__ */ jsxs5(
        Switch2,
        {
          checked: hasAgreed,
          onChange: setAgreed,
          className: `${hasAgreed ? "bg-info-600" : "bg-gray-200"} relative inline-flex h-6 w-11 items-center rounded-full`,
          children: [
            /* @__PURE__ */ jsx5("span", { className: "sr-only", children: "Agree To Terms" }),
            /* @__PURE__ */ jsx5(
              "span",
              {
                className: `${hasAgreed ? "translate-x-6" : "translate-x-1"} inline-block h-4 w-4 transform rounded-full bg-white`
              }
            )
          ]
        }
      ),
      /* @__PURE__ */ jsx5("div", { children: hasAgreed ? "I agree" : "I dont agree" }),
      /* @__PURE__ */ jsx5("div", { children: !hasAgreed ? /* @__PURE__ */ jsx5(
        TextArea,
        {
          rows: 3,
          className: "focus:border-info-500 focus:ring-info-500 block w-full rounded-md border border-gray-300 shadow-sm sm:text-sm",
          placeholder: "Reason",
          onValueChange: (text) => setReason(text)
        }
      ) : null })
    ] }),
    /* @__PURE__ */ jsx5("div", { className: "mt-2", children: /* @__PURE__ */ jsx5(
      Button4,
      {
        color: "primary",
        disabled: isMutationInFlight || !hasChanged,
        clicked: save,
        children: "Save"
      }
    ) })
  ] });
};

// src/components/account/components/CandidateAccountSetupContainer.tsx
import { jsx as jsx6 } from "react/jsx-runtime";
var fragmentDef6 = CandidateAccountSetupContainer_account_graphql_default;
function getStateFromStatus2(data) {
  if (!data.hasAgreedToTerms) {
    return "terms";
  }
  if (!data.isGdprConsented) {
    return "gdpr";
  }
  if (!data.isEmailVerified) {
    return "email";
  }
  return "account";
}
var CandidateAccountSetupContainer = ({ fragmentRef }) => {
  const data = useFragment6(
    fragmentDef6,
    fragmentRef
  );
  const state = useMemo2(() => {
    return getStateFromStatus2(data);
  }, [data]);
  if (!data) {
    return /* @__PURE__ */ jsx6("div", { className: "m-8", children: "No Candidate Data Found" });
  }
  let view = /* @__PURE__ */ jsx6("div", { children: /* @__PURE__ */ jsx6("h1", { children: "All Done!!" }) });
  if (state === "terms") {
    view = /* @__PURE__ */ jsx6(CandidateAccountTermsForm, { fragmentRef: data });
  } else if (state === "gdpr") {
    view = /* @__PURE__ */ jsx6(CandidateAccountGDPRConsentForm, { fragmentRef: data });
  } else if (state === "email") {
    view = /* @__PURE__ */ jsx6(CandidateAccountEmailVerifyForm, { fragmentRef: data });
  }
  return /* @__PURE__ */ jsx6(Suspense, { fallback: /* @__PURE__ */ jsx6(EdSkeleton, {}), children: /* @__PURE__ */ jsx6(ElevateCentered, { children: view }) });
};

// src/components/account/components/__generated__/CandidateAccountNameEditor_account.graphql.ts
var node18 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CandidateAccountNameEditor_account",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedAt",
      "storageKey": null
    }
  ],
  "type": "AccountsCandidateAccount",
  "abstractKey": null
};
node18.hash = "fe242a81f9de3af7b80c1056e7ebdd52";
var CandidateAccountNameEditor_account_graphql_default = node18;

// src/components/account/components/CandidateAccountNameEditor.tsx
import { useCallback as useCallback6 } from "react";
import { useFragment as useFragment7 } from "react-relay";
import * as zod2 from "zod";
import { zodResolver as zodResolver2 } from "@hookform/resolvers/zod";
import { useForm as useForm2 } from "react-hook-form";
import {
  AlertMessage as AlertMessage3,
  ActionContainer as ActionContainer2,
  FormInputRow as FormInputRow2,
  FormInput as FormInput2,
  ErrorField as ErrorField2
} from "shared-ui";
import { createClientMutationId as createClientMutationId6, useUserErrorCode as useUserErrorCode2 } from "shared-lib";
import { jsx as jsx7, jsxs as jsxs6 } from "react/jsx-runtime";
var fragmentDef7 = CandidateAccountNameEditor_account_graphql_default;
var FormSchema2 = zod2.object({
  firstName: zod2.string().min(2),
  lastName: zod2.string().min(2)
});
var CandidateAccountNameEditor = ({
  candidateId,
  fragmentRef,
  onSaved,
  onCancel
}) => {
  const data = useFragment7(
    fragmentDef7,
    fragmentRef
  );
  const errorCode = useUserErrorCode2();
  const [save, isSaving] = useCandidateChangeName();
  const defaultValues = {
    firstName: data.firstName || "",
    lastName: data.lastName || ""
  };
  const { register, handleSubmit, formState } = useForm2({
    resolver: zodResolver2(FormSchema2),
    defaultValues
  });
  const { errors, isDirty } = formState;
  const onSave = useCallback6((form) => {
    async function saveAsync() {
      await save({
        input: {
          clientMutationId: createClientMutationId6(),
          candidateId,
          firstName: form.firstName,
          lastName: form.lastName
        }
      });
      onSaved();
    }
    saveAsync();
  }, []);
  return /* @__PURE__ */ jsxs6(
    ActionContainer2,
    {
      onSubmit: handleSubmit(onSave),
      onCancel,
      showCancel: true,
      isSaving,
      isDirty,
      titleTop: "Update details",
      children: [
        errorCode && /* @__PURE__ */ jsx7(AlertMessage3, { message: "An error has occurred" }),
        /* @__PURE__ */ jsxs6(FormInputRow2, { name: "firstName", title: "First Name", children: [
          /* @__PURE__ */ jsx7(
            FormInput2,
            {
              type: "text",
              name: "firstName",
              required: true,
              register
            }
          ),
          /* @__PURE__ */ jsx7(ErrorField2, { field: errors.firstName })
        ] }),
        /* @__PURE__ */ jsxs6(FormInputRow2, { name: "lastName", title: "Last Name", children: [
          /* @__PURE__ */ jsx7(
            FormInput2,
            {
              type: "text",
              name: "lastName",
              required: true,
              register
            }
          ),
          /* @__PURE__ */ jsx7(ErrorField2, { field: errors.lastName })
        ] })
      ]
    }
  );
};

// src/components/account/components/CandidateAccountResetPasswordTerms.tsx
import { Suspense as Suspense2, useCallback as useCallback7, useState as useState5 } from "react";
import { Link as Link2 } from "react-router-dom";
import { createClientMutationId as createClientMutationId7, getPlatformLinks as getPlatformLinks2, noop } from "shared-lib";
import {
  ActionContainer as ActionContainer3,
  Button as Button5,
  CheckBox as CheckBox2,
  ErrorField as ErrorField3,
  Input as Input3
} from "shared-ui";
import { Fragment, jsx as jsx8, jsxs as jsxs7 } from "react/jsx-runtime";
var CandidateAccountResetPasswordTerms = ({
  email,
  resetCode,
  onDone,
  onCancel
}) => {
  const [update, isUpdating] = useCandidateResetPasswordAcceptTerms();
  const [password, setPassword] = useState5();
  const [hasAcceptedGDPR, setHasAcceptedGDPR] = useState5(true);
  const [hasAcceptedTerms, setHasAcceptedTerms] = useState5(true);
  const [userErrors, setUserErrors] = useState5([]);
  const onResetPassword = useCallback7(() => {
    async function change() {
      if (!password) {
        return;
      }
      const input = {
        password,
        email,
        resetCode,
        hasAcceptedGDPR,
        hasAcceptedTerms,
        clientMutationId: createClientMutationId7()
      };
      const result = await update({ input });
      if (result.task.userErrors) {
        setUserErrors(result.task.userErrors);
      }
      if (result.task.payload) {
        if (onDone) {
          onDone(result.task.payload);
        }
        return;
      }
    }
    change();
  }, [
    email,
    hasAcceptedGDPR,
    hasAcceptedTerms,
    onDone,
    password,
    resetCode,
    update
  ]);
  const platformLinks = getPlatformLinks2();
  const isDisabled = !hasAcceptedGDPR || !hasAcceptedTerms || !password;
  return /* @__PURE__ */ jsx8(Suspense2, { fallback: /* @__PURE__ */ jsx8("div", { children: "Loading" }), children: /* @__PURE__ */ jsx8(
    ActionContainer3,
    {
      onSubmit: onResetPassword,
      showCancel: false,
      onCancel,
      isDisabled,
      buttonElement: /* @__PURE__ */ jsx8(Fragment, { children: /* @__PURE__ */ jsx8(
        Button5,
        {
          color: isDisabled ? "gray" : "primary",
          onClick: isDisabled ? noop : onResetPassword,
          disabled: isDisabled,
          children: "Save"
        }
      ) }),
      titleBottom: `Set Password`,
      isSaving: isUpdating,
      children: /* @__PURE__ */ jsxs7("div", { className: "grid grid-cols-3 items-center gap-4 p-2 lg:p-4", children: [
        /* @__PURE__ */ jsx8("div", { className: "col-span-3 text-gray-900 lg:col-span-1", children: "Set a password" }),
        /* @__PURE__ */ jsxs7("div", { className: "col-span-3 lg:col-span-2", children: [
          /* @__PURE__ */ jsx8(
            Input3,
            {
              type: "password",
              name: "password",
              onValueChange: (number2) => {
                setPassword(number2);
              }
            }
          ),
          userErrors.map((e) => {
            switch (e?.code) {
              case "ACCOUNTS_CANDIDATE_ACCOUNT_VALIDATION":
                return /* @__PURE__ */ jsx8(
                  ErrorField3,
                  {
                    field: "Invalid password",
                    validations: e.validations.map((x) => x.message)
                  }
                );
            }
          })
        ] }),
        /* @__PURE__ */ jsxs7("div", { className: "col-span-2 text-gray-900 lg:col-span-1", children: [
          "I accept the",
          " ",
          /* @__PURE__ */ jsx8(
            Link2,
            {
              to: platformLinks.privacyPolicy,
              target: `_blank`,
              className: `underline`,
              children: "Privacy Policy"
            }
          )
        ] }),
        /* @__PURE__ */ jsx8("div", { className: "col-span-1 lg:col-span-2", children: /* @__PURE__ */ jsx8(
          CheckBox2,
          {
            checked: hasAcceptedGDPR,
            onChanged: setHasAcceptedGDPR
          }
        ) }),
        /* @__PURE__ */ jsxs7("div", { className: "col-span-2 text-gray-900 lg:col-span-1", children: [
          "I accept the",
          " ",
          /* @__PURE__ */ jsx8(
            Link2,
            {
              to: platformLinks.termsAndConditions,
              target: `_blank`,
              className: `underline`,
              children: "Terms and Conditions"
            }
          )
        ] }),
        /* @__PURE__ */ jsx8("div", { className: "col-span-1 lg:col-span-2", children: /* @__PURE__ */ jsx8(
          CheckBox2,
          {
            checked: hasAcceptedTerms,
            onChanged: setHasAcceptedTerms
          }
        ) })
      ] })
    }
  ) });
};

// src/components/account/components/CandidateAccountSendResetPassword.tsx
import { Suspense as Suspense3, useCallback as useCallback8 } from "react";
import { Button as Button6 } from "shared-ui";
import { jsx as jsx9 } from "react/jsx-runtime";
var CandidateAccountSendResetPassword = ({
  email,
  onDone,
  onCancel
}) => {
  const onReset = useCallback8(() => {
    console.log(``);
  }, []);
  return /* @__PURE__ */ jsx9(Suspense3, { fallback: /* @__PURE__ */ jsx9("div", { children: "Loading" }), children: /* @__PURE__ */ jsx9(Button6, { color: "primary", clicked: onReset, children: "Send" }) });
};

// src/components/account/components/__generated__/CandidatePhoneContainer_account.graphql.ts
var node19 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CandidatePhoneContainer_account",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "accountId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CandidatePhoneVerification",
      "kind": "LinkedField",
      "name": "phone",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "phoneCountryCode",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "phoneCountryPrefix",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "phoneNumber",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "phoneVerificationStatus",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CandidatePhoneEditor_account"
    }
  ],
  "type": "AccountsCandidateAccount",
  "abstractKey": null
};
node19.hash = "d4e1df19ca99214e8409dd56a2f03676";
var CandidatePhoneContainer_account_graphql_default = node19;

// src/components/account/components/CandidatePhoneContainer.tsx
import { Suspense as Suspense8, useMemo as useMemo3, useState as useState8 } from "react";
import { useFragment as useFragment9 } from "react-relay";
import { ActionContainer as ActionContainer6, Button as Button10, ButtonList as ButtonList4, Size as Size6 } from "shared-ui";

// src/components/account/components/CandidatePhoneVerificationStatusLabel.tsx
import { Fragment as Fragment2, jsx as jsx10 } from "react/jsx-runtime";
var CandidatePhoneVerificationStatusLabel = ({
  status
}) => {
  if (status === "NOT_VERIFIED") {
    return /* @__PURE__ */ jsx10("div", { className: "font-medium", children: /* @__PURE__ */ jsx10("span", { className: "text-primary-500", children: "Not Verified" }) });
  } else if (status === "SENT") {
    return /* @__PURE__ */ jsx10("div", { className: "font-medium", children: /* @__PURE__ */ jsx10("span", { className: "text-primary-500", children: "Sent" }) });
  } else if (status === "SENDING_FAILED") {
    return /* @__PURE__ */ jsx10("div", { className: "font-medium", children: /* @__PURE__ */ jsx10("span", { className: "text-gray-500", children: "Sending Failed" }) });
  } else if (status === "VERIFIED") {
    return /* @__PURE__ */ jsx10("div", { className: "font-medium", children: /* @__PURE__ */ jsx10("span", { className: "text-success-500", children: "Verified" }) });
  }
  return /* @__PURE__ */ jsx10(Fragment2, {});
};

// src/components/account/components/CandidatePhoneVerificationButton.tsx
import { Button as Button7, Size as Size3 } from "shared-ui";
import { Fragment as Fragment3, jsx as jsx11 } from "react/jsx-runtime";
var CandidatePhoneVerificationButton = ({
  phoneCountryCode,
  phoneCountryPrefix,
  phoneNumber,
  status,
  onSend,
  onResend,
  onEdit
}) => {
  if (!phoneNumber || !phoneCountryPrefix) {
    return /* @__PURE__ */ jsx11(Button7, { size: Size3.lg, color: "green", clicked: onEdit, children: "Add Number" });
  }
  if (status === "NOT_VERIFIED" || status === "SENT") {
    return /* @__PURE__ */ jsx11(Button7, { size: Size3.lg, color: "green", clicked: onSend, children: "Verify" });
  } else if (status === "SENDING_FAILED") {
    return /* @__PURE__ */ jsx11(Button7, { size: Size3.lg, color: "green", clicked: onResend, children: "Resend" });
  } else if (status === "VERIFIED") {
    return /* @__PURE__ */ jsx11(Button7, { size: Size3.lg, color: "green", clicked: onEdit, children: "Update" });
  }
  return /* @__PURE__ */ jsx11(Fragment3, {});
};

// src/components/account/components/__generated__/CandidatePhoneEditor_account.graphql.ts
var node20 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CandidatePhoneEditor_account",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "accountId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CandidatePhoneVerification",
      "kind": "LinkedField",
      "name": "phone",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "phoneCountryCode",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "phoneCountryPrefix",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "phoneNumber",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "phoneVerificationStatus",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "AccountsCandidateAccount",
  "abstractKey": null
};
node20.hash = "27ea9eaba514d722b83ff1db2a14585a";
var CandidatePhoneEditor_account_graphql_default = node20;

// src/components/account/components/CandidatePhoneEditor.tsx
import { Suspense as Suspense4, useCallback as useCallback9, useState as useState6 } from "react";
import { useFragment as useFragment8 } from "react-relay";
import { createClientMutationId as createClientMutationId8 } from "shared-lib";
import { ActionContainer as ActionContainer4, Input as Input4 } from "shared-ui";
import {
  GeoCountriesSearchContainer
} from "feature-data-management";

// src/components/account/components/EditorSection.tsx
import { PhoneIcon } from "@heroicons/react/24/outline";
import { jsx as jsx12, jsxs as jsxs8 } from "react/jsx-runtime";
var Editor = ({
  title,
  actions,
  children
}) => {
  return /* @__PURE__ */ jsxs8("div", { className: "px-2 sm:px-0", children: [
    /* @__PURE__ */ jsxs8("div", { className: "flex items-center justify-between border-b pb-2", children: [
      /* @__PURE__ */ jsxs8("div", { className: "flex gap-3", children: [
        /* @__PURE__ */ jsx12(PhoneIcon, { className: "stroke-info-600 h-7 w-7" }),
        /* @__PURE__ */ jsx12("h3", { className: "text-primary-900 text-lg", children: title })
      ] }),
      actions && /* @__PURE__ */ jsx12("div", { children: actions })
    ] }),
    /* @__PURE__ */ jsx12("div", { className: "pt-3", children })
  ] });
};
var EditorSection = ({
  title,
  children
}) => {
  return /* @__PURE__ */ jsxs8("div", { className: "flex items-center py-2", children: [
    /* @__PURE__ */ jsx12("div", { className: "w-32 font-medium", children: title }),
    /* @__PURE__ */ jsx12("div", { children })
  ] });
};

// src/components/account/components/CandidatePhoneEditor.tsx
import { jsx as jsx13, jsxs as jsxs9 } from "react/jsx-runtime";
var fragmentDef8 = CandidatePhoneEditor_account_graphql_default;
var CandidatePhoneEditor = ({
  fragmentRef,
  onDone,
  onCancel
}) => {
  const data = useFragment8(fragmentDef8, fragmentRef);
  const [changePhone, isChanging] = useCandidateChangePhoneNumber();
  const [country, setCountry] = useState6(null);
  const [phoneNumber, setPhoneNumber] = useState6(
    data.phone.phoneNumber
  );
  const [phoneCountryCode, setPhoneCountryCode] = useState6(data.phone.phoneCountryCode);
  const [phoneCountryCodePrefix, setPhoneCountryCodePrefix] = useState6(data.phone.phoneCountryPrefix);
  const onChangeCountry = useCallback9(
    (selected) => {
      setCountry(selected);
      setPhoneCountryCode(selected.iso3);
      setPhoneCountryCodePrefix(selected.phone || "");
    },
    [setCountry, setPhoneCountryCode, setPhoneCountryCodePrefix]
  );
  const onChangePhone = useCallback9(() => {
    async function change() {
      if (!phoneNumber || !phoneCountryCode || !phoneCountryCodePrefix || !country) {
        return;
      }
      const input = {
        candidateId: data.accountId,
        phoneNumber,
        phoneCountryCode,
        phoneCountryPrefix: phoneCountryCodePrefix,
        clientMutationId: createClientMutationId8()
      };
      const result = await changePhone({ input });
      if (result.task.candidateAccount) {
        if (onDone) {
          onDone();
        }
        return;
      }
    }
    change();
  }, [
    phoneNumber,
    phoneCountryCode,
    phoneCountryCodePrefix,
    country,
    data.accountId,
    changePhone,
    onDone
  ]);
  return /* @__PURE__ */ jsx13(Suspense4, { fallback: /* @__PURE__ */ jsx13("div", { children: "Loading" }), children: /* @__PURE__ */ jsx13(
    ActionContainer4,
    {
      onSubmit: onChangePhone,
      showCancel: true,
      onCancel,
      titleBottom: `Update Phone Number`,
      isSaving: isChanging,
      children: /* @__PURE__ */ jsxs9("div", { className: "p-2 sm:p-4", children: [
        /* @__PURE__ */ jsx13(EditorSection, { title: "Country", children: /* @__PURE__ */ jsx13(
          GeoCountriesSearchContainer,
          {
            name: "phone-country-search",
            onSearchCompleted: onChangeCountry
          }
        ) }),
        /* @__PURE__ */ jsx13(EditorSection, { title: "Number", children: /* @__PURE__ */ jsxs9("div", { className: "flex flex-1 items-center space-x-2", children: [
          country && country.phone && /* @__PURE__ */ jsxs9("div", { children: [
            "+",
            country.phone
          ] }),
          /* @__PURE__ */ jsx13("div", { children: /* @__PURE__ */ jsx13(
            Input4,
            {
              type: "text",
              name: "phoneNumber",
              onValueChange: (number2) => {
                setPhoneNumber(number2);
              }
            }
          ) })
        ] }) })
      ] })
    }
  ) });
};

// src/components/account/components/CandidatePhoneVerificationSend.tsx
import { Suspense as Suspense5, useCallback as useCallback10 } from "react";
import { createClientMutationId as createClientMutationId9 } from "shared-lib";
import { Button as Button8, ButtonList as ButtonList2, Size as Size4 } from "shared-ui";
import { jsx as jsx14, jsxs as jsxs10 } from "react/jsx-runtime";
var CandidatePhoneVerificationSend = ({
  candidateId,
  onDone,
  onCancel
}) => {
  const [send, isSending] = useCandidatePhoneSendVerification();
  const onSend = useCallback10(() => {
    async function sendCode() {
      const input = {
        candidateId,
        clientMutationId: createClientMutationId9()
      };
      const result = await send({ input });
      if (result.task.candidateAccount) {
        onDone();
        return;
      }
    }
    sendCode();
  }, [send]);
  return /* @__PURE__ */ jsx14(Suspense5, { fallback: /* @__PURE__ */ jsx14("div", { children: "Loading" }), children: /* @__PURE__ */ jsxs10(ButtonList2, { justify: "START", children: [
    /* @__PURE__ */ jsx14(
      Button8,
      {
        color: "primary",
        disabled: isSending,
        size: Size4.md,
        clicked: onSend,
        children: "Send Code"
      }
    ),
    /* @__PURE__ */ jsx14(
      Button8,
      {
        color: "gray",
        disabled: isSending,
        size: Size4.md,
        clicked: onCancel,
        children: "Cancel"
      }
    )
  ] }) });
};

// src/components/account/components/CandidatePhoneVerify.tsx
import { Suspense as Suspense7, useCallback as useCallback12, useState as useState7 } from "react";
import { createClientMutationId as createClientMutationId11 } from "shared-lib";
import { ActionContainer as ActionContainer5, Input as Input5 } from "shared-ui";

// src/components/account/components/CandidatePhoneVerificationResend.tsx
import { Suspense as Suspense6, useCallback as useCallback11 } from "react";
import { createClientMutationId as createClientMutationId10 } from "shared-lib";
import { Button as Button9, ButtonList as ButtonList3, Size as Size5 } from "shared-ui";
import { jsx as jsx15 } from "react/jsx-runtime";
var CandidatePhoneVerificationResend = ({
  candidateId,
  onDone,
  onCancel
}) => {
  const [send, isSending] = useCandidateResendPhoneVerificationCode();
  const onSend = useCallback11(async () => {
    const input = {
      candidateId,
      clientMutationId: createClientMutationId10()
    };
    const result = await send({ input });
    if (result.task.candidateAccount) {
      if (onDone) {
        onDone();
      }
      return;
    }
  }, [send]);
  return /* @__PURE__ */ jsx15(Suspense6, { fallback: /* @__PURE__ */ jsx15("div", { children: "Loading" }), children: /* @__PURE__ */ jsx15(ButtonList3, { justify: "START", children: /* @__PURE__ */ jsx15(
    Button9,
    {
      color: "primary",
      disabled: isSending,
      size: Size5.md,
      clicked: onSend,
      children: "Resend Code"
    }
  ) }) });
};

// src/components/account/components/CandidatePhoneVerify.tsx
import { jsx as jsx16, jsxs as jsxs11 } from "react/jsx-runtime";
var CandidatePhoneVerify = ({
  candidateId,
  onDone,
  onCancel
}) => {
  const [verify, isVerifying] = useCandidatePhoneVerify();
  const [code, setCode] = useState7(null);
  const onVerifyCode = useCallback12(async () => {
    if (!code) {
      return;
    }
    const input = {
      verificationCode: code,
      clientMutationId: createClientMutationId11()
    };
    const result = await verify({ input });
    if (result.task.candidateAccount && result.task.candidateAccount.isValidVerificationCode) {
      if (onDone) {
        onDone();
      }
      return;
    }
  }, [code, onDone, verify]);
  return /* @__PURE__ */ jsx16(Suspense7, { fallback: /* @__PURE__ */ jsx16("div", { children: "Loading" }), children: /* @__PURE__ */ jsx16(
    ActionContainer5,
    {
      onCancel,
      showCancel: true,
      cancelText: "Change Phone Number",
      onSubmit: onVerifyCode,
      isSaving: isVerifying,
      titleTop: "Verify Phone Number",
      children: /* @__PURE__ */ jsxs11("div", { className: "p-2 sm:p-4", children: [
        /* @__PURE__ */ jsx16(EditorSection, { title: "Code", children: /* @__PURE__ */ jsx16(Input5, { type: "text", name: "code", onValueChange: setCode }) }),
        /* @__PURE__ */ jsx16(CandidatePhoneVerificationResend, { candidateId })
      ] })
    }
  ) });
};

// src/components/account/components/CandidatePhoneContainer.tsx
import { jsx as jsx17, jsxs as jsxs12 } from "react/jsx-runtime";
var fragmentDef9 = CandidatePhoneContainer_account_graphql_default;
var PhoneEditingState = /* @__PURE__ */ ((PhoneEditingState2) => {
  PhoneEditingState2["View"] = "View";
  PhoneEditingState2["Edit"] = "Edit";
  PhoneEditingState2["Verify"] = "Verify";
  PhoneEditingState2["Send"] = "Send";
  PhoneEditingState2["Failed"] = "Failed";
  return PhoneEditingState2;
})(PhoneEditingState || {});
var CandidatePhoneContainer = ({
  fragmentRef,
  onCancel
}) => {
  const data = useFragment9(fragmentDef9, fragmentRef);
  const initialState = useMemo3(() => {
    if (data.phone.phoneVerificationStatus === "SENT") {
      return "Verify" /* Verify */;
    }
    if (data.phone.phoneVerificationStatus === "NOT_VERIFIED") {
      return "View" /* View */;
    }
    if (data.phone.phoneVerificationStatus === "SENDING_FAILED") {
      return "Failed" /* Failed */;
    }
    return "View" /* View */;
  }, [data]);
  const [state, setState] = useState8(initialState);
  return /* @__PURE__ */ jsx17(Suspense8, { fallback: /* @__PURE__ */ jsx17("div", { children: "Loading" }), children: /* @__PURE__ */ jsxs12("div", { className: "flex", children: [
    state === "Edit" /* Edit */ && /* @__PURE__ */ jsx17(
      CandidatePhoneEditor,
      {
        fragmentRef: data,
        onDone: () => setState("Verify" /* Verify */),
        onCancel: () => setState(
          data.phone.phoneVerificationStatus == "SENT" ? "Verify" /* Verify */ : "View" /* View */
        )
      }
    ),
    state === "Verify" /* Verify */ && /* @__PURE__ */ jsx17(
      CandidatePhoneVerify,
      {
        candidateId: data.accountId,
        onDone: () => setState("View" /* View */),
        onCancel: () => setState("Edit" /* Edit */)
      }
    ),
    !["Edit" /* Edit */, "Verify" /* Verify */].includes(
      state
    ) && /* @__PURE__ */ jsxs12(
      ActionContainer6,
      {
        titleTop: `Phone Number`,
        buttonElement: /* @__PURE__ */ jsxs12(ButtonList4, { justify: "START", children: [
          /* @__PURE__ */ jsx17(
            Button10,
            {
              size: Size6.lg,
              className: "border border-black bg-white text-black",
              onClick: onCancel,
              children: "Cancel"
            }
          ),
          /* @__PURE__ */ jsx17(
            CandidatePhoneVerificationButton,
            {
              phoneCountryCode: data.phone.phoneCountryCode,
              phoneCountryPrefix: data.phone.phoneCountryPrefix,
              phoneNumber: data.phone.phoneNumber,
              status: data.phone.phoneVerificationStatus,
              onEdit: () => setState("Edit" /* Edit */),
              onSend: () => setState("Send" /* Send */),
              onResend: () => setState("Send" /* Send */)
            }
          )
        ] }),
        children: [
          state === "View" /* View */ && /* @__PURE__ */ jsxs12(Editor, { title: "Phone", actions: /* @__PURE__ */ jsx17("div", {}), children: [
            /* @__PURE__ */ jsx17(EditorSection, { title: "Status", children: /* @__PURE__ */ jsx17(
              CandidatePhoneVerificationStatusLabel,
              {
                status: data.phone.phoneVerificationStatus
              }
            ) }),
            /* @__PURE__ */ jsx17(EditorSection, { title: "Number", children: /* @__PURE__ */ jsx17("div", { children: data.phone.phoneNumber ?? "Not Set" }) }),
            /* @__PURE__ */ jsx17(EditorSection, { title: "Prefix", children: /* @__PURE__ */ jsxs12("div", { children: [
              "+",
              data.phone.phoneCountryPrefix ?? "Not Set"
            ] }) })
          ] }),
          state === "Failed" /* Failed */ && /* @__PURE__ */ jsxs12(Editor, { title: "Sending Failed", children: [
            /* @__PURE__ */ jsx17(EditorSection, { title: "Status", children: /* @__PURE__ */ jsx17(
              CandidatePhoneVerificationStatusLabel,
              {
                status: data.phone.phoneVerificationStatus
              }
            ) }),
            /* @__PURE__ */ jsx17(
              Button10,
              {
                clicked: () => {
                  setState("Edit" /* Edit */);
                },
                children: "Change your phone"
              }
            )
          ] }),
          state === "Send" /* Send */ && /* @__PURE__ */ jsx17(Editor, { title: "Send Phone Verification", children: /* @__PURE__ */ jsx17(
            CandidatePhoneVerificationSend,
            {
              candidateId: data.accountId,
              onDone: () => setState("Verify" /* Verify */),
              onCancel: () => setState("View" /* View */)
            }
          ) })
        ]
      }
    )
  ] }) });
};

// src/components/account/lib/AccountSetup.ts
function candidateAccountHasCompletedRequiredSetup(account) {
  return account && account.hasAgreedToTerms && account.isGdprConsented;
}

// src/components/accounts/components/__generated__/CandidateAccountImpersonateRouteQuery.graphql.ts
var node21 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "candidateCode"
    }
  ], v1 = [
    {
      "alias": "candidate",
      "args": [
        {
          "kind": "Variable",
          "name": "code",
          "variableName": "candidateCode"
        }
      ],
      "concreteType": "AccountsCandidateAccount",
      "kind": "LinkedField",
      "name": "accountCandidateAccountByCode",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "accountId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "code",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "firstName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lastName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "email",
          "storageKey": null
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__id",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "CandidateAccountImpersonateRouteQuery",
      "selections": v1,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "CandidateAccountImpersonateRouteQuery",
      "selections": v1
    },
    "params": {
      "cacheID": "25d5c28f7d2174ff5e7750a79adeeeb2",
      "id": null,
      "metadata": {},
      "name": "CandidateAccountImpersonateRouteQuery",
      "operationKind": "query",
      "text": "query CandidateAccountImpersonateRouteQuery(\n  $candidateCode: Long!\n) {\n  candidate: accountCandidateAccountByCode(code: $candidateCode) {\n    id\n    accountId\n    code\n    firstName\n    lastName\n    email\n  }\n}\n"
    }
  };
}();
node21.hash = "04ac86ef1f27b0d0d95e6cfadc031039";
var CandidateAccountImpersonateRouteQuery_graphql_default = node21;

// src/components/accounts/components/CandidateAccountImpersonate.tsx
import { useCallback as useCallback34, useState as useState18 } from "react";
import { Link as Link4 } from "react-router-dom";
import { loadQuery as loadQuery3 } from "react-relay";
import { useCopyToClipboard } from "react-use";
import { useRouteData as useRouteData2 } from "shared-lib";
import { Button as Button13 } from "shared-ui";

// ../app-core/dist/index.mjs
import {
  useCallback as useCallback14,
  useEffect as useEffect2,
  useMemo as useMemo5,
  useState as useState10
} from "react";
import { useQueryLoader } from "react-relay";
import { ChevronUpDownIcon } from "@heroicons/react/24/solid";
import { Combobox as Combobox2 } from "@headlessui/react";
import { usePreloadedQuery } from "react-relay";
import { CheckIcon } from "@heroicons/react/24/solid";
import { Combobox } from "@headlessui/react";
import { classNames } from "shared-ui";
import { Fragment as Fragment4, jsx as jsx18, jsxs as jsxs13 } from "react/jsx-runtime";
import { jsx as jsx22, jsxs as jsxs22 } from "react/jsx-runtime";
import { jsx as jsx32 } from "react/jsx-runtime";
import { Controller } from "react-hook-form";
import {
  Suspense as Suspense9,
  useCallback as useCallback22,
  useEffect as useEffect22,
  useMemo as useMemo22,
  useState as useState22
} from "react";
import { useQueryLoader as useQueryLoader2 } from "react-relay";
import { ChevronUpDownIcon as ChevronUpDownIcon2 } from "@heroicons/react/24/solid";
import { Combobox as Combobox4 } from "@headlessui/react";
import { EdSkeleton as EdSkeleton2 } from "shared-ui";
import { usePreloadedQuery as usePreloadedQuery2 } from "react-relay";
import { CheckIcon as CheckIcon2 } from "@heroicons/react/24/solid";
import { Combobox as Combobox3 } from "@headlessui/react";
import { isNotNullOrUndefined } from "shared-lib";
import { classNames as classNames2 } from "shared-ui";
import { Fragment as Fragment22, jsx as jsx42, jsxs as jsxs32 } from "react/jsx-runtime";
import { jsx as jsx52, jsxs as jsxs42 } from "react/jsx-runtime";
import { jsx as jsx62 } from "react/jsx-runtime";
import { Suspense as Suspense72 } from "react";
import { Navigate as Navigate2, Outlet as Outlet3, useLocation as useLocation2 } from "react-router-dom";
import { ErrorBoundary as ErrorBoundary2 } from "react-error-boundary";
import { UsersIcon } from "@heroicons/react/24/outline";
import { PlusIcon } from "@heroicons/react/24/solid";
import {
  Button as Button32,
  createLinkState,
  EdLink,
  PageHeading,
  TabPills
} from "shared-ui";
import { jsx as jsx72 } from "react/jsx-runtime";
import { jsx as jsx82 } from "react/jsx-runtime";
import { jsx as jsx92 } from "react/jsx-runtime";
import { ElevateCentered as ElevateCentered2 } from "shared-ui";
import { jsx as jsx102 } from "react/jsx-runtime";
import { useCallback as useCallback32 } from "react";
import { useGlobalSettings, useLogger } from "shared-lib";
import { Button as Button11, ButtonList as ButtonList5, CheckBox as CheckBox3 } from "shared-ui";
import { jsx as jsx112, jsxs as jsxs52 } from "react/jsx-runtime";
import { ErrorToast } from "shared-ui";
import { jsx as jsx122 } from "react/jsx-runtime";
import { Fragment as Fragment32, jsx as jsx132 } from "react/jsx-runtime";
import { Fragment as Fragment42, jsx as jsx142 } from "react/jsx-runtime";
import { RadioListInput } from "shared-ui";
import { jsx as jsx152 } from "react/jsx-runtime";
import { Suspense as Suspense22 } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { Outlet } from "react-router-dom";
import { jsx as jsx162 } from "react/jsx-runtime";
import { Navigate } from "react-router-dom";
import { ErrorContainer } from "shared-ui";
import { Suspense as Suspense32 } from "react";
import {
  Link as Link3,
  Outlet as Outlet2,
  useLoaderData,
  useRouteLoaderData
} from "react-router-dom";
import {
  loadQuery,
  usePreloadedQuery as usePreloadedQuery3
} from "react-relay";
import { ArrowsPointingOutIcon } from "@heroicons/react/24/outline";
import {
  DynamicBreadcrumb,
  EdButtonLink,
  EdTextLink,
  IconJustify
} from "shared-ui";
import { Fragment as Fragment5, jsx as jsx172, jsxs as jsxs62 } from "react/jsx-runtime";
import { Suspense as Suspense42, useCallback as useCallback82 } from "react";
import { loadQuery as loadQuery2 } from "react-relay";
import { Link as Link22 } from "react-router-dom";
import {
  createClientMutationId as createClientMutationId32,
  timeAgo,
  useRouteData,
  useToggle
} from "shared-lib";
import {
  BooleanActionItem,
  Button as Button22,
  DescriptionItem,
  DescriptionList,
  EdSkeleton as EdSkeleton22,
  EdTable,
  Size as Size22
} from "shared-ui";
import { useCallback as useCallback52 } from "react";
import { fetchQuery as fetchQuery2, useRelayEnvironment as useRelayEnvironment2 } from "react-relay";

// ../../node_modules/jotai/esm/vanilla.mjs
var keyCount = 0;
function atom(read, write) {
  const key = `atom${++keyCount}`;
  const config = {
    toString: () => key
  };
  if (typeof read === "function") {
    config.read = read;
  } else {
    config.init = read;
    config.read = defaultRead;
    config.write = defaultWrite;
  }
  if (write) {
    config.write = write;
  }
  return config;
}
function defaultRead(get) {
  return get(this);
}
function defaultWrite(get, set, arg) {
  return set(
    this,
    typeof arg === "function" ? arg(get(this)) : arg
  );
}
if ((import.meta.env ? import.meta.env.MODE : void 0) !== "production") {
  if (typeof globalThis.__NUMBER_OF_JOTAI_INSTANCES__ === "number") {
    ++globalThis.__NUMBER_OF_JOTAI_INSTANCES__;
  } else {
    globalThis.__NUMBER_OF_JOTAI_INSTANCES__ = 1;
  }
}

// ../app-core/dist/index.mjs
import { useLogger as useLogger6 } from "shared-lib";
import {
  createContext,
  useEffect as useEffect3,
  useState as useState32
} from "react";
import { useLogger as useLogger4, useSetNextLocation as useSetNextLocation2, emitCustomEvent } from "shared-lib";
import { useMemo as useMemo32 } from "react";

// ../../node_modules/recoil/es/index.js
import react from "react";
import reactDom from "react-dom";
function err(message) {
  const error = new Error(message);
  if (error.stack === void 0) {
    try {
      throw error;
    } catch (_) {
    }
  }
  return error;
}
var err_1 = err;
var Recoil_err = err_1;
function isPromise(p) {
  return !!p && typeof p.then === "function";
}
var Recoil_isPromise = isPromise;
function nullthrows(x, message) {
  if (x != null) {
    return x;
  }
  throw Recoil_err(message !== null && message !== void 0 ? message : "Got unexpected null or undefined");
}
var Recoil_nullthrows = nullthrows;
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var BaseLoadable = class {
  getValue() {
    throw Recoil_err("BaseLoadable");
  }
  toPromise() {
    throw Recoil_err("BaseLoadable");
  }
  valueMaybe() {
    throw Recoil_err("BaseLoadable");
  }
  valueOrThrow() {
    throw Recoil_err(`Loadable expected value, but in "${this.state}" state`);
  }
  promiseMaybe() {
    throw Recoil_err("BaseLoadable");
  }
  promiseOrThrow() {
    throw Recoil_err(`Loadable expected promise, but in "${this.state}" state`);
  }
  errorMaybe() {
    throw Recoil_err("BaseLoadable");
  }
  errorOrThrow() {
    throw Recoil_err(`Loadable expected error, but in "${this.state}" state`);
  }
  is(other) {
    return other.state === this.state && other.contents === this.contents;
  }
  map(_map) {
    throw Recoil_err("BaseLoadable");
  }
};
var ValueLoadable = class extends BaseLoadable {
  constructor(value) {
    super();
    _defineProperty(this, "state", "hasValue");
    _defineProperty(this, "contents", void 0);
    this.contents = value;
  }
  getValue() {
    return this.contents;
  }
  toPromise() {
    return Promise.resolve(this.contents);
  }
  valueMaybe() {
    return this.contents;
  }
  valueOrThrow() {
    return this.contents;
  }
  promiseMaybe() {
    return void 0;
  }
  errorMaybe() {
    return void 0;
  }
  map(map) {
    try {
      const next = map(this.contents);
      return Recoil_isPromise(next) ? loadableWithPromise(next) : isLoadable(next) ? next : loadableWithValue(next);
    } catch (e) {
      return Recoil_isPromise(e) ? (
        // If we "suspended", then try again.
        // errors and subsequent retries will be handled in 'loading' case
        // $FlowFixMe[prop-missing]
        loadableWithPromise(e.next(() => this.map(map)))
      ) : loadableWithError(e);
    }
  }
};
var ErrorLoadable = class extends BaseLoadable {
  constructor(error) {
    super();
    _defineProperty(this, "state", "hasError");
    _defineProperty(this, "contents", void 0);
    this.contents = error;
  }
  getValue() {
    throw this.contents;
  }
  toPromise() {
    return Promise.reject(this.contents);
  }
  valueMaybe() {
    return void 0;
  }
  promiseMaybe() {
    return void 0;
  }
  errorMaybe() {
    return this.contents;
  }
  errorOrThrow() {
    return this.contents;
  }
  map(_map) {
    return this;
  }
};
var LoadingLoadable = class extends BaseLoadable {
  constructor(promise) {
    super();
    _defineProperty(this, "state", "loading");
    _defineProperty(this, "contents", void 0);
    this.contents = promise;
  }
  getValue() {
    throw this.contents;
  }
  toPromise() {
    return this.contents;
  }
  valueMaybe() {
    return void 0;
  }
  promiseMaybe() {
    return this.contents;
  }
  promiseOrThrow() {
    return this.contents;
  }
  errorMaybe() {
    return void 0;
  }
  map(map) {
    return loadableWithPromise(this.contents.then((value) => {
      const next = map(value);
      if (isLoadable(next)) {
        const nextLoadable = next;
        switch (nextLoadable.state) {
          case "hasValue":
            return nextLoadable.contents;
          case "hasError":
            throw nextLoadable.contents;
          case "loading":
            return nextLoadable.contents;
        }
      }
      return next;
    }).catch((e) => {
      if (Recoil_isPromise(e)) {
        return e.then(() => this.map(map).contents);
      }
      throw e;
    }));
  }
};
function loadableWithValue(value) {
  return Object.freeze(new ValueLoadable(value));
}
function loadableWithError(error) {
  return Object.freeze(new ErrorLoadable(error));
}
function loadableWithPromise(promise) {
  return Object.freeze(new LoadingLoadable(promise));
}
function loadableLoading() {
  return Object.freeze(new LoadingLoadable(new Promise(() => {
  })));
}
function loadableAllArray(inputs) {
  return inputs.every((i) => i.state === "hasValue") ? loadableWithValue(inputs.map((i) => i.contents)) : inputs.some((i) => i.state === "hasError") ? loadableWithError(Recoil_nullthrows(inputs.find((i) => i.state === "hasError"), "Invalid loadable passed to loadableAll").contents) : loadableWithPromise(Promise.all(inputs.map((i) => i.contents)));
}
function loadableAll(inputs) {
  const unwrapedInputs = Array.isArray(inputs) ? inputs : Object.getOwnPropertyNames(inputs).map((key) => inputs[key]);
  const normalizedInputs = unwrapedInputs.map((x) => isLoadable(x) ? x : Recoil_isPromise(x) ? loadableWithPromise(x) : loadableWithValue(x));
  const output = loadableAllArray(normalizedInputs);
  return Array.isArray(inputs) ? (
    // $FlowIssue[incompatible-return]
    output
  ) : (
    // Object.getOwnPropertyNames() has consistent key ordering with ES6
    // $FlowIssue[incompatible-call]
    output.map((outputs) => Object.getOwnPropertyNames(inputs).reduce(
      // $FlowFixMe[invalid-computed-prop]
      (out, key, idx) => ({
        ...out,
        [key]: outputs[idx]
      }),
      {}
    ))
  );
}
function isLoadable(x) {
  return x instanceof BaseLoadable;
}
var LoadableStaticInterface = {
  of: (value) => Recoil_isPromise(value) ? loadableWithPromise(value) : isLoadable(value) ? value : loadableWithValue(value),
  error: (error) => loadableWithError(error),
  // $FlowIssue[incompatible-return]
  loading: () => loadableLoading(),
  // $FlowIssue[unclear-type]
  all: loadableAll,
  isLoadable
};
var Recoil_Loadable = {
  loadableWithValue,
  loadableWithError,
  loadableWithPromise,
  loadableLoading,
  loadableAll,
  isLoadable,
  RecoilLoadable: LoadableStaticInterface
};
var Recoil_Loadable_1 = Recoil_Loadable.loadableWithValue;
var Recoil_Loadable_2 = Recoil_Loadable.loadableWithError;
var Recoil_Loadable_3 = Recoil_Loadable.loadableWithPromise;
var Recoil_Loadable_4 = Recoil_Loadable.loadableLoading;
var Recoil_Loadable_5 = Recoil_Loadable.loadableAll;
var Recoil_Loadable_6 = Recoil_Loadable.isLoadable;
var Recoil_Loadable_7 = Recoil_Loadable.RecoilLoadable;
var Recoil_Loadable$1 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  loadableWithValue: Recoil_Loadable_1,
  loadableWithError: Recoil_Loadable_2,
  loadableWithPromise: Recoil_Loadable_3,
  loadableLoading: Recoil_Loadable_4,
  loadableAll: Recoil_Loadable_5,
  isLoadable: Recoil_Loadable_6,
  RecoilLoadable: Recoil_Loadable_7
});
var env = {
  RECOIL_DUPLICATE_ATOM_KEY_CHECKING_ENABLED: true,
  // Note: RECOIL_GKS_ENABLED settings will only be honored in OSS builds of Recoil
  RECOIL_GKS_ENABLED: /* @__PURE__ */ new Set(["recoil_hamt_2020", "recoil_sync_external_store", "recoil_suppress_rerender_in_callback", "recoil_memory_managament_2020"])
};
function readProcessEnvBooleanFlag(name, set) {
  var _process$env$name, _process$env$name$toL;
  const sanitizedValue = (_process$env$name = process.env[name]) === null || _process$env$name === void 0 ? void 0 : (_process$env$name$toL = _process$env$name.toLowerCase()) === null || _process$env$name$toL === void 0 ? void 0 : _process$env$name$toL.trim();
  if (sanitizedValue == null || sanitizedValue === "") {
    return;
  }
  const allowedValues = ["true", "false"];
  if (!allowedValues.includes(sanitizedValue)) {
    throw Recoil_err(`process.env.${name} value must be 'true', 'false', or empty: ${sanitizedValue}`);
  }
  set(sanitizedValue === "true");
}
function readProcessEnvStringArrayFlag(name, set) {
  var _process$env$name2;
  const sanitizedValue = (_process$env$name2 = process.env[name]) === null || _process$env$name2 === void 0 ? void 0 : _process$env$name2.trim();
  if (sanitizedValue == null || sanitizedValue === "") {
    return;
  }
  set(sanitizedValue.split(/\s*,\s*|\s+/));
}
function applyProcessEnvFlagOverrides() {
  var _process;
  if (typeof process === "undefined") {
    return;
  }
  if (((_process = process) === null || _process === void 0 ? void 0 : _process.env) == null) {
    return;
  }
  readProcessEnvBooleanFlag("RECOIL_DUPLICATE_ATOM_KEY_CHECKING_ENABLED", (value) => {
    env.RECOIL_DUPLICATE_ATOM_KEY_CHECKING_ENABLED = value;
  });
  readProcessEnvStringArrayFlag("RECOIL_GKS_ENABLED", (value) => {
    value.forEach((gk) => {
      env.RECOIL_GKS_ENABLED.add(gk);
    });
  });
}
applyProcessEnvFlagOverrides();
var Recoil_RecoilEnv = env;
function Recoil_gkx_OSS(gk) {
  return Recoil_RecoilEnv.RECOIL_GKS_ENABLED.has(gk);
}
Recoil_gkx_OSS.setPass = (gk) => {
  Recoil_RecoilEnv.RECOIL_GKS_ENABLED.add(gk);
};
Recoil_gkx_OSS.setFail = (gk) => {
  Recoil_RecoilEnv.RECOIL_GKS_ENABLED.delete(gk);
};
Recoil_gkx_OSS.clear = () => {
  Recoil_RecoilEnv.RECOIL_GKS_ENABLED.clear();
};
var Recoil_gkx = Recoil_gkx_OSS;
function recoverableViolation(message, _projectName, {
  error
} = {}) {
  if (process.env.NODE_ENV !== "production") {
    console.error(message, error);
  }
  return null;
}
var recoverableViolation_1 = recoverableViolation;
var Recoil_recoverableViolation = recoverableViolation_1;
var _createMutableSource;
var _useMutableSource;
var _useSyncExternalStore;
var createMutableSource = (
  // flowlint-next-line unclear-type:off
  (_createMutableSource = react.createMutableSource) !== null && _createMutableSource !== void 0 ? _createMutableSource : react.unstable_createMutableSource
);
var useMutableSource = (
  // flowlint-next-line unclear-type:off
  (_useMutableSource = react.useMutableSource) !== null && _useMutableSource !== void 0 ? _useMutableSource : react.unstable_useMutableSource
);
var useSyncExternalStore = (
  // flowlint-next-line unclear-type:off
  (_useSyncExternalStore = react.useSyncExternalStore) !== null && _useSyncExternalStore !== void 0 ? _useSyncExternalStore : (
    // flowlint-next-line unclear-type:off
    react.unstable_useSyncExternalStore
  )
);
var ReactRendererVersionMismatchWarnOnce = false;
function currentRendererSupportsUseSyncExternalStore() {
  var _ReactCurrentDispatch;
  const {
    ReactCurrentDispatcher,
    ReactCurrentOwner
  } = (
    /* $FlowFixMe[prop-missing] This workaround was approved as a safer mechanism
     * to detect if the current renderer supports useSyncExternalStore()
     * https://fb.workplace.com/groups/reactjs/posts/9558682330846963/ */
    react.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED
  );
  const dispatcher = (_ReactCurrentDispatch = ReactCurrentDispatcher === null || ReactCurrentDispatcher === void 0 ? void 0 : ReactCurrentDispatcher.current) !== null && _ReactCurrentDispatch !== void 0 ? _ReactCurrentDispatch : ReactCurrentOwner.currentDispatcher;
  const isUseSyncExternalStoreSupported = dispatcher.useSyncExternalStore != null;
  if (useSyncExternalStore && !isUseSyncExternalStoreSupported && !ReactRendererVersionMismatchWarnOnce) {
    ReactRendererVersionMismatchWarnOnce = true;
    Recoil_recoverableViolation("A React renderer without React 18+ API support is being used with React 18+.");
  }
  return isUseSyncExternalStoreSupported;
}
function reactMode() {
  if (Recoil_gkx("recoil_transition_support")) {
    return {
      mode: "TRANSITION_SUPPORT",
      early: true,
      concurrent: true
    };
  }
  if (Recoil_gkx("recoil_sync_external_store") && useSyncExternalStore != null) {
    return {
      mode: "SYNC_EXTERNAL_STORE",
      early: true,
      concurrent: false
    };
  }
  if (Recoil_gkx("recoil_mutable_source") && useMutableSource != null && typeof window !== "undefined" && !window.$disableRecoilValueMutableSource_TEMP_HACK_DO_NOT_USE) {
    return Recoil_gkx("recoil_suppress_rerender_in_callback") ? {
      mode: "MUTABLE_SOURCE",
      early: true,
      concurrent: true
    } : {
      mode: "MUTABLE_SOURCE",
      early: false,
      concurrent: false
    };
  }
  return Recoil_gkx("recoil_suppress_rerender_in_callback") ? {
    mode: "LEGACY",
    early: true,
    concurrent: false
  } : {
    mode: "LEGACY",
    early: false,
    concurrent: false
  };
}
function isFastRefreshEnabled() {
  return false;
}
var Recoil_ReactMode = {
  createMutableSource,
  useMutableSource,
  useSyncExternalStore,
  currentRendererSupportsUseSyncExternalStore,
  reactMode,
  isFastRefreshEnabled
};
var AbstractRecoilValue = class {
  constructor(newKey) {
    _defineProperty(this, "key", void 0);
    this.key = newKey;
  }
  toJSON() {
    return {
      key: this.key
    };
  }
};
var RecoilState = class extends AbstractRecoilValue {
};
var RecoilValueReadOnly = class extends AbstractRecoilValue {
};
function isRecoilValue(x) {
  return x instanceof RecoilState || x instanceof RecoilValueReadOnly;
}
var Recoil_RecoilValue = {
  AbstractRecoilValue,
  RecoilState,
  RecoilValueReadOnly,
  isRecoilValue
};
var Recoil_RecoilValue_1 = Recoil_RecoilValue.AbstractRecoilValue;
var Recoil_RecoilValue_2 = Recoil_RecoilValue.RecoilState;
var Recoil_RecoilValue_3 = Recoil_RecoilValue.RecoilValueReadOnly;
var Recoil_RecoilValue_4 = Recoil_RecoilValue.isRecoilValue;
var Recoil_RecoilValue$1 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  AbstractRecoilValue: Recoil_RecoilValue_1,
  RecoilState: Recoil_RecoilValue_2,
  RecoilValueReadOnly: Recoil_RecoilValue_3,
  isRecoilValue: Recoil_RecoilValue_4
});
function sprintf(format, ...args) {
  let index = 0;
  return format.replace(/%s/g, () => String(args[index++]));
}
var sprintf_1 = sprintf;
function expectationViolation(format, ...args) {
  if (process.env.NODE_ENV !== "production") {
    const message = sprintf_1.call(null, format, ...args);
    const error = new Error(message);
    error.name = "Expectation Violation";
    console.error(error);
  }
}
var expectationViolation_1 = expectationViolation;
var Recoil_expectationViolation = expectationViolation_1;
function mapIterable(iterable, callback) {
  return function* () {
    let index = 0;
    for (const value of iterable) {
      yield callback(value, index++);
    }
  }();
}
var Recoil_mapIterable = mapIterable;
var {
  isFastRefreshEnabled: isFastRefreshEnabled$1
} = Recoil_ReactMode;
var DefaultValue = class {
};
var DEFAULT_VALUE = new DefaultValue();
var nodes = /* @__PURE__ */ new Map();
var recoilValues = /* @__PURE__ */ new Map();
function recoilValuesForKeys(keys) {
  return Recoil_mapIterable(keys, (key) => Recoil_nullthrows(recoilValues.get(key)));
}
function checkForDuplicateAtomKey(key) {
  if (nodes.has(key)) {
    const message = `Duplicate atom key "${key}". This is a FATAL ERROR in
      production. But it is safe to ignore this warning if it occurred because of
      hot module replacement.`;
    if (process.env.NODE_ENV !== "production") {
      if (!isFastRefreshEnabled$1()) {
        Recoil_expectationViolation(message, "recoil");
      }
    } else {
      console.warn(message);
    }
  }
}
function registerNode(node81) {
  if (Recoil_RecoilEnv.RECOIL_DUPLICATE_ATOM_KEY_CHECKING_ENABLED) {
    checkForDuplicateAtomKey(node81.key);
  }
  nodes.set(node81.key, node81);
  const recoilValue = node81.set == null ? new Recoil_RecoilValue$1.RecoilValueReadOnly(node81.key) : new Recoil_RecoilValue$1.RecoilState(node81.key);
  recoilValues.set(node81.key, recoilValue);
  return recoilValue;
}
var NodeMissingError = class extends Error {
};
function getNode(key) {
  const node81 = nodes.get(key);
  if (node81 == null) {
    throw new NodeMissingError(`Missing definition for RecoilValue: "${key}""`);
  }
  return node81;
}
function getNodeMaybe(key) {
  return nodes.get(key);
}
var configDeletionHandlers = /* @__PURE__ */ new Map();
function deleteNodeConfigIfPossible(key) {
  var _node$shouldDeleteCon;
  if (!Recoil_gkx("recoil_memory_managament_2020")) {
    return;
  }
  const node81 = nodes.get(key);
  if (node81 !== null && node81 !== void 0 && (_node$shouldDeleteCon = node81.shouldDeleteConfigOnRelease) !== null && _node$shouldDeleteCon !== void 0 && _node$shouldDeleteCon.call(node81)) {
    var _getConfigDeletionHan;
    nodes.delete(key);
    (_getConfigDeletionHan = getConfigDeletionHandler(key)) === null || _getConfigDeletionHan === void 0 ? void 0 : _getConfigDeletionHan();
    configDeletionHandlers.delete(key);
  }
}
function setConfigDeletionHandler(key, fn) {
  if (!Recoil_gkx("recoil_memory_managament_2020")) {
    return;
  }
  if (fn === void 0) {
    configDeletionHandlers.delete(key);
  } else {
    configDeletionHandlers.set(key, fn);
  }
}
function getConfigDeletionHandler(key) {
  return configDeletionHandlers.get(key);
}
var Recoil_Node = {
  nodes,
  recoilValues,
  registerNode,
  getNode,
  getNodeMaybe,
  deleteNodeConfigIfPossible,
  setConfigDeletionHandler,
  getConfigDeletionHandler,
  recoilValuesForKeys,
  NodeMissingError,
  DefaultValue,
  DEFAULT_VALUE
};
function enqueueExecution(s, f) {
  f();
}
var Recoil_Queue = {
  enqueueExecution
};
function createCommonjsModule(fn, module) {
  return module = { exports: {} }, fn(module, module.exports), module.exports;
}
var hamt_1 = createCommonjsModule(function(module) {
  var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
  } : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  };
  var hamt = {};
  var SIZE = 5;
  var BUCKET_SIZE = Math.pow(2, SIZE);
  var MASK = BUCKET_SIZE - 1;
  var MAX_INDEX_NODE = BUCKET_SIZE / 2;
  var MIN_ARRAY_NODE = BUCKET_SIZE / 4;
  var nothing = {};
  var constant = function constant2(x) {
    return function() {
      return x;
    };
  };
  var hash = hamt.hash = function(str) {
    var type = typeof str === "undefined" ? "undefined" : _typeof(str);
    if (type === "number")
      return str;
    if (type !== "string")
      str += "";
    var hash2 = 0;
    for (var i = 0, len = str.length; i < len; ++i) {
      var c = str.charCodeAt(i);
      hash2 = (hash2 << 5) - hash2 + c | 0;
    }
    return hash2;
  };
  var popcount = function popcount2(x) {
    x -= x >> 1 & 1431655765;
    x = (x & 858993459) + (x >> 2 & 858993459);
    x = x + (x >> 4) & 252645135;
    x += x >> 8;
    x += x >> 16;
    return x & 127;
  };
  var hashFragment = function hashFragment2(shift, h) {
    return h >>> shift & MASK;
  };
  var toBitmap = function toBitmap2(x) {
    return 1 << x;
  };
  var fromBitmap = function fromBitmap2(bitmap, bit) {
    return popcount(bitmap & bit - 1);
  };
  var arrayUpdate = function arrayUpdate2(mutate2, at, v, arr) {
    var out = arr;
    if (!mutate2) {
      var len = arr.length;
      out = new Array(len);
      for (var i = 0; i < len; ++i) {
        out[i] = arr[i];
      }
    }
    out[at] = v;
    return out;
  };
  var arraySpliceOut = function arraySpliceOut2(mutate2, at, arr) {
    var newLen = arr.length - 1;
    var i = 0;
    var g = 0;
    var out = arr;
    if (mutate2) {
      i = g = at;
    } else {
      out = new Array(newLen);
      while (i < at) {
        out[g++] = arr[i++];
      }
    }
    ++i;
    while (i <= newLen) {
      out[g++] = arr[i++];
    }
    if (mutate2) {
      out.length = newLen;
    }
    return out;
  };
  var arraySpliceIn = function arraySpliceIn2(mutate2, at, v, arr) {
    var len = arr.length;
    if (mutate2) {
      var _i = len;
      while (_i >= at) {
        arr[_i--] = arr[_i];
      }
      arr[at] = v;
      return arr;
    }
    var i = 0, g = 0;
    var out = new Array(len + 1);
    while (i < at) {
      out[g++] = arr[i++];
    }
    out[at] = v;
    while (i < len) {
      out[++g] = arr[i++];
    }
    return out;
  };
  var LEAF = 1;
  var COLLISION = 2;
  var INDEX = 3;
  var ARRAY = 4;
  var empty = {
    __hamt_isEmpty: true
  };
  var isEmptyNode = function isEmptyNode2(x) {
    return x === empty || x && x.__hamt_isEmpty;
  };
  var Leaf = function Leaf2(edit, hash2, key, value) {
    return {
      type: LEAF,
      edit,
      hash: hash2,
      key,
      value,
      _modify: Leaf__modify
    };
  };
  var Collision = function Collision2(edit, hash2, children) {
    return {
      type: COLLISION,
      edit,
      hash: hash2,
      children,
      _modify: Collision__modify
    };
  };
  var IndexedNode = function IndexedNode2(edit, mask, children) {
    return {
      type: INDEX,
      edit,
      mask,
      children,
      _modify: IndexedNode__modify
    };
  };
  var ArrayNode = function ArrayNode2(edit, size, children) {
    return {
      type: ARRAY,
      edit,
      size,
      children,
      _modify: ArrayNode__modify
    };
  };
  var isLeaf = function isLeaf2(node81) {
    return node81 === empty || node81.type === LEAF || node81.type === COLLISION;
  };
  var expand = function expand2(edit, frag, child, bitmap, subNodes) {
    var arr = [];
    var bit = bitmap;
    var count2 = 0;
    for (var i = 0; bit; ++i) {
      if (bit & 1)
        arr[i] = subNodes[count2++];
      bit >>>= 1;
    }
    arr[frag] = child;
    return ArrayNode(edit, count2 + 1, arr);
  };
  var pack = function pack2(edit, count2, removed, elements) {
    var children = new Array(count2 - 1);
    var g = 0;
    var bitmap = 0;
    for (var i = 0, len = elements.length; i < len; ++i) {
      if (i !== removed) {
        var elem = elements[i];
        if (elem && !isEmptyNode(elem)) {
          children[g++] = elem;
          bitmap |= 1 << i;
        }
      }
    }
    return IndexedNode(edit, bitmap, children);
  };
  var mergeLeaves = function mergeLeaves2(edit, shift, h1, n1, h2, n2) {
    if (h1 === h2)
      return Collision(edit, h1, [n2, n1]);
    var subH1 = hashFragment(shift, h1);
    var subH2 = hashFragment(shift, h2);
    return IndexedNode(edit, toBitmap(subH1) | toBitmap(subH2), subH1 === subH2 ? [mergeLeaves2(edit, shift + SIZE, h1, n1, h2, n2)] : subH1 < subH2 ? [n1, n2] : [n2, n1]);
  };
  var updateCollisionList = function updateCollisionList2(mutate2, edit, keyEq, h, list, f, k, size) {
    var len = list.length;
    for (var i = 0; i < len; ++i) {
      var child = list[i];
      if (keyEq(k, child.key)) {
        var value = child.value;
        var _newValue = f(value);
        if (_newValue === value)
          return list;
        if (_newValue === nothing) {
          --size.value;
          return arraySpliceOut(mutate2, i, list);
        }
        return arrayUpdate(mutate2, i, Leaf(edit, h, k, _newValue), list);
      }
    }
    var newValue = f();
    if (newValue === nothing)
      return list;
    ++size.value;
    return arrayUpdate(mutate2, len, Leaf(edit, h, k, newValue), list);
  };
  var canEditNode = function canEditNode2(edit, node81) {
    return edit === node81.edit;
  };
  var Leaf__modify = function Leaf__modify2(edit, keyEq, shift, f, h, k, size) {
    if (keyEq(k, this.key)) {
      var _v = f(this.value);
      if (_v === this.value)
        return this;
      else if (_v === nothing) {
        --size.value;
        return empty;
      }
      if (canEditNode(edit, this)) {
        this.value = _v;
        return this;
      }
      return Leaf(edit, h, k, _v);
    }
    var v = f();
    if (v === nothing)
      return this;
    ++size.value;
    return mergeLeaves(edit, shift, this.hash, this, h, Leaf(edit, h, k, v));
  };
  var Collision__modify = function Collision__modify2(edit, keyEq, shift, f, h, k, size) {
    if (h === this.hash) {
      var canEdit = canEditNode(edit, this);
      var list = updateCollisionList(canEdit, edit, keyEq, this.hash, this.children, f, k, size);
      if (list === this.children)
        return this;
      return list.length > 1 ? Collision(edit, this.hash, list) : list[0];
    }
    var v = f();
    if (v === nothing)
      return this;
    ++size.value;
    return mergeLeaves(edit, shift, this.hash, this, h, Leaf(edit, h, k, v));
  };
  var IndexedNode__modify = function IndexedNode__modify2(edit, keyEq, shift, f, h, k, size) {
    var mask = this.mask;
    var children = this.children;
    var frag = hashFragment(shift, h);
    var bit = toBitmap(frag);
    var indx = fromBitmap(mask, bit);
    var exists = mask & bit;
    var current = exists ? children[indx] : empty;
    var child = current._modify(edit, keyEq, shift + SIZE, f, h, k, size);
    if (current === child)
      return this;
    var canEdit = canEditNode(edit, this);
    var bitmap = mask;
    var newChildren = void 0;
    if (exists && isEmptyNode(child)) {
      bitmap &= ~bit;
      if (!bitmap)
        return empty;
      if (children.length <= 2 && isLeaf(children[indx ^ 1]))
        return children[indx ^ 1];
      newChildren = arraySpliceOut(canEdit, indx, children);
    } else if (!exists && !isEmptyNode(child)) {
      if (children.length >= MAX_INDEX_NODE)
        return expand(edit, frag, child, mask, children);
      bitmap |= bit;
      newChildren = arraySpliceIn(canEdit, indx, child, children);
    } else {
      newChildren = arrayUpdate(canEdit, indx, child, children);
    }
    if (canEdit) {
      this.mask = bitmap;
      this.children = newChildren;
      return this;
    }
    return IndexedNode(edit, bitmap, newChildren);
  };
  var ArrayNode__modify = function ArrayNode__modify2(edit, keyEq, shift, f, h, k, size) {
    var count2 = this.size;
    var children = this.children;
    var frag = hashFragment(shift, h);
    var child = children[frag];
    var newChild = (child || empty)._modify(edit, keyEq, shift + SIZE, f, h, k, size);
    if (child === newChild)
      return this;
    var canEdit = canEditNode(edit, this);
    var newChildren = void 0;
    if (isEmptyNode(child) && !isEmptyNode(newChild)) {
      ++count2;
      newChildren = arrayUpdate(canEdit, frag, newChild, children);
    } else if (!isEmptyNode(child) && isEmptyNode(newChild)) {
      --count2;
      if (count2 <= MIN_ARRAY_NODE)
        return pack(edit, count2, frag, children);
      newChildren = arrayUpdate(canEdit, frag, empty, children);
    } else {
      newChildren = arrayUpdate(canEdit, frag, newChild, children);
    }
    if (canEdit) {
      this.size = count2;
      this.children = newChildren;
      return this;
    }
    return ArrayNode(edit, count2, newChildren);
  };
  empty._modify = function(edit, keyEq, shift, f, h, k, size) {
    var v = f();
    if (v === nothing)
      return empty;
    ++size.value;
    return Leaf(edit, h, k, v);
  };
  function Map2(editable, edit, config, root2, size) {
    this._editable = editable;
    this._edit = edit;
    this._config = config;
    this._root = root2;
    this._size = size;
  }
  Map2.prototype.setTree = function(newRoot, newSize) {
    if (this._editable) {
      this._root = newRoot;
      this._size = newSize;
      return this;
    }
    return newRoot === this._root ? this : new Map2(this._editable, this._edit, this._config, newRoot, newSize);
  };
  var tryGetHash = hamt.tryGetHash = function(alt, hash2, key, map) {
    var node81 = map._root;
    var shift = 0;
    var keyEq = map._config.keyEq;
    while (true) {
      switch (node81.type) {
        case LEAF: {
          return keyEq(key, node81.key) ? node81.value : alt;
        }
        case COLLISION: {
          if (hash2 === node81.hash) {
            var children = node81.children;
            for (var i = 0, len = children.length; i < len; ++i) {
              var child = children[i];
              if (keyEq(key, child.key))
                return child.value;
            }
          }
          return alt;
        }
        case INDEX: {
          var frag = hashFragment(shift, hash2);
          var bit = toBitmap(frag);
          if (node81.mask & bit) {
            node81 = node81.children[fromBitmap(node81.mask, bit)];
            shift += SIZE;
            break;
          }
          return alt;
        }
        case ARRAY: {
          node81 = node81.children[hashFragment(shift, hash2)];
          if (node81) {
            shift += SIZE;
            break;
          }
          return alt;
        }
        default:
          return alt;
      }
    }
  };
  Map2.prototype.tryGetHash = function(alt, hash2, key) {
    return tryGetHash(alt, hash2, key, this);
  };
  var tryGet = hamt.tryGet = function(alt, key, map) {
    return tryGetHash(alt, map._config.hash(key), key, map);
  };
  Map2.prototype.tryGet = function(alt, key) {
    return tryGet(alt, key, this);
  };
  var getHash = hamt.getHash = function(hash2, key, map) {
    return tryGetHash(void 0, hash2, key, map);
  };
  Map2.prototype.getHash = function(hash2, key) {
    return getHash(hash2, key, this);
  };
  var get = hamt.get = function(key, map) {
    return tryGetHash(void 0, map._config.hash(key), key, map);
  };
  Map2.prototype.get = function(key, alt) {
    return tryGet(alt, key, this);
  };
  var hasHash = hamt.has = function(hash2, key, map) {
    return tryGetHash(nothing, hash2, key, map) !== nothing;
  };
  Map2.prototype.hasHash = function(hash2, key) {
    return hasHash(hash2, key, this);
  };
  var has = hamt.has = function(key, map) {
    return hasHash(map._config.hash(key), key, map);
  };
  Map2.prototype.has = function(key) {
    return has(key, this);
  };
  var defKeyCompare = function defKeyCompare2(x, y) {
    return x === y;
  };
  hamt.make = function(config) {
    return new Map2(0, 0, {
      keyEq: config && config.keyEq || defKeyCompare,
      hash: config && config.hash || hash
    }, empty, 0);
  };
  hamt.empty = hamt.make();
  var isEmpty = hamt.isEmpty = function(map) {
    return map && !!isEmptyNode(map._root);
  };
  Map2.prototype.isEmpty = function() {
    return isEmpty(this);
  };
  var modifyHash = hamt.modifyHash = function(f, hash2, key, map) {
    var size = {
      value: map._size
    };
    var newRoot = map._root._modify(map._editable ? map._edit : NaN, map._config.keyEq, 0, f, hash2, key, size);
    return map.setTree(newRoot, size.value);
  };
  Map2.prototype.modifyHash = function(hash2, key, f) {
    return modifyHash(f, hash2, key, this);
  };
  var modify = hamt.modify = function(f, key, map) {
    return modifyHash(f, map._config.hash(key), key, map);
  };
  Map2.prototype.modify = function(key, f) {
    return modify(f, key, this);
  };
  var setHash = hamt.setHash = function(hash2, key, value, map) {
    return modifyHash(constant(value), hash2, key, map);
  };
  Map2.prototype.setHash = function(hash2, key, value) {
    return setHash(hash2, key, value, this);
  };
  var set = hamt.set = function(key, value, map) {
    return setHash(map._config.hash(key), key, value, map);
  };
  Map2.prototype.set = function(key, value) {
    return set(key, value, this);
  };
  var del = constant(nothing);
  var removeHash = hamt.removeHash = function(hash2, key, map) {
    return modifyHash(del, hash2, key, map);
  };
  Map2.prototype.removeHash = Map2.prototype.deleteHash = function(hash2, key) {
    return removeHash(hash2, key, this);
  };
  var remove = hamt.remove = function(key, map) {
    return removeHash(map._config.hash(key), key, map);
  };
  Map2.prototype.remove = Map2.prototype.delete = function(key) {
    return remove(key, this);
  };
  var beginMutation = hamt.beginMutation = function(map) {
    return new Map2(map._editable + 1, map._edit + 1, map._config, map._root, map._size);
  };
  Map2.prototype.beginMutation = function() {
    return beginMutation(this);
  };
  var endMutation = hamt.endMutation = function(map) {
    map._editable = map._editable && map._editable - 1;
    return map;
  };
  Map2.prototype.endMutation = function() {
    return endMutation(this);
  };
  var mutate = hamt.mutate = function(f, map) {
    var transient = beginMutation(map);
    f(transient);
    return endMutation(transient);
  };
  Map2.prototype.mutate = function(f) {
    return mutate(f, this);
  };
  var appk = function appk2(k) {
    return k && lazyVisitChildren(k[0], k[1], k[2], k[3], k[4]);
  };
  var lazyVisitChildren = function lazyVisitChildren2(len, children, i, f, k) {
    while (i < len) {
      var child = children[i++];
      if (child && !isEmptyNode(child))
        return lazyVisit(child, f, [len, children, i, f, k]);
    }
    return appk(k);
  };
  var lazyVisit = function lazyVisit2(node81, f, k) {
    switch (node81.type) {
      case LEAF:
        return {
          value: f(node81),
          rest: k
        };
      case COLLISION:
      case ARRAY:
      case INDEX:
        var children = node81.children;
        return lazyVisitChildren(children.length, children, 0, f, k);
      default:
        return appk(k);
    }
  };
  var DONE = {
    done: true
  };
  function MapIterator(v) {
    this.v = v;
  }
  MapIterator.prototype.next = function() {
    if (!this.v)
      return DONE;
    var v0 = this.v;
    this.v = appk(v0.rest);
    return v0;
  };
  MapIterator.prototype[Symbol.iterator] = function() {
    return this;
  };
  var visit = function visit2(map, f) {
    return new MapIterator(lazyVisit(map._root, f));
  };
  var buildPairs = function buildPairs2(x) {
    return [x.key, x.value];
  };
  var entries = hamt.entries = function(map) {
    return visit(map, buildPairs);
  };
  Map2.prototype.entries = Map2.prototype[Symbol.iterator] = function() {
    return entries(this);
  };
  var buildKeys = function buildKeys2(x) {
    return x.key;
  };
  var keys = hamt.keys = function(map) {
    return visit(map, buildKeys);
  };
  Map2.prototype.keys = function() {
    return keys(this);
  };
  var buildValues = function buildValues2(x) {
    return x.value;
  };
  var values = hamt.values = Map2.prototype.values = function(map) {
    return visit(map, buildValues);
  };
  Map2.prototype.values = function() {
    return values(this);
  };
  var fold = hamt.fold = function(f, z, m) {
    var root2 = m._root;
    if (root2.type === LEAF)
      return f(z, root2.value, root2.key);
    var toVisit = [root2.children];
    var children = void 0;
    while (children = toVisit.pop()) {
      for (var i = 0, len = children.length; i < len; ) {
        var child = children[i++];
        if (child && child.type) {
          if (child.type === LEAF)
            z = f(z, child.value, child.key);
          else
            toVisit.push(child.children);
        }
      }
    }
    return z;
  };
  Map2.prototype.fold = function(f, z) {
    return fold(f, z, this);
  };
  var forEach = hamt.forEach = function(f, map) {
    return fold(function(_, value, key) {
      return f(value, key, map);
    }, null, map);
  };
  Map2.prototype.forEach = function(f) {
    return forEach(f, this);
  };
  var count = hamt.count = function(map) {
    return map._size;
  };
  Map2.prototype.count = function() {
    return count(this);
  };
  Object.defineProperty(Map2.prototype, "size", {
    get: Map2.prototype.count
  });
  if (module.exports) {
    module.exports = hamt;
  } else {
    (void 0).hamt = hamt;
  }
});
var BuiltInMap = class {
  constructor(existing) {
    _defineProperty(this, "_map", void 0);
    this._map = new Map(existing === null || existing === void 0 ? void 0 : existing.entries());
  }
  keys() {
    return this._map.keys();
  }
  entries() {
    return this._map.entries();
  }
  get(k) {
    return this._map.get(k);
  }
  has(k) {
    return this._map.has(k);
  }
  set(k, v) {
    this._map.set(k, v);
    return this;
  }
  delete(k) {
    this._map.delete(k);
    return this;
  }
  clone() {
    return persistentMap(this);
  }
  toMap() {
    return new Map(this._map);
  }
};
var HashArrayMappedTrieMap = class _HashArrayMappedTrieMap {
  // Because hamt.empty is not a function there is no way to introduce type
  // parameters on it, so empty is typed as HAMTPlusMap<string, mixed>.
  // $FlowIssue
  constructor(existing) {
    _defineProperty(this, "_hamt", hamt_1.empty.beginMutation());
    if (existing instanceof _HashArrayMappedTrieMap) {
      const h = existing._hamt.endMutation();
      existing._hamt = h.beginMutation();
      this._hamt = h.beginMutation();
    } else if (existing) {
      for (const [k, v] of existing.entries()) {
        this._hamt.set(k, v);
      }
    }
  }
  keys() {
    return this._hamt.keys();
  }
  entries() {
    return this._hamt.entries();
  }
  get(k) {
    return this._hamt.get(k);
  }
  has(k) {
    return this._hamt.has(k);
  }
  set(k, v) {
    this._hamt.set(k, v);
    return this;
  }
  delete(k) {
    this._hamt.delete(k);
    return this;
  }
  clone() {
    return persistentMap(this);
  }
  toMap() {
    return new Map(this._hamt);
  }
};
function persistentMap(existing) {
  if (Recoil_gkx("recoil_hamt_2020")) {
    return new HashArrayMappedTrieMap(existing);
  } else {
    return new BuiltInMap(existing);
  }
}
var Recoil_PersistentMap = {
  persistentMap
};
var Recoil_PersistentMap_1 = Recoil_PersistentMap.persistentMap;
var Recoil_PersistentMap$1 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  persistentMap: Recoil_PersistentMap_1
});
function differenceSets(set, ...setsWithValuesToRemove) {
  const ret = /* @__PURE__ */ new Set();
  FIRST:
    for (const value of set) {
      for (const otherSet of setsWithValuesToRemove) {
        if (otherSet.has(value)) {
          continue FIRST;
        }
      }
      ret.add(value);
    }
  return ret;
}
var Recoil_differenceSets = differenceSets;
function mapMap(map, callback) {
  const result = /* @__PURE__ */ new Map();
  map.forEach((value, key) => {
    result.set(key, callback(value, key));
  });
  return result;
}
var Recoil_mapMap = mapMap;
function makeGraph() {
  return {
    nodeDeps: /* @__PURE__ */ new Map(),
    nodeToNodeSubscriptions: /* @__PURE__ */ new Map()
  };
}
function cloneGraph(graph2) {
  return {
    nodeDeps: Recoil_mapMap(graph2.nodeDeps, (s) => new Set(s)),
    nodeToNodeSubscriptions: Recoil_mapMap(graph2.nodeToNodeSubscriptions, (s) => new Set(s))
  };
}
function mergeDepsIntoGraph(key, newDeps, graph2, olderGraph) {
  const {
    nodeDeps,
    nodeToNodeSubscriptions
  } = graph2;
  const oldDeps = nodeDeps.get(key);
  if (oldDeps && olderGraph && oldDeps !== olderGraph.nodeDeps.get(key)) {
    return;
  }
  nodeDeps.set(key, newDeps);
  const addedDeps = oldDeps == null ? newDeps : Recoil_differenceSets(newDeps, oldDeps);
  for (const dep of addedDeps) {
    if (!nodeToNodeSubscriptions.has(dep)) {
      nodeToNodeSubscriptions.set(dep, /* @__PURE__ */ new Set());
    }
    const existing = Recoil_nullthrows(nodeToNodeSubscriptions.get(dep));
    existing.add(key);
  }
  if (oldDeps) {
    const removedDeps = Recoil_differenceSets(oldDeps, newDeps);
    for (const dep of removedDeps) {
      if (!nodeToNodeSubscriptions.has(dep)) {
        return;
      }
      const existing = Recoil_nullthrows(nodeToNodeSubscriptions.get(dep));
      existing.delete(key);
      if (existing.size === 0) {
        nodeToNodeSubscriptions.delete(dep);
      }
    }
  }
}
function saveDepsToStore(key, deps, store, version) {
  var _storeState$nextTree, _storeState$previousT, _storeState$previousT2, _storeState$previousT3;
  const storeState = store.getState();
  if (!(version === storeState.currentTree.version || version === ((_storeState$nextTree = storeState.nextTree) === null || _storeState$nextTree === void 0 ? void 0 : _storeState$nextTree.version) || version === ((_storeState$previousT = storeState.previousTree) === null || _storeState$previousT === void 0 ? void 0 : _storeState$previousT.version))) {
    Recoil_recoverableViolation("Tried to save dependencies to a discarded tree");
  }
  const graph2 = store.getGraph(version);
  mergeDepsIntoGraph(key, deps, graph2);
  if (version === ((_storeState$previousT2 = storeState.previousTree) === null || _storeState$previousT2 === void 0 ? void 0 : _storeState$previousT2.version)) {
    const currentGraph = store.getGraph(storeState.currentTree.version);
    mergeDepsIntoGraph(key, deps, currentGraph, graph2);
  }
  if (version === ((_storeState$previousT3 = storeState.previousTree) === null || _storeState$previousT3 === void 0 ? void 0 : _storeState$previousT3.version) || version === storeState.currentTree.version) {
    var _storeState$nextTree2;
    const nextVersion = (_storeState$nextTree2 = storeState.nextTree) === null || _storeState$nextTree2 === void 0 ? void 0 : _storeState$nextTree2.version;
    if (nextVersion !== void 0) {
      const nextGraph = store.getGraph(nextVersion);
      mergeDepsIntoGraph(key, deps, nextGraph, graph2);
    }
  }
}
var Recoil_Graph = {
  cloneGraph,
  graph: makeGraph,
  saveDepsToStore
};
var nextTreeStateVersion = 0;
var getNextTreeStateVersion = () => nextTreeStateVersion++;
var nextStoreID = 0;
var getNextStoreID = () => nextStoreID++;
var nextComponentID = 0;
var getNextComponentID = () => nextComponentID++;
var Recoil_Keys = {
  getNextTreeStateVersion,
  getNextStoreID,
  getNextComponentID
};
var {
  persistentMap: persistentMap$1
} = Recoil_PersistentMap$1;
var {
  graph
} = Recoil_Graph;
var {
  getNextTreeStateVersion: getNextTreeStateVersion$1
} = Recoil_Keys;
function makeEmptyTreeState() {
  const version = getNextTreeStateVersion$1();
  return {
    version,
    stateID: version,
    transactionMetadata: {},
    dirtyAtoms: /* @__PURE__ */ new Set(),
    atomValues: persistentMap$1(),
    nonvalidatedAtoms: persistentMap$1()
  };
}
function makeEmptyStoreState() {
  const currentTree = makeEmptyTreeState();
  return {
    currentTree,
    nextTree: null,
    previousTree: null,
    commitDepth: 0,
    knownAtoms: /* @__PURE__ */ new Set(),
    knownSelectors: /* @__PURE__ */ new Set(),
    transactionSubscriptions: /* @__PURE__ */ new Map(),
    nodeTransactionSubscriptions: /* @__PURE__ */ new Map(),
    nodeToComponentSubscriptions: /* @__PURE__ */ new Map(),
    queuedComponentCallbacks_DEPRECATED: [],
    suspendedComponentResolvers: /* @__PURE__ */ new Set(),
    graphsByVersion: (/* @__PURE__ */ new Map()).set(currentTree.version, graph()),
    retention: {
      referenceCounts: /* @__PURE__ */ new Map(),
      nodesRetainedByZone: /* @__PURE__ */ new Map(),
      retainablesToCheckForRelease: /* @__PURE__ */ new Set()
    },
    nodeCleanupFunctions: /* @__PURE__ */ new Map()
  };
}
var Recoil_State = {
  makeEmptyTreeState,
  makeEmptyStoreState,
  getNextTreeStateVersion: getNextTreeStateVersion$1
};
var RetentionZone = class {
};
function retentionZone() {
  return new RetentionZone();
}
var Recoil_RetentionZone = {
  RetentionZone,
  retentionZone
};
function setByAddingToSet(set, v) {
  const next = new Set(set);
  next.add(v);
  return next;
}
function setByDeletingFromSet(set, v) {
  const next = new Set(set);
  next.delete(v);
  return next;
}
function mapBySettingInMap(map, k, v) {
  const next = new Map(map);
  next.set(k, v);
  return next;
}
function mapByUpdatingInMap(map, k, updater) {
  const next = new Map(map);
  next.set(k, updater(next.get(k)));
  return next;
}
function mapByDeletingFromMap(map, k) {
  const next = new Map(map);
  next.delete(k);
  return next;
}
function mapByDeletingMultipleFromMap(map, ks) {
  const next = new Map(map);
  ks.forEach((k) => next.delete(k));
  return next;
}
var Recoil_CopyOnWrite = {
  setByAddingToSet,
  setByDeletingFromSet,
  mapBySettingInMap,
  mapByUpdatingInMap,
  mapByDeletingFromMap,
  mapByDeletingMultipleFromMap
};
function* filterIterable(iterable, predicate) {
  let index = 0;
  for (const value of iterable) {
    if (predicate(value, index++)) {
      yield value;
    }
  }
}
var Recoil_filterIterable = filterIterable;
function lazyProxy(base, factories) {
  const proxy = new Proxy(base, {
    // Compute and cache lazy property if not already done.
    get: (target, prop) => {
      if (!(prop in target) && prop in factories) {
        target[prop] = factories[prop]();
      }
      return target[prop];
    },
    // This method allows user to iterate keys as normal
    ownKeys: (target) => {
      return Object.keys(target);
    }
  });
  return proxy;
}
var Recoil_lazyProxy = lazyProxy;
var {
  getNode: getNode$1,
  getNodeMaybe: getNodeMaybe$1,
  recoilValuesForKeys: recoilValuesForKeys$1
} = Recoil_Node;
var {
  RetentionZone: RetentionZone$1
} = Recoil_RetentionZone;
var {
  setByAddingToSet: setByAddingToSet$1
} = Recoil_CopyOnWrite;
var emptySet = Object.freeze(/* @__PURE__ */ new Set());
var ReadOnlyRecoilValueError = class extends Error {
};
function initializeRetentionForNode(store, nodeKey, retainedBy) {
  if (!Recoil_gkx("recoil_memory_managament_2020")) {
    return () => void 0;
  }
  const {
    nodesRetainedByZone: nodesRetainedByZone2
  } = store.getState().retention;
  function addToZone(zone) {
    let set = nodesRetainedByZone2.get(zone);
    if (!set) {
      nodesRetainedByZone2.set(zone, set = /* @__PURE__ */ new Set());
    }
    set.add(nodeKey);
  }
  if (retainedBy instanceof RetentionZone$1) {
    addToZone(retainedBy);
  } else if (Array.isArray(retainedBy)) {
    for (const zone of retainedBy) {
      addToZone(zone);
    }
  }
  return () => {
    if (!Recoil_gkx("recoil_memory_managament_2020")) {
      return;
    }
    const {
      retention
    } = store.getState();
    function deleteFromZone(zone) {
      const set = retention.nodesRetainedByZone.get(zone);
      set === null || set === void 0 ? void 0 : set.delete(nodeKey);
      if (set && set.size === 0) {
        retention.nodesRetainedByZone.delete(zone);
      }
    }
    if (retainedBy instanceof RetentionZone$1) {
      deleteFromZone(retainedBy);
    } else if (Array.isArray(retainedBy)) {
      for (const zone of retainedBy) {
        deleteFromZone(zone);
      }
    }
  };
}
function initializeNodeIfNewToStore(store, treeState, key, trigger) {
  const storeState = store.getState();
  if (storeState.nodeCleanupFunctions.has(key)) {
    return;
  }
  const node81 = getNode$1(key);
  const retentionCleanup = initializeRetentionForNode(store, key, node81.retainedBy);
  const nodeCleanup = node81.init(store, treeState, trigger);
  storeState.nodeCleanupFunctions.set(key, () => {
    nodeCleanup();
    retentionCleanup();
  });
}
function initializeNode(store, key, trigger) {
  initializeNodeIfNewToStore(store, store.getState().currentTree, key, trigger);
}
function cleanUpNode(store, key) {
  var _state$nodeCleanupFun;
  const state = store.getState();
  (_state$nodeCleanupFun = state.nodeCleanupFunctions.get(key)) === null || _state$nodeCleanupFun === void 0 ? void 0 : _state$nodeCleanupFun();
  state.nodeCleanupFunctions.delete(key);
}
function getNodeLoadable(store, state, key) {
  initializeNodeIfNewToStore(store, state, key, "get");
  return getNode$1(key).get(store, state);
}
function peekNodeLoadable(store, state, key) {
  return getNode$1(key).peek(store, state);
}
function setUnvalidatedAtomValue_DEPRECATED(state, key, newValue) {
  var _node$invalidate;
  const node81 = getNodeMaybe$1(key);
  node81 === null || node81 === void 0 ? void 0 : (_node$invalidate = node81.invalidate) === null || _node$invalidate === void 0 ? void 0 : _node$invalidate.call(node81, state);
  return {
    ...state,
    atomValues: state.atomValues.clone().delete(key),
    nonvalidatedAtoms: state.nonvalidatedAtoms.clone().set(key, newValue),
    dirtyAtoms: setByAddingToSet$1(state.dirtyAtoms, key)
  };
}
function setNodeValue(store, state, key, newValue) {
  const node81 = getNode$1(key);
  if (node81.set == null) {
    throw new ReadOnlyRecoilValueError(`Attempt to set read-only RecoilValue: ${key}`);
  }
  const set = node81.set;
  initializeNodeIfNewToStore(store, state, key, "set");
  return set(store, state, newValue);
}
function peekNodeInfo(store, state, key) {
  const storeState = store.getState();
  const graph2 = store.getGraph(state.version);
  const type = getNode$1(key).nodeType;
  return Recoil_lazyProxy({
    type
  }, {
    // $FlowFixMe[underconstrained-implicit-instantiation]
    loadable: () => peekNodeLoadable(store, state, key),
    isActive: () => storeState.knownAtoms.has(key) || storeState.knownSelectors.has(key),
    isSet: () => type === "selector" ? false : state.atomValues.has(key),
    isModified: () => state.dirtyAtoms.has(key),
    // Report current dependencies.  If the node hasn't been evaluated, then
    // dependencies may be missing based on the current state.
    deps: () => {
      var _graph$nodeDeps$get;
      return recoilValuesForKeys$1((_graph$nodeDeps$get = graph2.nodeDeps.get(key)) !== null && _graph$nodeDeps$get !== void 0 ? _graph$nodeDeps$get : []);
    },
    // Reports all "current" subscribers.  Evaluating other nodes or
    // previous in-progress async evaluations may introduce new subscribers.
    subscribers: () => {
      var _storeState$nodeToCom, _storeState$nodeToCom2;
      return {
        nodes: recoilValuesForKeys$1(Recoil_filterIterable(getDownstreamNodes(store, state, /* @__PURE__ */ new Set([key])), (nodeKey) => nodeKey !== key)),
        components: Recoil_mapIterable((_storeState$nodeToCom = (_storeState$nodeToCom2 = storeState.nodeToComponentSubscriptions.get(key)) === null || _storeState$nodeToCom2 === void 0 ? void 0 : _storeState$nodeToCom2.values()) !== null && _storeState$nodeToCom !== void 0 ? _storeState$nodeToCom : [], ([name]) => ({
          name
        }))
      };
    }
  });
}
function getDownstreamNodes(store, state, keys) {
  const visitedNodes = /* @__PURE__ */ new Set();
  const visitingNodes = Array.from(keys);
  const graph2 = store.getGraph(state.version);
  for (let key = visitingNodes.pop(); key; key = visitingNodes.pop()) {
    var _graph$nodeToNodeSubs;
    visitedNodes.add(key);
    const subscribedNodes = (_graph$nodeToNodeSubs = graph2.nodeToNodeSubscriptions.get(key)) !== null && _graph$nodeToNodeSubs !== void 0 ? _graph$nodeToNodeSubs : emptySet;
    for (const downstreamNode of subscribedNodes) {
      if (!visitedNodes.has(downstreamNode)) {
        visitingNodes.push(downstreamNode);
      }
    }
  }
  return visitedNodes;
}
var Recoil_FunctionalCore = {
  getNodeLoadable,
  peekNodeLoadable,
  setNodeValue,
  initializeNode,
  cleanUpNode,
  setUnvalidatedAtomValue_DEPRECATED,
  peekNodeInfo,
  getDownstreamNodes
};
var _invalidateMemoizedSnapshot = null;
function setInvalidateMemoizedSnapshot(invalidate) {
  _invalidateMemoizedSnapshot = invalidate;
}
function invalidateMemoizedSnapshot() {
  var _invalidateMemoizedSn;
  (_invalidateMemoizedSn = _invalidateMemoizedSnapshot) === null || _invalidateMemoizedSn === void 0 ? void 0 : _invalidateMemoizedSn();
}
var Recoil_SnapshotCache = {
  setInvalidateMemoizedSnapshot,
  invalidateMemoizedSnapshot
};
var {
  getDownstreamNodes: getDownstreamNodes$1,
  getNodeLoadable: getNodeLoadable$1,
  setNodeValue: setNodeValue$1
} = Recoil_FunctionalCore;
var {
  getNextComponentID: getNextComponentID$1
} = Recoil_Keys;
var {
  getNode: getNode$2,
  getNodeMaybe: getNodeMaybe$2
} = Recoil_Node;
var {
  DefaultValue: DefaultValue$1
} = Recoil_Node;
var {
  reactMode: reactMode$1
} = Recoil_ReactMode;
var {
  AbstractRecoilValue: AbstractRecoilValue$1,
  RecoilState: RecoilState$1,
  RecoilValueReadOnly: RecoilValueReadOnly$1,
  isRecoilValue: isRecoilValue$1
} = Recoil_RecoilValue$1;
var {
  invalidateMemoizedSnapshot: invalidateMemoizedSnapshot$1
} = Recoil_SnapshotCache;
function getRecoilValueAsLoadable(store, {
  key
}, treeState = store.getState().currentTree) {
  var _storeState$nextTree, _storeState$previousT;
  const storeState = store.getState();
  if (!(treeState.version === storeState.currentTree.version || treeState.version === ((_storeState$nextTree = storeState.nextTree) === null || _storeState$nextTree === void 0 ? void 0 : _storeState$nextTree.version) || treeState.version === ((_storeState$previousT = storeState.previousTree) === null || _storeState$previousT === void 0 ? void 0 : _storeState$previousT.version))) {
    Recoil_recoverableViolation("Tried to read from a discarded tree");
  }
  const loadable = getNodeLoadable$1(store, treeState, key);
  if (loadable.state === "loading") {
    loadable.contents.catch(() => {
      return;
    });
  }
  return loadable;
}
function applyAtomValueWrites(atomValues, writes) {
  const result = atomValues.clone();
  writes.forEach((v, k) => {
    if (v.state === "hasValue" && v.contents instanceof DefaultValue$1) {
      result.delete(k);
    } else {
      result.set(k, v);
    }
  });
  return result;
}
function valueFromValueOrUpdater(store, state, {
  key
}, valueOrUpdater) {
  if (typeof valueOrUpdater === "function") {
    const current = getNodeLoadable$1(store, state, key);
    if (current.state === "loading") {
      const msg = `Tried to set atom or selector "${key}" using an updater function while the current state is pending, this is not currently supported.`;
      Recoil_recoverableViolation(msg);
      throw Recoil_err(msg);
    } else if (current.state === "hasError") {
      throw current.contents;
    }
    return valueOrUpdater(current.contents);
  } else {
    return valueOrUpdater;
  }
}
function applyAction(store, state, action) {
  if (action.type === "set") {
    const {
      recoilValue,
      valueOrUpdater
    } = action;
    const newValue = valueFromValueOrUpdater(store, state, recoilValue, valueOrUpdater);
    const writes = setNodeValue$1(store, state, recoilValue.key, newValue);
    for (const [key, loadable] of writes.entries()) {
      writeLoadableToTreeState(state, key, loadable);
    }
  } else if (action.type === "setLoadable") {
    const {
      recoilValue: {
        key
      },
      loadable
    } = action;
    writeLoadableToTreeState(state, key, loadable);
  } else if (action.type === "markModified") {
    const {
      recoilValue: {
        key
      }
    } = action;
    state.dirtyAtoms.add(key);
  } else if (action.type === "setUnvalidated") {
    var _node$invalidate;
    const {
      recoilValue: {
        key
      },
      unvalidatedValue
    } = action;
    const node81 = getNodeMaybe$2(key);
    node81 === null || node81 === void 0 ? void 0 : (_node$invalidate = node81.invalidate) === null || _node$invalidate === void 0 ? void 0 : _node$invalidate.call(node81, state);
    state.atomValues.delete(key);
    state.nonvalidatedAtoms.set(key, unvalidatedValue);
    state.dirtyAtoms.add(key);
  } else {
    Recoil_recoverableViolation(`Unknown action ${action.type}`);
  }
}
function writeLoadableToTreeState(state, key, loadable) {
  if (loadable.state === "hasValue" && loadable.contents instanceof DefaultValue$1) {
    state.atomValues.delete(key);
  } else {
    state.atomValues.set(key, loadable);
  }
  state.dirtyAtoms.add(key);
  state.nonvalidatedAtoms.delete(key);
}
function applyActionsToStore(store, actions) {
  store.replaceState((state) => {
    const newState = copyTreeState(state);
    for (const action of actions) {
      applyAction(store, newState, action);
    }
    invalidateDownstreams(store, newState);
    invalidateMemoizedSnapshot$1();
    return newState;
  });
}
function queueOrPerformStateUpdate(store, action) {
  if (batchStack.length) {
    const actionsByStore = batchStack[batchStack.length - 1];
    let actions = actionsByStore.get(store);
    if (!actions) {
      actionsByStore.set(store, actions = []);
    }
    actions.push(action);
  } else {
    applyActionsToStore(store, [action]);
  }
}
var batchStack = [];
function batchStart() {
  const actionsByStore = /* @__PURE__ */ new Map();
  batchStack.push(actionsByStore);
  return () => {
    for (const [store, actions] of actionsByStore) {
      applyActionsToStore(store, actions);
    }
    const popped = batchStack.pop();
    if (popped !== actionsByStore) {
      Recoil_recoverableViolation("Incorrect order of batch popping");
    }
  };
}
function copyTreeState(state) {
  return {
    ...state,
    atomValues: state.atomValues.clone(),
    nonvalidatedAtoms: state.nonvalidatedAtoms.clone(),
    dirtyAtoms: new Set(state.dirtyAtoms)
  };
}
function invalidateDownstreams(store, state) {
  const downstreams = getDownstreamNodes$1(store, state, state.dirtyAtoms);
  for (const key of downstreams) {
    var _getNodeMaybe, _getNodeMaybe$invalid;
    (_getNodeMaybe = getNodeMaybe$2(key)) === null || _getNodeMaybe === void 0 ? void 0 : (_getNodeMaybe$invalid = _getNodeMaybe.invalidate) === null || _getNodeMaybe$invalid === void 0 ? void 0 : _getNodeMaybe$invalid.call(_getNodeMaybe, state);
  }
}
function setRecoilValue(store, recoilValue, valueOrUpdater) {
  queueOrPerformStateUpdate(store, {
    type: "set",
    recoilValue,
    valueOrUpdater
  });
}
function setRecoilValueLoadable(store, recoilValue, loadable) {
  if (loadable instanceof DefaultValue$1) {
    return setRecoilValue(store, recoilValue, loadable);
  }
  queueOrPerformStateUpdate(store, {
    type: "setLoadable",
    recoilValue,
    loadable
  });
}
function markRecoilValueModified(store, recoilValue) {
  queueOrPerformStateUpdate(store, {
    type: "markModified",
    recoilValue
  });
}
function setUnvalidatedRecoilValue(store, recoilValue, unvalidatedValue) {
  queueOrPerformStateUpdate(store, {
    type: "setUnvalidated",
    recoilValue,
    unvalidatedValue
  });
}
function subscribeToRecoilValue(store, {
  key
}, callback, componentDebugName = null) {
  const subID = getNextComponentID$1();
  const storeState = store.getState();
  if (!storeState.nodeToComponentSubscriptions.has(key)) {
    storeState.nodeToComponentSubscriptions.set(key, /* @__PURE__ */ new Map());
  }
  Recoil_nullthrows(storeState.nodeToComponentSubscriptions.get(key)).set(subID, [componentDebugName !== null && componentDebugName !== void 0 ? componentDebugName : "<not captured>", callback]);
  const mode = reactMode$1();
  if (mode.early && (mode.mode === "LEGACY" || mode.mode === "MUTABLE_SOURCE")) {
    const nextTree = store.getState().nextTree;
    if (nextTree && nextTree.dirtyAtoms.has(key)) {
      callback(nextTree);
    }
  }
  return {
    release: () => {
      const releaseStoreState = store.getState();
      const subs = releaseStoreState.nodeToComponentSubscriptions.get(key);
      if (subs === void 0 || !subs.has(subID)) {
        Recoil_recoverableViolation(`Subscription missing at release time for atom ${key}. This is a bug in Recoil.`);
        return;
      }
      subs.delete(subID);
      if (subs.size === 0) {
        releaseStoreState.nodeToComponentSubscriptions.delete(key);
      }
    }
  };
}
function refreshRecoilValue(store, recoilValue) {
  var _node$clearCache;
  const {
    currentTree
  } = store.getState();
  const node81 = getNode$2(recoilValue.key);
  (_node$clearCache = node81.clearCache) === null || _node$clearCache === void 0 ? void 0 : _node$clearCache.call(node81, store, currentTree);
}
var Recoil_RecoilValueInterface = {
  RecoilValueReadOnly: RecoilValueReadOnly$1,
  AbstractRecoilValue: AbstractRecoilValue$1,
  RecoilState: RecoilState$1,
  getRecoilValueAsLoadable,
  setRecoilValue,
  setRecoilValueLoadable,
  markRecoilValueModified,
  setUnvalidatedRecoilValue,
  subscribeToRecoilValue,
  isRecoilValue: isRecoilValue$1,
  applyAtomValueWrites,
  // TODO Remove export when deprecating initialStoreState_DEPRECATED in RecoilRoot
  batchStart,
  writeLoadableToTreeState,
  invalidateDownstreams,
  copyTreeState,
  refreshRecoilValue
};
function someSet(set, callback, context) {
  const iterator = set.entries();
  let current = iterator.next();
  while (!current.done) {
    const entry = current.value;
    if (callback.call(context, entry[1], entry[0], set)) {
      return true;
    }
    current = iterator.next();
  }
  return false;
}
var Recoil_someSet = someSet;
var {
  cleanUpNode: cleanUpNode$1
} = Recoil_FunctionalCore;
var {
  deleteNodeConfigIfPossible: deleteNodeConfigIfPossible$1,
  getNode: getNode$3
} = Recoil_Node;
var {
  RetentionZone: RetentionZone$2
} = Recoil_RetentionZone;
var SUSPENSE_TIMEOUT_MS = 12e4;
var emptySet$1 = /* @__PURE__ */ new Set();
function releaseRetainablesNowOnCurrentTree(store, retainables) {
  const storeState = store.getState();
  const treeState = storeState.currentTree;
  if (storeState.nextTree) {
    Recoil_recoverableViolation("releaseNodesNowOnCurrentTree should only be called at the end of a batch");
    return;
  }
  const nodes2 = /* @__PURE__ */ new Set();
  for (const r of retainables) {
    if (r instanceof RetentionZone$2) {
      for (const n of nodesRetainedByZone(storeState, r)) {
        nodes2.add(n);
      }
    } else {
      nodes2.add(r);
    }
  }
  const releasableNodes = findReleasableNodes(store, nodes2);
  for (const node81 of releasableNodes) {
    releaseNode(store, treeState, node81);
  }
}
function findReleasableNodes(store, searchFromNodes) {
  const storeState = store.getState();
  const treeState = storeState.currentTree;
  const graph2 = store.getGraph(treeState.version);
  const releasableNodes = /* @__PURE__ */ new Set();
  const nonReleasableNodes = /* @__PURE__ */ new Set();
  findReleasableNodesInner(searchFromNodes);
  return releasableNodes;
  function findReleasableNodesInner(searchFromNodes2) {
    const releasableNodesFoundThisIteration = /* @__PURE__ */ new Set();
    const downstreams = getDownstreamNodesInTopologicalOrder(
      store,
      treeState,
      searchFromNodes2,
      releasableNodes,
      // don't descend into these
      nonReleasableNodes
      // don't descend into these
    );
    for (const node81 of downstreams) {
      var _storeState$retention;
      if (getNode$3(node81).retainedBy === "recoilRoot") {
        nonReleasableNodes.add(node81);
        continue;
      }
      if (((_storeState$retention = storeState.retention.referenceCounts.get(node81)) !== null && _storeState$retention !== void 0 ? _storeState$retention : 0) > 0) {
        nonReleasableNodes.add(node81);
        continue;
      }
      if (zonesThatCouldRetainNode(node81).some((z) => storeState.retention.referenceCounts.get(z))) {
        nonReleasableNodes.add(node81);
        continue;
      }
      const nodeChildren = graph2.nodeToNodeSubscriptions.get(node81);
      if (nodeChildren && Recoil_someSet(nodeChildren, (child) => nonReleasableNodes.has(child))) {
        nonReleasableNodes.add(node81);
        continue;
      }
      releasableNodes.add(node81);
      releasableNodesFoundThisIteration.add(node81);
    }
    const parents = /* @__PURE__ */ new Set();
    for (const node81 of releasableNodesFoundThisIteration) {
      for (const parent of (_graph$nodeDeps$get = graph2.nodeDeps.get(node81)) !== null && _graph$nodeDeps$get !== void 0 ? _graph$nodeDeps$get : emptySet$1) {
        var _graph$nodeDeps$get;
        if (!releasableNodes.has(parent)) {
          parents.add(parent);
        }
      }
    }
    if (parents.size) {
      findReleasableNodesInner(parents);
    }
  }
}
function getDownstreamNodesInTopologicalOrder(store, treeState, nodes2, doNotDescendInto1, doNotDescendInto2) {
  const graph2 = store.getGraph(treeState.version);
  const answer = [];
  const visited = /* @__PURE__ */ new Set();
  while (nodes2.size > 0) {
    visit(Recoil_nullthrows(nodes2.values().next().value));
  }
  return answer;
  function visit(node81) {
    if (doNotDescendInto1.has(node81) || doNotDescendInto2.has(node81)) {
      nodes2.delete(node81);
      return;
    }
    if (visited.has(node81)) {
      return;
    }
    const children = graph2.nodeToNodeSubscriptions.get(node81);
    if (children) {
      for (const child of children) {
        visit(child);
      }
    }
    visited.add(node81);
    nodes2.delete(node81);
    answer.push(node81);
  }
}
function releaseNode(store, treeState, node81) {
  if (!Recoil_gkx("recoil_memory_managament_2020")) {
    return;
  }
  cleanUpNode$1(store, node81);
  const storeState = store.getState();
  storeState.knownAtoms.delete(node81);
  storeState.knownSelectors.delete(node81);
  storeState.nodeTransactionSubscriptions.delete(node81);
  storeState.retention.referenceCounts.delete(node81);
  const zones = zonesThatCouldRetainNode(node81);
  for (const zone of zones) {
    var _storeState$retention2;
    (_storeState$retention2 = storeState.retention.nodesRetainedByZone.get(zone)) === null || _storeState$retention2 === void 0 ? void 0 : _storeState$retention2.delete(node81);
  }
  treeState.atomValues.delete(node81);
  treeState.dirtyAtoms.delete(node81);
  treeState.nonvalidatedAtoms.delete(node81);
  const graph2 = storeState.graphsByVersion.get(treeState.version);
  if (graph2) {
    const deps = graph2.nodeDeps.get(node81);
    if (deps !== void 0) {
      graph2.nodeDeps.delete(node81);
      for (const dep of deps) {
        var _graph$nodeToNodeSubs;
        (_graph$nodeToNodeSubs = graph2.nodeToNodeSubscriptions.get(dep)) === null || _graph$nodeToNodeSubs === void 0 ? void 0 : _graph$nodeToNodeSubs.delete(node81);
      }
    }
    graph2.nodeToNodeSubscriptions.delete(node81);
  }
  deleteNodeConfigIfPossible$1(node81);
}
function nodesRetainedByZone(storeState, zone) {
  var _storeState$retention3;
  return (_storeState$retention3 = storeState.retention.nodesRetainedByZone.get(zone)) !== null && _storeState$retention3 !== void 0 ? _storeState$retention3 : emptySet$1;
}
function zonesThatCouldRetainNode(node81) {
  const retainedBy = getNode$3(node81).retainedBy;
  if (retainedBy === void 0 || retainedBy === "components" || retainedBy === "recoilRoot") {
    return [];
  } else if (retainedBy instanceof RetentionZone$2) {
    return [retainedBy];
  } else {
    return retainedBy;
  }
}
function scheduleOrPerformPossibleReleaseOfRetainable(store, retainable) {
  const state = store.getState();
  if (state.nextTree) {
    state.retention.retainablesToCheckForRelease.add(retainable);
  } else {
    releaseRetainablesNowOnCurrentTree(store, /* @__PURE__ */ new Set([retainable]));
  }
}
function updateRetainCount(store, retainable, delta) {
  var _map$get;
  if (!Recoil_gkx("recoil_memory_managament_2020")) {
    return;
  }
  const map = store.getState().retention.referenceCounts;
  const newCount = ((_map$get = map.get(retainable)) !== null && _map$get !== void 0 ? _map$get : 0) + delta;
  if (newCount === 0) {
    updateRetainCountToZero(store, retainable);
  } else {
    map.set(retainable, newCount);
  }
}
function updateRetainCountToZero(store, retainable) {
  if (!Recoil_gkx("recoil_memory_managament_2020")) {
    return;
  }
  const map = store.getState().retention.referenceCounts;
  map.delete(retainable);
  scheduleOrPerformPossibleReleaseOfRetainable(store, retainable);
}
function releaseScheduledRetainablesNow(store) {
  if (!Recoil_gkx("recoil_memory_managament_2020")) {
    return;
  }
  const state = store.getState();
  releaseRetainablesNowOnCurrentTree(store, state.retention.retainablesToCheckForRelease);
  state.retention.retainablesToCheckForRelease.clear();
}
function retainedByOptionWithDefault(r) {
  return r === void 0 ? "recoilRoot" : r;
}
var Recoil_Retention = {
  SUSPENSE_TIMEOUT_MS,
  updateRetainCount,
  updateRetainCountToZero,
  releaseScheduledRetainablesNow,
  retainedByOptionWithDefault
};
var {
  unstable_batchedUpdates
} = reactDom;
var ReactBatchedUpdates = {
  unstable_batchedUpdates
};
var {
  unstable_batchedUpdates: unstable_batchedUpdates$1
} = ReactBatchedUpdates;
var Recoil_ReactBatchedUpdates = {
  unstable_batchedUpdates: unstable_batchedUpdates$1
};
var {
  batchStart: batchStart$1
} = Recoil_RecoilValueInterface;
var {
  unstable_batchedUpdates: unstable_batchedUpdates$2
} = Recoil_ReactBatchedUpdates;
var batcher = unstable_batchedUpdates$2 || ((batchFn) => batchFn());
var setBatcher = (newBatcher) => {
  batcher = newBatcher;
};
var getBatcher = () => batcher;
var batchUpdates = (callback) => {
  batcher(() => {
    let batchEnd = () => void 0;
    try {
      batchEnd = batchStart$1();
      callback();
    } finally {
      batchEnd();
    }
  });
};
var Recoil_Batching = {
  getBatcher,
  setBatcher,
  batchUpdates
};
function* concatIterables(iters) {
  for (const iter of iters) {
    for (const val of iter) {
      yield val;
    }
  }
}
var Recoil_concatIterables = concatIterables;
var isSSR = (
  // $FlowFixMe(site=recoil) Window does not have a FlowType definition https://github.com/facebook/flow/issues/6709
  typeof Window === "undefined" || typeof window === "undefined"
);
var isWindow = (value) => !isSSR && // $FlowFixMe(site=recoil) Window does not have a FlowType definition https://github.com/facebook/flow/issues/6709
(value === window || value instanceof Window);
var isReactNative = typeof navigator !== "undefined" && navigator.product === "ReactNative";
var Recoil_Environment = {
  isSSR,
  isReactNative,
  isWindow
};
function memoizeWithArgsHash(fn, hashFunction) {
  let cache;
  return (...args) => {
    if (!cache) {
      cache = {};
    }
    const key = hashFunction(...args);
    if (!Object.hasOwnProperty.call(cache, key)) {
      cache[key] = fn(...args);
    }
    return cache[key];
  };
}
function memoizeOneWithArgsHash(fn, hashFunction) {
  let lastKey;
  let lastResult;
  return (...args) => {
    const key = hashFunction(...args);
    if (lastKey === key) {
      return lastResult;
    }
    lastKey = key;
    lastResult = fn(...args);
    return lastResult;
  };
}
function memoizeOneWithArgsHashAndInvalidation(fn, hashFunction) {
  let lastKey;
  let lastResult;
  const memoizedFn = (...args) => {
    const key = hashFunction(...args);
    if (lastKey === key) {
      return lastResult;
    }
    lastKey = key;
    lastResult = fn(...args);
    return lastResult;
  };
  const invalidate = () => {
    lastKey = null;
  };
  return [memoizedFn, invalidate];
}
var Recoil_Memoize = {
  memoizeWithArgsHash,
  memoizeOneWithArgsHash,
  memoizeOneWithArgsHashAndInvalidation
};
var {
  batchUpdates: batchUpdates$1
} = Recoil_Batching;
var {
  initializeNode: initializeNode$1,
  peekNodeInfo: peekNodeInfo$1
} = Recoil_FunctionalCore;
var {
  graph: graph$1
} = Recoil_Graph;
var {
  getNextStoreID: getNextStoreID$1
} = Recoil_Keys;
var {
  DEFAULT_VALUE: DEFAULT_VALUE$1,
  recoilValues: recoilValues$1,
  recoilValuesForKeys: recoilValuesForKeys$2
} = Recoil_Node;
var {
  AbstractRecoilValue: AbstractRecoilValue$2,
  getRecoilValueAsLoadable: getRecoilValueAsLoadable$1,
  setRecoilValue: setRecoilValue$1,
  setUnvalidatedRecoilValue: setUnvalidatedRecoilValue$1
} = Recoil_RecoilValueInterface;
var {
  updateRetainCount: updateRetainCount$1
} = Recoil_Retention;
var {
  setInvalidateMemoizedSnapshot: setInvalidateMemoizedSnapshot$1
} = Recoil_SnapshotCache;
var {
  getNextTreeStateVersion: getNextTreeStateVersion$2,
  makeEmptyStoreState: makeEmptyStoreState$1
} = Recoil_State;
var {
  isSSR: isSSR$1
} = Recoil_Environment;
var {
  memoizeOneWithArgsHashAndInvalidation: memoizeOneWithArgsHashAndInvalidation$1
} = Recoil_Memoize;
var retainWarning = `
Recoil Snapshots only last for the duration of the callback they are provided to. To keep a Snapshot longer, do this:

  const release = snapshot.retain();
  try {
    await doSomethingWithSnapshot(snapshot);
  } finally {
    release();
  }

This is currently a DEV-only warning but will become a thrown exception in the next release of Recoil.
`;
var Snapshot = class {
  // eslint-disable-next-line fb-www/no-uninitialized-properties
  constructor(storeState, parentStoreID) {
    _defineProperty(this, "_store", void 0);
    _defineProperty(this, "_refCount", 1);
    _defineProperty(this, "getLoadable", (recoilValue) => {
      this.checkRefCount_INTERNAL();
      return getRecoilValueAsLoadable$1(this._store, recoilValue);
    });
    _defineProperty(this, "getPromise", (recoilValue) => {
      this.checkRefCount_INTERNAL();
      return this.getLoadable(recoilValue).toPromise();
    });
    _defineProperty(this, "getNodes_UNSTABLE", (opt) => {
      this.checkRefCount_INTERNAL();
      if ((opt === null || opt === void 0 ? void 0 : opt.isModified) === true) {
        if ((opt === null || opt === void 0 ? void 0 : opt.isInitialized) === false) {
          return [];
        }
        const state = this._store.getState().currentTree;
        return recoilValuesForKeys$2(state.dirtyAtoms);
      }
      const knownAtoms = this._store.getState().knownAtoms;
      const knownSelectors = this._store.getState().knownSelectors;
      return (opt === null || opt === void 0 ? void 0 : opt.isInitialized) == null ? recoilValues$1.values() : opt.isInitialized === true ? recoilValuesForKeys$2(Recoil_concatIterables([knownAtoms, knownSelectors])) : Recoil_filterIterable(recoilValues$1.values(), ({
        key
      }) => !knownAtoms.has(key) && !knownSelectors.has(key));
    });
    _defineProperty(this, "getInfo_UNSTABLE", ({
      key
    }) => {
      this.checkRefCount_INTERNAL();
      return peekNodeInfo$1(this._store, this._store.getState().currentTree, key);
    });
    _defineProperty(this, "map", (mapper) => {
      this.checkRefCount_INTERNAL();
      const mutableSnapshot = new MutableSnapshot(this, batchUpdates$1);
      mapper(mutableSnapshot);
      return mutableSnapshot;
    });
    _defineProperty(this, "asyncMap", async (mapper) => {
      this.checkRefCount_INTERNAL();
      const mutableSnapshot = new MutableSnapshot(this, batchUpdates$1);
      mutableSnapshot.retain();
      await mapper(mutableSnapshot);
      mutableSnapshot.autoRelease_INTERNAL();
      return mutableSnapshot;
    });
    this._store = {
      storeID: getNextStoreID$1(),
      parentStoreID,
      getState: () => storeState,
      replaceState: (replacer) => {
        storeState.currentTree = replacer(storeState.currentTree);
      },
      getGraph: (version) => {
        const graphs = storeState.graphsByVersion;
        if (graphs.has(version)) {
          return Recoil_nullthrows(graphs.get(version));
        }
        const newGraph = graph$1();
        graphs.set(version, newGraph);
        return newGraph;
      },
      subscribeToTransactions: () => ({
        release: () => {
        }
      }),
      addTransactionMetadata: () => {
        throw Recoil_err("Cannot subscribe to Snapshots");
      }
    };
    for (const nodeKey of this._store.getState().knownAtoms) {
      initializeNode$1(this._store, nodeKey, "get");
      updateRetainCount$1(this._store, nodeKey, 1);
    }
    this.autoRelease_INTERNAL();
  }
  retain() {
    if (this._refCount <= 0) {
      if (process.env.NODE_ENV !== "production") {
        throw Recoil_err("Snapshot has already been released.");
      } else {
        Recoil_recoverableViolation("Attempt to retain() Snapshot that was already released.");
      }
    }
    this._refCount++;
    let released = false;
    return () => {
      if (!released) {
        released = true;
        this._release();
      }
    };
  }
  /**
   * Release the snapshot on the next tick.  This means the snapshot is retained
   * during the execution of the current function using it.
   */
  autoRelease_INTERNAL() {
    if (!isSSR$1) {
      window.setTimeout(() => this._release(), 10);
    }
  }
  _release() {
    this._refCount--;
    if (this._refCount === 0) {
      this._store.getState().nodeCleanupFunctions.forEach((cleanup) => cleanup());
      this._store.getState().nodeCleanupFunctions.clear();
      if (!Recoil_gkx("recoil_memory_managament_2020")) {
        return;
      }
    } else if (this._refCount < 0) {
      if (process.env.NODE_ENV !== "production") {
        Recoil_recoverableViolation("Snapshot released an extra time.");
      }
    }
  }
  isRetained() {
    return this._refCount > 0;
  }
  checkRefCount_INTERNAL() {
    if (Recoil_gkx("recoil_memory_managament_2020") && this._refCount <= 0) {
      if (process.env.NODE_ENV !== "production") {
        Recoil_recoverableViolation(retainWarning);
      }
    }
  }
  getStore_INTERNAL() {
    this.checkRefCount_INTERNAL();
    return this._store;
  }
  getID() {
    this.checkRefCount_INTERNAL();
    return this._store.getState().currentTree.stateID;
  }
  getStoreID() {
    this.checkRefCount_INTERNAL();
    return this._store.storeID;
  }
  // We want to allow the methods to be destructured and used as accessors
  /* eslint-disable fb-www/extra-arrow-initializer */
  /* eslint-enable fb-www/extra-arrow-initializer */
};
function cloneStoreState(store, treeState, bumpVersion = false) {
  const storeState = store.getState();
  const version = bumpVersion ? getNextTreeStateVersion$2() : treeState.version;
  return {
    // Always clone the TreeState to isolate stores from accidental mutations.
    // For example, reading a selector from a cloned snapshot shouldn't cache
    // in the original treestate which may cause the original to skip
    // initialization of upstream atoms.
    currentTree: {
      // TODO snapshots shouldn't really have versions because a new version number
      // is always assigned when the snapshot is gone to.
      version: bumpVersion ? version : treeState.version,
      stateID: bumpVersion ? version : treeState.stateID,
      transactionMetadata: {
        ...treeState.transactionMetadata
      },
      dirtyAtoms: new Set(treeState.dirtyAtoms),
      atomValues: treeState.atomValues.clone(),
      nonvalidatedAtoms: treeState.nonvalidatedAtoms.clone()
    },
    commitDepth: 0,
    nextTree: null,
    previousTree: null,
    knownAtoms: new Set(storeState.knownAtoms),
    // FIXME here's a copy
    knownSelectors: new Set(storeState.knownSelectors),
    // FIXME here's a copy
    transactionSubscriptions: /* @__PURE__ */ new Map(),
    nodeTransactionSubscriptions: /* @__PURE__ */ new Map(),
    nodeToComponentSubscriptions: /* @__PURE__ */ new Map(),
    queuedComponentCallbacks_DEPRECATED: [],
    suspendedComponentResolvers: /* @__PURE__ */ new Set(),
    graphsByVersion: (/* @__PURE__ */ new Map()).set(version, store.getGraph(treeState.version)),
    retention: {
      referenceCounts: /* @__PURE__ */ new Map(),
      nodesRetainedByZone: /* @__PURE__ */ new Map(),
      retainablesToCheckForRelease: /* @__PURE__ */ new Set()
    },
    // FIXME here's a copy
    // Create blank cleanup handlers for atoms so snapshots don't re-run
    // atom effects.
    nodeCleanupFunctions: new Map(Recoil_mapIterable(storeState.nodeCleanupFunctions.entries(), ([key]) => [key, () => {
    }]))
  };
}
function freshSnapshot(initializeState) {
  const snapshot = new Snapshot(makeEmptyStoreState$1());
  return initializeState != null ? snapshot.map(initializeState) : snapshot;
}
var [memoizedCloneSnapshot, invalidateMemoizedSnapshot$2] = memoizeOneWithArgsHashAndInvalidation$1(
  // $FlowFixMe[missing-local-annot]
  (store, version) => {
    var _storeState$nextTree;
    const storeState = store.getState();
    const treeState = version === "latest" ? (_storeState$nextTree = storeState.nextTree) !== null && _storeState$nextTree !== void 0 ? _storeState$nextTree : storeState.currentTree : Recoil_nullthrows(storeState.previousTree);
    return new Snapshot(cloneStoreState(store, treeState), store.storeID);
  },
  (store, version) => {
    var _store$getState$nextT, _store$getState$previ;
    return String(version) + String(store.storeID) + String((_store$getState$nextT = store.getState().nextTree) === null || _store$getState$nextT === void 0 ? void 0 : _store$getState$nextT.version) + String(store.getState().currentTree.version) + String((_store$getState$previ = store.getState().previousTree) === null || _store$getState$previ === void 0 ? void 0 : _store$getState$previ.version);
  }
);
setInvalidateMemoizedSnapshot$1(invalidateMemoizedSnapshot$2);
function cloneSnapshot(store, version = "latest") {
  const snapshot = memoizedCloneSnapshot(store, version);
  if (!snapshot.isRetained()) {
    invalidateMemoizedSnapshot$2();
    return memoizedCloneSnapshot(store, version);
  }
  return snapshot;
}
var MutableSnapshot = class extends Snapshot {
  constructor(snapshot, batch) {
    super(cloneStoreState(snapshot.getStore_INTERNAL(), snapshot.getStore_INTERNAL().getState().currentTree, true), snapshot.getStoreID());
    _defineProperty(this, "_batch", void 0);
    _defineProperty(this, "set", (recoilState, newValueOrUpdater) => {
      this.checkRefCount_INTERNAL();
      const store = this.getStore_INTERNAL();
      this._batch(() => {
        updateRetainCount$1(store, recoilState.key, 1);
        setRecoilValue$1(this.getStore_INTERNAL(), recoilState, newValueOrUpdater);
      });
    });
    _defineProperty(this, "reset", (recoilState) => {
      this.checkRefCount_INTERNAL();
      const store = this.getStore_INTERNAL();
      this._batch(() => {
        updateRetainCount$1(store, recoilState.key, 1);
        setRecoilValue$1(this.getStore_INTERNAL(), recoilState, DEFAULT_VALUE$1);
      });
    });
    _defineProperty(this, "setUnvalidatedAtomValues_DEPRECATED", (values) => {
      this.checkRefCount_INTERNAL();
      const store = this.getStore_INTERNAL();
      batchUpdates$1(() => {
        for (const [k, v] of values.entries()) {
          updateRetainCount$1(store, k, 1);
          setUnvalidatedRecoilValue$1(store, new AbstractRecoilValue$2(k), v);
        }
      });
    });
    this._batch = batch;
  }
};
var Recoil_Snapshot = {
  Snapshot,
  MutableSnapshot,
  freshSnapshot,
  cloneSnapshot
};
var Recoil_Snapshot_1 = Recoil_Snapshot.Snapshot;
var Recoil_Snapshot_2 = Recoil_Snapshot.MutableSnapshot;
var Recoil_Snapshot_3 = Recoil_Snapshot.freshSnapshot;
var Recoil_Snapshot_4 = Recoil_Snapshot.cloneSnapshot;
var Recoil_Snapshot$1 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  Snapshot: Recoil_Snapshot_1,
  MutableSnapshot: Recoil_Snapshot_2,
  freshSnapshot: Recoil_Snapshot_3,
  cloneSnapshot: Recoil_Snapshot_4
});
function unionSets(...sets) {
  const result = /* @__PURE__ */ new Set();
  for (const set of sets) {
    for (const value of set) {
      result.add(value);
    }
  }
  return result;
}
var Recoil_unionSets = unionSets;
var {
  useRef
} = react;
function useRefInitOnce(initialValue) {
  const ref = useRef(initialValue);
  if (ref.current === initialValue && typeof initialValue === "function") {
    ref.current = initialValue();
  }
  return ref;
}
var Recoil_useRefInitOnce = useRefInitOnce;
var {
  getNextTreeStateVersion: getNextTreeStateVersion$3,
  makeEmptyStoreState: makeEmptyStoreState$2
} = Recoil_State;
var {
  cleanUpNode: cleanUpNode$2,
  getDownstreamNodes: getDownstreamNodes$2,
  initializeNode: initializeNode$2,
  setNodeValue: setNodeValue$2,
  setUnvalidatedAtomValue_DEPRECATED: setUnvalidatedAtomValue_DEPRECATED$1
} = Recoil_FunctionalCore;
var {
  graph: graph$2
} = Recoil_Graph;
var {
  cloneGraph: cloneGraph$1
} = Recoil_Graph;
var {
  getNextStoreID: getNextStoreID$2
} = Recoil_Keys;
var {
  createMutableSource: createMutableSource$1,
  reactMode: reactMode$2
} = Recoil_ReactMode;
var {
  applyAtomValueWrites: applyAtomValueWrites$1
} = Recoil_RecoilValueInterface;
var {
  releaseScheduledRetainablesNow: releaseScheduledRetainablesNow$1
} = Recoil_Retention;
var {
  freshSnapshot: freshSnapshot$1
} = Recoil_Snapshot$1;
var {
  useCallback: useCallback13,
  useContext,
  useEffect,
  useMemo: useMemo4,
  useRef: useRef$1,
  useState: useState9
} = react;
function notInAContext() {
  throw Recoil_err("This component must be used inside a <RecoilRoot> component.");
}
var defaultStore = Object.freeze({
  storeID: getNextStoreID$2(),
  getState: notInAContext,
  replaceState: notInAContext,
  getGraph: notInAContext,
  subscribeToTransactions: notInAContext,
  addTransactionMetadata: notInAContext
});
var stateReplacerIsBeingExecuted = false;
function startNextTreeIfNeeded(store) {
  if (stateReplacerIsBeingExecuted) {
    throw Recoil_err("An atom update was triggered within the execution of a state updater function. State updater functions provided to Recoil must be pure functions.");
  }
  const storeState = store.getState();
  if (storeState.nextTree === null) {
    if (Recoil_gkx("recoil_memory_managament_2020") && Recoil_gkx("recoil_release_on_cascading_update_killswitch_2021")) {
      if (storeState.commitDepth > 0) {
        releaseScheduledRetainablesNow$1(store);
      }
    }
    const version = storeState.currentTree.version;
    const nextVersion = getNextTreeStateVersion$3();
    storeState.nextTree = {
      ...storeState.currentTree,
      version: nextVersion,
      stateID: nextVersion,
      dirtyAtoms: /* @__PURE__ */ new Set(),
      transactionMetadata: {}
    };
    storeState.graphsByVersion.set(nextVersion, cloneGraph$1(Recoil_nullthrows(storeState.graphsByVersion.get(version))));
  }
}
var AppContext = react.createContext({
  current: defaultStore
});
var useStoreRef = () => useContext(AppContext);
var MutableSourceContext = react.createContext(null);
function useRecoilMutableSource() {
  const mutableSource = useContext(MutableSourceContext);
  if (mutableSource == null) {
    Recoil_expectationViolation("Attempted to use a Recoil hook outside of a <RecoilRoot>. <RecoilRoot> must be an ancestor of any component that uses Recoil hooks.");
  }
  return mutableSource;
}
function notifyComponents(store, storeState, treeState) {
  const dependentNodes = getDownstreamNodes$2(store, treeState, treeState.dirtyAtoms);
  for (const key of dependentNodes) {
    const comps = storeState.nodeToComponentSubscriptions.get(key);
    if (comps) {
      for (const [_subID, [_debugName, callback]] of comps) {
        callback(treeState);
      }
    }
  }
}
function sendEndOfBatchNotifications(store) {
  const storeState = store.getState();
  const treeState = storeState.currentTree;
  const dirtyAtoms = treeState.dirtyAtoms;
  if (dirtyAtoms.size) {
    for (const [key, subscriptions] of storeState.nodeTransactionSubscriptions) {
      if (dirtyAtoms.has(key)) {
        for (const [_, subscription] of subscriptions) {
          subscription(store);
        }
      }
    }
    for (const [_, subscription] of storeState.transactionSubscriptions) {
      subscription(store);
    }
    if (!reactMode$2().early || storeState.suspendedComponentResolvers.size > 0) {
      notifyComponents(store, storeState, treeState);
      storeState.suspendedComponentResolvers.forEach((cb) => cb());
      storeState.suspendedComponentResolvers.clear();
    }
  }
  storeState.queuedComponentCallbacks_DEPRECATED.forEach((cb) => cb(treeState));
  storeState.queuedComponentCallbacks_DEPRECATED.splice(0, storeState.queuedComponentCallbacks_DEPRECATED.length);
}
function endBatch(store) {
  const storeState = store.getState();
  storeState.commitDepth++;
  try {
    const {
      nextTree
    } = storeState;
    if (nextTree == null) {
      return;
    }
    storeState.previousTree = storeState.currentTree;
    storeState.currentTree = nextTree;
    storeState.nextTree = null;
    sendEndOfBatchNotifications(store);
    if (storeState.previousTree != null) {
      storeState.graphsByVersion.delete(storeState.previousTree.version);
    } else {
      Recoil_recoverableViolation("Ended batch with no previous state, which is unexpected", "recoil");
    }
    storeState.previousTree = null;
    if (Recoil_gkx("recoil_memory_managament_2020")) {
      if (nextTree == null) {
        releaseScheduledRetainablesNow$1(store);
      }
    }
  } finally {
    storeState.commitDepth--;
  }
}
function Batcher({
  setNotifyBatcherOfChange
}) {
  const storeRef = useStoreRef();
  const [, setState] = useState9([]);
  setNotifyBatcherOfChange(() => setState({}));
  useEffect(() => {
    setNotifyBatcherOfChange(() => setState({}));
    return () => {
      setNotifyBatcherOfChange(() => {
      });
    };
  }, [setNotifyBatcherOfChange]);
  useEffect(() => {
    Recoil_Queue.enqueueExecution("Batcher", () => {
      endBatch(storeRef.current);
    });
  });
  return null;
}
if (process.env.NODE_ENV !== "production") {
  if (typeof window !== "undefined" && !window.$recoilDebugStates) {
    window.$recoilDebugStates = [];
  }
}
function initialStoreState_DEPRECATED(store, initializeState) {
  const initial = makeEmptyStoreState$2();
  initializeState({
    set: (atom3, value) => {
      const state = initial.currentTree;
      const writes = setNodeValue$2(store, state, atom3.key, value);
      const writtenNodes = new Set(writes.keys());
      const nonvalidatedAtoms = state.nonvalidatedAtoms.clone();
      for (const n of writtenNodes) {
        nonvalidatedAtoms.delete(n);
      }
      initial.currentTree = {
        ...state,
        dirtyAtoms: Recoil_unionSets(state.dirtyAtoms, writtenNodes),
        atomValues: applyAtomValueWrites$1(state.atomValues, writes),
        // NB: PLEASE un-export applyAtomValueWrites when deleting this code
        nonvalidatedAtoms
      };
    },
    setUnvalidatedAtomValues: (atomValues) => {
      atomValues.forEach((v, k) => {
        initial.currentTree = setUnvalidatedAtomValue_DEPRECATED$1(initial.currentTree, k, v);
      });
    }
  });
  return initial;
}
function initialStoreState(initializeState) {
  const snapshot = freshSnapshot$1(initializeState);
  const storeState = snapshot.getStore_INTERNAL().getState();
  snapshot.retain();
  storeState.nodeCleanupFunctions.forEach((cleanup) => cleanup());
  storeState.nodeCleanupFunctions.clear();
  return storeState;
}
var nextID = 0;
function RecoilRoot_INTERNAL({
  initializeState_DEPRECATED,
  initializeState,
  store_INTERNAL: storeProp,
  // For use with React "context bridging"
  children
}) {
  let storeStateRef;
  const getGraph = (version) => {
    const graphs = storeStateRef.current.graphsByVersion;
    if (graphs.has(version)) {
      return Recoil_nullthrows(graphs.get(version));
    }
    const newGraph = graph$2();
    graphs.set(version, newGraph);
    return newGraph;
  };
  const subscribeToTransactions = (callback, key) => {
    if (key == null) {
      const {
        transactionSubscriptions
      } = storeRef.current.getState();
      const id = nextID++;
      transactionSubscriptions.set(id, callback);
      return {
        release: () => {
          transactionSubscriptions.delete(id);
        }
      };
    } else {
      const {
        nodeTransactionSubscriptions
      } = storeRef.current.getState();
      if (!nodeTransactionSubscriptions.has(key)) {
        nodeTransactionSubscriptions.set(key, /* @__PURE__ */ new Map());
      }
      const id = nextID++;
      Recoil_nullthrows(nodeTransactionSubscriptions.get(key)).set(id, callback);
      return {
        release: () => {
          const subs = nodeTransactionSubscriptions.get(key);
          if (subs) {
            subs.delete(id);
            if (subs.size === 0) {
              nodeTransactionSubscriptions.delete(key);
            }
          }
        }
      };
    }
  };
  const addTransactionMetadata = (metadata) => {
    startNextTreeIfNeeded(storeRef.current);
    for (const k of Object.keys(metadata)) {
      Recoil_nullthrows(storeRef.current.getState().nextTree).transactionMetadata[k] = metadata[k];
    }
  };
  const replaceState = (replacer) => {
    startNextTreeIfNeeded(storeRef.current);
    const nextTree = Recoil_nullthrows(storeStateRef.current.nextTree);
    let replaced;
    try {
      stateReplacerIsBeingExecuted = true;
      replaced = replacer(nextTree);
    } finally {
      stateReplacerIsBeingExecuted = false;
    }
    if (replaced === nextTree) {
      return;
    }
    if (process.env.NODE_ENV !== "production") {
      if (typeof window !== "undefined") {
        window.$recoilDebugStates.push(replaced);
      }
    }
    storeStateRef.current.nextTree = replaced;
    if (reactMode$2().early) {
      notifyComponents(storeRef.current, storeStateRef.current, replaced);
    }
    Recoil_nullthrows(notifyBatcherOfChange.current)();
  };
  const notifyBatcherOfChange = useRef$1(null);
  const setNotifyBatcherOfChange = useCallback13((x) => {
    notifyBatcherOfChange.current = x;
  }, [notifyBatcherOfChange]);
  const storeRef = Recoil_useRefInitOnce(() => storeProp !== null && storeProp !== void 0 ? storeProp : {
    storeID: getNextStoreID$2(),
    getState: () => storeStateRef.current,
    replaceState,
    getGraph,
    subscribeToTransactions,
    addTransactionMetadata
  });
  if (storeProp != null) {
    storeRef.current = storeProp;
  }
  storeStateRef = Recoil_useRefInitOnce(() => initializeState_DEPRECATED != null ? initialStoreState_DEPRECATED(storeRef.current, initializeState_DEPRECATED) : initializeState != null ? initialStoreState(initializeState) : makeEmptyStoreState$2());
  const mutableSource = useMemo4(() => createMutableSource$1 === null || createMutableSource$1 === void 0 ? void 0 : createMutableSource$1(storeStateRef, () => storeStateRef.current.currentTree.version), [storeStateRef]);
  useEffect(() => {
    const store = storeRef.current;
    for (const atomKey of new Set(store.getState().knownAtoms)) {
      initializeNode$2(store, atomKey, "get");
    }
    return () => {
      for (const atomKey of store.getState().knownAtoms) {
        cleanUpNode$2(store, atomKey);
      }
    };
  }, [storeRef]);
  return /* @__PURE__ */ react.createElement(AppContext.Provider, {
    value: storeRef
  }, /* @__PURE__ */ react.createElement(MutableSourceContext.Provider, {
    value: mutableSource
  }, /* @__PURE__ */ react.createElement(Batcher, {
    setNotifyBatcherOfChange
  }), children));
}
function RecoilRoot(props) {
  const {
    override,
    ...propsExceptOverride
  } = props;
  const ancestorStoreRef = useStoreRef();
  if (override === false && ancestorStoreRef.current !== defaultStore) {
    return props.children;
  }
  return /* @__PURE__ */ react.createElement(RecoilRoot_INTERNAL, propsExceptOverride);
}
function useRecoilStoreID() {
  return useStoreRef().current.storeID;
}
var Recoil_RecoilRoot = {
  RecoilRoot,
  useStoreRef,
  useRecoilMutableSource,
  useRecoilStoreID,
  notifyComponents_FOR_TESTING: notifyComponents,
  sendEndOfBatchNotifications_FOR_TESTING: sendEndOfBatchNotifications
};
function shallowArrayEqual(a, b) {
  if (a === b) {
    return true;
  }
  if (a.length !== b.length) {
    return false;
  }
  for (let i = 0, l = a.length; i < l; i++) {
    if (a[i] !== b[i]) {
      return false;
    }
  }
  return true;
}
var Recoil_shallowArrayEqual = shallowArrayEqual;
var {
  useEffect: useEffect$1,
  useRef: useRef$2
} = react;
function usePrevious(value) {
  const ref = useRef$2();
  useEffect$1(() => {
    ref.current = value;
  });
  return ref.current;
}
var Recoil_usePrevious = usePrevious;
var {
  useStoreRef: useStoreRef$1
} = Recoil_RecoilRoot;
var {
  SUSPENSE_TIMEOUT_MS: SUSPENSE_TIMEOUT_MS$1
} = Recoil_Retention;
var {
  updateRetainCount: updateRetainCount$2
} = Recoil_Retention;
var {
  RetentionZone: RetentionZone$3
} = Recoil_RetentionZone;
var {
  useEffect: useEffect$2,
  useRef: useRef$3
} = react;
var {
  isSSR: isSSR$2
} = Recoil_Environment;
function useRetain(toRetain) {
  if (!Recoil_gkx("recoil_memory_managament_2020")) {
    return;
  }
  return useRetain_ACTUAL(toRetain);
}
function useRetain_ACTUAL(toRetain) {
  const array = Array.isArray(toRetain) ? toRetain : [toRetain];
  const retainables = array.map((a) => a instanceof RetentionZone$3 ? a : a.key);
  const storeRef = useStoreRef$1();
  useEffect$2(() => {
    if (!Recoil_gkx("recoil_memory_managament_2020")) {
      return;
    }
    const store = storeRef.current;
    if (timeoutID.current && !isSSR$2) {
      window.clearTimeout(timeoutID.current);
      timeoutID.current = null;
    } else {
      for (const r of retainables) {
        updateRetainCount$2(store, r, 1);
      }
    }
    return () => {
      for (const r of retainables) {
        updateRetainCount$2(store, r, -1);
      }
    };
  }, [storeRef, ...retainables]);
  const timeoutID = useRef$3();
  const previousRetainables = Recoil_usePrevious(retainables);
  if (!isSSR$2 && (previousRetainables === void 0 || !Recoil_shallowArrayEqual(previousRetainables, retainables))) {
    const store = storeRef.current;
    for (const r of retainables) {
      updateRetainCount$2(store, r, 1);
    }
    if (previousRetainables) {
      for (const r of previousRetainables) {
        updateRetainCount$2(store, r, -1);
      }
    }
    if (timeoutID.current) {
      window.clearTimeout(timeoutID.current);
    }
    timeoutID.current = window.setTimeout(() => {
      timeoutID.current = null;
      for (const r of retainables) {
        updateRetainCount$2(store, r, -1);
      }
    }, SUSPENSE_TIMEOUT_MS$1);
  }
}
var Recoil_useRetain = useRetain;
function useComponentName() {
  return "<component name not available>";
}
var Recoil_useComponentName = useComponentName;
var {
  batchUpdates: batchUpdates$2
} = Recoil_Batching;
var {
  DEFAULT_VALUE: DEFAULT_VALUE$2
} = Recoil_Node;
var {
  currentRendererSupportsUseSyncExternalStore: currentRendererSupportsUseSyncExternalStore$1,
  reactMode: reactMode$3,
  useMutableSource: useMutableSource$1,
  useSyncExternalStore: useSyncExternalStore$1
} = Recoil_ReactMode;
var {
  useRecoilMutableSource: useRecoilMutableSource$1,
  useStoreRef: useStoreRef$2
} = Recoil_RecoilRoot;
var {
  isRecoilValue: isRecoilValue$2
} = Recoil_RecoilValue$1;
var {
  AbstractRecoilValue: AbstractRecoilValue$3,
  getRecoilValueAsLoadable: getRecoilValueAsLoadable$2,
  setRecoilValue: setRecoilValue$2,
  setUnvalidatedRecoilValue: setUnvalidatedRecoilValue$2,
  subscribeToRecoilValue: subscribeToRecoilValue$1
} = Recoil_RecoilValueInterface;
var {
  useCallback: useCallback$1,
  useEffect: useEffect$3,
  useMemo: useMemo$1,
  useRef: useRef$4,
  useState: useState$1
} = react;
var {
  setByAddingToSet: setByAddingToSet$2
} = Recoil_CopyOnWrite;
var {
  isSSR: isSSR$3
} = Recoil_Environment;
function handleLoadable(loadable, recoilValue, storeRef) {
  if (loadable.state === "hasValue") {
    return loadable.contents;
  } else if (loadable.state === "loading") {
    const promise = new Promise((resolve) => {
      const suspendedComponentResolvers = storeRef.current.getState().suspendedComponentResolvers;
      suspendedComponentResolvers.add(resolve);
      if (isSSR$3 && Recoil_isPromise(loadable.contents)) {
        loadable.contents.finally(() => {
          suspendedComponentResolvers.delete(resolve);
        });
      }
    });
    throw promise;
  } else if (loadable.state === "hasError") {
    throw loadable.contents;
  } else {
    throw Recoil_err(`Invalid value of loadable atom "${recoilValue.key}"`);
  }
}
function validateRecoilValue(recoilValue, hookName) {
  if (!isRecoilValue$2(recoilValue)) {
    throw Recoil_err(`Invalid argument to ${hookName}: expected an atom or selector but got ${String(recoilValue)}`);
  }
}
function useRecoilInterface_DEPRECATED() {
  const componentName = Recoil_useComponentName();
  const storeRef = useStoreRef$2();
  const [, forceUpdate] = useState$1([]);
  const recoilValuesUsed = useRef$4(/* @__PURE__ */ new Set());
  recoilValuesUsed.current = /* @__PURE__ */ new Set();
  const previousSubscriptions = useRef$4(/* @__PURE__ */ new Set());
  const subscriptions = useRef$4(/* @__PURE__ */ new Map());
  const unsubscribeFrom = useCallback$1((key) => {
    const sub = subscriptions.current.get(key);
    if (sub) {
      sub.release();
      subscriptions.current.delete(key);
    }
  }, [subscriptions]);
  const updateState = useCallback$1((_state, key) => {
    if (subscriptions.current.has(key)) {
      forceUpdate([]);
    }
  }, []);
  useEffect$3(() => {
    const store = storeRef.current;
    Recoil_differenceSets(recoilValuesUsed.current, previousSubscriptions.current).forEach((key) => {
      if (subscriptions.current.has(key)) {
        Recoil_expectationViolation(`Double subscription to RecoilValue "${key}"`);
        return;
      }
      const sub = subscribeToRecoilValue$1(store, new AbstractRecoilValue$3(key), (state2) => updateState(state2, key), componentName);
      subscriptions.current.set(key, sub);
      const state = store.getState();
      if (state.nextTree) {
        store.getState().queuedComponentCallbacks_DEPRECATED.push(() => {
          updateState(store.getState(), key);
        });
      } else {
        updateState(store.getState(), key);
      }
    });
    Recoil_differenceSets(previousSubscriptions.current, recoilValuesUsed.current).forEach((key) => {
      unsubscribeFrom(key);
    });
    previousSubscriptions.current = recoilValuesUsed.current;
  });
  useEffect$3(() => {
    const currentSubscriptions = subscriptions.current;
    Recoil_differenceSets(recoilValuesUsed.current, new Set(currentSubscriptions.keys())).forEach((key) => {
      const sub = subscribeToRecoilValue$1(storeRef.current, new AbstractRecoilValue$3(key), (state) => updateState(state, key), componentName);
      currentSubscriptions.set(key, sub);
    });
    return () => currentSubscriptions.forEach((_, key) => unsubscribeFrom(key));
  }, [componentName, storeRef, unsubscribeFrom, updateState]);
  return useMemo$1(() => {
    function useSetRecoilState2(recoilState) {
      if (process.env.NODE_ENV !== "production") {
        validateRecoilValue(recoilState, "useSetRecoilState");
      }
      return (newValueOrUpdater) => {
        setRecoilValue$2(storeRef.current, recoilState, newValueOrUpdater);
      };
    }
    function useResetRecoilState2(recoilState) {
      if (process.env.NODE_ENV !== "production") {
        validateRecoilValue(recoilState, "useResetRecoilState");
      }
      return () => setRecoilValue$2(storeRef.current, recoilState, DEFAULT_VALUE$2);
    }
    function useRecoilValueLoadable2(recoilValue) {
      var _storeState$nextTree;
      if (process.env.NODE_ENV !== "production") {
        validateRecoilValue(recoilValue, "useRecoilValueLoadable");
      }
      if (!recoilValuesUsed.current.has(recoilValue.key)) {
        recoilValuesUsed.current = setByAddingToSet$2(recoilValuesUsed.current, recoilValue.key);
      }
      const storeState = storeRef.current.getState();
      return getRecoilValueAsLoadable$2(storeRef.current, recoilValue, reactMode$3().early ? (_storeState$nextTree = storeState.nextTree) !== null && _storeState$nextTree !== void 0 ? _storeState$nextTree : storeState.currentTree : storeState.currentTree);
    }
    function useRecoilValue2(recoilValue) {
      if (process.env.NODE_ENV !== "production") {
        validateRecoilValue(recoilValue, "useRecoilValue");
      }
      const loadable = useRecoilValueLoadable2(recoilValue);
      return handleLoadable(loadable, recoilValue, storeRef);
    }
    function useRecoilState2(recoilState) {
      if (process.env.NODE_ENV !== "production") {
        validateRecoilValue(recoilState, "useRecoilState");
      }
      return [useRecoilValue2(recoilState), useSetRecoilState2(recoilState)];
    }
    function useRecoilStateLoadable2(recoilState) {
      if (process.env.NODE_ENV !== "production") {
        validateRecoilValue(recoilState, "useRecoilStateLoadable");
      }
      return [useRecoilValueLoadable2(recoilState), useSetRecoilState2(recoilState)];
    }
    return {
      getRecoilValue: useRecoilValue2,
      getRecoilValueLoadable: useRecoilValueLoadable2,
      getRecoilState: useRecoilState2,
      getRecoilStateLoadable: useRecoilStateLoadable2,
      getSetRecoilState: useSetRecoilState2,
      getResetRecoilState: useResetRecoilState2
    };
  }, [recoilValuesUsed, storeRef]);
}
var recoilComponentGetRecoilValueCount_FOR_TESTING = {
  current: 0
};
function useRecoilValueLoadable_SYNC_EXTERNAL_STORE(recoilValue) {
  const storeRef = useStoreRef$2();
  const componentName = Recoil_useComponentName();
  const getSnapshot = useCallback$1(() => {
    var _storeState$nextTree2;
    if (process.env.NODE_ENV !== "production") {
      recoilComponentGetRecoilValueCount_FOR_TESTING.current++;
    }
    const store = storeRef.current;
    const storeState = store.getState();
    const treeState = reactMode$3().early ? (_storeState$nextTree2 = storeState.nextTree) !== null && _storeState$nextTree2 !== void 0 ? _storeState$nextTree2 : storeState.currentTree : storeState.currentTree;
    const loadable = getRecoilValueAsLoadable$2(store, recoilValue, treeState);
    return {
      loadable,
      key: recoilValue.key
    };
  }, [storeRef, recoilValue]);
  const memoizePreviousSnapshot = useCallback$1((getState) => {
    let prevState;
    return () => {
      var _prevState, _prevState2;
      const nextState = getState();
      if ((_prevState = prevState) !== null && _prevState !== void 0 && _prevState.loadable.is(nextState.loadable) && ((_prevState2 = prevState) === null || _prevState2 === void 0 ? void 0 : _prevState2.key) === nextState.key) {
        return prevState;
      }
      prevState = nextState;
      return nextState;
    };
  }, []);
  const getMemoizedSnapshot = useMemo$1(() => memoizePreviousSnapshot(getSnapshot), [getSnapshot, memoizePreviousSnapshot]);
  const subscribe = useCallback$1((notify) => {
    const store = storeRef.current;
    const subscription = subscribeToRecoilValue$1(store, recoilValue, notify, componentName);
    return subscription.release;
  }, [storeRef, recoilValue, componentName]);
  return useSyncExternalStore$1(
    subscribe,
    getMemoizedSnapshot,
    // getSnapshot()
    getMemoizedSnapshot
    // getServerSnapshot() for SSR support
  ).loadable;
}
function useRecoilValueLoadable_MUTABLE_SOURCE(recoilValue) {
  const storeRef = useStoreRef$2();
  const getLoadable = useCallback$1(() => {
    var _storeState$nextTree3;
    const store = storeRef.current;
    const storeState = store.getState();
    const treeState = reactMode$3().early ? (_storeState$nextTree3 = storeState.nextTree) !== null && _storeState$nextTree3 !== void 0 ? _storeState$nextTree3 : storeState.currentTree : storeState.currentTree;
    return getRecoilValueAsLoadable$2(store, recoilValue, treeState);
  }, [storeRef, recoilValue]);
  const getLoadableWithTesting = useCallback$1(() => {
    if (process.env.NODE_ENV !== "production") {
      recoilComponentGetRecoilValueCount_FOR_TESTING.current++;
    }
    return getLoadable();
  }, [getLoadable]);
  const componentName = Recoil_useComponentName();
  const subscribe = useCallback$1((_storeState, notify) => {
    const store = storeRef.current;
    const subscription = subscribeToRecoilValue$1(store, recoilValue, () => {
      if (!Recoil_gkx("recoil_suppress_rerender_in_callback")) {
        return notify();
      }
      const newLoadable = getLoadable();
      if (!prevLoadableRef.current.is(newLoadable)) {
        notify();
      }
      prevLoadableRef.current = newLoadable;
    }, componentName);
    return subscription.release;
  }, [storeRef, recoilValue, componentName, getLoadable]);
  const source = useRecoilMutableSource$1();
  if (source == null) {
    throw Recoil_err("Recoil hooks must be used in components contained within a <RecoilRoot> component.");
  }
  const loadable = useMutableSource$1(source, getLoadableWithTesting, subscribe);
  const prevLoadableRef = useRef$4(loadable);
  useEffect$3(() => {
    prevLoadableRef.current = loadable;
  });
  return loadable;
}
function useRecoilValueLoadable_TRANSITION_SUPPORT(recoilValue) {
  const storeRef = useStoreRef$2();
  const componentName = Recoil_useComponentName();
  const getLoadable = useCallback$1(() => {
    var _storeState$nextTree4;
    if (process.env.NODE_ENV !== "production") {
      recoilComponentGetRecoilValueCount_FOR_TESTING.current++;
    }
    const store = storeRef.current;
    const storeState = store.getState();
    const treeState = reactMode$3().early ? (_storeState$nextTree4 = storeState.nextTree) !== null && _storeState$nextTree4 !== void 0 ? _storeState$nextTree4 : storeState.currentTree : storeState.currentTree;
    return getRecoilValueAsLoadable$2(store, recoilValue, treeState);
  }, [storeRef, recoilValue]);
  const getState = useCallback$1(() => ({
    loadable: getLoadable(),
    key: recoilValue.key
  }), [getLoadable, recoilValue.key]);
  const updateState = useCallback$1((prevState) => {
    const nextState = getState();
    return prevState.loadable.is(nextState.loadable) && prevState.key === nextState.key ? prevState : nextState;
  }, [getState]);
  useEffect$3(() => {
    const subscription = subscribeToRecoilValue$1(storeRef.current, recoilValue, (_state) => {
      setState(updateState);
    }, componentName);
    setState(updateState);
    return subscription.release;
  }, [componentName, recoilValue, storeRef, updateState]);
  const [state, setState] = useState$1(getState);
  return state.key !== recoilValue.key ? getState().loadable : state.loadable;
}
function useRecoilValueLoadable_LEGACY(recoilValue) {
  const storeRef = useStoreRef$2();
  const [, forceUpdate] = useState$1([]);
  const componentName = Recoil_useComponentName();
  const getLoadable = useCallback$1(() => {
    var _storeState$nextTree5;
    if (process.env.NODE_ENV !== "production") {
      recoilComponentGetRecoilValueCount_FOR_TESTING.current++;
    }
    const store = storeRef.current;
    const storeState = store.getState();
    const treeState = reactMode$3().early ? (_storeState$nextTree5 = storeState.nextTree) !== null && _storeState$nextTree5 !== void 0 ? _storeState$nextTree5 : storeState.currentTree : storeState.currentTree;
    return getRecoilValueAsLoadable$2(store, recoilValue, treeState);
  }, [storeRef, recoilValue]);
  const loadable = getLoadable();
  const prevLoadableRef = useRef$4(loadable);
  useEffect$3(() => {
    prevLoadableRef.current = loadable;
  });
  useEffect$3(() => {
    const store = storeRef.current;
    const storeState = store.getState();
    const subscription = subscribeToRecoilValue$1(store, recoilValue, (_state) => {
      var _prevLoadableRef$curr;
      if (!Recoil_gkx("recoil_suppress_rerender_in_callback")) {
        return forceUpdate([]);
      }
      const newLoadable = getLoadable();
      if (!((_prevLoadableRef$curr = prevLoadableRef.current) !== null && _prevLoadableRef$curr !== void 0 && _prevLoadableRef$curr.is(newLoadable))) {
        forceUpdate(newLoadable);
      }
      prevLoadableRef.current = newLoadable;
    }, componentName);
    if (storeState.nextTree) {
      store.getState().queuedComponentCallbacks_DEPRECATED.push(() => {
        prevLoadableRef.current = null;
        forceUpdate([]);
      });
    } else {
      var _prevLoadableRef$curr2;
      if (!Recoil_gkx("recoil_suppress_rerender_in_callback")) {
        return forceUpdate([]);
      }
      const newLoadable = getLoadable();
      if (!((_prevLoadableRef$curr2 = prevLoadableRef.current) !== null && _prevLoadableRef$curr2 !== void 0 && _prevLoadableRef$curr2.is(newLoadable))) {
        forceUpdate(newLoadable);
      }
      prevLoadableRef.current = newLoadable;
    }
    return subscription.release;
  }, [componentName, getLoadable, recoilValue, storeRef]);
  return loadable;
}
function useRecoilValueLoadable(recoilValue) {
  if (process.env.NODE_ENV !== "production") {
    validateRecoilValue(recoilValue, "useRecoilValueLoadable");
  }
  if (Recoil_gkx("recoil_memory_managament_2020")) {
    Recoil_useRetain(recoilValue);
  }
  return {
    TRANSITION_SUPPORT: useRecoilValueLoadable_TRANSITION_SUPPORT,
    // Recoil will attemp to detect if `useSyncExternalStore()` is supported with
    // `reactMode()` before calling it.  However, sometimes the host React
    // environment supports it but uses additional React renderers (such as with
    // `react-three-fiber`) which do not.  While this is technically a user issue
    // by using a renderer with React 18+ that doesn't fully support React 18 we
    // don't want to break users if it can be avoided. As the current renderer can
    // change at runtime, we need to dynamically check and fallback if necessary.
    SYNC_EXTERNAL_STORE: currentRendererSupportsUseSyncExternalStore$1() ? useRecoilValueLoadable_SYNC_EXTERNAL_STORE : useRecoilValueLoadable_TRANSITION_SUPPORT,
    MUTABLE_SOURCE: useRecoilValueLoadable_MUTABLE_SOURCE,
    LEGACY: useRecoilValueLoadable_LEGACY
  }[reactMode$3().mode](recoilValue);
}
function useRecoilValue(recoilValue) {
  if (process.env.NODE_ENV !== "production") {
    validateRecoilValue(recoilValue, "useRecoilValue");
  }
  const storeRef = useStoreRef$2();
  const loadable = useRecoilValueLoadable(recoilValue);
  return handleLoadable(loadable, recoilValue, storeRef);
}
function useSetRecoilState(recoilState) {
  if (process.env.NODE_ENV !== "production") {
    validateRecoilValue(recoilState, "useSetRecoilState");
  }
  const storeRef = useStoreRef$2();
  return useCallback$1((newValueOrUpdater) => {
    setRecoilValue$2(storeRef.current, recoilState, newValueOrUpdater);
  }, [storeRef, recoilState]);
}
function useResetRecoilState(recoilState) {
  if (process.env.NODE_ENV !== "production") {
    validateRecoilValue(recoilState, "useResetRecoilState");
  }
  const storeRef = useStoreRef$2();
  return useCallback$1(() => {
    setRecoilValue$2(storeRef.current, recoilState, DEFAULT_VALUE$2);
  }, [storeRef, recoilState]);
}
function useRecoilState(recoilState) {
  if (process.env.NODE_ENV !== "production") {
    validateRecoilValue(recoilState, "useRecoilState");
  }
  return [useRecoilValue(recoilState), useSetRecoilState(recoilState)];
}
function useRecoilStateLoadable(recoilState) {
  if (process.env.NODE_ENV !== "production") {
    validateRecoilValue(recoilState, "useRecoilStateLoadable");
  }
  return [useRecoilValueLoadable(recoilState), useSetRecoilState(recoilState)];
}
function useSetUnvalidatedAtomValues() {
  const storeRef = useStoreRef$2();
  return (values, transactionMetadata = {}) => {
    batchUpdates$2(() => {
      storeRef.current.addTransactionMetadata(transactionMetadata);
      values.forEach((value, key) => setUnvalidatedRecoilValue$2(storeRef.current, new AbstractRecoilValue$3(key), value));
    });
  };
}
function useRecoilValueLoadable_TRANSITION_SUPPORT_UNSTABLE(recoilValue) {
  if (process.env.NODE_ENV !== "production") {
    validateRecoilValue(recoilValue, "useRecoilValueLoadable_TRANSITION_SUPPORT_UNSTABLE");
    if (!reactMode$3().early) {
      Recoil_recoverableViolation("Attepmt to use a hook with UNSTABLE_TRANSITION_SUPPORT in a rendering mode incompatible with concurrent rendering.  Try enabling the recoil_sync_external_store or recoil_transition_support GKs.");
    }
  }
  if (Recoil_gkx("recoil_memory_managament_2020")) {
    Recoil_useRetain(recoilValue);
  }
  return useRecoilValueLoadable_TRANSITION_SUPPORT(recoilValue);
}
function useRecoilValue_TRANSITION_SUPPORT_UNSTABLE(recoilValue) {
  if (process.env.NODE_ENV !== "production") {
    validateRecoilValue(recoilValue, "useRecoilValue_TRANSITION_SUPPORT_UNSTABLE");
  }
  const storeRef = useStoreRef$2();
  const loadable = useRecoilValueLoadable_TRANSITION_SUPPORT_UNSTABLE(recoilValue);
  return handleLoadable(loadable, recoilValue, storeRef);
}
function useRecoilState_TRANSITION_SUPPORT_UNSTABLE(recoilState) {
  if (process.env.NODE_ENV !== "production") {
    validateRecoilValue(recoilState, "useRecoilState_TRANSITION_SUPPORT_UNSTABLE");
  }
  return [useRecoilValue_TRANSITION_SUPPORT_UNSTABLE(recoilState), useSetRecoilState(recoilState)];
}
var Recoil_Hooks = {
  recoilComponentGetRecoilValueCount_FOR_TESTING,
  useRecoilInterface: useRecoilInterface_DEPRECATED,
  useRecoilState,
  useRecoilStateLoadable,
  useRecoilValue,
  useRecoilValueLoadable,
  useResetRecoilState,
  useSetRecoilState,
  useSetUnvalidatedAtomValues,
  useRecoilValueLoadable_TRANSITION_SUPPORT_UNSTABLE,
  useRecoilValue_TRANSITION_SUPPORT_UNSTABLE,
  useRecoilState_TRANSITION_SUPPORT_UNSTABLE
};
function filterMap(map, callback) {
  const result = /* @__PURE__ */ new Map();
  for (const [key, value] of map) {
    if (callback(value, key)) {
      result.set(key, value);
    }
  }
  return result;
}
var Recoil_filterMap = filterMap;
function filterSet(set, callback) {
  const result = /* @__PURE__ */ new Set();
  for (const value of set) {
    if (callback(value)) {
      result.add(value);
    }
  }
  return result;
}
var Recoil_filterSet = filterSet;
function mergeMaps(...maps) {
  const result = /* @__PURE__ */ new Map();
  for (let i = 0; i < maps.length; i++) {
    const iterator = maps[i].keys();
    let nextKey;
    while (!(nextKey = iterator.next()).done) {
      result.set(nextKey.value, maps[i].get(nextKey.value));
    }
  }
  return result;
}
var Recoil_mergeMaps = mergeMaps;
var {
  batchUpdates: batchUpdates$3
} = Recoil_Batching;
var {
  DEFAULT_VALUE: DEFAULT_VALUE$3,
  getNode: getNode$4,
  nodes: nodes$1
} = Recoil_Node;
var {
  useStoreRef: useStoreRef$3
} = Recoil_RecoilRoot;
var {
  AbstractRecoilValue: AbstractRecoilValue$4,
  setRecoilValueLoadable: setRecoilValueLoadable$1
} = Recoil_RecoilValueInterface;
var {
  SUSPENSE_TIMEOUT_MS: SUSPENSE_TIMEOUT_MS$2
} = Recoil_Retention;
var {
  cloneSnapshot: cloneSnapshot$1
} = Recoil_Snapshot$1;
var {
  useCallback: useCallback$2,
  useEffect: useEffect$4,
  useRef: useRef$5,
  useState: useState$2
} = react;
var {
  isSSR: isSSR$4
} = Recoil_Environment;
function useTransactionSubscription(callback) {
  const storeRef = useStoreRef$3();
  useEffect$4(() => {
    const sub = storeRef.current.subscribeToTransactions(callback);
    return sub.release;
  }, [callback, storeRef]);
}
function externallyVisibleAtomValuesInState(state) {
  const atomValues = state.atomValues.toMap();
  const persistedAtomContentsValues = Recoil_mapMap(Recoil_filterMap(atomValues, (v, k) => {
    const node81 = getNode$4(k);
    const persistence = node81.persistence_UNSTABLE;
    return persistence != null && persistence.type !== "none" && v.state === "hasValue";
  }), (v) => v.contents);
  return Recoil_mergeMaps(state.nonvalidatedAtoms.toMap(), persistedAtomContentsValues);
}
function useTransactionObservation_DEPRECATED(callback) {
  useTransactionSubscription(useCallback$2((store) => {
    let previousTree = store.getState().previousTree;
    const currentTree = store.getState().currentTree;
    if (!previousTree) {
      Recoil_recoverableViolation("Transaction subscribers notified without a previous tree being present -- this is a bug in Recoil");
      previousTree = store.getState().currentTree;
    }
    const atomValues = externallyVisibleAtomValuesInState(currentTree);
    const previousAtomValues = externallyVisibleAtomValuesInState(previousTree);
    const atomInfo = Recoil_mapMap(nodes$1, (node81) => {
      var _node$persistence_UNS, _node$persistence_UNS2, _node$persistence_UNS3, _node$persistence_UNS4;
      return {
        persistence_UNSTABLE: {
          type: (_node$persistence_UNS = (_node$persistence_UNS2 = node81.persistence_UNSTABLE) === null || _node$persistence_UNS2 === void 0 ? void 0 : _node$persistence_UNS2.type) !== null && _node$persistence_UNS !== void 0 ? _node$persistence_UNS : "none",
          backButton: (_node$persistence_UNS3 = (_node$persistence_UNS4 = node81.persistence_UNSTABLE) === null || _node$persistence_UNS4 === void 0 ? void 0 : _node$persistence_UNS4.backButton) !== null && _node$persistence_UNS3 !== void 0 ? _node$persistence_UNS3 : false
        }
      };
    });
    const modifiedAtoms = Recoil_filterSet(currentTree.dirtyAtoms, (k) => atomValues.has(k) || previousAtomValues.has(k));
    callback({
      atomValues,
      previousAtomValues,
      atomInfo,
      modifiedAtoms,
      transactionMetadata: {
        ...currentTree.transactionMetadata
      }
    });
  }, [callback]));
}
function useRecoilTransactionObserver(callback) {
  useTransactionSubscription(useCallback$2((store) => {
    const snapshot = cloneSnapshot$1(store, "latest");
    const previousSnapshot = cloneSnapshot$1(store, "previous");
    callback({
      snapshot,
      previousSnapshot
    });
  }, [callback]));
}
function useRecoilSnapshot() {
  const storeRef = useStoreRef$3();
  const [snapshot, setSnapshot] = useState$2(() => cloneSnapshot$1(storeRef.current));
  const previousSnapshot = Recoil_usePrevious(snapshot);
  const timeoutID = useRef$5();
  const releaseRef = useRef$5();
  useTransactionSubscription(useCallback$2((store) => setSnapshot(cloneSnapshot$1(store)), []));
  useEffect$4(() => {
    const release = snapshot.retain();
    if (timeoutID.current && !isSSR$4) {
      var _releaseRef$current;
      window.clearTimeout(timeoutID.current);
      timeoutID.current = null;
      (_releaseRef$current = releaseRef.current) === null || _releaseRef$current === void 0 ? void 0 : _releaseRef$current.call(releaseRef);
      releaseRef.current = null;
    }
    return () => {
      window.setTimeout(release, 10);
    };
  }, [snapshot]);
  if (previousSnapshot !== snapshot && !isSSR$4) {
    if (timeoutID.current) {
      var _releaseRef$current2;
      window.clearTimeout(timeoutID.current);
      timeoutID.current = null;
      (_releaseRef$current2 = releaseRef.current) === null || _releaseRef$current2 === void 0 ? void 0 : _releaseRef$current2.call(releaseRef);
      releaseRef.current = null;
    }
    releaseRef.current = snapshot.retain();
    timeoutID.current = window.setTimeout(() => {
      var _releaseRef$current3;
      timeoutID.current = null;
      (_releaseRef$current3 = releaseRef.current) === null || _releaseRef$current3 === void 0 ? void 0 : _releaseRef$current3.call(releaseRef);
      releaseRef.current = null;
    }, SUSPENSE_TIMEOUT_MS$2);
  }
  return snapshot;
}
function gotoSnapshot(store, snapshot) {
  var _storeState$nextTree;
  const storeState = store.getState();
  const prev = (_storeState$nextTree = storeState.nextTree) !== null && _storeState$nextTree !== void 0 ? _storeState$nextTree : storeState.currentTree;
  const next = snapshot.getStore_INTERNAL().getState().currentTree;
  batchUpdates$3(() => {
    const keysToUpdate = /* @__PURE__ */ new Set();
    for (const keys of [prev.atomValues.keys(), next.atomValues.keys()]) {
      for (const key of keys) {
        var _prev$atomValues$get, _next$atomValues$get;
        if (((_prev$atomValues$get = prev.atomValues.get(key)) === null || _prev$atomValues$get === void 0 ? void 0 : _prev$atomValues$get.contents) !== ((_next$atomValues$get = next.atomValues.get(key)) === null || _next$atomValues$get === void 0 ? void 0 : _next$atomValues$get.contents) && getNode$4(key).shouldRestoreFromSnapshots) {
          keysToUpdate.add(key);
        }
      }
    }
    keysToUpdate.forEach((key) => {
      setRecoilValueLoadable$1(store, new AbstractRecoilValue$4(key), next.atomValues.has(key) ? Recoil_nullthrows(next.atomValues.get(key)) : DEFAULT_VALUE$3);
    });
    store.replaceState((state) => ({
      ...state,
      stateID: snapshot.getID()
    }));
  });
}
function useGotoRecoilSnapshot() {
  const storeRef = useStoreRef$3();
  return useCallback$2((snapshot) => gotoSnapshot(storeRef.current, snapshot), [storeRef]);
}
var Recoil_SnapshotHooks = {
  useRecoilSnapshot,
  gotoSnapshot,
  useGotoRecoilSnapshot,
  useRecoilTransactionObserver,
  useTransactionObservation_DEPRECATED,
  useTransactionSubscription_DEPRECATED: useTransactionSubscription
};
var {
  peekNodeInfo: peekNodeInfo$2
} = Recoil_FunctionalCore;
var {
  useStoreRef: useStoreRef$4
} = Recoil_RecoilRoot;
function useGetRecoilValueInfo() {
  const storeRef = useStoreRef$4();
  return ({
    key
  }) => peekNodeInfo$2(storeRef.current, storeRef.current.getState().currentTree, key);
}
var Recoil_useGetRecoilValueInfo = useGetRecoilValueInfo;
var {
  reactMode: reactMode$4
} = Recoil_ReactMode;
var {
  RecoilRoot: RecoilRoot$1,
  useStoreRef: useStoreRef$5
} = Recoil_RecoilRoot;
var {
  useMemo: useMemo$2
} = react;
function useRecoilBridgeAcrossReactRoots() {
  if (reactMode$4().mode === "MUTABLE_SOURCE") {
    console.warn("Warning: There are known issues using useRecoilBridgeAcrossReactRoots() in recoil_mutable_source rendering mode.  Please consider upgrading to recoil_sync_external_store mode.");
  }
  const store = useStoreRef$5().current;
  return useMemo$2(() => {
    function RecoilBridge({
      children
    }) {
      return /* @__PURE__ */ react.createElement(RecoilRoot$1, {
        store_INTERNAL: store
      }, children);
    }
    return RecoilBridge;
  }, [store]);
}
var Recoil_useRecoilBridgeAcrossReactRoots = useRecoilBridgeAcrossReactRoots;
var {
  loadableWithValue: loadableWithValue$1
} = Recoil_Loadable$1;
var {
  initializeNode: initializeNode$3
} = Recoil_FunctionalCore;
var {
  DEFAULT_VALUE: DEFAULT_VALUE$4,
  getNode: getNode$5
} = Recoil_Node;
var {
  copyTreeState: copyTreeState$1,
  getRecoilValueAsLoadable: getRecoilValueAsLoadable$3,
  invalidateDownstreams: invalidateDownstreams$1,
  writeLoadableToTreeState: writeLoadableToTreeState$1
} = Recoil_RecoilValueInterface;
function isAtom(recoilValue) {
  return getNode$5(recoilValue.key).nodeType === "atom";
}
var TransactionInterfaceImpl = class {
  constructor(store, treeState) {
    _defineProperty(this, "_store", void 0);
    _defineProperty(this, "_treeState", void 0);
    _defineProperty(this, "_changes", void 0);
    _defineProperty(this, "get", (recoilValue) => {
      if (this._changes.has(recoilValue.key)) {
        return this._changes.get(recoilValue.key);
      }
      if (!isAtom(recoilValue)) {
        throw Recoil_err("Reading selectors within atomicUpdate is not supported");
      }
      const loadable = getRecoilValueAsLoadable$3(this._store, recoilValue, this._treeState);
      if (loadable.state === "hasValue") {
        return loadable.contents;
      } else if (loadable.state === "hasError") {
        throw loadable.contents;
      } else {
        throw Recoil_err(`Expected Recoil atom ${recoilValue.key} to have a value, but it is in a loading state.`);
      }
    });
    _defineProperty(this, "set", (recoilState, valueOrUpdater) => {
      if (!isAtom(recoilState)) {
        throw Recoil_err("Setting selectors within atomicUpdate is not supported");
      }
      if (typeof valueOrUpdater === "function") {
        const current = this.get(recoilState);
        this._changes.set(recoilState.key, valueOrUpdater(current));
      } else {
        initializeNode$3(this._store, recoilState.key, "set");
        this._changes.set(recoilState.key, valueOrUpdater);
      }
    });
    _defineProperty(this, "reset", (recoilState) => {
      this.set(recoilState, DEFAULT_VALUE$4);
    });
    this._store = store;
    this._treeState = treeState;
    this._changes = /* @__PURE__ */ new Map();
  }
  // Allow destructing
  // eslint-disable-next-line fb-www/extra-arrow-initializer
  newTreeState_INTERNAL() {
    if (this._changes.size === 0) {
      return this._treeState;
    }
    const newState = copyTreeState$1(this._treeState);
    for (const [k, v] of this._changes) {
      writeLoadableToTreeState$1(newState, k, loadableWithValue$1(v));
    }
    invalidateDownstreams$1(this._store, newState);
    return newState;
  }
};
function atomicUpdater(store) {
  return (fn) => {
    store.replaceState((treeState) => {
      const changeset = new TransactionInterfaceImpl(store, treeState);
      fn(changeset);
      return changeset.newTreeState_INTERNAL();
    });
  };
}
var Recoil_AtomicUpdates = {
  atomicUpdater
};
var Recoil_AtomicUpdates_1 = Recoil_AtomicUpdates.atomicUpdater;
var Recoil_AtomicUpdates$1 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  atomicUpdater: Recoil_AtomicUpdates_1
});
function invariant(condition, message) {
  if (!condition) {
    throw new Error(message);
  }
}
var invariant_1 = invariant;
var Recoil_invariant = invariant_1;
var {
  atomicUpdater: atomicUpdater$1
} = Recoil_AtomicUpdates$1;
var {
  batchUpdates: batchUpdates$4
} = Recoil_Batching;
var {
  DEFAULT_VALUE: DEFAULT_VALUE$5
} = Recoil_Node;
var {
  useStoreRef: useStoreRef$6
} = Recoil_RecoilRoot;
var {
  refreshRecoilValue: refreshRecoilValue$1,
  setRecoilValue: setRecoilValue$3
} = Recoil_RecoilValueInterface;
var {
  cloneSnapshot: cloneSnapshot$2
} = Recoil_Snapshot$1;
var {
  gotoSnapshot: gotoSnapshot$1
} = Recoil_SnapshotHooks;
var {
  useCallback: useCallback$3
} = react;
var Sentinel = class {
};
var SENTINEL = new Sentinel();
function recoilCallback(store, fn, args, extraInterface) {
  let ret = SENTINEL;
  let releaseSnapshot;
  batchUpdates$4(() => {
    const errMsg = "useRecoilCallback() expects a function that returns a function: it accepts a function of the type (RecoilInterface) => (Args) => ReturnType and returns a callback function (Args) => ReturnType, where RecoilInterface is an object {snapshot, set, ...} and Args and ReturnType are the argument and return types of the callback you want to create.  Please see the docs at recoiljs.org for details.";
    if (typeof fn !== "function") {
      throw Recoil_err(errMsg);
    }
    const callbackInterface = Recoil_lazyProxy({
      ...extraInterface !== null && extraInterface !== void 0 ? extraInterface : {},
      // flowlint-line unclear-type:off
      // $FlowFixMe[missing-local-annot]
      set: (node81, newValue) => setRecoilValue$3(store, node81, newValue),
      // $FlowFixMe[missing-local-annot]
      reset: (node81) => setRecoilValue$3(store, node81, DEFAULT_VALUE$5),
      // $FlowFixMe[missing-local-annot]
      refresh: (node81) => refreshRecoilValue$1(store, node81),
      gotoSnapshot: (snapshot) => gotoSnapshot$1(store, snapshot),
      transact_UNSTABLE: (transaction) => atomicUpdater$1(store)(transaction)
    }, {
      snapshot: () => {
        const snapshot = cloneSnapshot$2(store);
        releaseSnapshot = snapshot.retain();
        return snapshot;
      }
    });
    const callback = fn(callbackInterface);
    if (typeof callback !== "function") {
      throw Recoil_err(errMsg);
    }
    ret = callback(...args);
  });
  !!(ret instanceof Sentinel) ? process.env.NODE_ENV !== "production" ? Recoil_invariant(false, "batchUpdates should return immediately") : Recoil_invariant(false) : void 0;
  if (Recoil_isPromise(ret)) {
    ret = ret.finally(() => {
      var _releaseSnapshot;
      (_releaseSnapshot = releaseSnapshot) === null || _releaseSnapshot === void 0 ? void 0 : _releaseSnapshot();
    });
  } else {
    var _releaseSnapshot2;
    (_releaseSnapshot2 = releaseSnapshot) === null || _releaseSnapshot2 === void 0 ? void 0 : _releaseSnapshot2();
  }
  return ret;
}
function useRecoilCallback(fn, deps) {
  const storeRef = useStoreRef$6();
  return useCallback$3(
    // $FlowIssue[incompatible-call]
    (...args) => {
      return recoilCallback(storeRef.current, fn, args);
    },
    deps != null ? [...deps, storeRef] : void 0
    // eslint-disable-line fb-www/react-hooks-deps
  );
}
var Recoil_useRecoilCallback = {
  recoilCallback,
  useRecoilCallback
};
var {
  useStoreRef: useStoreRef$7
} = Recoil_RecoilRoot;
var {
  refreshRecoilValue: refreshRecoilValue$2
} = Recoil_RecoilValueInterface;
var {
  useCallback: useCallback$4
} = react;
function useRecoilRefresher(recoilValue) {
  const storeRef = useStoreRef$7();
  return useCallback$4(() => {
    const store = storeRef.current;
    refreshRecoilValue$2(store, recoilValue);
  }, [recoilValue, storeRef]);
}
var Recoil_useRecoilRefresher = useRecoilRefresher;
var {
  atomicUpdater: atomicUpdater$2
} = Recoil_AtomicUpdates$1;
var {
  useStoreRef: useStoreRef$8
} = Recoil_RecoilRoot;
var {
  useMemo: useMemo$3
} = react;
function useRecoilTransaction(fn, deps) {
  const storeRef = useStoreRef$8();
  return useMemo$3(
    () => (...args) => {
      const atomicUpdate = atomicUpdater$2(storeRef.current);
      atomicUpdate((transactionInterface) => {
        fn(transactionInterface)(...args);
      });
    },
    deps != null ? [...deps, storeRef] : void 0
    // eslint-disable-line fb-www/react-hooks-deps
  );
}
var Recoil_useRecoilTransaction = useRecoilTransaction;
var WrappedValue = class {
  constructor(value) {
    _defineProperty(this, "value", void 0);
    this.value = value;
  }
};
var Recoil_Wrapper = {
  WrappedValue
};
var Recoil_Wrapper_1 = Recoil_Wrapper.WrappedValue;
var Recoil_Wrapper$1 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  WrappedValue: Recoil_Wrapper_1
});
var {
  isFastRefreshEnabled: isFastRefreshEnabled$2
} = Recoil_ReactMode;
var ChangedPathError = class extends Error {
};
var TreeCache = class {
  // $FlowIssue[unclear-type]
  constructor(options) {
    var _options$onHit, _options$onSet, _options$mapNodeValue;
    _defineProperty(this, "_name", void 0);
    _defineProperty(this, "_numLeafs", void 0);
    _defineProperty(this, "_root", void 0);
    _defineProperty(this, "_onHit", void 0);
    _defineProperty(this, "_onSet", void 0);
    _defineProperty(this, "_mapNodeValue", void 0);
    this._name = options === null || options === void 0 ? void 0 : options.name;
    this._numLeafs = 0;
    this._root = null;
    this._onHit = (_options$onHit = options === null || options === void 0 ? void 0 : options.onHit) !== null && _options$onHit !== void 0 ? _options$onHit : () => {
    };
    this._onSet = (_options$onSet = options === null || options === void 0 ? void 0 : options.onSet) !== null && _options$onSet !== void 0 ? _options$onSet : () => {
    };
    this._mapNodeValue = (_options$mapNodeValue = options === null || options === void 0 ? void 0 : options.mapNodeValue) !== null && _options$mapNodeValue !== void 0 ? _options$mapNodeValue : (val) => val;
  }
  size() {
    return this._numLeafs;
  }
  // $FlowIssue[unclear-type]
  root() {
    return this._root;
  }
  get(getNodeValue, handlers) {
    var _this$getLeafNode;
    return (_this$getLeafNode = this.getLeafNode(getNodeValue, handlers)) === null || _this$getLeafNode === void 0 ? void 0 : _this$getLeafNode.value;
  }
  getLeafNode(getNodeValue, handlers) {
    if (this._root == null) {
      return void 0;
    }
    let node81 = this._root;
    while (node81) {
      handlers === null || handlers === void 0 ? void 0 : handlers.onNodeVisit(node81);
      if (node81.type === "leaf") {
        this._onHit(node81);
        return node81;
      }
      const nodeValue = this._mapNodeValue(getNodeValue(node81.nodeKey));
      node81 = node81.branches.get(nodeValue);
    }
    return void 0;
  }
  set(route, value, handlers) {
    const addLeaf = () => {
      var _node2, _node3, _this$_root2, _handlers$onNodeVisit2;
      let node81;
      let branchKey;
      for (const [nodeKey, nodeValue] of route) {
        var _node, _handlers$onNodeVisit, _this$_root;
        const root2 = this._root;
        if ((root2 === null || root2 === void 0 ? void 0 : root2.type) === "leaf") {
          throw this.invalidCacheError();
        }
        const parent = node81;
        node81 = parent ? parent.branches.get(branchKey) : root2;
        node81 = (_node = node81) !== null && _node !== void 0 ? _node : {
          type: "branch",
          nodeKey,
          parent,
          branches: /* @__PURE__ */ new Map(),
          branchKey
        };
        if (node81.type !== "branch" || node81.nodeKey !== nodeKey) {
          throw this.invalidCacheError();
        }
        parent === null || parent === void 0 ? void 0 : parent.branches.set(branchKey, node81);
        handlers === null || handlers === void 0 ? void 0 : (_handlers$onNodeVisit = handlers.onNodeVisit) === null || _handlers$onNodeVisit === void 0 ? void 0 : _handlers$onNodeVisit.call(handlers, node81);
        branchKey = this._mapNodeValue(nodeValue);
        this._root = (_this$_root = this._root) !== null && _this$_root !== void 0 ? _this$_root : node81;
      }
      const oldLeaf = node81 ? (_node2 = node81) === null || _node2 === void 0 ? void 0 : _node2.branches.get(branchKey) : this._root;
      if (oldLeaf != null && (oldLeaf.type !== "leaf" || oldLeaf.branchKey !== branchKey)) {
        throw this.invalidCacheError();
      }
      const leafNode = {
        type: "leaf",
        value,
        parent: node81,
        branchKey
      };
      (_node3 = node81) === null || _node3 === void 0 ? void 0 : _node3.branches.set(branchKey, leafNode);
      this._root = (_this$_root2 = this._root) !== null && _this$_root2 !== void 0 ? _this$_root2 : leafNode;
      this._numLeafs++;
      this._onSet(leafNode);
      handlers === null || handlers === void 0 ? void 0 : (_handlers$onNodeVisit2 = handlers.onNodeVisit) === null || _handlers$onNodeVisit2 === void 0 ? void 0 : _handlers$onNodeVisit2.call(handlers, leafNode);
    };
    try {
      addLeaf();
    } catch (error) {
      if (error instanceof ChangedPathError) {
        this.clear();
        addLeaf();
      } else {
        throw error;
      }
    }
  }
  // Returns true if leaf was actually deleted from the tree
  delete(leaf) {
    const root2 = this.root();
    if (!root2) {
      return false;
    }
    if (leaf === root2) {
      this._root = null;
      this._numLeafs = 0;
      return true;
    }
    let node81 = leaf.parent;
    let branchKey = leaf.branchKey;
    while (node81) {
      var _node4;
      node81.branches.delete(branchKey);
      if (node81 === root2) {
        if (node81.branches.size === 0) {
          this._root = null;
          this._numLeafs = 0;
        } else {
          this._numLeafs--;
        }
        return true;
      }
      if (node81.branches.size > 0) {
        break;
      }
      branchKey = (_node4 = node81) === null || _node4 === void 0 ? void 0 : _node4.branchKey;
      node81 = node81.parent;
    }
    for (; node81 !== root2; node81 = node81.parent) {
      if (node81 == null) {
        return false;
      }
    }
    this._numLeafs--;
    return true;
  }
  clear() {
    this._numLeafs = 0;
    this._root = null;
  }
  invalidCacheError() {
    const CHANGED_PATH_ERROR_MESSAGE = isFastRefreshEnabled$2() ? "Possible Fast Refresh module reload detected.  This may also be caused by an selector returning inconsistent values. Resetting cache." : "Invalid cache values.  This happens when selectors do not return consistent values for the same input dependency values.  That may also be caused when using Fast Refresh to change a selector implementation.  Resetting cache.";
    Recoil_recoverableViolation(CHANGED_PATH_ERROR_MESSAGE + (this._name != null ? ` - ${this._name}` : ""));
    throw new ChangedPathError();
  }
};
var Recoil_TreeCache = {
  TreeCache
};
var Recoil_TreeCache_1 = Recoil_TreeCache.TreeCache;
var Recoil_TreeCache$1 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  TreeCache: Recoil_TreeCache_1
});
var LRUCache = class {
  constructor(options) {
    var _options$mapKey;
    _defineProperty(this, "_maxSize", void 0);
    _defineProperty(this, "_size", void 0);
    _defineProperty(this, "_head", void 0);
    _defineProperty(this, "_tail", void 0);
    _defineProperty(this, "_map", void 0);
    _defineProperty(this, "_keyMapper", void 0);
    this._maxSize = options.maxSize;
    this._size = 0;
    this._head = null;
    this._tail = null;
    this._map = /* @__PURE__ */ new Map();
    this._keyMapper = (_options$mapKey = options.mapKey) !== null && _options$mapKey !== void 0 ? _options$mapKey : (v) => v;
  }
  head() {
    return this._head;
  }
  tail() {
    return this._tail;
  }
  size() {
    return this._size;
  }
  maxSize() {
    return this._maxSize;
  }
  has(key) {
    return this._map.has(this._keyMapper(key));
  }
  get(key) {
    const mappedKey = this._keyMapper(key);
    const node81 = this._map.get(mappedKey);
    if (!node81) {
      return void 0;
    }
    this.set(key, node81.value);
    return node81.value;
  }
  set(key, val) {
    const mappedKey = this._keyMapper(key);
    const existingNode = this._map.get(mappedKey);
    if (existingNode) {
      this.delete(key);
    }
    const head = this.head();
    const node81 = {
      key,
      right: head,
      left: null,
      value: val
    };
    if (head) {
      head.left = node81;
    } else {
      this._tail = node81;
    }
    this._map.set(mappedKey, node81);
    this._head = node81;
    this._size++;
    this._maybeDeleteLRU();
  }
  _maybeDeleteLRU() {
    if (this.size() > this.maxSize()) {
      this.deleteLru();
    }
  }
  deleteLru() {
    const tail = this.tail();
    if (tail) {
      this.delete(tail.key);
    }
  }
  delete(key) {
    const mappedKey = this._keyMapper(key);
    if (!this._size || !this._map.has(mappedKey)) {
      return;
    }
    const node81 = Recoil_nullthrows(this._map.get(mappedKey));
    const right = node81.right;
    const left = node81.left;
    if (right) {
      right.left = node81.left;
    }
    if (left) {
      left.right = node81.right;
    }
    if (node81 === this.head()) {
      this._head = right;
    }
    if (node81 === this.tail()) {
      this._tail = left;
    }
    this._map.delete(mappedKey);
    this._size--;
  }
  clear() {
    this._size = 0;
    this._head = null;
    this._tail = null;
    this._map = /* @__PURE__ */ new Map();
  }
};
var Recoil_LRUCache = {
  LRUCache
};
var Recoil_LRUCache_1 = Recoil_LRUCache.LRUCache;
var Recoil_LRUCache$1 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  LRUCache: Recoil_LRUCache_1
});
var {
  LRUCache: LRUCache$1
} = Recoil_LRUCache$1;
var {
  TreeCache: TreeCache$1
} = Recoil_TreeCache$1;
function treeCacheLRU({
  name,
  maxSize,
  mapNodeValue = (v) => v
}) {
  const lruCache = new LRUCache$1({
    maxSize
  });
  const cache = new TreeCache$1({
    name,
    mapNodeValue,
    onHit: (node81) => {
      lruCache.set(node81, true);
    },
    onSet: (node81) => {
      const lruNode = lruCache.tail();
      lruCache.set(node81, true);
      if (lruNode && cache.size() > maxSize) {
        cache.delete(lruNode.key);
      }
    }
  });
  return cache;
}
var Recoil_treeCacheLRU = treeCacheLRU;
var TIME_WARNING_THRESHOLD_MS = 15;
function stringify(x, opt, key) {
  if (typeof x === "string" && !x.includes('"') && !x.includes("\\")) {
    return `"${x}"`;
  }
  switch (typeof x) {
    case "undefined":
      return "";
    case "boolean":
      return x ? "true" : "false";
    case "number":
    case "symbol":
      return String(x);
    case "string":
      return JSON.stringify(x);
    case "function":
      if ((opt === null || opt === void 0 ? void 0 : opt.allowFunctions) !== true) {
        throw Recoil_err("Attempt to serialize function in a Recoil cache key");
      }
      return `__FUNCTION(${x.name})__`;
  }
  if (x === null) {
    return "null";
  }
  if (typeof x !== "object") {
    var _JSON$stringify;
    return (_JSON$stringify = JSON.stringify(x)) !== null && _JSON$stringify !== void 0 ? _JSON$stringify : "";
  }
  if (Recoil_isPromise(x)) {
    return "__PROMISE__";
  }
  if (Array.isArray(x)) {
    return `[${x.map((v, i) => stringify(v, opt, i.toString()))}]`;
  }
  if (typeof x.toJSON === "function") {
    return stringify(x.toJSON(key), opt, key);
  }
  if (x instanceof Map) {
    const obj = {};
    for (const [k, v] of x) {
      obj[typeof k === "string" ? k : stringify(k, opt)] = v;
    }
    return stringify(obj, opt, key);
  }
  if (x instanceof Set) {
    return stringify(
      // $FlowFixMe[missing-local-annot]
      Array.from(x).sort((a, b) => stringify(a, opt).localeCompare(stringify(b, opt))),
      opt,
      key
    );
  }
  if (Symbol !== void 0 && x[Symbol.iterator] != null && typeof x[Symbol.iterator] === "function") {
    return stringify(Array.from(x), opt, key);
  }
  return `{${Object.keys(x).filter((k) => x[k] !== void 0).sort().map((k) => `${stringify(k, opt)}:${stringify(x[k], opt, k)}`).join(",")}}`;
}
function stableStringify(x, opt = {
  allowFunctions: false
}) {
  if (process.env.NODE_ENV !== "production") {
    if (typeof window !== "undefined") {
      const startTime = window.performance ? window.performance.now() : 0;
      const str = stringify(x, opt);
      const endTime = window.performance ? window.performance.now() : 0;
      if (endTime - startTime > TIME_WARNING_THRESHOLD_MS) {
        console.groupCollapsed(`Recoil: Spent ${endTime - startTime}ms computing a cache key`);
        console.warn(x, str);
        console.groupEnd();
      }
      return str;
    }
  }
  return stringify(x, opt);
}
var Recoil_stableStringify = stableStringify;
var {
  TreeCache: TreeCache$2
} = Recoil_TreeCache$1;
var defaultPolicy = {
  equality: "reference",
  eviction: "keep-all",
  maxSize: Infinity
};
function treeCacheFromPolicy({
  equality = defaultPolicy.equality,
  eviction = defaultPolicy.eviction,
  maxSize = defaultPolicy.maxSize
} = defaultPolicy, name) {
  const valueMapper = getValueMapper(equality);
  return getTreeCache(eviction, maxSize, valueMapper, name);
}
function getValueMapper(equality) {
  switch (equality) {
    case "reference":
      return (val) => val;
    case "value":
      return (val) => Recoil_stableStringify(val);
  }
  throw Recoil_err(`Unrecognized equality policy ${equality}`);
}
function getTreeCache(eviction, maxSize, mapNodeValue, name) {
  switch (eviction) {
    case "keep-all":
      return new TreeCache$2({
        name,
        mapNodeValue
      });
    case "lru":
      return Recoil_treeCacheLRU({
        name,
        maxSize: Recoil_nullthrows(maxSize),
        mapNodeValue
      });
    case "most-recent":
      return Recoil_treeCacheLRU({
        name,
        maxSize: 1,
        mapNodeValue
      });
  }
  throw Recoil_err(`Unrecognized eviction policy ${eviction}`);
}
var Recoil_treeCacheFromPolicy = treeCacheFromPolicy;
function isNode(object7) {
  var _ownerDocument, _doc$defaultView;
  if (typeof window === "undefined") {
    return false;
  }
  const doc = object7 != null ? (_ownerDocument = object7.ownerDocument) !== null && _ownerDocument !== void 0 ? _ownerDocument : object7 : document;
  const defaultView = (_doc$defaultView = doc.defaultView) !== null && _doc$defaultView !== void 0 ? _doc$defaultView : window;
  return !!(object7 != null && (typeof defaultView.Node === "function" ? object7 instanceof defaultView.Node : typeof object7 === "object" && typeof object7.nodeType === "number" && typeof object7.nodeName === "string"));
}
var Recoil_isNode = isNode;
var {
  isReactNative: isReactNative$1,
  isWindow: isWindow$1
} = Recoil_Environment;
function shouldNotBeFrozen(value) {
  if (value === null || typeof value !== "object") {
    return true;
  }
  switch (typeof value.$$typeof) {
    case "symbol":
      return true;
    case "number":
      return true;
  }
  if (value["@@__IMMUTABLE_ITERABLE__@@"] != null || value["@@__IMMUTABLE_KEYED__@@"] != null || value["@@__IMMUTABLE_INDEXED__@@"] != null || value["@@__IMMUTABLE_ORDERED__@@"] != null || value["@@__IMMUTABLE_RECORD__@@"] != null) {
    return true;
  }
  if (Recoil_isNode(value)) {
    return true;
  }
  if (Recoil_isPromise(value)) {
    return true;
  }
  if (value instanceof Error) {
    return true;
  }
  if (ArrayBuffer.isView(value)) {
    return true;
  }
  if (!isReactNative$1 && isWindow$1(value)) {
    return true;
  }
  return false;
}
function deepFreezeValue(value) {
  if (typeof value !== "object" || shouldNotBeFrozen(value)) {
    return;
  }
  Object.freeze(value);
  for (const key in value) {
    if (Object.prototype.hasOwnProperty.call(value, key)) {
      const prop = value[key];
      if (typeof prop === "object" && prop != null && !Object.isFrozen(prop)) {
        deepFreezeValue(prop);
      }
    }
  }
  Object.seal(value);
}
var Recoil_deepFreezeValue = deepFreezeValue;
function startPerfBlock(_id) {
  return () => null;
}
var Recoil_PerformanceTimings = {
  startPerfBlock
};
var {
  isLoadable: isLoadable$1,
  loadableWithError: loadableWithError$1,
  loadableWithPromise: loadableWithPromise$1,
  loadableWithValue: loadableWithValue$2
} = Recoil_Loadable$1;
var {
  WrappedValue: WrappedValue$1
} = Recoil_Wrapper$1;
var {
  getNodeLoadable: getNodeLoadable$2,
  peekNodeLoadable: peekNodeLoadable$1,
  setNodeValue: setNodeValue$3
} = Recoil_FunctionalCore;
var {
  saveDepsToStore: saveDepsToStore$1
} = Recoil_Graph;
var {
  DEFAULT_VALUE: DEFAULT_VALUE$6,
  getConfigDeletionHandler: getConfigDeletionHandler$1,
  getNode: getNode$6,
  registerNode: registerNode$1
} = Recoil_Node;
var {
  isRecoilValue: isRecoilValue$3
} = Recoil_RecoilValue$1;
var {
  markRecoilValueModified: markRecoilValueModified$1
} = Recoil_RecoilValueInterface;
var {
  retainedByOptionWithDefault: retainedByOptionWithDefault$1
} = Recoil_Retention;
var {
  recoilCallback: recoilCallback$1
} = Recoil_useRecoilCallback;
var {
  startPerfBlock: startPerfBlock$1
} = Recoil_PerformanceTimings;
var Canceled = class {
};
var CANCELED = new Canceled();
var dependencyStack = [];
var waitingStores = /* @__PURE__ */ new Map();
var getNewExecutionID = (() => {
  let executionID = 0;
  return () => executionID++;
})();
function selector(options) {
  let recoilValue = null;
  const {
    key,
    get,
    cachePolicy_UNSTABLE: cachePolicy
  } = options;
  const set = options.set != null ? options.set : void 0;
  if (process.env.NODE_ENV !== "production") {
    if (typeof key !== "string") {
      throw Recoil_err("A key option with a unique string value must be provided when creating a selector.");
    }
    if (typeof get !== "function") {
      throw Recoil_err("Selectors must specify a get callback option to get the selector value.");
    }
  }
  const discoveredDependencyNodeKeys = /* @__PURE__ */ new Set();
  const cache = Recoil_treeCacheFromPolicy(cachePolicy !== null && cachePolicy !== void 0 ? cachePolicy : {
    equality: "reference",
    eviction: "keep-all"
  }, key);
  const retainedBy = retainedByOptionWithDefault$1(options.retainedBy_UNSTABLE);
  const executionInfoMap = /* @__PURE__ */ new Map();
  let liveStoresCount = 0;
  function selectorIsLive() {
    return !Recoil_gkx("recoil_memory_managament_2020") || liveStoresCount > 0;
  }
  function selectorInit(store) {
    store.getState().knownSelectors.add(key);
    liveStoresCount++;
    return () => {
      liveStoresCount--;
    };
  }
  function selectorShouldDeleteConfigOnRelease() {
    return getConfigDeletionHandler$1(key) !== void 0 && !selectorIsLive();
  }
  function resolveAsync(store, state, executionID, loadable, depValues) {
    setCache(state, loadable, depValues);
    notifyStoresOfResolvedAsync(store, executionID);
  }
  function notifyStoresOfResolvedAsync(store, executionID) {
    if (isLatestExecution(store, executionID)) {
      clearExecutionInfo(store);
    }
    notifyWaitingStores(executionID, true);
  }
  function notifyStoresOfNewAsyncDep(store, executionID) {
    if (isLatestExecution(store, executionID)) {
      const executionInfo = Recoil_nullthrows(getExecutionInfo(store));
      executionInfo.stateVersions.clear();
      notifyWaitingStores(executionID, false);
    }
  }
  function notifyWaitingStores(executionID, clearWaitlist) {
    const stores = waitingStores.get(executionID);
    if (stores != null) {
      for (const waitingStore of stores) {
        markRecoilValueModified$1(waitingStore, Recoil_nullthrows(recoilValue));
      }
      if (clearWaitlist) {
        waitingStores.delete(executionID);
      }
    }
  }
  function markStoreWaitingForResolvedAsync(store, executionID) {
    let stores = waitingStores.get(executionID);
    if (stores == null) {
      waitingStores.set(executionID, stores = /* @__PURE__ */ new Set());
    }
    stores.add(store);
  }
  function wrapResultPromise(store, promise, state, depValues, executionID, loadingDepsState) {
    return promise.then((value) => {
      if (!selectorIsLive()) {
        clearExecutionInfo(store);
        throw CANCELED;
      }
      const loadable = loadableWithValue$2(value);
      resolveAsync(store, state, executionID, loadable, depValues);
      return value;
    }).catch((errorOrPromise) => {
      if (!selectorIsLive()) {
        clearExecutionInfo(store);
        throw CANCELED;
      }
      if (Recoil_isPromise(errorOrPromise)) {
        return wrapPendingDependencyPromise(store, errorOrPromise, state, depValues, executionID, loadingDepsState);
      }
      const loadable = loadableWithError$1(errorOrPromise);
      resolveAsync(store, state, executionID, loadable, depValues);
      throw errorOrPromise;
    });
  }
  function wrapPendingDependencyPromise(store, promise, state, existingDeps, executionID, loadingDepsState) {
    return promise.then((resolvedDep) => {
      if (!selectorIsLive()) {
        clearExecutionInfo(store);
        throw CANCELED;
      }
      if (loadingDepsState.loadingDepKey != null && loadingDepsState.loadingDepPromise === promise) {
        state.atomValues.set(loadingDepsState.loadingDepKey, loadableWithValue$2(resolvedDep));
      } else {
        store.getState().knownSelectors.forEach((nodeKey) => {
          state.atomValues.delete(nodeKey);
        });
      }
      const cachedLoadable = getLoadableFromCacheAndUpdateDeps(store, state);
      if (cachedLoadable && cachedLoadable.state !== "loading") {
        if (isLatestExecution(store, executionID) || getExecutionInfo(store) == null) {
          notifyStoresOfResolvedAsync(store, executionID);
        }
        if (cachedLoadable.state === "hasValue") {
          return cachedLoadable.contents;
        } else {
          throw cachedLoadable.contents;
        }
      }
      if (!isLatestExecution(store, executionID)) {
        const executionInfo = getInProgressExecutionInfo(store, state);
        if (executionInfo != null) {
          return executionInfo.loadingLoadable.contents;
        }
      }
      const [loadable, depValues] = evaluateSelectorGetter(store, state, executionID);
      if (loadable.state !== "loading") {
        resolveAsync(store, state, executionID, loadable, depValues);
      }
      if (loadable.state === "hasError") {
        throw loadable.contents;
      }
      return loadable.contents;
    }).catch((error) => {
      if (error instanceof Canceled) {
        throw CANCELED;
      }
      if (!selectorIsLive()) {
        clearExecutionInfo(store);
        throw CANCELED;
      }
      const loadable = loadableWithError$1(error);
      resolveAsync(store, state, executionID, loadable, existingDeps);
      throw error;
    });
  }
  function updateDeps(store, state, deps, executionID) {
    var _store$getState, _store$getState$curre, _store$getState2, _store$getState2$next;
    if (isLatestExecution(store, executionID) || state.version === ((_store$getState = store.getState()) === null || _store$getState === void 0 ? void 0 : (_store$getState$curre = _store$getState.currentTree) === null || _store$getState$curre === void 0 ? void 0 : _store$getState$curre.version) || state.version === ((_store$getState2 = store.getState()) === null || _store$getState2 === void 0 ? void 0 : (_store$getState2$next = _store$getState2.nextTree) === null || _store$getState2$next === void 0 ? void 0 : _store$getState2$next.version)) {
      var _store$getState$nextT, _store$getState3, _store$getState3$next;
      saveDepsToStore$1(key, deps, store, (_store$getState$nextT = (_store$getState3 = store.getState()) === null || _store$getState3 === void 0 ? void 0 : (_store$getState3$next = _store$getState3.nextTree) === null || _store$getState3$next === void 0 ? void 0 : _store$getState3$next.version) !== null && _store$getState$nextT !== void 0 ? _store$getState$nextT : store.getState().currentTree.version);
    }
    for (const nodeKey of deps) {
      discoveredDependencyNodeKeys.add(nodeKey);
    }
  }
  function evaluateSelectorGetter(store, state, executionID) {
    const endPerfBlock = startPerfBlock$1(key);
    let duringSynchronousExecution = true;
    let duringAsynchronousExecution = true;
    const finishEvaluation = () => {
      endPerfBlock();
      duringAsynchronousExecution = false;
    };
    let result;
    let resultIsError = false;
    let loadable;
    const loadingDepsState = {
      loadingDepKey: null,
      loadingDepPromise: null
    };
    const depValues = /* @__PURE__ */ new Map();
    function getRecoilValue({
      key: depKey
    }) {
      const depLoadable = getNodeLoadable$2(store, state, depKey);
      depValues.set(depKey, depLoadable);
      if (!duringSynchronousExecution) {
        updateDeps(store, state, new Set(depValues.keys()), executionID);
        notifyStoresOfNewAsyncDep(store, executionID);
      }
      switch (depLoadable.state) {
        case "hasValue":
          return depLoadable.contents;
        case "hasError":
          throw depLoadable.contents;
        case "loading":
          loadingDepsState.loadingDepKey = depKey;
          loadingDepsState.loadingDepPromise = depLoadable.contents;
          throw depLoadable.contents;
      }
      throw Recoil_err("Invalid Loadable state");
    }
    const getCallback = (fn) => {
      return (...args) => {
        if (duringAsynchronousExecution) {
          throw Recoil_err("Callbacks from getCallback() should only be called asynchronously after the selector is evalutated.  It can be used for selectors to return objects with callbacks that can work with Recoil state without a subscription.");
        }
        !(recoilValue != null) ? process.env.NODE_ENV !== "production" ? Recoil_invariant(false, "Recoil Value can never be null") : Recoil_invariant(false) : void 0;
        return recoilCallback$1(
          store,
          fn,
          args,
          {
            node: recoilValue
          }
          // flowlint-line unclear-type:off
        );
      };
    };
    try {
      result = get({
        get: getRecoilValue,
        getCallback
      });
      result = isRecoilValue$3(result) ? getRecoilValue(result) : result;
      if (isLoadable$1(result)) {
        if (result.state === "hasError") {
          resultIsError = true;
        }
        result = result.contents;
      }
      if (Recoil_isPromise(result)) {
        result = wrapResultPromise(store, result, state, depValues, executionID, loadingDepsState).finally(finishEvaluation);
      } else {
        finishEvaluation();
      }
      result = result instanceof WrappedValue$1 ? result.value : result;
    } catch (errorOrDepPromise) {
      result = errorOrDepPromise;
      if (Recoil_isPromise(result)) {
        result = wrapPendingDependencyPromise(store, result, state, depValues, executionID, loadingDepsState).finally(finishEvaluation);
      } else {
        resultIsError = true;
        finishEvaluation();
      }
    }
    if (resultIsError) {
      loadable = loadableWithError$1(result);
    } else if (Recoil_isPromise(result)) {
      loadable = loadableWithPromise$1(result);
    } else {
      loadable = loadableWithValue$2(result);
    }
    duringSynchronousExecution = false;
    updateExecutionInfoDepValues(store, executionID, depValues);
    updateDeps(store, state, new Set(depValues.keys()), executionID);
    return [loadable, depValues];
  }
  function getLoadableFromCacheAndUpdateDeps(store, state) {
    let cachedLoadable = state.atomValues.get(key);
    if (cachedLoadable != null) {
      return cachedLoadable;
    }
    const depsAfterCacheLookup = /* @__PURE__ */ new Set();
    try {
      cachedLoadable = cache.get((nodeKey) => {
        !(typeof nodeKey === "string") ? process.env.NODE_ENV !== "production" ? Recoil_invariant(false, "Cache nodeKey is type string") : Recoil_invariant(false) : void 0;
        return getNodeLoadable$2(store, state, nodeKey).contents;
      }, {
        onNodeVisit: (node81) => {
          if (node81.type === "branch" && node81.nodeKey !== key) {
            depsAfterCacheLookup.add(node81.nodeKey);
          }
        }
      });
    } catch (error) {
      throw Recoil_err(`Problem with cache lookup for selector "${key}": ${error.message}`);
    }
    if (cachedLoadable) {
      var _getExecutionInfo;
      state.atomValues.set(key, cachedLoadable);
      updateDeps(store, state, depsAfterCacheLookup, (_getExecutionInfo = getExecutionInfo(store)) === null || _getExecutionInfo === void 0 ? void 0 : _getExecutionInfo.executionID);
    }
    return cachedLoadable;
  }
  function getSelectorLoadableAndUpdateDeps(store, state) {
    const cachedVal = getLoadableFromCacheAndUpdateDeps(store, state);
    if (cachedVal != null) {
      clearExecutionInfo(store);
      return cachedVal;
    }
    const inProgressExecutionInfo = getInProgressExecutionInfo(store, state);
    if (inProgressExecutionInfo != null) {
      var _inProgressExecutionI;
      if (((_inProgressExecutionI = inProgressExecutionInfo.loadingLoadable) === null || _inProgressExecutionI === void 0 ? void 0 : _inProgressExecutionI.state) === "loading") {
        markStoreWaitingForResolvedAsync(store, inProgressExecutionInfo.executionID);
      }
      return inProgressExecutionInfo.loadingLoadable;
    }
    const newExecutionID = getNewExecutionID();
    const [loadable, newDepValues] = evaluateSelectorGetter(store, state, newExecutionID);
    if (loadable.state === "loading") {
      setExecutionInfo(store, newExecutionID, loadable, newDepValues, state);
      markStoreWaitingForResolvedAsync(store, newExecutionID);
    } else {
      clearExecutionInfo(store);
      setCache(state, loadable, newDepValues);
    }
    return loadable;
  }
  function getInProgressExecutionInfo(store, state) {
    const pendingExecutions = Recoil_concatIterables([executionInfoMap.has(store) ? [Recoil_nullthrows(executionInfoMap.get(store))] : [], Recoil_mapIterable(Recoil_filterIterable(executionInfoMap, ([s]) => s !== store), ([, execInfo]) => execInfo)]);
    function anyDepChanged(execDepValues) {
      for (const [depKey, execLoadable] of execDepValues) {
        if (!getNodeLoadable$2(store, state, depKey).is(execLoadable)) {
          return true;
        }
      }
      return false;
    }
    for (const execInfo of pendingExecutions) {
      if (
        // If this execution was already checked to be valid with this version
        // of state, then let's use it!
        execInfo.stateVersions.get(state.version) || // If the deps for the execution match our current state, then it's valid
        !anyDepChanged(execInfo.depValuesDiscoveredSoFarDuringAsyncWork)
      ) {
        execInfo.stateVersions.set(state.version, true);
        return execInfo;
      } else {
        execInfo.stateVersions.set(state.version, false);
      }
    }
    return void 0;
  }
  function getExecutionInfo(store) {
    return executionInfoMap.get(store);
  }
  function setExecutionInfo(store, newExecutionID, loadable, depValues, state) {
    executionInfoMap.set(store, {
      depValuesDiscoveredSoFarDuringAsyncWork: depValues,
      executionID: newExecutionID,
      loadingLoadable: loadable,
      stateVersions: /* @__PURE__ */ new Map([[state.version, true]])
    });
  }
  function updateExecutionInfoDepValues(store, executionID, depValues) {
    if (isLatestExecution(store, executionID)) {
      const executionInfo = getExecutionInfo(store);
      if (executionInfo != null) {
        executionInfo.depValuesDiscoveredSoFarDuringAsyncWork = depValues;
      }
    }
  }
  function clearExecutionInfo(store) {
    executionInfoMap.delete(store);
  }
  function isLatestExecution(store, executionID) {
    var _getExecutionInfo2;
    return executionID === ((_getExecutionInfo2 = getExecutionInfo(store)) === null || _getExecutionInfo2 === void 0 ? void 0 : _getExecutionInfo2.executionID);
  }
  function depValuesToDepRoute(depValues) {
    return Array.from(depValues.entries()).map(([depKey, valLoadable]) => [depKey, valLoadable.contents]);
  }
  function setCache(state, loadable, depValues) {
    if (process.env.NODE_ENV !== "production") {
      if (loadable.state !== "loading" && Boolean(options.dangerouslyAllowMutability) === false) {
        Recoil_deepFreezeValue(loadable.contents);
      }
    }
    state.atomValues.set(key, loadable);
    try {
      cache.set(depValuesToDepRoute(depValues), loadable);
    } catch (error) {
      throw Recoil_err(`Problem with setting cache for selector "${key}": ${error.message}`);
    }
  }
  function detectCircularDependencies(fn) {
    if (dependencyStack.includes(key)) {
      const message = `Recoil selector has circular dependencies: ${dependencyStack.slice(dependencyStack.indexOf(key)).join(" \u2192 ")}`;
      return loadableWithError$1(Recoil_err(message));
    }
    dependencyStack.push(key);
    try {
      return fn();
    } finally {
      dependencyStack.pop();
    }
  }
  function selectorPeek(store, state) {
    const cachedLoadable = state.atomValues.get(key);
    if (cachedLoadable != null) {
      return cachedLoadable;
    }
    return cache.get((nodeKey) => {
      var _peekNodeLoadable;
      !(typeof nodeKey === "string") ? process.env.NODE_ENV !== "production" ? Recoil_invariant(false, "Cache nodeKey is type string") : Recoil_invariant(false) : void 0;
      return (_peekNodeLoadable = peekNodeLoadable$1(store, state, nodeKey)) === null || _peekNodeLoadable === void 0 ? void 0 : _peekNodeLoadable.contents;
    });
  }
  function selectorGet(store, state) {
    return detectCircularDependencies(() => getSelectorLoadableAndUpdateDeps(store, state));
  }
  function invalidateSelector(state) {
    state.atomValues.delete(key);
  }
  function clearSelectorCache(store, treeState) {
    !(recoilValue != null) ? process.env.NODE_ENV !== "production" ? Recoil_invariant(false, "Recoil Value can never be null") : Recoil_invariant(false) : void 0;
    for (const nodeKey of discoveredDependencyNodeKeys) {
      var _node$clearCache;
      const node81 = getNode$6(nodeKey);
      (_node$clearCache = node81.clearCache) === null || _node$clearCache === void 0 ? void 0 : _node$clearCache.call(node81, store, treeState);
    }
    discoveredDependencyNodeKeys.clear();
    invalidateSelector(treeState);
    cache.clear();
    markRecoilValueModified$1(store, recoilValue);
  }
  if (set != null) {
    const selectorSet = (store, state, newValue) => {
      let syncSelectorSetFinished = false;
      const writes = /* @__PURE__ */ new Map();
      function getRecoilValue({
        key: depKey
      }) {
        if (syncSelectorSetFinished) {
          throw Recoil_err("Recoil: Async selector sets are not currently supported.");
        }
        const loadable = getNodeLoadable$2(store, state, depKey);
        if (loadable.state === "hasValue") {
          return loadable.contents;
        } else if (loadable.state === "loading") {
          const msg = `Getting value of asynchronous atom or selector "${depKey}" in a pending state while setting selector "${key}" is not yet supported.`;
          Recoil_recoverableViolation(msg);
          throw Recoil_err(msg);
        } else {
          throw loadable.contents;
        }
      }
      function setRecoilState(recoilState, valueOrUpdater) {
        if (syncSelectorSetFinished) {
          const msg = "Recoil: Async selector sets are not currently supported.";
          Recoil_recoverableViolation(msg);
          throw Recoil_err(msg);
        }
        const setValue = typeof valueOrUpdater === "function" ? (
          // cast to any because we can't restrict type S from being a function itself without losing support for opaque types
          // flowlint-next-line unclear-type:off
          valueOrUpdater(getRecoilValue(recoilState))
        ) : valueOrUpdater;
        const upstreamWrites = setNodeValue$3(store, state, recoilState.key, setValue);
        upstreamWrites.forEach((v, k) => writes.set(k, v));
      }
      function resetRecoilState(recoilState) {
        setRecoilState(recoilState, DEFAULT_VALUE$6);
      }
      const ret = set({
        set: setRecoilState,
        get: getRecoilValue,
        reset: resetRecoilState
      }, newValue);
      if (ret !== void 0) {
        throw Recoil_isPromise(ret) ? Recoil_err("Recoil: Async selector sets are not currently supported.") : Recoil_err("Recoil: selector set should be a void function.");
      }
      syncSelectorSetFinished = true;
      return writes;
    };
    return recoilValue = registerNode$1({
      key,
      nodeType: "selector",
      peek: selectorPeek,
      get: selectorGet,
      set: selectorSet,
      init: selectorInit,
      invalidate: invalidateSelector,
      clearCache: clearSelectorCache,
      shouldDeleteConfigOnRelease: selectorShouldDeleteConfigOnRelease,
      dangerouslyAllowMutability: options.dangerouslyAllowMutability,
      shouldRestoreFromSnapshots: false,
      retainedBy
    });
  } else {
    return recoilValue = registerNode$1({
      key,
      nodeType: "selector",
      peek: selectorPeek,
      get: selectorGet,
      init: selectorInit,
      invalidate: invalidateSelector,
      clearCache: clearSelectorCache,
      shouldDeleteConfigOnRelease: selectorShouldDeleteConfigOnRelease,
      dangerouslyAllowMutability: options.dangerouslyAllowMutability,
      shouldRestoreFromSnapshots: false,
      retainedBy
    });
  }
}
selector.value = (value) => new WrappedValue$1(value);
var Recoil_selector = selector;
var {
  isLoadable: isLoadable$2,
  loadableWithError: loadableWithError$2,
  loadableWithPromise: loadableWithPromise$2,
  loadableWithValue: loadableWithValue$3
} = Recoil_Loadable$1;
var {
  WrappedValue: WrappedValue$2
} = Recoil_Wrapper$1;
var {
  peekNodeInfo: peekNodeInfo$3
} = Recoil_FunctionalCore;
var {
  DEFAULT_VALUE: DEFAULT_VALUE$7,
  DefaultValue: DefaultValue$2,
  getConfigDeletionHandler: getConfigDeletionHandler$2,
  registerNode: registerNode$2,
  setConfigDeletionHandler: setConfigDeletionHandler$1
} = Recoil_Node;
var {
  isRecoilValue: isRecoilValue$4
} = Recoil_RecoilValue$1;
var {
  getRecoilValueAsLoadable: getRecoilValueAsLoadable$4,
  markRecoilValueModified: markRecoilValueModified$2,
  setRecoilValue: setRecoilValue$4,
  setRecoilValueLoadable: setRecoilValueLoadable$2
} = Recoil_RecoilValueInterface;
var {
  retainedByOptionWithDefault: retainedByOptionWithDefault$2
} = Recoil_Retention;
var unwrap = (x) => x instanceof WrappedValue$2 ? x.value : x;
function baseAtom(options) {
  const {
    key,
    persistence_UNSTABLE: persistence
  } = options;
  const retainedBy = retainedByOptionWithDefault$2(options.retainedBy_UNSTABLE);
  let liveStoresCount = 0;
  function unwrapPromise(promise) {
    return loadableWithPromise$2(promise.then((value) => {
      defaultLoadable = loadableWithValue$3(value);
      return value;
    }).catch((error) => {
      defaultLoadable = loadableWithError$2(error);
      throw error;
    }));
  }
  let defaultLoadable = Recoil_isPromise(options.default) ? unwrapPromise(options.default) : isLoadable$2(options.default) ? options.default.state === "loading" ? unwrapPromise(options.default.contents) : options.default : (
    // $FlowFixMe[incompatible-call]
    loadableWithValue$3(unwrap(options.default))
  );
  maybeFreezeValueOrPromise(defaultLoadable.contents);
  let cachedAnswerForUnvalidatedValue = void 0;
  const cleanupEffectsByStore = /* @__PURE__ */ new Map();
  function maybeFreezeValueOrPromise(valueOrPromise) {
    if (process.env.NODE_ENV !== "production") {
      if (options.dangerouslyAllowMutability !== true) {
        if (Recoil_isPromise(valueOrPromise)) {
          return valueOrPromise.then((value) => {
            Recoil_deepFreezeValue(value);
            return value;
          });
        } else {
          Recoil_deepFreezeValue(valueOrPromise);
          return valueOrPromise;
        }
      }
    }
    return valueOrPromise;
  }
  function wrapPendingPromise(store, promise) {
    const wrappedPromise = promise.then((value) => {
      var _store$getState$nextT, _state$atomValues$get;
      const state = (_store$getState$nextT = store.getState().nextTree) !== null && _store$getState$nextT !== void 0 ? _store$getState$nextT : store.getState().currentTree;
      if (((_state$atomValues$get = state.atomValues.get(key)) === null || _state$atomValues$get === void 0 ? void 0 : _state$atomValues$get.contents) === wrappedPromise) {
        setRecoilValue$4(store, node81, value);
      }
      return value;
    }).catch((error) => {
      var _store$getState$nextT2, _state$atomValues$get2;
      const state = (_store$getState$nextT2 = store.getState().nextTree) !== null && _store$getState$nextT2 !== void 0 ? _store$getState$nextT2 : store.getState().currentTree;
      if (((_state$atomValues$get2 = state.atomValues.get(key)) === null || _state$atomValues$get2 === void 0 ? void 0 : _state$atomValues$get2.contents) === wrappedPromise) {
        setRecoilValueLoadable$2(store, node81, loadableWithError$2(error));
      }
      throw error;
    });
    return wrappedPromise;
  }
  function initAtom(store, initState, trigger) {
    var _options$effects;
    liveStoresCount++;
    const cleanupAtom = () => {
      var _cleanupEffectsByStor;
      liveStoresCount--;
      (_cleanupEffectsByStor = cleanupEffectsByStore.get(store)) === null || _cleanupEffectsByStor === void 0 ? void 0 : _cleanupEffectsByStor.forEach((cleanup) => cleanup());
      cleanupEffectsByStore.delete(store);
    };
    store.getState().knownAtoms.add(key);
    if (defaultLoadable.state === "loading") {
      const notifyDefaultSubscribers = () => {
        var _store$getState$nextT3;
        const state = (_store$getState$nextT3 = store.getState().nextTree) !== null && _store$getState$nextT3 !== void 0 ? _store$getState$nextT3 : store.getState().currentTree;
        if (!state.atomValues.has(key)) {
          markRecoilValueModified$2(store, node81);
        }
      };
      defaultLoadable.contents.finally(notifyDefaultSubscribers);
    }
    const effects = (_options$effects = options.effects) !== null && _options$effects !== void 0 ? _options$effects : options.effects_UNSTABLE;
    if (effects != null) {
      let getLoadable2 = function(recoilValue) {
        if (isDuringInit && recoilValue.key === key) {
          const retValue = initValue;
          return retValue instanceof DefaultValue$2 ? peekAtom(store, initState) : Recoil_isPromise(retValue) ? loadableWithPromise$2(retValue.then((v) => v instanceof DefaultValue$2 ? (
            // Cast T to S
            defaultLoadable.toPromise()
          ) : v)) : (
            // $FlowFixMe[incompatible-call]
            loadableWithValue$3(retValue)
          );
        }
        return getRecoilValueAsLoadable$4(store, recoilValue);
      }, getPromise2 = function(recoilValue) {
        return getLoadable2(recoilValue).toPromise();
      }, getInfo_UNSTABLE2 = function(recoilValue) {
        var _store$getState$nextT4;
        const info = peekNodeInfo$3(store, (_store$getState$nextT4 = store.getState().nextTree) !== null && _store$getState$nextT4 !== void 0 ? _store$getState$nextT4 : store.getState().currentTree, recoilValue.key);
        return isDuringInit && recoilValue.key === key && !(initValue instanceof DefaultValue$2) ? {
          ...info,
          isSet: true,
          loadable: getLoadable2(recoilValue)
        } : info;
      };
      var getLoadable = getLoadable2, getPromise = getPromise2, getInfo_UNSTABLE = getInfo_UNSTABLE2;
      let initValue = DEFAULT_VALUE$7;
      let isDuringInit = true;
      let isInitError = false;
      let pendingSetSelf = null;
      const setSelf = (effect) => (valueOrUpdater) => {
        if (isDuringInit) {
          const currentLoadable = getLoadable2(node81);
          const currentValue = currentLoadable.state === "hasValue" ? currentLoadable.contents : DEFAULT_VALUE$7;
          initValue = typeof valueOrUpdater === "function" ? (
            // cast to any because we can't restrict T from being a function without losing support for opaque types
            valueOrUpdater(currentValue)
          ) : valueOrUpdater;
          if (Recoil_isPromise(initValue)) {
            initValue = initValue.then((value) => {
              pendingSetSelf = {
                effect,
                value
              };
              return value;
            });
          }
        } else {
          if (Recoil_isPromise(valueOrUpdater)) {
            throw Recoil_err("Setting atoms to async values is not implemented.");
          }
          if (typeof valueOrUpdater !== "function") {
            pendingSetSelf = {
              effect,
              value: unwrap(valueOrUpdater)
            };
          }
          setRecoilValue$4(store, node81, typeof valueOrUpdater === "function" ? (currentValue) => {
            const newValue = unwrap(
              // cast to any because we can't restrict T from being a function without losing support for opaque types
              valueOrUpdater(currentValue)
              // flowlint-line unclear-type:off
            );
            pendingSetSelf = {
              effect,
              value: newValue
            };
            return newValue;
          } : unwrap(valueOrUpdater));
        }
      };
      const resetSelf = (effect) => () => setSelf(effect)(DEFAULT_VALUE$7);
      const onSet = (effect) => (handler) => {
        var _cleanupEffectsByStor2;
        const {
          release
        } = store.subscribeToTransactions((currentStore) => {
          var _currentTree$atomValu;
          let {
            currentTree,
            previousTree
          } = currentStore.getState();
          if (!previousTree) {
            Recoil_recoverableViolation("Transaction subscribers notified without a next tree being present -- this is a bug in Recoil");
            previousTree = currentTree;
          }
          const newLoadable = (_currentTree$atomValu = currentTree.atomValues.get(key)) !== null && _currentTree$atomValu !== void 0 ? _currentTree$atomValu : defaultLoadable;
          if (newLoadable.state === "hasValue") {
            var _previousTree$atomVal, _pendingSetSelf, _pendingSetSelf2, _pendingSetSelf3;
            const newValue = newLoadable.contents;
            const oldLoadable = (_previousTree$atomVal = previousTree.atomValues.get(key)) !== null && _previousTree$atomVal !== void 0 ? _previousTree$atomVal : defaultLoadable;
            const oldValue = oldLoadable.state === "hasValue" ? oldLoadable.contents : DEFAULT_VALUE$7;
            if (((_pendingSetSelf = pendingSetSelf) === null || _pendingSetSelf === void 0 ? void 0 : _pendingSetSelf.effect) !== effect || ((_pendingSetSelf2 = pendingSetSelf) === null || _pendingSetSelf2 === void 0 ? void 0 : _pendingSetSelf2.value) !== newValue) {
              handler(newValue, oldValue, !currentTree.atomValues.has(key));
            } else if (((_pendingSetSelf3 = pendingSetSelf) === null || _pendingSetSelf3 === void 0 ? void 0 : _pendingSetSelf3.effect) === effect) {
              pendingSetSelf = null;
            }
          }
        }, key);
        cleanupEffectsByStore.set(store, [...(_cleanupEffectsByStor2 = cleanupEffectsByStore.get(store)) !== null && _cleanupEffectsByStor2 !== void 0 ? _cleanupEffectsByStor2 : [], release]);
      };
      for (const effect of effects) {
        try {
          const cleanup = effect({
            node: node81,
            storeID: store.storeID,
            parentStoreID_UNSTABLE: store.parentStoreID,
            trigger,
            setSelf: setSelf(effect),
            resetSelf: resetSelf(effect),
            onSet: onSet(effect),
            getPromise: getPromise2,
            getLoadable: getLoadable2,
            getInfo_UNSTABLE: getInfo_UNSTABLE2
          });
          if (cleanup != null) {
            var _cleanupEffectsByStor3;
            cleanupEffectsByStore.set(store, [...(_cleanupEffectsByStor3 = cleanupEffectsByStore.get(store)) !== null && _cleanupEffectsByStor3 !== void 0 ? _cleanupEffectsByStor3 : [], cleanup]);
          }
        } catch (error) {
          initValue = error;
          isInitError = true;
        }
      }
      isDuringInit = false;
      if (!(initValue instanceof DefaultValue$2)) {
        var _store$getState$nextT5;
        const initLoadable = isInitError ? loadableWithError$2(initValue) : Recoil_isPromise(initValue) ? loadableWithPromise$2(wrapPendingPromise(store, initValue)) : loadableWithValue$3(unwrap(initValue));
        maybeFreezeValueOrPromise(initLoadable.contents);
        initState.atomValues.set(key, initLoadable);
        (_store$getState$nextT5 = store.getState().nextTree) === null || _store$getState$nextT5 === void 0 ? void 0 : _store$getState$nextT5.atomValues.set(key, initLoadable);
      }
    }
    return cleanupAtom;
  }
  function peekAtom(_store, state) {
    var _ref, _state$atomValues$get3;
    return (_ref = (_state$atomValues$get3 = state.atomValues.get(key)) !== null && _state$atomValues$get3 !== void 0 ? _state$atomValues$get3 : cachedAnswerForUnvalidatedValue) !== null && _ref !== void 0 ? _ref : defaultLoadable;
  }
  function getAtom(_store, state) {
    if (state.atomValues.has(key)) {
      return Recoil_nullthrows(state.atomValues.get(key));
    } else if (state.nonvalidatedAtoms.has(key)) {
      if (cachedAnswerForUnvalidatedValue != null) {
        return cachedAnswerForUnvalidatedValue;
      }
      if (persistence == null) {
        Recoil_expectationViolation(`Tried to restore a persisted value for atom ${key} but it has no persistence settings.`);
        return defaultLoadable;
      }
      const nonvalidatedValue = state.nonvalidatedAtoms.get(key);
      const validatorResult = persistence.validator(nonvalidatedValue, DEFAULT_VALUE$7);
      const validatedValueLoadable = validatorResult instanceof DefaultValue$2 ? defaultLoadable : loadableWithValue$3(validatorResult);
      cachedAnswerForUnvalidatedValue = validatedValueLoadable;
      return cachedAnswerForUnvalidatedValue;
    } else {
      return defaultLoadable;
    }
  }
  function invalidateAtom() {
    cachedAnswerForUnvalidatedValue = void 0;
  }
  function setAtom(_store, state, newValue) {
    if (state.atomValues.has(key)) {
      const existing = Recoil_nullthrows(state.atomValues.get(key));
      if (existing.state === "hasValue" && newValue === existing.contents) {
        return /* @__PURE__ */ new Map();
      }
    } else if (!state.nonvalidatedAtoms.has(key) && newValue instanceof DefaultValue$2) {
      return /* @__PURE__ */ new Map();
    }
    maybeFreezeValueOrPromise(newValue);
    cachedAnswerForUnvalidatedValue = void 0;
    return (/* @__PURE__ */ new Map()).set(key, loadableWithValue$3(newValue));
  }
  function shouldDeleteConfigOnReleaseAtom() {
    return getConfigDeletionHandler$2(key) !== void 0 && liveStoresCount <= 0;
  }
  const node81 = registerNode$2({
    key,
    nodeType: "atom",
    peek: peekAtom,
    get: getAtom,
    set: setAtom,
    init: initAtom,
    invalidate: invalidateAtom,
    shouldDeleteConfigOnRelease: shouldDeleteConfigOnReleaseAtom,
    dangerouslyAllowMutability: options.dangerouslyAllowMutability,
    persistence_UNSTABLE: options.persistence_UNSTABLE ? {
      type: options.persistence_UNSTABLE.type,
      backButton: options.persistence_UNSTABLE.backButton
    } : void 0,
    shouldRestoreFromSnapshots: true,
    retainedBy
  });
  return node81;
}
function atom2(options) {
  if (process.env.NODE_ENV !== "production") {
    if (typeof options.key !== "string") {
      throw Recoil_err("A key option with a unique string value must be provided when creating an atom.");
    }
  }
  const {
    // @fb-only: scopeRules_APPEND_ONLY_READ_THE_DOCS,
    ...restOptions
  } = options;
  const optionsDefault = "default" in options ? (
    // $FlowIssue[incompatible-type] No way to refine in Flow that property is not defined
    options.default
  ) : new Promise(() => {
  });
  if (isRecoilValue$4(optionsDefault)) {
    return atomWithFallback({
      ...restOptions,
      default: optionsDefault
      // @fb-only: scopeRules_APPEND_ONLY_READ_THE_DOCS,
    });
  } else {
    return baseAtom({
      ...restOptions,
      default: optionsDefault
    });
  }
}
function atomWithFallback(options) {
  const base = atom2({
    ...options,
    default: DEFAULT_VALUE$7,
    persistence_UNSTABLE: options.persistence_UNSTABLE === void 0 ? void 0 : {
      ...options.persistence_UNSTABLE,
      validator: (storedValue) => storedValue instanceof DefaultValue$2 ? storedValue : Recoil_nullthrows(options.persistence_UNSTABLE).validator(storedValue, DEFAULT_VALUE$7)
    },
    // TODO Hack for now.
    effects: options.effects,
    // flowlint-line unclear-type: off
    effects_UNSTABLE: options.effects_UNSTABLE
    // flowlint-line unclear-type: off
  });
  const sel = Recoil_selector({
    key: `${options.key}__withFallback`,
    get: ({
      get
    }) => {
      const baseValue = get(base);
      return baseValue instanceof DefaultValue$2 ? options.default : baseValue;
    },
    // $FlowFixMe[incompatible-call]
    set: ({
      set
    }, newValue) => set(base, newValue),
    // This selector does not need to cache as it is a wrapper selector
    // and the selector within the wrapper selector will have a cache
    // option by default
    cachePolicy_UNSTABLE: {
      eviction: "most-recent"
    },
    dangerouslyAllowMutability: options.dangerouslyAllowMutability
  });
  setConfigDeletionHandler$1(sel.key, getConfigDeletionHandler$2(options.key));
  return sel;
}
atom2.value = (value) => new WrappedValue$2(value);
var Recoil_atom = atom2;
var MapCache = class {
  constructor(options) {
    var _options$mapKey;
    _defineProperty(this, "_map", void 0);
    _defineProperty(this, "_keyMapper", void 0);
    this._map = /* @__PURE__ */ new Map();
    this._keyMapper = (_options$mapKey = options === null || options === void 0 ? void 0 : options.mapKey) !== null && _options$mapKey !== void 0 ? _options$mapKey : (v) => v;
  }
  size() {
    return this._map.size;
  }
  has(key) {
    return this._map.has(this._keyMapper(key));
  }
  get(key) {
    return this._map.get(this._keyMapper(key));
  }
  set(key, val) {
    this._map.set(this._keyMapper(key), val);
  }
  delete(key) {
    this._map.delete(this._keyMapper(key));
  }
  clear() {
    this._map.clear();
  }
};
var Recoil_MapCache = {
  MapCache
};
var Recoil_MapCache_1 = Recoil_MapCache.MapCache;
var Recoil_MapCache$1 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  MapCache: Recoil_MapCache_1
});
var {
  LRUCache: LRUCache$2
} = Recoil_LRUCache$1;
var {
  MapCache: MapCache$1
} = Recoil_MapCache$1;
var defaultPolicy$1 = {
  equality: "reference",
  eviction: "none",
  maxSize: Infinity
};
function cacheFromPolicy({
  equality = defaultPolicy$1.equality,
  eviction = defaultPolicy$1.eviction,
  maxSize = defaultPolicy$1.maxSize
} = defaultPolicy$1) {
  const valueMapper = getValueMapper$1(equality);
  const cache = getCache(eviction, maxSize, valueMapper);
  return cache;
}
function getValueMapper$1(equality) {
  switch (equality) {
    case "reference":
      return (val) => val;
    case "value":
      return (val) => Recoil_stableStringify(val);
  }
  throw Recoil_err(`Unrecognized equality policy ${equality}`);
}
function getCache(eviction, maxSize, mapKey) {
  switch (eviction) {
    case "keep-all":
      return new MapCache$1({
        mapKey
      });
    case "lru":
      return new LRUCache$2({
        mapKey,
        maxSize: Recoil_nullthrows(maxSize)
      });
    case "most-recent":
      return new LRUCache$2({
        mapKey,
        maxSize: 1
      });
  }
  throw Recoil_err(`Unrecognized eviction policy ${eviction}`);
}
var Recoil_cacheFromPolicy = cacheFromPolicy;
var {
  setConfigDeletionHandler: setConfigDeletionHandler$2
} = Recoil_Node;
function atomFamily(options) {
  var _options$cachePolicyF, _options$cachePolicyF2;
  const atomCache = Recoil_cacheFromPolicy({
    equality: (_options$cachePolicyF = (_options$cachePolicyF2 = options.cachePolicyForParams_UNSTABLE) === null || _options$cachePolicyF2 === void 0 ? void 0 : _options$cachePolicyF2.equality) !== null && _options$cachePolicyF !== void 0 ? _options$cachePolicyF : "value",
    eviction: "keep-all"
  });
  return (params) => {
    var _stableStringify, _options$effects;
    const cachedAtom = atomCache.get(params);
    if (cachedAtom != null) {
      return cachedAtom;
    }
    const {
      cachePolicyForParams_UNSTABLE,
      ...atomOptions
    } = options;
    const optionsDefault = "default" in options ? (
      // $FlowIssue[incompatible-type] No way to refine in Flow that property is not defined
      options.default
    ) : new Promise(() => {
    });
    const newAtom = Recoil_atom({
      ...atomOptions,
      key: `${options.key}__${(_stableStringify = Recoil_stableStringify(params)) !== null && _stableStringify !== void 0 ? _stableStringify : "void"}`,
      default: typeof optionsDefault === "function" ? (
        // The default was parameterized
        // Flow doesn't know that T isn't a function, so we need to case to any
        // $FlowIssue[incompatible-use]
        optionsDefault(params)
      ) : (
        // Default may be a static value, promise, or RecoilValue
        optionsDefault
      ),
      retainedBy_UNSTABLE: typeof options.retainedBy_UNSTABLE === "function" ? options.retainedBy_UNSTABLE(params) : options.retainedBy_UNSTABLE,
      effects: typeof options.effects === "function" ? options.effects(params) : typeof options.effects_UNSTABLE === "function" ? options.effects_UNSTABLE(params) : (_options$effects = options.effects) !== null && _options$effects !== void 0 ? _options$effects : options.effects_UNSTABLE
      // prettier-ignore
      // @fb-only: scopeRules_APPEND_ONLY_READ_THE_DOCS: mapScopeRules(
      // @fb-only: options.scopeRules_APPEND_ONLY_READ_THE_DOCS,
      // @fb-only: params,
      // @fb-only: ),
    });
    atomCache.set(params, newAtom);
    setConfigDeletionHandler$2(newAtom.key, () => {
      atomCache.delete(params);
    });
    return newAtom;
  };
}
var Recoil_atomFamily = atomFamily;
var {
  setConfigDeletionHandler: setConfigDeletionHandler$3
} = Recoil_Node;
var nextIndex = 0;
function selectorFamily(options) {
  var _options$cachePolicyF, _options$cachePolicyF2;
  const selectorCache = Recoil_cacheFromPolicy({
    equality: (_options$cachePolicyF = (_options$cachePolicyF2 = options.cachePolicyForParams_UNSTABLE) === null || _options$cachePolicyF2 === void 0 ? void 0 : _options$cachePolicyF2.equality) !== null && _options$cachePolicyF !== void 0 ? _options$cachePolicyF : "value",
    eviction: "keep-all"
  });
  return (params) => {
    var _stableStringify;
    let cachedSelector;
    try {
      cachedSelector = selectorCache.get(params);
    } catch (error) {
      throw Recoil_err(`Problem with cache lookup for selector ${options.key}: ${error.message}`);
    }
    if (cachedSelector != null) {
      return cachedSelector;
    }
    const myKey = `${options.key}__selectorFamily/${(_stableStringify = Recoil_stableStringify(params, {
      // It is possible to use functions in parameters if the user uses
      // a cache with reference equality thanks to the incrementing index.
      allowFunctions: true
    })) !== null && _stableStringify !== void 0 ? _stableStringify : "void"}/${nextIndex++}`;
    const myGet = (callbacks) => options.get(params)(callbacks);
    const myCachePolicy = options.cachePolicy_UNSTABLE;
    const retainedBy = typeof options.retainedBy_UNSTABLE === "function" ? options.retainedBy_UNSTABLE(params) : options.retainedBy_UNSTABLE;
    let newSelector;
    if (options.set != null) {
      const set = options.set;
      const mySet = (callbacks, newValue) => set(params)(callbacks, newValue);
      newSelector = Recoil_selector({
        key: myKey,
        get: myGet,
        set: mySet,
        cachePolicy_UNSTABLE: myCachePolicy,
        dangerouslyAllowMutability: options.dangerouslyAllowMutability,
        retainedBy_UNSTABLE: retainedBy
      });
    } else {
      newSelector = Recoil_selector({
        key: myKey,
        get: myGet,
        cachePolicy_UNSTABLE: myCachePolicy,
        dangerouslyAllowMutability: options.dangerouslyAllowMutability,
        retainedBy_UNSTABLE: retainedBy
      });
    }
    selectorCache.set(params, newSelector);
    setConfigDeletionHandler$3(newSelector.key, () => {
      selectorCache.delete(params);
    });
    return newSelector;
  };
}
var Recoil_selectorFamily = selectorFamily;
var constantSelector = Recoil_selectorFamily({
  key: "__constant",
  get: (constant) => () => constant,
  cachePolicyForParams_UNSTABLE: {
    equality: "reference"
  }
});
function constSelector(constant) {
  return constantSelector(constant);
}
var Recoil_constSelector = constSelector;
var throwingSelector = Recoil_selectorFamily({
  key: "__error",
  get: (message) => () => {
    throw Recoil_err(message);
  },
  // TODO Why?
  cachePolicyForParams_UNSTABLE: {
    equality: "reference"
  }
});
function errorSelector(message) {
  return throwingSelector(message);
}
var Recoil_errorSelector = errorSelector;
function readOnlySelector(atom3) {
  return atom3;
}
var Recoil_readOnlySelector = readOnlySelector;
var {
  loadableWithError: loadableWithError$3,
  loadableWithPromise: loadableWithPromise$3,
  loadableWithValue: loadableWithValue$4
} = Recoil_Loadable$1;
function concurrentRequests(getRecoilValue, deps) {
  const results = Array(deps.length).fill(void 0);
  const exceptions = Array(deps.length).fill(void 0);
  for (const [i, dep] of deps.entries()) {
    try {
      results[i] = getRecoilValue(dep);
    } catch (e) {
      exceptions[i] = e;
    }
  }
  return [results, exceptions];
}
function isError(exp) {
  return exp != null && !Recoil_isPromise(exp);
}
function unwrapDependencies(dependencies) {
  return Array.isArray(dependencies) ? dependencies : Object.getOwnPropertyNames(dependencies).map((key) => dependencies[key]);
}
function wrapResults(dependencies, results) {
  return Array.isArray(dependencies) ? results : (
    // Object.getOwnPropertyNames() has consistent key ordering with ES6
    Object.getOwnPropertyNames(dependencies).reduce((out, key, idx) => ({
      ...out,
      [key]: results[idx]
    }), {})
  );
}
function wrapLoadables(dependencies, results, exceptions) {
  const output = exceptions.map((exception, idx) => exception == null ? loadableWithValue$4(results[idx]) : Recoil_isPromise(exception) ? loadableWithPromise$3(exception) : loadableWithError$3(exception));
  return wrapResults(dependencies, output);
}
function combineAsyncResultsWithSyncResults(syncResults, asyncResults) {
  return asyncResults.map((result, idx) => (
    /**
     * it's important we use === undefined as opposed to == null, because the
     * resolved value of the async promise could be `null`, in which case we
     * don't want to use syncResults[idx], which would be undefined. If async
     * promise resolves to `undefined`, that's ok because `syncResults[idx]`
     * will also be `undefined`. That's a little hacky, but it works.
     */
    result === void 0 ? syncResults[idx] : result
  ));
}
var waitForNone = Recoil_selectorFamily({
  key: "__waitForNone",
  get: (dependencies) => ({
    get
  }) => {
    const deps = unwrapDependencies(dependencies);
    const [results, exceptions] = concurrentRequests(get, deps);
    return wrapLoadables(dependencies, results, exceptions);
  },
  dangerouslyAllowMutability: true
});
var waitForAny = Recoil_selectorFamily({
  key: "__waitForAny",
  get: (dependencies) => ({
    get
  }) => {
    const deps = unwrapDependencies(dependencies);
    const [results, exceptions] = concurrentRequests(get, deps);
    if (exceptions.some((exp) => !Recoil_isPromise(exp))) {
      return wrapLoadables(dependencies, results, exceptions);
    }
    return new Promise((resolve) => {
      for (const [i, exp] of exceptions.entries()) {
        if (Recoil_isPromise(exp)) {
          exp.then((result) => {
            results[i] = result;
            exceptions[i] = void 0;
            resolve(wrapLoadables(dependencies, results, exceptions));
          }).catch((error) => {
            exceptions[i] = error;
            resolve(wrapLoadables(dependencies, results, exceptions));
          });
        }
      }
    });
  },
  dangerouslyAllowMutability: true
});
var waitForAll = Recoil_selectorFamily({
  key: "__waitForAll",
  get: (dependencies) => ({
    get
  }) => {
    const deps = unwrapDependencies(dependencies);
    const [results, exceptions] = concurrentRequests(get, deps);
    if (exceptions.every((exp) => exp == null)) {
      return wrapResults(dependencies, results);
    }
    const error = exceptions.find(isError);
    if (error != null) {
      throw error;
    }
    return Promise.all(exceptions).then((exceptionResults) => wrapResults(dependencies, combineAsyncResultsWithSyncResults(results, exceptionResults)));
  },
  dangerouslyAllowMutability: true
});
var waitForAllSettled = Recoil_selectorFamily({
  key: "__waitForAllSettled",
  get: (dependencies) => ({
    get
  }) => {
    const deps = unwrapDependencies(dependencies);
    const [results, exceptions] = concurrentRequests(get, deps);
    if (exceptions.every((exp) => !Recoil_isPromise(exp))) {
      return wrapLoadables(dependencies, results, exceptions);
    }
    return Promise.all(exceptions.map((exp, i) => Recoil_isPromise(exp) ? exp.then((result) => {
      results[i] = result;
      exceptions[i] = void 0;
    }).catch((error) => {
      results[i] = void 0;
      exceptions[i] = error;
    }) : null)).then(() => wrapLoadables(dependencies, results, exceptions));
  },
  dangerouslyAllowMutability: true
});
var noWait = Recoil_selectorFamily({
  key: "__noWait",
  get: (dependency) => ({
    get
  }) => {
    try {
      return Recoil_selector.value(loadableWithValue$4(get(dependency)));
    } catch (exception) {
      return Recoil_selector.value(Recoil_isPromise(exception) ? loadableWithPromise$3(exception) : loadableWithError$3(exception));
    }
  },
  dangerouslyAllowMutability: true
});
var Recoil_WaitFor = {
  waitForNone,
  waitForAny,
  waitForAll,
  waitForAllSettled,
  noWait
};
var {
  RecoilLoadable
} = Recoil_Loadable$1;
var {
  DefaultValue: DefaultValue$3
} = Recoil_Node;
var {
  RecoilRoot: RecoilRoot$2,
  useRecoilStoreID: useRecoilStoreID$1
} = Recoil_RecoilRoot;
var {
  isRecoilValue: isRecoilValue$5
} = Recoil_RecoilValue$1;
var {
  retentionZone: retentionZone$1
} = Recoil_RetentionZone;
var {
  freshSnapshot: freshSnapshot$2
} = Recoil_Snapshot$1;
var {
  useRecoilState: useRecoilState$1,
  useRecoilState_TRANSITION_SUPPORT_UNSTABLE: useRecoilState_TRANSITION_SUPPORT_UNSTABLE$1,
  useRecoilStateLoadable: useRecoilStateLoadable$1,
  useRecoilValue: useRecoilValue$1,
  useRecoilValue_TRANSITION_SUPPORT_UNSTABLE: useRecoilValue_TRANSITION_SUPPORT_UNSTABLE$1,
  useRecoilValueLoadable: useRecoilValueLoadable$1,
  useRecoilValueLoadable_TRANSITION_SUPPORT_UNSTABLE: useRecoilValueLoadable_TRANSITION_SUPPORT_UNSTABLE$1,
  useResetRecoilState: useResetRecoilState$1,
  useSetRecoilState: useSetRecoilState$1
} = Recoil_Hooks;
var {
  useGotoRecoilSnapshot: useGotoRecoilSnapshot$1,
  useRecoilSnapshot: useRecoilSnapshot$1,
  useRecoilTransactionObserver: useRecoilTransactionObserver$1
} = Recoil_SnapshotHooks;
var {
  useRecoilCallback: useRecoilCallback$1
} = Recoil_useRecoilCallback;
var {
  noWait: noWait$1,
  waitForAll: waitForAll$1,
  waitForAllSettled: waitForAllSettled$1,
  waitForAny: waitForAny$1,
  waitForNone: waitForNone$1
} = Recoil_WaitFor;
var Recoil_index = {
  // Types
  DefaultValue: DefaultValue$3,
  isRecoilValue: isRecoilValue$5,
  RecoilLoadable,
  // Global Recoil environment settiongs
  RecoilEnv: Recoil_RecoilEnv,
  // Recoil Root
  RecoilRoot: RecoilRoot$2,
  useRecoilStoreID: useRecoilStoreID$1,
  useRecoilBridgeAcrossReactRoots_UNSTABLE: Recoil_useRecoilBridgeAcrossReactRoots,
  // Atoms/Selectors
  atom: Recoil_atom,
  selector: Recoil_selector,
  // Convenience Atoms/Selectors
  atomFamily: Recoil_atomFamily,
  selectorFamily: Recoil_selectorFamily,
  constSelector: Recoil_constSelector,
  errorSelector: Recoil_errorSelector,
  readOnlySelector: Recoil_readOnlySelector,
  // Concurrency Helpers for Atoms/Selectors
  noWait: noWait$1,
  waitForNone: waitForNone$1,
  waitForAny: waitForAny$1,
  waitForAll: waitForAll$1,
  waitForAllSettled: waitForAllSettled$1,
  // Hooks for Atoms/Selectors
  useRecoilValue: useRecoilValue$1,
  useRecoilValueLoadable: useRecoilValueLoadable$1,
  useRecoilState: useRecoilState$1,
  useRecoilStateLoadable: useRecoilStateLoadable$1,
  useSetRecoilState: useSetRecoilState$1,
  useResetRecoilState: useResetRecoilState$1,
  useGetRecoilValueInfo_UNSTABLE: Recoil_useGetRecoilValueInfo,
  useRecoilRefresher_UNSTABLE: Recoil_useRecoilRefresher,
  useRecoilValueLoadable_TRANSITION_SUPPORT_UNSTABLE: useRecoilValueLoadable_TRANSITION_SUPPORT_UNSTABLE$1,
  useRecoilValue_TRANSITION_SUPPORT_UNSTABLE: useRecoilValue_TRANSITION_SUPPORT_UNSTABLE$1,
  useRecoilState_TRANSITION_SUPPORT_UNSTABLE: useRecoilState_TRANSITION_SUPPORT_UNSTABLE$1,
  // Hooks for complex operations
  useRecoilCallback: useRecoilCallback$1,
  useRecoilTransaction_UNSTABLE: Recoil_useRecoilTransaction,
  // Snapshots
  useGotoRecoilSnapshot: useGotoRecoilSnapshot$1,
  useRecoilSnapshot: useRecoilSnapshot$1,
  useRecoilTransactionObserver_UNSTABLE: useRecoilTransactionObserver$1,
  snapshot_UNSTABLE: freshSnapshot$2,
  // Memory Management
  useRetain: Recoil_useRetain,
  retentionZone: retentionZone$1
};
var Recoil_index_1 = Recoil_index.DefaultValue;
var Recoil_index_2 = Recoil_index.isRecoilValue;
var Recoil_index_3 = Recoil_index.RecoilLoadable;
var Recoil_index_4 = Recoil_index.RecoilEnv;
var Recoil_index_5 = Recoil_index.RecoilRoot;
var Recoil_index_6 = Recoil_index.useRecoilStoreID;
var Recoil_index_7 = Recoil_index.useRecoilBridgeAcrossReactRoots_UNSTABLE;
var Recoil_index_8 = Recoil_index.atom;
var Recoil_index_9 = Recoil_index.selector;
var Recoil_index_10 = Recoil_index.atomFamily;
var Recoil_index_11 = Recoil_index.selectorFamily;
var Recoil_index_12 = Recoil_index.constSelector;
var Recoil_index_13 = Recoil_index.errorSelector;
var Recoil_index_14 = Recoil_index.readOnlySelector;
var Recoil_index_15 = Recoil_index.noWait;
var Recoil_index_16 = Recoil_index.waitForNone;
var Recoil_index_17 = Recoil_index.waitForAny;
var Recoil_index_18 = Recoil_index.waitForAll;
var Recoil_index_19 = Recoil_index.waitForAllSettled;
var Recoil_index_20 = Recoil_index.useRecoilValue;
var Recoil_index_21 = Recoil_index.useRecoilValueLoadable;
var Recoil_index_22 = Recoil_index.useRecoilState;
var Recoil_index_23 = Recoil_index.useRecoilStateLoadable;
var Recoil_index_24 = Recoil_index.useSetRecoilState;
var Recoil_index_25 = Recoil_index.useResetRecoilState;
var Recoil_index_26 = Recoil_index.useGetRecoilValueInfo_UNSTABLE;
var Recoil_index_27 = Recoil_index.useRecoilRefresher_UNSTABLE;
var Recoil_index_28 = Recoil_index.useRecoilValueLoadable_TRANSITION_SUPPORT_UNSTABLE;
var Recoil_index_29 = Recoil_index.useRecoilValue_TRANSITION_SUPPORT_UNSTABLE;
var Recoil_index_30 = Recoil_index.useRecoilState_TRANSITION_SUPPORT_UNSTABLE;
var Recoil_index_31 = Recoil_index.useRecoilCallback;
var Recoil_index_32 = Recoil_index.useRecoilTransaction_UNSTABLE;
var Recoil_index_33 = Recoil_index.useGotoRecoilSnapshot;
var Recoil_index_34 = Recoil_index.useRecoilSnapshot;
var Recoil_index_35 = Recoil_index.useRecoilTransactionObserver_UNSTABLE;
var Recoil_index_36 = Recoil_index.snapshot_UNSTABLE;
var Recoil_index_37 = Recoil_index.useRetain;
var Recoil_index_38 = Recoil_index.retentionZone;

// ../app-core/dist/index.mjs
import { useLocation } from "react-router-dom";
import { LogLevel, useLogger as useLogger2 } from "shared-lib";
import { useSetNextLocation } from "shared-lib";
import { AuthError } from "shared-lib";
import { useCallback as useCallback42 } from "react";
import { fetchQuery, useRelayEnvironment } from "react-relay";
import { useLogger as useLogger3 } from "shared-lib";
import { jsx as jsx182 } from "react/jsx-runtime";
import { usePlatformBaseUrl } from "shared-lib";
import { useContext as useContext2 } from "react";
import { jsx as jsx19 } from "react/jsx-runtime";
import { useState as useState42, useEffect as useEffect4 } from "react";
import { emitCustomEvent as emitCustomEvent2 } from "shared-lib/dist/hooks";
import { useLogger as useLogger5 } from "shared-lib/dist/logging";
import { useSetNextLocation as useSetNextLocation3 } from "shared-lib/dist/navigation";
import { jsx as jsx20 } from "react/jsx-runtime";
import { useCallback as useCallback62 } from "react";
import * as zod3 from "zod";
import { useForm as useForm3 } from "react-hook-form";
import { zodResolver as zodResolver3 } from "@hookform/resolvers/zod";
import {
  createClientMutationId as createClientMutationId12,
  useSetUserErrorCodes,
  useUserErrorCode as useUserErrorCode3
} from "shared-lib";
import {
  ActionContainer as ActionContainer7,
  ErrorField as ErrorField4,
  FormErrorCode,
  FormErrorCodes,
  FormInputRow as FormInputRow3,
  InputField
} from "shared-ui";
import { useAsyncMutation as useAsyncMutation9 } from "shared-lib";
import { useAsyncMutation as useAsyncMutation22 } from "shared-lib";
import { useAsyncMutation as useAsyncMutation32 } from "shared-lib";
import { useAsyncMutation as useAsyncMutation42 } from "shared-lib";
import { useAsyncMutation as useAsyncMutation52 } from "shared-lib";
import { useAsyncMutation as useAsyncMutation62 } from "shared-lib";
import { useAsyncMutation as useAsyncMutation72 } from "shared-lib";
import { jsx as jsx21, jsxs as jsxs72 } from "react/jsx-runtime";
import { useCallback as useCallback72 } from "react";
import * as zod22 from "zod";
import { useForm as useForm22 } from "react-hook-form";
import { zodResolver as zodResolver22 } from "@hookform/resolvers/zod";
import {
  createClientMutationId as createClientMutationId22,
  useSetUserErrorCodes as useSetUserErrorCodes2,
  useUserErrorCode as useUserErrorCode22
} from "shared-lib";
import {
  ActionContainer as ActionContainer22,
  ErrorField as ErrorField22,
  FormErrorCode as FormErrorCode2,
  FormErrorCodes as FormErrorCodes2,
  FormInputRow as FormInputRow22,
  InputField as InputField2
} from "shared-ui";
import { jsx as jsx222, jsxs as jsxs82 } from "react/jsx-runtime";
import { useFragment as useFragment10 } from "react-relay";
import { EdColumnCell, EdRow } from "shared-ui";
import { jsx as jsx23, jsxs as jsxs92 } from "react/jsx-runtime";
import { Fragment as Fragment6, jsx as jsx24, jsxs as jsxs102 } from "react/jsx-runtime";
import { jsx as jsx25 } from "react/jsx-runtime";
import { Suspense as Suspense52, useCallback as useCallback102 } from "react";
import { useNavigate } from "react-router-dom";
import { EdSkeleton as EdSkeleton3 } from "shared-ui";
import { useCallback as useCallback92 } from "react";
import * as zod32 from "zod";
import { useForm as useForm32 } from "react-hook-form";
import { zodResolver as zodResolver32 } from "@hookform/resolvers/zod";
import {
  createClientMutationId as createClientMutationId42,
  useSetUserErrorCodes as useSetUserErrorCodes3,
  useUserErrorCode as useUserErrorCode32
} from "shared-lib";
import {
  allListObject,
  ActionContainer as ActionContainer32,
  ErrorField as ErrorField32,
  FormErrorCode as FormErrorCode3,
  FormErrorCodes as FormErrorCodes3,
  FormInputRow as FormInputRow32,
  InputField as InputField3,
  SelectMenuInput,
  SwitchInput
} from "shared-ui";
import { jsx as jsx26, jsxs as jsxs112 } from "react/jsx-runtime";
import { jsx as jsx27 } from "react/jsx-runtime";
import { Suspense as Suspense62, useCallback as useCallback112, useState as useState52 } from "react";
import { useLazyLoadQuery, usePaginationFragment } from "react-relay";
import { formatDistanceToNow, parseISO } from "date-fns";
import {
  DebouncedInput,
  DefaultListLayoutItemHeader,
  DefaultListLayoutSectionElement,
  ListLayout,
  Loading
} from "shared-ui";
import { isNotNullOrUndefined as isNotNullOrUndefined2, useDebounce } from "shared-lib";
import { jsx as jsx28, jsxs as jsxs122 } from "react/jsx-runtime";
import { jsx as jsx29, jsxs as jsxs132 } from "react/jsx-runtime";
import { jsx as jsx30 } from "react/jsx-runtime";
import { useCallback as useCallback122 } from "react";
import { createClientMutationId as createClientMutationId52 } from "shared-lib";
import { useCallback as useCallback142 } from "react";
import { useCallback as useCallback132, useState as useState62 } from "react";
import { Switch as Switch3 } from "@headlessui/react";
import { classNames as classNames3 } from "shared-ui";
import { jsx as jsx31, jsxs as jsxs14 } from "react/jsx-runtime";
import { jsx as jsx322, jsxs as jsxs15 } from "react/jsx-runtime";
import { KeyableSet } from "shared-lib";
import { KeyableSet as KeyableSet2 } from "shared-lib";
import {
  useCallback as useCallback15,
  useEffect as useEffect5,
  useMemo as useMemo42,
  useState as useState72
} from "react";
import { useQueryLoader as useQueryLoader3 } from "react-relay";
import { ChevronUpDownIcon as ChevronUpDownIcon3 } from "@heroicons/react/24/solid";
import { Combobox as Combobox6 } from "@headlessui/react";
import { usePreloadedQuery as usePreloadedQuery4 } from "react-relay";
import { CheckIcon as CheckIcon3 } from "@heroicons/react/24/solid";
import { Combobox as Combobox5 } from "@headlessui/react";
import { classNames as classNames4 } from "shared-ui";
import { Fragment as Fragment7, jsx as jsx33, jsxs as jsxs16 } from "react/jsx-runtime";
import { jsx as jsx34, jsxs as jsxs17 } from "react/jsx-runtime";
import { useCallback as useCallback18, useState as useState102 } from "react";
import { useFragment as useFragment32 } from "react-relay";
import { createClientMutationId as createClientMutationId62 } from "shared-lib";
import { Button as Button42, ButtonList as ButtonList22 } from "shared-ui";
import { useCallback as useCallback16, useState as useState82 } from "react";
import { useLazyLoadQuery as useLazyLoadQuery2, usePaginationFragment as usePaginationFragment2 } from "react-relay";
import { formatDistanceToNow as formatDistanceToNow2, parseISO as parseISO2 } from "date-fns";
import { isNotNullOrUndefined as isNotNullOrUndefined3, useDebounce as useDebounce2 } from "shared-lib";
import {
  DefaultListLayoutItemHeader as DefaultListLayoutItemHeader2,
  DefaultListLayoutSectionElement as DefaultListLayoutSectionElement2,
  EdTextLink as EdTextLink2,
  Input as Input6,
  ListLayout as ListLayout2,
  PageHeading as PageHeading2
} from "shared-ui";
import { jsx as jsx35, jsxs as jsxs18 } from "react/jsx-runtime";
import { useFragment as useFragment22 } from "react-relay";
import { jsx as jsx36 } from "react/jsx-runtime";
import {
  useCallback as useCallback17,
  useEffect as useEffect6,
  useMemo as useMemo52,
  useState as useState92
} from "react";
import { usePaginationFragment as usePaginationFragment3 } from "react-relay";
import { CheckIcon as CheckIcon4, ChevronUpDownIcon as ChevronUpDownIcon4 } from "@heroicons/react/24/solid";
import { Combobox as Combobox7 } from "@headlessui/react";
import { classNames as classNames5 } from "shared-ui";
import { Fragment as Fragment8, jsx as jsx37, jsxs as jsxs19 } from "react/jsx-runtime";
import { useLazyLoadQuery as useLazyLoadQuery3 } from "react-relay";
import { jsx as jsx38 } from "react/jsx-runtime";
import { useAsyncMutation as useAsyncMutation82 } from "shared-lib";
import { useAsyncMutation as useAsyncMutation92 } from "shared-lib";
import { useAsyncMutation as useAsyncMutation10 } from "shared-lib";
import { useAsyncMutation as useAsyncMutation11 } from "shared-lib";
import { jsx as jsx39, jsxs as jsxs20 } from "react/jsx-runtime";
import { jsx as jsx40 } from "react/jsx-runtime";
import { Suspense as Suspense92 } from "react";
import { useLazyLoadQuery as useLazyLoadQuery4 } from "react-relay";
import { EdSkeleton as EdSkeleton4 } from "shared-ui";
import { Suspense as Suspense82, useCallback as useCallback19 } from "react";
import { usePaginationFragment as usePaginationFragment4 } from "react-relay";
import { formatDistanceToNow as formatDistanceToNow3, parseISO as parseISO3 } from "date-fns";
import { isNotNullOrUndefined as isNotNullOrUndefined4 } from "shared-lib";
import {
  DefaultListLayoutItemHeader as DefaultListLayoutItemHeader3,
  DefaultListLayoutSectionElement as DefaultListLayoutSectionElement3,
  ListLayout as ListLayout3
} from "shared-ui";
import { jsx as jsx41, jsxs as jsxs21 } from "react/jsx-runtime";
import { jsx as jsx422 } from "react/jsx-runtime";
import { Suspense as Suspense11, useCallback as useCallback21 } from "react";
import { useLazyLoadQuery as useLazyLoadQuery5 } from "react-relay";
import { useLocalStorage } from "react-use";
import { EdSkeleton as EdSkeleton5, EdTextLink as EdTextLink3 } from "shared-ui";
import { Suspense as Suspense10, useCallback as useCallback20 } from "react";
import { usePaginationFragment as usePaginationFragment5 } from "react-relay";
import { formatDistanceToNow as formatDistanceToNow4, parseISO as parseISO4 } from "date-fns";
import { isNotNullOrUndefined as isNotNullOrUndefined5 } from "shared-lib";
import {
  DefaultListLayoutItemHeader as DefaultListLayoutItemHeader4,
  DefaultListLayoutSectionElement as DefaultListLayoutSectionElement4,
  ListLayout as ListLayout4
} from "shared-ui";
import { jsx as jsx43, jsxs as jsxs222 } from "react/jsx-runtime";
import { jsx as jsx44, jsxs as jsxs23 } from "react/jsx-runtime";
import { Suspense as Suspense12, useCallback as useCallback222 } from "react";
import { zodResolver as zodResolver4 } from "@hookform/resolvers/zod";
import { useForm as useForm4 } from "react-hook-form";
import * as zod4 from "zod";
import { createClientMutationId as createClientMutationId72, useSetUserErrorCodes as useSetUserErrorCodes4 } from "shared-lib";
import {
  Button as Button52,
  ButtonList as ButtonList32,
  ErrorField as ErrorField42,
  FormTextAreaInput,
  InputField as InputField4,
  SwitchInput as SwitchInput2
} from "shared-ui";
import { jsx as jsx45, jsxs as jsxs24 } from "react/jsx-runtime";
import { useCallback as useCallback23 } from "react";
import { ConnectionHandler, useFragment as useFragment42 } from "react-relay";
import { createClientMutationId as createClientMutationId82, timeAgo as timeAgo2 } from "shared-lib";
import {
  Button as Button62,
  ButtonList as ButtonList42,
  DescriptionItem as DescriptionItem2,
  DescriptionList as DescriptionList2,
  Size as Size32
} from "shared-ui";
import { useAsyncMutation as useAsyncMutation12 } from "shared-lib";
import { useAsyncMutation as useAsyncMutation13 } from "shared-lib";
import { Fragment as Fragment9, jsx as jsx46, jsxs as jsxs25 } from "react/jsx-runtime";
import { useCallback as useCallback24, useState as useState11 } from "react";
import { useFragment as useFragment52 } from "react-relay";
import { createClientMutationId as createClientMutationId92 } from "shared-lib";
import { Button as Button72, ButtonList as ButtonList52 } from "shared-ui";
import { jsx as jsx47, jsxs as jsxs26 } from "react/jsx-runtime";
import { Suspense as Suspense14 } from "react";
import { useLazyLoadQuery as useLazyLoadQuery6 } from "react-relay";
import { EdSkeleton as EdSkeleton6 } from "shared-ui";
import { Suspense as Suspense13, useCallback as useCallback25 } from "react";
import { usePaginationFragment as usePaginationFragment6 } from "react-relay";
import { formatDistanceToNow as formatDistanceToNow5, parseISO as parseISO5 } from "date-fns";
import { isNotNullOrUndefined as isNotNullOrUndefined6 } from "shared-lib";
import {
  DefaultListLayoutItemHeader as DefaultListLayoutItemHeader5,
  DefaultListLayoutSectionElement as DefaultListLayoutSectionElement5,
  ListLayout as ListLayout5
} from "shared-ui";
import { jsx as jsx48, jsxs as jsxs27 } from "react/jsx-runtime";
import { jsx as jsx49 } from "react/jsx-runtime";
import { useCallback as useCallback27, useState as useState13 } from "react";
import {
  createClientMutationId as createClientMutationId102,
  useSetUserErrorCodes as useSetUserErrorCodes5,
  useUserErrorCode as useUserErrorCode4
} from "shared-lib";
import {
  Button as Button82,
  ButtonList as ButtonList6,
  FormErrorCode as FormErrorCode4,
  FormErrorCodes as FormErrorCodes4,
  Input as Input22,
  TextArea as TextArea2
} from "shared-ui";
import {
  useCallback as useCallback26,
  useEffect as useEffect7,
  useMemo as useMemo6,
  useState as useState12
} from "react";
import { usePaginationFragment as usePaginationFragment7 } from "react-relay";
import { CheckIcon as CheckIcon5, ChevronUpDownIcon as ChevronUpDownIcon5 } from "@heroicons/react/24/solid";
import { Combobox as Combobox8 } from "@headlessui/react";
import { classNames as classNames6 } from "shared-ui";
import { Fragment as Fragment10, jsx as jsx50, jsxs as jsxs28 } from "react/jsx-runtime";
import { useLazyLoadQuery as useLazyLoadQuery7 } from "react-relay";
import { jsx as jsx51 } from "react/jsx-runtime";
import { useAsyncMutation as useAsyncMutation14 } from "shared-lib";
import { useAsyncMutation as useAsyncMutation15 } from "shared-lib";
import { jsx as jsx522, jsxs as jsxs29 } from "react/jsx-runtime";
import { useCallback as useCallback28, useState as useState14 } from "react";
import { useFragment as useFragment62 } from "react-relay";
import {
  createClientMutationId as createClientMutationId112,
  useSetUserErrorCodes as useSetUserErrorCodes6,
  useUserErrorCode as useUserErrorCode5
} from "shared-lib";
import {
  Button as Button92,
  ButtonList as ButtonList7,
  FormErrorCode as FormErrorCode5,
  FormErrorCodes as FormErrorCodes5,
  TextArea as TextArea22
} from "shared-ui";
import { jsx as jsx53, jsxs as jsxs30 } from "react/jsx-runtime";
import { Suspense as Suspense15, useCallback as useCallback29, useState as useState15 } from "react";
import { useLazyLoadQuery as useLazyLoadQuery8, usePaginationFragment as usePaginationFragment8 } from "react-relay";
import { formatDistanceToNow as formatDistanceToNow6, parseISO as parseISO6 } from "date-fns";
import { useLocalStorage as useLocalStorage2 } from "react-use";
import { isNotNullOrUndefined as isNotNullOrUndefined7, useDebounce as useDebounce3 } from "shared-lib";
import {
  DefaultListLayoutItemHeader as DefaultListLayoutItemHeader6,
  DefaultListLayoutSectionElement as DefaultListLayoutSectionElement6,
  EdSkeleton as EdSkeleton7,
  EdTextLink as EdTextLink4,
  Input as Input32,
  ListLayout as ListLayout6
} from "shared-ui";
import { jsx as jsx54, jsxs as jsxs31 } from "react/jsx-runtime";
import { useFragment as useFragment72 } from "react-relay";
import { jsx as jsx55 } from "react/jsx-runtime";
import {
  Suspense as Suspense16,
  useCallback as useCallback30,
  useEffect as useEffect8,
  useMemo as useMemo7,
  useState as useState16
} from "react";
import { usePaginationFragment as usePaginationFragment9 } from "react-relay";
import { CheckIcon as CheckIcon6, ChevronUpDownIcon as ChevronUpDownIcon6 } from "@heroicons/react/24/solid";
import { Combobox as Combobox9 } from "@headlessui/react";
import { classNames as classNames7, EdSkeleton as EdSkeleton8 } from "shared-ui";
import { Fragment as Fragment11, jsx as jsx56, jsxs as jsxs322 } from "react/jsx-runtime";
import { useLazyLoadQuery as useLazyLoadQuery9 } from "react-relay";
import { jsx as jsx57 } from "react/jsx-runtime";
import {
  useCallback as useCallback31,
  useMemo as useMemo8,
  useState as useState17
} from "react";
import { useFragment as useFragment82 } from "react-relay";
import { MagnifyingGlassIcon } from "@heroicons/react/20/solid";
import {
  Button as Button102,
  ButtonList as ButtonList8,
  Input as Input42,
  Size as Size42,
  sortFacetsByCount,
  Spinner,
  Tag,
  workflowLabelMap
} from "shared-ui";
import { jsx as jsx58, jsxs as jsxs33 } from "react/jsx-runtime";
import { useCallback as useCallback322 } from "react";
import { createClientMutationId as createClientMutationId122, useSetUserErrorCodes as useSetUserErrorCodes7 } from "shared-lib";
import { Button as Button112 } from "shared-ui";
import { useAsyncMutation as useAsyncMutation16 } from "shared-lib";
import { Fragment as Fragment12, jsx as jsx59 } from "react/jsx-runtime";
import { useCallback as useCallback33, useEffect as useEffect9 } from "react";
import { usePaginationFragment as usePaginationFragment10 } from "react-relay";
import { Button as Button12, Progress, classNames as classNames9 } from "shared-ui";
import { useFragment as useFragment92 } from "react-relay";
import { classNames as classNames8 } from "shared-ui";
import { Fragment as Fragment13, jsx as jsx60 } from "react/jsx-runtime";
import { jsx as jsx61, jsxs as jsxs34 } from "react/jsx-runtime";
import { Fragment as Fragment14, jsx as jsx622, jsxs as jsxs35 } from "react/jsx-runtime";
import { jsx as jsx63, jsxs as jsxs36 } from "react/jsx-runtime";
var __create2 = Object.create;
var __defProp2 = Object.defineProperty;
var __getOwnPropDesc2 = Object.getOwnPropertyDescriptor;
var __getOwnPropNames2 = Object.getOwnPropertyNames;
var __getProtoOf2 = Object.getPrototypeOf;
var __hasOwnProp2 = Object.prototype.hasOwnProperty;
var __commonJS2 = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames2(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __copyProps2 = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames2(from))
      if (!__hasOwnProp2.call(to, key) && key !== except)
        __defProp2(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc2(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM2 = (mod, isNodeMode, target) => (target = mod != null ? __create2(__getProtoOf2(mod)) : {}, __copyProps2(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp2(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var require_oidc_client_min = __commonJS2({
  "../../node_modules/oidc-client/lib/oidc-client.min.js"(exports, module) {
    "use strict";
    !function t(e, r) {
      if ("object" == typeof exports && "object" == typeof module)
        module.exports = r();
      else if ("function" == typeof define && define.amd)
        define([], r);
      else {
        var n = r();
        for (var i in n)
          ("object" == typeof exports ? exports : e)[i] = n[i];
      }
    }(exports, function() {
      return function(t) {
        var e = {};
        function r(n) {
          if (e[n])
            return e[n].exports;
          var i = e[n] = { i: n, l: false, exports: {} };
          return t[n].call(i.exports, i, i.exports, r), i.l = true, i.exports;
        }
        return r.m = t, r.c = e, r.d = function(t2, e2, n) {
          r.o(t2, e2) || Object.defineProperty(t2, e2, { enumerable: true, get: n });
        }, r.r = function(t2) {
          "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t2, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(t2, "__esModule", { value: true });
        }, r.t = function(t2, e2) {
          if (1 & e2 && (t2 = r(t2)), 8 & e2)
            return t2;
          if (4 & e2 && "object" == typeof t2 && t2 && t2.__esModule)
            return t2;
          var n = /* @__PURE__ */ Object.create(null);
          if (r.r(n), Object.defineProperty(n, "default", { enumerable: true, value: t2 }), 2 & e2 && "string" != typeof t2)
            for (var i in t2)
              r.d(n, i, function(e3) {
                return t2[e3];
              }.bind(null, i));
          return n;
        }, r.n = function(t2) {
          var e2 = t2 && t2.__esModule ? function e3() {
            return t2.default;
          } : function e3() {
            return t2;
          };
          return r.d(e2, "a", e2), e2;
        }, r.o = function(t2, e2) {
          return Object.prototype.hasOwnProperty.call(t2, e2);
        }, r.p = "", r(r.s = 22);
      }([function(t, e, r) {
        "use strict";
        Object.defineProperty(e, "__esModule", { value: true });
        var n = function() {
          function t2(t3, e2) {
            for (var r2 = 0; r2 < e2.length; r2++) {
              var n2 = e2[r2];
              n2.enumerable = n2.enumerable || false, n2.configurable = true, "value" in n2 && (n2.writable = true), Object.defineProperty(t3, n2.key, n2);
            }
          }
          return function(e2, r2, n2) {
            return r2 && t2(e2.prototype, r2), n2 && t2(e2, n2), e2;
          };
        }();
        var i = { debug: function t2() {
        }, info: function t2() {
        }, warn: function t2() {
        }, error: function t2() {
        } }, o = void 0, s = void 0;
        (e.Log = function() {
          function t2() {
            !function e2(t3, r2) {
              if (!(t3 instanceof r2))
                throw new TypeError("Cannot call a class as a function");
            }(this, t2);
          }
          return t2.reset = function t3() {
            s = 3, o = i;
          }, t2.debug = function t3() {
            if (s >= 4) {
              for (var e2 = arguments.length, r2 = Array(e2), n2 = 0; n2 < e2; n2++)
                r2[n2] = arguments[n2];
              o.debug.apply(o, Array.from(r2));
            }
          }, t2.info = function t3() {
            if (s >= 3) {
              for (var e2 = arguments.length, r2 = Array(e2), n2 = 0; n2 < e2; n2++)
                r2[n2] = arguments[n2];
              o.info.apply(o, Array.from(r2));
            }
          }, t2.warn = function t3() {
            if (s >= 2) {
              for (var e2 = arguments.length, r2 = Array(e2), n2 = 0; n2 < e2; n2++)
                r2[n2] = arguments[n2];
              o.warn.apply(o, Array.from(r2));
            }
          }, t2.error = function t3() {
            if (s >= 1) {
              for (var e2 = arguments.length, r2 = Array(e2), n2 = 0; n2 < e2; n2++)
                r2[n2] = arguments[n2];
              o.error.apply(o, Array.from(r2));
            }
          }, n(t2, null, [{ key: "NONE", get: function t3() {
            return 0;
          } }, { key: "ERROR", get: function t3() {
            return 1;
          } }, { key: "WARN", get: function t3() {
            return 2;
          } }, { key: "INFO", get: function t3() {
            return 3;
          } }, { key: "DEBUG", get: function t3() {
            return 4;
          } }, { key: "level", get: function t3() {
            return s;
          }, set: function t3(e2) {
            if (!(0 <= e2 && e2 <= 4))
              throw new Error("Invalid log level");
            s = e2;
          } }, { key: "logger", get: function t3() {
            return o;
          }, set: function t3(e2) {
            if (!e2.debug && e2.info && (e2.debug = e2.info), !(e2.debug && e2.info && e2.warn && e2.error))
              throw new Error("Invalid logger");
            o = e2;
          } }]), t2;
        }()).reset();
      }, function(t, e, r) {
        "use strict";
        Object.defineProperty(e, "__esModule", { value: true });
        var n = function() {
          function t2(t3, e2) {
            for (var r2 = 0; r2 < e2.length; r2++) {
              var n2 = e2[r2];
              n2.enumerable = n2.enumerable || false, n2.configurable = true, "value" in n2 && (n2.writable = true), Object.defineProperty(t3, n2.key, n2);
            }
          }
          return function(e2, r2, n2) {
            return r2 && t2(e2.prototype, r2), n2 && t2(e2, n2), e2;
          };
        }();
        var i = { setInterval: function(t2) {
          function e2(e3, r2) {
            return t2.apply(this, arguments);
          }
          return e2.toString = function() {
            return t2.toString();
          }, e2;
        }(function(t2, e2) {
          return setInterval(t2, e2);
        }), clearInterval: function(t2) {
          function e2(e3) {
            return t2.apply(this, arguments);
          }
          return e2.toString = function() {
            return t2.toString();
          }, e2;
        }(function(t2) {
          return clearInterval(t2);
        }) }, o = false, s = null;
        e.Global = function() {
          function t2() {
            !function e2(t3, r2) {
              if (!(t3 instanceof r2))
                throw new TypeError("Cannot call a class as a function");
            }(this, t2);
          }
          return t2._testing = function t3() {
            o = true;
          }, t2.setXMLHttpRequest = function t3(e2) {
            s = e2;
          }, n(t2, null, [{ key: "location", get: function t3() {
            if (!o)
              return location;
          } }, { key: "localStorage", get: function t3() {
            if (!o && "undefined" != typeof window)
              return localStorage;
          } }, { key: "sessionStorage", get: function t3() {
            if (!o && "undefined" != typeof window)
              return sessionStorage;
          } }, { key: "XMLHttpRequest", get: function t3() {
            if (!o && "undefined" != typeof window)
              return s || XMLHttpRequest;
          } }, { key: "timer", get: function t3() {
            if (!o)
              return i;
          } }]), t2;
        }();
      }, function(t, e, r) {
        "use strict";
        Object.defineProperty(e, "__esModule", { value: true }), e.MetadataService = void 0;
        var n = function() {
          function t2(t3, e2) {
            for (var r2 = 0; r2 < e2.length; r2++) {
              var n2 = e2[r2];
              n2.enumerable = n2.enumerable || false, n2.configurable = true, "value" in n2 && (n2.writable = true), Object.defineProperty(t3, n2.key, n2);
            }
          }
          return function(e2, r2, n2) {
            return r2 && t2(e2.prototype, r2), n2 && t2(e2, n2), e2;
          };
        }(), i = r(0), o = r(7);
        function s(t2, e2) {
          if (!(t2 instanceof e2))
            throw new TypeError("Cannot call a class as a function");
        }
        var a = ".well-known/openid-configuration";
        e.MetadataService = function() {
          function t2(e2) {
            var r2 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : o.JsonService;
            if (s(this, t2), !e2)
              throw i.Log.error("MetadataService: No settings passed to MetadataService"), new Error("settings");
            this._settings = e2, this._jsonService = new r2(["application/jwk-set+json"]);
          }
          return t2.prototype.resetSigningKeys = function t3() {
            this._settings = this._settings || {}, this._settings.signingKeys = void 0;
          }, t2.prototype.getMetadata = function t3() {
            var e2 = this;
            return this._settings.metadata ? (i.Log.debug("MetadataService.getMetadata: Returning metadata from settings"), Promise.resolve(this._settings.metadata)) : this.metadataUrl ? (i.Log.debug("MetadataService.getMetadata: getting metadata from", this.metadataUrl), this._jsonService.getJson(this.metadataUrl).then(function(t4) {
              i.Log.debug("MetadataService.getMetadata: json received");
              var r2 = e2._settings.metadataSeed || {};
              return e2._settings.metadata = Object.assign({}, r2, t4), e2._settings.metadata;
            })) : (i.Log.error("MetadataService.getMetadata: No authority or metadataUrl configured on settings"), Promise.reject(new Error("No authority or metadataUrl configured on settings")));
          }, t2.prototype.getIssuer = function t3() {
            return this._getMetadataProperty("issuer");
          }, t2.prototype.getAuthorizationEndpoint = function t3() {
            return this._getMetadataProperty("authorization_endpoint");
          }, t2.prototype.getUserInfoEndpoint = function t3() {
            return this._getMetadataProperty("userinfo_endpoint");
          }, t2.prototype.getTokenEndpoint = function t3() {
            var e2 = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
            return this._getMetadataProperty("token_endpoint", e2);
          }, t2.prototype.getCheckSessionIframe = function t3() {
            return this._getMetadataProperty("check_session_iframe", true);
          }, t2.prototype.getEndSessionEndpoint = function t3() {
            return this._getMetadataProperty("end_session_endpoint", true);
          }, t2.prototype.getRevocationEndpoint = function t3() {
            return this._getMetadataProperty("revocation_endpoint", true);
          }, t2.prototype.getKeysEndpoint = function t3() {
            return this._getMetadataProperty("jwks_uri", true);
          }, t2.prototype._getMetadataProperty = function t3(e2) {
            var r2 = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
            return i.Log.debug("MetadataService.getMetadataProperty for: " + e2), this.getMetadata().then(function(t4) {
              if (i.Log.debug("MetadataService.getMetadataProperty: metadata recieved"), void 0 === t4[e2]) {
                if (true === r2)
                  return void i.Log.warn("MetadataService.getMetadataProperty: Metadata does not contain optional property " + e2);
                throw i.Log.error("MetadataService.getMetadataProperty: Metadata does not contain property " + e2), new Error("Metadata does not contain property " + e2);
              }
              return t4[e2];
            });
          }, t2.prototype.getSigningKeys = function t3() {
            var e2 = this;
            return this._settings.signingKeys ? (i.Log.debug("MetadataService.getSigningKeys: Returning signingKeys from settings"), Promise.resolve(this._settings.signingKeys)) : this._getMetadataProperty("jwks_uri").then(function(t4) {
              return i.Log.debug("MetadataService.getSigningKeys: jwks_uri received", t4), e2._jsonService.getJson(t4).then(function(t5) {
                if (i.Log.debug("MetadataService.getSigningKeys: key set received", t5), !t5.keys)
                  throw i.Log.error("MetadataService.getSigningKeys: Missing keys on keyset"), new Error("Missing keys on keyset");
                return e2._settings.signingKeys = t5.keys, e2._settings.signingKeys;
              });
            });
          }, n(t2, [{ key: "metadataUrl", get: function t3() {
            return this._metadataUrl || (this._settings.metadataUrl ? this._metadataUrl = this._settings.metadataUrl : (this._metadataUrl = this._settings.authority, this._metadataUrl && this._metadataUrl.indexOf(a) < 0 && ("/" !== this._metadataUrl[this._metadataUrl.length - 1] && (this._metadataUrl += "/"), this._metadataUrl += a))), this._metadataUrl;
          } }]), t2;
        }();
      }, function(t, e, r) {
        "use strict";
        Object.defineProperty(e, "__esModule", { value: true }), e.UrlUtility = void 0;
        var n = r(0), i = r(1);
        e.UrlUtility = function() {
          function t2() {
            !function e2(t3, r2) {
              if (!(t3 instanceof r2))
                throw new TypeError("Cannot call a class as a function");
            }(this, t2);
          }
          return t2.addQueryParam = function t3(e2, r2, n2) {
            return e2.indexOf("?") < 0 && (e2 += "?"), "?" !== e2[e2.length - 1] && (e2 += "&"), e2 += encodeURIComponent(r2), e2 += "=", e2 += encodeURIComponent(n2);
          }, t2.parseUrlFragment = function t3(e2) {
            var r2 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "#", o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : i.Global;
            "string" != typeof e2 && (e2 = o.location.href);
            var s = e2.lastIndexOf(r2);
            s >= 0 && (e2 = e2.substr(s + 1)), "?" === r2 && (s = e2.indexOf("#")) >= 0 && (e2 = e2.substr(0, s));
            for (var a, u = {}, c = /([^&=]+)=([^&]*)/g, h = 0; a = c.exec(e2); )
              if (u[decodeURIComponent(a[1])] = decodeURIComponent(a[2].replace(/\+/g, " ")), h++ > 50)
                return n.Log.error("UrlUtility.parseUrlFragment: response exceeded expected number of parameters", e2), { error: "Response exceeded expected number of parameters" };
            for (var l in u)
              return u;
            return {};
          }, t2;
        }();
      }, function(t, e, r) {
        "use strict";
        Object.defineProperty(e, "__esModule", { value: true }), e.JoseUtil = void 0;
        var n = r(26), i = function o(t2) {
          return t2 && t2.__esModule ? t2 : { default: t2 };
        }(r(33));
        e.JoseUtil = (0, i.default)({ jws: n.jws, KeyUtil: n.KeyUtil, X509: n.X509, crypto: n.crypto, hextob64u: n.hextob64u, b64tohex: n.b64tohex, AllowedSigningAlgs: n.AllowedSigningAlgs });
      }, function(t, e, r) {
        "use strict";
        Object.defineProperty(e, "__esModule", { value: true }), e.OidcClientSettings = void 0;
        var n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t2) {
          return typeof t2;
        } : function(t2) {
          return t2 && "function" == typeof Symbol && t2.constructor === Symbol && t2 !== Symbol.prototype ? "symbol" : typeof t2;
        }, i = function() {
          function t2(t3, e2) {
            for (var r2 = 0; r2 < e2.length; r2++) {
              var n2 = e2[r2];
              n2.enumerable = n2.enumerable || false, n2.configurable = true, "value" in n2 && (n2.writable = true), Object.defineProperty(t3, n2.key, n2);
            }
          }
          return function(e2, r2, n2) {
            return r2 && t2(e2.prototype, r2), n2 && t2(e2, n2), e2;
          };
        }(), o = r(0), s = r(23), a = r(6), u = r(24), c = r(2);
        function h(t2, e2) {
          if (!(t2 instanceof e2))
            throw new TypeError("Cannot call a class as a function");
        }
        var l = ".well-known/openid-configuration", f = "id_token", g = "openid", d = "client_secret_post";
        e.OidcClientSettings = function() {
          function t2() {
            var e2 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, r2 = e2.authority, i2 = e2.metadataUrl, o2 = e2.metadata, l2 = e2.signingKeys, p = e2.metadataSeed, v = e2.client_id, y = e2.client_secret, m = e2.response_type, _ = void 0 === m ? f : m, S = e2.scope, b = void 0 === S ? g : S, w = e2.redirect_uri, F = e2.post_logout_redirect_uri, E = e2.client_authentication, x = void 0 === E ? d : E, A = e2.prompt, k = e2.display, P = e2.max_age, C = e2.ui_locales, T = e2.acr_values, R = e2.resource, I = e2.response_mode, D = e2.filterProtocolClaims, L = void 0 === D || D, N = e2.loadUserInfo, U = void 0 === N || N, B = e2.staleStateAge, O = void 0 === B ? 900 : B, j = e2.clockSkew, M = void 0 === j ? 300 : j, H = e2.clockService, V = void 0 === H ? new s.ClockService() : H, K = e2.userInfoJwtIssuer, q = void 0 === K ? "OP" : K, J = e2.mergeClaims, W = void 0 !== J && J, z = e2.stateStore, Y = void 0 === z ? new a.WebStorageStateStore() : z, G = e2.ResponseValidatorCtor, X = void 0 === G ? u.ResponseValidator : G, $ = e2.MetadataServiceCtor, Q = void 0 === $ ? c.MetadataService : $, Z = e2.extraQueryParams, tt = void 0 === Z ? {} : Z, et = e2.extraTokenParams, rt = void 0 === et ? {} : et;
            h(this, t2), this._authority = r2, this._metadataUrl = i2, this._metadata = o2, this._metadataSeed = p, this._signingKeys = l2, this._client_id = v, this._client_secret = y, this._response_type = _, this._scope = b, this._redirect_uri = w, this._post_logout_redirect_uri = F, this._client_authentication = x, this._prompt = A, this._display = k, this._max_age = P, this._ui_locales = C, this._acr_values = T, this._resource = R, this._response_mode = I, this._filterProtocolClaims = !!L, this._loadUserInfo = !!U, this._staleStateAge = O, this._clockSkew = M, this._clockService = V, this._userInfoJwtIssuer = q, this._mergeClaims = !!W, this._stateStore = Y, this._validator = new X(this), this._metadataService = new Q(this), this._extraQueryParams = "object" === (void 0 === tt ? "undefined" : n(tt)) ? tt : {}, this._extraTokenParams = "object" === (void 0 === rt ? "undefined" : n(rt)) ? rt : {};
          }
          return t2.prototype.getEpochTime = function t3() {
            return this._clockService.getEpochTime();
          }, i(t2, [{ key: "client_id", get: function t3() {
            return this._client_id;
          }, set: function t3(e2) {
            if (this._client_id)
              throw o.Log.error("OidcClientSettings.set_client_id: client_id has already been assigned."), new Error("client_id has already been assigned.");
            this._client_id = e2;
          } }, { key: "client_secret", get: function t3() {
            return this._client_secret;
          } }, { key: "response_type", get: function t3() {
            return this._response_type;
          } }, { key: "scope", get: function t3() {
            return this._scope;
          } }, { key: "redirect_uri", get: function t3() {
            return this._redirect_uri;
          } }, { key: "post_logout_redirect_uri", get: function t3() {
            return this._post_logout_redirect_uri;
          } }, { key: "client_authentication", get: function t3() {
            return this._client_authentication;
          } }, { key: "prompt", get: function t3() {
            return this._prompt;
          } }, { key: "display", get: function t3() {
            return this._display;
          } }, { key: "max_age", get: function t3() {
            return this._max_age;
          } }, { key: "ui_locales", get: function t3() {
            return this._ui_locales;
          } }, { key: "acr_values", get: function t3() {
            return this._acr_values;
          } }, { key: "resource", get: function t3() {
            return this._resource;
          } }, { key: "response_mode", get: function t3() {
            return this._response_mode;
          } }, { key: "authority", get: function t3() {
            return this._authority;
          }, set: function t3(e2) {
            if (this._authority)
              throw o.Log.error("OidcClientSettings.set_authority: authority has already been assigned."), new Error("authority has already been assigned.");
            this._authority = e2;
          } }, { key: "metadataUrl", get: function t3() {
            return this._metadataUrl || (this._metadataUrl = this.authority, this._metadataUrl && this._metadataUrl.indexOf(l) < 0 && ("/" !== this._metadataUrl[this._metadataUrl.length - 1] && (this._metadataUrl += "/"), this._metadataUrl += l)), this._metadataUrl;
          } }, { key: "metadata", get: function t3() {
            return this._metadata;
          }, set: function t3(e2) {
            this._metadata = e2;
          } }, { key: "metadataSeed", get: function t3() {
            return this._metadataSeed;
          }, set: function t3(e2) {
            this._metadataSeed = e2;
          } }, { key: "signingKeys", get: function t3() {
            return this._signingKeys;
          }, set: function t3(e2) {
            this._signingKeys = e2;
          } }, { key: "filterProtocolClaims", get: function t3() {
            return this._filterProtocolClaims;
          } }, { key: "loadUserInfo", get: function t3() {
            return this._loadUserInfo;
          } }, { key: "staleStateAge", get: function t3() {
            return this._staleStateAge;
          } }, { key: "clockSkew", get: function t3() {
            return this._clockSkew;
          } }, { key: "userInfoJwtIssuer", get: function t3() {
            return this._userInfoJwtIssuer;
          } }, { key: "mergeClaims", get: function t3() {
            return this._mergeClaims;
          } }, { key: "stateStore", get: function t3() {
            return this._stateStore;
          } }, { key: "validator", get: function t3() {
            return this._validator;
          } }, { key: "metadataService", get: function t3() {
            return this._metadataService;
          } }, { key: "extraQueryParams", get: function t3() {
            return this._extraQueryParams;
          }, set: function t3(e2) {
            "object" === (void 0 === e2 ? "undefined" : n(e2)) ? this._extraQueryParams = e2 : this._extraQueryParams = {};
          } }, { key: "extraTokenParams", get: function t3() {
            return this._extraTokenParams;
          }, set: function t3(e2) {
            "object" === (void 0 === e2 ? "undefined" : n(e2)) ? this._extraTokenParams = e2 : this._extraTokenParams = {};
          } }]), t2;
        }();
      }, function(t, e, r) {
        "use strict";
        Object.defineProperty(e, "__esModule", { value: true }), e.WebStorageStateStore = void 0;
        var n = r(0), i = r(1);
        function o(t2, e2) {
          if (!(t2 instanceof e2))
            throw new TypeError("Cannot call a class as a function");
        }
        e.WebStorageStateStore = function() {
          function t2() {
            var e2 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, r2 = e2.prefix, n2 = void 0 === r2 ? "oidc." : r2, s = e2.store, a = void 0 === s ? i.Global.localStorage : s;
            o(this, t2), this._store = a, this._prefix = n2;
          }
          return t2.prototype.set = function t3(e2, r2) {
            return n.Log.debug("WebStorageStateStore.set", e2), e2 = this._prefix + e2, this._store.setItem(e2, r2), Promise.resolve();
          }, t2.prototype.get = function t3(e2) {
            n.Log.debug("WebStorageStateStore.get", e2), e2 = this._prefix + e2;
            var r2 = this._store.getItem(e2);
            return Promise.resolve(r2);
          }, t2.prototype.remove = function t3(e2) {
            n.Log.debug("WebStorageStateStore.remove", e2), e2 = this._prefix + e2;
            var r2 = this._store.getItem(e2);
            return this._store.removeItem(e2), Promise.resolve(r2);
          }, t2.prototype.getAllKeys = function t3() {
            n.Log.debug("WebStorageStateStore.getAllKeys");
            for (var e2 = [], r2 = 0; r2 < this._store.length; r2++) {
              var i2 = this._store.key(r2);
              0 === i2.indexOf(this._prefix) && e2.push(i2.substr(this._prefix.length));
            }
            return Promise.resolve(e2);
          }, t2;
        }();
      }, function(t, e, r) {
        "use strict";
        Object.defineProperty(e, "__esModule", { value: true }), e.JsonService = void 0;
        var n = r(0), i = r(1);
        function o(t2, e2) {
          if (!(t2 instanceof e2))
            throw new TypeError("Cannot call a class as a function");
        }
        e.JsonService = function() {
          function t2() {
            var e2 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null, r2 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : i.Global.XMLHttpRequest, n2 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null;
            o(this, t2), e2 && Array.isArray(e2) ? this._contentTypes = e2.slice() : this._contentTypes = [], this._contentTypes.push("application/json"), n2 && this._contentTypes.push("application/jwt"), this._XMLHttpRequest = r2, this._jwtHandler = n2;
          }
          return t2.prototype.getJson = function t3(e2, r2) {
            var i2 = this;
            if (!e2)
              throw n.Log.error("JsonService.getJson: No url passed"), new Error("url");
            return n.Log.debug("JsonService.getJson, url: ", e2), new Promise(function(t4, o2) {
              var s = new i2._XMLHttpRequest();
              s.open("GET", e2);
              var a = i2._contentTypes, u = i2._jwtHandler;
              s.onload = function() {
                if (n.Log.debug("JsonService.getJson: HTTP response received, status", s.status), 200 === s.status) {
                  var r3 = s.getResponseHeader("Content-Type");
                  if (r3) {
                    var i3 = a.find(function(t5) {
                      if (r3.startsWith(t5))
                        return true;
                    });
                    if ("application/jwt" == i3)
                      return void u(s).then(t4, o2);
                    if (i3)
                      try {
                        return void t4(JSON.parse(s.responseText));
                      } catch (t5) {
                        return n.Log.error("JsonService.getJson: Error parsing JSON response", t5.message), void o2(t5);
                      }
                  }
                  o2(Error("Invalid response Content-Type: " + r3 + ", from URL: " + e2));
                } else
                  o2(Error(s.statusText + " (" + s.status + ")"));
              }, s.onerror = function() {
                n.Log.error("JsonService.getJson: network error"), o2(Error("Network Error"));
              }, r2 && (n.Log.debug("JsonService.getJson: token passed, setting Authorization header"), s.setRequestHeader("Authorization", "Bearer " + r2)), s.send();
            });
          }, t2.prototype.postForm = function t3(e2, r2, i2) {
            var o2 = this;
            if (!e2)
              throw n.Log.error("JsonService.postForm: No url passed"), new Error("url");
            return n.Log.debug("JsonService.postForm, url: ", e2), new Promise(function(t4, s) {
              var a = new o2._XMLHttpRequest();
              a.open("POST", e2);
              var u = o2._contentTypes;
              a.onload = function() {
                if (n.Log.debug("JsonService.postForm: HTTP response received, status", a.status), 200 !== a.status) {
                  if (400 === a.status) {
                    if (i3 = a.getResponseHeader("Content-Type")) {
                      if (u.find(function(t5) {
                        if (i3.startsWith(t5))
                          return true;
                      }))
                        try {
                          var r3 = JSON.parse(a.responseText);
                          if (r3 && r3.error)
                            return n.Log.error("JsonService.postForm: Error from server: ", r3.error), void s(new Error(r3.error));
                        } catch (t5) {
                          return n.Log.error("JsonService.postForm: Error parsing JSON response", t5.message), void s(t5);
                        }
                    }
                  }
                  s(Error(a.statusText + " (" + a.status + ")"));
                } else {
                  var i3;
                  if ((i3 = a.getResponseHeader("Content-Type")) && u.find(function(t5) {
                    if (i3.startsWith(t5))
                      return true;
                  }))
                    try {
                      return void t4(JSON.parse(a.responseText));
                    } catch (t5) {
                      return n.Log.error("JsonService.postForm: Error parsing JSON response", t5.message), void s(t5);
                    }
                  s(Error("Invalid response Content-Type: " + i3 + ", from URL: " + e2));
                }
              }, a.onerror = function() {
                n.Log.error("JsonService.postForm: network error"), s(Error("Network Error"));
              };
              var c = "";
              for (var h in r2) {
                var l = r2[h];
                l && (c.length > 0 && (c += "&"), c += encodeURIComponent(h), c += "=", c += encodeURIComponent(l));
              }
              a.setRequestHeader("Content-Type", "application/x-www-form-urlencoded"), void 0 !== i2 && a.setRequestHeader("Authorization", "Basic " + btoa(i2)), a.send(c);
            });
          }, t2;
        }();
      }, function(t, e, r) {
        "use strict";
        Object.defineProperty(e, "__esModule", { value: true }), e.SigninRequest = void 0;
        var n = r(0), i = r(3), o = r(13);
        e.SigninRequest = function() {
          function t2(e2) {
            var r2 = e2.url, s = e2.client_id, a = e2.redirect_uri, u = e2.response_type, c = e2.scope, h = e2.authority, l = e2.data, f = e2.prompt, g = e2.display, d = e2.max_age, p = e2.ui_locales, v = e2.id_token_hint, y = e2.login_hint, m = e2.acr_values, _ = e2.resource, S = e2.response_mode, b = e2.request, w = e2.request_uri, F = e2.extraQueryParams, E = e2.request_type, x = e2.client_secret, A = e2.extraTokenParams, k = e2.skipUserInfo;
            if (function P(t3, e3) {
              if (!(t3 instanceof e3))
                throw new TypeError("Cannot call a class as a function");
            }(this, t2), !r2)
              throw n.Log.error("SigninRequest.ctor: No url passed"), new Error("url");
            if (!s)
              throw n.Log.error("SigninRequest.ctor: No client_id passed"), new Error("client_id");
            if (!a)
              throw n.Log.error("SigninRequest.ctor: No redirect_uri passed"), new Error("redirect_uri");
            if (!u)
              throw n.Log.error("SigninRequest.ctor: No response_type passed"), new Error("response_type");
            if (!c)
              throw n.Log.error("SigninRequest.ctor: No scope passed"), new Error("scope");
            if (!h)
              throw n.Log.error("SigninRequest.ctor: No authority passed"), new Error("authority");
            var C = t2.isOidc(u), T = t2.isCode(u);
            S || (S = t2.isCode(u) ? "query" : null), this.state = new o.SigninState({ nonce: C, data: l, client_id: s, authority: h, redirect_uri: a, code_verifier: T, request_type: E, response_mode: S, client_secret: x, scope: c, extraTokenParams: A, skipUserInfo: k }), r2 = i.UrlUtility.addQueryParam(r2, "client_id", s), r2 = i.UrlUtility.addQueryParam(r2, "redirect_uri", a), r2 = i.UrlUtility.addQueryParam(r2, "response_type", u), r2 = i.UrlUtility.addQueryParam(r2, "scope", c), r2 = i.UrlUtility.addQueryParam(r2, "state", this.state.id), C && (r2 = i.UrlUtility.addQueryParam(r2, "nonce", this.state.nonce)), T && (r2 = i.UrlUtility.addQueryParam(r2, "code_challenge", this.state.code_challenge), r2 = i.UrlUtility.addQueryParam(r2, "code_challenge_method", "S256"));
            var R = { prompt: f, display: g, max_age: d, ui_locales: p, id_token_hint: v, login_hint: y, acr_values: m, resource: _, request: b, request_uri: w, response_mode: S };
            for (var I in R)
              R[I] && (r2 = i.UrlUtility.addQueryParam(r2, I, R[I]));
            for (var D in F)
              r2 = i.UrlUtility.addQueryParam(r2, D, F[D]);
            this.url = r2;
          }
          return t2.isOidc = function t3(e2) {
            return !!e2.split(/\s+/g).filter(function(t4) {
              return "id_token" === t4;
            })[0];
          }, t2.isOAuth = function t3(e2) {
            return !!e2.split(/\s+/g).filter(function(t4) {
              return "token" === t4;
            })[0];
          }, t2.isCode = function t3(e2) {
            return !!e2.split(/\s+/g).filter(function(t4) {
              return "code" === t4;
            })[0];
          }, t2;
        }();
      }, function(t, e, r) {
        "use strict";
        Object.defineProperty(e, "__esModule", { value: true }), e.State = void 0;
        var n = function() {
          function t2(t3, e2) {
            for (var r2 = 0; r2 < e2.length; r2++) {
              var n2 = e2[r2];
              n2.enumerable = n2.enumerable || false, n2.configurable = true, "value" in n2 && (n2.writable = true), Object.defineProperty(t3, n2.key, n2);
            }
          }
          return function(e2, r2, n2) {
            return r2 && t2(e2.prototype, r2), n2 && t2(e2, n2), e2;
          };
        }(), i = r(0), o = function s(t2) {
          return t2 && t2.__esModule ? t2 : { default: t2 };
        }(r(14));
        function a(t2, e2) {
          if (!(t2 instanceof e2))
            throw new TypeError("Cannot call a class as a function");
        }
        e.State = function() {
          function t2() {
            var e2 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, r2 = e2.id, n2 = e2.data, i2 = e2.created, s = e2.request_type;
            a(this, t2), this._id = r2 || (0, o.default)(), this._data = n2, this._created = "number" == typeof i2 && i2 > 0 ? i2 : parseInt(Date.now() / 1e3), this._request_type = s;
          }
          return t2.prototype.toStorageString = function t3() {
            return i.Log.debug("State.toStorageString"), JSON.stringify({ id: this.id, data: this.data, created: this.created, request_type: this.request_type });
          }, t2.fromStorageString = function e2(r2) {
            return i.Log.debug("State.fromStorageString"), new t2(JSON.parse(r2));
          }, t2.clearStaleState = function e2(r2, n2) {
            var o2 = Date.now() / 1e3 - n2;
            return r2.getAllKeys().then(function(e3) {
              i.Log.debug("State.clearStaleState: got keys", e3);
              for (var n3 = [], s = function s2(a3) {
                var c = e3[a3];
                u = r2.get(c).then(function(e4) {
                  var n4 = false;
                  if (e4)
                    try {
                      var s3 = t2.fromStorageString(e4);
                      i.Log.debug("State.clearStaleState: got item from key: ", c, s3.created), s3.created <= o2 && (n4 = true);
                    } catch (t3) {
                      i.Log.error("State.clearStaleState: Error parsing state for key", c, t3.message), n4 = true;
                    }
                  else
                    i.Log.debug("State.clearStaleState: no item in storage for key: ", c), n4 = true;
                  if (n4)
                    return i.Log.debug("State.clearStaleState: removed item for key: ", c), r2.remove(c);
                }), n3.push(u);
              }, a2 = 0; a2 < e3.length; a2++) {
                var u;
                s(a2);
              }
              return i.Log.debug("State.clearStaleState: waiting on promise count:", n3.length), Promise.all(n3);
            });
          }, n(t2, [{ key: "id", get: function t3() {
            return this._id;
          } }, { key: "data", get: function t3() {
            return this._data;
          } }, { key: "created", get: function t3() {
            return this._created;
          } }, { key: "request_type", get: function t3() {
            return this._request_type;
          } }]), t2;
        }();
      }, function(t, e, r) {
        "use strict";
        Object.defineProperty(e, "__esModule", { value: true }), e.OidcClient = void 0;
        var n = function() {
          function t2(t3, e2) {
            for (var r2 = 0; r2 < e2.length; r2++) {
              var n2 = e2[r2];
              n2.enumerable = n2.enumerable || false, n2.configurable = true, "value" in n2 && (n2.writable = true), Object.defineProperty(t3, n2.key, n2);
            }
          }
          return function(e2, r2, n2) {
            return r2 && t2(e2.prototype, r2), n2 && t2(e2, n2), e2;
          };
        }(), i = r(0), o = r(5), s = r(12), a = r(8), u = r(34), c = r(35), h = r(36), l = r(13), f = r(9);
        function g(t2, e2) {
          if (!(t2 instanceof e2))
            throw new TypeError("Cannot call a class as a function");
        }
        e.OidcClient = function() {
          function t2() {
            var e2 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            g(this, t2), e2 instanceof o.OidcClientSettings ? this._settings = e2 : this._settings = new o.OidcClientSettings(e2);
          }
          return t2.prototype.createSigninRequest = function t3() {
            var e2 = this, r2 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, n2 = r2.response_type, o2 = r2.scope, s2 = r2.redirect_uri, u2 = r2.data, c2 = r2.state, h2 = r2.prompt, l2 = r2.display, f2 = r2.max_age, g2 = r2.ui_locales, d = r2.id_token_hint, p = r2.login_hint, v = r2.acr_values, y = r2.resource, m = r2.request, _ = r2.request_uri, S = r2.response_mode, b = r2.extraQueryParams, w = r2.extraTokenParams, F = r2.request_type, E = r2.skipUserInfo, x = arguments[1];
            i.Log.debug("OidcClient.createSigninRequest");
            var A = this._settings.client_id;
            n2 = n2 || this._settings.response_type, o2 = o2 || this._settings.scope, s2 = s2 || this._settings.redirect_uri, h2 = h2 || this._settings.prompt, l2 = l2 || this._settings.display, f2 = f2 || this._settings.max_age, g2 = g2 || this._settings.ui_locales, v = v || this._settings.acr_values, y = y || this._settings.resource, S = S || this._settings.response_mode, b = b || this._settings.extraQueryParams, w = w || this._settings.extraTokenParams;
            var k = this._settings.authority;
            return a.SigninRequest.isCode(n2) && "code" !== n2 ? Promise.reject(new Error("OpenID Connect hybrid flow is not supported")) : this._metadataService.getAuthorizationEndpoint().then(function(t4) {
              i.Log.debug("OidcClient.createSigninRequest: Received authorization endpoint", t4);
              var r3 = new a.SigninRequest({ url: t4, client_id: A, redirect_uri: s2, response_type: n2, scope: o2, data: u2 || c2, authority: k, prompt: h2, display: l2, max_age: f2, ui_locales: g2, id_token_hint: d, login_hint: p, acr_values: v, resource: y, request: m, request_uri: _, extraQueryParams: b, extraTokenParams: w, request_type: F, response_mode: S, client_secret: e2._settings.client_secret, skipUserInfo: E }), P = r3.state;
              return (x = x || e2._stateStore).set(P.id, P.toStorageString()).then(function() {
                return r3;
              });
            });
          }, t2.prototype.readSigninResponseState = function t3(e2, r2) {
            var n2 = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
            i.Log.debug("OidcClient.readSigninResponseState");
            var o2 = "query" === this._settings.response_mode || !this._settings.response_mode && a.SigninRequest.isCode(this._settings.response_type), s2 = o2 ? "?" : "#", c2 = new u.SigninResponse(e2, s2);
            if (!c2.state)
              return i.Log.error("OidcClient.readSigninResponseState: No state in response"), Promise.reject(new Error("No state in response"));
            r2 = r2 || this._stateStore;
            var h2 = n2 ? r2.remove.bind(r2) : r2.get.bind(r2);
            return h2(c2.state).then(function(t4) {
              if (!t4)
                throw i.Log.error("OidcClient.readSigninResponseState: No matching state found in storage"), new Error("No matching state found in storage");
              return { state: l.SigninState.fromStorageString(t4), response: c2 };
            });
          }, t2.prototype.processSigninResponse = function t3(e2, r2) {
            var n2 = this;
            return i.Log.debug("OidcClient.processSigninResponse"), this.readSigninResponseState(e2, r2, true).then(function(t4) {
              var e3 = t4.state, r3 = t4.response;
              return i.Log.debug("OidcClient.processSigninResponse: Received state from storage; validating response"), n2._validator.validateSigninResponse(e3, r3);
            });
          }, t2.prototype.createSignoutRequest = function t3() {
            var e2 = this, r2 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, n2 = r2.id_token_hint, o2 = r2.data, s2 = r2.state, a2 = r2.post_logout_redirect_uri, u2 = r2.extraQueryParams, h2 = r2.request_type, l2 = arguments[1];
            return i.Log.debug("OidcClient.createSignoutRequest"), a2 = a2 || this._settings.post_logout_redirect_uri, u2 = u2 || this._settings.extraQueryParams, this._metadataService.getEndSessionEndpoint().then(function(t4) {
              if (!t4)
                throw i.Log.error("OidcClient.createSignoutRequest: No end session endpoint url returned"), new Error("no end session endpoint");
              i.Log.debug("OidcClient.createSignoutRequest: Received end session endpoint", t4);
              var r3 = new c.SignoutRequest({ url: t4, id_token_hint: n2, post_logout_redirect_uri: a2, data: o2 || s2, extraQueryParams: u2, request_type: h2 }), f2 = r3.state;
              return f2 && (i.Log.debug("OidcClient.createSignoutRequest: Signout request has state to persist"), (l2 = l2 || e2._stateStore).set(f2.id, f2.toStorageString())), r3;
            });
          }, t2.prototype.readSignoutResponseState = function t3(e2, r2) {
            var n2 = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
            i.Log.debug("OidcClient.readSignoutResponseState");
            var o2 = new h.SignoutResponse(e2);
            if (!o2.state)
              return i.Log.debug("OidcClient.readSignoutResponseState: No state in response"), o2.error ? (i.Log.warn("OidcClient.readSignoutResponseState: Response was error: ", o2.error), Promise.reject(new s.ErrorResponse(o2))) : Promise.resolve({ state: void 0, response: o2 });
            var a2 = o2.state;
            r2 = r2 || this._stateStore;
            var u2 = n2 ? r2.remove.bind(r2) : r2.get.bind(r2);
            return u2(a2).then(function(t4) {
              if (!t4)
                throw i.Log.error("OidcClient.readSignoutResponseState: No matching state found in storage"), new Error("No matching state found in storage");
              return { state: f.State.fromStorageString(t4), response: o2 };
            });
          }, t2.prototype.processSignoutResponse = function t3(e2, r2) {
            var n2 = this;
            return i.Log.debug("OidcClient.processSignoutResponse"), this.readSignoutResponseState(e2, r2, true).then(function(t4) {
              var e3 = t4.state, r3 = t4.response;
              return e3 ? (i.Log.debug("OidcClient.processSignoutResponse: Received state from storage; validating response"), n2._validator.validateSignoutResponse(e3, r3)) : (i.Log.debug("OidcClient.processSignoutResponse: No state from storage; skipping validating response"), r3);
            });
          }, t2.prototype.clearStaleState = function t3(e2) {
            return i.Log.debug("OidcClient.clearStaleState"), e2 = e2 || this._stateStore, f.State.clearStaleState(e2, this.settings.staleStateAge);
          }, n(t2, [{ key: "_stateStore", get: function t3() {
            return this.settings.stateStore;
          } }, { key: "_validator", get: function t3() {
            return this.settings.validator;
          } }, { key: "_metadataService", get: function t3() {
            return this.settings.metadataService;
          } }, { key: "settings", get: function t3() {
            return this._settings;
          } }, { key: "metadataService", get: function t3() {
            return this._metadataService;
          } }]), t2;
        }();
      }, function(t, e, r) {
        "use strict";
        Object.defineProperty(e, "__esModule", { value: true }), e.TokenClient = void 0;
        var n = r(7), i = r(2), o = r(0);
        function s(t2, e2) {
          if (!(t2 instanceof e2))
            throw new TypeError("Cannot call a class as a function");
        }
        e.TokenClient = function() {
          function t2(e2) {
            var r2 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : n.JsonService, a = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : i.MetadataService;
            if (s(this, t2), !e2)
              throw o.Log.error("TokenClient.ctor: No settings passed"), new Error("settings");
            this._settings = e2, this._jsonService = new r2(), this._metadataService = new a(this._settings);
          }
          return t2.prototype.exchangeCode = function t3() {
            var e2 = this, r2 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            (r2 = Object.assign({}, r2)).grant_type = r2.grant_type || "authorization_code", r2.client_id = r2.client_id || this._settings.client_id, r2.client_secret = r2.client_secret || this._settings.client_secret, r2.redirect_uri = r2.redirect_uri || this._settings.redirect_uri;
            var n2 = void 0, i2 = r2._client_authentication || this._settings._client_authentication;
            return delete r2._client_authentication, r2.code ? r2.redirect_uri ? r2.code_verifier ? r2.client_id ? r2.client_secret || "client_secret_basic" != i2 ? ("client_secret_basic" == i2 && (n2 = r2.client_id + ":" + r2.client_secret, delete r2.client_id, delete r2.client_secret), this._metadataService.getTokenEndpoint(false).then(function(t4) {
              return o.Log.debug("TokenClient.exchangeCode: Received token endpoint"), e2._jsonService.postForm(t4, r2, n2).then(function(t5) {
                return o.Log.debug("TokenClient.exchangeCode: response received"), t5;
              });
            })) : (o.Log.error("TokenClient.exchangeCode: No client_secret passed"), Promise.reject(new Error("A client_secret is required"))) : (o.Log.error("TokenClient.exchangeCode: No client_id passed"), Promise.reject(new Error("A client_id is required"))) : (o.Log.error("TokenClient.exchangeCode: No code_verifier passed"), Promise.reject(new Error("A code_verifier is required"))) : (o.Log.error("TokenClient.exchangeCode: No redirect_uri passed"), Promise.reject(new Error("A redirect_uri is required"))) : (o.Log.error("TokenClient.exchangeCode: No code passed"), Promise.reject(new Error("A code is required")));
          }, t2.prototype.exchangeRefreshToken = function t3() {
            var e2 = this, r2 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            (r2 = Object.assign({}, r2)).grant_type = r2.grant_type || "refresh_token", r2.client_id = r2.client_id || this._settings.client_id, r2.client_secret = r2.client_secret || this._settings.client_secret;
            var n2 = void 0, i2 = r2._client_authentication || this._settings._client_authentication;
            return delete r2._client_authentication, r2.refresh_token ? r2.client_id ? ("client_secret_basic" == i2 && (n2 = r2.client_id + ":" + r2.client_secret, delete r2.client_id, delete r2.client_secret), this._metadataService.getTokenEndpoint(false).then(function(t4) {
              return o.Log.debug("TokenClient.exchangeRefreshToken: Received token endpoint"), e2._jsonService.postForm(t4, r2, n2).then(function(t5) {
                return o.Log.debug("TokenClient.exchangeRefreshToken: response received"), t5;
              });
            })) : (o.Log.error("TokenClient.exchangeRefreshToken: No client_id passed"), Promise.reject(new Error("A client_id is required"))) : (o.Log.error("TokenClient.exchangeRefreshToken: No refresh_token passed"), Promise.reject(new Error("A refresh_token is required")));
          }, t2;
        }();
      }, function(t, e, r) {
        "use strict";
        Object.defineProperty(e, "__esModule", { value: true }), e.ErrorResponse = void 0;
        var n = r(0);
        function i(t2, e2) {
          if (!(t2 instanceof e2))
            throw new TypeError("Cannot call a class as a function");
        }
        function o(t2, e2) {
          if (!t2)
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !e2 || "object" != typeof e2 && "function" != typeof e2 ? t2 : e2;
        }
        e.ErrorResponse = function(t2) {
          function e2() {
            var r2 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, s = r2.error, a = r2.error_description, u = r2.error_uri, c = r2.state, h = r2.session_state;
            if (i(this, e2), !s)
              throw n.Log.error("No error passed to ErrorResponse"), new Error("error");
            var l = o(this, t2.call(this, a || s));
            return l.name = "ErrorResponse", l.error = s, l.error_description = a, l.error_uri = u, l.state = c, l.session_state = h, l;
          }
          return function r2(t3, e3) {
            if ("function" != typeof e3 && null !== e3)
              throw new TypeError("Super expression must either be null or a function, not " + typeof e3);
            t3.prototype = Object.create(e3 && e3.prototype, { constructor: { value: t3, enumerable: false, writable: true, configurable: true } }), e3 && (Object.setPrototypeOf ? Object.setPrototypeOf(t3, e3) : t3.__proto__ = e3);
          }(e2, t2), e2;
        }(Error);
      }, function(t, e, r) {
        "use strict";
        Object.defineProperty(e, "__esModule", { value: true }), e.SigninState = void 0;
        var n = function() {
          function t2(t3, e2) {
            for (var r2 = 0; r2 < e2.length; r2++) {
              var n2 = e2[r2];
              n2.enumerable = n2.enumerable || false, n2.configurable = true, "value" in n2 && (n2.writable = true), Object.defineProperty(t3, n2.key, n2);
            }
          }
          return function(e2, r2, n2) {
            return r2 && t2(e2.prototype, r2), n2 && t2(e2, n2), e2;
          };
        }(), i = r(0), o = r(9), s = r(4), a = function u(t2) {
          return t2 && t2.__esModule ? t2 : { default: t2 };
        }(r(14));
        function c(t2, e2) {
          if (!(t2 instanceof e2))
            throw new TypeError("Cannot call a class as a function");
        }
        function h(t2, e2) {
          if (!t2)
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !e2 || "object" != typeof e2 && "function" != typeof e2 ? t2 : e2;
        }
        e.SigninState = function(t2) {
          function e2() {
            var r2 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, n2 = r2.nonce, i2 = r2.authority, o2 = r2.client_id, u = r2.redirect_uri, l = r2.code_verifier, f = r2.response_mode, g = r2.client_secret, d = r2.scope, p = r2.extraTokenParams, v = r2.skipUserInfo;
            c(this, e2);
            var y = h(this, t2.call(this, arguments[0]));
            if (true === n2 ? y._nonce = (0, a.default)() : n2 && (y._nonce = n2), true === l ? y._code_verifier = (0, a.default)() + (0, a.default)() + (0, a.default)() : l && (y._code_verifier = l), y.code_verifier) {
              var m = s.JoseUtil.hashString(y.code_verifier, "SHA256");
              y._code_challenge = s.JoseUtil.hexToBase64Url(m);
            }
            return y._redirect_uri = u, y._authority = i2, y._client_id = o2, y._response_mode = f, y._client_secret = g, y._scope = d, y._extraTokenParams = p, y._skipUserInfo = v, y;
          }
          return function r2(t3, e3) {
            if ("function" != typeof e3 && null !== e3)
              throw new TypeError("Super expression must either be null or a function, not " + typeof e3);
            t3.prototype = Object.create(e3 && e3.prototype, { constructor: { value: t3, enumerable: false, writable: true, configurable: true } }), e3 && (Object.setPrototypeOf ? Object.setPrototypeOf(t3, e3) : t3.__proto__ = e3);
          }(e2, t2), e2.prototype.toStorageString = function t3() {
            return i.Log.debug("SigninState.toStorageString"), JSON.stringify({ id: this.id, data: this.data, created: this.created, request_type: this.request_type, nonce: this.nonce, code_verifier: this.code_verifier, redirect_uri: this.redirect_uri, authority: this.authority, client_id: this.client_id, response_mode: this.response_mode, client_secret: this.client_secret, scope: this.scope, extraTokenParams: this.extraTokenParams, skipUserInfo: this.skipUserInfo });
          }, e2.fromStorageString = function t3(r2) {
            return i.Log.debug("SigninState.fromStorageString"), new e2(JSON.parse(r2));
          }, n(e2, [{ key: "nonce", get: function t3() {
            return this._nonce;
          } }, { key: "authority", get: function t3() {
            return this._authority;
          } }, { key: "client_id", get: function t3() {
            return this._client_id;
          } }, { key: "redirect_uri", get: function t3() {
            return this._redirect_uri;
          } }, { key: "code_verifier", get: function t3() {
            return this._code_verifier;
          } }, { key: "code_challenge", get: function t3() {
            return this._code_challenge;
          } }, { key: "response_mode", get: function t3() {
            return this._response_mode;
          } }, { key: "client_secret", get: function t3() {
            return this._client_secret;
          } }, { key: "scope", get: function t3() {
            return this._scope;
          } }, { key: "extraTokenParams", get: function t3() {
            return this._extraTokenParams;
          } }, { key: "skipUserInfo", get: function t3() {
            return this._skipUserInfo;
          } }]), e2;
        }(o.State);
      }, function(t, e, r) {
        "use strict";
        Object.defineProperty(e, "__esModule", { value: true }), e.default = function n() {
          return ("undefined" != i && null !== i && void 0 !== i.getRandomValues ? o : s)().replace(/-/g, "");
        };
        var i = "undefined" != typeof window ? window.crypto || window.msCrypto : null;
        function o() {
          return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, function(t2) {
            return (t2 ^ i.getRandomValues(new Uint8Array(1))[0] & 15 >> t2 / 4).toString(16);
          });
        }
        function s() {
          return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, function(t2) {
            return (t2 ^ 16 * Math.random() >> t2 / 4).toString(16);
          });
        }
        t.exports = e.default;
      }, function(t, e, r) {
        "use strict";
        Object.defineProperty(e, "__esModule", { value: true }), e.User = void 0;
        var n = function() {
          function t2(t3, e2) {
            for (var r2 = 0; r2 < e2.length; r2++) {
              var n2 = e2[r2];
              n2.enumerable = n2.enumerable || false, n2.configurable = true, "value" in n2 && (n2.writable = true), Object.defineProperty(t3, n2.key, n2);
            }
          }
          return function(e2, r2, n2) {
            return r2 && t2(e2.prototype, r2), n2 && t2(e2, n2), e2;
          };
        }(), i = r(0);
        e.User = function() {
          function t2(e2) {
            var r2 = e2.id_token, n2 = e2.session_state, i2 = e2.access_token, o = e2.refresh_token, s = e2.token_type, a = e2.scope, u = e2.profile, c = e2.expires_at, h = e2.state;
            !function l(t3, e3) {
              if (!(t3 instanceof e3))
                throw new TypeError("Cannot call a class as a function");
            }(this, t2), this.id_token = r2, this.session_state = n2, this.access_token = i2, this.refresh_token = o, this.token_type = s, this.scope = a, this.profile = u, this.expires_at = c, this.state = h;
          }
          return t2.prototype.toStorageString = function t3() {
            return i.Log.debug("User.toStorageString"), JSON.stringify({ id_token: this.id_token, session_state: this.session_state, access_token: this.access_token, refresh_token: this.refresh_token, token_type: this.token_type, scope: this.scope, profile: this.profile, expires_at: this.expires_at });
          }, t2.fromStorageString = function e2(r2) {
            return i.Log.debug("User.fromStorageString"), new t2(JSON.parse(r2));
          }, n(t2, [{ key: "expires_in", get: function t3() {
            if (this.expires_at) {
              var e2 = parseInt(Date.now() / 1e3);
              return this.expires_at - e2;
            }
          }, set: function t3(e2) {
            var r2 = parseInt(e2);
            if ("number" == typeof r2 && r2 > 0) {
              var n2 = parseInt(Date.now() / 1e3);
              this.expires_at = n2 + r2;
            }
          } }, { key: "expired", get: function t3() {
            var e2 = this.expires_in;
            if (void 0 !== e2)
              return e2 <= 0;
          } }, { key: "scopes", get: function t3() {
            return (this.scope || "").split(" ");
          } }]), t2;
        }();
      }, function(t, e, r) {
        "use strict";
        Object.defineProperty(e, "__esModule", { value: true }), e.AccessTokenEvents = void 0;
        var n = r(0), i = r(46);
        function o(t2, e2) {
          if (!(t2 instanceof e2))
            throw new TypeError("Cannot call a class as a function");
        }
        e.AccessTokenEvents = function() {
          function t2() {
            var e2 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, r2 = e2.accessTokenExpiringNotificationTime, n2 = void 0 === r2 ? 60 : r2, s = e2.accessTokenExpiringTimer, a = void 0 === s ? new i.Timer("Access token expiring") : s, u = e2.accessTokenExpiredTimer, c = void 0 === u ? new i.Timer("Access token expired") : u;
            o(this, t2), this._accessTokenExpiringNotificationTime = n2, this._accessTokenExpiring = a, this._accessTokenExpired = c;
          }
          return t2.prototype.load = function t3(e2) {
            if (e2.access_token && void 0 !== e2.expires_in) {
              var r2 = e2.expires_in;
              if (n.Log.debug("AccessTokenEvents.load: access token present, remaining duration:", r2), r2 > 0) {
                var i2 = r2 - this._accessTokenExpiringNotificationTime;
                i2 <= 0 && (i2 = 1), n.Log.debug("AccessTokenEvents.load: registering expiring timer in:", i2), this._accessTokenExpiring.init(i2);
              } else
                n.Log.debug("AccessTokenEvents.load: canceling existing expiring timer becase we're past expiration."), this._accessTokenExpiring.cancel();
              var o2 = r2 + 1;
              n.Log.debug("AccessTokenEvents.load: registering expired timer in:", o2), this._accessTokenExpired.init(o2);
            } else
              this._accessTokenExpiring.cancel(), this._accessTokenExpired.cancel();
          }, t2.prototype.unload = function t3() {
            n.Log.debug("AccessTokenEvents.unload: canceling existing access token timers"), this._accessTokenExpiring.cancel(), this._accessTokenExpired.cancel();
          }, t2.prototype.addAccessTokenExpiring = function t3(e2) {
            this._accessTokenExpiring.addHandler(e2);
          }, t2.prototype.removeAccessTokenExpiring = function t3(e2) {
            this._accessTokenExpiring.removeHandler(e2);
          }, t2.prototype.addAccessTokenExpired = function t3(e2) {
            this._accessTokenExpired.addHandler(e2);
          }, t2.prototype.removeAccessTokenExpired = function t3(e2) {
            this._accessTokenExpired.removeHandler(e2);
          }, t2;
        }();
      }, function(t, e, r) {
        "use strict";
        Object.defineProperty(e, "__esModule", { value: true }), e.Event = void 0;
        var n = r(0);
        e.Event = function() {
          function t2(e2) {
            !function r2(t3, e3) {
              if (!(t3 instanceof e3))
                throw new TypeError("Cannot call a class as a function");
            }(this, t2), this._name = e2, this._callbacks = [];
          }
          return t2.prototype.addHandler = function t3(e2) {
            this._callbacks.push(e2);
          }, t2.prototype.removeHandler = function t3(e2) {
            var r2 = this._callbacks.findIndex(function(t4) {
              return t4 === e2;
            });
            r2 >= 0 && this._callbacks.splice(r2, 1);
          }, t2.prototype.raise = function t3() {
            n.Log.debug("Event: Raising event: " + this._name);
            for (var e2 = 0; e2 < this._callbacks.length; e2++) {
              var r2;
              (r2 = this._callbacks)[e2].apply(r2, arguments);
            }
          }, t2;
        }();
      }, function(t, e, r) {
        "use strict";
        Object.defineProperty(e, "__esModule", { value: true }), e.SessionMonitor = void 0;
        var n = function() {
          function t2(t3, e2) {
            for (var r2 = 0; r2 < e2.length; r2++) {
              var n2 = e2[r2];
              n2.enumerable = n2.enumerable || false, n2.configurable = true, "value" in n2 && (n2.writable = true), Object.defineProperty(t3, n2.key, n2);
            }
          }
          return function(e2, r2, n2) {
            return r2 && t2(e2.prototype, r2), n2 && t2(e2, n2), e2;
          };
        }(), i = r(0), o = r(19), s = r(1);
        function a(t2, e2) {
          if (!(t2 instanceof e2))
            throw new TypeError("Cannot call a class as a function");
        }
        e.SessionMonitor = function() {
          function t2(e2) {
            var r2 = this, n2 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : o.CheckSessionIFrame, u = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : s.Global.timer;
            if (a(this, t2), !e2)
              throw i.Log.error("SessionMonitor.ctor: No user manager passed to SessionMonitor"), new Error("userManager");
            this._userManager = e2, this._CheckSessionIFrameCtor = n2, this._timer = u, this._userManager.events.addUserLoaded(this._start.bind(this)), this._userManager.events.addUserUnloaded(this._stop.bind(this)), Promise.resolve(this._userManager.getUser().then(function(t3) {
              t3 ? r2._start(t3) : r2._settings.monitorAnonymousSession && r2._userManager.querySessionStatus().then(function(t4) {
                var e3 = { session_state: t4.session_state };
                t4.sub && t4.sid && (e3.profile = { sub: t4.sub, sid: t4.sid }), r2._start(e3);
              }).catch(function(t4) {
                i.Log.error("SessionMonitor ctor: error from querySessionStatus:", t4.message);
              });
            }).catch(function(t3) {
              i.Log.error("SessionMonitor ctor: error from getUser:", t3.message);
            }));
          }
          return t2.prototype._start = function t3(e2) {
            var r2 = this, n2 = e2.session_state;
            n2 && (e2.profile ? (this._sub = e2.profile.sub, this._sid = e2.profile.sid, i.Log.debug("SessionMonitor._start: session_state:", n2, ", sub:", this._sub)) : (this._sub = void 0, this._sid = void 0, i.Log.debug("SessionMonitor._start: session_state:", n2, ", anonymous user")), this._checkSessionIFrame ? this._checkSessionIFrame.start(n2) : this._metadataService.getCheckSessionIframe().then(function(t4) {
              if (t4) {
                i.Log.debug("SessionMonitor._start: Initializing check session iframe");
                var e3 = r2._client_id, o2 = r2._checkSessionInterval, s2 = r2._stopCheckSessionOnError;
                r2._checkSessionIFrame = new r2._CheckSessionIFrameCtor(r2._callback.bind(r2), e3, t4, o2, s2), r2._checkSessionIFrame.load().then(function() {
                  r2._checkSessionIFrame.start(n2);
                });
              } else
                i.Log.warn("SessionMonitor._start: No check session iframe found in the metadata");
            }).catch(function(t4) {
              i.Log.error("SessionMonitor._start: Error from getCheckSessionIframe:", t4.message);
            }));
          }, t2.prototype._stop = function t3() {
            var e2 = this;
            if (this._sub = void 0, this._sid = void 0, this._checkSessionIFrame && (i.Log.debug("SessionMonitor._stop"), this._checkSessionIFrame.stop()), this._settings.monitorAnonymousSession)
              var r2 = this._timer.setInterval(function() {
                e2._timer.clearInterval(r2), e2._userManager.querySessionStatus().then(function(t4) {
                  var r3 = { session_state: t4.session_state };
                  t4.sub && t4.sid && (r3.profile = { sub: t4.sub, sid: t4.sid }), e2._start(r3);
                }).catch(function(t4) {
                  i.Log.error("SessionMonitor: error from querySessionStatus:", t4.message);
                });
              }, 1e3);
          }, t2.prototype._callback = function t3() {
            var e2 = this;
            this._userManager.querySessionStatus().then(function(t4) {
              var r2 = true;
              t4 ? t4.sub === e2._sub ? (r2 = false, e2._checkSessionIFrame.start(t4.session_state), t4.sid === e2._sid ? i.Log.debug("SessionMonitor._callback: Same sub still logged in at OP, restarting check session iframe; session_state:", t4.session_state) : (i.Log.debug("SessionMonitor._callback: Same sub still logged in at OP, session state has changed, restarting check session iframe; session_state:", t4.session_state), e2._userManager.events._raiseUserSessionChanged())) : i.Log.debug("SessionMonitor._callback: Different subject signed into OP:", t4.sub) : i.Log.debug("SessionMonitor._callback: Subject no longer signed into OP"), r2 && (e2._sub ? (i.Log.debug("SessionMonitor._callback: SessionMonitor._callback; raising signed out event"), e2._userManager.events._raiseUserSignedOut()) : (i.Log.debug("SessionMonitor._callback: SessionMonitor._callback; raising signed in event"), e2._userManager.events._raiseUserSignedIn()));
            }).catch(function(t4) {
              e2._sub && (i.Log.debug("SessionMonitor._callback: Error calling queryCurrentSigninSession; raising signed out event", t4.message), e2._userManager.events._raiseUserSignedOut());
            });
          }, n(t2, [{ key: "_settings", get: function t3() {
            return this._userManager.settings;
          } }, { key: "_metadataService", get: function t3() {
            return this._userManager.metadataService;
          } }, { key: "_client_id", get: function t3() {
            return this._settings.client_id;
          } }, { key: "_checkSessionInterval", get: function t3() {
            return this._settings.checkSessionInterval;
          } }, { key: "_stopCheckSessionOnError", get: function t3() {
            return this._settings.stopCheckSessionOnError;
          } }]), t2;
        }();
      }, function(t, e, r) {
        "use strict";
        Object.defineProperty(e, "__esModule", { value: true }), e.CheckSessionIFrame = void 0;
        var n = r(0);
        function i(t2, e2) {
          if (!(t2 instanceof e2))
            throw new TypeError("Cannot call a class as a function");
        }
        e.CheckSessionIFrame = function() {
          function t2(e2, r2, n2, o) {
            var s = !(arguments.length > 4 && void 0 !== arguments[4]) || arguments[4];
            i(this, t2), this._callback = e2, this._client_id = r2, this._url = n2, this._interval = o || 2e3, this._stopOnError = s;
            var a = n2.indexOf("/", n2.indexOf("//") + 2);
            this._frame_origin = n2.substr(0, a), this._frame = window.document.createElement("iframe"), this._frame.style.visibility = "hidden", this._frame.style.position = "absolute", this._frame.style.display = "none", this._frame.width = 0, this._frame.height = 0, this._frame.src = n2;
          }
          return t2.prototype.load = function t3() {
            var e2 = this;
            return new Promise(function(t4) {
              e2._frame.onload = function() {
                t4();
              }, window.document.body.appendChild(e2._frame), e2._boundMessageEvent = e2._message.bind(e2), window.addEventListener("message", e2._boundMessageEvent, false);
            });
          }, t2.prototype._message = function t3(e2) {
            e2.origin === this._frame_origin && e2.source === this._frame.contentWindow && ("error" === e2.data ? (n.Log.error("CheckSessionIFrame: error message from check session op iframe"), this._stopOnError && this.stop()) : "changed" === e2.data ? (n.Log.debug("CheckSessionIFrame: changed message from check session op iframe"), this.stop(), this._callback()) : n.Log.debug("CheckSessionIFrame: " + e2.data + " message from check session op iframe"));
          }, t2.prototype.start = function t3(e2) {
            var r2 = this;
            if (this._session_state !== e2) {
              n.Log.debug("CheckSessionIFrame.start"), this.stop(), this._session_state = e2;
              var i2 = function t4() {
                r2._frame.contentWindow.postMessage(r2._client_id + " " + r2._session_state, r2._frame_origin);
              };
              i2(), this._timer = window.setInterval(i2, this._interval);
            }
          }, t2.prototype.stop = function t3() {
            this._session_state = null, this._timer && (n.Log.debug("CheckSessionIFrame.stop"), window.clearInterval(this._timer), this._timer = null);
          }, t2;
        }();
      }, function(t, e, r) {
        "use strict";
        Object.defineProperty(e, "__esModule", { value: true }), e.TokenRevocationClient = void 0;
        var n = r(0), i = r(2), o = r(1);
        function s(t2, e2) {
          if (!(t2 instanceof e2))
            throw new TypeError("Cannot call a class as a function");
        }
        var a = "access_token", u = "refresh_token";
        e.TokenRevocationClient = function() {
          function t2(e2) {
            var r2 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : o.Global.XMLHttpRequest, a2 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : i.MetadataService;
            if (s(this, t2), !e2)
              throw n.Log.error("TokenRevocationClient.ctor: No settings provided"), new Error("No settings provided.");
            this._settings = e2, this._XMLHttpRequestCtor = r2, this._metadataService = new a2(this._settings);
          }
          return t2.prototype.revoke = function t3(e2, r2) {
            var i2 = this, o2 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "access_token";
            if (!e2)
              throw n.Log.error("TokenRevocationClient.revoke: No token provided"), new Error("No token provided.");
            if (o2 !== a && o2 != u)
              throw n.Log.error("TokenRevocationClient.revoke: Invalid token type"), new Error("Invalid token type.");
            return this._metadataService.getRevocationEndpoint().then(function(t4) {
              if (t4) {
                n.Log.debug("TokenRevocationClient.revoke: Revoking " + o2);
                var s2 = i2._settings.client_id, a2 = i2._settings.client_secret;
                return i2._revoke(t4, s2, a2, e2, o2);
              }
              if (r2)
                throw n.Log.error("TokenRevocationClient.revoke: Revocation not supported"), new Error("Revocation not supported");
            });
          }, t2.prototype._revoke = function t3(e2, r2, i2, o2, s2) {
            var a2 = this;
            return new Promise(function(t4, u2) {
              var c = new a2._XMLHttpRequestCtor();
              c.open("POST", e2), c.onload = function() {
                n.Log.debug("TokenRevocationClient.revoke: HTTP response received, status", c.status), 200 === c.status ? t4() : u2(Error(c.statusText + " (" + c.status + ")"));
              }, c.onerror = function() {
                n.Log.debug("TokenRevocationClient.revoke: Network Error."), u2("Network Error");
              };
              var h = "client_id=" + encodeURIComponent(r2);
              i2 && (h += "&client_secret=" + encodeURIComponent(i2)), h += "&token_type_hint=" + encodeURIComponent(s2), h += "&token=" + encodeURIComponent(o2), c.setRequestHeader("Content-Type", "application/x-www-form-urlencoded"), c.send(h);
            });
          }, t2;
        }();
      }, function(t, e, r) {
        "use strict";
        Object.defineProperty(e, "__esModule", { value: true }), e.CordovaPopupWindow = void 0;
        var n = function() {
          function t2(t3, e2) {
            for (var r2 = 0; r2 < e2.length; r2++) {
              var n2 = e2[r2];
              n2.enumerable = n2.enumerable || false, n2.configurable = true, "value" in n2 && (n2.writable = true), Object.defineProperty(t3, n2.key, n2);
            }
          }
          return function(e2, r2, n2) {
            return r2 && t2(e2.prototype, r2), n2 && t2(e2, n2), e2;
          };
        }(), i = r(0);
        e.CordovaPopupWindow = function() {
          function t2(e2) {
            var r2 = this;
            !function n2(t3, e3) {
              if (!(t3 instanceof e3))
                throw new TypeError("Cannot call a class as a function");
            }(this, t2), this._promise = new Promise(function(t3, e3) {
              r2._resolve = t3, r2._reject = e3;
            }), this.features = e2.popupWindowFeatures || "location=no,toolbar=no,zoom=no", this.target = e2.popupWindowTarget || "_blank", this.redirect_uri = e2.startUrl, i.Log.debug("CordovaPopupWindow.ctor: redirect_uri: " + this.redirect_uri);
          }
          return t2.prototype._isInAppBrowserInstalled = function t3(e2) {
            return ["cordova-plugin-inappbrowser", "cordova-plugin-inappbrowser.inappbrowser", "org.apache.cordova.inappbrowser"].some(function(t4) {
              return e2.hasOwnProperty(t4);
            });
          }, t2.prototype.navigate = function t3(e2) {
            if (e2 && e2.url) {
              if (!window.cordova)
                return this._error("cordova is undefined");
              var r2 = window.cordova.require("cordova/plugin_list").metadata;
              if (false === this._isInAppBrowserInstalled(r2))
                return this._error("InAppBrowser plugin not found");
              this._popup = cordova.InAppBrowser.open(e2.url, this.target, this.features), this._popup ? (i.Log.debug("CordovaPopupWindow.navigate: popup successfully created"), this._exitCallbackEvent = this._exitCallback.bind(this), this._loadStartCallbackEvent = this._loadStartCallback.bind(this), this._popup.addEventListener("exit", this._exitCallbackEvent, false), this._popup.addEventListener("loadstart", this._loadStartCallbackEvent, false)) : this._error("Error opening popup window");
            } else
              this._error("No url provided");
            return this.promise;
          }, t2.prototype._loadStartCallback = function t3(e2) {
            0 === e2.url.indexOf(this.redirect_uri) && this._success({ url: e2.url });
          }, t2.prototype._exitCallback = function t3(e2) {
            this._error(e2);
          }, t2.prototype._success = function t3(e2) {
            this._cleanup(), i.Log.debug("CordovaPopupWindow: Successful response from cordova popup window"), this._resolve(e2);
          }, t2.prototype._error = function t3(e2) {
            this._cleanup(), i.Log.error(e2), this._reject(new Error(e2));
          }, t2.prototype.close = function t3() {
            this._cleanup();
          }, t2.prototype._cleanup = function t3() {
            this._popup && (i.Log.debug("CordovaPopupWindow: cleaning up popup"), this._popup.removeEventListener("exit", this._exitCallbackEvent, false), this._popup.removeEventListener("loadstart", this._loadStartCallbackEvent, false), this._popup.close()), this._popup = null;
          }, n(t2, [{ key: "promise", get: function t3() {
            return this._promise;
          } }]), t2;
        }();
      }, function(t, e, r) {
        "use strict";
        Object.defineProperty(e, "__esModule", { value: true });
        var n = r(0), i = r(10), o = r(5), s = r(6), a = r(37), u = r(38), c = r(16), h = r(2), l = r(48), f = r(49), g = r(19), d = r(20), p = r(18), v = r(1), y = r(15), m = r(50);
        e.default = { Version: m.Version, Log: n.Log, OidcClient: i.OidcClient, OidcClientSettings: o.OidcClientSettings, WebStorageStateStore: s.WebStorageStateStore, InMemoryWebStorage: a.InMemoryWebStorage, UserManager: u.UserManager, AccessTokenEvents: c.AccessTokenEvents, MetadataService: h.MetadataService, CordovaPopupNavigator: l.CordovaPopupNavigator, CordovaIFrameNavigator: f.CordovaIFrameNavigator, CheckSessionIFrame: g.CheckSessionIFrame, TokenRevocationClient: d.TokenRevocationClient, SessionMonitor: p.SessionMonitor, Global: v.Global, User: y.User }, t.exports = e.default;
      }, function(t, e, r) {
        "use strict";
        Object.defineProperty(e, "__esModule", { value: true });
        e.ClockService = function() {
          function t2() {
            !function e2(t3, r2) {
              if (!(t3 instanceof r2))
                throw new TypeError("Cannot call a class as a function");
            }(this, t2);
          }
          return t2.prototype.getEpochTime = function t3() {
            return Promise.resolve(Date.now() / 1e3 | 0);
          }, t2;
        }();
      }, function(t, e, r) {
        "use strict";
        Object.defineProperty(e, "__esModule", { value: true }), e.ResponseValidator = void 0;
        var n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t2) {
          return typeof t2;
        } : function(t2) {
          return t2 && "function" == typeof Symbol && t2.constructor === Symbol && t2 !== Symbol.prototype ? "symbol" : typeof t2;
        }, i = r(0), o = r(2), s = r(25), a = r(11), u = r(12), c = r(4);
        function h(t2, e2) {
          if (!(t2 instanceof e2))
            throw new TypeError("Cannot call a class as a function");
        }
        var l = ["nonce", "at_hash", "iat", "nbf", "exp", "aud", "iss", "c_hash"];
        e.ResponseValidator = function() {
          function t2(e2) {
            var r2 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : o.MetadataService, n2 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : s.UserInfoService, u2 = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : c.JoseUtil, l2 = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : a.TokenClient;
            if (h(this, t2), !e2)
              throw i.Log.error("ResponseValidator.ctor: No settings passed to ResponseValidator"), new Error("settings");
            this._settings = e2, this._metadataService = new r2(this._settings), this._userInfoService = new n2(this._settings), this._joseUtil = u2, this._tokenClient = new l2(this._settings);
          }
          return t2.prototype.validateSigninResponse = function t3(e2, r2) {
            var n2 = this;
            return i.Log.debug("ResponseValidator.validateSigninResponse"), this._processSigninParams(e2, r2).then(function(t4) {
              return i.Log.debug("ResponseValidator.validateSigninResponse: state processed"), n2._validateTokens(e2, t4).then(function(t5) {
                return i.Log.debug("ResponseValidator.validateSigninResponse: tokens validated"), n2._processClaims(e2, t5).then(function(t6) {
                  return i.Log.debug("ResponseValidator.validateSigninResponse: claims processed"), t6;
                });
              });
            });
          }, t2.prototype.validateSignoutResponse = function t3(e2, r2) {
            return e2.id !== r2.state ? (i.Log.error("ResponseValidator.validateSignoutResponse: State does not match"), Promise.reject(new Error("State does not match"))) : (i.Log.debug("ResponseValidator.validateSignoutResponse: state validated"), r2.state = e2.data, r2.error ? (i.Log.warn("ResponseValidator.validateSignoutResponse: Response was error", r2.error), Promise.reject(new u.ErrorResponse(r2))) : Promise.resolve(r2));
          }, t2.prototype._processSigninParams = function t3(e2, r2) {
            if (e2.id !== r2.state)
              return i.Log.error("ResponseValidator._processSigninParams: State does not match"), Promise.reject(new Error("State does not match"));
            if (!e2.client_id)
              return i.Log.error("ResponseValidator._processSigninParams: No client_id on state"), Promise.reject(new Error("No client_id on state"));
            if (!e2.authority)
              return i.Log.error("ResponseValidator._processSigninParams: No authority on state"), Promise.reject(new Error("No authority on state"));
            if (this._settings.authority) {
              if (this._settings.authority && this._settings.authority !== e2.authority)
                return i.Log.error("ResponseValidator._processSigninParams: authority mismatch on settings vs. signin state"), Promise.reject(new Error("authority mismatch on settings vs. signin state"));
            } else
              this._settings.authority = e2.authority;
            if (this._settings.client_id) {
              if (this._settings.client_id && this._settings.client_id !== e2.client_id)
                return i.Log.error("ResponseValidator._processSigninParams: client_id mismatch on settings vs. signin state"), Promise.reject(new Error("client_id mismatch on settings vs. signin state"));
            } else
              this._settings.client_id = e2.client_id;
            return i.Log.debug("ResponseValidator._processSigninParams: state validated"), r2.state = e2.data, r2.error ? (i.Log.warn("ResponseValidator._processSigninParams: Response was error", r2.error), Promise.reject(new u.ErrorResponse(r2))) : e2.nonce && !r2.id_token ? (i.Log.error("ResponseValidator._processSigninParams: Expecting id_token in response"), Promise.reject(new Error("No id_token in response"))) : !e2.nonce && r2.id_token ? (i.Log.error("ResponseValidator._processSigninParams: Not expecting id_token in response"), Promise.reject(new Error("Unexpected id_token in response"))) : e2.code_verifier && !r2.code ? (i.Log.error("ResponseValidator._processSigninParams: Expecting code in response"), Promise.reject(new Error("No code in response"))) : !e2.code_verifier && r2.code ? (i.Log.error("ResponseValidator._processSigninParams: Not expecting code in response"), Promise.reject(new Error("Unexpected code in response"))) : (r2.scope || (r2.scope = e2.scope), Promise.resolve(r2));
          }, t2.prototype._processClaims = function t3(e2, r2) {
            var n2 = this;
            if (r2.isOpenIdConnect) {
              if (i.Log.debug("ResponseValidator._processClaims: response is OIDC, processing claims"), r2.profile = this._filterProtocolClaims(r2.profile), true !== e2.skipUserInfo && this._settings.loadUserInfo && r2.access_token)
                return i.Log.debug("ResponseValidator._processClaims: loading user info"), this._userInfoService.getClaims(r2.access_token).then(function(t4) {
                  return i.Log.debug("ResponseValidator._processClaims: user info claims received from user info endpoint"), t4.sub !== r2.profile.sub ? (i.Log.error("ResponseValidator._processClaims: sub from user info endpoint does not match sub in id_token"), Promise.reject(new Error("sub from user info endpoint does not match sub in id_token"))) : (r2.profile = n2._mergeClaims(r2.profile, t4), i.Log.debug("ResponseValidator._processClaims: user info claims received, updated profile:", r2.profile), r2);
                });
              i.Log.debug("ResponseValidator._processClaims: not loading user info");
            } else
              i.Log.debug("ResponseValidator._processClaims: response is not OIDC, not processing claims");
            return Promise.resolve(r2);
          }, t2.prototype._mergeClaims = function t3(e2, r2) {
            var i2 = Object.assign({}, e2);
            for (var o2 in r2) {
              var s2 = r2[o2];
              Array.isArray(s2) || (s2 = [s2]);
              for (var a2 = 0; a2 < s2.length; a2++) {
                var u2 = s2[a2];
                i2[o2] ? Array.isArray(i2[o2]) ? i2[o2].indexOf(u2) < 0 && i2[o2].push(u2) : i2[o2] !== u2 && ("object" === (void 0 === u2 ? "undefined" : n(u2)) && this._settings.mergeClaims ? i2[o2] = this._mergeClaims(i2[o2], u2) : i2[o2] = [i2[o2], u2]) : i2[o2] = u2;
              }
            }
            return i2;
          }, t2.prototype._filterProtocolClaims = function t3(e2) {
            i.Log.debug("ResponseValidator._filterProtocolClaims, incoming claims:", e2);
            var r2 = Object.assign({}, e2);
            return this._settings._filterProtocolClaims ? (l.forEach(function(t4) {
              delete r2[t4];
            }), i.Log.debug("ResponseValidator._filterProtocolClaims: protocol claims filtered", r2)) : i.Log.debug("ResponseValidator._filterProtocolClaims: protocol claims not filtered"), r2;
          }, t2.prototype._validateTokens = function t3(e2, r2) {
            return r2.code ? (i.Log.debug("ResponseValidator._validateTokens: Validating code"), this._processCode(e2, r2)) : r2.id_token ? r2.access_token ? (i.Log.debug("ResponseValidator._validateTokens: Validating id_token and access_token"), this._validateIdTokenAndAccessToken(e2, r2)) : (i.Log.debug("ResponseValidator._validateTokens: Validating id_token"), this._validateIdToken(e2, r2)) : (i.Log.debug("ResponseValidator._validateTokens: No code to process or id_token to validate"), Promise.resolve(r2));
          }, t2.prototype._processCode = function t3(e2, r2) {
            var o2 = this, s2 = { client_id: e2.client_id, client_secret: e2.client_secret, code: r2.code, redirect_uri: e2.redirect_uri, code_verifier: e2.code_verifier };
            return e2.extraTokenParams && "object" === n(e2.extraTokenParams) && Object.assign(s2, e2.extraTokenParams), this._tokenClient.exchangeCode(s2).then(function(t4) {
              for (var n2 in t4)
                r2[n2] = t4[n2];
              return r2.id_token ? (i.Log.debug("ResponseValidator._processCode: token response successful, processing id_token"), o2._validateIdTokenAttributes(e2, r2)) : (i.Log.debug("ResponseValidator._processCode: token response successful, returning response"), r2);
            });
          }, t2.prototype._validateIdTokenAttributes = function t3(e2, r2) {
            var n2 = this;
            return this._metadataService.getIssuer().then(function(t4) {
              var o2 = e2.client_id, s2 = n2._settings.clockSkew;
              return i.Log.debug("ResponseValidator._validateIdTokenAttributes: Validaing JWT attributes; using clock skew (in seconds) of: ", s2), n2._settings.getEpochTime().then(function(a2) {
                return n2._joseUtil.validateJwtAttributes(r2.id_token, t4, o2, s2, a2).then(function(t5) {
                  return e2.nonce && e2.nonce !== t5.nonce ? (i.Log.error("ResponseValidator._validateIdTokenAttributes: Invalid nonce in id_token"), Promise.reject(new Error("Invalid nonce in id_token"))) : t5.sub ? (r2.profile = t5, r2) : (i.Log.error("ResponseValidator._validateIdTokenAttributes: No sub present in id_token"), Promise.reject(new Error("No sub present in id_token")));
                });
              });
            });
          }, t2.prototype._validateIdTokenAndAccessToken = function t3(e2, r2) {
            var n2 = this;
            return this._validateIdToken(e2, r2).then(function(t4) {
              return n2._validateAccessToken(t4);
            });
          }, t2.prototype._getSigningKeyForJwt = function t3(e2) {
            var r2 = this;
            return this._metadataService.getSigningKeys().then(function(t4) {
              var n2 = e2.header.kid;
              if (!t4)
                return i.Log.error("ResponseValidator._validateIdToken: No signing keys from metadata"), Promise.reject(new Error("No signing keys from metadata"));
              i.Log.debug("ResponseValidator._validateIdToken: Received signing keys");
              var o2 = void 0;
              if (n2)
                o2 = t4.filter(function(t5) {
                  return t5.kid === n2;
                })[0];
              else {
                if ((t4 = r2._filterByAlg(t4, e2.header.alg)).length > 1)
                  return i.Log.error("ResponseValidator._validateIdToken: No kid found in id_token and more than one key found in metadata"), Promise.reject(new Error("No kid found in id_token and more than one key found in metadata"));
                o2 = t4[0];
              }
              return Promise.resolve(o2);
            });
          }, t2.prototype._getSigningKeyForJwtWithSingleRetry = function t3(e2) {
            var r2 = this;
            return this._getSigningKeyForJwt(e2).then(function(t4) {
              return t4 ? Promise.resolve(t4) : (r2._metadataService.resetSigningKeys(), r2._getSigningKeyForJwt(e2));
            });
          }, t2.prototype._validateIdToken = function t3(e2, r2) {
            var n2 = this;
            if (!e2.nonce)
              return i.Log.error("ResponseValidator._validateIdToken: No nonce on state"), Promise.reject(new Error("No nonce on state"));
            var o2 = this._joseUtil.parseJwt(r2.id_token);
            return o2 && o2.header && o2.payload ? e2.nonce !== o2.payload.nonce ? (i.Log.error("ResponseValidator._validateIdToken: Invalid nonce in id_token"), Promise.reject(new Error("Invalid nonce in id_token"))) : this._metadataService.getIssuer().then(function(t4) {
              return i.Log.debug("ResponseValidator._validateIdToken: Received issuer"), n2._getSigningKeyForJwtWithSingleRetry(o2).then(function(s2) {
                if (!s2)
                  return i.Log.error("ResponseValidator._validateIdToken: No key matching kid or alg found in signing keys"), Promise.reject(new Error("No key matching kid or alg found in signing keys"));
                var a2 = e2.client_id, u2 = n2._settings.clockSkew;
                return i.Log.debug("ResponseValidator._validateIdToken: Validaing JWT; using clock skew (in seconds) of: ", u2), n2._joseUtil.validateJwt(r2.id_token, s2, t4, a2, u2).then(function() {
                  return i.Log.debug("ResponseValidator._validateIdToken: JWT validation successful"), o2.payload.sub ? (r2.profile = o2.payload, r2) : (i.Log.error("ResponseValidator._validateIdToken: No sub present in id_token"), Promise.reject(new Error("No sub present in id_token")));
                });
              });
            }) : (i.Log.error("ResponseValidator._validateIdToken: Failed to parse id_token", o2), Promise.reject(new Error("Failed to parse id_token")));
          }, t2.prototype._filterByAlg = function t3(e2, r2) {
            var n2 = null;
            if (r2.startsWith("RS"))
              n2 = "RSA";
            else if (r2.startsWith("PS"))
              n2 = "PS";
            else {
              if (!r2.startsWith("ES"))
                return i.Log.debug("ResponseValidator._filterByAlg: alg not supported: ", r2), [];
              n2 = "EC";
            }
            return i.Log.debug("ResponseValidator._filterByAlg: Looking for keys that match kty: ", n2), e2 = e2.filter(function(t4) {
              return t4.kty === n2;
            }), i.Log.debug("ResponseValidator._filterByAlg: Number of keys that match kty: ", n2, e2.length), e2;
          }, t2.prototype._validateAccessToken = function t3(e2) {
            if (!e2.profile)
              return i.Log.error("ResponseValidator._validateAccessToken: No profile loaded from id_token"), Promise.reject(new Error("No profile loaded from id_token"));
            if (!e2.profile.at_hash)
              return i.Log.error("ResponseValidator._validateAccessToken: No at_hash in id_token"), Promise.reject(new Error("No at_hash in id_token"));
            if (!e2.id_token)
              return i.Log.error("ResponseValidator._validateAccessToken: No id_token"), Promise.reject(new Error("No id_token"));
            var r2 = this._joseUtil.parseJwt(e2.id_token);
            if (!r2 || !r2.header)
              return i.Log.error("ResponseValidator._validateAccessToken: Failed to parse id_token", r2), Promise.reject(new Error("Failed to parse id_token"));
            var n2 = r2.header.alg;
            if (!n2 || 5 !== n2.length)
              return i.Log.error("ResponseValidator._validateAccessToken: Unsupported alg:", n2), Promise.reject(new Error("Unsupported alg: " + n2));
            var o2 = n2.substr(2, 3);
            if (!o2)
              return i.Log.error("ResponseValidator._validateAccessToken: Unsupported alg:", n2, o2), Promise.reject(new Error("Unsupported alg: " + n2));
            if (256 !== (o2 = parseInt(o2)) && 384 !== o2 && 512 !== o2)
              return i.Log.error("ResponseValidator._validateAccessToken: Unsupported alg:", n2, o2), Promise.reject(new Error("Unsupported alg: " + n2));
            var s2 = "sha" + o2, a2 = this._joseUtil.hashString(e2.access_token, s2);
            if (!a2)
              return i.Log.error("ResponseValidator._validateAccessToken: access_token hash failed:", s2), Promise.reject(new Error("Failed to validate at_hash"));
            var u2 = a2.substr(0, a2.length / 2), c2 = this._joseUtil.hexToBase64Url(u2);
            return c2 !== e2.profile.at_hash ? (i.Log.error("ResponseValidator._validateAccessToken: Failed to validate at_hash", c2, e2.profile.at_hash), Promise.reject(new Error("Failed to validate at_hash"))) : (i.Log.debug("ResponseValidator._validateAccessToken: success"), Promise.resolve(e2));
          }, t2;
        }();
      }, function(t, e, r) {
        "use strict";
        Object.defineProperty(e, "__esModule", { value: true }), e.UserInfoService = void 0;
        var n = r(7), i = r(2), o = r(0), s = r(4);
        function a(t2, e2) {
          if (!(t2 instanceof e2))
            throw new TypeError("Cannot call a class as a function");
        }
        e.UserInfoService = function() {
          function t2(e2) {
            var r2 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : n.JsonService, u = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : i.MetadataService, c = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : s.JoseUtil;
            if (a(this, t2), !e2)
              throw o.Log.error("UserInfoService.ctor: No settings passed"), new Error("settings");
            this._settings = e2, this._jsonService = new r2(void 0, void 0, this._getClaimsFromJwt.bind(this)), this._metadataService = new u(this._settings), this._joseUtil = c;
          }
          return t2.prototype.getClaims = function t3(e2) {
            var r2 = this;
            return e2 ? this._metadataService.getUserInfoEndpoint().then(function(t4) {
              return o.Log.debug("UserInfoService.getClaims: received userinfo url", t4), r2._jsonService.getJson(t4, e2).then(function(t5) {
                return o.Log.debug("UserInfoService.getClaims: claims received", t5), t5;
              });
            }) : (o.Log.error("UserInfoService.getClaims: No token passed"), Promise.reject(new Error("A token is required")));
          }, t2.prototype._getClaimsFromJwt = function t3(e2) {
            var r2 = this;
            try {
              var n2 = this._joseUtil.parseJwt(e2.responseText);
              if (!n2 || !n2.header || !n2.payload)
                return o.Log.error("UserInfoService._getClaimsFromJwt: Failed to parse JWT", n2), Promise.reject(new Error("Failed to parse id_token"));
              var i2 = n2.header.kid, s2 = void 0;
              switch (this._settings.userInfoJwtIssuer) {
                case "OP":
                  s2 = this._metadataService.getIssuer();
                  break;
                case "ANY":
                  s2 = Promise.resolve(n2.payload.iss);
                  break;
                default:
                  s2 = Promise.resolve(this._settings.userInfoJwtIssuer);
              }
              return s2.then(function(t4) {
                return o.Log.debug("UserInfoService._getClaimsFromJwt: Received issuer:" + t4), r2._metadataService.getSigningKeys().then(function(s3) {
                  if (!s3)
                    return o.Log.error("UserInfoService._getClaimsFromJwt: No signing keys from metadata"), Promise.reject(new Error("No signing keys from metadata"));
                  o.Log.debug("UserInfoService._getClaimsFromJwt: Received signing keys");
                  var a2 = void 0;
                  if (i2)
                    a2 = s3.filter(function(t5) {
                      return t5.kid === i2;
                    })[0];
                  else {
                    if ((s3 = r2._filterByAlg(s3, n2.header.alg)).length > 1)
                      return o.Log.error("UserInfoService._getClaimsFromJwt: No kid found in id_token and more than one key found in metadata"), Promise.reject(new Error("No kid found in id_token and more than one key found in metadata"));
                    a2 = s3[0];
                  }
                  if (!a2)
                    return o.Log.error("UserInfoService._getClaimsFromJwt: No key matching kid or alg found in signing keys"), Promise.reject(new Error("No key matching kid or alg found in signing keys"));
                  var u = r2._settings.client_id, c = r2._settings.clockSkew;
                  return o.Log.debug("UserInfoService._getClaimsFromJwt: Validaing JWT; using clock skew (in seconds) of: ", c), r2._joseUtil.validateJwt(e2.responseText, a2, t4, u, c, void 0, true).then(function() {
                    return o.Log.debug("UserInfoService._getClaimsFromJwt: JWT validation successful"), n2.payload;
                  });
                });
              });
            } catch (t4) {
              return o.Log.error("UserInfoService._getClaimsFromJwt: Error parsing JWT response", t4.message), void reject(t4);
            }
          }, t2.prototype._filterByAlg = function t3(e2, r2) {
            var n2 = null;
            if (r2.startsWith("RS"))
              n2 = "RSA";
            else if (r2.startsWith("PS"))
              n2 = "PS";
            else {
              if (!r2.startsWith("ES"))
                return o.Log.debug("UserInfoService._filterByAlg: alg not supported: ", r2), [];
              n2 = "EC";
            }
            return o.Log.debug("UserInfoService._filterByAlg: Looking for keys that match kty: ", n2), e2 = e2.filter(function(t4) {
              return t4.kty === n2;
            }), o.Log.debug("UserInfoService._filterByAlg: Number of keys that match kty: ", n2, e2.length), e2;
          }, t2;
        }();
      }, function(t, e, r) {
        "use strict";
        Object.defineProperty(e, "__esModule", { value: true }), e.AllowedSigningAlgs = e.b64tohex = e.hextob64u = e.crypto = e.X509 = e.KeyUtil = e.jws = void 0;
        var n = r(27);
        e.jws = n.jws, e.KeyUtil = n.KEYUTIL, e.X509 = n.X509, e.crypto = n.crypto, e.hextob64u = n.hextob64u, e.b64tohex = n.b64tohex, e.AllowedSigningAlgs = ["RS256", "RS384", "RS512", "PS256", "PS384", "PS512", "ES256", "ES384", "ES512"];
      }, function(t, e, r) {
        "use strict";
        (function(t2) {
          Object.defineProperty(e, "__esModule", { value: true });
          var r2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t3) {
            return typeof t3;
          } : function(t3) {
            return t3 && "function" == typeof Symbol && t3.constructor === Symbol && t3 !== Symbol.prototype ? "symbol" : typeof t3;
          }, n = { userAgent: false }, i = {};
          if (void 0 === o)
            var o = {};
          o.lang = { extend: function t3(e2, r3, i2) {
            if (!r3 || !e2)
              throw new Error("YAHOO.lang.extend failed, please check that all dependencies are included.");
            var o2 = function t4() {
            };
            if (o2.prototype = r3.prototype, e2.prototype = new o2(), e2.prototype.constructor = e2, e2.superclass = r3.prototype, r3.prototype.constructor == Object.prototype.constructor && (r3.prototype.constructor = r3), i2) {
              var s2;
              for (s2 in i2)
                e2.prototype[s2] = i2[s2];
              var a2 = function t4() {
              }, u2 = ["toString", "valueOf"];
              try {
                /MSIE/.test(n.userAgent) && (a2 = function t4(e3, r4) {
                  for (s2 = 0; s2 < u2.length; s2 += 1) {
                    var n2 = u2[s2], i3 = r4[n2];
                    "function" == typeof i3 && i3 != Object.prototype[n2] && (e3[n2] = i3);
                  }
                });
              } catch (t4) {
              }
              a2(e2.prototype, i2);
            }
          } };
          var s, a, u, c, h, l, f, g, d, p, v, y = y || (s = Math, u = (a = {}).lib = {}, c = u.Base = function() {
            function t3() {
            }
            return { extend: function e2(r3) {
              t3.prototype = this;
              var n2 = new t3();
              return r3 && n2.mixIn(r3), n2.hasOwnProperty("init") || (n2.init = function() {
                n2.$super.init.apply(this, arguments);
              }), n2.init.prototype = n2, n2.$super = this, n2;
            }, create: function t4() {
              var e2 = this.extend();
              return e2.init.apply(e2, arguments), e2;
            }, init: function t4() {
            }, mixIn: function t4(e2) {
              for (var r3 in e2)
                e2.hasOwnProperty(r3) && (this[r3] = e2[r3]);
              e2.hasOwnProperty("toString") && (this.toString = e2.toString);
            }, clone: function t4() {
              return this.init.prototype.extend(this);
            } };
          }(), h = u.WordArray = c.extend({ init: function t3(e2, r3) {
            e2 = this.words = e2 || [], this.sigBytes = null != r3 ? r3 : 4 * e2.length;
          }, toString: function t3(e2) {
            return (e2 || f).stringify(this);
          }, concat: function t3(e2) {
            var r3 = this.words, n2 = e2.words, i2 = this.sigBytes, o2 = e2.sigBytes;
            if (this.clamp(), i2 % 4)
              for (var s2 = 0; s2 < o2; s2++) {
                var a2 = n2[s2 >>> 2] >>> 24 - s2 % 4 * 8 & 255;
                r3[i2 + s2 >>> 2] |= a2 << 24 - (i2 + s2) % 4 * 8;
              }
            else
              for (s2 = 0; s2 < o2; s2 += 4)
                r3[i2 + s2 >>> 2] = n2[s2 >>> 2];
            return this.sigBytes += o2, this;
          }, clamp: function t3() {
            var e2 = this.words, r3 = this.sigBytes;
            e2[r3 >>> 2] &= 4294967295 << 32 - r3 % 4 * 8, e2.length = s.ceil(r3 / 4);
          }, clone: function t3() {
            var e2 = c.clone.call(this);
            return e2.words = this.words.slice(0), e2;
          }, random: function t3(e2) {
            for (var r3 = [], n2 = 0; n2 < e2; n2 += 4)
              r3.push(4294967296 * s.random() | 0);
            return new h.init(r3, e2);
          } }), l = a.enc = {}, f = l.Hex = { stringify: function t3(e2) {
            for (var r3 = e2.words, n2 = e2.sigBytes, i2 = [], o2 = 0; o2 < n2; o2++) {
              var s2 = r3[o2 >>> 2] >>> 24 - o2 % 4 * 8 & 255;
              i2.push((s2 >>> 4).toString(16)), i2.push((15 & s2).toString(16));
            }
            return i2.join("");
          }, parse: function t3(e2) {
            for (var r3 = e2.length, n2 = [], i2 = 0; i2 < r3; i2 += 2)
              n2[i2 >>> 3] |= parseInt(e2.substr(i2, 2), 16) << 24 - i2 % 8 * 4;
            return new h.init(n2, r3 / 2);
          } }, g = l.Latin1 = { stringify: function t3(e2) {
            for (var r3 = e2.words, n2 = e2.sigBytes, i2 = [], o2 = 0; o2 < n2; o2++) {
              var s2 = r3[o2 >>> 2] >>> 24 - o2 % 4 * 8 & 255;
              i2.push(String.fromCharCode(s2));
            }
            return i2.join("");
          }, parse: function t3(e2) {
            for (var r3 = e2.length, n2 = [], i2 = 0; i2 < r3; i2++)
              n2[i2 >>> 2] |= (255 & e2.charCodeAt(i2)) << 24 - i2 % 4 * 8;
            return new h.init(n2, r3);
          } }, d = l.Utf8 = { stringify: function t3(e2) {
            try {
              return decodeURIComponent(escape(g.stringify(e2)));
            } catch (t4) {
              throw new Error("Malformed UTF-8 data");
            }
          }, parse: function t3(e2) {
            return g.parse(unescape(encodeURIComponent(e2)));
          } }, p = u.BufferedBlockAlgorithm = c.extend({ reset: function t3() {
            this._data = new h.init(), this._nDataBytes = 0;
          }, _append: function t3(e2) {
            "string" == typeof e2 && (e2 = d.parse(e2)), this._data.concat(e2), this._nDataBytes += e2.sigBytes;
          }, _process: function t3(e2) {
            var r3 = this._data, n2 = r3.words, i2 = r3.sigBytes, o2 = this.blockSize, a2 = i2 / (4 * o2), u2 = (a2 = e2 ? s.ceil(a2) : s.max((0 | a2) - this._minBufferSize, 0)) * o2, c2 = s.min(4 * u2, i2);
            if (u2) {
              for (var l2 = 0; l2 < u2; l2 += o2)
                this._doProcessBlock(n2, l2);
              var f2 = n2.splice(0, u2);
              r3.sigBytes -= c2;
            }
            return new h.init(f2, c2);
          }, clone: function t3() {
            var e2 = c.clone.call(this);
            return e2._data = this._data.clone(), e2;
          }, _minBufferSize: 0 }), u.Hasher = p.extend({ cfg: c.extend(), init: function t3(e2) {
            this.cfg = this.cfg.extend(e2), this.reset();
          }, reset: function t3() {
            p.reset.call(this), this._doReset();
          }, update: function t3(e2) {
            return this._append(e2), this._process(), this;
          }, finalize: function t3(e2) {
            return e2 && this._append(e2), this._doFinalize();
          }, blockSize: 16, _createHelper: function t3(e2) {
            return function(t4, r3) {
              return new e2.init(r3).finalize(t4);
            };
          }, _createHmacHelper: function t3(e2) {
            return function(t4, r3) {
              return new v.HMAC.init(e2, r3).finalize(t4);
            };
          } }), v = a.algo = {}, a);
          !function(t3) {
            var e2, r3 = (e2 = y).lib, n2 = r3.Base, i2 = r3.WordArray;
            (e2 = e2.x64 = {}).Word = n2.extend({ init: function t4(e3, r4) {
              this.high = e3, this.low = r4;
            } }), e2.WordArray = n2.extend({ init: function t4(e3, r4) {
              e3 = this.words = e3 || [], this.sigBytes = null != r4 ? r4 : 8 * e3.length;
            }, toX32: function t4() {
              for (var e3 = this.words, r4 = e3.length, n3 = [], o2 = 0; o2 < r4; o2++) {
                var s2 = e3[o2];
                n3.push(s2.high), n3.push(s2.low);
              }
              return i2.create(n3, this.sigBytes);
            }, clone: function t4() {
              for (var e3 = n2.clone.call(this), r4 = e3.words = this.words.slice(0), i3 = r4.length, o2 = 0; o2 < i3; o2++)
                r4[o2] = r4[o2].clone();
              return e3;
            } });
          }(), function() {
            var t3 = y, e2 = t3.lib.WordArray;
            t3.enc.Base64 = { stringify: function t4(e3) {
              var r3 = e3.words, n2 = e3.sigBytes, i2 = this._map;
              e3.clamp(), e3 = [];
              for (var o2 = 0; o2 < n2; o2 += 3)
                for (var s2 = (r3[o2 >>> 2] >>> 24 - o2 % 4 * 8 & 255) << 16 | (r3[o2 + 1 >>> 2] >>> 24 - (o2 + 1) % 4 * 8 & 255) << 8 | r3[o2 + 2 >>> 2] >>> 24 - (o2 + 2) % 4 * 8 & 255, a2 = 0; 4 > a2 && o2 + 0.75 * a2 < n2; a2++)
                  e3.push(i2.charAt(s2 >>> 6 * (3 - a2) & 63));
              if (r3 = i2.charAt(64))
                for (; e3.length % 4; )
                  e3.push(r3);
              return e3.join("");
            }, parse: function t4(r3) {
              var n2 = r3.length, i2 = this._map;
              (o2 = i2.charAt(64)) && (-1 != (o2 = r3.indexOf(o2)) && (n2 = o2));
              for (var o2 = [], s2 = 0, a2 = 0; a2 < n2; a2++)
                if (a2 % 4) {
                  var u2 = i2.indexOf(r3.charAt(a2 - 1)) << a2 % 4 * 2, c2 = i2.indexOf(r3.charAt(a2)) >>> 6 - a2 % 4 * 2;
                  o2[s2 >>> 2] |= (u2 | c2) << 24 - s2 % 4 * 8, s2++;
                }
              return e2.create(o2, s2);
            }, _map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=" };
          }(), function(t3) {
            for (var e2 = y, r3 = (i2 = e2.lib).WordArray, n2 = i2.Hasher, i2 = e2.algo, o2 = [], s2 = [], a2 = function t4(e3) {
              return 4294967296 * (e3 - (0 | e3)) | 0;
            }, u2 = 2, c2 = 0; 64 > c2; ) {
              var h2;
              t: {
                h2 = u2;
                for (var l2 = t3.sqrt(h2), f2 = 2; f2 <= l2; f2++)
                  if (!(h2 % f2)) {
                    h2 = false;
                    break t;
                  }
                h2 = true;
              }
              h2 && (8 > c2 && (o2[c2] = a2(t3.pow(u2, 0.5))), s2[c2] = a2(t3.pow(u2, 1 / 3)), c2++), u2++;
            }
            var g2 = [];
            i2 = i2.SHA256 = n2.extend({ _doReset: function t4() {
              this._hash = new r3.init(o2.slice(0));
            }, _doProcessBlock: function t4(e3, r4) {
              for (var n3 = this._hash.words, i3 = n3[0], o3 = n3[1], a3 = n3[2], u3 = n3[3], c3 = n3[4], h3 = n3[5], l3 = n3[6], f3 = n3[7], d2 = 0; 64 > d2; d2++) {
                if (16 > d2)
                  g2[d2] = 0 | e3[r4 + d2];
                else {
                  var p2 = g2[d2 - 15], v2 = g2[d2 - 2];
                  g2[d2] = ((p2 << 25 | p2 >>> 7) ^ (p2 << 14 | p2 >>> 18) ^ p2 >>> 3) + g2[d2 - 7] + ((v2 << 15 | v2 >>> 17) ^ (v2 << 13 | v2 >>> 19) ^ v2 >>> 10) + g2[d2 - 16];
                }
                p2 = f3 + ((c3 << 26 | c3 >>> 6) ^ (c3 << 21 | c3 >>> 11) ^ (c3 << 7 | c3 >>> 25)) + (c3 & h3 ^ ~c3 & l3) + s2[d2] + g2[d2], v2 = ((i3 << 30 | i3 >>> 2) ^ (i3 << 19 | i3 >>> 13) ^ (i3 << 10 | i3 >>> 22)) + (i3 & o3 ^ i3 & a3 ^ o3 & a3), f3 = l3, l3 = h3, h3 = c3, c3 = u3 + p2 | 0, u3 = a3, a3 = o3, o3 = i3, i3 = p2 + v2 | 0;
              }
              n3[0] = n3[0] + i3 | 0, n3[1] = n3[1] + o3 | 0, n3[2] = n3[2] + a3 | 0, n3[3] = n3[3] + u3 | 0, n3[4] = n3[4] + c3 | 0, n3[5] = n3[5] + h3 | 0, n3[6] = n3[6] + l3 | 0, n3[7] = n3[7] + f3 | 0;
            }, _doFinalize: function e3() {
              var r4 = this._data, n3 = r4.words, i3 = 8 * this._nDataBytes, o3 = 8 * r4.sigBytes;
              return n3[o3 >>> 5] |= 128 << 24 - o3 % 32, n3[14 + (o3 + 64 >>> 9 << 4)] = t3.floor(i3 / 4294967296), n3[15 + (o3 + 64 >>> 9 << 4)] = i3, r4.sigBytes = 4 * n3.length, this._process(), this._hash;
            }, clone: function t4() {
              var e3 = n2.clone.call(this);
              return e3._hash = this._hash.clone(), e3;
            } });
            e2.SHA256 = n2._createHelper(i2), e2.HmacSHA256 = n2._createHmacHelper(i2);
          }(Math), function() {
            function t3() {
              return n2.create.apply(n2, arguments);
            }
            for (var e2 = y, r3 = e2.lib.Hasher, n2 = (o2 = e2.x64).Word, i2 = o2.WordArray, o2 = e2.algo, s2 = [t3(1116352408, 3609767458), t3(1899447441, 602891725), t3(3049323471, 3964484399), t3(3921009573, 2173295548), t3(961987163, 4081628472), t3(1508970993, 3053834265), t3(2453635748, 2937671579), t3(2870763221, 3664609560), t3(3624381080, 2734883394), t3(310598401, 1164996542), t3(607225278, 1323610764), t3(1426881987, 3590304994), t3(1925078388, 4068182383), t3(2162078206, 991336113), t3(2614888103, 633803317), t3(3248222580, 3479774868), t3(3835390401, 2666613458), t3(4022224774, 944711139), t3(264347078, 2341262773), t3(604807628, 2007800933), t3(770255983, 1495990901), t3(1249150122, 1856431235), t3(1555081692, 3175218132), t3(1996064986, 2198950837), t3(2554220882, 3999719339), t3(2821834349, 766784016), t3(2952996808, 2566594879), t3(3210313671, 3203337956), t3(3336571891, 1034457026), t3(3584528711, 2466948901), t3(113926993, 3758326383), t3(338241895, 168717936), t3(666307205, 1188179964), t3(773529912, 1546045734), t3(1294757372, 1522805485), t3(1396182291, 2643833823), t3(1695183700, 2343527390), t3(1986661051, 1014477480), t3(2177026350, 1206759142), t3(2456956037, 344077627), t3(2730485921, 1290863460), t3(2820302411, 3158454273), t3(3259730800, 3505952657), t3(3345764771, 106217008), t3(3516065817, 3606008344), t3(3600352804, 1432725776), t3(4094571909, 1467031594), t3(275423344, 851169720), t3(430227734, 3100823752), t3(506948616, 1363258195), t3(659060556, 3750685593), t3(883997877, 3785050280), t3(958139571, 3318307427), t3(1322822218, 3812723403), t3(1537002063, 2003034995), t3(1747873779, 3602036899), t3(1955562222, 1575990012), t3(2024104815, 1125592928), t3(2227730452, 2716904306), t3(2361852424, 442776044), t3(2428436474, 593698344), t3(2756734187, 3733110249), t3(3204031479, 2999351573), t3(3329325298, 3815920427), t3(3391569614, 3928383900), t3(3515267271, 566280711), t3(3940187606, 3454069534), t3(4118630271, 4000239992), t3(116418474, 1914138554), t3(174292421, 2731055270), t3(289380356, 3203993006), t3(460393269, 320620315), t3(685471733, 587496836), t3(852142971, 1086792851), t3(1017036298, 365543100), t3(1126000580, 2618297676), t3(1288033470, 3409855158), t3(1501505948, 4234509866), t3(1607167915, 987167468), t3(1816402316, 1246189591)], a2 = [], u2 = 0; 80 > u2; u2++)
              a2[u2] = t3();
            o2 = o2.SHA512 = r3.extend({ _doReset: function t4() {
              this._hash = new i2.init([new n2.init(1779033703, 4089235720), new n2.init(3144134277, 2227873595), new n2.init(1013904242, 4271175723), new n2.init(2773480762, 1595750129), new n2.init(1359893119, 2917565137), new n2.init(2600822924, 725511199), new n2.init(528734635, 4215389547), new n2.init(1541459225, 327033209)]);
            }, _doProcessBlock: function t4(e3, r4) {
              for (var n3 = (f2 = this._hash.words)[0], i3 = f2[1], o3 = f2[2], u3 = f2[3], c2 = f2[4], h2 = f2[5], l2 = f2[6], f2 = f2[7], g2 = n3.high, d2 = n3.low, p2 = i3.high, v2 = i3.low, y2 = o3.high, m2 = o3.low, _2 = u3.high, S2 = u3.low, b2 = c2.high, w2 = c2.low, F2 = h2.high, E2 = h2.low, x = l2.high, A = l2.low, k = f2.high, P2 = f2.low, C2 = g2, T2 = d2, R2 = p2, I2 = v2, D2 = y2, L2 = m2, N2 = _2, U2 = S2, B2 = b2, O2 = w2, j2 = F2, M2 = E2, H2 = x, V2 = A, K2 = k, q2 = P2, J2 = 0; 80 > J2; J2++) {
                var W = a2[J2];
                if (16 > J2)
                  var z = W.high = 0 | e3[r4 + 2 * J2], Y = W.low = 0 | e3[r4 + 2 * J2 + 1];
                else {
                  z = ((Y = (z = a2[J2 - 15]).high) >>> 1 | (G = z.low) << 31) ^ (Y >>> 8 | G << 24) ^ Y >>> 7;
                  var G = (G >>> 1 | Y << 31) ^ (G >>> 8 | Y << 24) ^ (G >>> 7 | Y << 25), X = ((Y = (X = a2[J2 - 2]).high) >>> 19 | ($ = X.low) << 13) ^ (Y << 3 | $ >>> 29) ^ Y >>> 6, $ = ($ >>> 19 | Y << 13) ^ ($ << 3 | Y >>> 29) ^ ($ >>> 6 | Y << 26), Q = (Y = a2[J2 - 7]).high, Z = (tt = a2[J2 - 16]).high, tt = tt.low;
                  z = (z = (z = z + Q + ((Y = G + Y.low) >>> 0 < G >>> 0 ? 1 : 0)) + X + ((Y = Y + $) >>> 0 < $ >>> 0 ? 1 : 0)) + Z + ((Y = Y + tt) >>> 0 < tt >>> 0 ? 1 : 0);
                  W.high = z, W.low = Y;
                }
                Q = B2 & j2 ^ ~B2 & H2, tt = O2 & M2 ^ ~O2 & V2, W = C2 & R2 ^ C2 & D2 ^ R2 & D2;
                var et = T2 & I2 ^ T2 & L2 ^ I2 & L2, rt = (G = (C2 >>> 28 | T2 << 4) ^ (C2 << 30 | T2 >>> 2) ^ (C2 << 25 | T2 >>> 7), X = (T2 >>> 28 | C2 << 4) ^ (T2 << 30 | C2 >>> 2) ^ (T2 << 25 | C2 >>> 7), ($ = s2[J2]).high), nt = $.low;
                Z = K2 + ((B2 >>> 14 | O2 << 18) ^ (B2 >>> 18 | O2 << 14) ^ (B2 << 23 | O2 >>> 9)) + (($ = q2 + ((O2 >>> 14 | B2 << 18) ^ (O2 >>> 18 | B2 << 14) ^ (O2 << 23 | B2 >>> 9))) >>> 0 < q2 >>> 0 ? 1 : 0), K2 = H2, q2 = V2, H2 = j2, V2 = M2, j2 = B2, M2 = O2, B2 = N2 + (Z = (Z = (Z = Z + Q + (($ = $ + tt) >>> 0 < tt >>> 0 ? 1 : 0)) + rt + (($ = $ + nt) >>> 0 < nt >>> 0 ? 1 : 0)) + z + (($ = $ + Y) >>> 0 < Y >>> 0 ? 1 : 0)) + ((O2 = U2 + $ | 0) >>> 0 < U2 >>> 0 ? 1 : 0) | 0, N2 = D2, U2 = L2, D2 = R2, L2 = I2, R2 = C2, I2 = T2, C2 = Z + (W = G + W + ((Y = X + et) >>> 0 < X >>> 0 ? 1 : 0)) + ((T2 = $ + Y | 0) >>> 0 < $ >>> 0 ? 1 : 0) | 0;
              }
              d2 = n3.low = d2 + T2, n3.high = g2 + C2 + (d2 >>> 0 < T2 >>> 0 ? 1 : 0), v2 = i3.low = v2 + I2, i3.high = p2 + R2 + (v2 >>> 0 < I2 >>> 0 ? 1 : 0), m2 = o3.low = m2 + L2, o3.high = y2 + D2 + (m2 >>> 0 < L2 >>> 0 ? 1 : 0), S2 = u3.low = S2 + U2, u3.high = _2 + N2 + (S2 >>> 0 < U2 >>> 0 ? 1 : 0), w2 = c2.low = w2 + O2, c2.high = b2 + B2 + (w2 >>> 0 < O2 >>> 0 ? 1 : 0), E2 = h2.low = E2 + M2, h2.high = F2 + j2 + (E2 >>> 0 < M2 >>> 0 ? 1 : 0), A = l2.low = A + V2, l2.high = x + H2 + (A >>> 0 < V2 >>> 0 ? 1 : 0), P2 = f2.low = P2 + q2, f2.high = k + K2 + (P2 >>> 0 < q2 >>> 0 ? 1 : 0);
            }, _doFinalize: function t4() {
              var e3 = this._data, r4 = e3.words, n3 = 8 * this._nDataBytes, i3 = 8 * e3.sigBytes;
              return r4[i3 >>> 5] |= 128 << 24 - i3 % 32, r4[30 + (i3 + 128 >>> 10 << 5)] = Math.floor(n3 / 4294967296), r4[31 + (i3 + 128 >>> 10 << 5)] = n3, e3.sigBytes = 4 * r4.length, this._process(), this._hash.toX32();
            }, clone: function t4() {
              var e3 = r3.clone.call(this);
              return e3._hash = this._hash.clone(), e3;
            }, blockSize: 32 }), e2.SHA512 = r3._createHelper(o2), e2.HmacSHA512 = r3._createHmacHelper(o2);
          }(), function() {
            var t3 = y, e2 = (i2 = t3.x64).Word, r3 = i2.WordArray, n2 = (i2 = t3.algo).SHA512, i2 = i2.SHA384 = n2.extend({ _doReset: function t4() {
              this._hash = new r3.init([new e2.init(3418070365, 3238371032), new e2.init(1654270250, 914150663), new e2.init(2438529370, 812702999), new e2.init(355462360, 4144912697), new e2.init(1731405415, 4290775857), new e2.init(2394180231, 1750603025), new e2.init(3675008525, 1694076839), new e2.init(1203062813, 3204075428)]);
            }, _doFinalize: function t4() {
              var e3 = n2._doFinalize.call(this);
              return e3.sigBytes -= 16, e3;
            } });
            t3.SHA384 = n2._createHelper(i2), t3.HmacSHA384 = n2._createHmacHelper(i2);
          }();
          var m, _ = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
          function S(t3) {
            var e2, r3, n2 = "";
            for (e2 = 0; e2 + 3 <= t3.length; e2 += 3)
              r3 = parseInt(t3.substring(e2, e2 + 3), 16), n2 += _.charAt(r3 >> 6) + _.charAt(63 & r3);
            for (e2 + 1 == t3.length ? (r3 = parseInt(t3.substring(e2, e2 + 1), 16), n2 += _.charAt(r3 << 2)) : e2 + 2 == t3.length && (r3 = parseInt(t3.substring(e2, e2 + 2), 16), n2 += _.charAt(r3 >> 2) + _.charAt((3 & r3) << 4)), "="; (3 & n2.length) > 0; )
              n2 += "=";
            return n2;
          }
          function b(t3) {
            var e2, r3, n2, i2 = "", o2 = 0;
            for (e2 = 0; e2 < t3.length && "=" != t3.charAt(e2); ++e2)
              (n2 = _.indexOf(t3.charAt(e2))) < 0 || (0 == o2 ? (i2 += R(n2 >> 2), r3 = 3 & n2, o2 = 1) : 1 == o2 ? (i2 += R(r3 << 2 | n2 >> 4), r3 = 15 & n2, o2 = 2) : 2 == o2 ? (i2 += R(r3), i2 += R(n2 >> 2), r3 = 3 & n2, o2 = 3) : (i2 += R(r3 << 2 | n2 >> 4), i2 += R(15 & n2), o2 = 0));
            return 1 == o2 && (i2 += R(r3 << 2)), i2;
          }
          function w(t3) {
            var e2, r3 = b(t3), n2 = new Array();
            for (e2 = 0; 2 * e2 < r3.length; ++e2)
              n2[e2] = parseInt(r3.substring(2 * e2, 2 * e2 + 2), 16);
            return n2;
          }
          function F(t3, e2, r3) {
            null != t3 && ("number" == typeof t3 ? this.fromNumber(t3, e2, r3) : null == e2 && "string" != typeof t3 ? this.fromString(t3, 256) : this.fromString(t3, e2));
          }
          function E() {
            return new F(null);
          }
          "Microsoft Internet Explorer" == n.appName ? (F.prototype.am = function x(t3, e2, r3, n2, i2, o2) {
            for (var s2 = 32767 & e2, a2 = e2 >> 15; --o2 >= 0; ) {
              var u2 = 32767 & this[t3], c2 = this[t3++] >> 15, h2 = a2 * u2 + c2 * s2;
              i2 = ((u2 = s2 * u2 + ((32767 & h2) << 15) + r3[n2] + (1073741823 & i2)) >>> 30) + (h2 >>> 15) + a2 * c2 + (i2 >>> 30), r3[n2++] = 1073741823 & u2;
            }
            return i2;
          }, m = 30) : "Netscape" != n.appName ? (F.prototype.am = function A(t3, e2, r3, n2, i2, o2) {
            for (; --o2 >= 0; ) {
              var s2 = e2 * this[t3++] + r3[n2] + i2;
              i2 = Math.floor(s2 / 67108864), r3[n2++] = 67108863 & s2;
            }
            return i2;
          }, m = 26) : (F.prototype.am = function k(t3, e2, r3, n2, i2, o2) {
            for (var s2 = 16383 & e2, a2 = e2 >> 14; --o2 >= 0; ) {
              var u2 = 16383 & this[t3], c2 = this[t3++] >> 14, h2 = a2 * u2 + c2 * s2;
              i2 = ((u2 = s2 * u2 + ((16383 & h2) << 14) + r3[n2] + i2) >> 28) + (h2 >> 14) + a2 * c2, r3[n2++] = 268435455 & u2;
            }
            return i2;
          }, m = 28), F.prototype.DB = m, F.prototype.DM = (1 << m) - 1, F.prototype.DV = 1 << m;
          F.prototype.FV = Math.pow(2, 52), F.prototype.F1 = 52 - m, F.prototype.F2 = 2 * m - 52;
          var P, C, T = new Array();
          for (P = "0".charCodeAt(0), C = 0; C <= 9; ++C)
            T[P++] = C;
          for (P = "a".charCodeAt(0), C = 10; C < 36; ++C)
            T[P++] = C;
          for (P = "A".charCodeAt(0), C = 10; C < 36; ++C)
            T[P++] = C;
          function R(t3) {
            return "0123456789abcdefghijklmnopqrstuvwxyz".charAt(t3);
          }
          function I(t3, e2) {
            var r3 = T[t3.charCodeAt(e2)];
            return null == r3 ? -1 : r3;
          }
          function D(t3) {
            var e2 = E();
            return e2.fromInt(t3), e2;
          }
          function L(t3) {
            var e2, r3 = 1;
            return 0 != (e2 = t3 >>> 16) && (t3 = e2, r3 += 16), 0 != (e2 = t3 >> 8) && (t3 = e2, r3 += 8), 0 != (e2 = t3 >> 4) && (t3 = e2, r3 += 4), 0 != (e2 = t3 >> 2) && (t3 = e2, r3 += 2), 0 != (e2 = t3 >> 1) && (t3 = e2, r3 += 1), r3;
          }
          function N(t3) {
            this.m = t3;
          }
          function U(t3) {
            this.m = t3, this.mp = t3.invDigit(), this.mpl = 32767 & this.mp, this.mph = this.mp >> 15, this.um = (1 << t3.DB - 15) - 1, this.mt2 = 2 * t3.t;
          }
          function B(t3, e2) {
            return t3 & e2;
          }
          function O(t3, e2) {
            return t3 | e2;
          }
          function j(t3, e2) {
            return t3 ^ e2;
          }
          function M(t3, e2) {
            return t3 & ~e2;
          }
          function H(t3) {
            if (0 == t3)
              return -1;
            var e2 = 0;
            return 0 == (65535 & t3) && (t3 >>= 16, e2 += 16), 0 == (255 & t3) && (t3 >>= 8, e2 += 8), 0 == (15 & t3) && (t3 >>= 4, e2 += 4), 0 == (3 & t3) && (t3 >>= 2, e2 += 2), 0 == (1 & t3) && ++e2, e2;
          }
          function V(t3) {
            for (var e2 = 0; 0 != t3; )
              t3 &= t3 - 1, ++e2;
            return e2;
          }
          function K() {
          }
          function q(t3) {
            return t3;
          }
          function J(t3) {
            this.r2 = E(), this.q3 = E(), F.ONE.dlShiftTo(2 * t3.t, this.r2), this.mu = this.r2.divide(t3), this.m = t3;
          }
          N.prototype.convert = function W(t3) {
            return t3.s < 0 || t3.compareTo(this.m) >= 0 ? t3.mod(this.m) : t3;
          }, N.prototype.revert = function z(t3) {
            return t3;
          }, N.prototype.reduce = function Y(t3) {
            t3.divRemTo(this.m, null, t3);
          }, N.prototype.mulTo = function G(t3, e2, r3) {
            t3.multiplyTo(e2, r3), this.reduce(r3);
          }, N.prototype.sqrTo = function X(t3, e2) {
            t3.squareTo(e2), this.reduce(e2);
          }, U.prototype.convert = function $(t3) {
            var e2 = E();
            return t3.abs().dlShiftTo(this.m.t, e2), e2.divRemTo(this.m, null, e2), t3.s < 0 && e2.compareTo(F.ZERO) > 0 && this.m.subTo(e2, e2), e2;
          }, U.prototype.revert = function Q(t3) {
            var e2 = E();
            return t3.copyTo(e2), this.reduce(e2), e2;
          }, U.prototype.reduce = function Z(t3) {
            for (; t3.t <= this.mt2; )
              t3[t3.t++] = 0;
            for (var e2 = 0; e2 < this.m.t; ++e2) {
              var r3 = 32767 & t3[e2], n2 = r3 * this.mpl + ((r3 * this.mph + (t3[e2] >> 15) * this.mpl & this.um) << 15) & t3.DM;
              for (t3[r3 = e2 + this.m.t] += this.m.am(0, n2, t3, e2, 0, this.m.t); t3[r3] >= t3.DV; )
                t3[r3] -= t3.DV, t3[++r3]++;
            }
            t3.clamp(), t3.drShiftTo(this.m.t, t3), t3.compareTo(this.m) >= 0 && t3.subTo(this.m, t3);
          }, U.prototype.mulTo = function tt(t3, e2, r3) {
            t3.multiplyTo(e2, r3), this.reduce(r3);
          }, U.prototype.sqrTo = function et(t3, e2) {
            t3.squareTo(e2), this.reduce(e2);
          }, F.prototype.copyTo = function rt(t3) {
            for (var e2 = this.t - 1; e2 >= 0; --e2)
              t3[e2] = this[e2];
            t3.t = this.t, t3.s = this.s;
          }, F.prototype.fromInt = function nt(t3) {
            this.t = 1, this.s = t3 < 0 ? -1 : 0, t3 > 0 ? this[0] = t3 : t3 < -1 ? this[0] = t3 + this.DV : this.t = 0;
          }, F.prototype.fromString = function it(t3, e2) {
            var r3;
            if (16 == e2)
              r3 = 4;
            else if (8 == e2)
              r3 = 3;
            else if (256 == e2)
              r3 = 8;
            else if (2 == e2)
              r3 = 1;
            else if (32 == e2)
              r3 = 5;
            else {
              if (4 != e2)
                return void this.fromRadix(t3, e2);
              r3 = 2;
            }
            this.t = 0, this.s = 0;
            for (var n2 = t3.length, i2 = false, o2 = 0; --n2 >= 0; ) {
              var s2 = 8 == r3 ? 255 & t3[n2] : I(t3, n2);
              s2 < 0 ? "-" == t3.charAt(n2) && (i2 = true) : (i2 = false, 0 == o2 ? this[this.t++] = s2 : o2 + r3 > this.DB ? (this[this.t - 1] |= (s2 & (1 << this.DB - o2) - 1) << o2, this[this.t++] = s2 >> this.DB - o2) : this[this.t - 1] |= s2 << o2, (o2 += r3) >= this.DB && (o2 -= this.DB));
            }
            8 == r3 && 0 != (128 & t3[0]) && (this.s = -1, o2 > 0 && (this[this.t - 1] |= (1 << this.DB - o2) - 1 << o2)), this.clamp(), i2 && F.ZERO.subTo(this, this);
          }, F.prototype.clamp = function ot() {
            for (var t3 = this.s & this.DM; this.t > 0 && this[this.t - 1] == t3; )
              --this.t;
          }, F.prototype.dlShiftTo = function st(t3, e2) {
            var r3;
            for (r3 = this.t - 1; r3 >= 0; --r3)
              e2[r3 + t3] = this[r3];
            for (r3 = t3 - 1; r3 >= 0; --r3)
              e2[r3] = 0;
            e2.t = this.t + t3, e2.s = this.s;
          }, F.prototype.drShiftTo = function at(t3, e2) {
            for (var r3 = t3; r3 < this.t; ++r3)
              e2[r3 - t3] = this[r3];
            e2.t = Math.max(this.t - t3, 0), e2.s = this.s;
          }, F.prototype.lShiftTo = function ut(t3, e2) {
            var r3, n2 = t3 % this.DB, i2 = this.DB - n2, o2 = (1 << i2) - 1, s2 = Math.floor(t3 / this.DB), a2 = this.s << n2 & this.DM;
            for (r3 = this.t - 1; r3 >= 0; --r3)
              e2[r3 + s2 + 1] = this[r3] >> i2 | a2, a2 = (this[r3] & o2) << n2;
            for (r3 = s2 - 1; r3 >= 0; --r3)
              e2[r3] = 0;
            e2[s2] = a2, e2.t = this.t + s2 + 1, e2.s = this.s, e2.clamp();
          }, F.prototype.rShiftTo = function ct(t3, e2) {
            e2.s = this.s;
            var r3 = Math.floor(t3 / this.DB);
            if (r3 >= this.t)
              e2.t = 0;
            else {
              var n2 = t3 % this.DB, i2 = this.DB - n2, o2 = (1 << n2) - 1;
              e2[0] = this[r3] >> n2;
              for (var s2 = r3 + 1; s2 < this.t; ++s2)
                e2[s2 - r3 - 1] |= (this[s2] & o2) << i2, e2[s2 - r3] = this[s2] >> n2;
              n2 > 0 && (e2[this.t - r3 - 1] |= (this.s & o2) << i2), e2.t = this.t - r3, e2.clamp();
            }
          }, F.prototype.subTo = function ht(t3, e2) {
            for (var r3 = 0, n2 = 0, i2 = Math.min(t3.t, this.t); r3 < i2; )
              n2 += this[r3] - t3[r3], e2[r3++] = n2 & this.DM, n2 >>= this.DB;
            if (t3.t < this.t) {
              for (n2 -= t3.s; r3 < this.t; )
                n2 += this[r3], e2[r3++] = n2 & this.DM, n2 >>= this.DB;
              n2 += this.s;
            } else {
              for (n2 += this.s; r3 < t3.t; )
                n2 -= t3[r3], e2[r3++] = n2 & this.DM, n2 >>= this.DB;
              n2 -= t3.s;
            }
            e2.s = n2 < 0 ? -1 : 0, n2 < -1 ? e2[r3++] = this.DV + n2 : n2 > 0 && (e2[r3++] = n2), e2.t = r3, e2.clamp();
          }, F.prototype.multiplyTo = function lt(t3, e2) {
            var r3 = this.abs(), n2 = t3.abs(), i2 = r3.t;
            for (e2.t = i2 + n2.t; --i2 >= 0; )
              e2[i2] = 0;
            for (i2 = 0; i2 < n2.t; ++i2)
              e2[i2 + r3.t] = r3.am(0, n2[i2], e2, i2, 0, r3.t);
            e2.s = 0, e2.clamp(), this.s != t3.s && F.ZERO.subTo(e2, e2);
          }, F.prototype.squareTo = function ft(t3) {
            for (var e2 = this.abs(), r3 = t3.t = 2 * e2.t; --r3 >= 0; )
              t3[r3] = 0;
            for (r3 = 0; r3 < e2.t - 1; ++r3) {
              var n2 = e2.am(r3, e2[r3], t3, 2 * r3, 0, 1);
              (t3[r3 + e2.t] += e2.am(r3 + 1, 2 * e2[r3], t3, 2 * r3 + 1, n2, e2.t - r3 - 1)) >= e2.DV && (t3[r3 + e2.t] -= e2.DV, t3[r3 + e2.t + 1] = 1);
            }
            t3.t > 0 && (t3[t3.t - 1] += e2.am(r3, e2[r3], t3, 2 * r3, 0, 1)), t3.s = 0, t3.clamp();
          }, F.prototype.divRemTo = function gt(t3, e2, r3) {
            var n2 = t3.abs();
            if (!(n2.t <= 0)) {
              var i2 = this.abs();
              if (i2.t < n2.t)
                return null != e2 && e2.fromInt(0), void (null != r3 && this.copyTo(r3));
              null == r3 && (r3 = E());
              var o2 = E(), s2 = this.s, a2 = t3.s, u2 = this.DB - L(n2[n2.t - 1]);
              u2 > 0 ? (n2.lShiftTo(u2, o2), i2.lShiftTo(u2, r3)) : (n2.copyTo(o2), i2.copyTo(r3));
              var c2 = o2.t, h2 = o2[c2 - 1];
              if (0 != h2) {
                var l2 = h2 * (1 << this.F1) + (c2 > 1 ? o2[c2 - 2] >> this.F2 : 0), f2 = this.FV / l2, g2 = (1 << this.F1) / l2, d2 = 1 << this.F2, p2 = r3.t, v2 = p2 - c2, y2 = null == e2 ? E() : e2;
                for (o2.dlShiftTo(v2, y2), r3.compareTo(y2) >= 0 && (r3[r3.t++] = 1, r3.subTo(y2, r3)), F.ONE.dlShiftTo(c2, y2), y2.subTo(o2, o2); o2.t < c2; )
                  o2[o2.t++] = 0;
                for (; --v2 >= 0; ) {
                  var m2 = r3[--p2] == h2 ? this.DM : Math.floor(r3[p2] * f2 + (r3[p2 - 1] + d2) * g2);
                  if ((r3[p2] += o2.am(0, m2, r3, v2, 0, c2)) < m2)
                    for (o2.dlShiftTo(v2, y2), r3.subTo(y2, r3); r3[p2] < --m2; )
                      r3.subTo(y2, r3);
                }
                null != e2 && (r3.drShiftTo(c2, e2), s2 != a2 && F.ZERO.subTo(e2, e2)), r3.t = c2, r3.clamp(), u2 > 0 && r3.rShiftTo(u2, r3), s2 < 0 && F.ZERO.subTo(r3, r3);
              }
            }
          }, F.prototype.invDigit = function dt() {
            if (this.t < 1)
              return 0;
            var t3 = this[0];
            if (0 == (1 & t3))
              return 0;
            var e2 = 3 & t3;
            return (e2 = (e2 = (e2 = (e2 = e2 * (2 - (15 & t3) * e2) & 15) * (2 - (255 & t3) * e2) & 255) * (2 - ((65535 & t3) * e2 & 65535)) & 65535) * (2 - t3 * e2 % this.DV) % this.DV) > 0 ? this.DV - e2 : -e2;
          }, F.prototype.isEven = function pt() {
            return 0 == (this.t > 0 ? 1 & this[0] : this.s);
          }, F.prototype.exp = function vt(t3, e2) {
            if (t3 > 4294967295 || t3 < 1)
              return F.ONE;
            var r3 = E(), n2 = E(), i2 = e2.convert(this), o2 = L(t3) - 1;
            for (i2.copyTo(r3); --o2 >= 0; )
              if (e2.sqrTo(r3, n2), (t3 & 1 << o2) > 0)
                e2.mulTo(n2, i2, r3);
              else {
                var s2 = r3;
                r3 = n2, n2 = s2;
              }
            return e2.revert(r3);
          }, F.prototype.toString = function yt(t3) {
            if (this.s < 0)
              return "-" + this.negate().toString(t3);
            var e2;
            if (16 == t3)
              e2 = 4;
            else if (8 == t3)
              e2 = 3;
            else if (2 == t3)
              e2 = 1;
            else if (32 == t3)
              e2 = 5;
            else {
              if (4 != t3)
                return this.toRadix(t3);
              e2 = 2;
            }
            var r3, n2 = (1 << e2) - 1, i2 = false, o2 = "", s2 = this.t, a2 = this.DB - s2 * this.DB % e2;
            if (s2-- > 0)
              for (a2 < this.DB && (r3 = this[s2] >> a2) > 0 && (i2 = true, o2 = R(r3)); s2 >= 0; )
                a2 < e2 ? (r3 = (this[s2] & (1 << a2) - 1) << e2 - a2, r3 |= this[--s2] >> (a2 += this.DB - e2)) : (r3 = this[s2] >> (a2 -= e2) & n2, a2 <= 0 && (a2 += this.DB, --s2)), r3 > 0 && (i2 = true), i2 && (o2 += R(r3));
            return i2 ? o2 : "0";
          }, F.prototype.negate = function mt() {
            var t3 = E();
            return F.ZERO.subTo(this, t3), t3;
          }, F.prototype.abs = function _t() {
            return this.s < 0 ? this.negate() : this;
          }, F.prototype.compareTo = function St(t3) {
            var e2 = this.s - t3.s;
            if (0 != e2)
              return e2;
            var r3 = this.t;
            if (0 != (e2 = r3 - t3.t))
              return this.s < 0 ? -e2 : e2;
            for (; --r3 >= 0; )
              if (0 != (e2 = this[r3] - t3[r3]))
                return e2;
            return 0;
          }, F.prototype.bitLength = function bt() {
            return this.t <= 0 ? 0 : this.DB * (this.t - 1) + L(this[this.t - 1] ^ this.s & this.DM);
          }, F.prototype.mod = function wt(t3) {
            var e2 = E();
            return this.abs().divRemTo(t3, null, e2), this.s < 0 && e2.compareTo(F.ZERO) > 0 && t3.subTo(e2, e2), e2;
          }, F.prototype.modPowInt = function Ft(t3, e2) {
            var r3;
            return r3 = t3 < 256 || e2.isEven() ? new N(e2) : new U(e2), this.exp(t3, r3);
          }, F.ZERO = D(0), F.ONE = D(1), K.prototype.convert = q, K.prototype.revert = q, K.prototype.mulTo = function Et(t3, e2, r3) {
            t3.multiplyTo(e2, r3);
          }, K.prototype.sqrTo = function xt(t3, e2) {
            t3.squareTo(e2);
          }, J.prototype.convert = function At(t3) {
            if (t3.s < 0 || t3.t > 2 * this.m.t)
              return t3.mod(this.m);
            if (t3.compareTo(this.m) < 0)
              return t3;
            var e2 = E();
            return t3.copyTo(e2), this.reduce(e2), e2;
          }, J.prototype.revert = function kt(t3) {
            return t3;
          }, J.prototype.reduce = function Pt(t3) {
            for (t3.drShiftTo(this.m.t - 1, this.r2), t3.t > this.m.t + 1 && (t3.t = this.m.t + 1, t3.clamp()), this.mu.multiplyUpperTo(this.r2, this.m.t + 1, this.q3), this.m.multiplyLowerTo(this.q3, this.m.t + 1, this.r2); t3.compareTo(this.r2) < 0; )
              t3.dAddOffset(1, this.m.t + 1);
            for (t3.subTo(this.r2, t3); t3.compareTo(this.m) >= 0; )
              t3.subTo(this.m, t3);
          }, J.prototype.mulTo = function Ct(t3, e2, r3) {
            t3.multiplyTo(e2, r3), this.reduce(r3);
          }, J.prototype.sqrTo = function Tt(t3, e2) {
            t3.squareTo(e2), this.reduce(e2);
          };
          var Rt = [2, 3, 5, 7, 11, 13, 17, 19, 23, 29, 31, 37, 41, 43, 47, 53, 59, 61, 67, 71, 73, 79, 83, 89, 97, 101, 103, 107, 109, 113, 127, 131, 137, 139, 149, 151, 157, 163, 167, 173, 179, 181, 191, 193, 197, 199, 211, 223, 227, 229, 233, 239, 241, 251, 257, 263, 269, 271, 277, 281, 283, 293, 307, 311, 313, 317, 331, 337, 347, 349, 353, 359, 367, 373, 379, 383, 389, 397, 401, 409, 419, 421, 431, 433, 439, 443, 449, 457, 461, 463, 467, 479, 487, 491, 499, 503, 509, 521, 523, 541, 547, 557, 563, 569, 571, 577, 587, 593, 599, 601, 607, 613, 617, 619, 631, 641, 643, 647, 653, 659, 661, 673, 677, 683, 691, 701, 709, 719, 727, 733, 739, 743, 751, 757, 761, 769, 773, 787, 797, 809, 811, 821, 823, 827, 829, 839, 853, 857, 859, 863, 877, 881, 883, 887, 907, 911, 919, 929, 937, 941, 947, 953, 967, 971, 977, 983, 991, 997], It = (1 << 26) / Rt[Rt.length - 1];
          function Dt() {
            this.i = 0, this.j = 0, this.S = new Array();
          }
          F.prototype.chunkSize = function Lt(t3) {
            return Math.floor(Math.LN2 * this.DB / Math.log(t3));
          }, F.prototype.toRadix = function Nt(t3) {
            if (null == t3 && (t3 = 10), 0 == this.signum() || t3 < 2 || t3 > 36)
              return "0";
            var e2 = this.chunkSize(t3), r3 = Math.pow(t3, e2), n2 = D(r3), i2 = E(), o2 = E(), s2 = "";
            for (this.divRemTo(n2, i2, o2); i2.signum() > 0; )
              s2 = (r3 + o2.intValue()).toString(t3).substr(1) + s2, i2.divRemTo(n2, i2, o2);
            return o2.intValue().toString(t3) + s2;
          }, F.prototype.fromRadix = function Ut(t3, e2) {
            this.fromInt(0), null == e2 && (e2 = 10);
            for (var r3 = this.chunkSize(e2), n2 = Math.pow(e2, r3), i2 = false, o2 = 0, s2 = 0, a2 = 0; a2 < t3.length; ++a2) {
              var u2 = I(t3, a2);
              u2 < 0 ? "-" == t3.charAt(a2) && 0 == this.signum() && (i2 = true) : (s2 = e2 * s2 + u2, ++o2 >= r3 && (this.dMultiply(n2), this.dAddOffset(s2, 0), o2 = 0, s2 = 0));
            }
            o2 > 0 && (this.dMultiply(Math.pow(e2, o2)), this.dAddOffset(s2, 0)), i2 && F.ZERO.subTo(this, this);
          }, F.prototype.fromNumber = function Bt(t3, e2, r3) {
            if ("number" == typeof e2)
              if (t3 < 2)
                this.fromInt(1);
              else
                for (this.fromNumber(t3, r3), this.testBit(t3 - 1) || this.bitwiseTo(F.ONE.shiftLeft(t3 - 1), O, this), this.isEven() && this.dAddOffset(1, 0); !this.isProbablePrime(e2); )
                  this.dAddOffset(2, 0), this.bitLength() > t3 && this.subTo(F.ONE.shiftLeft(t3 - 1), this);
            else {
              var n2 = new Array(), i2 = 7 & t3;
              n2.length = 1 + (t3 >> 3), e2.nextBytes(n2), i2 > 0 ? n2[0] &= (1 << i2) - 1 : n2[0] = 0, this.fromString(n2, 256);
            }
          }, F.prototype.bitwiseTo = function Ot(t3, e2, r3) {
            var n2, i2, o2 = Math.min(t3.t, this.t);
            for (n2 = 0; n2 < o2; ++n2)
              r3[n2] = e2(this[n2], t3[n2]);
            if (t3.t < this.t) {
              for (i2 = t3.s & this.DM, n2 = o2; n2 < this.t; ++n2)
                r3[n2] = e2(this[n2], i2);
              r3.t = this.t;
            } else {
              for (i2 = this.s & this.DM, n2 = o2; n2 < t3.t; ++n2)
                r3[n2] = e2(i2, t3[n2]);
              r3.t = t3.t;
            }
            r3.s = e2(this.s, t3.s), r3.clamp();
          }, F.prototype.changeBit = function jt(t3, e2) {
            var r3 = F.ONE.shiftLeft(t3);
            return this.bitwiseTo(r3, e2, r3), r3;
          }, F.prototype.addTo = function Mt(t3, e2) {
            for (var r3 = 0, n2 = 0, i2 = Math.min(t3.t, this.t); r3 < i2; )
              n2 += this[r3] + t3[r3], e2[r3++] = n2 & this.DM, n2 >>= this.DB;
            if (t3.t < this.t) {
              for (n2 += t3.s; r3 < this.t; )
                n2 += this[r3], e2[r3++] = n2 & this.DM, n2 >>= this.DB;
              n2 += this.s;
            } else {
              for (n2 += this.s; r3 < t3.t; )
                n2 += t3[r3], e2[r3++] = n2 & this.DM, n2 >>= this.DB;
              n2 += t3.s;
            }
            e2.s = n2 < 0 ? -1 : 0, n2 > 0 ? e2[r3++] = n2 : n2 < -1 && (e2[r3++] = this.DV + n2), e2.t = r3, e2.clamp();
          }, F.prototype.dMultiply = function Ht(t3) {
            this[this.t] = this.am(0, t3 - 1, this, 0, 0, this.t), ++this.t, this.clamp();
          }, F.prototype.dAddOffset = function Vt(t3, e2) {
            if (0 != t3) {
              for (; this.t <= e2; )
                this[this.t++] = 0;
              for (this[e2] += t3; this[e2] >= this.DV; )
                this[e2] -= this.DV, ++e2 >= this.t && (this[this.t++] = 0), ++this[e2];
            }
          }, F.prototype.multiplyLowerTo = function Kt(t3, e2, r3) {
            var n2, i2 = Math.min(this.t + t3.t, e2);
            for (r3.s = 0, r3.t = i2; i2 > 0; )
              r3[--i2] = 0;
            for (n2 = r3.t - this.t; i2 < n2; ++i2)
              r3[i2 + this.t] = this.am(0, t3[i2], r3, i2, 0, this.t);
            for (n2 = Math.min(t3.t, e2); i2 < n2; ++i2)
              this.am(0, t3[i2], r3, i2, 0, e2 - i2);
            r3.clamp();
          }, F.prototype.multiplyUpperTo = function qt(t3, e2, r3) {
            --e2;
            var n2 = r3.t = this.t + t3.t - e2;
            for (r3.s = 0; --n2 >= 0; )
              r3[n2] = 0;
            for (n2 = Math.max(e2 - this.t, 0); n2 < t3.t; ++n2)
              r3[this.t + n2 - e2] = this.am(e2 - n2, t3[n2], r3, 0, 0, this.t + n2 - e2);
            r3.clamp(), r3.drShiftTo(1, r3);
          }, F.prototype.modInt = function Jt(t3) {
            if (t3 <= 0)
              return 0;
            var e2 = this.DV % t3, r3 = this.s < 0 ? t3 - 1 : 0;
            if (this.t > 0)
              if (0 == e2)
                r3 = this[0] % t3;
              else
                for (var n2 = this.t - 1; n2 >= 0; --n2)
                  r3 = (e2 * r3 + this[n2]) % t3;
            return r3;
          }, F.prototype.millerRabin = function Wt(t3) {
            var e2 = this.subtract(F.ONE), r3 = e2.getLowestSetBit();
            if (r3 <= 0)
              return false;
            var n2 = e2.shiftRight(r3);
            (t3 = t3 + 1 >> 1) > Rt.length && (t3 = Rt.length);
            for (var i2 = E(), o2 = 0; o2 < t3; ++o2) {
              i2.fromInt(Rt[Math.floor(Math.random() * Rt.length)]);
              var s2 = i2.modPow(n2, this);
              if (0 != s2.compareTo(F.ONE) && 0 != s2.compareTo(e2)) {
                for (var a2 = 1; a2++ < r3 && 0 != s2.compareTo(e2); )
                  if (0 == (s2 = s2.modPowInt(2, this)).compareTo(F.ONE))
                    return false;
                if (0 != s2.compareTo(e2))
                  return false;
              }
            }
            return true;
          }, F.prototype.clone = /*! (c) Tom Wu | http://www-cs-students.stanford.edu/~tjw/jsbn/
          */
          function zt() {
            var t3 = E();
            return this.copyTo(t3), t3;
          }, F.prototype.intValue = function Yt() {
            if (this.s < 0) {
              if (1 == this.t)
                return this[0] - this.DV;
              if (0 == this.t)
                return -1;
            } else {
              if (1 == this.t)
                return this[0];
              if (0 == this.t)
                return 0;
            }
            return (this[1] & (1 << 32 - this.DB) - 1) << this.DB | this[0];
          }, F.prototype.byteValue = function Gt() {
            return 0 == this.t ? this.s : this[0] << 24 >> 24;
          }, F.prototype.shortValue = function Xt() {
            return 0 == this.t ? this.s : this[0] << 16 >> 16;
          }, F.prototype.signum = function $t() {
            return this.s < 0 ? -1 : this.t <= 0 || 1 == this.t && this[0] <= 0 ? 0 : 1;
          }, F.prototype.toByteArray = function Qt() {
            var t3 = this.t, e2 = new Array();
            e2[0] = this.s;
            var r3, n2 = this.DB - t3 * this.DB % 8, i2 = 0;
            if (t3-- > 0)
              for (n2 < this.DB && (r3 = this[t3] >> n2) != (this.s & this.DM) >> n2 && (e2[i2++] = r3 | this.s << this.DB - n2); t3 >= 0; )
                n2 < 8 ? (r3 = (this[t3] & (1 << n2) - 1) << 8 - n2, r3 |= this[--t3] >> (n2 += this.DB - 8)) : (r3 = this[t3] >> (n2 -= 8) & 255, n2 <= 0 && (n2 += this.DB, --t3)), 0 != (128 & r3) && (r3 |= -256), 0 == i2 && (128 & this.s) != (128 & r3) && ++i2, (i2 > 0 || r3 != this.s) && (e2[i2++] = r3);
            return e2;
          }, F.prototype.equals = function Zt(t3) {
            return 0 == this.compareTo(t3);
          }, F.prototype.min = function te(t3) {
            return this.compareTo(t3) < 0 ? this : t3;
          }, F.prototype.max = function ee(t3) {
            return this.compareTo(t3) > 0 ? this : t3;
          }, F.prototype.and = function re(t3) {
            var e2 = E();
            return this.bitwiseTo(t3, B, e2), e2;
          }, F.prototype.or = function ne(t3) {
            var e2 = E();
            return this.bitwiseTo(t3, O, e2), e2;
          }, F.prototype.xor = function ie(t3) {
            var e2 = E();
            return this.bitwiseTo(t3, j, e2), e2;
          }, F.prototype.andNot = function oe(t3) {
            var e2 = E();
            return this.bitwiseTo(t3, M, e2), e2;
          }, F.prototype.not = function se() {
            for (var t3 = E(), e2 = 0; e2 < this.t; ++e2)
              t3[e2] = this.DM & ~this[e2];
            return t3.t = this.t, t3.s = ~this.s, t3;
          }, F.prototype.shiftLeft = function ae(t3) {
            var e2 = E();
            return t3 < 0 ? this.rShiftTo(-t3, e2) : this.lShiftTo(t3, e2), e2;
          }, F.prototype.shiftRight = function ue(t3) {
            var e2 = E();
            return t3 < 0 ? this.lShiftTo(-t3, e2) : this.rShiftTo(t3, e2), e2;
          }, F.prototype.getLowestSetBit = function ce() {
            for (var t3 = 0; t3 < this.t; ++t3)
              if (0 != this[t3])
                return t3 * this.DB + H(this[t3]);
            return this.s < 0 ? this.t * this.DB : -1;
          }, F.prototype.bitCount = function he() {
            for (var t3 = 0, e2 = this.s & this.DM, r3 = 0; r3 < this.t; ++r3)
              t3 += V(this[r3] ^ e2);
            return t3;
          }, F.prototype.testBit = function le(t3) {
            var e2 = Math.floor(t3 / this.DB);
            return e2 >= this.t ? 0 != this.s : 0 != (this[e2] & 1 << t3 % this.DB);
          }, F.prototype.setBit = function fe(t3) {
            return this.changeBit(t3, O);
          }, F.prototype.clearBit = function ge(t3) {
            return this.changeBit(t3, M);
          }, F.prototype.flipBit = function de(t3) {
            return this.changeBit(t3, j);
          }, F.prototype.add = function pe(t3) {
            var e2 = E();
            return this.addTo(t3, e2), e2;
          }, F.prototype.subtract = function ve(t3) {
            var e2 = E();
            return this.subTo(t3, e2), e2;
          }, F.prototype.multiply = function ye(t3) {
            var e2 = E();
            return this.multiplyTo(t3, e2), e2;
          }, F.prototype.divide = function me(t3) {
            var e2 = E();
            return this.divRemTo(t3, e2, null), e2;
          }, F.prototype.remainder = function _e(t3) {
            var e2 = E();
            return this.divRemTo(t3, null, e2), e2;
          }, F.prototype.divideAndRemainder = function Se(t3) {
            var e2 = E(), r3 = E();
            return this.divRemTo(t3, e2, r3), new Array(e2, r3);
          }, F.prototype.modPow = function be(t3, e2) {
            var r3, n2, i2 = t3.bitLength(), o2 = D(1);
            if (i2 <= 0)
              return o2;
            r3 = i2 < 18 ? 1 : i2 < 48 ? 3 : i2 < 144 ? 4 : i2 < 768 ? 5 : 6, n2 = i2 < 8 ? new N(e2) : e2.isEven() ? new J(e2) : new U(e2);
            var s2 = new Array(), a2 = 3, u2 = r3 - 1, c2 = (1 << r3) - 1;
            if (s2[1] = n2.convert(this), r3 > 1) {
              var h2 = E();
              for (n2.sqrTo(s2[1], h2); a2 <= c2; )
                s2[a2] = E(), n2.mulTo(h2, s2[a2 - 2], s2[a2]), a2 += 2;
            }
            var l2, f2, g2 = t3.t - 1, d2 = true, p2 = E();
            for (i2 = L(t3[g2]) - 1; g2 >= 0; ) {
              for (i2 >= u2 ? l2 = t3[g2] >> i2 - u2 & c2 : (l2 = (t3[g2] & (1 << i2 + 1) - 1) << u2 - i2, g2 > 0 && (l2 |= t3[g2 - 1] >> this.DB + i2 - u2)), a2 = r3; 0 == (1 & l2); )
                l2 >>= 1, --a2;
              if ((i2 -= a2) < 0 && (i2 += this.DB, --g2), d2)
                s2[l2].copyTo(o2), d2 = false;
              else {
                for (; a2 > 1; )
                  n2.sqrTo(o2, p2), n2.sqrTo(p2, o2), a2 -= 2;
                a2 > 0 ? n2.sqrTo(o2, p2) : (f2 = o2, o2 = p2, p2 = f2), n2.mulTo(p2, s2[l2], o2);
              }
              for (; g2 >= 0 && 0 == (t3[g2] & 1 << i2); )
                n2.sqrTo(o2, p2), f2 = o2, o2 = p2, p2 = f2, --i2 < 0 && (i2 = this.DB - 1, --g2);
            }
            return n2.revert(o2);
          }, F.prototype.modInverse = function we(t3) {
            var e2 = t3.isEven();
            if (this.isEven() && e2 || 0 == t3.signum())
              return F.ZERO;
            for (var r3 = t3.clone(), n2 = this.clone(), i2 = D(1), o2 = D(0), s2 = D(0), a2 = D(1); 0 != r3.signum(); ) {
              for (; r3.isEven(); )
                r3.rShiftTo(1, r3), e2 ? (i2.isEven() && o2.isEven() || (i2.addTo(this, i2), o2.subTo(t3, o2)), i2.rShiftTo(1, i2)) : o2.isEven() || o2.subTo(t3, o2), o2.rShiftTo(1, o2);
              for (; n2.isEven(); )
                n2.rShiftTo(1, n2), e2 ? (s2.isEven() && a2.isEven() || (s2.addTo(this, s2), a2.subTo(t3, a2)), s2.rShiftTo(1, s2)) : a2.isEven() || a2.subTo(t3, a2), a2.rShiftTo(1, a2);
              r3.compareTo(n2) >= 0 ? (r3.subTo(n2, r3), e2 && i2.subTo(s2, i2), o2.subTo(a2, o2)) : (n2.subTo(r3, n2), e2 && s2.subTo(i2, s2), a2.subTo(o2, a2));
            }
            return 0 != n2.compareTo(F.ONE) ? F.ZERO : a2.compareTo(t3) >= 0 ? a2.subtract(t3) : a2.signum() < 0 ? (a2.addTo(t3, a2), a2.signum() < 0 ? a2.add(t3) : a2) : a2;
          }, F.prototype.pow = function Fe(t3) {
            return this.exp(t3, new K());
          }, F.prototype.gcd = function Ee(t3) {
            var e2 = this.s < 0 ? this.negate() : this.clone(), r3 = t3.s < 0 ? t3.negate() : t3.clone();
            if (e2.compareTo(r3) < 0) {
              var n2 = e2;
              e2 = r3, r3 = n2;
            }
            var i2 = e2.getLowestSetBit(), o2 = r3.getLowestSetBit();
            if (o2 < 0)
              return e2;
            for (i2 < o2 && (o2 = i2), o2 > 0 && (e2.rShiftTo(o2, e2), r3.rShiftTo(o2, r3)); e2.signum() > 0; )
              (i2 = e2.getLowestSetBit()) > 0 && e2.rShiftTo(i2, e2), (i2 = r3.getLowestSetBit()) > 0 && r3.rShiftTo(i2, r3), e2.compareTo(r3) >= 0 ? (e2.subTo(r3, e2), e2.rShiftTo(1, e2)) : (r3.subTo(e2, r3), r3.rShiftTo(1, r3));
            return o2 > 0 && r3.lShiftTo(o2, r3), r3;
          }, F.prototype.isProbablePrime = function xe(t3) {
            var e2, r3 = this.abs();
            if (1 == r3.t && r3[0] <= Rt[Rt.length - 1]) {
              for (e2 = 0; e2 < Rt.length; ++e2)
                if (r3[0] == Rt[e2])
                  return true;
              return false;
            }
            if (r3.isEven())
              return false;
            for (e2 = 1; e2 < Rt.length; ) {
              for (var n2 = Rt[e2], i2 = e2 + 1; i2 < Rt.length && n2 < It; )
                n2 *= Rt[i2++];
              for (n2 = r3.modInt(n2); e2 < i2; )
                if (n2 % Rt[e2++] == 0)
                  return false;
            }
            return r3.millerRabin(t3);
          }, F.prototype.square = function Ae() {
            var t3 = E();
            return this.squareTo(t3), t3;
          }, Dt.prototype.init = function ke(t3) {
            var e2, r3, n2;
            for (e2 = 0; e2 < 256; ++e2)
              this.S[e2] = e2;
            for (r3 = 0, e2 = 0; e2 < 256; ++e2)
              r3 = r3 + this.S[e2] + t3[e2 % t3.length] & 255, n2 = this.S[e2], this.S[e2] = this.S[r3], this.S[r3] = n2;
            this.i = 0, this.j = 0;
          }, Dt.prototype.next = function Pe() {
            var t3;
            return this.i = this.i + 1 & 255, this.j = this.j + this.S[this.i] & 255, t3 = this.S[this.i], this.S[this.i] = this.S[this.j], this.S[this.j] = t3, this.S[t3 + this.S[this.i] & 255];
          };
          var Ce, Te, Re;
          function Ie() {
            !function t3(e2) {
              Te[Re++] ^= 255 & e2, Te[Re++] ^= e2 >> 8 & 255, Te[Re++] ^= e2 >> 16 & 255, Te[Re++] ^= e2 >> 24 & 255, Re >= 256 && (Re -= 256);
            }((/* @__PURE__ */ new Date()).getTime());
          }
          if (null == Te) {
            var De;
            if (Te = new Array(), Re = 0, void 0 !== i && (void 0 !== i.crypto || void 0 !== i.msCrypto)) {
              var Le = i.crypto || i.msCrypto;
              if (Le.getRandomValues) {
                var Ne = new Uint8Array(32);
                for (Le.getRandomValues(Ne), De = 0; De < 32; ++De)
                  Te[Re++] = Ne[De];
              } else if ("Netscape" == n.appName && n.appVersion < "5") {
                var Ue = i.crypto.random(32);
                for (De = 0; De < Ue.length; ++De)
                  Te[Re++] = 255 & Ue.charCodeAt(De);
              }
            }
            for (; Re < 256; )
              De = Math.floor(65536 * Math.random()), Te[Re++] = De >>> 8, Te[Re++] = 255 & De;
            Re = 0, Ie();
          }
          function Be() {
            if (null == Ce) {
              for (Ie(), (Ce = function t3() {
                return new Dt();
              }()).init(Te), Re = 0; Re < Te.length; ++Re)
                Te[Re] = 0;
              Re = 0;
            }
            return Ce.next();
          }
          function Oe() {
          }
          function je(t3, e2) {
            return new F(t3, e2);
          }
          function Me(t3, e2, r3) {
            for (var n2 = "", i2 = 0; n2.length < e2; )
              n2 += r3(String.fromCharCode.apply(String, t3.concat([(4278190080 & i2) >> 24, (16711680 & i2) >> 16, (65280 & i2) >> 8, 255 & i2]))), i2 += 1;
            return n2;
          }
          function He() {
            this.n = null, this.e = 0, this.d = null, this.p = null, this.q = null, this.dmp1 = null, this.dmq1 = null, this.coeff = null;
          }
          function Ve(t3, e2) {
            this.x = e2, this.q = t3;
          }
          function Ke(t3, e2, r3, n2) {
            this.curve = t3, this.x = e2, this.y = r3, this.z = null == n2 ? F.ONE : n2, this.zinv = null;
          }
          function qe(t3, e2, r3) {
            this.q = t3, this.a = this.fromBigInteger(e2), this.b = this.fromBigInteger(r3), this.infinity = new Ke(this, null, null);
          }
          Oe.prototype.nextBytes = function Je(t3) {
            var e2;
            for (e2 = 0; e2 < t3.length; ++e2)
              t3[e2] = Be();
          }, He.prototype.doPublic = function We(t3) {
            return t3.modPowInt(this.e, this.n);
          }, He.prototype.setPublic = function ze(t3, e2) {
            if (this.isPublic = true, this.isPrivate = false, "string" != typeof t3)
              this.n = t3, this.e = e2;
            else {
              if (!(null != t3 && null != e2 && t3.length > 0 && e2.length > 0))
                throw "Invalid RSA public key";
              this.n = je(t3, 16), this.e = parseInt(e2, 16);
            }
          }, He.prototype.encrypt = function Ye(t3) {
            var e2 = function r3(t4, e3) {
              if (e3 < t4.length + 11)
                throw "Message too long for RSA";
              for (var r4 = new Array(), n3 = t4.length - 1; n3 >= 0 && e3 > 0; ) {
                var i3 = t4.charCodeAt(n3--);
                i3 < 128 ? r4[--e3] = i3 : i3 > 127 && i3 < 2048 ? (r4[--e3] = 63 & i3 | 128, r4[--e3] = i3 >> 6 | 192) : (r4[--e3] = 63 & i3 | 128, r4[--e3] = i3 >> 6 & 63 | 128, r4[--e3] = i3 >> 12 | 224);
              }
              r4[--e3] = 0;
              for (var o2 = new Oe(), s2 = new Array(); e3 > 2; ) {
                for (s2[0] = 0; 0 == s2[0]; )
                  o2.nextBytes(s2);
                r4[--e3] = s2[0];
              }
              return r4[--e3] = 2, r4[--e3] = 0, new F(r4);
            }(t3, this.n.bitLength() + 7 >> 3);
            if (null == e2)
              return null;
            var n2 = this.doPublic(e2);
            if (null == n2)
              return null;
            var i2 = n2.toString(16);
            return 0 == (1 & i2.length) ? i2 : "0" + i2;
          }, He.prototype.encryptOAEP = function Ge(t3, e2, r3) {
            var n2 = function i2(t4, e3, r4, n3) {
              var i3 = br.crypto.MessageDigest, o3 = br.crypto.Util, s3 = null;
              if (r4 || (r4 = "sha1"), "string" == typeof r4 && (s3 = i3.getCanonicalAlgName(r4), n3 = i3.getHashLength(s3), r4 = function t5(e4) {
                return Nr(o3.hashHex(Ur(e4), s3));
              }), t4.length + 2 * n3 + 2 > e3)
                throw "Message too long for RSA";
              var a2, u2 = "";
              for (a2 = 0; a2 < e3 - t4.length - 2 * n3 - 2; a2 += 1)
                u2 += "\0";
              var c2 = r4("") + u2 + "" + t4, h2 = new Array(n3);
              new Oe().nextBytes(h2);
              var l2 = Me(h2, c2.length, r4), f2 = [];
              for (a2 = 0; a2 < c2.length; a2 += 1)
                f2[a2] = c2.charCodeAt(a2) ^ l2.charCodeAt(a2);
              var g2 = Me(f2, h2.length, r4), d2 = [0];
              for (a2 = 0; a2 < h2.length; a2 += 1)
                d2[a2 + 1] = h2[a2] ^ g2.charCodeAt(a2);
              return new F(d2.concat(f2));
            }(t3, this.n.bitLength() + 7 >> 3, e2, r3);
            if (null == n2)
              return null;
            var o2 = this.doPublic(n2);
            if (null == o2)
              return null;
            var s2 = o2.toString(16);
            return 0 == (1 & s2.length) ? s2 : "0" + s2;
          }, He.prototype.type = "RSA", Ve.prototype.equals = function Xe(t3) {
            return t3 == this || this.q.equals(t3.q) && this.x.equals(t3.x);
          }, Ve.prototype.toBigInteger = function $e() {
            return this.x;
          }, Ve.prototype.negate = function Qe() {
            return new Ve(this.q, this.x.negate().mod(this.q));
          }, Ve.prototype.add = function Ze(t3) {
            return new Ve(this.q, this.x.add(t3.toBigInteger()).mod(this.q));
          }, Ve.prototype.subtract = function tr(t3) {
            return new Ve(this.q, this.x.subtract(t3.toBigInteger()).mod(this.q));
          }, Ve.prototype.multiply = function er(t3) {
            return new Ve(this.q, this.x.multiply(t3.toBigInteger()).mod(this.q));
          }, Ve.prototype.square = function rr() {
            return new Ve(this.q, this.x.square().mod(this.q));
          }, Ve.prototype.divide = function nr(t3) {
            return new Ve(this.q, this.x.multiply(t3.toBigInteger().modInverse(this.q)).mod(this.q));
          }, Ke.prototype.getX = function ir() {
            return null == this.zinv && (this.zinv = this.z.modInverse(this.curve.q)), this.curve.fromBigInteger(this.x.toBigInteger().multiply(this.zinv).mod(this.curve.q));
          }, Ke.prototype.getY = function or() {
            return null == this.zinv && (this.zinv = this.z.modInverse(this.curve.q)), this.curve.fromBigInteger(this.y.toBigInteger().multiply(this.zinv).mod(this.curve.q));
          }, Ke.prototype.equals = function sr(t3) {
            return t3 == this || (this.isInfinity() ? t3.isInfinity() : t3.isInfinity() ? this.isInfinity() : !!t3.y.toBigInteger().multiply(this.z).subtract(this.y.toBigInteger().multiply(t3.z)).mod(this.curve.q).equals(F.ZERO) && t3.x.toBigInteger().multiply(this.z).subtract(this.x.toBigInteger().multiply(t3.z)).mod(this.curve.q).equals(F.ZERO));
          }, Ke.prototype.isInfinity = function ar() {
            return null == this.x && null == this.y || this.z.equals(F.ZERO) && !this.y.toBigInteger().equals(F.ZERO);
          }, Ke.prototype.negate = function ur() {
            return new Ke(this.curve, this.x, this.y.negate(), this.z);
          }, Ke.prototype.add = function cr(t3) {
            if (this.isInfinity())
              return t3;
            if (t3.isInfinity())
              return this;
            var e2 = t3.y.toBigInteger().multiply(this.z).subtract(this.y.toBigInteger().multiply(t3.z)).mod(this.curve.q), r3 = t3.x.toBigInteger().multiply(this.z).subtract(this.x.toBigInteger().multiply(t3.z)).mod(this.curve.q);
            if (F.ZERO.equals(r3))
              return F.ZERO.equals(e2) ? this.twice() : this.curve.getInfinity();
            var n2 = new F("3"), i2 = this.x.toBigInteger(), o2 = this.y.toBigInteger(), s2 = (t3.x.toBigInteger(), t3.y.toBigInteger(), r3.square()), a2 = s2.multiply(r3), u2 = i2.multiply(s2), c2 = e2.square().multiply(this.z), h2 = c2.subtract(u2.shiftLeft(1)).multiply(t3.z).subtract(a2).multiply(r3).mod(this.curve.q), l2 = u2.multiply(n2).multiply(e2).subtract(o2.multiply(a2)).subtract(c2.multiply(e2)).multiply(t3.z).add(e2.multiply(a2)).mod(this.curve.q), f2 = a2.multiply(this.z).multiply(t3.z).mod(this.curve.q);
            return new Ke(this.curve, this.curve.fromBigInteger(h2), this.curve.fromBigInteger(l2), f2);
          }, Ke.prototype.twice = function hr() {
            if (this.isInfinity())
              return this;
            if (0 == this.y.toBigInteger().signum())
              return this.curve.getInfinity();
            var t3 = new F("3"), e2 = this.x.toBigInteger(), r3 = this.y.toBigInteger(), n2 = r3.multiply(this.z), i2 = n2.multiply(r3).mod(this.curve.q), o2 = this.curve.a.toBigInteger(), s2 = e2.square().multiply(t3);
            F.ZERO.equals(o2) || (s2 = s2.add(this.z.square().multiply(o2)));
            var a2 = (s2 = s2.mod(this.curve.q)).square().subtract(e2.shiftLeft(3).multiply(i2)).shiftLeft(1).multiply(n2).mod(this.curve.q), u2 = s2.multiply(t3).multiply(e2).subtract(i2.shiftLeft(1)).shiftLeft(2).multiply(i2).subtract(s2.square().multiply(s2)).mod(this.curve.q), c2 = n2.square().multiply(n2).shiftLeft(3).mod(this.curve.q);
            return new Ke(this.curve, this.curve.fromBigInteger(a2), this.curve.fromBigInteger(u2), c2);
          }, Ke.prototype.multiply = function lr(t3) {
            if (this.isInfinity())
              return this;
            if (0 == t3.signum())
              return this.curve.getInfinity();
            var e2, r3 = t3, n2 = r3.multiply(new F("3")), i2 = this.negate(), o2 = this, s2 = this.curve.q.subtract(t3), a2 = s2.multiply(new F("3")), u2 = new Ke(this.curve, this.x, this.y), c2 = u2.negate();
            for (e2 = n2.bitLength() - 2; e2 > 0; --e2) {
              o2 = o2.twice();
              var h2 = n2.testBit(e2);
              h2 != r3.testBit(e2) && (o2 = o2.add(h2 ? this : i2));
            }
            for (e2 = a2.bitLength() - 2; e2 > 0; --e2) {
              u2 = u2.twice();
              var l2 = a2.testBit(e2);
              l2 != s2.testBit(e2) && (u2 = u2.add(l2 ? u2 : c2));
            }
            return o2;
          }, Ke.prototype.multiplyTwo = function fr(t3, e2, r3) {
            var n2;
            n2 = t3.bitLength() > r3.bitLength() ? t3.bitLength() - 1 : r3.bitLength() - 1;
            for (var i2 = this.curve.getInfinity(), o2 = this.add(e2); n2 >= 0; )
              i2 = i2.twice(), t3.testBit(n2) ? i2 = r3.testBit(n2) ? i2.add(o2) : i2.add(this) : r3.testBit(n2) && (i2 = i2.add(e2)), --n2;
            return i2;
          }, qe.prototype.getQ = function gr() {
            return this.q;
          }, qe.prototype.getA = function dr() {
            return this.a;
          }, qe.prototype.getB = function pr() {
            return this.b;
          }, qe.prototype.equals = function vr(t3) {
            return t3 == this || this.q.equals(t3.q) && this.a.equals(t3.a) && this.b.equals(t3.b);
          }, qe.prototype.getInfinity = function yr() {
            return this.infinity;
          }, qe.prototype.fromBigInteger = function mr(t3) {
            return new Ve(this.q, t3);
          }, qe.prototype.decodePointHex = function _r(t3) {
            switch (parseInt(t3.substr(0, 2), 16)) {
              case 0:
                return this.infinity;
              case 2:
              case 3:
                return null;
              case 4:
              case 6:
              case 7:
                var e2 = (t3.length - 2) / 2, r3 = t3.substr(2, e2), n2 = t3.substr(e2 + 2, e2);
                return new Ke(this, this.fromBigInteger(new F(r3, 16)), this.fromBigInteger(new F(n2, 16)));
              default:
                return null;
            }
          }, /*! (c) Stefan Thomas | https://github.com/bitcoinjs/bitcoinjs-lib
          */
          Ve.prototype.getByteLength = function() {
            return Math.floor((this.toBigInteger().bitLength() + 7) / 8);
          }, Ke.prototype.getEncoded = function(t3) {
            var e2 = function t4(e3, r4) {
              var n3 = e3.toByteArrayUnsigned();
              if (r4 < n3.length)
                n3 = n3.slice(n3.length - r4);
              else
                for (; r4 > n3.length; )
                  n3.unshift(0);
              return n3;
            }, r3 = this.getX().toBigInteger(), n2 = this.getY().toBigInteger(), i2 = e2(r3, 32);
            return t3 ? n2.isEven() ? i2.unshift(2) : i2.unshift(3) : (i2.unshift(4), i2 = i2.concat(e2(n2, 32))), i2;
          }, Ke.decodeFrom = function(t3, e2) {
            e2[0];
            var r3 = e2.length - 1, n2 = e2.slice(1, 1 + r3 / 2), i2 = e2.slice(1 + r3 / 2, 1 + r3);
            n2.unshift(0), i2.unshift(0);
            var o2 = new F(n2), s2 = new F(i2);
            return new Ke(t3, t3.fromBigInteger(o2), t3.fromBigInteger(s2));
          }, Ke.decodeFromHex = function(t3, e2) {
            e2.substr(0, 2);
            var r3 = e2.length - 2, n2 = e2.substr(2, r3 / 2), i2 = e2.substr(2 + r3 / 2, r3 / 2), o2 = new F(n2, 16), s2 = new F(i2, 16);
            return new Ke(t3, t3.fromBigInteger(o2), t3.fromBigInteger(s2));
          }, Ke.prototype.add2D = function(t3) {
            if (this.isInfinity())
              return t3;
            if (t3.isInfinity())
              return this;
            if (this.x.equals(t3.x))
              return this.y.equals(t3.y) ? this.twice() : this.curve.getInfinity();
            var e2 = t3.x.subtract(this.x), r3 = t3.y.subtract(this.y).divide(e2), n2 = r3.square().subtract(this.x).subtract(t3.x), i2 = r3.multiply(this.x.subtract(n2)).subtract(this.y);
            return new Ke(this.curve, n2, i2);
          }, Ke.prototype.twice2D = function() {
            if (this.isInfinity())
              return this;
            if (0 == this.y.toBigInteger().signum())
              return this.curve.getInfinity();
            var t3 = this.curve.fromBigInteger(F.valueOf(2)), e2 = this.curve.fromBigInteger(F.valueOf(3)), r3 = this.x.square().multiply(e2).add(this.curve.a).divide(this.y.multiply(t3)), n2 = r3.square().subtract(this.x.multiply(t3)), i2 = r3.multiply(this.x.subtract(n2)).subtract(this.y);
            return new Ke(this.curve, n2, i2);
          }, Ke.prototype.multiply2D = function(t3) {
            if (this.isInfinity())
              return this;
            if (0 == t3.signum())
              return this.curve.getInfinity();
            var e2, r3 = t3, n2 = r3.multiply(new F("3")), i2 = this.negate(), o2 = this;
            for (e2 = n2.bitLength() - 2; e2 > 0; --e2) {
              o2 = o2.twice();
              var s2 = n2.testBit(e2);
              s2 != r3.testBit(e2) && (o2 = o2.add2D(s2 ? this : i2));
            }
            return o2;
          }, Ke.prototype.isOnCurve = function() {
            var t3 = this.getX().toBigInteger(), e2 = this.getY().toBigInteger(), r3 = this.curve.getA().toBigInteger(), n2 = this.curve.getB().toBigInteger(), i2 = this.curve.getQ(), o2 = e2.multiply(e2).mod(i2), s2 = t3.multiply(t3).multiply(t3).add(r3.multiply(t3)).add(n2).mod(i2);
            return o2.equals(s2);
          }, Ke.prototype.toString = function() {
            return "(" + this.getX().toBigInteger().toString() + "," + this.getY().toBigInteger().toString() + ")";
          }, Ke.prototype.validate = function() {
            var t3 = this.curve.getQ();
            if (this.isInfinity())
              throw new Error("Point is at infinity.");
            var e2 = this.getX().toBigInteger(), r3 = this.getY().toBigInteger();
            if (e2.compareTo(F.ONE) < 0 || e2.compareTo(t3.subtract(F.ONE)) > 0)
              throw new Error("x coordinate out of bounds");
            if (r3.compareTo(F.ONE) < 0 || r3.compareTo(t3.subtract(F.ONE)) > 0)
              throw new Error("y coordinate out of bounds");
            if (!this.isOnCurve())
              throw new Error("Point is not on the curve.");
            if (this.multiply(t3).isInfinity())
              throw new Error("Point is not a scalar multiple of G.");
            return true;
          };
          var Sr = function() {
            var t3 = new RegExp('(?:false|true|null|[\\{\\}\\[\\]]|(?:-?\\b(?:0|[1-9][0-9]*)(?:\\.[0-9]+)?(?:[eE][+-]?[0-9]+)?\\b)|(?:"(?:[^\\0-\\x08\\x0a-\\x1f"\\\\]|\\\\(?:["/\\\\bfnrt]|u[0-9A-Fa-f]{4}))*"))', "g"), e2 = new RegExp("\\\\(?:([^u])|u(.{4}))", "g"), n2 = { '"': '"', "/": "/", "\\": "\\", b: "\b", f: "\f", n: "\n", r: "\r", t: "	" };
            function i2(t4, e3, r3) {
              return e3 ? n2[e3] : String.fromCharCode(parseInt(r3, 16));
            }
            var o2 = new String(""), s2 = Object.hasOwnProperty;
            return function(n3, a2) {
              var u2, c2, h2 = n3.match(t3), l2 = h2[0], f2 = false;
              "{" === l2 ? u2 = {} : "[" === l2 ? u2 = [] : (u2 = [], f2 = true);
              for (var g2 = [u2], d2 = 1 - f2, p2 = h2.length; d2 < p2; ++d2) {
                var v2;
                switch ((l2 = h2[d2]).charCodeAt(0)) {
                  default:
                    (v2 = g2[0])[c2 || v2.length] = +l2, c2 = void 0;
                    break;
                  case 34:
                    if (-1 !== (l2 = l2.substring(1, l2.length - 1)).indexOf("\\") && (l2 = l2.replace(e2, i2)), v2 = g2[0], !c2) {
                      if (!(v2 instanceof Array)) {
                        c2 = l2 || o2;
                        break;
                      }
                      c2 = v2.length;
                    }
                    v2[c2] = l2, c2 = void 0;
                    break;
                  case 91:
                    v2 = g2[0], g2.unshift(v2[c2 || v2.length] = []), c2 = void 0;
                    break;
                  case 93:
                    g2.shift();
                    break;
                  case 102:
                    (v2 = g2[0])[c2 || v2.length] = false, c2 = void 0;
                    break;
                  case 110:
                    (v2 = g2[0])[c2 || v2.length] = null, c2 = void 0;
                    break;
                  case 116:
                    (v2 = g2[0])[c2 || v2.length] = true, c2 = void 0;
                    break;
                  case 123:
                    v2 = g2[0], g2.unshift(v2[c2 || v2.length] = {}), c2 = void 0;
                    break;
                  case 125:
                    g2.shift();
                }
              }
              if (f2) {
                if (1 !== g2.length)
                  throw new Error();
                u2 = u2[0];
              } else if (g2.length)
                throw new Error();
              if (a2) {
                u2 = function t4(e3, n4) {
                  var i3 = e3[n4];
                  if (i3 && "object" === (void 0 === i3 ? "undefined" : r2(i3))) {
                    var o3 = null;
                    for (var u3 in i3)
                      if (s2.call(i3, u3) && i3 !== e3) {
                        var c3 = t4(i3, u3);
                        void 0 !== c3 ? i3[u3] = c3 : (o3 || (o3 = []), o3.push(u3));
                      }
                    if (o3)
                      for (var h3 = o3.length; --h3 >= 0; )
                        delete i3[o3[h3]];
                  }
                  return a2.call(e3, n4, i3);
                }({ "": u2 }, "");
              }
              return u2;
            };
          }();
          void 0 !== br && br || (e.KJUR = br = {}), void 0 !== br.asn1 && br.asn1 || (br.asn1 = {}), br.asn1.ASN1Util = new function() {
            this.integerToByteHex = function(t3) {
              var e2 = t3.toString(16);
              return e2.length % 2 == 1 && (e2 = "0" + e2), e2;
            }, this.bigIntToMinTwosComplementsHex = function(t3) {
              var e2 = t3.toString(16);
              if ("-" != e2.substr(0, 1))
                e2.length % 2 == 1 ? e2 = "0" + e2 : e2.match(/^[0-7]/) || (e2 = "00" + e2);
              else {
                var r3 = e2.substr(1).length;
                r3 % 2 == 1 ? r3 += 1 : e2.match(/^[0-7]/) || (r3 += 2);
                for (var n2 = "", i2 = 0; i2 < r3; i2++)
                  n2 += "f";
                e2 = new F(n2, 16).xor(t3).add(F.ONE).toString(16).replace(/^-/, "");
              }
              return e2;
            }, this.getPEMStringFromHex = function(t3, e2) {
              return Mr(t3, e2);
            }, this.newObject = function(t3) {
              var e2 = br.asn1, r3 = e2.ASN1Object, n2 = e2.DERBoolean, i2 = e2.DERInteger, o2 = e2.DERBitString, s2 = e2.DEROctetString, a2 = e2.DERNull, u2 = e2.DERObjectIdentifier, c2 = e2.DEREnumerated, h2 = e2.DERUTF8String, l2 = e2.DERNumericString, f2 = e2.DERPrintableString, g2 = e2.DERTeletexString, d2 = e2.DERIA5String, p2 = e2.DERUTCTime, v2 = e2.DERGeneralizedTime, y2 = e2.DERVisibleString, m2 = e2.DERBMPString, _2 = e2.DERSequence, S2 = e2.DERSet, b2 = e2.DERTaggedObject, w2 = e2.ASN1Util.newObject;
              if (t3 instanceof e2.ASN1Object)
                return t3;
              var F2 = Object.keys(t3);
              if (1 != F2.length)
                throw new Error("key of param shall be only one.");
              var E2 = F2[0];
              if (-1 == ":asn1:bool:int:bitstr:octstr:null:oid:enum:utf8str:numstr:prnstr:telstr:ia5str:utctime:gentime:visstr:bmpstr:seq:set:tag:".indexOf(":" + E2 + ":"))
                throw new Error("undefined key: " + E2);
              if ("bool" == E2)
                return new n2(t3[E2]);
              if ("int" == E2)
                return new i2(t3[E2]);
              if ("bitstr" == E2)
                return new o2(t3[E2]);
              if ("octstr" == E2)
                return new s2(t3[E2]);
              if ("null" == E2)
                return new a2(t3[E2]);
              if ("oid" == E2)
                return new u2(t3[E2]);
              if ("enum" == E2)
                return new c2(t3[E2]);
              if ("utf8str" == E2)
                return new h2(t3[E2]);
              if ("numstr" == E2)
                return new l2(t3[E2]);
              if ("prnstr" == E2)
                return new f2(t3[E2]);
              if ("telstr" == E2)
                return new g2(t3[E2]);
              if ("ia5str" == E2)
                return new d2(t3[E2]);
              if ("utctime" == E2)
                return new p2(t3[E2]);
              if ("gentime" == E2)
                return new v2(t3[E2]);
              if ("visstr" == E2)
                return new y2(t3[E2]);
              if ("bmpstr" == E2)
                return new m2(t3[E2]);
              if ("asn1" == E2)
                return new r3(t3[E2]);
              if ("seq" == E2) {
                for (var x = t3[E2], A = [], k = 0; k < x.length; k++) {
                  var P2 = w2(x[k]);
                  A.push(P2);
                }
                return new _2({ array: A });
              }
              if ("set" == E2) {
                for (x = t3[E2], A = [], k = 0; k < x.length; k++) {
                  P2 = w2(x[k]);
                  A.push(P2);
                }
                return new S2({ array: A });
              }
              if ("tag" == E2) {
                var C2 = t3[E2];
                if ("[object Array]" === Object.prototype.toString.call(C2) && 3 == C2.length) {
                  var T2 = w2(C2[2]);
                  return new b2({ tag: C2[0], explicit: C2[1], obj: T2 });
                }
                return new b2(C2);
              }
            }, this.jsonToASN1HEX = function(t3) {
              return this.newObject(t3).getEncodedHex();
            };
          }(), br.asn1.ASN1Util.oidHexToInt = function(t3) {
            for (var e2 = "", r3 = parseInt(t3.substr(0, 2), 16), n2 = (e2 = Math.floor(r3 / 40) + "." + r3 % 40, ""), i2 = 2; i2 < t3.length; i2 += 2) {
              var o2 = ("00000000" + parseInt(t3.substr(i2, 2), 16).toString(2)).slice(-8);
              if (n2 += o2.substr(1, 7), "0" == o2.substr(0, 1))
                e2 = e2 + "." + new F(n2, 2).toString(10), n2 = "";
            }
            return e2;
          }, br.asn1.ASN1Util.oidIntToHex = function(t3) {
            var e2 = function t4(e3) {
              var r4 = e3.toString(16);
              return 1 == r4.length && (r4 = "0" + r4), r4;
            }, r3 = function t4(r4) {
              var n3 = "", i3 = new F(r4, 10).toString(2), o3 = 7 - i3.length % 7;
              7 == o3 && (o3 = 0);
              for (var s3 = "", a2 = 0; a2 < o3; a2++)
                s3 += "0";
              i3 = s3 + i3;
              for (a2 = 0; a2 < i3.length - 1; a2 += 7) {
                var u2 = i3.substr(a2, 7);
                a2 != i3.length - 7 && (u2 = "1" + u2), n3 += e2(parseInt(u2, 2));
              }
              return n3;
            };
            if (!t3.match(/^[0-9.]+$/))
              throw "malformed oid string: " + t3;
            var n2 = "", i2 = t3.split("."), o2 = 40 * parseInt(i2[0]) + parseInt(i2[1]);
            n2 += e2(o2), i2.splice(0, 2);
            for (var s2 = 0; s2 < i2.length; s2++)
              n2 += r3(i2[s2]);
            return n2;
          }, br.asn1.ASN1Object = function(t3) {
            this.params = null, this.getLengthHexFromValue = function() {
              if (void 0 === this.hV || null == this.hV)
                throw new Error("this.hV is null or undefined");
              if (this.hV.length % 2 == 1)
                throw new Error("value hex must be even length: n=" + "".length + ",v=" + this.hV);
              var t4 = this.hV.length / 2, e2 = t4.toString(16);
              if (e2.length % 2 == 1 && (e2 = "0" + e2), t4 < 128)
                return e2;
              var r3 = e2.length / 2;
              if (r3 > 15)
                throw "ASN.1 length too long to represent by 8x: n = " + t4.toString(16);
              return (128 + r3).toString(16) + e2;
            }, this.getEncodedHex = function() {
              return (null == this.hTLV || this.isModified) && (this.hV = this.getFreshValueHex(), this.hL = this.getLengthHexFromValue(), this.hTLV = this.hT + this.hL + this.hV, this.isModified = false), this.hTLV;
            }, this.getValueHex = function() {
              return this.getEncodedHex(), this.hV;
            }, this.getFreshValueHex = function() {
              return "";
            }, this.setByParam = function(t4) {
              this.params = t4;
            }, null != t3 && null != t3.tlv && (this.hTLV = t3.tlv, this.isModified = false);
          }, br.asn1.DERAbstractString = function(t3) {
            br.asn1.DERAbstractString.superclass.constructor.call(this);
            this.getString = function() {
              return this.s;
            }, this.setString = function(t4) {
              this.hTLV = null, this.isModified = true, this.s = t4, this.hV = Dr(this.s).toLowerCase();
            }, this.setStringHex = function(t4) {
              this.hTLV = null, this.isModified = true, this.s = null, this.hV = t4;
            }, this.getFreshValueHex = function() {
              return this.hV;
            }, void 0 !== t3 && ("string" == typeof t3 ? this.setString(t3) : void 0 !== t3.str ? this.setString(t3.str) : void 0 !== t3.hex && this.setStringHex(t3.hex));
          }, o.lang.extend(br.asn1.DERAbstractString, br.asn1.ASN1Object), br.asn1.DERAbstractTime = function(t3) {
            br.asn1.DERAbstractTime.superclass.constructor.call(this);
            this.localDateToUTC = function(t4) {
              var e2 = t4.getTime() + 6e4 * t4.getTimezoneOffset();
              return new Date(e2);
            }, this.formatDate = function(t4, e2, r3) {
              var n2 = this.zeroPadding, i2 = this.localDateToUTC(t4), o2 = String(i2.getFullYear());
              "utc" == e2 && (o2 = o2.substr(2, 2));
              var s2 = o2 + n2(String(i2.getMonth() + 1), 2) + n2(String(i2.getDate()), 2) + n2(String(i2.getHours()), 2) + n2(String(i2.getMinutes()), 2) + n2(String(i2.getSeconds()), 2);
              if (true === r3) {
                var a2 = i2.getMilliseconds();
                if (0 != a2) {
                  var u2 = n2(String(a2), 3);
                  s2 = s2 + "." + (u2 = u2.replace(/[0]+$/, ""));
                }
              }
              return s2 + "Z";
            }, this.zeroPadding = function(t4, e2) {
              return t4.length >= e2 ? t4 : new Array(e2 - t4.length + 1).join("0") + t4;
            }, this.getString = function() {
              return this.s;
            }, this.setString = function(t4) {
              this.hTLV = null, this.isModified = true, this.s = t4, this.hV = Pr(t4);
            }, this.setByDateValue = function(t4, e2, r3, n2, i2, o2) {
              var s2 = new Date(Date.UTC(t4, e2 - 1, r3, n2, i2, o2, 0));
              this.setByDate(s2);
            }, this.getFreshValueHex = function() {
              return this.hV;
            };
          }, o.lang.extend(br.asn1.DERAbstractTime, br.asn1.ASN1Object), br.asn1.DERAbstractStructured = function(t3) {
            br.asn1.DERAbstractString.superclass.constructor.call(this);
            this.setByASN1ObjectArray = function(t4) {
              this.hTLV = null, this.isModified = true, this.asn1Array = t4;
            }, this.appendASN1Object = function(t4) {
              this.hTLV = null, this.isModified = true, this.asn1Array.push(t4);
            }, this.asn1Array = new Array(), void 0 !== t3 && void 0 !== t3.array && (this.asn1Array = t3.array);
          }, o.lang.extend(br.asn1.DERAbstractStructured, br.asn1.ASN1Object), br.asn1.DERBoolean = function(t3) {
            br.asn1.DERBoolean.superclass.constructor.call(this), this.hT = "01", this.hTLV = 0 == t3 ? "010100" : "0101ff";
          }, o.lang.extend(br.asn1.DERBoolean, br.asn1.ASN1Object), br.asn1.DERInteger = function(t3) {
            br.asn1.DERInteger.superclass.constructor.call(this), this.hT = "02", this.setByBigInteger = function(t4) {
              this.hTLV = null, this.isModified = true, this.hV = br.asn1.ASN1Util.bigIntToMinTwosComplementsHex(t4);
            }, this.setByInteger = function(t4) {
              var e2 = new F(String(t4), 10);
              this.setByBigInteger(e2);
            }, this.setValueHex = function(t4) {
              this.hV = t4;
            }, this.getFreshValueHex = function() {
              return this.hV;
            }, void 0 !== t3 && (void 0 !== t3.bigint ? this.setByBigInteger(t3.bigint) : void 0 !== t3.int ? this.setByInteger(t3.int) : "number" == typeof t3 ? this.setByInteger(t3) : void 0 !== t3.hex && this.setValueHex(t3.hex));
          }, o.lang.extend(br.asn1.DERInteger, br.asn1.ASN1Object), br.asn1.DERBitString = function(t3) {
            if (void 0 !== t3 && void 0 !== t3.obj) {
              var e2 = br.asn1.ASN1Util.newObject(t3.obj);
              t3.hex = "00" + e2.getEncodedHex();
            }
            br.asn1.DERBitString.superclass.constructor.call(this), this.hT = "03", this.setHexValueIncludingUnusedBits = function(t4) {
              this.hTLV = null, this.isModified = true, this.hV = t4;
            }, this.setUnusedBitsAndHexValue = function(t4, e3) {
              if (t4 < 0 || 7 < t4)
                throw "unused bits shall be from 0 to 7: u = " + t4;
              var r3 = "0" + t4;
              this.hTLV = null, this.isModified = true, this.hV = r3 + e3;
            }, this.setByBinaryString = function(t4) {
              var e3 = 8 - (t4 = t4.replace(/0+$/, "")).length % 8;
              8 == e3 && (e3 = 0);
              for (var r3 = 0; r3 <= e3; r3++)
                t4 += "0";
              var n2 = "";
              for (r3 = 0; r3 < t4.length - 1; r3 += 8) {
                var i2 = t4.substr(r3, 8), o2 = parseInt(i2, 2).toString(16);
                1 == o2.length && (o2 = "0" + o2), n2 += o2;
              }
              this.hTLV = null, this.isModified = true, this.hV = "0" + e3 + n2;
            }, this.setByBooleanArray = function(t4) {
              for (var e3 = "", r3 = 0; r3 < t4.length; r3++)
                1 == t4[r3] ? e3 += "1" : e3 += "0";
              this.setByBinaryString(e3);
            }, this.newFalseArray = function(t4) {
              for (var e3 = new Array(t4), r3 = 0; r3 < t4; r3++)
                e3[r3] = false;
              return e3;
            }, this.getFreshValueHex = function() {
              return this.hV;
            }, void 0 !== t3 && ("string" == typeof t3 && t3.toLowerCase().match(/^[0-9a-f]+$/) ? this.setHexValueIncludingUnusedBits(t3) : void 0 !== t3.hex ? this.setHexValueIncludingUnusedBits(t3.hex) : void 0 !== t3.bin ? this.setByBinaryString(t3.bin) : void 0 !== t3.array && this.setByBooleanArray(t3.array));
          }, o.lang.extend(br.asn1.DERBitString, br.asn1.ASN1Object), br.asn1.DEROctetString = function(t3) {
            if (void 0 !== t3 && void 0 !== t3.obj) {
              var e2 = br.asn1.ASN1Util.newObject(t3.obj);
              t3.hex = e2.getEncodedHex();
            }
            br.asn1.DEROctetString.superclass.constructor.call(this, t3), this.hT = "04";
          }, o.lang.extend(br.asn1.DEROctetString, br.asn1.DERAbstractString), br.asn1.DERNull = function() {
            br.asn1.DERNull.superclass.constructor.call(this), this.hT = "05", this.hTLV = "0500";
          }, o.lang.extend(br.asn1.DERNull, br.asn1.ASN1Object), br.asn1.DERObjectIdentifier = function(t3) {
            br.asn1.DERObjectIdentifier.superclass.constructor.call(this), this.hT = "06", this.setValueHex = function(t4) {
              this.hTLV = null, this.isModified = true, this.s = null, this.hV = t4;
            }, this.setValueOidString = function(t4) {
              var e2 = function r3(t5) {
                var e3 = function t6(e4) {
                  var r5 = e4.toString(16);
                  return 1 == r5.length && (r5 = "0" + r5), r5;
                }, r4 = function t6(r5) {
                  var n3 = "", i3 = parseInt(r5, 10).toString(2), o3 = 7 - i3.length % 7;
                  7 == o3 && (o3 = 0);
                  for (var s3 = "", a2 = 0; a2 < o3; a2++)
                    s3 += "0";
                  i3 = s3 + i3;
                  for (a2 = 0; a2 < i3.length - 1; a2 += 7) {
                    var u2 = i3.substr(a2, 7);
                    a2 != i3.length - 7 && (u2 = "1" + u2), n3 += e3(parseInt(u2, 2));
                  }
                  return n3;
                };
                try {
                  if (!t5.match(/^[0-9.]+$/))
                    return null;
                  var n2 = "", i2 = t5.split("."), o2 = 40 * parseInt(i2[0], 10) + parseInt(i2[1], 10);
                  n2 += e3(o2), i2.splice(0, 2);
                  for (var s2 = 0; s2 < i2.length; s2++)
                    n2 += r4(i2[s2]);
                  return n2;
                } catch (t6) {
                  return null;
                }
              }(t4);
              if (null == e2)
                throw new Error("malformed oid string: " + t4);
              this.hTLV = null, this.isModified = true, this.s = null, this.hV = e2;
            }, this.setValueName = function(t4) {
              var e2 = br.asn1.x509.OID.name2oid(t4);
              if ("" === e2)
                throw new Error("DERObjectIdentifier oidName undefined: " + t4);
              this.setValueOidString(e2);
            }, this.setValueNameOrOid = function(t4) {
              t4.match(/^[0-2].[0-9.]+$/) ? this.setValueOidString(t4) : this.setValueName(t4);
            }, this.getFreshValueHex = function() {
              return this.hV;
            }, this.setByParam = function(t4) {
              "string" == typeof t4 ? this.setValueNameOrOid(t4) : void 0 !== t4.oid ? this.setValueNameOrOid(t4.oid) : void 0 !== t4.name ? this.setValueNameOrOid(t4.name) : void 0 !== t4.hex && this.setValueHex(t4.hex);
            }, void 0 !== t3 && this.setByParam(t3);
          }, o.lang.extend(br.asn1.DERObjectIdentifier, br.asn1.ASN1Object), br.asn1.DEREnumerated = function(t3) {
            br.asn1.DEREnumerated.superclass.constructor.call(this), this.hT = "0a", this.setByBigInteger = function(t4) {
              this.hTLV = null, this.isModified = true, this.hV = br.asn1.ASN1Util.bigIntToMinTwosComplementsHex(t4);
            }, this.setByInteger = function(t4) {
              var e2 = new F(String(t4), 10);
              this.setByBigInteger(e2);
            }, this.setValueHex = function(t4) {
              this.hV = t4;
            }, this.getFreshValueHex = function() {
              return this.hV;
            }, void 0 !== t3 && (void 0 !== t3.int ? this.setByInteger(t3.int) : "number" == typeof t3 ? this.setByInteger(t3) : void 0 !== t3.hex && this.setValueHex(t3.hex));
          }, o.lang.extend(br.asn1.DEREnumerated, br.asn1.ASN1Object), br.asn1.DERUTF8String = function(t3) {
            br.asn1.DERUTF8String.superclass.constructor.call(this, t3), this.hT = "0c";
          }, o.lang.extend(br.asn1.DERUTF8String, br.asn1.DERAbstractString), br.asn1.DERNumericString = function(t3) {
            br.asn1.DERNumericString.superclass.constructor.call(this, t3), this.hT = "12";
          }, o.lang.extend(br.asn1.DERNumericString, br.asn1.DERAbstractString), br.asn1.DERPrintableString = function(t3) {
            br.asn1.DERPrintableString.superclass.constructor.call(this, t3), this.hT = "13";
          }, o.lang.extend(br.asn1.DERPrintableString, br.asn1.DERAbstractString), br.asn1.DERTeletexString = function(t3) {
            br.asn1.DERTeletexString.superclass.constructor.call(this, t3), this.hT = "14";
          }, o.lang.extend(br.asn1.DERTeletexString, br.asn1.DERAbstractString), br.asn1.DERIA5String = function(t3) {
            br.asn1.DERIA5String.superclass.constructor.call(this, t3), this.hT = "16";
          }, o.lang.extend(br.asn1.DERIA5String, br.asn1.DERAbstractString), br.asn1.DERVisibleString = function(t3) {
            br.asn1.DERIA5String.superclass.constructor.call(this, t3), this.hT = "1a";
          }, o.lang.extend(br.asn1.DERVisibleString, br.asn1.DERAbstractString), br.asn1.DERBMPString = function(t3) {
            br.asn1.DERBMPString.superclass.constructor.call(this, t3), this.hT = "1e";
          }, o.lang.extend(br.asn1.DERBMPString, br.asn1.DERAbstractString), br.asn1.DERUTCTime = function(t3) {
            br.asn1.DERUTCTime.superclass.constructor.call(this, t3), this.hT = "17", this.setByDate = function(t4) {
              this.hTLV = null, this.isModified = true, this.date = t4, this.s = this.formatDate(this.date, "utc"), this.hV = Pr(this.s);
            }, this.getFreshValueHex = function() {
              return void 0 === this.date && void 0 === this.s && (this.date = /* @__PURE__ */ new Date(), this.s = this.formatDate(this.date, "utc"), this.hV = Pr(this.s)), this.hV;
            }, void 0 !== t3 && (void 0 !== t3.str ? this.setString(t3.str) : "string" == typeof t3 && t3.match(/^[0-9]{12}Z$/) ? this.setString(t3) : void 0 !== t3.hex ? this.setStringHex(t3.hex) : void 0 !== t3.date && this.setByDate(t3.date));
          }, o.lang.extend(br.asn1.DERUTCTime, br.asn1.DERAbstractTime), br.asn1.DERGeneralizedTime = function(t3) {
            br.asn1.DERGeneralizedTime.superclass.constructor.call(this, t3), this.hT = "18", this.withMillis = false, this.setByDate = function(t4) {
              this.hTLV = null, this.isModified = true, this.date = t4, this.s = this.formatDate(this.date, "gen", this.withMillis), this.hV = Pr(this.s);
            }, this.getFreshValueHex = function() {
              return void 0 === this.date && void 0 === this.s && (this.date = /* @__PURE__ */ new Date(), this.s = this.formatDate(this.date, "gen", this.withMillis), this.hV = Pr(this.s)), this.hV;
            }, void 0 !== t3 && (void 0 !== t3.str ? this.setString(t3.str) : "string" == typeof t3 && t3.match(/^[0-9]{14}Z$/) ? this.setString(t3) : void 0 !== t3.hex ? this.setStringHex(t3.hex) : void 0 !== t3.date && this.setByDate(t3.date), true === t3.millis && (this.withMillis = true));
          }, o.lang.extend(br.asn1.DERGeneralizedTime, br.asn1.DERAbstractTime), br.asn1.DERSequence = function(t3) {
            br.asn1.DERSequence.superclass.constructor.call(this, t3), this.hT = "30", this.getFreshValueHex = function() {
              for (var t4 = "", e2 = 0; e2 < this.asn1Array.length; e2++) {
                t4 += this.asn1Array[e2].getEncodedHex();
              }
              return this.hV = t4, this.hV;
            };
          }, o.lang.extend(br.asn1.DERSequence, br.asn1.DERAbstractStructured), br.asn1.DERSet = function(t3) {
            br.asn1.DERSet.superclass.constructor.call(this, t3), this.hT = "31", this.sortFlag = true, this.getFreshValueHex = function() {
              for (var t4 = new Array(), e2 = 0; e2 < this.asn1Array.length; e2++) {
                var r3 = this.asn1Array[e2];
                t4.push(r3.getEncodedHex());
              }
              return 1 == this.sortFlag && t4.sort(), this.hV = t4.join(""), this.hV;
            }, void 0 !== t3 && void 0 !== t3.sortflag && 0 == t3.sortflag && (this.sortFlag = false);
          }, o.lang.extend(br.asn1.DERSet, br.asn1.DERAbstractStructured), br.asn1.DERTaggedObject = function(t3) {
            br.asn1.DERTaggedObject.superclass.constructor.call(this);
            var e2 = br.asn1;
            this.hT = "a0", this.hV = "", this.isExplicit = true, this.asn1Object = null, this.setASN1Object = function(t4, e3, r3) {
              this.hT = e3, this.isExplicit = t4, this.asn1Object = r3, this.isExplicit ? (this.hV = this.asn1Object.getEncodedHex(), this.hTLV = null, this.isModified = true) : (this.hV = null, this.hTLV = r3.getEncodedHex(), this.hTLV = this.hTLV.replace(/^../, e3), this.isModified = false);
            }, this.getFreshValueHex = function() {
              return this.hV;
            }, this.setByParam = function(t4) {
              null != t4.tag && (this.hT = t4.tag), null != t4.explicit && (this.isExplicit = t4.explicit), null != t4.tage && (this.hT = t4.tage, this.isExplicit = true), null != t4.tagi && (this.hT = t4.tagi, this.isExplicit = false), null != t4.obj && (t4.obj instanceof e2.ASN1Object ? (this.asn1Object = t4.obj, this.setASN1Object(this.isExplicit, this.hT, this.asn1Object)) : "object" == r2(t4.obj) && (this.asn1Object = e2.ASN1Util.newObject(t4.obj), this.setASN1Object(this.isExplicit, this.hT, this.asn1Object)));
            }, null != t3 && this.setByParam(t3);
          }, o.lang.extend(br.asn1.DERTaggedObject, br.asn1.ASN1Object);
          var br, wr, Fr, Er = new function() {
          }();
          function xr(t3) {
            for (var e2 = new Array(), r3 = 0; r3 < t3.length; r3++)
              e2[r3] = t3.charCodeAt(r3);
            return e2;
          }
          function Ar(t3) {
            for (var e2 = "", r3 = 0; r3 < t3.length; r3++)
              e2 += String.fromCharCode(t3[r3]);
            return e2;
          }
          function kr(t3) {
            for (var e2 = "", r3 = 0; r3 < t3.length; r3++) {
              var n2 = t3[r3].toString(16);
              1 == n2.length && (n2 = "0" + n2), e2 += n2;
            }
            return e2;
          }
          function Pr(t3) {
            return kr(xr(t3));
          }
          function Cr(t3) {
            return t3 = (t3 = (t3 = t3.replace(/\=/g, "")).replace(/\+/g, "-")).replace(/\//g, "_");
          }
          function Tr(t3) {
            return t3.length % 4 == 2 ? t3 += "==" : t3.length % 4 == 3 && (t3 += "="), t3 = (t3 = t3.replace(/-/g, "+")).replace(/_/g, "/");
          }
          function Rr(t3) {
            return t3.length % 2 == 1 && (t3 = "0" + t3), Cr(S(t3));
          }
          function Ir(t3) {
            return b(Tr(t3));
          }
          function Dr(t3) {
            return qr(Gr(t3));
          }
          function Lr(t3) {
            return decodeURIComponent(Jr(t3));
          }
          function Nr(t3) {
            for (var e2 = "", r3 = 0; r3 < t3.length - 1; r3 += 2)
              e2 += String.fromCharCode(parseInt(t3.substr(r3, 2), 16));
            return e2;
          }
          function Ur(t3) {
            for (var e2 = "", r3 = 0; r3 < t3.length; r3++)
              e2 += ("0" + t3.charCodeAt(r3).toString(16)).slice(-2);
            return e2;
          }
          function Br(t3) {
            return S(t3);
          }
          function Or(t3) {
            var e2 = Br(t3).replace(/(.{64})/g, "$1\r\n");
            return e2 = e2.replace(/\r\n$/, "");
          }
          function jr(t3) {
            return b(t3.replace(/[^0-9A-Za-z\/+=]*/g, ""));
          }
          function Mr(t3, e2) {
            return "-----BEGIN " + e2 + "-----\r\n" + Or(t3) + "\r\n-----END " + e2 + "-----\r\n";
          }
          function Hr(t3, e2) {
            if (-1 == t3.indexOf("-----BEGIN "))
              throw "can't find PEM header: " + e2;
            return jr(t3 = void 0 !== e2 ? (t3 = t3.replace(new RegExp("^[^]*-----BEGIN " + e2 + "-----"), "")).replace(new RegExp("-----END " + e2 + "-----[^]*$"), "") : (t3 = t3.replace(/^[^]*-----BEGIN [^-]+-----/, "")).replace(/-----END [^-]+-----[^]*$/, ""));
          }
          function Vr(t3) {
            var e2, r3, n2, i2, o2, s2, a2, u2, c2, h2, l2;
            if (l2 = t3.match(/^(\d{2}|\d{4})(\d\d)(\d\d)(\d\d)(\d\d)(\d\d)(|\.\d+)Z$/))
              return u2 = l2[1], e2 = parseInt(u2), 2 === u2.length && (50 <= e2 && e2 < 100 ? e2 = 1900 + e2 : 0 <= e2 && e2 < 50 && (e2 = 2e3 + e2)), r3 = parseInt(l2[2]) - 1, n2 = parseInt(l2[3]), i2 = parseInt(l2[4]), o2 = parseInt(l2[5]), s2 = parseInt(l2[6]), a2 = 0, "" !== (c2 = l2[7]) && (h2 = (c2.substr(1) + "00").substr(0, 3), a2 = parseInt(h2)), Date.UTC(e2, r3, n2, i2, o2, s2, a2);
            throw "unsupported zulu format: " + t3;
          }
          function Kr(t3) {
            return ~~(Vr(t3) / 1e3);
          }
          function qr(t3) {
            return t3.replace(/%/g, "");
          }
          function Jr(t3) {
            return t3.replace(/(..)/g, "%$1");
          }
          function Wr(t3) {
            var e2 = "malformed IPv6 address";
            if (!t3.match(/^[0-9A-Fa-f:]+$/))
              throw e2;
            var r3 = (t3 = t3.toLowerCase()).split(":").length - 1;
            if (r3 < 2)
              throw e2;
            var n2 = ":".repeat(7 - r3 + 2), i2 = (t3 = t3.replace("::", n2)).split(":");
            if (8 != i2.length)
              throw e2;
            for (var o2 = 0; o2 < 8; o2++)
              i2[o2] = ("0000" + i2[o2]).slice(-4);
            return i2.join("");
          }
          function zr(t3) {
            if (!t3.match(/^[0-9A-Fa-f]{32}$/))
              throw "malformed IPv6 address octet";
            for (var e2 = (t3 = t3.toLowerCase()).match(/.{1,4}/g), r3 = 0; r3 < 8; r3++)
              e2[r3] = e2[r3].replace(/^0+/, ""), "" == e2[r3] && (e2[r3] = "0");
            var n2 = (t3 = ":" + e2.join(":") + ":").match(/:(0:){2,}/g);
            if (null === n2)
              return t3.slice(1, -1);
            var i2 = "";
            for (r3 = 0; r3 < n2.length; r3++)
              n2[r3].length > i2.length && (i2 = n2[r3]);
            return (t3 = t3.replace(i2, "::")).slice(1, -1);
          }
          function Yr(t3) {
            var e2 = "malformed hex value";
            if (!t3.match(/^([0-9A-Fa-f][0-9A-Fa-f]){1,}$/))
              throw e2;
            if (8 != t3.length)
              return 32 == t3.length ? zr(t3) : t3;
            try {
              return parseInt(t3.substr(0, 2), 16) + "." + parseInt(t3.substr(2, 2), 16) + "." + parseInt(t3.substr(4, 2), 16) + "." + parseInt(t3.substr(6, 2), 16);
            } catch (t4) {
              throw e2;
            }
          }
          function Gr(t3) {
            for (var e2 = encodeURIComponent(t3), r3 = "", n2 = 0; n2 < e2.length; n2++)
              "%" == e2[n2] ? (r3 += e2.substr(n2, 3), n2 += 2) : r3 = r3 + "%" + Pr(e2[n2]);
            return r3;
          }
          function Xr(t3) {
            return !(t3.length % 2 != 0 || !t3.match(/^[0-9a-f]+$/) && !t3.match(/^[0-9A-F]+$/));
          }
          function $r(t3) {
            return t3.length % 2 == 1 ? "0" + t3 : t3.substr(0, 1) > "7" ? "00" + t3 : t3;
          }
          Er.getLblen = function(t3, e2) {
            if ("8" != t3.substr(e2 + 2, 1))
              return 1;
            var r3 = parseInt(t3.substr(e2 + 3, 1));
            return 0 == r3 ? -1 : 0 < r3 && r3 < 10 ? r3 + 1 : -2;
          }, Er.getL = function(t3, e2) {
            var r3 = Er.getLblen(t3, e2);
            return r3 < 1 ? "" : t3.substr(e2 + 2, 2 * r3);
          }, Er.getVblen = function(t3, e2) {
            var r3;
            return "" == (r3 = Er.getL(t3, e2)) ? -1 : ("8" === r3.substr(0, 1) ? new F(r3.substr(2), 16) : new F(r3, 16)).intValue();
          }, Er.getVidx = function(t3, e2) {
            var r3 = Er.getLblen(t3, e2);
            return r3 < 0 ? r3 : e2 + 2 * (r3 + 1);
          }, Er.getV = function(t3, e2) {
            var r3 = Er.getVidx(t3, e2), n2 = Er.getVblen(t3, e2);
            return t3.substr(r3, 2 * n2);
          }, Er.getTLV = function(t3, e2) {
            return t3.substr(e2, 2) + Er.getL(t3, e2) + Er.getV(t3, e2);
          }, Er.getTLVblen = function(t3, e2) {
            return 2 + 2 * Er.getLblen(t3, e2) + 2 * Er.getVblen(t3, e2);
          }, Er.getNextSiblingIdx = function(t3, e2) {
            return Er.getVidx(t3, e2) + 2 * Er.getVblen(t3, e2);
          }, Er.getChildIdx = function(t3, e2) {
            var r3, n2, i2, o2 = Er, s2 = [];
            r3 = o2.getVidx(t3, e2), n2 = 2 * o2.getVblen(t3, e2), "03" == t3.substr(e2, 2) && (r3 += 2, n2 -= 2), i2 = 0;
            for (var a2 = r3; i2 <= n2; ) {
              var u2 = o2.getTLVblen(t3, a2);
              if ((i2 += u2) <= n2 && s2.push(a2), a2 += u2, i2 >= n2)
                break;
            }
            return s2;
          }, Er.getNthChildIdx = function(t3, e2, r3) {
            return Er.getChildIdx(t3, e2)[r3];
          }, Er.getIdxbyList = function(t3, e2, r3, n2) {
            var i2, o2, s2 = Er;
            return 0 == r3.length ? void 0 !== n2 && t3.substr(e2, 2) !== n2 ? -1 : e2 : (i2 = r3.shift()) >= (o2 = s2.getChildIdx(t3, e2)).length ? -1 : s2.getIdxbyList(t3, o2[i2], r3, n2);
          }, Er.getIdxbyListEx = function(t3, e2, r3, n2) {
            var i2, o2, s2 = Er;
            if (0 == r3.length)
              return void 0 !== n2 && t3.substr(e2, 2) !== n2 ? -1 : e2;
            i2 = r3.shift(), o2 = s2.getChildIdx(t3, e2);
            for (var a2 = 0, u2 = 0; u2 < o2.length; u2++) {
              var c2 = t3.substr(o2[u2], 2);
              if ("number" == typeof i2 && !s2.isContextTag(c2) && a2 == i2 || "string" == typeof i2 && s2.isContextTag(c2, i2))
                return s2.getIdxbyListEx(t3, o2[u2], r3, n2);
              s2.isContextTag(c2) || a2++;
            }
            return -1;
          }, Er.getTLVbyList = function(t3, e2, r3, n2) {
            var i2 = Er, o2 = i2.getIdxbyList(t3, e2, r3, n2);
            return -1 == o2 || o2 >= t3.length ? null : i2.getTLV(t3, o2);
          }, Er.getTLVbyListEx = function(t3, e2, r3, n2) {
            var i2 = Er, o2 = i2.getIdxbyListEx(t3, e2, r3, n2);
            return -1 == o2 ? null : i2.getTLV(t3, o2);
          }, Er.getVbyList = function(t3, e2, r3, n2, i2) {
            var o2, s2, a2 = Er;
            return -1 == (o2 = a2.getIdxbyList(t3, e2, r3, n2)) || o2 >= t3.length ? null : (s2 = a2.getV(t3, o2), true === i2 && (s2 = s2.substr(2)), s2);
          }, Er.getVbyListEx = function(t3, e2, r3, n2, i2) {
            var o2, s2, a2 = Er;
            return -1 == (o2 = a2.getIdxbyListEx(t3, e2, r3, n2)) ? null : (s2 = a2.getV(t3, o2), "03" == t3.substr(o2, 2) && false !== i2 && (s2 = s2.substr(2)), s2);
          }, Er.getInt = function(t3, e2, r3) {
            null == r3 && (r3 = -1);
            try {
              var n2 = t3.substr(e2, 2);
              if ("02" != n2 && "03" != n2)
                return r3;
              var i2 = Er.getV(t3, e2);
              return "02" == n2 ? parseInt(i2, 16) : function o2(t4) {
                try {
                  var e3 = t4.substr(0, 2);
                  if ("00" == e3)
                    return parseInt(t4.substr(2), 16);
                  var r4 = parseInt(e3, 16), n3 = t4.substr(2), i3 = parseInt(n3, 16).toString(2);
                  return "0" == i3 && (i3 = "00000000"), i3 = i3.slice(0, 0 - r4), parseInt(i3, 2);
                } catch (t5) {
                  return -1;
                }
              }(i2);
            } catch (t4) {
              return r3;
            }
          }, Er.getOID = function(t3, e2, r3) {
            null == r3 && (r3 = null);
            try {
              return "06" != t3.substr(e2, 2) ? r3 : function n2(t4) {
                if (!Xr(t4))
                  return null;
                try {
                  var e3 = [], r4 = t4.substr(0, 2), n3 = parseInt(r4, 16);
                  e3[0] = new String(Math.floor(n3 / 40)), e3[1] = new String(n3 % 40);
                  for (var i2 = t4.substr(2), o2 = [], s2 = 0; s2 < i2.length / 2; s2++)
                    o2.push(parseInt(i2.substr(2 * s2, 2), 16));
                  var a2 = [], u2 = "";
                  for (s2 = 0; s2 < o2.length; s2++)
                    128 & o2[s2] ? u2 += Qr((127 & o2[s2]).toString(2), 7) : (u2 += Qr((127 & o2[s2]).toString(2), 7), a2.push(new String(parseInt(u2, 2))), u2 = "");
                  var c2 = e3.join(".");
                  return a2.length > 0 && (c2 = c2 + "." + a2.join(".")), c2;
                } catch (t5) {
                  return null;
                }
              }(Er.getV(t3, e2));
            } catch (t4) {
              return r3;
            }
          }, Er.getOIDName = function(t3, e2, r3) {
            null == r3 && (r3 = null);
            try {
              var n2 = Er.getOID(t3, e2, r3);
              if (n2 == r3)
                return r3;
              var i2 = br.asn1.x509.OID.oid2name(n2);
              return "" == i2 ? n2 : i2;
            } catch (t4) {
              return r3;
            }
          }, Er.getString = function(t3, e2, r3) {
            null == r3 && (r3 = null);
            try {
              return Nr(Er.getV(t3, e2));
            } catch (t4) {
              return r3;
            }
          }, Er.hextooidstr = function(t3) {
            var e2 = function t4(e3, r4) {
              return e3.length >= r4 ? e3 : new Array(r4 - e3.length + 1).join("0") + e3;
            }, r3 = [], n2 = t3.substr(0, 2), i2 = parseInt(n2, 16);
            r3[0] = new String(Math.floor(i2 / 40)), r3[1] = new String(i2 % 40);
            for (var o2 = t3.substr(2), s2 = [], a2 = 0; a2 < o2.length / 2; a2++)
              s2.push(parseInt(o2.substr(2 * a2, 2), 16));
            var u2 = [], c2 = "";
            for (a2 = 0; a2 < s2.length; a2++)
              128 & s2[a2] ? c2 += e2((127 & s2[a2]).toString(2), 7) : (c2 += e2((127 & s2[a2]).toString(2), 7), u2.push(new String(parseInt(c2, 2))), c2 = "");
            var h2 = r3.join(".");
            return u2.length > 0 && (h2 = h2 + "." + u2.join(".")), h2;
          }, Er.dump = function(t3, e2, r3, n2) {
            var i2 = Er, o2 = i2.getV, s2 = i2.dump, a2 = i2.getChildIdx, u2 = t3;
            t3 instanceof br.asn1.ASN1Object && (u2 = t3.getEncodedHex());
            var c2 = function t4(e3, r4) {
              return e3.length <= 2 * r4 ? e3 : e3.substr(0, r4) + "..(total " + e3.length / 2 + "bytes).." + e3.substr(e3.length - r4, r4);
            };
            void 0 === e2 && (e2 = { ommit_long_octet: 32 }), void 0 === r3 && (r3 = 0), void 0 === n2 && (n2 = "");
            var h2, l2 = e2.ommit_long_octet;
            if ("01" == (h2 = u2.substr(r3, 2)))
              return "00" == (f2 = o2(u2, r3)) ? n2 + "BOOLEAN FALSE\n" : n2 + "BOOLEAN TRUE\n";
            if ("02" == h2)
              return n2 + "INTEGER " + c2(f2 = o2(u2, r3), l2) + "\n";
            if ("03" == h2) {
              var f2 = o2(u2, r3);
              if (i2.isASN1HEX(f2.substr(2))) {
                var g2 = n2 + "BITSTRING, encapsulates\n";
                return g2 += s2(f2.substr(2), e2, 0, n2 + "  ");
              }
              return n2 + "BITSTRING " + c2(f2, l2) + "\n";
            }
            if ("04" == h2) {
              f2 = o2(u2, r3);
              if (i2.isASN1HEX(f2)) {
                g2 = n2 + "OCTETSTRING, encapsulates\n";
                return g2 += s2(f2, e2, 0, n2 + "  ");
              }
              return n2 + "OCTETSTRING " + c2(f2, l2) + "\n";
            }
            if ("05" == h2)
              return n2 + "NULL\n";
            if ("06" == h2) {
              var d2 = o2(u2, r3), p2 = br.asn1.ASN1Util.oidHexToInt(d2), v2 = br.asn1.x509.OID.oid2name(p2), y2 = p2.replace(/\./g, " ");
              return "" != v2 ? n2 + "ObjectIdentifier " + v2 + " (" + y2 + ")\n" : n2 + "ObjectIdentifier (" + y2 + ")\n";
            }
            if ("0a" == h2)
              return n2 + "ENUMERATED " + parseInt(o2(u2, r3)) + "\n";
            if ("0c" == h2)
              return n2 + "UTF8String '" + Lr(o2(u2, r3)) + "'\n";
            if ("13" == h2)
              return n2 + "PrintableString '" + Lr(o2(u2, r3)) + "'\n";
            if ("14" == h2)
              return n2 + "TeletexString '" + Lr(o2(u2, r3)) + "'\n";
            if ("16" == h2)
              return n2 + "IA5String '" + Lr(o2(u2, r3)) + "'\n";
            if ("17" == h2)
              return n2 + "UTCTime " + Lr(o2(u2, r3)) + "\n";
            if ("18" == h2)
              return n2 + "GeneralizedTime " + Lr(o2(u2, r3)) + "\n";
            if ("1a" == h2)
              return n2 + "VisualString '" + Lr(o2(u2, r3)) + "'\n";
            if ("1e" == h2)
              return n2 + "BMPString '" + Lr(o2(u2, r3)) + "'\n";
            if ("30" == h2) {
              if ("3000" == u2.substr(r3, 4))
                return n2 + "SEQUENCE {}\n";
              g2 = n2 + "SEQUENCE\n";
              var m2 = e2;
              if ((2 == (b2 = a2(u2, r3)).length || 3 == b2.length) && "06" == u2.substr(b2[0], 2) && "04" == u2.substr(b2[b2.length - 1], 2)) {
                v2 = i2.oidname(o2(u2, b2[0]));
                var _2 = JSON.parse(JSON.stringify(e2));
                _2.x509ExtName = v2, m2 = _2;
              }
              for (var S2 = 0; S2 < b2.length; S2++)
                g2 += s2(u2, m2, b2[S2], n2 + "  ");
              return g2;
            }
            if ("31" == h2) {
              g2 = n2 + "SET\n";
              var b2 = a2(u2, r3);
              for (S2 = 0; S2 < b2.length; S2++)
                g2 += s2(u2, e2, b2[S2], n2 + "  ");
              return g2;
            }
            if (0 != (128 & (h2 = parseInt(h2, 16)))) {
              var w2 = 31 & h2;
              if (0 != (32 & h2)) {
                for (g2 = n2 + "[" + w2 + "]\n", b2 = a2(u2, r3), S2 = 0; S2 < b2.length; S2++)
                  g2 += s2(u2, e2, b2[S2], n2 + "  ");
                return g2;
              }
              f2 = o2(u2, r3);
              if (Er.isASN1HEX(f2)) {
                var g2 = n2 + "[" + w2 + "]\n";
                return g2 += s2(f2, e2, 0, n2 + "  ");
              }
              return ("68747470" == f2.substr(0, 8) || "subjectAltName" === e2.x509ExtName && 2 == w2) && (f2 = Lr(f2)), g2 = n2 + "[" + w2 + "] " + f2 + "\n";
            }
            return n2 + "UNKNOWN(" + h2 + ") " + o2(u2, r3) + "\n";
          }, Er.isContextTag = function(t3, e2) {
            var r3, n2;
            t3 = t3.toLowerCase();
            try {
              r3 = parseInt(t3, 16);
            } catch (t4) {
              return -1;
            }
            if (void 0 === e2)
              return 128 == (192 & r3);
            try {
              return null != e2.match(/^\[[0-9]+\]$/) && (!((n2 = parseInt(e2.substr(1, e2.length - 1), 10)) > 31) && (128 == (192 & r3) && (31 & r3) == n2));
            } catch (t4) {
              return false;
            }
          }, Er.isASN1HEX = function(t3) {
            var e2 = Er;
            if (t3.length % 2 == 1)
              return false;
            var r3 = e2.getVblen(t3, 0), n2 = t3.substr(0, 2), i2 = e2.getL(t3, 0);
            return t3.length - n2.length - i2.length == 2 * r3;
          }, Er.checkStrictDER = function(t3, e2, r3, n2, i2) {
            var o2 = Er;
            if (void 0 === r3) {
              if ("string" != typeof t3)
                throw new Error("not hex string");
              if (t3 = t3.toLowerCase(), !br.lang.String.isHex(t3))
                throw new Error("not hex string");
              r3 = t3.length, i2 = (n2 = t3.length / 2) < 128 ? 1 : Math.ceil(n2.toString(16)) + 1;
            }
            if (o2.getL(t3, e2).length > 2 * i2)
              throw new Error("L of TLV too long: idx=" + e2);
            var s2 = o2.getVblen(t3, e2);
            if (s2 > n2)
              throw new Error("value of L too long than hex: idx=" + e2);
            var a2 = o2.getTLV(t3, e2), u2 = a2.length - 2 - o2.getL(t3, e2).length;
            if (u2 !== 2 * s2)
              throw new Error("V string length and L's value not the same:" + u2 + "/" + 2 * s2);
            if (0 === e2 && t3.length != a2.length)
              throw new Error("total length and TLV length unmatch:" + t3.length + "!=" + a2.length);
            var c2 = t3.substr(e2, 2);
            if ("02" === c2) {
              var h2 = o2.getVidx(t3, e2);
              if ("00" == t3.substr(h2, 2) && t3.charCodeAt(h2 + 2) < 56)
                throw new Error("not least zeros for DER INTEGER");
            }
            if (32 & parseInt(c2, 16)) {
              for (var l2 = o2.getVblen(t3, e2), f2 = 0, g2 = o2.getChildIdx(t3, e2), d2 = 0; d2 < g2.length; d2++) {
                f2 += o2.getTLV(t3, g2[d2]).length, o2.checkStrictDER(t3, g2[d2], r3, n2, i2);
              }
              if (2 * l2 != f2)
                throw new Error("sum of children's TLV length and L unmatch: " + 2 * l2 + "!=" + f2);
            }
          }, Er.oidname = function(t3) {
            var e2 = br.asn1;
            br.lang.String.isHex(t3) && (t3 = e2.ASN1Util.oidHexToInt(t3));
            var r3 = e2.x509.OID.oid2name(t3);
            return "" === r3 && (r3 = t3), r3;
          }, void 0 !== br && br || (e.KJUR = br = {}), void 0 !== br.lang && br.lang || (br.lang = {}), br.lang.String = function() {
          }, "function" == typeof t2 ? (e.utf8tob64u = wr = function e2(r3) {
            return Cr(t2.from(r3, "utf8").toString("base64"));
          }, e.b64utoutf8 = Fr = function e2(r3) {
            return t2.from(Tr(r3), "base64").toString("utf8");
          }) : (e.utf8tob64u = wr = function t3(e2) {
            return Rr(qr(Gr(e2)));
          }, e.b64utoutf8 = Fr = function t3(e2) {
            return decodeURIComponent(Jr(Ir(e2)));
          }), br.lang.String.isInteger = function(t3) {
            return !!t3.match(/^[0-9]+$/) || !!t3.match(/^-[0-9]+$/);
          }, br.lang.String.isHex = function(t3) {
            return Xr(t3);
          }, br.lang.String.isBase64 = function(t3) {
            return !(!(t3 = t3.replace(/\s+/g, "")).match(/^[0-9A-Za-z+\/]+={0,3}$/) || t3.length % 4 != 0);
          }, br.lang.String.isBase64URL = function(t3) {
            return !t3.match(/[+/=]/) && (t3 = Tr(t3), br.lang.String.isBase64(t3));
          }, br.lang.String.isIntegerArray = function(t3) {
            return !!(t3 = t3.replace(/\s+/g, "")).match(/^\[[0-9,]+\]$/);
          }, br.lang.String.isPrintable = function(t3) {
            return null !== t3.match(/^[0-9A-Za-z '()+,-./:=?]*$/);
          }, br.lang.String.isIA5 = function(t3) {
            return null !== t3.match(/^[\x20-\x21\x23-\x7f]*$/);
          }, br.lang.String.isMail = function(t3) {
            return null !== t3.match(/^[A-Za-z0-9]{1}[A-Za-z0-9_.-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9]{1,}$/);
          };
          var Qr = function t3(e2, r3, n2) {
            return null == n2 && (n2 = "0"), e2.length >= r3 ? e2 : new Array(r3 - e2.length + 1).join(n2) + e2;
          };
          void 0 !== br && br || (e.KJUR = br = {}), void 0 !== br.crypto && br.crypto || (br.crypto = {}), br.crypto.Util = new function() {
            this.DIGESTINFOHEAD = { sha1: "3021300906052b0e03021a05000414", sha224: "302d300d06096086480165030402040500041c", sha256: "3031300d060960864801650304020105000420", sha384: "3041300d060960864801650304020205000430", sha512: "3051300d060960864801650304020305000440", md2: "3020300c06082a864886f70d020205000410", md5: "3020300c06082a864886f70d020505000410", ripemd160: "3021300906052b2403020105000414" }, this.DEFAULTPROVIDER = { md5: "cryptojs", sha1: "cryptojs", sha224: "cryptojs", sha256: "cryptojs", sha384: "cryptojs", sha512: "cryptojs", ripemd160: "cryptojs", hmacmd5: "cryptojs", hmacsha1: "cryptojs", hmacsha224: "cryptojs", hmacsha256: "cryptojs", hmacsha384: "cryptojs", hmacsha512: "cryptojs", hmacripemd160: "cryptojs", MD5withRSA: "cryptojs/jsrsa", SHA1withRSA: "cryptojs/jsrsa", SHA224withRSA: "cryptojs/jsrsa", SHA256withRSA: "cryptojs/jsrsa", SHA384withRSA: "cryptojs/jsrsa", SHA512withRSA: "cryptojs/jsrsa", RIPEMD160withRSA: "cryptojs/jsrsa", MD5withECDSA: "cryptojs/jsrsa", SHA1withECDSA: "cryptojs/jsrsa", SHA224withECDSA: "cryptojs/jsrsa", SHA256withECDSA: "cryptojs/jsrsa", SHA384withECDSA: "cryptojs/jsrsa", SHA512withECDSA: "cryptojs/jsrsa", RIPEMD160withECDSA: "cryptojs/jsrsa", SHA1withDSA: "cryptojs/jsrsa", SHA224withDSA: "cryptojs/jsrsa", SHA256withDSA: "cryptojs/jsrsa", MD5withRSAandMGF1: "cryptojs/jsrsa", SHAwithRSAandMGF1: "cryptojs/jsrsa", SHA1withRSAandMGF1: "cryptojs/jsrsa", SHA224withRSAandMGF1: "cryptojs/jsrsa", SHA256withRSAandMGF1: "cryptojs/jsrsa", SHA384withRSAandMGF1: "cryptojs/jsrsa", SHA512withRSAandMGF1: "cryptojs/jsrsa", RIPEMD160withRSAandMGF1: "cryptojs/jsrsa" }, this.CRYPTOJSMESSAGEDIGESTNAME = { md5: y.algo.MD5, sha1: y.algo.SHA1, sha224: y.algo.SHA224, sha256: y.algo.SHA256, sha384: y.algo.SHA384, sha512: y.algo.SHA512, ripemd160: y.algo.RIPEMD160 }, this.getDigestInfoHex = function(t3, e2) {
              if (void 0 === this.DIGESTINFOHEAD[e2])
                throw "alg not supported in Util.DIGESTINFOHEAD: " + e2;
              return this.DIGESTINFOHEAD[e2] + t3;
            }, this.getPaddedDigestInfoHex = function(t3, e2, r3) {
              var n2 = this.getDigestInfoHex(t3, e2), i2 = r3 / 4;
              if (n2.length + 22 > i2)
                throw "key is too short for SigAlg: keylen=" + r3 + "," + e2;
              for (var o2 = "0001", s2 = "00" + n2, a2 = "", u2 = i2 - o2.length - s2.length, c2 = 0; c2 < u2; c2 += 2)
                a2 += "ff";
              return o2 + a2 + s2;
            }, this.hashString = function(t3, e2) {
              return new br.crypto.MessageDigest({ alg: e2 }).digestString(t3);
            }, this.hashHex = function(t3, e2) {
              return new br.crypto.MessageDigest({ alg: e2 }).digestHex(t3);
            }, this.sha1 = function(t3) {
              return this.hashString(t3, "sha1");
            }, this.sha256 = function(t3) {
              return this.hashString(t3, "sha256");
            }, this.sha256Hex = function(t3) {
              return this.hashHex(t3, "sha256");
            }, this.sha512 = function(t3) {
              return this.hashString(t3, "sha512");
            }, this.sha512Hex = function(t3) {
              return this.hashHex(t3, "sha512");
            }, this.isKey = function(t3) {
              return t3 instanceof He || t3 instanceof br.crypto.DSA || t3 instanceof br.crypto.ECDSA;
            };
          }(), br.crypto.Util.md5 = function(t3) {
            return new br.crypto.MessageDigest({ alg: "md5", prov: "cryptojs" }).digestString(t3);
          }, br.crypto.Util.ripemd160 = function(t3) {
            return new br.crypto.MessageDigest({ alg: "ripemd160", prov: "cryptojs" }).digestString(t3);
          }, br.crypto.Util.SECURERANDOMGEN = new Oe(), br.crypto.Util.getRandomHexOfNbytes = function(t3) {
            var e2 = new Array(t3);
            return br.crypto.Util.SECURERANDOMGEN.nextBytes(e2), kr(e2);
          }, br.crypto.Util.getRandomBigIntegerOfNbytes = function(t3) {
            return new F(br.crypto.Util.getRandomHexOfNbytes(t3), 16);
          }, br.crypto.Util.getRandomHexOfNbits = function(t3) {
            var e2 = t3 % 8, r3 = new Array((t3 - e2) / 8 + 1);
            return br.crypto.Util.SECURERANDOMGEN.nextBytes(r3), r3[0] = (255 << e2 & 255 ^ 255) & r3[0], kr(r3);
          }, br.crypto.Util.getRandomBigIntegerOfNbits = function(t3) {
            return new F(br.crypto.Util.getRandomHexOfNbits(t3), 16);
          }, br.crypto.Util.getRandomBigIntegerZeroToMax = function(t3) {
            for (var e2 = t3.bitLength(); ; ) {
              var r3 = br.crypto.Util.getRandomBigIntegerOfNbits(e2);
              if (-1 != t3.compareTo(r3))
                return r3;
            }
          }, br.crypto.Util.getRandomBigIntegerMinToMax = function(t3, e2) {
            var r3 = t3.compareTo(e2);
            if (1 == r3)
              throw "biMin is greater than biMax";
            if (0 == r3)
              return t3;
            var n2 = e2.subtract(t3);
            return br.crypto.Util.getRandomBigIntegerZeroToMax(n2).add(t3);
          }, br.crypto.MessageDigest = function(t3) {
            this.setAlgAndProvider = function(t4, e2) {
              if (null !== (t4 = br.crypto.MessageDigest.getCanonicalAlgName(t4)) && void 0 === e2 && (e2 = br.crypto.Util.DEFAULTPROVIDER[t4]), -1 != ":md5:sha1:sha224:sha256:sha384:sha512:ripemd160:".indexOf(t4) && "cryptojs" == e2) {
                try {
                  this.md = br.crypto.Util.CRYPTOJSMESSAGEDIGESTNAME[t4].create();
                } catch (e3) {
                  throw "setAlgAndProvider hash alg set fail alg=" + t4 + "/" + e3;
                }
                this.updateString = function(t5) {
                  this.md.update(t5);
                }, this.updateHex = function(t5) {
                  var e3 = y.enc.Hex.parse(t5);
                  this.md.update(e3);
                }, this.digest = function() {
                  return this.md.finalize().toString(y.enc.Hex);
                }, this.digestString = function(t5) {
                  return this.updateString(t5), this.digest();
                }, this.digestHex = function(t5) {
                  return this.updateHex(t5), this.digest();
                };
              }
              if (-1 != ":sha256:".indexOf(t4) && "sjcl" == e2) {
                try {
                  this.md = new sjcl.hash.sha256();
                } catch (e3) {
                  throw "setAlgAndProvider hash alg set fail alg=" + t4 + "/" + e3;
                }
                this.updateString = function(t5) {
                  this.md.update(t5);
                }, this.updateHex = function(t5) {
                  var e3 = sjcl.codec.hex.toBits(t5);
                  this.md.update(e3);
                }, this.digest = function() {
                  var t5 = this.md.finalize();
                  return sjcl.codec.hex.fromBits(t5);
                }, this.digestString = function(t5) {
                  return this.updateString(t5), this.digest();
                }, this.digestHex = function(t5) {
                  return this.updateHex(t5), this.digest();
                };
              }
            }, this.updateString = function(t4) {
              throw "updateString(str) not supported for this alg/prov: " + this.algName + "/" + this.provName;
            }, this.updateHex = function(t4) {
              throw "updateHex(hex) not supported for this alg/prov: " + this.algName + "/" + this.provName;
            }, this.digest = function() {
              throw "digest() not supported for this alg/prov: " + this.algName + "/" + this.provName;
            }, this.digestString = function(t4) {
              throw "digestString(str) not supported for this alg/prov: " + this.algName + "/" + this.provName;
            }, this.digestHex = function(t4) {
              throw "digestHex(hex) not supported for this alg/prov: " + this.algName + "/" + this.provName;
            }, void 0 !== t3 && void 0 !== t3.alg && (this.algName = t3.alg, void 0 === t3.prov && (this.provName = br.crypto.Util.DEFAULTPROVIDER[this.algName]), this.setAlgAndProvider(this.algName, this.provName));
          }, br.crypto.MessageDigest.getCanonicalAlgName = function(t3) {
            return "string" == typeof t3 && (t3 = (t3 = t3.toLowerCase()).replace(/-/, "")), t3;
          }, br.crypto.MessageDigest.getHashLength = function(t3) {
            var e2 = br.crypto.MessageDigest, r3 = e2.getCanonicalAlgName(t3);
            if (void 0 === e2.HASHLENGTH[r3])
              throw "not supported algorithm: " + t3;
            return e2.HASHLENGTH[r3];
          }, br.crypto.MessageDigest.HASHLENGTH = { md5: 16, sha1: 20, sha224: 28, sha256: 32, sha384: 48, sha512: 64, ripemd160: 20 }, br.crypto.Mac = function(t3) {
            this.setAlgAndProvider = function(t4, e2) {
              if (null == (t4 = t4.toLowerCase()) && (t4 = "hmacsha1"), "hmac" != (t4 = t4.toLowerCase()).substr(0, 4))
                throw "setAlgAndProvider unsupported HMAC alg: " + t4;
              void 0 === e2 && (e2 = br.crypto.Util.DEFAULTPROVIDER[t4]), this.algProv = t4 + "/" + e2;
              var r3 = t4.substr(4);
              if (-1 != ":md5:sha1:sha224:sha256:sha384:sha512:ripemd160:".indexOf(r3) && "cryptojs" == e2) {
                try {
                  var n2 = br.crypto.Util.CRYPTOJSMESSAGEDIGESTNAME[r3];
                  this.mac = y.algo.HMAC.create(n2, this.pass);
                } catch (t5) {
                  throw "setAlgAndProvider hash alg set fail hashAlg=" + r3 + "/" + t5;
                }
                this.updateString = function(t5) {
                  this.mac.update(t5);
                }, this.updateHex = function(t5) {
                  var e3 = y.enc.Hex.parse(t5);
                  this.mac.update(e3);
                }, this.doFinal = function() {
                  return this.mac.finalize().toString(y.enc.Hex);
                }, this.doFinalString = function(t5) {
                  return this.updateString(t5), this.doFinal();
                }, this.doFinalHex = function(t5) {
                  return this.updateHex(t5), this.doFinal();
                };
              }
            }, this.updateString = function(t4) {
              throw "updateString(str) not supported for this alg/prov: " + this.algProv;
            }, this.updateHex = function(t4) {
              throw "updateHex(hex) not supported for this alg/prov: " + this.algProv;
            }, this.doFinal = function() {
              throw "digest() not supported for this alg/prov: " + this.algProv;
            }, this.doFinalString = function(t4) {
              throw "digestString(str) not supported for this alg/prov: " + this.algProv;
            }, this.doFinalHex = function(t4) {
              throw "digestHex(hex) not supported for this alg/prov: " + this.algProv;
            }, this.setPassword = function(t4) {
              if ("string" == typeof t4) {
                var e2 = t4;
                return t4.length % 2 != 1 && t4.match(/^[0-9A-Fa-f]+$/) || (e2 = Ur(t4)), void (this.pass = y.enc.Hex.parse(e2));
              }
              if ("object" != (void 0 === t4 ? "undefined" : r2(t4)))
                throw "KJUR.crypto.Mac unsupported password type: " + t4;
              e2 = null;
              if (void 0 !== t4.hex) {
                if (t4.hex.length % 2 != 0 || !t4.hex.match(/^[0-9A-Fa-f]+$/))
                  throw "Mac: wrong hex password: " + t4.hex;
                e2 = t4.hex;
              }
              if (void 0 !== t4.utf8 && (e2 = Dr(t4.utf8)), void 0 !== t4.rstr && (e2 = Ur(t4.rstr)), void 0 !== t4.b64 && (e2 = b(t4.b64)), void 0 !== t4.b64u && (e2 = Ir(t4.b64u)), null == e2)
                throw "KJUR.crypto.Mac unsupported password type: " + t4;
              this.pass = y.enc.Hex.parse(e2);
            }, void 0 !== t3 && (void 0 !== t3.pass && this.setPassword(t3.pass), void 0 !== t3.alg && (this.algName = t3.alg, void 0 === t3.prov && (this.provName = br.crypto.Util.DEFAULTPROVIDER[this.algName]), this.setAlgAndProvider(this.algName, this.provName)));
          }, br.crypto.Signature = function(t3) {
            var e2 = null;
            if (this._setAlgNames = function() {
              var t4 = this.algName.match(/^(.+)with(.+)$/);
              t4 && (this.mdAlgName = t4[1].toLowerCase(), this.pubkeyAlgName = t4[2].toLowerCase(), "rsaandmgf1" == this.pubkeyAlgName && "sha" == this.mdAlgName && (this.mdAlgName = "sha1"));
            }, this._zeroPaddingOfSignature = function(t4, e3) {
              for (var r3 = "", n2 = e3 / 4 - t4.length, i2 = 0; i2 < n2; i2++)
                r3 += "0";
              return r3 + t4;
            }, this.setAlgAndProvider = function(t4, e3) {
              if (this._setAlgNames(), "cryptojs/jsrsa" != e3)
                throw new Error("provider not supported: " + e3);
              if (-1 != ":md5:sha1:sha224:sha256:sha384:sha512:ripemd160:".indexOf(this.mdAlgName)) {
                try {
                  this.md = new br.crypto.MessageDigest({ alg: this.mdAlgName });
                } catch (t5) {
                  throw new Error("setAlgAndProvider hash alg set fail alg=" + this.mdAlgName + "/" + t5);
                }
                this.init = function(t5, e4) {
                  var r3 = null;
                  try {
                    r3 = void 0 === e4 ? Zr.getKey(t5) : Zr.getKey(t5, e4);
                  } catch (t6) {
                    throw "init failed:" + t6;
                  }
                  if (true === r3.isPrivate)
                    this.prvKey = r3, this.state = "SIGN";
                  else {
                    if (true !== r3.isPublic)
                      throw "init failed.:" + r3;
                    this.pubKey = r3, this.state = "VERIFY";
                  }
                }, this.updateString = function(t5) {
                  this.md.updateString(t5);
                }, this.updateHex = function(t5) {
                  this.md.updateHex(t5);
                }, this.sign = function() {
                  if (this.sHashHex = this.md.digest(), void 0 === this.prvKey && void 0 !== this.ecprvhex && void 0 !== this.eccurvename && void 0 !== br.crypto.ECDSA && (this.prvKey = new br.crypto.ECDSA({ curve: this.eccurvename, prv: this.ecprvhex })), this.prvKey instanceof He && "rsaandmgf1" === this.pubkeyAlgName)
                    this.hSign = this.prvKey.signWithMessageHashPSS(this.sHashHex, this.mdAlgName, this.pssSaltLen);
                  else if (this.prvKey instanceof He && "rsa" === this.pubkeyAlgName)
                    this.hSign = this.prvKey.signWithMessageHash(this.sHashHex, this.mdAlgName);
                  else if (this.prvKey instanceof br.crypto.ECDSA)
                    this.hSign = this.prvKey.signWithMessageHash(this.sHashHex);
                  else {
                    if (!(this.prvKey instanceof br.crypto.DSA))
                      throw "Signature: unsupported private key alg: " + this.pubkeyAlgName;
                    this.hSign = this.prvKey.signWithMessageHash(this.sHashHex);
                  }
                  return this.hSign;
                }, this.signString = function(t5) {
                  return this.updateString(t5), this.sign();
                }, this.signHex = function(t5) {
                  return this.updateHex(t5), this.sign();
                }, this.verify = function(t5) {
                  if (this.sHashHex = this.md.digest(), void 0 === this.pubKey && void 0 !== this.ecpubhex && void 0 !== this.eccurvename && void 0 !== br.crypto.ECDSA && (this.pubKey = new br.crypto.ECDSA({ curve: this.eccurvename, pub: this.ecpubhex })), this.pubKey instanceof He && "rsaandmgf1" === this.pubkeyAlgName)
                    return this.pubKey.verifyWithMessageHashPSS(this.sHashHex, t5, this.mdAlgName, this.pssSaltLen);
                  if (this.pubKey instanceof He && "rsa" === this.pubkeyAlgName)
                    return this.pubKey.verifyWithMessageHash(this.sHashHex, t5);
                  if (void 0 !== br.crypto.ECDSA && this.pubKey instanceof br.crypto.ECDSA)
                    return this.pubKey.verifyWithMessageHash(this.sHashHex, t5);
                  if (void 0 !== br.crypto.DSA && this.pubKey instanceof br.crypto.DSA)
                    return this.pubKey.verifyWithMessageHash(this.sHashHex, t5);
                  throw "Signature: unsupported public key alg: " + this.pubkeyAlgName;
                };
              }
            }, this.init = function(t4, e3) {
              throw "init(key, pass) not supported for this alg:prov=" + this.algProvName;
            }, this.updateString = function(t4) {
              throw "updateString(str) not supported for this alg:prov=" + this.algProvName;
            }, this.updateHex = function(t4) {
              throw "updateHex(hex) not supported for this alg:prov=" + this.algProvName;
            }, this.sign = function() {
              throw "sign() not supported for this alg:prov=" + this.algProvName;
            }, this.signString = function(t4) {
              throw "digestString(str) not supported for this alg:prov=" + this.algProvName;
            }, this.signHex = function(t4) {
              throw "digestHex(hex) not supported for this alg:prov=" + this.algProvName;
            }, this.verify = function(t4) {
              throw "verify(hSigVal) not supported for this alg:prov=" + this.algProvName;
            }, this.initParams = t3, void 0 !== t3 && (void 0 !== t3.alg && (this.algName = t3.alg, void 0 === t3.prov ? this.provName = br.crypto.Util.DEFAULTPROVIDER[this.algName] : this.provName = t3.prov, this.algProvName = this.algName + ":" + this.provName, this.setAlgAndProvider(this.algName, this.provName), this._setAlgNames()), void 0 !== t3.psssaltlen && (this.pssSaltLen = t3.psssaltlen), void 0 !== t3.prvkeypem)) {
              if (void 0 !== t3.prvkeypas)
                throw "both prvkeypem and prvkeypas parameters not supported";
              try {
                e2 = Zr.getKey(t3.prvkeypem);
                this.init(e2);
              } catch (t4) {
                throw "fatal error to load pem private key: " + t4;
              }
            }
          }, br.crypto.Cipher = function(t3) {
          }, br.crypto.Cipher.encrypt = function(t3, e2, r3) {
            if (e2 instanceof He && e2.isPublic) {
              var n2 = br.crypto.Cipher.getAlgByKeyAndName(e2, r3);
              if ("RSA" === n2)
                return e2.encrypt(t3);
              if ("RSAOAEP" === n2)
                return e2.encryptOAEP(t3, "sha1");
              var i2 = n2.match(/^RSAOAEP(\d+)$/);
              if (null !== i2)
                return e2.encryptOAEP(t3, "sha" + i2[1]);
              throw "Cipher.encrypt: unsupported algorithm for RSAKey: " + r3;
            }
            throw "Cipher.encrypt: unsupported key or algorithm";
          }, br.crypto.Cipher.decrypt = function(t3, e2, r3) {
            if (e2 instanceof He && e2.isPrivate) {
              var n2 = br.crypto.Cipher.getAlgByKeyAndName(e2, r3);
              if ("RSA" === n2)
                return e2.decrypt(t3);
              if ("RSAOAEP" === n2)
                return e2.decryptOAEP(t3, "sha1");
              var i2 = n2.match(/^RSAOAEP(\d+)$/);
              if (null !== i2)
                return e2.decryptOAEP(t3, "sha" + i2[1]);
              throw "Cipher.decrypt: unsupported algorithm for RSAKey: " + r3;
            }
            throw "Cipher.decrypt: unsupported key or algorithm";
          }, br.crypto.Cipher.getAlgByKeyAndName = function(t3, e2) {
            if (t3 instanceof He) {
              if (-1 != ":RSA:RSAOAEP:RSAOAEP224:RSAOAEP256:RSAOAEP384:RSAOAEP512:".indexOf(e2))
                return e2;
              if (null == e2)
                return "RSA";
              throw "getAlgByKeyAndName: not supported algorithm name for RSAKey: " + e2;
            }
            throw "getAlgByKeyAndName: not supported algorithm name: " + e2;
          }, br.crypto.OID = new function() {
            this.oidhex2name = { "2a864886f70d010101": "rsaEncryption", "2a8648ce3d0201": "ecPublicKey", "2a8648ce380401": "dsa", "2a8648ce3d030107": "secp256r1", "2b8104001f": "secp192k1", "2b81040021": "secp224r1", "2b8104000a": "secp256k1", "2b81040023": "secp521r1", "2b81040022": "secp384r1", "2a8648ce380403": "SHA1withDSA", "608648016503040301": "SHA224withDSA", "608648016503040302": "SHA256withDSA" };
          }(), void 0 !== br && br || (e.KJUR = br = {}), void 0 !== br.crypto && br.crypto || (br.crypto = {}), br.crypto.ECDSA = function(t3) {
            var e2 = Error, n2 = F, i2 = Ke, o2 = br.crypto.ECDSA, s2 = br.crypto.ECParameterDB, a2 = o2.getName, u2 = Er, c2 = u2.getVbyListEx, h2 = u2.isASN1HEX, l2 = new Oe();
            this.type = "EC", this.isPrivate = false, this.isPublic = false, this.getBigRandom = function(t4) {
              return new n2(t4.bitLength(), l2).mod(t4.subtract(n2.ONE)).add(n2.ONE);
            }, this.setNamedCurve = function(t4) {
              this.ecparams = s2.getByName(t4), this.prvKeyHex = null, this.pubKeyHex = null, this.curveName = t4;
            }, this.setPrivateKeyHex = function(t4) {
              this.isPrivate = true, this.prvKeyHex = t4;
            }, this.setPublicKeyHex = function(t4) {
              this.isPublic = true, this.pubKeyHex = t4;
            }, this.getPublicKeyXYHex = function() {
              var t4 = this.pubKeyHex;
              if ("04" !== t4.substr(0, 2))
                throw "this method supports uncompressed format(04) only";
              var e3 = this.ecparams.keylen / 4;
              if (t4.length !== 2 + 2 * e3)
                throw "malformed public key hex length";
              var r3 = {};
              return r3.x = t4.substr(2, e3), r3.y = t4.substr(2 + e3), r3;
            }, this.getShortNISTPCurveName = function() {
              var t4 = this.curveName;
              return "secp256r1" === t4 || "NIST P-256" === t4 || "P-256" === t4 || "prime256v1" === t4 ? "P-256" : "secp384r1" === t4 || "NIST P-384" === t4 || "P-384" === t4 ? "P-384" : null;
            }, this.generateKeyPairHex = function() {
              var t4 = this.ecparams.n, e3 = this.getBigRandom(t4), r3 = this.ecparams.G.multiply(e3), n3 = r3.getX().toBigInteger(), i3 = r3.getY().toBigInteger(), o3 = this.ecparams.keylen / 4, s3 = ("0000000000" + e3.toString(16)).slice(-o3), a3 = "04" + ("0000000000" + n3.toString(16)).slice(-o3) + ("0000000000" + i3.toString(16)).slice(-o3);
              return this.setPrivateKeyHex(s3), this.setPublicKeyHex(a3), { ecprvhex: s3, ecpubhex: a3 };
            }, this.signWithMessageHash = function(t4) {
              return this.signHex(t4, this.prvKeyHex);
            }, this.signHex = function(t4, e3) {
              var r3 = new n2(e3, 16), i3 = this.ecparams.n, s3 = new n2(t4.substring(0, this.ecparams.keylen / 4), 16);
              do {
                var a3 = this.getBigRandom(i3), u3 = this.ecparams.G.multiply(a3).getX().toBigInteger().mod(i3);
              } while (u3.compareTo(n2.ZERO) <= 0);
              var c3 = a3.modInverse(i3).multiply(s3.add(r3.multiply(u3))).mod(i3);
              return o2.biRSSigToASN1Sig(u3, c3);
            }, this.sign = function(t4, e3) {
              var r3 = e3, i3 = this.ecparams.n, o3 = n2.fromByteArrayUnsigned(t4);
              do {
                var s3 = this.getBigRandom(i3), a3 = this.ecparams.G.multiply(s3).getX().toBigInteger().mod(i3);
              } while (a3.compareTo(F.ZERO) <= 0);
              var u3 = s3.modInverse(i3).multiply(o3.add(r3.multiply(a3))).mod(i3);
              return this.serializeSig(a3, u3);
            }, this.verifyWithMessageHash = function(t4, e3) {
              return this.verifyHex(t4, e3, this.pubKeyHex);
            }, this.verifyHex = function(t4, e3, r3) {
              try {
                var s3, a3, u3 = o2.parseSigHex(e3);
                s3 = u3.r, a3 = u3.s;
                var c3 = i2.decodeFromHex(this.ecparams.curve, r3), h3 = new n2(t4.substring(0, this.ecparams.keylen / 4), 16);
                return this.verifyRaw(h3, s3, a3, c3);
              } catch (t5) {
                return false;
              }
            }, this.verify = function(t4, e3, o3) {
              var s3, a3, u3;
              if (Bitcoin.Util.isArray(e3)) {
                var c3 = this.parseSig(e3);
                s3 = c3.r, a3 = c3.s;
              } else {
                if ("object" !== (void 0 === e3 ? "undefined" : r2(e3)) || !e3.r || !e3.s)
                  throw "Invalid value for signature";
                s3 = e3.r, a3 = e3.s;
              }
              if (o3 instanceof Ke)
                u3 = o3;
              else {
                if (!Bitcoin.Util.isArray(o3))
                  throw "Invalid format for pubkey value, must be byte array or ECPointFp";
                u3 = i2.decodeFrom(this.ecparams.curve, o3);
              }
              var h3 = n2.fromByteArrayUnsigned(t4);
              return this.verifyRaw(h3, s3, a3, u3);
            }, this.verifyRaw = function(t4, e3, r3, i3) {
              var o3 = this.ecparams.n, s3 = this.ecparams.G;
              if (e3.compareTo(n2.ONE) < 0 || e3.compareTo(o3) >= 0)
                return false;
              if (r3.compareTo(n2.ONE) < 0 || r3.compareTo(o3) >= 0)
                return false;
              var a3 = r3.modInverse(o3), u3 = t4.multiply(a3).mod(o3), c3 = e3.multiply(a3).mod(o3);
              return s3.multiply(u3).add(i3.multiply(c3)).getX().toBigInteger().mod(o3).equals(e3);
            }, this.serializeSig = function(t4, e3) {
              var r3 = t4.toByteArraySigned(), n3 = e3.toByteArraySigned(), i3 = [];
              return i3.push(2), i3.push(r3.length), (i3 = i3.concat(r3)).push(2), i3.push(n3.length), (i3 = i3.concat(n3)).unshift(i3.length), i3.unshift(48), i3;
            }, this.parseSig = function(t4) {
              var e3;
              if (48 != t4[0])
                throw new Error("Signature not a valid DERSequence");
              if (2 != t4[e3 = 2])
                throw new Error("First element in signature must be a DERInteger");
              var r3 = t4.slice(e3 + 2, e3 + 2 + t4[e3 + 1]);
              if (2 != t4[e3 += 2 + t4[e3 + 1]])
                throw new Error("Second element in signature must be a DERInteger");
              var i3 = t4.slice(e3 + 2, e3 + 2 + t4[e3 + 1]);
              return e3 += 2 + t4[e3 + 1], { r: n2.fromByteArrayUnsigned(r3), s: n2.fromByteArrayUnsigned(i3) };
            }, this.parseSigCompact = function(t4) {
              if (65 !== t4.length)
                throw "Signature has the wrong length";
              var e3 = t4[0] - 27;
              if (e3 < 0 || e3 > 7)
                throw "Invalid signature type";
              var r3 = this.ecparams.n;
              return { r: n2.fromByteArrayUnsigned(t4.slice(1, 33)).mod(r3), s: n2.fromByteArrayUnsigned(t4.slice(33, 65)).mod(r3), i: e3 };
            }, this.readPKCS5PrvKeyHex = function(t4) {
              if (false === h2(t4))
                throw new Error("not ASN.1 hex string");
              var e3, r3, n3;
              try {
                e3 = c2(t4, 0, ["[0]", 0], "06"), r3 = c2(t4, 0, [1], "04");
                try {
                  n3 = c2(t4, 0, ["[1]", 0], "03");
                } catch (t5) {
                }
              } catch (t5) {
                throw new Error("malformed PKCS#1/5 plain ECC private key");
              }
              if (this.curveName = a2(e3), void 0 === this.curveName)
                throw "unsupported curve name";
              this.setNamedCurve(this.curveName), this.setPublicKeyHex(n3), this.setPrivateKeyHex(r3), this.isPublic = false;
            }, this.readPKCS8PrvKeyHex = function(t4) {
              if (false === h2(t4))
                throw new e2("not ASN.1 hex string");
              var r3, n3, i3;
              try {
                c2(t4, 0, [1, 0], "06"), r3 = c2(t4, 0, [1, 1], "06"), n3 = c2(t4, 0, [2, 0, 1], "04");
                try {
                  i3 = c2(t4, 0, [2, 0, "[1]", 0], "03");
                } catch (t5) {
                }
              } catch (t5) {
                throw new e2("malformed PKCS#8 plain ECC private key");
              }
              if (this.curveName = a2(r3), void 0 === this.curveName)
                throw new e2("unsupported curve name");
              this.setNamedCurve(this.curveName), this.setPublicKeyHex(i3), this.setPrivateKeyHex(n3), this.isPublic = false;
            }, this.readPKCS8PubKeyHex = function(t4) {
              if (false === h2(t4))
                throw new e2("not ASN.1 hex string");
              var r3, n3;
              try {
                c2(t4, 0, [0, 0], "06"), r3 = c2(t4, 0, [0, 1], "06"), n3 = c2(t4, 0, [1], "03");
              } catch (t5) {
                throw new e2("malformed PKCS#8 ECC public key");
              }
              if (this.curveName = a2(r3), null === this.curveName)
                throw new e2("unsupported curve name");
              this.setNamedCurve(this.curveName), this.setPublicKeyHex(n3);
            }, this.readCertPubKeyHex = function(t4, r3) {
              if (false === h2(t4))
                throw new e2("not ASN.1 hex string");
              var n3, i3;
              try {
                n3 = c2(t4, 0, [0, 5, 0, 1], "06"), i3 = c2(t4, 0, [0, 5, 1], "03");
              } catch (t5) {
                throw new e2("malformed X.509 certificate ECC public key");
              }
              if (this.curveName = a2(n3), null === this.curveName)
                throw new e2("unsupported curve name");
              this.setNamedCurve(this.curveName), this.setPublicKeyHex(i3);
            }, void 0 !== t3 && void 0 !== t3.curve && (this.curveName = t3.curve), void 0 === this.curveName && (this.curveName = "secp256r1"), this.setNamedCurve(this.curveName), void 0 !== t3 && (void 0 !== t3.prv && this.setPrivateKeyHex(t3.prv), void 0 !== t3.pub && this.setPublicKeyHex(t3.pub));
          }, br.crypto.ECDSA.parseSigHex = function(t3) {
            var e2 = br.crypto.ECDSA.parseSigHexInHexRS(t3);
            return { r: new F(e2.r, 16), s: new F(e2.s, 16) };
          }, br.crypto.ECDSA.parseSigHexInHexRS = function(t3) {
            var e2 = Er, r3 = e2.getChildIdx, n2 = e2.getV;
            if (e2.checkStrictDER(t3, 0), "30" != t3.substr(0, 2))
              throw new Error("signature is not a ASN.1 sequence");
            var i2 = r3(t3, 0);
            if (2 != i2.length)
              throw new Error("signature shall have two elements");
            var o2 = i2[0], s2 = i2[1];
            if ("02" != t3.substr(o2, 2))
              throw new Error("1st item not ASN.1 integer");
            if ("02" != t3.substr(s2, 2))
              throw new Error("2nd item not ASN.1 integer");
            return { r: n2(t3, o2), s: n2(t3, s2) };
          }, br.crypto.ECDSA.asn1SigToConcatSig = function(t3) {
            var e2 = br.crypto.ECDSA.parseSigHexInHexRS(t3), r3 = e2.r, n2 = e2.s;
            if ("00" == r3.substr(0, 2) && r3.length % 32 == 2 && (r3 = r3.substr(2)), "00" == n2.substr(0, 2) && n2.length % 32 == 2 && (n2 = n2.substr(2)), r3.length % 32 == 30 && (r3 = "00" + r3), n2.length % 32 == 30 && (n2 = "00" + n2), r3.length % 32 != 0)
              throw "unknown ECDSA sig r length error";
            if (n2.length % 32 != 0)
              throw "unknown ECDSA sig s length error";
            return r3 + n2;
          }, br.crypto.ECDSA.concatSigToASN1Sig = function(t3) {
            if (t3.length / 2 * 8 % 128 != 0)
              throw "unknown ECDSA concatinated r-s sig  length error";
            var e2 = t3.substr(0, t3.length / 2), r3 = t3.substr(t3.length / 2);
            return br.crypto.ECDSA.hexRSSigToASN1Sig(e2, r3);
          }, br.crypto.ECDSA.hexRSSigToASN1Sig = function(t3, e2) {
            var r3 = new F(t3, 16), n2 = new F(e2, 16);
            return br.crypto.ECDSA.biRSSigToASN1Sig(r3, n2);
          }, br.crypto.ECDSA.biRSSigToASN1Sig = function(t3, e2) {
            var r3 = br.asn1, n2 = new r3.DERInteger({ bigint: t3 }), i2 = new r3.DERInteger({ bigint: e2 });
            return new r3.DERSequence({ array: [n2, i2] }).getEncodedHex();
          }, br.crypto.ECDSA.getName = function(t3) {
            return "2b8104001f" === t3 ? "secp192k1" : "2a8648ce3d030107" === t3 ? "secp256r1" : "2b8104000a" === t3 ? "secp256k1" : "2b81040021" === t3 ? "secp224r1" : "2b81040022" === t3 ? "secp384r1" : -1 !== "|secp256r1|NIST P-256|P-256|prime256v1|".indexOf(t3) ? "secp256r1" : -1 !== "|secp256k1|".indexOf(t3) ? "secp256k1" : -1 !== "|secp224r1|NIST P-224|P-224|".indexOf(t3) ? "secp224r1" : -1 !== "|secp384r1|NIST P-384|P-384|".indexOf(t3) ? "secp384r1" : null;
          }, void 0 !== br && br || (e.KJUR = br = {}), void 0 !== br.crypto && br.crypto || (br.crypto = {}), br.crypto.ECParameterDB = new function() {
            var t3 = {}, e2 = {};
            function r3(t4) {
              return new F(t4, 16);
            }
            this.getByName = function(r4) {
              var n2 = r4;
              if (void 0 !== e2[n2] && (n2 = e2[r4]), void 0 !== t3[n2])
                return t3[n2];
              throw "unregistered EC curve name: " + n2;
            }, this.regist = function(n2, i2, o2, s2, a2, u2, c2, h2, l2, f2, g2, d2) {
              t3[n2] = {};
              var p2 = r3(o2), v2 = r3(s2), y2 = r3(a2), m2 = r3(u2), _2 = r3(c2), S2 = new qe(p2, v2, y2), b2 = S2.decodePointHex("04" + h2 + l2);
              t3[n2].name = n2, t3[n2].keylen = i2, t3[n2].curve = S2, t3[n2].G = b2, t3[n2].n = m2, t3[n2].h = _2, t3[n2].oid = g2, t3[n2].info = d2;
              for (var w2 = 0; w2 < f2.length; w2++)
                e2[f2[w2]] = n2;
            };
          }(), br.crypto.ECParameterDB.regist("secp128r1", 128, "FFFFFFFDFFFFFFFFFFFFFFFFFFFFFFFF", "FFFFFFFDFFFFFFFFFFFFFFFFFFFFFFFC", "E87579C11079F43DD824993C2CEE5ED3", "FFFFFFFE0000000075A30D1B9038A115", "1", "161FF7528B899B2D0C28607CA52C5B86", "CF5AC8395BAFEB13C02DA292DDED7A83", [], "", "secp128r1 : SECG curve over a 128 bit prime field"), br.crypto.ECParameterDB.regist("secp160k1", 160, "FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFAC73", "0", "7", "0100000000000000000001B8FA16DFAB9ACA16B6B3", "1", "3B4C382CE37AA192A4019E763036F4F5DD4D7EBB", "938CF935318FDCED6BC28286531733C3F03C4FEE", [], "", "secp160k1 : SECG curve over a 160 bit prime field"), br.crypto.ECParameterDB.regist("secp160r1", 160, "FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF7FFFFFFF", "FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF7FFFFFFC", "1C97BEFC54BD7A8B65ACF89F81D4D4ADC565FA45", "0100000000000000000001F4C8F927AED3CA752257", "1", "4A96B5688EF573284664698968C38BB913CBFC82", "23A628553168947D59DCC912042351377AC5FB32", [], "", "secp160r1 : SECG curve over a 160 bit prime field"), br.crypto.ECParameterDB.regist("secp192k1", 192, "FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFEE37", "0", "3", "FFFFFFFFFFFFFFFFFFFFFFFE26F2FC170F69466A74DEFD8D", "1", "DB4FF10EC057E9AE26B07D0280B7F4341DA5D1B1EAE06C7D", "9B2F2F6D9C5628A7844163D015BE86344082AA88D95E2F9D", []), br.crypto.ECParameterDB.regist("secp192r1", 192, "FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFFFFFFFFFFFFF", "FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFFFFFFFFFFFFC", "64210519E59C80E70FA7E9AB72243049FEB8DEECC146B9B1", "FFFFFFFFFFFFFFFFFFFFFFFF99DEF836146BC9B1B4D22831", "1", "188DA80EB03090F67CBF20EB43A18800F4FF0AFD82FF1012", "07192B95FFC8DA78631011ED6B24CDD573F977A11E794811", []), br.crypto.ECParameterDB.regist("secp224r1", 224, "FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF000000000000000000000001", "FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFFFFFFFFFFFFFFFFFFFFE", "B4050A850C04B3ABF54132565044B0B7D7BFD8BA270B39432355FFB4", "FFFFFFFFFFFFFFFFFFFFFFFFFFFF16A2E0B8F03E13DD29455C5C2A3D", "1", "B70E0CBD6BB4BF7F321390B94A03C1D356C21122343280D6115C1D21", "BD376388B5F723FB4C22DFE6CD4375A05A07476444D5819985007E34", []), br.crypto.ECParameterDB.regist("secp256k1", 256, "FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFFC2F", "0", "7", "FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEBAAEDCE6AF48A03BBFD25E8CD0364141", "1", "79BE667EF9DCBBAC55A06295CE870B07029BFCDB2DCE28D959F2815B16F81798", "483ADA7726A3C4655DA4FBFC0E1108A8FD17B448A68554199C47D08FFB10D4B8", []), br.crypto.ECParameterDB.regist("secp256r1", 256, "FFFFFFFF00000001000000000000000000000000FFFFFFFFFFFFFFFFFFFFFFFF", "FFFFFFFF00000001000000000000000000000000FFFFFFFFFFFFFFFFFFFFFFFC", "5AC635D8AA3A93E7B3EBBD55769886BC651D06B0CC53B0F63BCE3C3E27D2604B", "FFFFFFFF00000000FFFFFFFFFFFFFFFFBCE6FAADA7179E84F3B9CAC2FC632551", "1", "6B17D1F2E12C4247F8BCE6E563A440F277037D812DEB33A0F4A13945D898C296", "4FE342E2FE1A7F9B8EE7EB4A7C0F9E162BCE33576B315ECECBB6406837BF51F5", ["NIST P-256", "P-256", "prime256v1"]), br.crypto.ECParameterDB.regist("secp384r1", 384, "FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFFFFF0000000000000000FFFFFFFF", "FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFFFFF0000000000000000FFFFFFFC", "B3312FA7E23EE7E4988E056BE3F82D19181D9C6EFE8141120314088F5013875AC656398D8A2ED19D2A85C8EDD3EC2AEF", "FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFC7634D81F4372DDF581A0DB248B0A77AECEC196ACCC52973", "1", "AA87CA22BE8B05378EB1C71EF320AD746E1D3B628BA79B9859F741E082542A385502F25DBF55296C3A545E3872760AB7", "3617de4a96262c6f5d9e98bf9292dc29f8f41dbd289a147ce9da3113b5f0b8c00a60b1ce1d7e819d7a431d7c90ea0e5f", ["NIST P-384", "P-384"]), br.crypto.ECParameterDB.regist("secp521r1", 521, "1FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF", "1FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFC", "051953EB9618E1C9A1F929A21A0B68540EEA2DA725B99B315F3B8B489918EF109E156193951EC7E937B1652C0BD3BB1BF073573DF883D2C34F1EF451FD46B503F00", "1FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFA51868783BF2F966B7FCC0148F709A5D03BB5C9B8899C47AEBB6FB71E91386409", "1", "C6858E06B70404E9CD9E3ECB662395B4429C648139053FB521F828AF606B4D3DBAA14B5E77EFE75928FE1DC127A2FFA8DE3348B3C1856A429BF97E7E31C2E5BD66", "011839296a789a3bc0045c8a5fb42c7d1bd998f54449579b446817afbd17273e662c97ee72995ef42640c550b9013fad0761353c7086a272c24088be94769fd16650", ["NIST P-521", "P-521"]);
          var Zr = function() {
            var t3 = function t4(r4, n3, i3) {
              return e2(y.AES, r4, n3, i3);
            }, e2 = function t4(e3, r4, n3, i3) {
              var o3 = y.enc.Hex.parse(r4), s3 = y.enc.Hex.parse(n3), a3 = y.enc.Hex.parse(i3), u2 = {};
              u2.key = s3, u2.iv = a3, u2.ciphertext = o3;
              var c2 = e3.decrypt(u2, s3, { iv: a3 });
              return y.enc.Hex.stringify(c2);
            }, r3 = function t4(e3, r4, i3) {
              return n2(y.AES, e3, r4, i3);
            }, n2 = function t4(e3, r4, n3, i3) {
              var o3 = y.enc.Hex.parse(r4), s3 = y.enc.Hex.parse(n3), a3 = y.enc.Hex.parse(i3), u2 = e3.encrypt(o3, s3, { iv: a3 }), c2 = y.enc.Hex.parse(u2.toString());
              return y.enc.Base64.stringify(c2);
            }, i2 = { "AES-256-CBC": { proc: t3, eproc: r3, keylen: 32, ivlen: 16 }, "AES-192-CBC": { proc: t3, eproc: r3, keylen: 24, ivlen: 16 }, "AES-128-CBC": { proc: t3, eproc: r3, keylen: 16, ivlen: 16 }, "DES-EDE3-CBC": { proc: function t4(r4, n3, i3) {
              return e2(y.TripleDES, r4, n3, i3);
            }, eproc: function t4(e3, r4, i3) {
              return n2(y.TripleDES, e3, r4, i3);
            }, keylen: 24, ivlen: 8 }, "DES-CBC": { proc: function t4(r4, n3, i3) {
              return e2(y.DES, r4, n3, i3);
            }, eproc: function t4(e3, r4, i3) {
              return n2(y.DES, e3, r4, i3);
            }, keylen: 8, ivlen: 8 } }, o2 = function t4(e3) {
              var r4 = {}, n3 = e3.match(new RegExp("DEK-Info: ([^,]+),([0-9A-Fa-f]+)", "m"));
              n3 && (r4.cipher = n3[1], r4.ivsalt = n3[2]);
              var i3 = e3.match(new RegExp("-----BEGIN ([A-Z]+) PRIVATE KEY-----"));
              i3 && (r4.type = i3[1]);
              var o3 = -1, s3 = 0;
              -1 != e3.indexOf("\r\n\r\n") && (o3 = e3.indexOf("\r\n\r\n"), s3 = 2), -1 != e3.indexOf("\n\n") && (o3 = e3.indexOf("\n\n"), s3 = 1);
              var a3 = e3.indexOf("-----END");
              if (-1 != o3 && -1 != a3) {
                var u2 = e3.substring(o3 + 2 * s3, a3 - s3);
                u2 = u2.replace(/\s+/g, ""), r4.data = u2;
              }
              return r4;
            }, s2 = function t4(e3, r4, n3) {
              for (var o3 = n3.substring(0, 16), s3 = y.enc.Hex.parse(o3), a3 = y.enc.Utf8.parse(r4), u2 = i2[e3].keylen + i2[e3].ivlen, c2 = "", h2 = null; ; ) {
                var l2 = y.algo.MD5.create();
                if (null != h2 && l2.update(h2), l2.update(a3), l2.update(s3), h2 = l2.finalize(), (c2 += y.enc.Hex.stringify(h2)).length >= 2 * u2)
                  break;
              }
              var f2 = {};
              return f2.keyhex = c2.substr(0, 2 * i2[e3].keylen), f2.ivhex = c2.substr(2 * i2[e3].keylen, 2 * i2[e3].ivlen), f2;
            }, a2 = function t4(e3, r4, n3, o3) {
              var s3 = y.enc.Base64.parse(e3), a3 = y.enc.Hex.stringify(s3);
              return (0, i2[r4].proc)(a3, n3, o3);
            };
            return { version: "1.0.0", parsePKCS5PEM: function t4(e3) {
              return o2(e3);
            }, getKeyAndUnusedIvByPasscodeAndIvsalt: function t4(e3, r4, n3) {
              return s2(e3, r4, n3);
            }, decryptKeyB64: function t4(e3, r4, n3, i3) {
              return a2(e3, r4, n3, i3);
            }, getDecryptedKeyHex: function t4(e3, r4) {
              var n3 = o2(e3), i3 = (n3.type, n3.cipher), u2 = n3.ivsalt, c2 = n3.data, h2 = s2(i3, r4, u2).keyhex;
              return a2(c2, i3, h2, u2);
            }, getEncryptedPKCS5PEMFromPrvKeyHex: function t4(e3, r4, n3, o3, a3) {
              var u2 = "";
              if (void 0 !== o3 && null != o3 || (o3 = "AES-256-CBC"), void 0 === i2[o3])
                throw "KEYUTIL unsupported algorithm: " + o3;
              void 0 !== a3 && null != a3 || (a3 = function t5(e4) {
                var r5 = y.lib.WordArray.random(e4);
                return y.enc.Hex.stringify(r5);
              }(i2[o3].ivlen).toUpperCase());
              var c2 = function t5(e4, r5, n4, o4) {
                return (0, i2[r5].eproc)(e4, n4, o4);
              }(r4, o3, s2(o3, n3, a3).keyhex, a3);
              u2 = "-----BEGIN " + e3 + " PRIVATE KEY-----\r\n";
              return u2 += "Proc-Type: 4,ENCRYPTED\r\n", u2 += "DEK-Info: " + o3 + "," + a3 + "\r\n", u2 += "\r\n", u2 += c2.replace(/(.{64})/g, "$1\r\n"), u2 += "\r\n-----END " + e3 + " PRIVATE KEY-----\r\n";
            }, parseHexOfEncryptedPKCS8: function t4(e3) {
              var r4 = Er, n3 = r4.getChildIdx, i3 = r4.getV, o3 = {}, s3 = n3(e3, 0);
              if (2 != s3.length)
                throw "malformed format: SEQUENCE(0).items != 2: " + s3.length;
              o3.ciphertext = i3(e3, s3[1]);
              var a3 = n3(e3, s3[0]);
              if (2 != a3.length)
                throw "malformed format: SEQUENCE(0.0).items != 2: " + a3.length;
              if ("2a864886f70d01050d" != i3(e3, a3[0]))
                throw "this only supports pkcs5PBES2";
              var u2 = n3(e3, a3[1]);
              if (2 != a3.length)
                throw "malformed format: SEQUENCE(0.0.1).items != 2: " + u2.length;
              var c2 = n3(e3, u2[1]);
              if (2 != c2.length)
                throw "malformed format: SEQUENCE(0.0.1.1).items != 2: " + c2.length;
              if ("2a864886f70d0307" != i3(e3, c2[0]))
                throw "this only supports TripleDES";
              o3.encryptionSchemeAlg = "TripleDES", o3.encryptionSchemeIV = i3(e3, c2[1]);
              var h2 = n3(e3, u2[0]);
              if (2 != h2.length)
                throw "malformed format: SEQUENCE(0.0.1.0).items != 2: " + h2.length;
              if ("2a864886f70d01050c" != i3(e3, h2[0]))
                throw "this only supports pkcs5PBKDF2";
              var l2 = n3(e3, h2[1]);
              if (l2.length < 2)
                throw "malformed format: SEQUENCE(0.0.1.0.1).items < 2: " + l2.length;
              o3.pbkdf2Salt = i3(e3, l2[0]);
              var f2 = i3(e3, l2[1]);
              try {
                o3.pbkdf2Iter = parseInt(f2, 16);
              } catch (t5) {
                throw "malformed format pbkdf2Iter: " + f2;
              }
              return o3;
            }, getPBKDF2KeyHexFromParam: function t4(e3, r4) {
              var n3 = y.enc.Hex.parse(e3.pbkdf2Salt), i3 = e3.pbkdf2Iter, o3 = y.PBKDF2(r4, n3, { keySize: 6, iterations: i3 });
              return y.enc.Hex.stringify(o3);
            }, _getPlainPKCS8HexFromEncryptedPKCS8PEM: function t4(e3, r4) {
              var n3 = Hr(e3, "ENCRYPTED PRIVATE KEY"), i3 = this.parseHexOfEncryptedPKCS8(n3), o3 = Zr.getPBKDF2KeyHexFromParam(i3, r4), s3 = {};
              s3.ciphertext = y.enc.Hex.parse(i3.ciphertext);
              var a3 = y.enc.Hex.parse(o3), u2 = y.enc.Hex.parse(i3.encryptionSchemeIV), c2 = y.TripleDES.decrypt(s3, a3, { iv: u2 });
              return y.enc.Hex.stringify(c2);
            }, getKeyFromEncryptedPKCS8PEM: function t4(e3, r4) {
              var n3 = this._getPlainPKCS8HexFromEncryptedPKCS8PEM(e3, r4);
              return this.getKeyFromPlainPrivatePKCS8Hex(n3);
            }, parsePlainPrivatePKCS8Hex: function t4(e3) {
              var r4 = Er, n3 = r4.getChildIdx, i3 = r4.getV, o3 = { algparam: null };
              if ("30" != e3.substr(0, 2))
                throw "malformed plain PKCS8 private key(code:001)";
              var s3 = n3(e3, 0);
              if (3 != s3.length)
                throw "malformed plain PKCS8 private key(code:002)";
              if ("30" != e3.substr(s3[1], 2))
                throw "malformed PKCS8 private key(code:003)";
              var a3 = n3(e3, s3[1]);
              if (2 != a3.length)
                throw "malformed PKCS8 private key(code:004)";
              if ("06" != e3.substr(a3[0], 2))
                throw "malformed PKCS8 private key(code:005)";
              if (o3.algoid = i3(e3, a3[0]), "06" == e3.substr(a3[1], 2) && (o3.algparam = i3(e3, a3[1])), "04" != e3.substr(s3[2], 2))
                throw "malformed PKCS8 private key(code:006)";
              return o3.keyidx = r4.getVidx(e3, s3[2]), o3;
            }, getKeyFromPlainPrivatePKCS8PEM: function t4(e3) {
              var r4 = Hr(e3, "PRIVATE KEY");
              return this.getKeyFromPlainPrivatePKCS8Hex(r4);
            }, getKeyFromPlainPrivatePKCS8Hex: function t4(e3) {
              var r4, n3 = this.parsePlainPrivatePKCS8Hex(e3);
              if ("2a864886f70d010101" == n3.algoid)
                r4 = new He();
              else if ("2a8648ce380401" == n3.algoid)
                r4 = new br.crypto.DSA();
              else {
                if ("2a8648ce3d0201" != n3.algoid)
                  throw "unsupported private key algorithm";
                r4 = new br.crypto.ECDSA();
              }
              return r4.readPKCS8PrvKeyHex(e3), r4;
            }, _getKeyFromPublicPKCS8Hex: function t4(e3) {
              var r4, n3 = Er.getVbyList(e3, 0, [0, 0], "06");
              if ("2a864886f70d010101" === n3)
                r4 = new He();
              else if ("2a8648ce380401" === n3)
                r4 = new br.crypto.DSA();
              else {
                if ("2a8648ce3d0201" !== n3)
                  throw "unsupported PKCS#8 public key hex";
                r4 = new br.crypto.ECDSA();
              }
              return r4.readPKCS8PubKeyHex(e3), r4;
            }, parsePublicRawRSAKeyHex: function t4(e3) {
              var r4 = Er, n3 = r4.getChildIdx, i3 = r4.getV, o3 = {};
              if ("30" != e3.substr(0, 2))
                throw "malformed RSA key(code:001)";
              var s3 = n3(e3, 0);
              if (2 != s3.length)
                throw "malformed RSA key(code:002)";
              if ("02" != e3.substr(s3[0], 2))
                throw "malformed RSA key(code:003)";
              if (o3.n = i3(e3, s3[0]), "02" != e3.substr(s3[1], 2))
                throw "malformed RSA key(code:004)";
              return o3.e = i3(e3, s3[1]), o3;
            }, parsePublicPKCS8Hex: function t4(e3) {
              var r4 = Er, n3 = r4.getChildIdx, i3 = r4.getV, o3 = { algparam: null }, s3 = n3(e3, 0);
              if (2 != s3.length)
                throw "outer DERSequence shall have 2 elements: " + s3.length;
              var a3 = s3[0];
              if ("30" != e3.substr(a3, 2))
                throw "malformed PKCS8 public key(code:001)";
              var u2 = n3(e3, a3);
              if (2 != u2.length)
                throw "malformed PKCS8 public key(code:002)";
              if ("06" != e3.substr(u2[0], 2))
                throw "malformed PKCS8 public key(code:003)";
              if (o3.algoid = i3(e3, u2[0]), "06" == e3.substr(u2[1], 2) ? o3.algparam = i3(e3, u2[1]) : "30" == e3.substr(u2[1], 2) && (o3.algparam = {}, o3.algparam.p = r4.getVbyList(e3, u2[1], [0], "02"), o3.algparam.q = r4.getVbyList(e3, u2[1], [1], "02"), o3.algparam.g = r4.getVbyList(e3, u2[1], [2], "02")), "03" != e3.substr(s3[1], 2))
                throw "malformed PKCS8 public key(code:004)";
              return o3.key = i3(e3, s3[1]).substr(2), o3;
            } };
          }();
          Zr.getKey = function(t3, e2, r3) {
            var n2 = (v2 = Er).getChildIdx, i2 = (v2.getV, v2.getVbyList), o2 = br.crypto, s2 = o2.ECDSA, a2 = o2.DSA, u2 = He, c2 = Hr, h2 = Zr;
            if (void 0 !== u2 && t3 instanceof u2)
              return t3;
            if (void 0 !== s2 && t3 instanceof s2)
              return t3;
            if (void 0 !== a2 && t3 instanceof a2)
              return t3;
            if (void 0 !== t3.curve && void 0 !== t3.xy && void 0 === t3.d)
              return new s2({ pub: t3.xy, curve: t3.curve });
            if (void 0 !== t3.curve && void 0 !== t3.d)
              return new s2({ prv: t3.d, curve: t3.curve });
            if (void 0 === t3.kty && void 0 !== t3.n && void 0 !== t3.e && void 0 === t3.d)
              return (P2 = new u2()).setPublic(t3.n, t3.e), P2;
            if (void 0 === t3.kty && void 0 !== t3.n && void 0 !== t3.e && void 0 !== t3.d && void 0 !== t3.p && void 0 !== t3.q && void 0 !== t3.dp && void 0 !== t3.dq && void 0 !== t3.co && void 0 === t3.qi)
              return (P2 = new u2()).setPrivateEx(t3.n, t3.e, t3.d, t3.p, t3.q, t3.dp, t3.dq, t3.co), P2;
            if (void 0 === t3.kty && void 0 !== t3.n && void 0 !== t3.e && void 0 !== t3.d && void 0 === t3.p)
              return (P2 = new u2()).setPrivate(t3.n, t3.e, t3.d), P2;
            if (void 0 !== t3.p && void 0 !== t3.q && void 0 !== t3.g && void 0 !== t3.y && void 0 === t3.x)
              return (P2 = new a2()).setPublic(t3.p, t3.q, t3.g, t3.y), P2;
            if (void 0 !== t3.p && void 0 !== t3.q && void 0 !== t3.g && void 0 !== t3.y && void 0 !== t3.x)
              return (P2 = new a2()).setPrivate(t3.p, t3.q, t3.g, t3.y, t3.x), P2;
            if ("RSA" === t3.kty && void 0 !== t3.n && void 0 !== t3.e && void 0 === t3.d)
              return (P2 = new u2()).setPublic(Ir(t3.n), Ir(t3.e)), P2;
            if ("RSA" === t3.kty && void 0 !== t3.n && void 0 !== t3.e && void 0 !== t3.d && void 0 !== t3.p && void 0 !== t3.q && void 0 !== t3.dp && void 0 !== t3.dq && void 0 !== t3.qi)
              return (P2 = new u2()).setPrivateEx(Ir(t3.n), Ir(t3.e), Ir(t3.d), Ir(t3.p), Ir(t3.q), Ir(t3.dp), Ir(t3.dq), Ir(t3.qi)), P2;
            if ("RSA" === t3.kty && void 0 !== t3.n && void 0 !== t3.e && void 0 !== t3.d)
              return (P2 = new u2()).setPrivate(Ir(t3.n), Ir(t3.e), Ir(t3.d)), P2;
            if ("EC" === t3.kty && void 0 !== t3.crv && void 0 !== t3.x && void 0 !== t3.y && void 0 === t3.d) {
              var l2 = (k = new s2({ curve: t3.crv })).ecparams.keylen / 4, f2 = "04" + ("0000000000" + Ir(t3.x)).slice(-l2) + ("0000000000" + Ir(t3.y)).slice(-l2);
              return k.setPublicKeyHex(f2), k;
            }
            if ("EC" === t3.kty && void 0 !== t3.crv && void 0 !== t3.x && void 0 !== t3.y && void 0 !== t3.d) {
              l2 = (k = new s2({ curve: t3.crv })).ecparams.keylen / 4, f2 = "04" + ("0000000000" + Ir(t3.x)).slice(-l2) + ("0000000000" + Ir(t3.y)).slice(-l2);
              var g2 = ("0000000000" + Ir(t3.d)).slice(-l2);
              return k.setPublicKeyHex(f2), k.setPrivateKeyHex(g2), k;
            }
            if ("pkcs5prv" === r3) {
              var d2, p2 = t3, v2 = Er;
              if (9 === (d2 = n2(p2, 0)).length)
                (P2 = new u2()).readPKCS5PrvKeyHex(p2);
              else if (6 === d2.length)
                (P2 = new a2()).readPKCS5PrvKeyHex(p2);
              else {
                if (!(d2.length > 2 && "04" === p2.substr(d2[1], 2)))
                  throw "unsupported PKCS#1/5 hexadecimal key";
                (P2 = new s2()).readPKCS5PrvKeyHex(p2);
              }
              return P2;
            }
            if ("pkcs8prv" === r3)
              return P2 = h2.getKeyFromPlainPrivatePKCS8Hex(t3);
            if ("pkcs8pub" === r3)
              return h2._getKeyFromPublicPKCS8Hex(t3);
            if ("x509pub" === r3)
              return on.getPublicKeyFromCertHex(t3);
            if (-1 != t3.indexOf("-END CERTIFICATE-", 0) || -1 != t3.indexOf("-END X509 CERTIFICATE-", 0) || -1 != t3.indexOf("-END TRUSTED CERTIFICATE-", 0))
              return on.getPublicKeyFromCertPEM(t3);
            if (-1 != t3.indexOf("-END PUBLIC KEY-")) {
              var y2 = Hr(t3, "PUBLIC KEY");
              return h2._getKeyFromPublicPKCS8Hex(y2);
            }
            if (-1 != t3.indexOf("-END RSA PRIVATE KEY-") && -1 == t3.indexOf("4,ENCRYPTED")) {
              var m2 = c2(t3, "RSA PRIVATE KEY");
              return h2.getKey(m2, null, "pkcs5prv");
            }
            if (-1 != t3.indexOf("-END DSA PRIVATE KEY-") && -1 == t3.indexOf("4,ENCRYPTED")) {
              var _2 = i2(R2 = c2(t3, "DSA PRIVATE KEY"), 0, [1], "02"), S2 = i2(R2, 0, [2], "02"), b2 = i2(R2, 0, [3], "02"), w2 = i2(R2, 0, [4], "02"), E2 = i2(R2, 0, [5], "02");
              return (P2 = new a2()).setPrivate(new F(_2, 16), new F(S2, 16), new F(b2, 16), new F(w2, 16), new F(E2, 16)), P2;
            }
            if (-1 != t3.indexOf("-END EC PRIVATE KEY-") && -1 == t3.indexOf("4,ENCRYPTED")) {
              m2 = c2(t3, "EC PRIVATE KEY");
              return h2.getKey(m2, null, "pkcs5prv");
            }
            if (-1 != t3.indexOf("-END PRIVATE KEY-"))
              return h2.getKeyFromPlainPrivatePKCS8PEM(t3);
            if (-1 != t3.indexOf("-END RSA PRIVATE KEY-") && -1 != t3.indexOf("4,ENCRYPTED")) {
              var x = h2.getDecryptedKeyHex(t3, e2), A = new He();
              return A.readPKCS5PrvKeyHex(x), A;
            }
            if (-1 != t3.indexOf("-END EC PRIVATE KEY-") && -1 != t3.indexOf("4,ENCRYPTED")) {
              var k, P2 = i2(R2 = h2.getDecryptedKeyHex(t3, e2), 0, [1], "04"), C2 = i2(R2, 0, [2, 0], "06"), T2 = i2(R2, 0, [3, 0], "03").substr(2);
              if (void 0 === br.crypto.OID.oidhex2name[C2])
                throw "undefined OID(hex) in KJUR.crypto.OID: " + C2;
              return (k = new s2({ curve: br.crypto.OID.oidhex2name[C2] })).setPublicKeyHex(T2), k.setPrivateKeyHex(P2), k.isPublic = false, k;
            }
            if (-1 != t3.indexOf("-END DSA PRIVATE KEY-") && -1 != t3.indexOf("4,ENCRYPTED")) {
              var R2;
              _2 = i2(R2 = h2.getDecryptedKeyHex(t3, e2), 0, [1], "02"), S2 = i2(R2, 0, [2], "02"), b2 = i2(R2, 0, [3], "02"), w2 = i2(R2, 0, [4], "02"), E2 = i2(R2, 0, [5], "02");
              return (P2 = new a2()).setPrivate(new F(_2, 16), new F(S2, 16), new F(b2, 16), new F(w2, 16), new F(E2, 16)), P2;
            }
            if (-1 != t3.indexOf("-END ENCRYPTED PRIVATE KEY-"))
              return h2.getKeyFromEncryptedPKCS8PEM(t3, e2);
            throw new Error("not supported argument");
          }, Zr.generateKeypair = function(t3, e2) {
            if ("RSA" == t3) {
              var r3 = e2;
              (s2 = new He()).generate(r3, "10001"), s2.isPrivate = true, s2.isPublic = true;
              var n2 = new He(), i2 = s2.n.toString(16), o2 = s2.e.toString(16);
              return n2.setPublic(i2, o2), n2.isPrivate = false, n2.isPublic = true, (a2 = {}).prvKeyObj = s2, a2.pubKeyObj = n2, a2;
            }
            if ("EC" == t3) {
              var s2, a2, u2 = e2, c2 = new br.crypto.ECDSA({ curve: u2 }).generateKeyPairHex();
              return (s2 = new br.crypto.ECDSA({ curve: u2 })).setPublicKeyHex(c2.ecpubhex), s2.setPrivateKeyHex(c2.ecprvhex), s2.isPrivate = true, s2.isPublic = false, (n2 = new br.crypto.ECDSA({ curve: u2 })).setPublicKeyHex(c2.ecpubhex), n2.isPrivate = false, n2.isPublic = true, (a2 = {}).prvKeyObj = s2, a2.pubKeyObj = n2, a2;
            }
            throw "unknown algorithm: " + t3;
          }, Zr.getPEM = function(t3, e2, r3, n2, i2, o2) {
            var s2 = br, a2 = s2.asn1, u2 = a2.DERObjectIdentifier, c2 = a2.DERInteger, h2 = a2.ASN1Util.newObject, l2 = a2.x509.SubjectPublicKeyInfo, f2 = s2.crypto, g2 = f2.DSA, d2 = f2.ECDSA, p2 = He;
            function v2(t4) {
              return h2({ seq: [{ int: 0 }, { int: { bigint: t4.n } }, { int: t4.e }, { int: { bigint: t4.d } }, { int: { bigint: t4.p } }, { int: { bigint: t4.q } }, { int: { bigint: t4.dmp1 } }, { int: { bigint: t4.dmq1 } }, { int: { bigint: t4.coeff } }] });
            }
            function m2(t4) {
              return h2({ seq: [{ int: 1 }, { octstr: { hex: t4.prvKeyHex } }, { tag: ["a0", true, { oid: { name: t4.curveName } }] }, { tag: ["a1", true, { bitstr: { hex: "00" + t4.pubKeyHex } }] }] });
            }
            function _2(t4) {
              return h2({ seq: [{ int: 0 }, { int: { bigint: t4.p } }, { int: { bigint: t4.q } }, { int: { bigint: t4.g } }, { int: { bigint: t4.y } }, { int: { bigint: t4.x } }] });
            }
            if ((void 0 !== p2 && t3 instanceof p2 || void 0 !== g2 && t3 instanceof g2 || void 0 !== d2 && t3 instanceof d2) && 1 == t3.isPublic && (void 0 === e2 || "PKCS8PUB" == e2))
              return Mr(F2 = new l2(t3).getEncodedHex(), "PUBLIC KEY");
            if ("PKCS1PRV" == e2 && void 0 !== p2 && t3 instanceof p2 && (void 0 === r3 || null == r3) && 1 == t3.isPrivate)
              return Mr(F2 = v2(t3).getEncodedHex(), "RSA PRIVATE KEY");
            if ("PKCS1PRV" == e2 && void 0 !== d2 && t3 instanceof d2 && (void 0 === r3 || null == r3) && 1 == t3.isPrivate) {
              var S2 = new u2({ name: t3.curveName }).getEncodedHex(), b2 = m2(t3).getEncodedHex(), w2 = "";
              return w2 += Mr(S2, "EC PARAMETERS"), w2 += Mr(b2, "EC PRIVATE KEY");
            }
            if ("PKCS1PRV" == e2 && void 0 !== g2 && t3 instanceof g2 && (void 0 === r3 || null == r3) && 1 == t3.isPrivate)
              return Mr(F2 = _2(t3).getEncodedHex(), "DSA PRIVATE KEY");
            if ("PKCS5PRV" == e2 && void 0 !== p2 && t3 instanceof p2 && void 0 !== r3 && null != r3 && 1 == t3.isPrivate) {
              var F2 = v2(t3).getEncodedHex();
              return void 0 === n2 && (n2 = "DES-EDE3-CBC"), this.getEncryptedPKCS5PEMFromPrvKeyHex("RSA", F2, r3, n2, o2);
            }
            if ("PKCS5PRV" == e2 && void 0 !== d2 && t3 instanceof d2 && void 0 !== r3 && null != r3 && 1 == t3.isPrivate) {
              F2 = m2(t3).getEncodedHex();
              return void 0 === n2 && (n2 = "DES-EDE3-CBC"), this.getEncryptedPKCS5PEMFromPrvKeyHex("EC", F2, r3, n2, o2);
            }
            if ("PKCS5PRV" == e2 && void 0 !== g2 && t3 instanceof g2 && void 0 !== r3 && null != r3 && 1 == t3.isPrivate) {
              F2 = _2(t3).getEncodedHex();
              return void 0 === n2 && (n2 = "DES-EDE3-CBC"), this.getEncryptedPKCS5PEMFromPrvKeyHex("DSA", F2, r3, n2, o2);
            }
            var E2 = function t4(e3, r4) {
              var n3 = x(e3, r4);
              return new h2({ seq: [{ seq: [{ oid: { name: "pkcs5PBES2" } }, { seq: [{ seq: [{ oid: { name: "pkcs5PBKDF2" } }, { seq: [{ octstr: { hex: n3.pbkdf2Salt } }, { int: n3.pbkdf2Iter }] }] }, { seq: [{ oid: { name: "des-EDE3-CBC" } }, { octstr: { hex: n3.encryptionSchemeIV } }] }] }] }, { octstr: { hex: n3.ciphertext } }] }).getEncodedHex();
            }, x = function t4(e3, r4) {
              var n3 = y.lib.WordArray.random(8), i3 = y.lib.WordArray.random(8), o3 = y.PBKDF2(r4, n3, { keySize: 6, iterations: 100 }), s3 = y.enc.Hex.parse(e3), a3 = y.TripleDES.encrypt(s3, o3, { iv: i3 }) + "", u3 = {};
              return u3.ciphertext = a3, u3.pbkdf2Salt = y.enc.Hex.stringify(n3), u3.pbkdf2Iter = 100, u3.encryptionSchemeAlg = "DES-EDE3-CBC", u3.encryptionSchemeIV = y.enc.Hex.stringify(i3), u3;
            };
            if ("PKCS8PRV" == e2 && null != p2 && t3 instanceof p2 && 1 == t3.isPrivate) {
              var A = v2(t3).getEncodedHex();
              F2 = h2({ seq: [{ int: 0 }, { seq: [{ oid: { name: "rsaEncryption" } }, { null: true }] }, { octstr: { hex: A } }] }).getEncodedHex();
              return void 0 === r3 || null == r3 ? Mr(F2, "PRIVATE KEY") : Mr(b2 = E2(F2, r3), "ENCRYPTED PRIVATE KEY");
            }
            if ("PKCS8PRV" == e2 && void 0 !== d2 && t3 instanceof d2 && 1 == t3.isPrivate) {
              A = new h2({ seq: [{ int: 1 }, { octstr: { hex: t3.prvKeyHex } }, { tag: ["a1", true, { bitstr: { hex: "00" + t3.pubKeyHex } }] }] }).getEncodedHex(), F2 = h2({ seq: [{ int: 0 }, { seq: [{ oid: { name: "ecPublicKey" } }, { oid: { name: t3.curveName } }] }, { octstr: { hex: A } }] }).getEncodedHex();
              return void 0 === r3 || null == r3 ? Mr(F2, "PRIVATE KEY") : Mr(b2 = E2(F2, r3), "ENCRYPTED PRIVATE KEY");
            }
            if ("PKCS8PRV" == e2 && void 0 !== g2 && t3 instanceof g2 && 1 == t3.isPrivate) {
              A = new c2({ bigint: t3.x }).getEncodedHex(), F2 = h2({ seq: [{ int: 0 }, { seq: [{ oid: { name: "dsa" } }, { seq: [{ int: { bigint: t3.p } }, { int: { bigint: t3.q } }, { int: { bigint: t3.g } }] }] }, { octstr: { hex: A } }] }).getEncodedHex();
              return void 0 === r3 || null == r3 ? Mr(F2, "PRIVATE KEY") : Mr(b2 = E2(F2, r3), "ENCRYPTED PRIVATE KEY");
            }
            throw new Error("unsupported object nor format");
          }, Zr.getKeyFromCSRPEM = function(t3) {
            var e2 = Hr(t3, "CERTIFICATE REQUEST");
            return Zr.getKeyFromCSRHex(e2);
          }, Zr.getKeyFromCSRHex = function(t3) {
            var e2 = Zr.parseCSRHex(t3);
            return Zr.getKey(e2.p8pubkeyhex, null, "pkcs8pub");
          }, Zr.parseCSRHex = function(t3) {
            var e2 = Er, r3 = e2.getChildIdx, n2 = e2.getTLV, i2 = {}, o2 = t3;
            if ("30" != o2.substr(0, 2))
              throw "malformed CSR(code:001)";
            var s2 = r3(o2, 0);
            if (s2.length < 1)
              throw "malformed CSR(code:002)";
            if ("30" != o2.substr(s2[0], 2))
              throw "malformed CSR(code:003)";
            var a2 = r3(o2, s2[0]);
            if (a2.length < 3)
              throw "malformed CSR(code:004)";
            return i2.p8pubkeyhex = n2(o2, a2[2]), i2;
          }, Zr.getKeyID = function(t3) {
            var e2 = Zr, r3 = Er;
            "string" == typeof t3 && -1 != t3.indexOf("BEGIN ") && (t3 = e2.getKey(t3));
            var n2 = Hr(e2.getPEM(t3)), i2 = r3.getIdxbyList(n2, 0, [1]), o2 = r3.getV(n2, i2).substring(2);
            return br.crypto.Util.hashHex(o2, "sha1");
          }, Zr.getJWKFromKey = function(t3) {
            var e2 = {};
            if (t3 instanceof He && t3.isPrivate)
              return e2.kty = "RSA", e2.n = Rr(t3.n.toString(16)), e2.e = Rr(t3.e.toString(16)), e2.d = Rr(t3.d.toString(16)), e2.p = Rr(t3.p.toString(16)), e2.q = Rr(t3.q.toString(16)), e2.dp = Rr(t3.dmp1.toString(16)), e2.dq = Rr(t3.dmq1.toString(16)), e2.qi = Rr(t3.coeff.toString(16)), e2;
            if (t3 instanceof He && t3.isPublic)
              return e2.kty = "RSA", e2.n = Rr(t3.n.toString(16)), e2.e = Rr(t3.e.toString(16)), e2;
            if (t3 instanceof br.crypto.ECDSA && t3.isPrivate) {
              if ("P-256" !== (n2 = t3.getShortNISTPCurveName()) && "P-384" !== n2)
                throw "unsupported curve name for JWT: " + n2;
              var r3 = t3.getPublicKeyXYHex();
              return e2.kty = "EC", e2.crv = n2, e2.x = Rr(r3.x), e2.y = Rr(r3.y), e2.d = Rr(t3.prvKeyHex), e2;
            }
            if (t3 instanceof br.crypto.ECDSA && t3.isPublic) {
              var n2;
              if ("P-256" !== (n2 = t3.getShortNISTPCurveName()) && "P-384" !== n2)
                throw "unsupported curve name for JWT: " + n2;
              r3 = t3.getPublicKeyXYHex();
              return e2.kty = "EC", e2.crv = n2, e2.x = Rr(r3.x), e2.y = Rr(r3.y), e2;
            }
            throw "not supported key object";
          }, He.getPosArrayOfChildrenFromHex = function(t3) {
            return Er.getChildIdx(t3, 0);
          }, He.getHexValueArrayOfChildrenFromHex = function(t3) {
            var e2, r3 = Er.getV, n2 = r3(t3, (e2 = He.getPosArrayOfChildrenFromHex(t3))[0]), i2 = r3(t3, e2[1]), o2 = r3(t3, e2[2]), s2 = r3(t3, e2[3]), a2 = r3(t3, e2[4]), u2 = r3(t3, e2[5]), c2 = r3(t3, e2[6]), h2 = r3(t3, e2[7]), l2 = r3(t3, e2[8]);
            return (e2 = new Array()).push(n2, i2, o2, s2, a2, u2, c2, h2, l2), e2;
          }, He.prototype.readPrivateKeyFromPEMString = function(t3) {
            var e2 = Hr(t3), r3 = He.getHexValueArrayOfChildrenFromHex(e2);
            this.setPrivateEx(r3[1], r3[2], r3[3], r3[4], r3[5], r3[6], r3[7], r3[8]);
          }, He.prototype.readPKCS5PrvKeyHex = function(t3) {
            var e2 = He.getHexValueArrayOfChildrenFromHex(t3);
            this.setPrivateEx(e2[1], e2[2], e2[3], e2[4], e2[5], e2[6], e2[7], e2[8]);
          }, He.prototype.readPKCS8PrvKeyHex = function(t3) {
            var e2, r3, n2, i2, o2, s2, a2, u2, c2 = Er, h2 = c2.getVbyListEx;
            if (false === c2.isASN1HEX(t3))
              throw new Error("not ASN.1 hex string");
            try {
              e2 = h2(t3, 0, [2, 0, 1], "02"), r3 = h2(t3, 0, [2, 0, 2], "02"), n2 = h2(t3, 0, [2, 0, 3], "02"), i2 = h2(t3, 0, [2, 0, 4], "02"), o2 = h2(t3, 0, [2, 0, 5], "02"), s2 = h2(t3, 0, [2, 0, 6], "02"), a2 = h2(t3, 0, [2, 0, 7], "02"), u2 = h2(t3, 0, [2, 0, 8], "02");
            } catch (t4) {
              throw new Error("malformed PKCS#8 plain RSA private key");
            }
            this.setPrivateEx(e2, r3, n2, i2, o2, s2, a2, u2);
          }, He.prototype.readPKCS5PubKeyHex = function(t3) {
            var e2 = Er, r3 = e2.getV;
            if (false === e2.isASN1HEX(t3))
              throw new Error("keyHex is not ASN.1 hex string");
            var n2 = e2.getChildIdx(t3, 0);
            if (2 !== n2.length || "02" !== t3.substr(n2[0], 2) || "02" !== t3.substr(n2[1], 2))
              throw new Error("wrong hex for PKCS#5 public key");
            var i2 = r3(t3, n2[0]), o2 = r3(t3, n2[1]);
            this.setPublic(i2, o2);
          }, He.prototype.readPKCS8PubKeyHex = function(t3) {
            var e2 = Er;
            if (false === e2.isASN1HEX(t3))
              throw new Error("not ASN.1 hex string");
            if ("06092a864886f70d010101" !== e2.getTLVbyListEx(t3, 0, [0, 0]))
              throw new Error("not PKCS8 RSA public key");
            var r3 = e2.getTLVbyListEx(t3, 0, [1, 0]);
            this.readPKCS5PubKeyHex(r3);
          }, He.prototype.readCertPubKeyHex = function(t3, e2) {
            var r3, n2;
            (r3 = new on()).readCertHex(t3), n2 = r3.getPublicKeyHex(), this.readPKCS8PubKeyHex(n2);
          };
          var tn = new RegExp("[^0-9a-f]", "gi");
          function en(t3, e2) {
            for (var r3 = "", n2 = e2 / 4 - t3.length, i2 = 0; i2 < n2; i2++)
              r3 += "0";
            return r3 + t3;
          }
          function rn(t3, e2, r3) {
            for (var n2 = "", i2 = 0; n2.length < e2; )
              n2 += Nr(r3(Ur(t3 + String.fromCharCode.apply(String, [(4278190080 & i2) >> 24, (16711680 & i2) >> 16, (65280 & i2) >> 8, 255 & i2])))), i2 += 1;
            return n2;
          }
          function nn(t3) {
            for (var e2 in br.crypto.Util.DIGESTINFOHEAD) {
              var r3 = br.crypto.Util.DIGESTINFOHEAD[e2], n2 = r3.length;
              if (t3.substring(0, n2) == r3)
                return [e2, t3.substring(n2)];
            }
            return [];
          }
          function on(t3) {
            var e2, r3 = Er, n2 = r3.getChildIdx, i2 = r3.getV, o2 = r3.getTLV, s2 = r3.getVbyList, a2 = r3.getVbyListEx, u2 = r3.getTLVbyList, c2 = r3.getTLVbyListEx, h2 = r3.getIdxbyList, l2 = r3.getIdxbyListEx, f2 = r3.getVidx, g2 = r3.oidname, d2 = r3.hextooidstr, p2 = on, v2 = Hr;
            try {
              e2 = br.asn1.x509.AlgorithmIdentifier.PSSNAME2ASN1TLV;
            } catch (t4) {
            }
            this.HEX2STAG = { "0c": "utf8", 13: "prn", 16: "ia5", "1a": "vis", "1e": "bmp" }, this.hex = null, this.version = 0, this.foffset = 0, this.aExtInfo = null, this.getVersion = function() {
              return null === this.hex || 0 !== this.version ? this.version : "a003020102" !== u2(this.hex, 0, [0, 0]) ? (this.version = 1, this.foffset = -1, 1) : (this.version = 3, 3);
            }, this.getSerialNumberHex = function() {
              return a2(this.hex, 0, [0, 0], "02");
            }, this.getSignatureAlgorithmField = function() {
              var t4 = c2(this.hex, 0, [0, 1]);
              return this.getAlgorithmIdentifierName(t4);
            }, this.getAlgorithmIdentifierName = function(t4) {
              for (var r4 in e2)
                if (t4 === e2[r4])
                  return r4;
              return g2(a2(t4, 0, [0], "06"));
            }, this.getIssuer = function() {
              return this.getX500Name(this.getIssuerHex());
            }, this.getIssuerHex = function() {
              return u2(this.hex, 0, [0, 3 + this.foffset], "30");
            }, this.getIssuerString = function() {
              return p2.hex2dn(this.getIssuerHex());
            }, this.getSubject = function() {
              return this.getX500Name(this.getSubjectHex());
            }, this.getSubjectHex = function() {
              return u2(this.hex, 0, [0, 5 + this.foffset], "30");
            }, this.getSubjectString = function() {
              return p2.hex2dn(this.getSubjectHex());
            }, this.getNotBefore = function() {
              var t4 = s2(this.hex, 0, [0, 4 + this.foffset, 0]);
              return t4 = t4.replace(/(..)/g, "%$1"), t4 = decodeURIComponent(t4);
            }, this.getNotAfter = function() {
              var t4 = s2(this.hex, 0, [0, 4 + this.foffset, 1]);
              return t4 = t4.replace(/(..)/g, "%$1"), t4 = decodeURIComponent(t4);
            }, this.getPublicKeyHex = function() {
              return r3.getTLVbyList(this.hex, 0, [0, 6 + this.foffset], "30");
            }, this.getPublicKeyIdx = function() {
              return h2(this.hex, 0, [0, 6 + this.foffset], "30");
            }, this.getPublicKeyContentIdx = function() {
              var t4 = this.getPublicKeyIdx();
              return h2(this.hex, t4, [1, 0], "30");
            }, this.getPublicKey = function() {
              return Zr.getKey(this.getPublicKeyHex(), null, "pkcs8pub");
            }, this.getSignatureAlgorithmName = function() {
              var t4 = u2(this.hex, 0, [1], "30");
              return this.getAlgorithmIdentifierName(t4);
            }, this.getSignatureValueHex = function() {
              return s2(this.hex, 0, [2], "03", true);
            }, this.verifySignature = function(t4) {
              var e3 = this.getSignatureAlgorithmField(), r4 = this.getSignatureValueHex(), n3 = u2(this.hex, 0, [0], "30"), i3 = new br.crypto.Signature({ alg: e3 });
              return i3.init(t4), i3.updateHex(n3), i3.verify(r4);
            }, this.parseExt = function(t4) {
              var e3, o3, a3;
              if (void 0 === t4) {
                if (a3 = this.hex, 3 !== this.version)
                  return -1;
                e3 = h2(a3, 0, [0, 7, 0], "30"), o3 = n2(a3, e3);
              } else {
                a3 = Hr(t4);
                var u3 = h2(a3, 0, [0, 3, 0, 0], "06");
                if ("2a864886f70d01090e" != i2(a3, u3))
                  return void (this.aExtInfo = new Array());
                e3 = h2(a3, 0, [0, 3, 0, 1, 0], "30"), o3 = n2(a3, e3), this.hex = a3;
              }
              this.aExtInfo = new Array();
              for (var c3 = 0; c3 < o3.length; c3++) {
                var l3 = { critical: false }, g3 = 0;
                3 === n2(a3, o3[c3]).length && (l3.critical = true, g3 = 1), l3.oid = r3.hextooidstr(s2(a3, o3[c3], [0], "06"));
                var d3 = h2(a3, o3[c3], [1 + g3]);
                l3.vidx = f2(a3, d3), this.aExtInfo.push(l3);
              }
            }, this.getExtInfo = function(t4) {
              var e3 = this.aExtInfo, r4 = t4;
              if (t4.match(/^[0-9.]+$/) || (r4 = br.asn1.x509.OID.name2oid(t4)), "" !== r4) {
                for (var n3 = 0; n3 < e3.length; n3++)
                  if (e3[n3].oid === r4)
                    return e3[n3];
              }
            }, this.getExtBasicConstraints = function(t4, e3) {
              if (void 0 === t4 && void 0 === e3) {
                var r4 = this.getExtInfo("basicConstraints");
                if (void 0 === r4)
                  return;
                t4 = o2(this.hex, r4.vidx), e3 = r4.critical;
              }
              var n3 = { extname: "basicConstraints" };
              if (e3 && (n3.critical = true), "3000" === t4)
                return n3;
              if ("30030101ff" === t4)
                return n3.cA = true, n3;
              if ("30060101ff02" === t4.substr(0, 12)) {
                var s3 = i2(t4, 10), a3 = parseInt(s3, 16);
                return n3.cA = true, n3.pathLen = a3, n3;
              }
              throw new Error("hExtV parse error: " + t4);
            }, this.getExtKeyUsage = function(t4, e3) {
              if (void 0 === t4 && void 0 === e3) {
                var r4 = this.getExtInfo("keyUsage");
                if (void 0 === r4)
                  return;
                t4 = o2(this.hex, r4.vidx), e3 = r4.critical;
              }
              var n3 = { extname: "keyUsage" };
              return e3 && (n3.critical = true), n3.names = this.getExtKeyUsageString(t4).split(","), n3;
            }, this.getExtKeyUsageBin = function(t4) {
              if (void 0 === t4) {
                var e3 = this.getExtInfo("keyUsage");
                if (void 0 === e3)
                  return "";
                t4 = o2(this.hex, e3.vidx);
              }
              if (8 != t4.length && 10 != t4.length)
                throw new Error("malformed key usage value: " + t4);
              var r4 = "000000000000000" + parseInt(t4.substr(6), 16).toString(2);
              return 8 == t4.length && (r4 = r4.slice(-8)), 10 == t4.length && (r4 = r4.slice(-16)), "" == (r4 = r4.replace(/0+$/, "")) && (r4 = "0"), r4;
            }, this.getExtKeyUsageString = function(t4) {
              for (var e3 = this.getExtKeyUsageBin(t4), r4 = new Array(), n3 = 0; n3 < e3.length; n3++)
                "1" == e3.substr(n3, 1) && r4.push(on.KEYUSAGE_NAME[n3]);
              return r4.join(",");
            }, this.getExtSubjectKeyIdentifier = function(t4, e3) {
              if (void 0 === t4 && void 0 === e3) {
                var r4 = this.getExtInfo("subjectKeyIdentifier");
                if (void 0 === r4)
                  return;
                t4 = o2(this.hex, r4.vidx), e3 = r4.critical;
              }
              var n3 = { extname: "subjectKeyIdentifier" };
              e3 && (n3.critical = true);
              var s3 = i2(t4, 0);
              return n3.kid = { hex: s3 }, n3;
            }, this.getExtAuthorityKeyIdentifier = function(t4, e3) {
              if (void 0 === t4 && void 0 === e3) {
                var r4 = this.getExtInfo("authorityKeyIdentifier");
                if (void 0 === r4)
                  return;
                t4 = o2(this.hex, r4.vidx), e3 = r4.critical;
              }
              var s3 = { extname: "authorityKeyIdentifier" };
              e3 && (s3.critical = true);
              for (var a3 = n2(t4, 0), u3 = 0; u3 < a3.length; u3++) {
                var c3 = t4.substr(a3[u3], 2);
                if ("80" === c3 && (s3.kid = { hex: i2(t4, a3[u3]) }), "a1" === c3) {
                  var h3 = o2(t4, a3[u3]), l3 = this.getGeneralNames(h3);
                  s3.issuer = l3[0].dn;
                }
                "82" === c3 && (s3.sn = { hex: i2(t4, a3[u3]) });
              }
              return s3;
            }, this.getExtExtKeyUsage = function(t4, e3) {
              if (void 0 === t4 && void 0 === e3) {
                var r4 = this.getExtInfo("extKeyUsage");
                if (void 0 === r4)
                  return;
                t4 = o2(this.hex, r4.vidx), e3 = r4.critical;
              }
              var s3 = { extname: "extKeyUsage", array: [] };
              e3 && (s3.critical = true);
              for (var a3 = n2(t4, 0), u3 = 0; u3 < a3.length; u3++)
                s3.array.push(g2(i2(t4, a3[u3])));
              return s3;
            }, this.getExtExtKeyUsageName = function() {
              var t4 = this.getExtInfo("extKeyUsage");
              if (void 0 === t4)
                return t4;
              var e3 = new Array(), r4 = o2(this.hex, t4.vidx);
              if ("" === r4)
                return e3;
              for (var s3 = n2(r4, 0), a3 = 0; a3 < s3.length; a3++)
                e3.push(g2(i2(r4, s3[a3])));
              return e3;
            }, this.getExtSubjectAltName = function(t4, e3) {
              if (void 0 === t4 && void 0 === e3) {
                var r4 = this.getExtInfo("subjectAltName");
                if (void 0 === r4)
                  return;
                t4 = o2(this.hex, r4.vidx), e3 = r4.critical;
              }
              var n3 = { extname: "subjectAltName", array: [] };
              return e3 && (n3.critical = true), n3.array = this.getGeneralNames(t4), n3;
            }, this.getExtIssuerAltName = function(t4, e3) {
              if (void 0 === t4 && void 0 === e3) {
                var r4 = this.getExtInfo("issuerAltName");
                if (void 0 === r4)
                  return;
                t4 = o2(this.hex, r4.vidx), e3 = r4.critical;
              }
              var n3 = { extname: "issuerAltName", array: [] };
              return e3 && (n3.critical = true), n3.array = this.getGeneralNames(t4), n3;
            }, this.getGeneralNames = function(t4) {
              for (var e3 = n2(t4, 0), r4 = [], i3 = 0; i3 < e3.length; i3++) {
                var s3 = this.getGeneralName(o2(t4, e3[i3]));
                void 0 !== s3 && r4.push(s3);
              }
              return r4;
            }, this.getGeneralName = function(t4) {
              var e3 = t4.substr(0, 2), r4 = i2(t4, 0), n3 = Nr(r4);
              return "81" == e3 ? { rfc822: n3 } : "82" == e3 ? { dns: n3 } : "86" == e3 ? { uri: n3 } : "87" == e3 ? { ip: Yr(r4) } : "a4" == e3 ? { dn: this.getX500Name(r4) } : void 0;
            }, this.getExtSubjectAltName2 = function() {
              var t4, e3, r4, s3 = this.getExtInfo("subjectAltName");
              if (void 0 === s3)
                return s3;
              for (var a3 = new Array(), u3 = o2(this.hex, s3.vidx), c3 = n2(u3, 0), h3 = 0; h3 < c3.length; h3++)
                r4 = u3.substr(c3[h3], 2), t4 = i2(u3, c3[h3]), "81" === r4 && (e3 = Lr(t4), a3.push(["MAIL", e3])), "82" === r4 && (e3 = Lr(t4), a3.push(["DNS", e3])), "84" === r4 && (e3 = on.hex2dn(t4, 0), a3.push(["DN", e3])), "86" === r4 && (e3 = Lr(t4), a3.push(["URI", e3])), "87" === r4 && (e3 = Yr(t4), a3.push(["IP", e3]));
              return a3;
            }, this.getExtCRLDistributionPoints = function(t4, e3) {
              if (void 0 === t4 && void 0 === e3) {
                var r4 = this.getExtInfo("cRLDistributionPoints");
                if (void 0 === r4)
                  return;
                t4 = o2(this.hex, r4.vidx), e3 = r4.critical;
              }
              var i3 = { extname: "cRLDistributionPoints", array: [] };
              e3 && (i3.critical = true);
              for (var s3 = n2(t4, 0), a3 = 0; a3 < s3.length; a3++) {
                var u3 = o2(t4, s3[a3]);
                i3.array.push(this.getDistributionPoint(u3));
              }
              return i3;
            }, this.getDistributionPoint = function(t4) {
              for (var e3 = {}, r4 = n2(t4, 0), i3 = 0; i3 < r4.length; i3++) {
                var s3 = t4.substr(r4[i3], 2), a3 = o2(t4, r4[i3]);
                "a0" == s3 && (e3.dpname = this.getDistributionPointName(a3));
              }
              return e3;
            }, this.getDistributionPointName = function(t4) {
              for (var e3 = {}, r4 = n2(t4, 0), i3 = 0; i3 < r4.length; i3++) {
                var s3 = t4.substr(r4[i3], 2), a3 = o2(t4, r4[i3]);
                "a0" == s3 && (e3.full = this.getGeneralNames(a3));
              }
              return e3;
            }, this.getExtCRLDistributionPointsURI = function() {
              var t4 = this.getExtInfo("cRLDistributionPoints");
              if (void 0 === t4)
                return t4;
              for (var e3 = new Array(), r4 = n2(this.hex, t4.vidx), i3 = 0; i3 < r4.length; i3++)
                try {
                  var o3 = Lr(s2(this.hex, r4[i3], [0, 0, 0], "86"));
                  e3.push(o3);
                } catch (t5) {
                }
              return e3;
            }, this.getExtAIAInfo = function() {
              var t4 = this.getExtInfo("authorityInfoAccess");
              if (void 0 === t4)
                return t4;
              for (var e3 = { ocsp: [], caissuer: [] }, r4 = n2(this.hex, t4.vidx), i3 = 0; i3 < r4.length; i3++) {
                var o3 = s2(this.hex, r4[i3], [0], "06"), a3 = s2(this.hex, r4[i3], [1], "86");
                "2b06010505073001" === o3 && e3.ocsp.push(Lr(a3)), "2b06010505073002" === o3 && e3.caissuer.push(Lr(a3));
              }
              return e3;
            }, this.getExtAuthorityInfoAccess = function(t4, e3) {
              if (void 0 === t4 && void 0 === e3) {
                var r4 = this.getExtInfo("authorityInfoAccess");
                if (void 0 === r4)
                  return;
                t4 = o2(this.hex, r4.vidx), e3 = r4.critical;
              }
              var i3 = { extname: "authorityInfoAccess", array: [] };
              e3 && (i3.critical = true);
              for (var u3 = n2(t4, 0), c3 = 0; c3 < u3.length; c3++) {
                var h3 = a2(t4, u3[c3], [0], "06"), l3 = Lr(s2(t4, u3[c3], [1], "86"));
                if ("2b06010505073001" == h3)
                  i3.array.push({ ocsp: l3 });
                else {
                  if ("2b06010505073002" != h3)
                    throw new Error("unknown method: " + h3);
                  i3.array.push({ caissuer: l3 });
                }
              }
              return i3;
            }, this.getExtCertificatePolicies = function(t4, e3) {
              if (void 0 === t4 && void 0 === e3) {
                var r4 = this.getExtInfo("certificatePolicies");
                if (void 0 === r4)
                  return;
                t4 = o2(this.hex, r4.vidx), e3 = r4.critical;
              }
              var i3 = { extname: "certificatePolicies", array: [] };
              e3 && (i3.critical = true);
              for (var s3 = n2(t4, 0), a3 = 0; a3 < s3.length; a3++) {
                var u3 = o2(t4, s3[a3]), c3 = this.getPolicyInformation(u3);
                i3.array.push(c3);
              }
              return i3;
            }, this.getPolicyInformation = function(t4) {
              var e3 = {}, r4 = s2(t4, 0, [0], "06");
              e3.policyoid = g2(r4);
              var i3 = l2(t4, 0, [1], "30");
              if (-1 != i3) {
                e3.array = [];
                for (var a3 = n2(t4, i3), u3 = 0; u3 < a3.length; u3++) {
                  var c3 = o2(t4, a3[u3]), h3 = this.getPolicyQualifierInfo(c3);
                  e3.array.push(h3);
                }
              }
              return e3;
            }, this.getPolicyQualifierInfo = function(t4) {
              var e3 = {}, r4 = s2(t4, 0, [0], "06");
              if ("2b06010505070201" === r4) {
                var n3 = a2(t4, 0, [1], "16");
                e3.cps = Nr(n3);
              } else if ("2b06010505070202" === r4) {
                var i3 = u2(t4, 0, [1], "30");
                e3.unotice = this.getUserNotice(i3);
              }
              return e3;
            }, this.getUserNotice = function(t4) {
              for (var e3 = {}, r4 = n2(t4, 0), i3 = 0; i3 < r4.length; i3++) {
                var s3 = o2(t4, r4[i3]);
                "30" != s3.substr(0, 2) && (e3.exptext = this.getDisplayText(s3));
              }
              return e3;
            }, this.getDisplayText = function(t4) {
              var e3 = {};
              return e3.type = { "0c": "utf8", 16: "ia5", "1a": "vis", "1e": "bmp" }[t4.substr(0, 2)], e3.str = Nr(i2(t4, 0)), e3;
            }, this.getExtCRLNumber = function(t4, e3) {
              var r4 = { extname: "cRLNumber" };
              if (e3 && (r4.critical = true), "02" == t4.substr(0, 2))
                return r4.num = { hex: i2(t4, 0) }, r4;
              throw new Error("hExtV parse error: " + t4);
            }, this.getExtCRLReason = function(t4, e3) {
              var r4 = { extname: "cRLReason" };
              if (e3 && (r4.critical = true), "0a" == t4.substr(0, 2))
                return r4.code = parseInt(i2(t4, 0), 16), r4;
              throw new Error("hExtV parse error: " + t4);
            }, this.getExtOcspNonce = function(t4, e3) {
              var r4 = { extname: "ocspNonce" };
              e3 && (r4.critical = true);
              var n3 = i2(t4, 0);
              return r4.hex = n3, r4;
            }, this.getExtOcspNoCheck = function(t4, e3) {
              var r4 = { extname: "ocspNoCheck" };
              return e3 && (r4.critical = true), r4;
            }, this.getExtAdobeTimeStamp = function(t4, e3) {
              if (void 0 === t4 && void 0 === e3) {
                var r4 = this.getExtInfo("adobeTimeStamp");
                if (void 0 === r4)
                  return;
                t4 = o2(this.hex, r4.vidx), e3 = r4.critical;
              }
              var i3 = { extname: "adobeTimeStamp" };
              e3 && (i3.critical = true);
              var s3 = n2(t4, 0);
              if (s3.length > 1) {
                var a3 = o2(t4, s3[1]), u3 = this.getGeneralName(a3);
                null != u3.uri && (i3.uri = u3.uri);
              }
              if (s3.length > 2) {
                var c3 = o2(t4, s3[2]);
                "0101ff" == c3 && (i3.reqauth = true), "010100" == c3 && (i3.reqauth = false);
              }
              return i3;
            }, this.getX500NameRule = function(t4) {
              for (var e3 = null, r4 = [], n3 = 0; n3 < t4.length; n3++)
                for (var i3 = t4[n3], o3 = 0; o3 < i3.length; o3++)
                  r4.push(i3[o3]);
              for (n3 = 0; n3 < r4.length; n3++) {
                var s3 = r4[n3], a3 = s3.ds, u3 = s3.value, c3 = s3.type;
                if (":" + a3, "prn" != a3 && "utf8" != a3 && "ia5" != a3)
                  return "mixed";
                if ("ia5" == a3) {
                  if ("CN" != c3)
                    return "mixed";
                  if (br.lang.String.isMail(u3))
                    continue;
                  return "mixed";
                }
                if ("C" == c3) {
                  if ("prn" == a3)
                    continue;
                  return "mixed";
                }
                if (":" + a3, null == e3)
                  e3 = a3;
                else if (e3 !== a3)
                  return "mixed";
              }
              return null == e3 ? "prn" : e3;
            }, this.getX500Name = function(t4) {
              var e3 = this.getX500NameArray(t4);
              return { array: e3, str: this.dnarraytostr(e3) };
            }, this.getX500NameArray = function(t4) {
              for (var e3 = [], r4 = n2(t4, 0), i3 = 0; i3 < r4.length; i3++)
                e3.push(this.getRDN(o2(t4, r4[i3])));
              return e3;
            }, this.getRDN = function(t4) {
              for (var e3 = [], r4 = n2(t4, 0), i3 = 0; i3 < r4.length; i3++)
                e3.push(this.getAttrTypeAndValue(o2(t4, r4[i3])));
              return e3;
            }, this.getAttrTypeAndValue = function(t4) {
              var e3 = { type: null, value: null, ds: null }, r4 = n2(t4, 0), i3 = s2(t4, r4[0], [], "06"), o3 = s2(t4, r4[1], []), a3 = br.asn1.ASN1Util.oidHexToInt(i3);
              return e3.type = br.asn1.x509.OID.oid2atype(a3), e3.value = Nr(o3), e3.ds = this.HEX2STAG[t4.substr(r4[1], 2)], e3;
            }, this.readCertPEM = function(t4) {
              this.readCertHex(v2(t4));
            }, this.readCertHex = function(t4) {
              this.hex = t4, this.getVersion();
              try {
                h2(this.hex, 0, [0, 7], "a3"), this.parseExt();
              } catch (t5) {
              }
            }, this.getParam = function() {
              var t4 = {};
              return t4.version = this.getVersion(), t4.serial = { hex: this.getSerialNumberHex() }, t4.sigalg = this.getSignatureAlgorithmField(), t4.issuer = this.getIssuer(), t4.notbefore = this.getNotBefore(), t4.notafter = this.getNotAfter(), t4.subject = this.getSubject(), t4.sbjpubkey = Mr(this.getPublicKeyHex(), "PUBLIC KEY"), this.aExtInfo.length > 0 && (t4.ext = this.getExtParamArray()), t4.sighex = this.getSignatureValueHex(), t4;
            }, this.getExtParamArray = function(t4) {
              null == t4 && (-1 != l2(this.hex, 0, [0, "[3]"]) && (t4 = c2(this.hex, 0, [0, "[3]", 0], "30")));
              for (var e3 = [], r4 = n2(t4, 0), i3 = 0; i3 < r4.length; i3++) {
                var s3 = o2(t4, r4[i3]), a3 = this.getExtParam(s3);
                null != a3 && e3.push(a3);
              }
              return e3;
            }, this.getExtParam = function(t4) {
              var e3 = n2(t4, 0).length;
              if (2 != e3 && 3 != e3)
                throw new Error("wrong number elements in Extension: " + e3 + " " + t4);
              var r4 = d2(s2(t4, 0, [0], "06")), i3 = false;
              3 == e3 && "0101ff" == u2(t4, 0, [1]) && (i3 = true);
              var o3 = u2(t4, 0, [e3 - 1, 0]), a3 = void 0;
              if ("2.5.29.14" == r4 ? a3 = this.getExtSubjectKeyIdentifier(o3, i3) : "2.5.29.15" == r4 ? a3 = this.getExtKeyUsage(o3, i3) : "2.5.29.17" == r4 ? a3 = this.getExtSubjectAltName(o3, i3) : "2.5.29.18" == r4 ? a3 = this.getExtIssuerAltName(o3, i3) : "2.5.29.19" == r4 ? a3 = this.getExtBasicConstraints(o3, i3) : "2.5.29.31" == r4 ? a3 = this.getExtCRLDistributionPoints(o3, i3) : "2.5.29.32" == r4 ? a3 = this.getExtCertificatePolicies(o3, i3) : "2.5.29.35" == r4 ? a3 = this.getExtAuthorityKeyIdentifier(o3, i3) : "2.5.29.37" == r4 ? a3 = this.getExtExtKeyUsage(o3, i3) : "1.3.6.1.5.5.7.1.1" == r4 ? a3 = this.getExtAuthorityInfoAccess(o3, i3) : "2.5.29.20" == r4 ? a3 = this.getExtCRLNumber(o3, i3) : "2.5.29.21" == r4 ? a3 = this.getExtCRLReason(o3, i3) : "1.3.6.1.5.5.7.48.1.2" == r4 ? a3 = this.getExtOcspNonce(o3, i3) : "1.3.6.1.5.5.7.48.1.5" == r4 ? a3 = this.getExtOcspNoCheck(o3, i3) : "1.2.840.113583.1.1.9.1" == r4 && (a3 = this.getExtAdobeTimeStamp(o3, i3)), null != a3)
                return a3;
              var c3 = { extname: r4, extn: o3 };
              return i3 && (c3.critical = true), c3;
            }, this.findExt = function(t4, e3) {
              for (var r4 = 0; r4 < t4.length; r4++)
                if (t4[r4].extname == e3)
                  return t4[r4];
              return null;
            }, this.updateExtCDPFullURI = function(t4, e3) {
              var r4 = this.findExt(t4, "cRLDistributionPoints");
              if (null != r4 && null != r4.array) {
                for (var n3 = r4.array, i3 = 0; i3 < n3.length; i3++)
                  if (null != n3[i3].dpname && null != n3[i3].dpname.full)
                    for (var o3 = n3[i3].dpname.full, s3 = 0; s3 < o3.length; s3++) {
                      var a3 = o3[i3];
                      null != a3.uri && (a3.uri = e3);
                    }
              }
            }, this.updateExtAIAOCSP = function(t4, e3) {
              var r4 = this.findExt(t4, "authorityInfoAccess");
              if (null != r4 && null != r4.array)
                for (var n3 = r4.array, i3 = 0; i3 < n3.length; i3++)
                  null != n3[i3].ocsp && (n3[i3].ocsp = e3);
            }, this.updateExtAIACAIssuer = function(t4, e3) {
              var r4 = this.findExt(t4, "authorityInfoAccess");
              if (null != r4 && null != r4.array)
                for (var n3 = r4.array, i3 = 0; i3 < n3.length; i3++)
                  null != n3[i3].caissuer && (n3[i3].caissuer = e3);
            }, this.dnarraytostr = function(t4) {
              return "/" + t4.map(function(t5) {
                return function e3(t6) {
                  return t6.map(function(t7) {
                    return function e4(t8) {
                      return t8.type + "=" + t8.value;
                    }(t7);
                  }).join("+");
                }(t5);
              }).join("/");
            }, this.getInfo = function() {
              var t4, e3, r4, n3 = function t5(e4) {
                return JSON.stringify(e4.array).replace(/[\[\]\{\}\"]/g, "");
              }, i3 = function t5(e4) {
                for (var r5 = "", n4 = e4.array, i4 = 0; i4 < n4.length; i4++) {
                  var o4 = n4[i4];
                  if (r5 += "    policy oid: " + o4.policyoid + "\n", void 0 !== o4.array)
                    for (var s4 = 0; s4 < o4.array.length; s4++) {
                      var a4 = o4.array[s4];
                      void 0 !== a4.cps && (r5 += "    cps: " + a4.cps + "\n");
                    }
                }
                return r5;
              }, o3 = function t5(e4) {
                for (var r5 = "", n4 = e4.array, i4 = 0; i4 < n4.length; i4++) {
                  var o4 = n4[i4];
                  try {
                    void 0 !== o4.dpname.full[0].uri && (r5 += "    " + o4.dpname.full[0].uri + "\n");
                  } catch (t6) {
                  }
                  try {
                    void 0 !== o4.dname.full[0].dn.hex && (r5 += "    " + on.hex2dn(o4.dpname.full[0].dn.hex) + "\n");
                  } catch (t6) {
                  }
                }
                return r5;
              }, s3 = function t5(e4) {
                for (var r5 = "", n4 = e4.array, i4 = 0; i4 < n4.length; i4++) {
                  var o4 = n4[i4];
                  void 0 !== o4.caissuer && (r5 += "    caissuer: " + o4.caissuer + "\n"), void 0 !== o4.ocsp && (r5 += "    ocsp: " + o4.ocsp + "\n");
                }
                return r5;
              };
              if (t4 = "Basic Fields\n", t4 += "  serial number: " + this.getSerialNumberHex() + "\n", t4 += "  signature algorithm: " + this.getSignatureAlgorithmField() + "\n", t4 += "  issuer: " + this.getIssuerString() + "\n", t4 += "  notBefore: " + this.getNotBefore() + "\n", t4 += "  notAfter: " + this.getNotAfter() + "\n", t4 += "  subject: " + this.getSubjectString() + "\n", t4 += "  subject public key info: \n", t4 += "    key algorithm: " + (e3 = this.getPublicKey()).type + "\n", "RSA" === e3.type && (t4 += "    n=" + $r(e3.n.toString(16)).substr(0, 16) + "...\n", t4 += "    e=" + $r(e3.e.toString(16)) + "\n"), null != (r4 = this.aExtInfo)) {
                t4 += "X509v3 Extensions:\n";
                for (var a3 = 0; a3 < r4.length; a3++) {
                  var u3 = r4[a3], c3 = br.asn1.x509.OID.oid2name(u3.oid);
                  "" === c3 && (c3 = u3.oid);
                  var h3 = "";
                  if (true === u3.critical && (h3 = "CRITICAL"), t4 += "  " + c3 + " " + h3 + ":\n", "basicConstraints" === c3) {
                    var l3 = this.getExtBasicConstraints();
                    void 0 === l3.cA ? t4 += "    {}\n" : (t4 += "    cA=true", void 0 !== l3.pathLen && (t4 += ", pathLen=" + l3.pathLen), t4 += "\n");
                  } else if ("keyUsage" === c3)
                    t4 += "    " + this.getExtKeyUsageString() + "\n";
                  else if ("subjectKeyIdentifier" === c3)
                    t4 += "    " + this.getExtSubjectKeyIdentifier().kid.hex + "\n";
                  else if ("authorityKeyIdentifier" === c3) {
                    var f3 = this.getExtAuthorityKeyIdentifier();
                    void 0 !== f3.kid && (t4 += "    kid=" + f3.kid.hex + "\n");
                  } else {
                    if ("extKeyUsage" === c3)
                      t4 += "    " + this.getExtExtKeyUsage().array.join(", ") + "\n";
                    else if ("subjectAltName" === c3)
                      t4 += "    " + n3(this.getExtSubjectAltName()) + "\n";
                    else if ("cRLDistributionPoints" === c3)
                      t4 += o3(this.getExtCRLDistributionPoints());
                    else if ("authorityInfoAccess" === c3)
                      t4 += s3(this.getExtAuthorityInfoAccess());
                    else
                      "certificatePolicies" === c3 && (t4 += i3(this.getExtCertificatePolicies()));
                  }
                }
              }
              return t4 += "signature algorithm: " + this.getSignatureAlgorithmName() + "\n", t4 += "signature: " + this.getSignatureValueHex().substr(0, 16) + "...\n";
            }, "string" == typeof t3 && (-1 != t3.indexOf("-----BEGIN") ? this.readCertPEM(t3) : br.lang.String.isHex(t3) && this.readCertHex(t3));
          }
          He.prototype.sign = function(t3, e2) {
            var r3 = function t4(r4) {
              return br.crypto.Util.hashString(r4, e2);
            }(t3);
            return this.signWithMessageHash(r3, e2);
          }, He.prototype.signWithMessageHash = function(t3, e2) {
            var r3 = je(br.crypto.Util.getPaddedDigestInfoHex(t3, e2, this.n.bitLength()), 16);
            return en(this.doPrivate(r3).toString(16), this.n.bitLength());
          }, He.prototype.signPSS = function(t3, e2, r3) {
            var n2 = function t4(r4) {
              return br.crypto.Util.hashHex(r4, e2);
            }(Ur(t3));
            return void 0 === r3 && (r3 = -1), this.signWithMessageHashPSS(n2, e2, r3);
          }, He.prototype.signWithMessageHashPSS = function(t3, e2, r3) {
            var n2, i2 = Nr(t3), o2 = i2.length, s2 = this.n.bitLength() - 1, a2 = Math.ceil(s2 / 8), u2 = function t4(r4) {
              return br.crypto.Util.hashHex(r4, e2);
            };
            if (-1 === r3 || void 0 === r3)
              r3 = o2;
            else if (-2 === r3)
              r3 = a2 - o2 - 2;
            else if (r3 < -2)
              throw new Error("invalid salt length");
            if (a2 < o2 + r3 + 2)
              throw new Error("data too long");
            var c2 = "";
            r3 > 0 && (c2 = new Array(r3), new Oe().nextBytes(c2), c2 = String.fromCharCode.apply(String, c2));
            var h2 = Nr(u2(Ur("\0\0\0\0\0\0\0\0" + i2 + c2))), l2 = [];
            for (n2 = 0; n2 < a2 - r3 - o2 - 2; n2 += 1)
              l2[n2] = 0;
            var f2 = String.fromCharCode.apply(String, l2) + "" + c2, g2 = rn(h2, f2.length, u2), d2 = [];
            for (n2 = 0; n2 < f2.length; n2 += 1)
              d2[n2] = f2.charCodeAt(n2) ^ g2.charCodeAt(n2);
            var p2 = 65280 >> 8 * a2 - s2 & 255;
            for (d2[0] &= ~p2, n2 = 0; n2 < o2; n2++)
              d2.push(h2.charCodeAt(n2));
            return d2.push(188), en(this.doPrivate(new F(d2)).toString(16), this.n.bitLength());
          }, He.prototype.verify = function(t3, e2) {
            var r3 = je(e2 = (e2 = e2.replace(tn, "")).replace(/[ \n]+/g, ""), 16);
            if (r3.bitLength() > this.n.bitLength())
              return 0;
            var n2 = nn(this.doPublic(r3).toString(16).replace(/^1f+00/, ""));
            if (0 == n2.length)
              return false;
            var i2 = n2[0];
            return n2[1] == function t4(e3) {
              return br.crypto.Util.hashString(e3, i2);
            }(t3);
          }, He.prototype.verifyWithMessageHash = function(t3, e2) {
            if (e2.length != Math.ceil(this.n.bitLength() / 4))
              return false;
            var r3 = je(e2, 16);
            if (r3.bitLength() > this.n.bitLength())
              return 0;
            var n2 = nn(this.doPublic(r3).toString(16).replace(/^1f+00/, ""));
            if (0 == n2.length)
              return false;
            n2[0];
            return n2[1] == t3;
          }, He.prototype.verifyPSS = function(t3, e2, r3, n2) {
            var i2 = function t4(e3) {
              return br.crypto.Util.hashHex(e3, r3);
            }(Ur(t3));
            return void 0 === n2 && (n2 = -1), this.verifyWithMessageHashPSS(i2, e2, r3, n2);
          }, He.prototype.verifyWithMessageHashPSS = function(t3, e2, r3, n2) {
            if (e2.length != Math.ceil(this.n.bitLength() / 4))
              return false;
            var i2, o2 = new F(e2, 16), s2 = function t4(e3) {
              return br.crypto.Util.hashHex(e3, r3);
            }, a2 = Nr(t3), u2 = a2.length, c2 = this.n.bitLength() - 1, h2 = Math.ceil(c2 / 8);
            if (-1 === n2 || void 0 === n2)
              n2 = u2;
            else if (-2 === n2)
              n2 = h2 - u2 - 2;
            else if (n2 < -2)
              throw new Error("invalid salt length");
            if (h2 < u2 + n2 + 2)
              throw new Error("data too long");
            var l2 = this.doPublic(o2).toByteArray();
            for (i2 = 0; i2 < l2.length; i2 += 1)
              l2[i2] &= 255;
            for (; l2.length < h2; )
              l2.unshift(0);
            if (188 !== l2[h2 - 1])
              throw new Error("encoded message does not end in 0xbc");
            var f2 = (l2 = String.fromCharCode.apply(String, l2)).substr(0, h2 - u2 - 1), g2 = l2.substr(f2.length, u2), d2 = 65280 >> 8 * h2 - c2 & 255;
            if (0 != (f2.charCodeAt(0) & d2))
              throw new Error("bits beyond keysize not zero");
            var p2 = rn(g2, f2.length, s2), v2 = [];
            for (i2 = 0; i2 < f2.length; i2 += 1)
              v2[i2] = f2.charCodeAt(i2) ^ p2.charCodeAt(i2);
            v2[0] &= ~d2;
            var y2 = h2 - u2 - n2 - 2;
            for (i2 = 0; i2 < y2; i2 += 1)
              if (0 !== v2[i2])
                throw new Error("leftmost octets not zero");
            if (1 !== v2[y2])
              throw new Error("0x01 marker not found");
            return g2 === Nr(s2(Ur("\0\0\0\0\0\0\0\0" + a2 + String.fromCharCode.apply(String, v2.slice(-n2)))));
          }, He.SALT_LEN_HLEN = -1, He.SALT_LEN_MAX = -2, He.SALT_LEN_RECOVER = -2, on.hex2dn = function(t3, e2) {
            if (void 0 === e2 && (e2 = 0), "30" !== t3.substr(e2, 2))
              throw new Error("malformed DN");
            for (var r3 = new Array(), n2 = Er.getChildIdx(t3, e2), i2 = 0; i2 < n2.length; i2++)
              r3.push(on.hex2rdn(t3, n2[i2]));
            return "/" + (r3 = r3.map(function(t4) {
              return t4.replace("/", "\\/");
            })).join("/");
          }, on.hex2rdn = function(t3, e2) {
            if (void 0 === e2 && (e2 = 0), "31" !== t3.substr(e2, 2))
              throw new Error("malformed RDN");
            for (var r3 = new Array(), n2 = Er.getChildIdx(t3, e2), i2 = 0; i2 < n2.length; i2++)
              r3.push(on.hex2attrTypeValue(t3, n2[i2]));
            return (r3 = r3.map(function(t4) {
              return t4.replace("+", "\\+");
            })).join("+");
          }, on.hex2attrTypeValue = function(t3, e2) {
            var r3 = Er, n2 = r3.getV;
            if (void 0 === e2 && (e2 = 0), "30" !== t3.substr(e2, 2))
              throw new Error("malformed attribute type and value");
            var i2 = r3.getChildIdx(t3, e2);
            2 !== i2.length || t3.substr(i2[0], 2);
            var o2 = n2(t3, i2[0]), s2 = br.asn1.ASN1Util.oidHexToInt(o2);
            return br.asn1.x509.OID.oid2atype(s2) + "=" + Nr(n2(t3, i2[1]));
          }, on.getPublicKeyFromCertHex = function(t3) {
            var e2 = new on();
            return e2.readCertHex(t3), e2.getPublicKey();
          }, on.getPublicKeyFromCertPEM = function(t3) {
            var e2 = new on();
            return e2.readCertPEM(t3), e2.getPublicKey();
          }, on.getPublicKeyInfoPropOfCertPEM = function(t3) {
            var e2, r3, n2 = Er.getVbyList, i2 = {};
            return i2.algparam = null, (e2 = new on()).readCertPEM(t3), r3 = e2.getPublicKeyHex(), i2.keyhex = n2(r3, 0, [1], "03").substr(2), i2.algoid = n2(r3, 0, [0, 0], "06"), "2a8648ce3d0201" === i2.algoid && (i2.algparam = n2(r3, 0, [0, 1], "06")), i2;
          }, on.KEYUSAGE_NAME = ["digitalSignature", "nonRepudiation", "keyEncipherment", "dataEncipherment", "keyAgreement", "keyCertSign", "cRLSign", "encipherOnly", "decipherOnly"], void 0 !== br && br || (e.KJUR = br = {}), void 0 !== br.jws && br.jws || (br.jws = {}), br.jws.JWS = function() {
            var t3 = br.jws.JWS.isSafeJSONString;
            this.parseJWS = function(e2, r3) {
              if (void 0 === this.parsedJWS || !r3 && void 0 === this.parsedJWS.sigvalH) {
                var n2 = e2.match(/^([^.]+)\.([^.]+)\.([^.]+)$/);
                if (null == n2)
                  throw "JWS signature is not a form of 'Head.Payload.SigValue'.";
                var i2 = n2[1], o2 = n2[2], s2 = n2[3], a2 = i2 + "." + o2;
                if (this.parsedJWS = {}, this.parsedJWS.headB64U = i2, this.parsedJWS.payloadB64U = o2, this.parsedJWS.sigvalB64U = s2, this.parsedJWS.si = a2, !r3) {
                  var u2 = Ir(s2), c2 = je(u2, 16);
                  this.parsedJWS.sigvalH = u2, this.parsedJWS.sigvalBI = c2;
                }
                var h2 = Fr(i2), l2 = Fr(o2);
                if (this.parsedJWS.headS = h2, this.parsedJWS.payloadS = l2, !t3(h2, this.parsedJWS, "headP"))
                  throw "malformed JSON string for JWS Head: " + h2;
              }
            };
          }, br.jws.JWS.sign = function(t3, e2, n2, i2, o2) {
            var s2, a2, u2, c2 = br, h2 = c2.jws.JWS, l2 = h2.readSafeJSONString, f2 = h2.isSafeJSONString, g2 = c2.crypto, d2 = (g2.ECDSA, g2.Mac), p2 = g2.Signature, v2 = JSON;
            if ("string" != typeof e2 && "object" != (void 0 === e2 ? "undefined" : r2(e2)))
              throw "spHeader must be JSON string or object: " + e2;
            if ("object" == (void 0 === e2 ? "undefined" : r2(e2)) && (a2 = e2, s2 = v2.stringify(a2)), "string" == typeof e2) {
              if (!f2(s2 = e2))
                throw "JWS Head is not safe JSON string: " + s2;
              a2 = l2(s2);
            }
            if (u2 = n2, "object" == (void 0 === n2 ? "undefined" : r2(n2)) && (u2 = v2.stringify(n2)), "" != t3 && null != t3 || void 0 === a2.alg || (t3 = a2.alg), "" != t3 && null != t3 && void 0 === a2.alg && (a2.alg = t3, s2 = v2.stringify(a2)), t3 !== a2.alg)
              throw "alg and sHeader.alg doesn't match: " + t3 + "!=" + a2.alg;
            var y2 = null;
            if (void 0 === h2.jwsalg2sigalg[t3])
              throw "unsupported alg name: " + t3;
            y2 = h2.jwsalg2sigalg[t3];
            var m2 = wr(s2) + "." + wr(u2), _2 = "";
            if ("Hmac" == y2.substr(0, 4)) {
              if (void 0 === i2)
                throw "mac key shall be specified for HS* alg";
              var S2 = new d2({ alg: y2, prov: "cryptojs", pass: i2 });
              S2.updateString(m2), _2 = S2.doFinal();
            } else if (-1 != y2.indexOf("withECDSA")) {
              (w2 = new p2({ alg: y2 })).init(i2, o2), w2.updateString(m2);
              var b2 = w2.sign();
              _2 = br.crypto.ECDSA.asn1SigToConcatSig(b2);
            } else {
              var w2;
              if ("none" != y2)
                (w2 = new p2({ alg: y2 })).init(i2, o2), w2.updateString(m2), _2 = w2.sign();
            }
            return m2 + "." + Rr(_2);
          }, br.jws.JWS.verify = function(t3, e2, n2) {
            var i2, o2 = br, s2 = o2.jws.JWS, a2 = s2.readSafeJSONString, u2 = o2.crypto, c2 = u2.ECDSA, h2 = u2.Mac, l2 = u2.Signature;
            void 0 !== r2(He) && (i2 = He);
            var f2 = t3.split(".");
            if (3 !== f2.length)
              return false;
            var g2 = f2[0] + "." + f2[1], d2 = Ir(f2[2]), p2 = a2(Fr(f2[0])), v2 = null, y2 = null;
            if (void 0 === p2.alg)
              throw "algorithm not specified in header";
            if ((y2 = (v2 = p2.alg).substr(0, 2), null != n2 && "[object Array]" === Object.prototype.toString.call(n2) && n2.length > 0) && -1 == (":" + n2.join(":") + ":").indexOf(":" + v2 + ":"))
              throw "algorithm '" + v2 + "' not accepted in the list";
            if ("none" != v2 && null === e2)
              throw "key shall be specified to verify.";
            if ("string" == typeof e2 && -1 != e2.indexOf("-----BEGIN ") && (e2 = Zr.getKey(e2)), !("RS" != y2 && "PS" != y2 || e2 instanceof i2))
              throw "key shall be a RSAKey obj for RS* and PS* algs";
            if ("ES" == y2 && !(e2 instanceof c2))
              throw "key shall be a ECDSA obj for ES* algs";
            var m2 = null;
            if (void 0 === s2.jwsalg2sigalg[p2.alg])
              throw "unsupported alg name: " + v2;
            if ("none" == (m2 = s2.jwsalg2sigalg[v2]))
              throw "not supported";
            if ("Hmac" == m2.substr(0, 4)) {
              if (void 0 === e2)
                throw "hexadecimal key shall be specified for HMAC";
              var _2 = new h2({ alg: m2, pass: e2 });
              return _2.updateString(g2), d2 == _2.doFinal();
            }
            if (-1 != m2.indexOf("withECDSA")) {
              var S2, b2 = null;
              try {
                b2 = c2.concatSigToASN1Sig(d2);
              } catch (t4) {
                return false;
              }
              return (S2 = new l2({ alg: m2 })).init(e2), S2.updateString(g2), S2.verify(b2);
            }
            return (S2 = new l2({ alg: m2 })).init(e2), S2.updateString(g2), S2.verify(d2);
          }, br.jws.JWS.parse = function(t3) {
            var e2, r3, n2, i2 = t3.split("."), o2 = {};
            if (2 != i2.length && 3 != i2.length)
              throw "malformed sJWS: wrong number of '.' splitted elements";
            return e2 = i2[0], r3 = i2[1], 3 == i2.length && (n2 = i2[2]), o2.headerObj = br.jws.JWS.readSafeJSONString(Fr(e2)), o2.payloadObj = br.jws.JWS.readSafeJSONString(Fr(r3)), o2.headerPP = JSON.stringify(o2.headerObj, null, "  "), null == o2.payloadObj ? o2.payloadPP = Fr(r3) : o2.payloadPP = JSON.stringify(o2.payloadObj, null, "  "), void 0 !== n2 && (o2.sigHex = Ir(n2)), o2;
          }, br.jws.JWS.verifyJWT = function(t3, e2, n2) {
            var i2 = br.jws, o2 = i2.JWS, s2 = o2.readSafeJSONString, a2 = o2.inArray, u2 = o2.includedArray, c2 = t3.split("."), h2 = c2[0], l2 = c2[1], f2 = (Ir(c2[2]), s2(Fr(h2))), g2 = s2(Fr(l2));
            if (void 0 === f2.alg)
              return false;
            if (void 0 === n2.alg)
              throw "acceptField.alg shall be specified";
            if (!a2(f2.alg, n2.alg))
              return false;
            if (void 0 !== g2.iss && "object" === r2(n2.iss) && !a2(g2.iss, n2.iss))
              return false;
            if (void 0 !== g2.sub && "object" === r2(n2.sub) && !a2(g2.sub, n2.sub))
              return false;
            if (void 0 !== g2.aud && "object" === r2(n2.aud)) {
              if ("string" == typeof g2.aud) {
                if (!a2(g2.aud, n2.aud))
                  return false;
              } else if ("object" == r2(g2.aud) && !u2(g2.aud, n2.aud))
                return false;
            }
            var d2 = i2.IntDate.getNow();
            return void 0 !== n2.verifyAt && "number" == typeof n2.verifyAt && (d2 = n2.verifyAt), void 0 !== n2.gracePeriod && "number" == typeof n2.gracePeriod || (n2.gracePeriod = 0), !(void 0 !== g2.exp && "number" == typeof g2.exp && g2.exp + n2.gracePeriod < d2) && (!(void 0 !== g2.nbf && "number" == typeof g2.nbf && d2 < g2.nbf - n2.gracePeriod) && (!(void 0 !== g2.iat && "number" == typeof g2.iat && d2 < g2.iat - n2.gracePeriod) && ((void 0 === g2.jti || void 0 === n2.jti || g2.jti === n2.jti) && !!o2.verify(t3, e2, n2.alg))));
          }, br.jws.JWS.includedArray = function(t3, e2) {
            var n2 = br.jws.JWS.inArray;
            if (null === t3)
              return false;
            if ("object" !== (void 0 === t3 ? "undefined" : r2(t3)))
              return false;
            if ("number" != typeof t3.length)
              return false;
            for (var i2 = 0; i2 < t3.length; i2++)
              if (!n2(t3[i2], e2))
                return false;
            return true;
          }, br.jws.JWS.inArray = function(t3, e2) {
            if (null === e2)
              return false;
            if ("object" !== (void 0 === e2 ? "undefined" : r2(e2)))
              return false;
            if ("number" != typeof e2.length)
              return false;
            for (var n2 = 0; n2 < e2.length; n2++)
              if (e2[n2] == t3)
                return true;
            return false;
          }, br.jws.JWS.jwsalg2sigalg = { HS256: "HmacSHA256", HS384: "HmacSHA384", HS512: "HmacSHA512", RS256: "SHA256withRSA", RS384: "SHA384withRSA", RS512: "SHA512withRSA", ES256: "SHA256withECDSA", ES384: "SHA384withECDSA", PS256: "SHA256withRSAandMGF1", PS384: "SHA384withRSAandMGF1", PS512: "SHA512withRSAandMGF1", none: "none" }, br.jws.JWS.isSafeJSONString = function(t3, e2, n2) {
            var i2 = null;
            try {
              return "object" != (void 0 === (i2 = Sr(t3)) ? "undefined" : r2(i2)) || i2.constructor === Array ? 0 : (e2 && (e2[n2] = i2), 1);
            } catch (t4) {
              return 0;
            }
          }, br.jws.JWS.readSafeJSONString = function(t3) {
            var e2 = null;
            try {
              return "object" != (void 0 === (e2 = Sr(t3)) ? "undefined" : r2(e2)) || e2.constructor === Array ? null : e2;
            } catch (t4) {
              return null;
            }
          }, br.jws.JWS.getEncodedSignatureValueFromJWS = function(t3) {
            var e2 = t3.match(/^[^.]+\.[^.]+\.([^.]+)$/);
            if (null == e2)
              throw "JWS signature is not a form of 'Head.Payload.SigValue'.";
            return e2[1];
          }, br.jws.JWS.getJWKthumbprint = function(t3) {
            if ("RSA" !== t3.kty && "EC" !== t3.kty && "oct" !== t3.kty)
              throw "unsupported algorithm for JWK Thumprint";
            var e2 = "{";
            if ("RSA" === t3.kty) {
              if ("string" != typeof t3.n || "string" != typeof t3.e)
                throw "wrong n and e value for RSA key";
              e2 += '"e":"' + t3.e + '",', e2 += '"kty":"' + t3.kty + '",', e2 += '"n":"' + t3.n + '"}';
            } else if ("EC" === t3.kty) {
              if ("string" != typeof t3.crv || "string" != typeof t3.x || "string" != typeof t3.y)
                throw "wrong crv, x and y value for EC key";
              e2 += '"crv":"' + t3.crv + '",', e2 += '"kty":"' + t3.kty + '",', e2 += '"x":"' + t3.x + '",', e2 += '"y":"' + t3.y + '"}';
            } else if ("oct" === t3.kty) {
              if ("string" != typeof t3.k)
                throw "wrong k value for oct(symmetric) key";
              e2 += '"kty":"' + t3.kty + '",', e2 += '"k":"' + t3.k + '"}';
            }
            var r3 = Ur(e2);
            return Rr(br.crypto.Util.hashHex(r3, "sha256"));
          }, br.jws.IntDate = {}, br.jws.IntDate.get = function(t3) {
            var e2 = br.jws.IntDate, r3 = e2.getNow, n2 = e2.getZulu;
            if ("now" == t3)
              return r3();
            if ("now + 1hour" == t3)
              return r3() + 3600;
            if ("now + 1day" == t3)
              return r3() + 86400;
            if ("now + 1month" == t3)
              return r3() + 2592e3;
            if ("now + 1year" == t3)
              return r3() + 31536e3;
            if (t3.match(/Z$/))
              return n2(t3);
            if (t3.match(/^[0-9]+$/))
              return parseInt(t3);
            throw "unsupported format: " + t3;
          }, br.jws.IntDate.getZulu = function(t3) {
            return Kr(t3);
          }, br.jws.IntDate.getNow = function() {
            return ~~(/* @__PURE__ */ new Date() / 1e3);
          }, br.jws.IntDate.intDate2UTCString = function(t3) {
            return new Date(1e3 * t3).toUTCString();
          }, br.jws.IntDate.intDate2Zulu = function(t3) {
            var e2 = new Date(1e3 * t3);
            return ("0000" + e2.getUTCFullYear()).slice(-4) + ("00" + (e2.getUTCMonth() + 1)).slice(-2) + ("00" + e2.getUTCDate()).slice(-2) + ("00" + e2.getUTCHours()).slice(-2) + ("00" + e2.getUTCMinutes()).slice(-2) + ("00" + e2.getUTCSeconds()).slice(-2) + "Z";
          }, e.SecureRandom = Oe, e.rng_seed_time = Ie, e.BigInteger = F, e.RSAKey = He;
          var sn = br.crypto.EDSA;
          e.EDSA = sn;
          var an = br.crypto.DSA;
          e.DSA = an;
          var un = br.crypto.Signature;
          e.Signature = un;
          var cn = br.crypto.MessageDigest;
          e.MessageDigest = cn;
          var hn = br.crypto.Mac;
          e.Mac = hn;
          var ln = br.crypto.Cipher;
          e.Cipher = ln, e.KEYUTIL = Zr, e.ASN1HEX = Er, e.X509 = on, e.CryptoJS = y, e.b64tohex = b, e.b64toBA = w, e.stoBA = xr, e.BAtos = Ar, e.BAtohex = kr, e.stohex = Pr, e.stob64 = function fn(t3) {
            return S(Pr(t3));
          }, e.stob64u = function gn(t3) {
            return Cr(S(Pr(t3)));
          }, e.b64utos = function dn(t3) {
            return Ar(w(Tr(t3)));
          }, e.b64tob64u = Cr, e.b64utob64 = Tr, e.hex2b64 = S, e.hextob64u = Rr, e.b64utohex = Ir, e.utf8tob64u = wr, e.b64utoutf8 = Fr, e.utf8tob64 = function pn(t3) {
            return S(qr(Gr(t3)));
          }, e.b64toutf8 = function vn(t3) {
            return decodeURIComponent(Jr(b(t3)));
          }, e.utf8tohex = Dr, e.hextoutf8 = Lr, e.hextorstr = Nr, e.rstrtohex = Ur, e.hextob64 = Br, e.hextob64nl = Or, e.b64nltohex = jr, e.hextopem = Mr, e.pemtohex = Hr, e.hextoArrayBuffer = function yn(t3) {
            if (t3.length % 2 != 0)
              throw "input is not even length";
            if (null == t3.match(/^[0-9A-Fa-f]+$/))
              throw "input is not hexadecimal";
            for (var e2 = new ArrayBuffer(t3.length / 2), r3 = new DataView(e2), n2 = 0; n2 < t3.length / 2; n2++)
              r3.setUint8(n2, parseInt(t3.substr(2 * n2, 2), 16));
            return e2;
          }, e.ArrayBuffertohex = function mn(t3) {
            for (var e2 = "", r3 = new DataView(t3), n2 = 0; n2 < t3.byteLength; n2++)
              e2 += ("00" + r3.getUint8(n2).toString(16)).slice(-2);
            return e2;
          }, e.zulutomsec = Vr, e.zulutosec = Kr, e.zulutodate = function _n(t3) {
            return new Date(Vr(t3));
          }, e.datetozulu = function Sn(t3, e2, r3) {
            var n2, i2 = t3.getUTCFullYear();
            if (e2) {
              if (i2 < 1950 || 2049 < i2)
                throw "not proper year for UTCTime: " + i2;
              n2 = ("" + i2).slice(-2);
            } else
              n2 = ("000" + i2).slice(-4);
            if (n2 += ("0" + (t3.getUTCMonth() + 1)).slice(-2), n2 += ("0" + t3.getUTCDate()).slice(-2), n2 += ("0" + t3.getUTCHours()).slice(-2), n2 += ("0" + t3.getUTCMinutes()).slice(-2), n2 += ("0" + t3.getUTCSeconds()).slice(-2), r3) {
              var o2 = t3.getUTCMilliseconds();
              0 !== o2 && (n2 += "." + (o2 = (o2 = ("00" + o2).slice(-3)).replace(/0+$/g, "")));
            }
            return n2 += "Z";
          }, e.uricmptohex = qr, e.hextouricmp = Jr, e.ipv6tohex = Wr, e.hextoipv6 = zr, e.hextoip = Yr, e.iptohex = function bn(t3) {
            var e2 = "malformed IP address";
            if (!(t3 = t3.toLowerCase(t3)).match(/^[0-9.]+$/)) {
              if (t3.match(/^[0-9a-f:]+$/) && -1 !== t3.indexOf(":"))
                return Wr(t3);
              throw e2;
            }
            var r3 = t3.split(".");
            if (4 !== r3.length)
              throw e2;
            var n2 = "";
            try {
              for (var i2 = 0; i2 < 4; i2++) {
                n2 += ("0" + parseInt(r3[i2]).toString(16)).slice(-2);
              }
              return n2;
            } catch (t4) {
              throw e2;
            }
          }, e.encodeURIComponentAll = Gr, e.newline_toUnix = function wn(t3) {
            return t3 = t3.replace(/\r\n/gm, "\n");
          }, e.newline_toDos = function Fn(t3) {
            return t3 = (t3 = t3.replace(/\r\n/gm, "\n")).replace(/\n/gm, "\r\n");
          }, e.hextoposhex = $r, e.intarystrtohex = function En(t3) {
            t3 = (t3 = (t3 = t3.replace(/^\s*\[\s*/, "")).replace(/\s*\]\s*$/, "")).replace(/\s*/g, "");
            try {
              return t3.split(/,/).map(function(t4, e2, r3) {
                var n2 = parseInt(t4);
                if (n2 < 0 || 255 < n2)
                  throw "integer not in range 0-255";
                return ("00" + n2.toString(16)).slice(-2);
              }).join("");
            } catch (t4) {
              throw "malformed integer array string: " + t4;
            }
          }, e.strdiffidx = function t3(e2, r3) {
            var n2 = e2.length;
            e2.length > r3.length && (n2 = r3.length);
            for (var i2 = 0; i2 < n2; i2++)
              if (e2.charCodeAt(i2) != r3.charCodeAt(i2))
                return i2;
            return e2.length != r3.length ? n2 : -1;
          }, e.KJUR = br;
          var xn = br.crypto;
          e.crypto = xn;
          var An = br.asn1;
          e.asn1 = An;
          var kn = br.jws;
          e.jws = kn;
          var Pn = br.lang;
          e.lang = Pn;
        }).call(this, r(28).Buffer);
      }, function(t, e, r) {
        "use strict";
        (function(t2) {
          var n = r(30), i = r(31), o = r(32);
          function s() {
            return u.TYPED_ARRAY_SUPPORT ? 2147483647 : 1073741823;
          }
          function a(t3, e2) {
            if (s() < e2)
              throw new RangeError("Invalid typed array length");
            return u.TYPED_ARRAY_SUPPORT ? (t3 = new Uint8Array(e2)).__proto__ = u.prototype : (null === t3 && (t3 = new u(e2)), t3.length = e2), t3;
          }
          function u(t3, e2, r2) {
            if (!(u.TYPED_ARRAY_SUPPORT || this instanceof u))
              return new u(t3, e2, r2);
            if ("number" == typeof t3) {
              if ("string" == typeof e2)
                throw new Error("If encoding is specified then the first argument must be a string");
              return l(this, t3);
            }
            return c(this, t3, e2, r2);
          }
          function c(t3, e2, r2, n2) {
            if ("number" == typeof e2)
              throw new TypeError('"value" argument must not be a number');
            return "undefined" != typeof ArrayBuffer && e2 instanceof ArrayBuffer ? function i2(t4, e3, r3, n3) {
              if (e3.byteLength, r3 < 0 || e3.byteLength < r3)
                throw new RangeError("'offset' is out of bounds");
              if (e3.byteLength < r3 + (n3 || 0))
                throw new RangeError("'length' is out of bounds");
              e3 = void 0 === r3 && void 0 === n3 ? new Uint8Array(e3) : void 0 === n3 ? new Uint8Array(e3, r3) : new Uint8Array(e3, r3, n3);
              u.TYPED_ARRAY_SUPPORT ? (t4 = e3).__proto__ = u.prototype : t4 = f(t4, e3);
              return t4;
            }(t3, e2, r2, n2) : "string" == typeof e2 ? function s2(t4, e3, r3) {
              "string" == typeof r3 && "" !== r3 || (r3 = "utf8");
              if (!u.isEncoding(r3))
                throw new TypeError('"encoding" must be a valid string encoding');
              var n3 = 0 | d(e3, r3), i2 = (t4 = a(t4, n3)).write(e3, r3);
              i2 !== n3 && (t4 = t4.slice(0, i2));
              return t4;
            }(t3, e2, r2) : function c2(t4, e3) {
              if (u.isBuffer(e3)) {
                var r3 = 0 | g(e3.length);
                return 0 === (t4 = a(t4, r3)).length || e3.copy(t4, 0, 0, r3), t4;
              }
              if (e3) {
                if ("undefined" != typeof ArrayBuffer && e3.buffer instanceof ArrayBuffer || "length" in e3)
                  return "number" != typeof e3.length || function n3(t5) {
                    return t5 != t5;
                  }(e3.length) ? a(t4, 0) : f(t4, e3);
                if ("Buffer" === e3.type && o(e3.data))
                  return f(t4, e3.data);
              }
              throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
            }(t3, e2);
          }
          function h(t3) {
            if ("number" != typeof t3)
              throw new TypeError('"size" argument must be a number');
            if (t3 < 0)
              throw new RangeError('"size" argument must not be negative');
          }
          function l(t3, e2) {
            if (h(e2), t3 = a(t3, e2 < 0 ? 0 : 0 | g(e2)), !u.TYPED_ARRAY_SUPPORT)
              for (var r2 = 0; r2 < e2; ++r2)
                t3[r2] = 0;
            return t3;
          }
          function f(t3, e2) {
            var r2 = e2.length < 0 ? 0 : 0 | g(e2.length);
            t3 = a(t3, r2);
            for (var n2 = 0; n2 < r2; n2 += 1)
              t3[n2] = 255 & e2[n2];
            return t3;
          }
          function g(t3) {
            if (t3 >= s())
              throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + s().toString(16) + " bytes");
            return 0 | t3;
          }
          function d(t3, e2) {
            if (u.isBuffer(t3))
              return t3.length;
            if ("undefined" != typeof ArrayBuffer && "function" == typeof ArrayBuffer.isView && (ArrayBuffer.isView(t3) || t3 instanceof ArrayBuffer))
              return t3.byteLength;
            "string" != typeof t3 && (t3 = "" + t3);
            var r2 = t3.length;
            if (0 === r2)
              return 0;
            for (var n2 = false; ; )
              switch (e2) {
                case "ascii":
                case "latin1":
                case "binary":
                  return r2;
                case "utf8":
                case "utf-8":
                case void 0:
                  return K(t3).length;
                case "ucs2":
                case "ucs-2":
                case "utf16le":
                case "utf-16le":
                  return 2 * r2;
                case "hex":
                  return r2 >>> 1;
                case "base64":
                  return q(t3).length;
                default:
                  if (n2)
                    return K(t3).length;
                  e2 = ("" + e2).toLowerCase(), n2 = true;
              }
          }
          function p(t3, e2, r2) {
            var n2 = false;
            if ((void 0 === e2 || e2 < 0) && (e2 = 0), e2 > this.length)
              return "";
            if ((void 0 === r2 || r2 > this.length) && (r2 = this.length), r2 <= 0)
              return "";
            if ((r2 >>>= 0) <= (e2 >>>= 0))
              return "";
            for (t3 || (t3 = "utf8"); ; )
              switch (t3) {
                case "hex":
                  return I(this, e2, r2);
                case "utf8":
                case "utf-8":
                  return A(this, e2, r2);
                case "ascii":
                  return T(this, e2, r2);
                case "latin1":
                case "binary":
                  return R(this, e2, r2);
                case "base64":
                  return x(this, e2, r2);
                case "ucs2":
                case "ucs-2":
                case "utf16le":
                case "utf-16le":
                  return D(this, e2, r2);
                default:
                  if (n2)
                    throw new TypeError("Unknown encoding: " + t3);
                  t3 = (t3 + "").toLowerCase(), n2 = true;
              }
          }
          function v(t3, e2, r2) {
            var n2 = t3[e2];
            t3[e2] = t3[r2], t3[r2] = n2;
          }
          function y(t3, e2, r2, n2, i2) {
            if (0 === t3.length)
              return -1;
            if ("string" == typeof r2 ? (n2 = r2, r2 = 0) : r2 > 2147483647 ? r2 = 2147483647 : r2 < -2147483648 && (r2 = -2147483648), r2 = +r2, isNaN(r2) && (r2 = i2 ? 0 : t3.length - 1), r2 < 0 && (r2 = t3.length + r2), r2 >= t3.length) {
              if (i2)
                return -1;
              r2 = t3.length - 1;
            } else if (r2 < 0) {
              if (!i2)
                return -1;
              r2 = 0;
            }
            if ("string" == typeof e2 && (e2 = u.from(e2, n2)), u.isBuffer(e2))
              return 0 === e2.length ? -1 : m(t3, e2, r2, n2, i2);
            if ("number" == typeof e2)
              return e2 &= 255, u.TYPED_ARRAY_SUPPORT && "function" == typeof Uint8Array.prototype.indexOf ? i2 ? Uint8Array.prototype.indexOf.call(t3, e2, r2) : Uint8Array.prototype.lastIndexOf.call(t3, e2, r2) : m(t3, [e2], r2, n2, i2);
            throw new TypeError("val must be string, number or Buffer");
          }
          function m(t3, e2, r2, n2, i2) {
            var o2, s2 = 1, a2 = t3.length, u2 = e2.length;
            if (void 0 !== n2 && ("ucs2" === (n2 = String(n2).toLowerCase()) || "ucs-2" === n2 || "utf16le" === n2 || "utf-16le" === n2)) {
              if (t3.length < 2 || e2.length < 2)
                return -1;
              s2 = 2, a2 /= 2, u2 /= 2, r2 /= 2;
            }
            function c2(t4, e3) {
              return 1 === s2 ? t4[e3] : t4.readUInt16BE(e3 * s2);
            }
            if (i2) {
              var h2 = -1;
              for (o2 = r2; o2 < a2; o2++)
                if (c2(t3, o2) === c2(e2, -1 === h2 ? 0 : o2 - h2)) {
                  if (-1 === h2 && (h2 = o2), o2 - h2 + 1 === u2)
                    return h2 * s2;
                } else
                  -1 !== h2 && (o2 -= o2 - h2), h2 = -1;
            } else
              for (r2 + u2 > a2 && (r2 = a2 - u2), o2 = r2; o2 >= 0; o2--) {
                for (var l2 = true, f2 = 0; f2 < u2; f2++)
                  if (c2(t3, o2 + f2) !== c2(e2, f2)) {
                    l2 = false;
                    break;
                  }
                if (l2)
                  return o2;
              }
            return -1;
          }
          function _(t3, e2, r2, n2) {
            r2 = Number(r2) || 0;
            var i2 = t3.length - r2;
            n2 ? (n2 = Number(n2)) > i2 && (n2 = i2) : n2 = i2;
            var o2 = e2.length;
            if (o2 % 2 != 0)
              throw new TypeError("Invalid hex string");
            n2 > o2 / 2 && (n2 = o2 / 2);
            for (var s2 = 0; s2 < n2; ++s2) {
              var a2 = parseInt(e2.substr(2 * s2, 2), 16);
              if (isNaN(a2))
                return s2;
              t3[r2 + s2] = a2;
            }
            return s2;
          }
          function S(t3, e2, r2, n2) {
            return J(K(e2, t3.length - r2), t3, r2, n2);
          }
          function b(t3, e2, r2, n2) {
            return J(function i2(t4) {
              for (var e3 = [], r3 = 0; r3 < t4.length; ++r3)
                e3.push(255 & t4.charCodeAt(r3));
              return e3;
            }(e2), t3, r2, n2);
          }
          function w(t3, e2, r2, n2) {
            return b(t3, e2, r2, n2);
          }
          function F(t3, e2, r2, n2) {
            return J(q(e2), t3, r2, n2);
          }
          function E(t3, e2, r2, n2) {
            return J(function i2(t4, e3) {
              for (var r3, n3, i3, o2 = [], s2 = 0; s2 < t4.length && !((e3 -= 2) < 0); ++s2)
                n3 = (r3 = t4.charCodeAt(s2)) >> 8, i3 = r3 % 256, o2.push(i3), o2.push(n3);
              return o2;
            }(e2, t3.length - r2), t3, r2, n2);
          }
          function x(t3, e2, r2) {
            return 0 === e2 && r2 === t3.length ? n.fromByteArray(t3) : n.fromByteArray(t3.slice(e2, r2));
          }
          function A(t3, e2, r2) {
            r2 = Math.min(t3.length, r2);
            for (var n2 = [], i2 = e2; i2 < r2; ) {
              var o2, s2, a2, u2, c2 = t3[i2], h2 = null, l2 = c2 > 239 ? 4 : c2 > 223 ? 3 : c2 > 191 ? 2 : 1;
              if (i2 + l2 <= r2)
                switch (l2) {
                  case 1:
                    c2 < 128 && (h2 = c2);
                    break;
                  case 2:
                    128 == (192 & (o2 = t3[i2 + 1])) && (u2 = (31 & c2) << 6 | 63 & o2) > 127 && (h2 = u2);
                    break;
                  case 3:
                    o2 = t3[i2 + 1], s2 = t3[i2 + 2], 128 == (192 & o2) && 128 == (192 & s2) && (u2 = (15 & c2) << 12 | (63 & o2) << 6 | 63 & s2) > 2047 && (u2 < 55296 || u2 > 57343) && (h2 = u2);
                    break;
                  case 4:
                    o2 = t3[i2 + 1], s2 = t3[i2 + 2], a2 = t3[i2 + 3], 128 == (192 & o2) && 128 == (192 & s2) && 128 == (192 & a2) && (u2 = (15 & c2) << 18 | (63 & o2) << 12 | (63 & s2) << 6 | 63 & a2) > 65535 && u2 < 1114112 && (h2 = u2);
                }
              null === h2 ? (h2 = 65533, l2 = 1) : h2 > 65535 && (h2 -= 65536, n2.push(h2 >>> 10 & 1023 | 55296), h2 = 56320 | 1023 & h2), n2.push(h2), i2 += l2;
            }
            return function f2(t4) {
              var e3 = t4.length;
              if (e3 <= C)
                return String.fromCharCode.apply(String, t4);
              var r3 = "", n3 = 0;
              for (; n3 < e3; )
                r3 += String.fromCharCode.apply(String, t4.slice(n3, n3 += C));
              return r3;
            }(n2);
          }
          e.Buffer = u, e.SlowBuffer = function k(t3) {
            +t3 != t3 && (t3 = 0);
            return u.alloc(+t3);
          }, e.INSPECT_MAX_BYTES = 50, u.TYPED_ARRAY_SUPPORT = void 0 !== t2.TYPED_ARRAY_SUPPORT ? t2.TYPED_ARRAY_SUPPORT : function P() {
            try {
              var t3 = new Uint8Array(1);
              return t3.__proto__ = { __proto__: Uint8Array.prototype, foo: function() {
                return 42;
              } }, 42 === t3.foo() && "function" == typeof t3.subarray && 0 === t3.subarray(1, 1).byteLength;
            } catch (t4) {
              return false;
            }
          }(), e.kMaxLength = s(), u.poolSize = 8192, u._augment = function(t3) {
            return t3.__proto__ = u.prototype, t3;
          }, u.from = function(t3, e2, r2) {
            return c(null, t3, e2, r2);
          }, u.TYPED_ARRAY_SUPPORT && (u.prototype.__proto__ = Uint8Array.prototype, u.__proto__ = Uint8Array, "undefined" != typeof Symbol && Symbol.species && u[Symbol.species] === u && Object.defineProperty(u, Symbol.species, { value: null, configurable: true })), u.alloc = function(t3, e2, r2) {
            return function n2(t4, e3, r3, i2) {
              return h(e3), e3 <= 0 ? a(t4, e3) : void 0 !== r3 ? "string" == typeof i2 ? a(t4, e3).fill(r3, i2) : a(t4, e3).fill(r3) : a(t4, e3);
            }(null, t3, e2, r2);
          }, u.allocUnsafe = function(t3) {
            return l(null, t3);
          }, u.allocUnsafeSlow = function(t3) {
            return l(null, t3);
          }, u.isBuffer = function t3(e2) {
            return !(null == e2 || !e2._isBuffer);
          }, u.compare = function t3(e2, r2) {
            if (!u.isBuffer(e2) || !u.isBuffer(r2))
              throw new TypeError("Arguments must be Buffers");
            if (e2 === r2)
              return 0;
            for (var n2 = e2.length, i2 = r2.length, o2 = 0, s2 = Math.min(n2, i2); o2 < s2; ++o2)
              if (e2[o2] !== r2[o2]) {
                n2 = e2[o2], i2 = r2[o2];
                break;
              }
            return n2 < i2 ? -1 : i2 < n2 ? 1 : 0;
          }, u.isEncoding = function t3(e2) {
            switch (String(e2).toLowerCase()) {
              case "hex":
              case "utf8":
              case "utf-8":
              case "ascii":
              case "latin1":
              case "binary":
              case "base64":
              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                return true;
              default:
                return false;
            }
          }, u.concat = function t3(e2, r2) {
            if (!o(e2))
              throw new TypeError('"list" argument must be an Array of Buffers');
            if (0 === e2.length)
              return u.alloc(0);
            var n2;
            if (void 0 === r2)
              for (r2 = 0, n2 = 0; n2 < e2.length; ++n2)
                r2 += e2[n2].length;
            var i2 = u.allocUnsafe(r2), s2 = 0;
            for (n2 = 0; n2 < e2.length; ++n2) {
              var a2 = e2[n2];
              if (!u.isBuffer(a2))
                throw new TypeError('"list" argument must be an Array of Buffers');
              a2.copy(i2, s2), s2 += a2.length;
            }
            return i2;
          }, u.byteLength = d, u.prototype._isBuffer = true, u.prototype.swap16 = function t3() {
            var e2 = this.length;
            if (e2 % 2 != 0)
              throw new RangeError("Buffer size must be a multiple of 16-bits");
            for (var r2 = 0; r2 < e2; r2 += 2)
              v(this, r2, r2 + 1);
            return this;
          }, u.prototype.swap32 = function t3() {
            var e2 = this.length;
            if (e2 % 4 != 0)
              throw new RangeError("Buffer size must be a multiple of 32-bits");
            for (var r2 = 0; r2 < e2; r2 += 4)
              v(this, r2, r2 + 3), v(this, r2 + 1, r2 + 2);
            return this;
          }, u.prototype.swap64 = function t3() {
            var e2 = this.length;
            if (e2 % 8 != 0)
              throw new RangeError("Buffer size must be a multiple of 64-bits");
            for (var r2 = 0; r2 < e2; r2 += 8)
              v(this, r2, r2 + 7), v(this, r2 + 1, r2 + 6), v(this, r2 + 2, r2 + 5), v(this, r2 + 3, r2 + 4);
            return this;
          }, u.prototype.toString = function t3() {
            var e2 = 0 | this.length;
            return 0 === e2 ? "" : 0 === arguments.length ? A(this, 0, e2) : p.apply(this, arguments);
          }, u.prototype.equals = function t3(e2) {
            if (!u.isBuffer(e2))
              throw new TypeError("Argument must be a Buffer");
            return this === e2 || 0 === u.compare(this, e2);
          }, u.prototype.inspect = function t3() {
            var r2 = "", n2 = e.INSPECT_MAX_BYTES;
            return this.length > 0 && (r2 = this.toString("hex", 0, n2).match(/.{2}/g).join(" "), this.length > n2 && (r2 += " ... ")), "<Buffer " + r2 + ">";
          }, u.prototype.compare = function t3(e2, r2, n2, i2, o2) {
            if (!u.isBuffer(e2))
              throw new TypeError("Argument must be a Buffer");
            if (void 0 === r2 && (r2 = 0), void 0 === n2 && (n2 = e2 ? e2.length : 0), void 0 === i2 && (i2 = 0), void 0 === o2 && (o2 = this.length), r2 < 0 || n2 > e2.length || i2 < 0 || o2 > this.length)
              throw new RangeError("out of range index");
            if (i2 >= o2 && r2 >= n2)
              return 0;
            if (i2 >= o2)
              return -1;
            if (r2 >= n2)
              return 1;
            if (this === e2)
              return 0;
            for (var s2 = (o2 >>>= 0) - (i2 >>>= 0), a2 = (n2 >>>= 0) - (r2 >>>= 0), c2 = Math.min(s2, a2), h2 = this.slice(i2, o2), l2 = e2.slice(r2, n2), f2 = 0; f2 < c2; ++f2)
              if (h2[f2] !== l2[f2]) {
                s2 = h2[f2], a2 = l2[f2];
                break;
              }
            return s2 < a2 ? -1 : a2 < s2 ? 1 : 0;
          }, u.prototype.includes = function t3(e2, r2, n2) {
            return -1 !== this.indexOf(e2, r2, n2);
          }, u.prototype.indexOf = function t3(e2, r2, n2) {
            return y(this, e2, r2, n2, true);
          }, u.prototype.lastIndexOf = function t3(e2, r2, n2) {
            return y(this, e2, r2, n2, false);
          }, u.prototype.write = function t3(e2, r2, n2, i2) {
            if (void 0 === r2)
              i2 = "utf8", n2 = this.length, r2 = 0;
            else if (void 0 === n2 && "string" == typeof r2)
              i2 = r2, n2 = this.length, r2 = 0;
            else {
              if (!isFinite(r2))
                throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
              r2 |= 0, isFinite(n2) ? (n2 |= 0, void 0 === i2 && (i2 = "utf8")) : (i2 = n2, n2 = void 0);
            }
            var o2 = this.length - r2;
            if ((void 0 === n2 || n2 > o2) && (n2 = o2), e2.length > 0 && (n2 < 0 || r2 < 0) || r2 > this.length)
              throw new RangeError("Attempt to write outside buffer bounds");
            i2 || (i2 = "utf8");
            for (var s2 = false; ; )
              switch (i2) {
                case "hex":
                  return _(this, e2, r2, n2);
                case "utf8":
                case "utf-8":
                  return S(this, e2, r2, n2);
                case "ascii":
                  return b(this, e2, r2, n2);
                case "latin1":
                case "binary":
                  return w(this, e2, r2, n2);
                case "base64":
                  return F(this, e2, r2, n2);
                case "ucs2":
                case "ucs-2":
                case "utf16le":
                case "utf-16le":
                  return E(this, e2, r2, n2);
                default:
                  if (s2)
                    throw new TypeError("Unknown encoding: " + i2);
                  i2 = ("" + i2).toLowerCase(), s2 = true;
              }
          }, u.prototype.toJSON = function t3() {
            return { type: "Buffer", data: Array.prototype.slice.call(this._arr || this, 0) };
          };
          var C = 4096;
          function T(t3, e2, r2) {
            var n2 = "";
            r2 = Math.min(t3.length, r2);
            for (var i2 = e2; i2 < r2; ++i2)
              n2 += String.fromCharCode(127 & t3[i2]);
            return n2;
          }
          function R(t3, e2, r2) {
            var n2 = "";
            r2 = Math.min(t3.length, r2);
            for (var i2 = e2; i2 < r2; ++i2)
              n2 += String.fromCharCode(t3[i2]);
            return n2;
          }
          function I(t3, e2, r2) {
            var n2 = t3.length;
            (!e2 || e2 < 0) && (e2 = 0), (!r2 || r2 < 0 || r2 > n2) && (r2 = n2);
            for (var i2 = "", o2 = e2; o2 < r2; ++o2)
              i2 += V(t3[o2]);
            return i2;
          }
          function D(t3, e2, r2) {
            for (var n2 = t3.slice(e2, r2), i2 = "", o2 = 0; o2 < n2.length; o2 += 2)
              i2 += String.fromCharCode(n2[o2] + 256 * n2[o2 + 1]);
            return i2;
          }
          function L(t3, e2, r2) {
            if (t3 % 1 != 0 || t3 < 0)
              throw new RangeError("offset is not uint");
            if (t3 + e2 > r2)
              throw new RangeError("Trying to access beyond buffer length");
          }
          function N(t3, e2, r2, n2, i2, o2) {
            if (!u.isBuffer(t3))
              throw new TypeError('"buffer" argument must be a Buffer instance');
            if (e2 > i2 || e2 < o2)
              throw new RangeError('"value" argument is out of bounds');
            if (r2 + n2 > t3.length)
              throw new RangeError("Index out of range");
          }
          function U(t3, e2, r2, n2) {
            e2 < 0 && (e2 = 65535 + e2 + 1);
            for (var i2 = 0, o2 = Math.min(t3.length - r2, 2); i2 < o2; ++i2)
              t3[r2 + i2] = (e2 & 255 << 8 * (n2 ? i2 : 1 - i2)) >>> 8 * (n2 ? i2 : 1 - i2);
          }
          function B(t3, e2, r2, n2) {
            e2 < 0 && (e2 = 4294967295 + e2 + 1);
            for (var i2 = 0, o2 = Math.min(t3.length - r2, 4); i2 < o2; ++i2)
              t3[r2 + i2] = e2 >>> 8 * (n2 ? i2 : 3 - i2) & 255;
          }
          function O(t3, e2, r2, n2, i2, o2) {
            if (r2 + n2 > t3.length)
              throw new RangeError("Index out of range");
            if (r2 < 0)
              throw new RangeError("Index out of range");
          }
          function j(t3, e2, r2, n2, o2) {
            return o2 || O(t3, 0, r2, 4), i.write(t3, e2, r2, n2, 23, 4), r2 + 4;
          }
          function M(t3, e2, r2, n2, o2) {
            return o2 || O(t3, 0, r2, 8), i.write(t3, e2, r2, n2, 52, 8), r2 + 8;
          }
          u.prototype.slice = function t3(e2, r2) {
            var n2, i2 = this.length;
            if ((e2 = ~~e2) < 0 ? (e2 += i2) < 0 && (e2 = 0) : e2 > i2 && (e2 = i2), (r2 = void 0 === r2 ? i2 : ~~r2) < 0 ? (r2 += i2) < 0 && (r2 = 0) : r2 > i2 && (r2 = i2), r2 < e2 && (r2 = e2), u.TYPED_ARRAY_SUPPORT)
              (n2 = this.subarray(e2, r2)).__proto__ = u.prototype;
            else {
              var o2 = r2 - e2;
              n2 = new u(o2, void 0);
              for (var s2 = 0; s2 < o2; ++s2)
                n2[s2] = this[s2 + e2];
            }
            return n2;
          }, u.prototype.readUIntLE = function t3(e2, r2, n2) {
            e2 |= 0, r2 |= 0, n2 || L(e2, r2, this.length);
            for (var i2 = this[e2], o2 = 1, s2 = 0; ++s2 < r2 && (o2 *= 256); )
              i2 += this[e2 + s2] * o2;
            return i2;
          }, u.prototype.readUIntBE = function t3(e2, r2, n2) {
            e2 |= 0, r2 |= 0, n2 || L(e2, r2, this.length);
            for (var i2 = this[e2 + --r2], o2 = 1; r2 > 0 && (o2 *= 256); )
              i2 += this[e2 + --r2] * o2;
            return i2;
          }, u.prototype.readUInt8 = function t3(e2, r2) {
            return r2 || L(e2, 1, this.length), this[e2];
          }, u.prototype.readUInt16LE = function t3(e2, r2) {
            return r2 || L(e2, 2, this.length), this[e2] | this[e2 + 1] << 8;
          }, u.prototype.readUInt16BE = function t3(e2, r2) {
            return r2 || L(e2, 2, this.length), this[e2] << 8 | this[e2 + 1];
          }, u.prototype.readUInt32LE = function t3(e2, r2) {
            return r2 || L(e2, 4, this.length), (this[e2] | this[e2 + 1] << 8 | this[e2 + 2] << 16) + 16777216 * this[e2 + 3];
          }, u.prototype.readUInt32BE = function t3(e2, r2) {
            return r2 || L(e2, 4, this.length), 16777216 * this[e2] + (this[e2 + 1] << 16 | this[e2 + 2] << 8 | this[e2 + 3]);
          }, u.prototype.readIntLE = function t3(e2, r2, n2) {
            e2 |= 0, r2 |= 0, n2 || L(e2, r2, this.length);
            for (var i2 = this[e2], o2 = 1, s2 = 0; ++s2 < r2 && (o2 *= 256); )
              i2 += this[e2 + s2] * o2;
            return i2 >= (o2 *= 128) && (i2 -= Math.pow(2, 8 * r2)), i2;
          }, u.prototype.readIntBE = function t3(e2, r2, n2) {
            e2 |= 0, r2 |= 0, n2 || L(e2, r2, this.length);
            for (var i2 = r2, o2 = 1, s2 = this[e2 + --i2]; i2 > 0 && (o2 *= 256); )
              s2 += this[e2 + --i2] * o2;
            return s2 >= (o2 *= 128) && (s2 -= Math.pow(2, 8 * r2)), s2;
          }, u.prototype.readInt8 = function t3(e2, r2) {
            return r2 || L(e2, 1, this.length), 128 & this[e2] ? -1 * (255 - this[e2] + 1) : this[e2];
          }, u.prototype.readInt16LE = function t3(e2, r2) {
            r2 || L(e2, 2, this.length);
            var n2 = this[e2] | this[e2 + 1] << 8;
            return 32768 & n2 ? 4294901760 | n2 : n2;
          }, u.prototype.readInt16BE = function t3(e2, r2) {
            r2 || L(e2, 2, this.length);
            var n2 = this[e2 + 1] | this[e2] << 8;
            return 32768 & n2 ? 4294901760 | n2 : n2;
          }, u.prototype.readInt32LE = function t3(e2, r2) {
            return r2 || L(e2, 4, this.length), this[e2] | this[e2 + 1] << 8 | this[e2 + 2] << 16 | this[e2 + 3] << 24;
          }, u.prototype.readInt32BE = function t3(e2, r2) {
            return r2 || L(e2, 4, this.length), this[e2] << 24 | this[e2 + 1] << 16 | this[e2 + 2] << 8 | this[e2 + 3];
          }, u.prototype.readFloatLE = function t3(e2, r2) {
            return r2 || L(e2, 4, this.length), i.read(this, e2, true, 23, 4);
          }, u.prototype.readFloatBE = function t3(e2, r2) {
            return r2 || L(e2, 4, this.length), i.read(this, e2, false, 23, 4);
          }, u.prototype.readDoubleLE = function t3(e2, r2) {
            return r2 || L(e2, 8, this.length), i.read(this, e2, true, 52, 8);
          }, u.prototype.readDoubleBE = function t3(e2, r2) {
            return r2 || L(e2, 8, this.length), i.read(this, e2, false, 52, 8);
          }, u.prototype.writeUIntLE = function t3(e2, r2, n2, i2) {
            (e2 = +e2, r2 |= 0, n2 |= 0, i2) || N(this, e2, r2, n2, Math.pow(2, 8 * n2) - 1, 0);
            var o2 = 1, s2 = 0;
            for (this[r2] = 255 & e2; ++s2 < n2 && (o2 *= 256); )
              this[r2 + s2] = e2 / o2 & 255;
            return r2 + n2;
          }, u.prototype.writeUIntBE = function t3(e2, r2, n2, i2) {
            (e2 = +e2, r2 |= 0, n2 |= 0, i2) || N(this, e2, r2, n2, Math.pow(2, 8 * n2) - 1, 0);
            var o2 = n2 - 1, s2 = 1;
            for (this[r2 + o2] = 255 & e2; --o2 >= 0 && (s2 *= 256); )
              this[r2 + o2] = e2 / s2 & 255;
            return r2 + n2;
          }, u.prototype.writeUInt8 = function t3(e2, r2, n2) {
            return e2 = +e2, r2 |= 0, n2 || N(this, e2, r2, 1, 255, 0), u.TYPED_ARRAY_SUPPORT || (e2 = Math.floor(e2)), this[r2] = 255 & e2, r2 + 1;
          }, u.prototype.writeUInt16LE = function t3(e2, r2, n2) {
            return e2 = +e2, r2 |= 0, n2 || N(this, e2, r2, 2, 65535, 0), u.TYPED_ARRAY_SUPPORT ? (this[r2] = 255 & e2, this[r2 + 1] = e2 >>> 8) : U(this, e2, r2, true), r2 + 2;
          }, u.prototype.writeUInt16BE = function t3(e2, r2, n2) {
            return e2 = +e2, r2 |= 0, n2 || N(this, e2, r2, 2, 65535, 0), u.TYPED_ARRAY_SUPPORT ? (this[r2] = e2 >>> 8, this[r2 + 1] = 255 & e2) : U(this, e2, r2, false), r2 + 2;
          }, u.prototype.writeUInt32LE = function t3(e2, r2, n2) {
            return e2 = +e2, r2 |= 0, n2 || N(this, e2, r2, 4, 4294967295, 0), u.TYPED_ARRAY_SUPPORT ? (this[r2 + 3] = e2 >>> 24, this[r2 + 2] = e2 >>> 16, this[r2 + 1] = e2 >>> 8, this[r2] = 255 & e2) : B(this, e2, r2, true), r2 + 4;
          }, u.prototype.writeUInt32BE = function t3(e2, r2, n2) {
            return e2 = +e2, r2 |= 0, n2 || N(this, e2, r2, 4, 4294967295, 0), u.TYPED_ARRAY_SUPPORT ? (this[r2] = e2 >>> 24, this[r2 + 1] = e2 >>> 16, this[r2 + 2] = e2 >>> 8, this[r2 + 3] = 255 & e2) : B(this, e2, r2, false), r2 + 4;
          }, u.prototype.writeIntLE = function t3(e2, r2, n2, i2) {
            if (e2 = +e2, r2 |= 0, !i2) {
              var o2 = Math.pow(2, 8 * n2 - 1);
              N(this, e2, r2, n2, o2 - 1, -o2);
            }
            var s2 = 0, a2 = 1, u2 = 0;
            for (this[r2] = 255 & e2; ++s2 < n2 && (a2 *= 256); )
              e2 < 0 && 0 === u2 && 0 !== this[r2 + s2 - 1] && (u2 = 1), this[r2 + s2] = (e2 / a2 >> 0) - u2 & 255;
            return r2 + n2;
          }, u.prototype.writeIntBE = function t3(e2, r2, n2, i2) {
            if (e2 = +e2, r2 |= 0, !i2) {
              var o2 = Math.pow(2, 8 * n2 - 1);
              N(this, e2, r2, n2, o2 - 1, -o2);
            }
            var s2 = n2 - 1, a2 = 1, u2 = 0;
            for (this[r2 + s2] = 255 & e2; --s2 >= 0 && (a2 *= 256); )
              e2 < 0 && 0 === u2 && 0 !== this[r2 + s2 + 1] && (u2 = 1), this[r2 + s2] = (e2 / a2 >> 0) - u2 & 255;
            return r2 + n2;
          }, u.prototype.writeInt8 = function t3(e2, r2, n2) {
            return e2 = +e2, r2 |= 0, n2 || N(this, e2, r2, 1, 127, -128), u.TYPED_ARRAY_SUPPORT || (e2 = Math.floor(e2)), e2 < 0 && (e2 = 255 + e2 + 1), this[r2] = 255 & e2, r2 + 1;
          }, u.prototype.writeInt16LE = function t3(e2, r2, n2) {
            return e2 = +e2, r2 |= 0, n2 || N(this, e2, r2, 2, 32767, -32768), u.TYPED_ARRAY_SUPPORT ? (this[r2] = 255 & e2, this[r2 + 1] = e2 >>> 8) : U(this, e2, r2, true), r2 + 2;
          }, u.prototype.writeInt16BE = function t3(e2, r2, n2) {
            return e2 = +e2, r2 |= 0, n2 || N(this, e2, r2, 2, 32767, -32768), u.TYPED_ARRAY_SUPPORT ? (this[r2] = e2 >>> 8, this[r2 + 1] = 255 & e2) : U(this, e2, r2, false), r2 + 2;
          }, u.prototype.writeInt32LE = function t3(e2, r2, n2) {
            return e2 = +e2, r2 |= 0, n2 || N(this, e2, r2, 4, 2147483647, -2147483648), u.TYPED_ARRAY_SUPPORT ? (this[r2] = 255 & e2, this[r2 + 1] = e2 >>> 8, this[r2 + 2] = e2 >>> 16, this[r2 + 3] = e2 >>> 24) : B(this, e2, r2, true), r2 + 4;
          }, u.prototype.writeInt32BE = function t3(e2, r2, n2) {
            return e2 = +e2, r2 |= 0, n2 || N(this, e2, r2, 4, 2147483647, -2147483648), e2 < 0 && (e2 = 4294967295 + e2 + 1), u.TYPED_ARRAY_SUPPORT ? (this[r2] = e2 >>> 24, this[r2 + 1] = e2 >>> 16, this[r2 + 2] = e2 >>> 8, this[r2 + 3] = 255 & e2) : B(this, e2, r2, false), r2 + 4;
          }, u.prototype.writeFloatLE = function t3(e2, r2, n2) {
            return j(this, e2, r2, true, n2);
          }, u.prototype.writeFloatBE = function t3(e2, r2, n2) {
            return j(this, e2, r2, false, n2);
          }, u.prototype.writeDoubleLE = function t3(e2, r2, n2) {
            return M(this, e2, r2, true, n2);
          }, u.prototype.writeDoubleBE = function t3(e2, r2, n2) {
            return M(this, e2, r2, false, n2);
          }, u.prototype.copy = function t3(e2, r2, n2, i2) {
            if (n2 || (n2 = 0), i2 || 0 === i2 || (i2 = this.length), r2 >= e2.length && (r2 = e2.length), r2 || (r2 = 0), i2 > 0 && i2 < n2 && (i2 = n2), i2 === n2)
              return 0;
            if (0 === e2.length || 0 === this.length)
              return 0;
            if (r2 < 0)
              throw new RangeError("targetStart out of bounds");
            if (n2 < 0 || n2 >= this.length)
              throw new RangeError("sourceStart out of bounds");
            if (i2 < 0)
              throw new RangeError("sourceEnd out of bounds");
            i2 > this.length && (i2 = this.length), e2.length - r2 < i2 - n2 && (i2 = e2.length - r2 + n2);
            var o2, s2 = i2 - n2;
            if (this === e2 && n2 < r2 && r2 < i2)
              for (o2 = s2 - 1; o2 >= 0; --o2)
                e2[o2 + r2] = this[o2 + n2];
            else if (s2 < 1e3 || !u.TYPED_ARRAY_SUPPORT)
              for (o2 = 0; o2 < s2; ++o2)
                e2[o2 + r2] = this[o2 + n2];
            else
              Uint8Array.prototype.set.call(e2, this.subarray(n2, n2 + s2), r2);
            return s2;
          }, u.prototype.fill = function t3(e2, r2, n2, i2) {
            if ("string" == typeof e2) {
              if ("string" == typeof r2 ? (i2 = r2, r2 = 0, n2 = this.length) : "string" == typeof n2 && (i2 = n2, n2 = this.length), 1 === e2.length) {
                var o2 = e2.charCodeAt(0);
                o2 < 256 && (e2 = o2);
              }
              if (void 0 !== i2 && "string" != typeof i2)
                throw new TypeError("encoding must be a string");
              if ("string" == typeof i2 && !u.isEncoding(i2))
                throw new TypeError("Unknown encoding: " + i2);
            } else
              "number" == typeof e2 && (e2 &= 255);
            if (r2 < 0 || this.length < r2 || this.length < n2)
              throw new RangeError("Out of range index");
            if (n2 <= r2)
              return this;
            var s2;
            if (r2 >>>= 0, n2 = void 0 === n2 ? this.length : n2 >>> 0, e2 || (e2 = 0), "number" == typeof e2)
              for (s2 = r2; s2 < n2; ++s2)
                this[s2] = e2;
            else {
              var a2 = u.isBuffer(e2) ? e2 : K(new u(e2, i2).toString()), c2 = a2.length;
              for (s2 = 0; s2 < n2 - r2; ++s2)
                this[s2 + r2] = a2[s2 % c2];
            }
            return this;
          };
          var H = /[^+\/0-9A-Za-z-_]/g;
          function V(t3) {
            return t3 < 16 ? "0" + t3.toString(16) : t3.toString(16);
          }
          function K(t3, e2) {
            var r2;
            e2 = e2 || 1 / 0;
            for (var n2 = t3.length, i2 = null, o2 = [], s2 = 0; s2 < n2; ++s2) {
              if ((r2 = t3.charCodeAt(s2)) > 55295 && r2 < 57344) {
                if (!i2) {
                  if (r2 > 56319) {
                    (e2 -= 3) > -1 && o2.push(239, 191, 189);
                    continue;
                  }
                  if (s2 + 1 === n2) {
                    (e2 -= 3) > -1 && o2.push(239, 191, 189);
                    continue;
                  }
                  i2 = r2;
                  continue;
                }
                if (r2 < 56320) {
                  (e2 -= 3) > -1 && o2.push(239, 191, 189), i2 = r2;
                  continue;
                }
                r2 = 65536 + (i2 - 55296 << 10 | r2 - 56320);
              } else
                i2 && (e2 -= 3) > -1 && o2.push(239, 191, 189);
              if (i2 = null, r2 < 128) {
                if ((e2 -= 1) < 0)
                  break;
                o2.push(r2);
              } else if (r2 < 2048) {
                if ((e2 -= 2) < 0)
                  break;
                o2.push(r2 >> 6 | 192, 63 & r2 | 128);
              } else if (r2 < 65536) {
                if ((e2 -= 3) < 0)
                  break;
                o2.push(r2 >> 12 | 224, r2 >> 6 & 63 | 128, 63 & r2 | 128);
              } else {
                if (!(r2 < 1114112))
                  throw new Error("Invalid code point");
                if ((e2 -= 4) < 0)
                  break;
                o2.push(r2 >> 18 | 240, r2 >> 12 & 63 | 128, r2 >> 6 & 63 | 128, 63 & r2 | 128);
              }
            }
            return o2;
          }
          function q(t3) {
            return n.toByteArray(function e2(t4) {
              if ((t4 = function e3(t5) {
                return t5.trim ? t5.trim() : t5.replace(/^\s+|\s+$/g, "");
              }(t4).replace(H, "")).length < 2)
                return "";
              for (; t4.length % 4 != 0; )
                t4 += "=";
              return t4;
            }(t3));
          }
          function J(t3, e2, r2, n2) {
            for (var i2 = 0; i2 < n2 && !(i2 + r2 >= e2.length || i2 >= t3.length); ++i2)
              e2[i2 + r2] = t3[i2];
            return i2;
          }
        }).call(this, r(29));
      }, function(t, e) {
        var r;
        r = function() {
          return this;
        }();
        try {
          r = r || new Function("return this")();
        } catch (t2) {
          "object" == typeof window && (r = window);
        }
        t.exports = r;
      }, function(t, e, r) {
        "use strict";
        e.byteLength = function n(t2) {
          var e2 = f(t2), r2 = e2[0], n2 = e2[1];
          return 3 * (r2 + n2) / 4 - n2;
        }, e.toByteArray = function i(t2) {
          var e2, r2, n = f(t2), i2 = n[0], o = n[1], s2 = new u(function c2(t3, e3, r3) {
            return 3 * (e3 + r3) / 4 - r3;
          }(0, i2, o)), h2 = 0, l2 = o > 0 ? i2 - 4 : i2;
          for (r2 = 0; r2 < l2; r2 += 4)
            e2 = a[t2.charCodeAt(r2)] << 18 | a[t2.charCodeAt(r2 + 1)] << 12 | a[t2.charCodeAt(r2 + 2)] << 6 | a[t2.charCodeAt(r2 + 3)], s2[h2++] = e2 >> 16 & 255, s2[h2++] = e2 >> 8 & 255, s2[h2++] = 255 & e2;
          2 === o && (e2 = a[t2.charCodeAt(r2)] << 2 | a[t2.charCodeAt(r2 + 1)] >> 4, s2[h2++] = 255 & e2);
          1 === o && (e2 = a[t2.charCodeAt(r2)] << 10 | a[t2.charCodeAt(r2 + 1)] << 4 | a[t2.charCodeAt(r2 + 2)] >> 2, s2[h2++] = e2 >> 8 & 255, s2[h2++] = 255 & e2);
          return s2;
        }, e.fromByteArray = function o(t2) {
          for (var e2, r2 = t2.length, n = r2 % 3, i = [], o2 = 16383, a2 = 0, u2 = r2 - n; a2 < u2; a2 += o2)
            i.push(g(t2, a2, a2 + o2 > u2 ? u2 : a2 + o2));
          1 === n ? (e2 = t2[r2 - 1], i.push(s[e2 >> 2] + s[e2 << 4 & 63] + "==")) : 2 === n && (e2 = (t2[r2 - 2] << 8) + t2[r2 - 1], i.push(s[e2 >> 10] + s[e2 >> 4 & 63] + s[e2 << 2 & 63] + "="));
          return i.join("");
        };
        for (var s = [], a = [], u = "undefined" != typeof Uint8Array ? Uint8Array : Array, c = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", h = 0, l = c.length; h < l; ++h)
          s[h] = c[h], a[c.charCodeAt(h)] = h;
        function f(t2) {
          var e2 = t2.length;
          if (e2 % 4 > 0)
            throw new Error("Invalid string. Length must be a multiple of 4");
          var r2 = t2.indexOf("=");
          return -1 === r2 && (r2 = e2), [r2, r2 === e2 ? 0 : 4 - r2 % 4];
        }
        function g(t2, e2, r2) {
          for (var n, i, o = [], a2 = e2; a2 < r2; a2 += 3)
            n = (t2[a2] << 16 & 16711680) + (t2[a2 + 1] << 8 & 65280) + (255 & t2[a2 + 2]), o.push(s[(i = n) >> 18 & 63] + s[i >> 12 & 63] + s[i >> 6 & 63] + s[63 & i]);
          return o.join("");
        }
        a["-".charCodeAt(0)] = 62, a["_".charCodeAt(0)] = 63;
      }, function(t, e) {
        e.read = function(t2, e2, r, n, i) {
          var o, s, a = 8 * i - n - 1, u = (1 << a) - 1, c = u >> 1, h = -7, l = r ? i - 1 : 0, f = r ? -1 : 1, g = t2[e2 + l];
          for (l += f, o = g & (1 << -h) - 1, g >>= -h, h += a; h > 0; o = 256 * o + t2[e2 + l], l += f, h -= 8)
            ;
          for (s = o & (1 << -h) - 1, o >>= -h, h += n; h > 0; s = 256 * s + t2[e2 + l], l += f, h -= 8)
            ;
          if (0 === o)
            o = 1 - c;
          else {
            if (o === u)
              return s ? NaN : 1 / 0 * (g ? -1 : 1);
            s += Math.pow(2, n), o -= c;
          }
          return (g ? -1 : 1) * s * Math.pow(2, o - n);
        }, e.write = function(t2, e2, r, n, i, o) {
          var s, a, u, c = 8 * o - i - 1, h = (1 << c) - 1, l = h >> 1, f = 23 === i ? Math.pow(2, -24) - Math.pow(2, -77) : 0, g = n ? 0 : o - 1, d = n ? 1 : -1, p = e2 < 0 || 0 === e2 && 1 / e2 < 0 ? 1 : 0;
          for (e2 = Math.abs(e2), isNaN(e2) || e2 === 1 / 0 ? (a = isNaN(e2) ? 1 : 0, s = h) : (s = Math.floor(Math.log(e2) / Math.LN2), e2 * (u = Math.pow(2, -s)) < 1 && (s--, u *= 2), (e2 += s + l >= 1 ? f / u : f * Math.pow(2, 1 - l)) * u >= 2 && (s++, u /= 2), s + l >= h ? (a = 0, s = h) : s + l >= 1 ? (a = (e2 * u - 1) * Math.pow(2, i), s += l) : (a = e2 * Math.pow(2, l - 1) * Math.pow(2, i), s = 0)); i >= 8; t2[r + g] = 255 & a, g += d, a /= 256, i -= 8)
            ;
          for (s = s << i | a, c += i; c > 0; t2[r + g] = 255 & s, g += d, s /= 256, c -= 8)
            ;
          t2[r + g - d] |= 128 * p;
        };
      }, function(t, e) {
        var r = {}.toString;
        t.exports = Array.isArray || function(t2) {
          return "[object Array]" == r.call(t2);
        };
      }, function(t, e, r) {
        "use strict";
        Object.defineProperty(e, "__esModule", { value: true }), e.default = function n(t2) {
          var e2 = t2.jws, r2 = t2.KeyUtil, n2 = t2.X509, o = t2.crypto, s = t2.hextob64u, a = t2.b64tohex, u = t2.AllowedSigningAlgs;
          return function() {
            function t3() {
              !function e3(t4, r3) {
                if (!(t4 instanceof r3))
                  throw new TypeError("Cannot call a class as a function");
              }(this, t3);
            }
            return t3.parseJwt = function t4(r3) {
              i.Log.debug("JoseUtil.parseJwt");
              try {
                var n3 = e2.JWS.parse(r3);
                return { header: n3.headerObj, payload: n3.payloadObj };
              } catch (t5) {
                i.Log.error(t5);
              }
            }, t3.validateJwt = function e3(o2, s2, u2, c, h, l, f) {
              i.Log.debug("JoseUtil.validateJwt");
              try {
                if ("RSA" === s2.kty)
                  if (s2.e && s2.n)
                    s2 = r2.getKey(s2);
                  else {
                    if (!s2.x5c || !s2.x5c.length)
                      return i.Log.error("JoseUtil.validateJwt: RSA key missing key material", s2), Promise.reject(new Error("RSA key missing key material"));
                    var g = a(s2.x5c[0]);
                    s2 = n2.getPublicKeyFromCertHex(g);
                  }
                else {
                  if ("EC" !== s2.kty)
                    return i.Log.error("JoseUtil.validateJwt: Unsupported key type", s2 && s2.kty), Promise.reject(new Error(s2.kty));
                  if (!(s2.crv && s2.x && s2.y))
                    return i.Log.error("JoseUtil.validateJwt: EC key missing key material", s2), Promise.reject(new Error("EC key missing key material"));
                  s2 = r2.getKey(s2);
                }
                return t3._validateJwt(o2, s2, u2, c, h, l, f);
              } catch (t4) {
                return i.Log.error(t4 && t4.message || t4), Promise.reject("JWT validation failed");
              }
            }, t3.validateJwtAttributes = function e3(r3, n3, o2, s2, a2, u2) {
              s2 || (s2 = 0), a2 || (a2 = parseInt(Date.now() / 1e3));
              var c = t3.parseJwt(r3).payload;
              if (!c.iss)
                return i.Log.error("JoseUtil._validateJwt: issuer was not provided"), Promise.reject(new Error("issuer was not provided"));
              if (c.iss !== n3)
                return i.Log.error("JoseUtil._validateJwt: Invalid issuer in token", c.iss), Promise.reject(new Error("Invalid issuer in token: " + c.iss));
              if (!c.aud)
                return i.Log.error("JoseUtil._validateJwt: aud was not provided"), Promise.reject(new Error("aud was not provided"));
              if (!(c.aud === o2 || Array.isArray(c.aud) && c.aud.indexOf(o2) >= 0))
                return i.Log.error("JoseUtil._validateJwt: Invalid audience in token", c.aud), Promise.reject(new Error("Invalid audience in token: " + c.aud));
              if (c.azp && c.azp !== o2)
                return i.Log.error("JoseUtil._validateJwt: Invalid azp in token", c.azp), Promise.reject(new Error("Invalid azp in token: " + c.azp));
              if (!u2) {
                var h = a2 + s2, l = a2 - s2;
                if (!c.iat)
                  return i.Log.error("JoseUtil._validateJwt: iat was not provided"), Promise.reject(new Error("iat was not provided"));
                if (h < c.iat)
                  return i.Log.error("JoseUtil._validateJwt: iat is in the future", c.iat), Promise.reject(new Error("iat is in the future: " + c.iat));
                if (c.nbf && h < c.nbf)
                  return i.Log.error("JoseUtil._validateJwt: nbf is in the future", c.nbf), Promise.reject(new Error("nbf is in the future: " + c.nbf));
                if (!c.exp)
                  return i.Log.error("JoseUtil._validateJwt: exp was not provided"), Promise.reject(new Error("exp was not provided"));
                if (c.exp < l)
                  return i.Log.error("JoseUtil._validateJwt: exp is in the past", c.exp), Promise.reject(new Error("exp is in the past:" + c.exp));
              }
              return Promise.resolve(c);
            }, t3._validateJwt = function r3(n3, o2, s2, a2, c, h, l) {
              return t3.validateJwtAttributes(n3, s2, a2, c, h, l).then(function(t4) {
                try {
                  return e2.JWS.verify(n3, o2, u) ? t4 : (i.Log.error("JoseUtil._validateJwt: signature validation failed"), Promise.reject(new Error("signature validation failed")));
                } catch (t5) {
                  return i.Log.error(t5 && t5.message || t5), Promise.reject(new Error("signature validation failed"));
                }
              });
            }, t3.hashString = function t4(e3, r3) {
              try {
                return o.Util.hashString(e3, r3);
              } catch (t5) {
                i.Log.error(t5);
              }
            }, t3.hexToBase64Url = function t4(e3) {
              try {
                return s(e3);
              } catch (t5) {
                i.Log.error(t5);
              }
            }, t3;
          }();
        };
        var i = r(0);
        t.exports = e.default;
      }, function(t, e, r) {
        "use strict";
        Object.defineProperty(e, "__esModule", { value: true }), e.SigninResponse = void 0;
        var n = function() {
          function t2(t3, e2) {
            for (var r2 = 0; r2 < e2.length; r2++) {
              var n2 = e2[r2];
              n2.enumerable = n2.enumerable || false, n2.configurable = true, "value" in n2 && (n2.writable = true), Object.defineProperty(t3, n2.key, n2);
            }
          }
          return function(e2, r2, n2) {
            return r2 && t2(e2.prototype, r2), n2 && t2(e2, n2), e2;
          };
        }(), i = r(3);
        function o(t2, e2) {
          if (!(t2 instanceof e2))
            throw new TypeError("Cannot call a class as a function");
        }
        e.SigninResponse = function() {
          function t2(e2) {
            var r2 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "#";
            o(this, t2);
            var n2 = i.UrlUtility.parseUrlFragment(e2, r2);
            this.error = n2.error, this.error_description = n2.error_description, this.error_uri = n2.error_uri, this.code = n2.code, this.state = n2.state, this.id_token = n2.id_token, this.session_state = n2.session_state, this.access_token = n2.access_token, this.token_type = n2.token_type, this.scope = n2.scope, this.profile = void 0, this.expires_in = n2.expires_in;
          }
          return n(t2, [{ key: "expires_in", get: function t3() {
            if (this.expires_at) {
              var e2 = parseInt(Date.now() / 1e3);
              return this.expires_at - e2;
            }
          }, set: function t3(e2) {
            var r2 = parseInt(e2);
            if ("number" == typeof r2 && r2 > 0) {
              var n2 = parseInt(Date.now() / 1e3);
              this.expires_at = n2 + r2;
            }
          } }, { key: "expired", get: function t3() {
            var e2 = this.expires_in;
            if (void 0 !== e2)
              return e2 <= 0;
          } }, { key: "scopes", get: function t3() {
            return (this.scope || "").split(" ");
          } }, { key: "isOpenIdConnect", get: function t3() {
            return this.scopes.indexOf("openid") >= 0 || !!this.id_token;
          } }]), t2;
        }();
      }, function(t, e, r) {
        "use strict";
        Object.defineProperty(e, "__esModule", { value: true }), e.SignoutRequest = void 0;
        var n = r(0), i = r(3), o = r(9);
        e.SignoutRequest = function t2(e2) {
          var r2 = e2.url, s = e2.id_token_hint, a = e2.post_logout_redirect_uri, u = e2.data, c = e2.extraQueryParams, h = e2.request_type;
          if (function l(t3, e3) {
            if (!(t3 instanceof e3))
              throw new TypeError("Cannot call a class as a function");
          }(this, t2), !r2)
            throw n.Log.error("SignoutRequest.ctor: No url passed"), new Error("url");
          for (var f in s && (r2 = i.UrlUtility.addQueryParam(r2, "id_token_hint", s)), a && (r2 = i.UrlUtility.addQueryParam(r2, "post_logout_redirect_uri", a), u && (this.state = new o.State({ data: u, request_type: h }), r2 = i.UrlUtility.addQueryParam(r2, "state", this.state.id))), c)
            r2 = i.UrlUtility.addQueryParam(r2, f, c[f]);
          this.url = r2;
        };
      }, function(t, e, r) {
        "use strict";
        Object.defineProperty(e, "__esModule", { value: true }), e.SignoutResponse = void 0;
        var n = r(3);
        e.SignoutResponse = function t2(e2) {
          !function r2(t3, e3) {
            if (!(t3 instanceof e3))
              throw new TypeError("Cannot call a class as a function");
          }(this, t2);
          var i = n.UrlUtility.parseUrlFragment(e2, "?");
          this.error = i.error, this.error_description = i.error_description, this.error_uri = i.error_uri, this.state = i.state;
        };
      }, function(t, e, r) {
        "use strict";
        Object.defineProperty(e, "__esModule", { value: true }), e.InMemoryWebStorage = void 0;
        var n = function() {
          function t2(t3, e2) {
            for (var r2 = 0; r2 < e2.length; r2++) {
              var n2 = e2[r2];
              n2.enumerable = n2.enumerable || false, n2.configurable = true, "value" in n2 && (n2.writable = true), Object.defineProperty(t3, n2.key, n2);
            }
          }
          return function(e2, r2, n2) {
            return r2 && t2(e2.prototype, r2), n2 && t2(e2, n2), e2;
          };
        }(), i = r(0);
        e.InMemoryWebStorage = function() {
          function t2() {
            !function e2(t3, r2) {
              if (!(t3 instanceof r2))
                throw new TypeError("Cannot call a class as a function");
            }(this, t2), this._data = {};
          }
          return t2.prototype.getItem = function t3(e2) {
            return i.Log.debug("InMemoryWebStorage.getItem", e2), this._data[e2];
          }, t2.prototype.setItem = function t3(e2, r2) {
            i.Log.debug("InMemoryWebStorage.setItem", e2), this._data[e2] = r2;
          }, t2.prototype.removeItem = function t3(e2) {
            i.Log.debug("InMemoryWebStorage.removeItem", e2), delete this._data[e2];
          }, t2.prototype.key = function t3(e2) {
            return Object.getOwnPropertyNames(this._data)[e2];
          }, n(t2, [{ key: "length", get: function t3() {
            return Object.getOwnPropertyNames(this._data).length;
          } }]), t2;
        }();
      }, function(t, e, r) {
        "use strict";
        Object.defineProperty(e, "__esModule", { value: true }), e.UserManager = void 0;
        var n = function() {
          function t2(t3, e2) {
            for (var r2 = 0; r2 < e2.length; r2++) {
              var n2 = e2[r2];
              n2.enumerable = n2.enumerable || false, n2.configurable = true, "value" in n2 && (n2.writable = true), Object.defineProperty(t3, n2.key, n2);
            }
          }
          return function(e2, r2, n2) {
            return r2 && t2(e2.prototype, r2), n2 && t2(e2, n2), e2;
          };
        }(), i = r(0), o = r(10), s = r(39), a = r(15), u = r(45), c = r(47), h = r(18), l = r(8), f = r(20), g = r(11), d = r(4);
        function p(t2, e2) {
          if (!(t2 instanceof e2))
            throw new TypeError("Cannot call a class as a function");
        }
        function v(t2, e2) {
          if (!t2)
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !e2 || "object" != typeof e2 && "function" != typeof e2 ? t2 : e2;
        }
        e.UserManager = function(t2) {
          function e2() {
            var r2 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, n2 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : c.SilentRenewService, o2 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : h.SessionMonitor, a2 = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : f.TokenRevocationClient, l2 = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : g.TokenClient, y = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : d.JoseUtil;
            p(this, e2), r2 instanceof s.UserManagerSettings || (r2 = new s.UserManagerSettings(r2));
            var m = v(this, t2.call(this, r2));
            return m._events = new u.UserManagerEvents(r2), m._silentRenewService = new n2(m), m.settings.automaticSilentRenew && (i.Log.debug("UserManager.ctor: automaticSilentRenew is configured, setting up silent renew"), m.startSilentRenew()), m.settings.monitorSession && (i.Log.debug("UserManager.ctor: monitorSession is configured, setting up session monitor"), m._sessionMonitor = new o2(m)), m._tokenRevocationClient = new a2(m._settings), m._tokenClient = new l2(m._settings), m._joseUtil = y, m;
          }
          return function r2(t3, e3) {
            if ("function" != typeof e3 && null !== e3)
              throw new TypeError("Super expression must either be null or a function, not " + typeof e3);
            t3.prototype = Object.create(e3 && e3.prototype, { constructor: { value: t3, enumerable: false, writable: true, configurable: true } }), e3 && (Object.setPrototypeOf ? Object.setPrototypeOf(t3, e3) : t3.__proto__ = e3);
          }(e2, t2), e2.prototype.getUser = function t3() {
            var e3 = this;
            return this._loadUser().then(function(t4) {
              return t4 ? (i.Log.info("UserManager.getUser: user loaded"), e3._events.load(t4, false), t4) : (i.Log.info("UserManager.getUser: user not found in storage"), null);
            });
          }, e2.prototype.removeUser = function t3() {
            var e3 = this;
            return this.storeUser(null).then(function() {
              i.Log.info("UserManager.removeUser: user removed from storage"), e3._events.unload();
            });
          }, e2.prototype.signinRedirect = function t3() {
            var e3 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            (e3 = Object.assign({}, e3)).request_type = "si:r";
            var r2 = { useReplaceToNavigate: e3.useReplaceToNavigate };
            return this._signinStart(e3, this._redirectNavigator, r2).then(function() {
              i.Log.info("UserManager.signinRedirect: successful");
            });
          }, e2.prototype.signinRedirectCallback = function t3(e3) {
            return this._signinEnd(e3 || this._redirectNavigator.url).then(function(t4) {
              return t4.profile && t4.profile.sub ? i.Log.info("UserManager.signinRedirectCallback: successful, signed in sub: ", t4.profile.sub) : i.Log.info("UserManager.signinRedirectCallback: no sub"), t4;
            });
          }, e2.prototype.signinPopup = function t3() {
            var e3 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            (e3 = Object.assign({}, e3)).request_type = "si:p";
            var r2 = e3.redirect_uri || this.settings.popup_redirect_uri || this.settings.redirect_uri;
            return r2 ? (e3.redirect_uri = r2, e3.display = "popup", this._signin(e3, this._popupNavigator, { startUrl: r2, popupWindowFeatures: e3.popupWindowFeatures || this.settings.popupWindowFeatures, popupWindowTarget: e3.popupWindowTarget || this.settings.popupWindowTarget }).then(function(t4) {
              return t4 && (t4.profile && t4.profile.sub ? i.Log.info("UserManager.signinPopup: signinPopup successful, signed in sub: ", t4.profile.sub) : i.Log.info("UserManager.signinPopup: no sub")), t4;
            })) : (i.Log.error("UserManager.signinPopup: No popup_redirect_uri or redirect_uri configured"), Promise.reject(new Error("No popup_redirect_uri or redirect_uri configured")));
          }, e2.prototype.signinPopupCallback = function t3(e3) {
            return this._signinCallback(e3, this._popupNavigator).then(function(t4) {
              return t4 && (t4.profile && t4.profile.sub ? i.Log.info("UserManager.signinPopupCallback: successful, signed in sub: ", t4.profile.sub) : i.Log.info("UserManager.signinPopupCallback: no sub")), t4;
            }).catch(function(t4) {
              i.Log.error(t4.message);
            });
          }, e2.prototype.signinSilent = function t3() {
            var e3 = this, r2 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            return r2 = Object.assign({}, r2), this._loadUser().then(function(t4) {
              return t4 && t4.refresh_token ? (r2.refresh_token = t4.refresh_token, e3._useRefreshToken(r2)) : (r2.request_type = "si:s", r2.id_token_hint = r2.id_token_hint || e3.settings.includeIdTokenInSilentRenew && t4 && t4.id_token, t4 && e3._settings.validateSubOnSilentRenew && (i.Log.debug("UserManager.signinSilent, subject prior to silent renew: ", t4.profile.sub), r2.current_sub = t4.profile.sub), e3._signinSilentIframe(r2));
            });
          }, e2.prototype._useRefreshToken = function t3() {
            var e3 = this, r2 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            return this._tokenClient.exchangeRefreshToken(r2).then(function(t4) {
              return t4 ? t4.access_token ? e3._loadUser().then(function(r3) {
                if (r3) {
                  var n2 = Promise.resolve();
                  return t4.id_token && (n2 = e3._validateIdTokenFromTokenRefreshToken(r3.profile, t4.id_token)), n2.then(function() {
                    return i.Log.debug("UserManager._useRefreshToken: refresh token response success"), r3.id_token = t4.id_token || r3.id_token, r3.access_token = t4.access_token, r3.refresh_token = t4.refresh_token || r3.refresh_token, r3.expires_in = t4.expires_in, e3.storeUser(r3).then(function() {
                      return e3._events.load(r3), r3;
                    });
                  });
                }
                return null;
              }) : (i.Log.error("UserManager._useRefreshToken: No access token returned from token endpoint"), Promise.reject("No access token returned from token endpoint")) : (i.Log.error("UserManager._useRefreshToken: No response returned from token endpoint"), Promise.reject("No response returned from token endpoint"));
            });
          }, e2.prototype._validateIdTokenFromTokenRefreshToken = function t3(e3, r2) {
            var n2 = this;
            return this._metadataService.getIssuer().then(function(t4) {
              return n2.settings.getEpochTime().then(function(o2) {
                return n2._joseUtil.validateJwtAttributes(r2, t4, n2._settings.client_id, n2._settings.clockSkew, o2).then(function(t5) {
                  return t5 ? t5.sub !== e3.sub ? (i.Log.error("UserManager._validateIdTokenFromTokenRefreshToken: sub in id_token does not match current sub"), Promise.reject(new Error("sub in id_token does not match current sub"))) : t5.auth_time && t5.auth_time !== e3.auth_time ? (i.Log.error("UserManager._validateIdTokenFromTokenRefreshToken: auth_time in id_token does not match original auth_time"), Promise.reject(new Error("auth_time in id_token does not match original auth_time"))) : t5.azp && t5.azp !== e3.azp ? (i.Log.error("UserManager._validateIdTokenFromTokenRefreshToken: azp in id_token does not match original azp"), Promise.reject(new Error("azp in id_token does not match original azp"))) : !t5.azp && e3.azp ? (i.Log.error("UserManager._validateIdTokenFromTokenRefreshToken: azp not in id_token, but present in original id_token"), Promise.reject(new Error("azp not in id_token, but present in original id_token"))) : void 0 : (i.Log.error("UserManager._validateIdTokenFromTokenRefreshToken: Failed to validate id_token"), Promise.reject(new Error("Failed to validate id_token")));
                });
              });
            });
          }, e2.prototype._signinSilentIframe = function t3() {
            var e3 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, r2 = e3.redirect_uri || this.settings.silent_redirect_uri || this.settings.redirect_uri;
            return r2 ? (e3.redirect_uri = r2, e3.prompt = e3.prompt || "none", this._signin(e3, this._iframeNavigator, { startUrl: r2, silentRequestTimeout: e3.silentRequestTimeout || this.settings.silentRequestTimeout }).then(function(t4) {
              return t4 && (t4.profile && t4.profile.sub ? i.Log.info("UserManager.signinSilent: successful, signed in sub: ", t4.profile.sub) : i.Log.info("UserManager.signinSilent: no sub")), t4;
            })) : (i.Log.error("UserManager.signinSilent: No silent_redirect_uri configured"), Promise.reject(new Error("No silent_redirect_uri configured")));
          }, e2.prototype.signinSilentCallback = function t3(e3) {
            return this._signinCallback(e3, this._iframeNavigator).then(function(t4) {
              return t4 && (t4.profile && t4.profile.sub ? i.Log.info("UserManager.signinSilentCallback: successful, signed in sub: ", t4.profile.sub) : i.Log.info("UserManager.signinSilentCallback: no sub")), t4;
            });
          }, e2.prototype.signinCallback = function t3(e3) {
            var r2 = this;
            return this.readSigninResponseState(e3).then(function(t4) {
              var n2 = t4.state;
              t4.response;
              return "si:r" === n2.request_type ? r2.signinRedirectCallback(e3) : "si:p" === n2.request_type ? r2.signinPopupCallback(e3) : "si:s" === n2.request_type ? r2.signinSilentCallback(e3) : Promise.reject(new Error("invalid response_type in state"));
            });
          }, e2.prototype.signoutCallback = function t3(e3, r2) {
            var n2 = this;
            return this.readSignoutResponseState(e3).then(function(t4) {
              var i2 = t4.state, o2 = t4.response;
              return i2 ? "so:r" === i2.request_type ? n2.signoutRedirectCallback(e3) : "so:p" === i2.request_type ? n2.signoutPopupCallback(e3, r2) : Promise.reject(new Error("invalid response_type in state")) : o2;
            });
          }, e2.prototype.querySessionStatus = function t3() {
            var e3 = this, r2 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            (r2 = Object.assign({}, r2)).request_type = "si:s";
            var n2 = r2.redirect_uri || this.settings.silent_redirect_uri || this.settings.redirect_uri;
            return n2 ? (r2.redirect_uri = n2, r2.prompt = "none", r2.response_type = r2.response_type || this.settings.query_status_response_type, r2.scope = r2.scope || "openid", r2.skipUserInfo = true, this._signinStart(r2, this._iframeNavigator, { startUrl: n2, silentRequestTimeout: r2.silentRequestTimeout || this.settings.silentRequestTimeout }).then(function(t4) {
              return e3.processSigninResponse(t4.url).then(function(t5) {
                if (i.Log.debug("UserManager.querySessionStatus: got signin response"), t5.session_state && t5.profile.sub)
                  return i.Log.info("UserManager.querySessionStatus: querySessionStatus success for sub: ", t5.profile.sub), { session_state: t5.session_state, sub: t5.profile.sub, sid: t5.profile.sid };
                i.Log.info("querySessionStatus successful, user not authenticated");
              }).catch(function(t5) {
                if (t5.session_state && e3.settings.monitorAnonymousSession && ("login_required" == t5.message || "consent_required" == t5.message || "interaction_required" == t5.message || "account_selection_required" == t5.message))
                  return i.Log.info("UserManager.querySessionStatus: querySessionStatus success for anonymous user"), { session_state: t5.session_state };
                throw t5;
              });
            })) : (i.Log.error("UserManager.querySessionStatus: No silent_redirect_uri configured"), Promise.reject(new Error("No silent_redirect_uri configured")));
          }, e2.prototype._signin = function t3(e3, r2) {
            var n2 = this, i2 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
            return this._signinStart(e3, r2, i2).then(function(t4) {
              return n2._signinEnd(t4.url, e3);
            });
          }, e2.prototype._signinStart = function t3(e3, r2) {
            var n2 = this, o2 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
            return r2.prepare(o2).then(function(t4) {
              return i.Log.debug("UserManager._signinStart: got navigator window handle"), n2.createSigninRequest(e3).then(function(e4) {
                return i.Log.debug("UserManager._signinStart: got signin request"), o2.url = e4.url, o2.id = e4.state.id, t4.navigate(o2);
              }).catch(function(e4) {
                throw t4.close && (i.Log.debug("UserManager._signinStart: Error after preparing navigator, closing navigator window"), t4.close()), e4;
              });
            });
          }, e2.prototype._signinEnd = function t3(e3) {
            var r2 = this, n2 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            return this.processSigninResponse(e3).then(function(t4) {
              i.Log.debug("UserManager._signinEnd: got signin response");
              var e4 = new a.User(t4);
              if (n2.current_sub) {
                if (n2.current_sub !== e4.profile.sub)
                  return i.Log.debug("UserManager._signinEnd: current user does not match user returned from signin. sub from signin: ", e4.profile.sub), Promise.reject(new Error("login_required"));
                i.Log.debug("UserManager._signinEnd: current user matches user returned from signin");
              }
              return r2.storeUser(e4).then(function() {
                return i.Log.debug("UserManager._signinEnd: user stored"), r2._events.load(e4), e4;
              });
            });
          }, e2.prototype._signinCallback = function t3(e3, r2) {
            i.Log.debug("UserManager._signinCallback");
            var n2 = "query" === this._settings.response_mode || !this._settings.response_mode && l.SigninRequest.isCode(this._settings.response_type) ? "?" : "#";
            return r2.callback(e3, void 0, n2);
          }, e2.prototype.signoutRedirect = function t3() {
            var e3 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            (e3 = Object.assign({}, e3)).request_type = "so:r";
            var r2 = e3.post_logout_redirect_uri || this.settings.post_logout_redirect_uri;
            r2 && (e3.post_logout_redirect_uri = r2);
            var n2 = { useReplaceToNavigate: e3.useReplaceToNavigate };
            return this._signoutStart(e3, this._redirectNavigator, n2).then(function() {
              i.Log.info("UserManager.signoutRedirect: successful");
            });
          }, e2.prototype.signoutRedirectCallback = function t3(e3) {
            return this._signoutEnd(e3 || this._redirectNavigator.url).then(function(t4) {
              return i.Log.info("UserManager.signoutRedirectCallback: successful"), t4;
            });
          }, e2.prototype.signoutPopup = function t3() {
            var e3 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            (e3 = Object.assign({}, e3)).request_type = "so:p";
            var r2 = e3.post_logout_redirect_uri || this.settings.popup_post_logout_redirect_uri || this.settings.post_logout_redirect_uri;
            return e3.post_logout_redirect_uri = r2, e3.display = "popup", e3.post_logout_redirect_uri && (e3.state = e3.state || {}), this._signout(e3, this._popupNavigator, { startUrl: r2, popupWindowFeatures: e3.popupWindowFeatures || this.settings.popupWindowFeatures, popupWindowTarget: e3.popupWindowTarget || this.settings.popupWindowTarget }).then(function() {
              i.Log.info("UserManager.signoutPopup: successful");
            });
          }, e2.prototype.signoutPopupCallback = function t3(e3, r2) {
            void 0 === r2 && "boolean" == typeof e3 && (r2 = e3, e3 = null);
            return this._popupNavigator.callback(e3, r2, "?").then(function() {
              i.Log.info("UserManager.signoutPopupCallback: successful");
            });
          }, e2.prototype._signout = function t3(e3, r2) {
            var n2 = this, i2 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
            return this._signoutStart(e3, r2, i2).then(function(t4) {
              return n2._signoutEnd(t4.url);
            });
          }, e2.prototype._signoutStart = function t3() {
            var e3 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, r2 = this, n2 = arguments[1], o2 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
            return n2.prepare(o2).then(function(t4) {
              return i.Log.debug("UserManager._signoutStart: got navigator window handle"), r2._loadUser().then(function(n3) {
                return i.Log.debug("UserManager._signoutStart: loaded current user from storage"), (r2._settings.revokeAccessTokenOnSignout ? r2._revokeInternal(n3) : Promise.resolve()).then(function() {
                  var s2 = e3.id_token_hint || n3 && n3.id_token;
                  return s2 && (i.Log.debug("UserManager._signoutStart: Setting id_token into signout request"), e3.id_token_hint = s2), r2.removeUser().then(function() {
                    return i.Log.debug("UserManager._signoutStart: user removed, creating signout request"), r2.createSignoutRequest(e3).then(function(e4) {
                      return i.Log.debug("UserManager._signoutStart: got signout request"), o2.url = e4.url, e4.state && (o2.id = e4.state.id), t4.navigate(o2);
                    });
                  });
                });
              }).catch(function(e4) {
                throw t4.close && (i.Log.debug("UserManager._signoutStart: Error after preparing navigator, closing navigator window"), t4.close()), e4;
              });
            });
          }, e2.prototype._signoutEnd = function t3(e3) {
            return this.processSignoutResponse(e3).then(function(t4) {
              return i.Log.debug("UserManager._signoutEnd: got signout response"), t4;
            });
          }, e2.prototype.revokeAccessToken = function t3() {
            var e3 = this;
            return this._loadUser().then(function(t4) {
              return e3._revokeInternal(t4, true).then(function(r2) {
                if (r2)
                  return i.Log.debug("UserManager.revokeAccessToken: removing token properties from user and re-storing"), t4.access_token = null, t4.refresh_token = null, t4.expires_at = null, t4.token_type = null, e3.storeUser(t4).then(function() {
                    i.Log.debug("UserManager.revokeAccessToken: user stored"), e3._events.load(t4);
                  });
              });
            }).then(function() {
              i.Log.info("UserManager.revokeAccessToken: access token revoked successfully");
            });
          }, e2.prototype._revokeInternal = function t3(e3, r2) {
            var n2 = this;
            if (e3) {
              var o2 = e3.access_token, s2 = e3.refresh_token;
              return this._revokeAccessTokenInternal(o2, r2).then(function(t4) {
                return n2._revokeRefreshTokenInternal(s2, r2).then(function(e4) {
                  return t4 || e4 || i.Log.debug("UserManager.revokeAccessToken: no need to revoke due to no token(s), or JWT format"), t4 || e4;
                });
              });
            }
            return Promise.resolve(false);
          }, e2.prototype._revokeAccessTokenInternal = function t3(e3, r2) {
            return !e3 || e3.indexOf(".") >= 0 ? Promise.resolve(false) : this._tokenRevocationClient.revoke(e3, r2).then(function() {
              return true;
            });
          }, e2.prototype._revokeRefreshTokenInternal = function t3(e3, r2) {
            return e3 ? this._tokenRevocationClient.revoke(e3, r2, "refresh_token").then(function() {
              return true;
            }) : Promise.resolve(false);
          }, e2.prototype.startSilentRenew = function t3() {
            this._silentRenewService.start();
          }, e2.prototype.stopSilentRenew = function t3() {
            this._silentRenewService.stop();
          }, e2.prototype._loadUser = function t3() {
            return this._userStore.get(this._userStoreKey).then(function(t4) {
              return t4 ? (i.Log.debug("UserManager._loadUser: user storageString loaded"), a.User.fromStorageString(t4)) : (i.Log.debug("UserManager._loadUser: no user storageString"), null);
            });
          }, e2.prototype.storeUser = function t3(e3) {
            if (e3) {
              i.Log.debug("UserManager.storeUser: storing user");
              var r2 = e3.toStorageString();
              return this._userStore.set(this._userStoreKey, r2);
            }
            return i.Log.debug("storeUser.storeUser: removing user"), this._userStore.remove(this._userStoreKey);
          }, n(e2, [{ key: "_redirectNavigator", get: function t3() {
            return this.settings.redirectNavigator;
          } }, { key: "_popupNavigator", get: function t3() {
            return this.settings.popupNavigator;
          } }, { key: "_iframeNavigator", get: function t3() {
            return this.settings.iframeNavigator;
          } }, { key: "_userStore", get: function t3() {
            return this.settings.userStore;
          } }, { key: "events", get: function t3() {
            return this._events;
          } }, { key: "_userStoreKey", get: function t3() {
            return "user:" + this.settings.authority + ":" + this.settings.client_id;
          } }]), e2;
        }(o.OidcClient);
      }, function(t, e, r) {
        "use strict";
        Object.defineProperty(e, "__esModule", { value: true }), e.UserManagerSettings = void 0;
        var n = function() {
          function t2(t3, e2) {
            for (var r2 = 0; r2 < e2.length; r2++) {
              var n2 = e2[r2];
              n2.enumerable = n2.enumerable || false, n2.configurable = true, "value" in n2 && (n2.writable = true), Object.defineProperty(t3, n2.key, n2);
            }
          }
          return function(e2, r2, n2) {
            return r2 && t2(e2.prototype, r2), n2 && t2(e2, n2), e2;
          };
        }(), i = (r(0), r(5)), o = r(40), s = r(41), a = r(43), u = r(6), c = r(1), h = r(8);
        function l(t2, e2) {
          if (!(t2 instanceof e2))
            throw new TypeError("Cannot call a class as a function");
        }
        function f(t2, e2) {
          if (!t2)
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !e2 || "object" != typeof e2 && "function" != typeof e2 ? t2 : e2;
        }
        e.UserManagerSettings = function(t2) {
          function e2() {
            var r2 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, n2 = r2.popup_redirect_uri, i2 = r2.popup_post_logout_redirect_uri, g = r2.popupWindowFeatures, d = r2.popupWindowTarget, p = r2.silent_redirect_uri, v = r2.silentRequestTimeout, y = r2.automaticSilentRenew, m = void 0 !== y && y, _ = r2.validateSubOnSilentRenew, S = void 0 !== _ && _, b = r2.includeIdTokenInSilentRenew, w = void 0 === b || b, F = r2.monitorSession, E = void 0 === F || F, x = r2.monitorAnonymousSession, A = void 0 !== x && x, k = r2.checkSessionInterval, P = void 0 === k ? 2e3 : k, C = r2.stopCheckSessionOnError, T = void 0 === C || C, R = r2.query_status_response_type, I = r2.revokeAccessTokenOnSignout, D = void 0 !== I && I, L = r2.accessTokenExpiringNotificationTime, N = void 0 === L ? 60 : L, U = r2.redirectNavigator, B = void 0 === U ? new o.RedirectNavigator() : U, O = r2.popupNavigator, j = void 0 === O ? new s.PopupNavigator() : O, M = r2.iframeNavigator, H = void 0 === M ? new a.IFrameNavigator() : M, V = r2.userStore, K = void 0 === V ? new u.WebStorageStateStore({ store: c.Global.sessionStorage }) : V;
            l(this, e2);
            var q = f(this, t2.call(this, arguments[0]));
            return q._popup_redirect_uri = n2, q._popup_post_logout_redirect_uri = i2, q._popupWindowFeatures = g, q._popupWindowTarget = d, q._silent_redirect_uri = p, q._silentRequestTimeout = v, q._automaticSilentRenew = m, q._validateSubOnSilentRenew = S, q._includeIdTokenInSilentRenew = w, q._accessTokenExpiringNotificationTime = N, q._monitorSession = E, q._monitorAnonymousSession = A, q._checkSessionInterval = P, q._stopCheckSessionOnError = T, R ? q._query_status_response_type = R : arguments[0] && arguments[0].response_type ? q._query_status_response_type = h.SigninRequest.isOidc(arguments[0].response_type) ? "id_token" : "code" : q._query_status_response_type = "id_token", q._revokeAccessTokenOnSignout = D, q._redirectNavigator = B, q._popupNavigator = j, q._iframeNavigator = H, q._userStore = K, q;
          }
          return function r2(t3, e3) {
            if ("function" != typeof e3 && null !== e3)
              throw new TypeError("Super expression must either be null or a function, not " + typeof e3);
            t3.prototype = Object.create(e3 && e3.prototype, { constructor: { value: t3, enumerable: false, writable: true, configurable: true } }), e3 && (Object.setPrototypeOf ? Object.setPrototypeOf(t3, e3) : t3.__proto__ = e3);
          }(e2, t2), n(e2, [{ key: "popup_redirect_uri", get: function t3() {
            return this._popup_redirect_uri;
          } }, { key: "popup_post_logout_redirect_uri", get: function t3() {
            return this._popup_post_logout_redirect_uri;
          } }, { key: "popupWindowFeatures", get: function t3() {
            return this._popupWindowFeatures;
          } }, { key: "popupWindowTarget", get: function t3() {
            return this._popupWindowTarget;
          } }, { key: "silent_redirect_uri", get: function t3() {
            return this._silent_redirect_uri;
          } }, { key: "silentRequestTimeout", get: function t3() {
            return this._silentRequestTimeout;
          } }, { key: "automaticSilentRenew", get: function t3() {
            return this._automaticSilentRenew;
          } }, { key: "validateSubOnSilentRenew", get: function t3() {
            return this._validateSubOnSilentRenew;
          } }, { key: "includeIdTokenInSilentRenew", get: function t3() {
            return this._includeIdTokenInSilentRenew;
          } }, { key: "accessTokenExpiringNotificationTime", get: function t3() {
            return this._accessTokenExpiringNotificationTime;
          } }, { key: "monitorSession", get: function t3() {
            return this._monitorSession;
          } }, { key: "monitorAnonymousSession", get: function t3() {
            return this._monitorAnonymousSession;
          } }, { key: "checkSessionInterval", get: function t3() {
            return this._checkSessionInterval;
          } }, { key: "stopCheckSessionOnError", get: function t3() {
            return this._stopCheckSessionOnError;
          } }, { key: "query_status_response_type", get: function t3() {
            return this._query_status_response_type;
          } }, { key: "revokeAccessTokenOnSignout", get: function t3() {
            return this._revokeAccessTokenOnSignout;
          } }, { key: "redirectNavigator", get: function t3() {
            return this._redirectNavigator;
          } }, { key: "popupNavigator", get: function t3() {
            return this._popupNavigator;
          } }, { key: "iframeNavigator", get: function t3() {
            return this._iframeNavigator;
          } }, { key: "userStore", get: function t3() {
            return this._userStore;
          } }]), e2;
        }(i.OidcClientSettings);
      }, function(t, e, r) {
        "use strict";
        Object.defineProperty(e, "__esModule", { value: true }), e.RedirectNavigator = void 0;
        var n = function() {
          function t2(t3, e2) {
            for (var r2 = 0; r2 < e2.length; r2++) {
              var n2 = e2[r2];
              n2.enumerable = n2.enumerable || false, n2.configurable = true, "value" in n2 && (n2.writable = true), Object.defineProperty(t3, n2.key, n2);
            }
          }
          return function(e2, r2, n2) {
            return r2 && t2(e2.prototype, r2), n2 && t2(e2, n2), e2;
          };
        }(), i = r(0);
        e.RedirectNavigator = function() {
          function t2() {
            !function e2(t3, r2) {
              if (!(t3 instanceof r2))
                throw new TypeError("Cannot call a class as a function");
            }(this, t2);
          }
          return t2.prototype.prepare = function t3() {
            return Promise.resolve(this);
          }, t2.prototype.navigate = function t3(e2) {
            return e2 && e2.url ? (e2.useReplaceToNavigate ? window.location.replace(e2.url) : window.location = e2.url, Promise.resolve()) : (i.Log.error("RedirectNavigator.navigate: No url provided"), Promise.reject(new Error("No url provided")));
          }, n(t2, [{ key: "url", get: function t3() {
            return window.location.href;
          } }]), t2;
        }();
      }, function(t, e, r) {
        "use strict";
        Object.defineProperty(e, "__esModule", { value: true }), e.PopupNavigator = void 0;
        var n = r(0), i = r(42);
        e.PopupNavigator = function() {
          function t2() {
            !function e2(t3, r2) {
              if (!(t3 instanceof r2))
                throw new TypeError("Cannot call a class as a function");
            }(this, t2);
          }
          return t2.prototype.prepare = function t3(e2) {
            var r2 = new i.PopupWindow(e2);
            return Promise.resolve(r2);
          }, t2.prototype.callback = function t3(e2, r2, o) {
            n.Log.debug("PopupNavigator.callback");
            try {
              return i.PopupWindow.notifyOpener(e2, r2, o), Promise.resolve();
            } catch (t4) {
              return Promise.reject(t4);
            }
          }, t2;
        }();
      }, function(t, e, r) {
        "use strict";
        Object.defineProperty(e, "__esModule", { value: true }), e.PopupWindow = void 0;
        var n = function() {
          function t2(t3, e2) {
            for (var r2 = 0; r2 < e2.length; r2++) {
              var n2 = e2[r2];
              n2.enumerable = n2.enumerable || false, n2.configurable = true, "value" in n2 && (n2.writable = true), Object.defineProperty(t3, n2.key, n2);
            }
          }
          return function(e2, r2, n2) {
            return r2 && t2(e2.prototype, r2), n2 && t2(e2, n2), e2;
          };
        }(), i = r(0), o = r(3);
        e.PopupWindow = function() {
          function t2(e2) {
            var r2 = this;
            !function n2(t3, e3) {
              if (!(t3 instanceof e3))
                throw new TypeError("Cannot call a class as a function");
            }(this, t2), this._promise = new Promise(function(t3, e3) {
              r2._resolve = t3, r2._reject = e3;
            });
            var o2 = e2.popupWindowTarget || "_blank", s = e2.popupWindowFeatures || "location=no,toolbar=no,width=500,height=500,left=100,top=100;";
            this._popup = window.open("", o2, s), this._popup && (i.Log.debug("PopupWindow.ctor: popup successfully created"), this._checkForPopupClosedTimer = window.setInterval(this._checkForPopupClosed.bind(this), 500));
          }
          return t2.prototype.navigate = function t3(e2) {
            return this._popup ? e2 && e2.url ? (i.Log.debug("PopupWindow.navigate: Setting URL in popup"), this._id = e2.id, this._id && (window["popupCallback_" + e2.id] = this._callback.bind(this)), this._popup.focus(), this._popup.window.location = e2.url) : (this._error("PopupWindow.navigate: no url provided"), this._error("No url provided")) : this._error("PopupWindow.navigate: Error opening popup window"), this.promise;
          }, t2.prototype._success = function t3(e2) {
            i.Log.debug("PopupWindow.callback: Successful response from popup window"), this._cleanup(), this._resolve(e2);
          }, t2.prototype._error = function t3(e2) {
            i.Log.error("PopupWindow.error: ", e2), this._cleanup(), this._reject(new Error(e2));
          }, t2.prototype.close = function t3() {
            this._cleanup(false);
          }, t2.prototype._cleanup = function t3(e2) {
            i.Log.debug("PopupWindow.cleanup"), window.clearInterval(this._checkForPopupClosedTimer), this._checkForPopupClosedTimer = null, delete window["popupCallback_" + this._id], this._popup && !e2 && this._popup.close(), this._popup = null;
          }, t2.prototype._checkForPopupClosed = function t3() {
            this._popup && !this._popup.closed || this._error("Popup window closed");
          }, t2.prototype._callback = function t3(e2, r2) {
            this._cleanup(r2), e2 ? (i.Log.debug("PopupWindow.callback success"), this._success({ url: e2 })) : (i.Log.debug("PopupWindow.callback: Invalid response from popup"), this._error("Invalid response from popup"));
          }, t2.notifyOpener = function t3(e2, r2, n2) {
            if (window.opener) {
              if (e2 = e2 || window.location.href) {
                var s = o.UrlUtility.parseUrlFragment(e2, n2);
                if (s.state) {
                  var a = "popupCallback_" + s.state, u = window.opener[a];
                  u ? (i.Log.debug("PopupWindow.notifyOpener: passing url message to opener"), u(e2, r2)) : i.Log.warn("PopupWindow.notifyOpener: no matching callback found on opener");
                } else
                  i.Log.warn("PopupWindow.notifyOpener: no state found in response url");
              }
            } else
              i.Log.warn("PopupWindow.notifyOpener: no window.opener. Can't complete notification.");
          }, n(t2, [{ key: "promise", get: function t3() {
            return this._promise;
          } }]), t2;
        }();
      }, function(t, e, r) {
        "use strict";
        Object.defineProperty(e, "__esModule", { value: true }), e.IFrameNavigator = void 0;
        var n = r(0), i = r(44);
        e.IFrameNavigator = function() {
          function t2() {
            !function e2(t3, r2) {
              if (!(t3 instanceof r2))
                throw new TypeError("Cannot call a class as a function");
            }(this, t2);
          }
          return t2.prototype.prepare = function t3(e2) {
            var r2 = new i.IFrameWindow(e2);
            return Promise.resolve(r2);
          }, t2.prototype.callback = function t3(e2) {
            n.Log.debug("IFrameNavigator.callback");
            try {
              return i.IFrameWindow.notifyParent(e2), Promise.resolve();
            } catch (t4) {
              return Promise.reject(t4);
            }
          }, t2;
        }();
      }, function(t, e, r) {
        "use strict";
        Object.defineProperty(e, "__esModule", { value: true }), e.IFrameWindow = void 0;
        var n = function() {
          function t2(t3, e2) {
            for (var r2 = 0; r2 < e2.length; r2++) {
              var n2 = e2[r2];
              n2.enumerable = n2.enumerable || false, n2.configurable = true, "value" in n2 && (n2.writable = true), Object.defineProperty(t3, n2.key, n2);
            }
          }
          return function(e2, r2, n2) {
            return r2 && t2(e2.prototype, r2), n2 && t2(e2, n2), e2;
          };
        }(), i = r(0);
        e.IFrameWindow = function() {
          function t2(e2) {
            var r2 = this;
            !function n2(t3, e3) {
              if (!(t3 instanceof e3))
                throw new TypeError("Cannot call a class as a function");
            }(this, t2), this._promise = new Promise(function(t3, e3) {
              r2._resolve = t3, r2._reject = e3;
            }), this._boundMessageEvent = this._message.bind(this), window.addEventListener("message", this._boundMessageEvent, false), this._frame = window.document.createElement("iframe"), this._frame.style.visibility = "hidden", this._frame.style.position = "absolute", this._frame.width = 0, this._frame.height = 0, window.document.body.appendChild(this._frame);
          }
          return t2.prototype.navigate = function t3(e2) {
            if (e2 && e2.url) {
              var r2 = e2.silentRequestTimeout || 1e4;
              i.Log.debug("IFrameWindow.navigate: Using timeout of:", r2), this._timer = window.setTimeout(this._timeout.bind(this), r2), this._frame.src = e2.url;
            } else
              this._error("No url provided");
            return this.promise;
          }, t2.prototype._success = function t3(e2) {
            this._cleanup(), i.Log.debug("IFrameWindow: Successful response from frame window"), this._resolve(e2);
          }, t2.prototype._error = function t3(e2) {
            this._cleanup(), i.Log.error(e2), this._reject(new Error(e2));
          }, t2.prototype.close = function t3() {
            this._cleanup();
          }, t2.prototype._cleanup = function t3() {
            this._frame && (i.Log.debug("IFrameWindow: cleanup"), window.removeEventListener("message", this._boundMessageEvent, false), window.clearTimeout(this._timer), window.document.body.removeChild(this._frame), this._timer = null, this._frame = null, this._boundMessageEvent = null);
          }, t2.prototype._timeout = function t3() {
            i.Log.debug("IFrameWindow.timeout"), this._error("Frame window timed out");
          }, t2.prototype._message = function t3(e2) {
            if (i.Log.debug("IFrameWindow.message"), this._timer && e2.origin === this._origin && e2.source === this._frame.contentWindow && "string" == typeof e2.data && (e2.data.startsWith("http://") || e2.data.startsWith("https://"))) {
              var r2 = e2.data;
              r2 ? this._success({ url: r2 }) : this._error("Invalid response from frame");
            }
          }, t2.notifyParent = function t3(e2) {
            i.Log.debug("IFrameWindow.notifyParent"), (e2 = e2 || window.location.href) && (i.Log.debug("IFrameWindow.notifyParent: posting url message to parent"), window.parent.postMessage(e2, location.protocol + "//" + location.host));
          }, n(t2, [{ key: "promise", get: function t3() {
            return this._promise;
          } }, { key: "_origin", get: function t3() {
            return location.protocol + "//" + location.host;
          } }]), t2;
        }();
      }, function(t, e, r) {
        "use strict";
        Object.defineProperty(e, "__esModule", { value: true }), e.UserManagerEvents = void 0;
        var n = r(0), i = r(16), o = r(17);
        e.UserManagerEvents = function(t2) {
          function e2(r2) {
            !function n2(t3, e3) {
              if (!(t3 instanceof e3))
                throw new TypeError("Cannot call a class as a function");
            }(this, e2);
            var i2 = function s(t3, e3) {
              if (!t3)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return !e3 || "object" != typeof e3 && "function" != typeof e3 ? t3 : e3;
            }(this, t2.call(this, r2));
            return i2._userLoaded = new o.Event("User loaded"), i2._userUnloaded = new o.Event("User unloaded"), i2._silentRenewError = new o.Event("Silent renew error"), i2._userSignedIn = new o.Event("User signed in"), i2._userSignedOut = new o.Event("User signed out"), i2._userSessionChanged = new o.Event("User session changed"), i2;
          }
          return function r2(t3, e3) {
            if ("function" != typeof e3 && null !== e3)
              throw new TypeError("Super expression must either be null or a function, not " + typeof e3);
            t3.prototype = Object.create(e3 && e3.prototype, { constructor: { value: t3, enumerable: false, writable: true, configurable: true } }), e3 && (Object.setPrototypeOf ? Object.setPrototypeOf(t3, e3) : t3.__proto__ = e3);
          }(e2, t2), e2.prototype.load = function e3(r2) {
            var i2 = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
            n.Log.debug("UserManagerEvents.load"), t2.prototype.load.call(this, r2), i2 && this._userLoaded.raise(r2);
          }, e2.prototype.unload = function e3() {
            n.Log.debug("UserManagerEvents.unload"), t2.prototype.unload.call(this), this._userUnloaded.raise();
          }, e2.prototype.addUserLoaded = function t3(e3) {
            this._userLoaded.addHandler(e3);
          }, e2.prototype.removeUserLoaded = function t3(e3) {
            this._userLoaded.removeHandler(e3);
          }, e2.prototype.addUserUnloaded = function t3(e3) {
            this._userUnloaded.addHandler(e3);
          }, e2.prototype.removeUserUnloaded = function t3(e3) {
            this._userUnloaded.removeHandler(e3);
          }, e2.prototype.addSilentRenewError = function t3(e3) {
            this._silentRenewError.addHandler(e3);
          }, e2.prototype.removeSilentRenewError = function t3(e3) {
            this._silentRenewError.removeHandler(e3);
          }, e2.prototype._raiseSilentRenewError = function t3(e3) {
            n.Log.debug("UserManagerEvents._raiseSilentRenewError", e3.message), this._silentRenewError.raise(e3);
          }, e2.prototype.addUserSignedIn = function t3(e3) {
            this._userSignedIn.addHandler(e3);
          }, e2.prototype.removeUserSignedIn = function t3(e3) {
            this._userSignedIn.removeHandler(e3);
          }, e2.prototype._raiseUserSignedIn = function t3() {
            n.Log.debug("UserManagerEvents._raiseUserSignedIn"), this._userSignedIn.raise();
          }, e2.prototype.addUserSignedOut = function t3(e3) {
            this._userSignedOut.addHandler(e3);
          }, e2.prototype.removeUserSignedOut = function t3(e3) {
            this._userSignedOut.removeHandler(e3);
          }, e2.prototype._raiseUserSignedOut = function t3() {
            n.Log.debug("UserManagerEvents._raiseUserSignedOut"), this._userSignedOut.raise();
          }, e2.prototype.addUserSessionChanged = function t3(e3) {
            this._userSessionChanged.addHandler(e3);
          }, e2.prototype.removeUserSessionChanged = function t3(e3) {
            this._userSessionChanged.removeHandler(e3);
          }, e2.prototype._raiseUserSessionChanged = function t3() {
            n.Log.debug("UserManagerEvents._raiseUserSessionChanged"), this._userSessionChanged.raise();
          }, e2;
        }(i.AccessTokenEvents);
      }, function(t, e, r) {
        "use strict";
        Object.defineProperty(e, "__esModule", { value: true }), e.Timer = void 0;
        var n = function() {
          function t2(t3, e2) {
            for (var r2 = 0; r2 < e2.length; r2++) {
              var n2 = e2[r2];
              n2.enumerable = n2.enumerable || false, n2.configurable = true, "value" in n2 && (n2.writable = true), Object.defineProperty(t3, n2.key, n2);
            }
          }
          return function(e2, r2, n2) {
            return r2 && t2(e2.prototype, r2), n2 && t2(e2, n2), e2;
          };
        }(), i = r(0), o = r(1), s = r(17);
        function a(t2, e2) {
          if (!(t2 instanceof e2))
            throw new TypeError("Cannot call a class as a function");
        }
        function u(t2, e2) {
          if (!t2)
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !e2 || "object" != typeof e2 && "function" != typeof e2 ? t2 : e2;
        }
        e.Timer = function(t2) {
          function e2(r2) {
            var n2 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : o.Global.timer, i2 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : void 0;
            a(this, e2);
            var s2 = u(this, t2.call(this, r2));
            return s2._timer = n2, s2._nowFunc = i2 || function() {
              return Date.now() / 1e3;
            }, s2;
          }
          return function r2(t3, e3) {
            if ("function" != typeof e3 && null !== e3)
              throw new TypeError("Super expression must either be null or a function, not " + typeof e3);
            t3.prototype = Object.create(e3 && e3.prototype, { constructor: { value: t3, enumerable: false, writable: true, configurable: true } }), e3 && (Object.setPrototypeOf ? Object.setPrototypeOf(t3, e3) : t3.__proto__ = e3);
          }(e2, t2), e2.prototype.init = function t3(e3) {
            e3 <= 0 && (e3 = 1), e3 = parseInt(e3);
            var r2 = this.now + e3;
            if (this.expiration === r2 && this._timerHandle)
              i.Log.debug("Timer.init timer " + this._name + " skipping initialization since already initialized for expiration:", this.expiration);
            else {
              this.cancel(), i.Log.debug("Timer.init timer " + this._name + " for duration:", e3), this._expiration = r2;
              var n2 = 5;
              e3 < n2 && (n2 = e3), this._timerHandle = this._timer.setInterval(this._callback.bind(this), 1e3 * n2);
            }
          }, e2.prototype.cancel = function t3() {
            this._timerHandle && (i.Log.debug("Timer.cancel: ", this._name), this._timer.clearInterval(this._timerHandle), this._timerHandle = null);
          }, e2.prototype._callback = function e3() {
            var r2 = this._expiration - this.now;
            i.Log.debug("Timer.callback; " + this._name + " timer expires in:", r2), this._expiration <= this.now && (this.cancel(), t2.prototype.raise.call(this));
          }, n(e2, [{ key: "now", get: function t3() {
            return parseInt(this._nowFunc());
          } }, { key: "expiration", get: function t3() {
            return this._expiration;
          } }]), e2;
        }(s.Event);
      }, function(t, e, r) {
        "use strict";
        Object.defineProperty(e, "__esModule", { value: true }), e.SilentRenewService = void 0;
        var n = r(0);
        e.SilentRenewService = function() {
          function t2(e2) {
            !function r2(t3, e3) {
              if (!(t3 instanceof e3))
                throw new TypeError("Cannot call a class as a function");
            }(this, t2), this._userManager = e2;
          }
          return t2.prototype.start = function t3() {
            this._callback || (this._callback = this._tokenExpiring.bind(this), this._userManager.events.addAccessTokenExpiring(this._callback), this._userManager.getUser().then(function(t4) {
            }).catch(function(t4) {
              n.Log.error("SilentRenewService.start: Error from getUser:", t4.message);
            }));
          }, t2.prototype.stop = function t3() {
            this._callback && (this._userManager.events.removeAccessTokenExpiring(this._callback), delete this._callback);
          }, t2.prototype._tokenExpiring = function t3() {
            var e2 = this;
            this._userManager.signinSilent().then(function(t4) {
              n.Log.debug("SilentRenewService._tokenExpiring: Silent token renewal successful");
            }, function(t4) {
              n.Log.error("SilentRenewService._tokenExpiring: Error from signinSilent:", t4.message), e2._userManager.events._raiseSilentRenewError(t4);
            });
          }, t2;
        }();
      }, function(t, e, r) {
        "use strict";
        Object.defineProperty(e, "__esModule", { value: true }), e.CordovaPopupNavigator = void 0;
        var n = r(21);
        e.CordovaPopupNavigator = function() {
          function t2() {
            !function e2(t3, r2) {
              if (!(t3 instanceof r2))
                throw new TypeError("Cannot call a class as a function");
            }(this, t2);
          }
          return t2.prototype.prepare = function t3(e2) {
            var r2 = new n.CordovaPopupWindow(e2);
            return Promise.resolve(r2);
          }, t2;
        }();
      }, function(t, e, r) {
        "use strict";
        Object.defineProperty(e, "__esModule", { value: true }), e.CordovaIFrameNavigator = void 0;
        var n = r(21);
        e.CordovaIFrameNavigator = function() {
          function t2() {
            !function e2(t3, r2) {
              if (!(t3 instanceof r2))
                throw new TypeError("Cannot call a class as a function");
            }(this, t2);
          }
          return t2.prototype.prepare = function t3(e2) {
            e2.popupWindowFeatures = "hidden=yes";
            var r2 = new n.CordovaPopupWindow(e2);
            return Promise.resolve(r2);
          }, t2;
        }();
      }, function(t, e, r) {
        "use strict";
        Object.defineProperty(e, "__esModule", { value: true });
        e.Version = "1.11.5";
      }]);
    });
  }
});
var node22 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = [
    {
      "alias": "list",
      "args": [
        {
          "kind": "Literal",
          "name": "order",
          "value": [
            {
              "firstName": "ASC"
            }
          ]
        },
        {
          "kind": "Variable",
          "name": "where",
          "variableName": "where"
        }
      ],
      "concreteType": "AccountAdminUsersConnection",
      "kind": "LinkedField",
      "name": "accountAdminUsers",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasPreviousPage",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "startCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "AccountAdminUsersEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountsAdminUser",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "accountId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "code",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "firstName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "lastName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "emailAddress",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__id",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "AdminUserSearchBoxQuery",
      "selections": v1,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "AdminUserSearchBoxQuery",
      "selections": v1
    },
    "params": {
      "cacheID": "95dde80fc322d95341c4136daba82033",
      "id": null,
      "metadata": {},
      "name": "AdminUserSearchBoxQuery",
      "operationKind": "query",
      "text": "query AdminUserSearchBoxQuery(\n  $where: AccountsAdminUserFilter!\n) {\n  list: accountAdminUsers(order: [{firstName: ASC}], where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        accountId\n        code\n        firstName\n        lastName\n        emailAddress\n      }\n    }\n  }\n}\n"
    }
  };
}();
node22.hash = "d4c44fafb86f57cd014ff173d2269b06";
var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
var freeGlobal_default = freeGlobal;
var freeSelf = typeof self == "object" && self && self.Object === Object && self;
var root = freeGlobal_default || freeSelf || Function("return this")();
var root_default = root;
var Symbol2 = root_default.Symbol;
var Symbol_default = Symbol2;
var objectProto = Object.prototype;
var hasOwnProperty = objectProto.hasOwnProperty;
var nativeObjectToString = objectProto.toString;
var symToStringTag = Symbol_default ? Symbol_default.toStringTag : void 0;
var objectProto2 = Object.prototype;
var nativeObjectToString2 = objectProto2.toString;
var symToStringTag2 = Symbol_default ? Symbol_default.toStringTag : void 0;
var NAN = 0 / 0;
var node23 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = [
    {
      "alias": "list",
      "args": [
        {
          "kind": "Literal",
          "name": "order",
          "value": [
            {
              "firstName": "ASC"
            }
          ]
        },
        {
          "kind": "Variable",
          "name": "where",
          "variableName": "where"
        }
      ],
      "concreteType": "IdentityUsersConnection",
      "kind": "LinkedField",
      "name": "identityUsers",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasPreviousPage",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "startCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "IdentityUsersEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "IdentityUser",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "code",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "identityUserId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "lastLoggedIn",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "updatedAt",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "createdAt",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "firstName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "lastName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "email",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "accountTypes",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__id",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "IdentityUserSearchBoxQuery",
      "selections": v1,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "IdentityUserSearchBoxQuery",
      "selections": v1
    },
    "params": {
      "cacheID": "79a36878d70792e2c9bc33b960a61ba8",
      "id": null,
      "metadata": {},
      "name": "IdentityUserSearchBoxQuery",
      "operationKind": "query",
      "text": "query IdentityUserSearchBoxQuery(\n  $where: IdentityUserFilter!\n) {\n  list: identityUsers(order: [{firstName: ASC}], where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        code\n        identityUserId\n        lastLoggedIn\n        updatedAt\n        createdAt\n        firstName\n        lastName\n        email\n        accountTypes\n      }\n    }\n  }\n}\n"
    }
  };
}();
node23.hash = "eb8495c4c9e3d0eb49f2c761a5563e0a";
var node32 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "identityUserCode"
    }
  ], v1 = [
    {
      "alias": "identityUser",
      "args": [
        {
          "kind": "Variable",
          "name": "code",
          "variableName": "identityUserCode"
        }
      ],
      "concreteType": "IdentityUser",
      "kind": "LinkedField",
      "name": "identityUserByCode",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "code",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "identityUserId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lastLoggedIn",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "updatedAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "createdAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "firstName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lastName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "email",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "accountTypes",
          "storageKey": null
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__id",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "IdentityUserLayoutQuery",
      "selections": v1,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "IdentityUserLayoutQuery",
      "selections": v1
    },
    "params": {
      "cacheID": "72600eb64ccca5488572aafaca34de41",
      "id": null,
      "metadata": {},
      "name": "IdentityUserLayoutQuery",
      "operationKind": "query",
      "text": "query IdentityUserLayoutQuery(\n  $identityUserCode: Long!\n) {\n  identityUser: identityUserByCode(code: $identityUserCode) {\n    id\n    code\n    identityUserId\n    lastLoggedIn\n    updatedAt\n    createdAt\n    firstName\n    lastName\n    email\n    accountTypes\n  }\n}\n"
    }
  };
}();
node32.hash = "132b26a418b18eac69081c86cdb6e4c5";
var node42 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "identityUserCode"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "code",
      "variableName": "identityUserCode"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "identityUserId",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "lastLoggedIn",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "updatedAt",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "createdAt",
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "firstName",
    "storageKey": null
  }, v9 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "lastName",
    "storageKey": null
  }, v10 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "email",
    "storageKey": null
  }, v11 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "accountTypes",
    "storageKey": null
  }, v12 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "accountId",
    "storageKey": null
  }, v13 = [
    v12,
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "IdentityAccountRow_account"
    }
  ], v14 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  }, v15 = [
    v12,
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "identityId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    v10,
    v8,
    v9,
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "IdentityUserDetailsRouteQuery",
      "selections": [
        {
          "alias": "identityUser",
          "args": v1,
          "concreteType": "IdentityUser",
          "kind": "LinkedField",
          "name": "identityUserByCode",
          "plural": false,
          "selections": [
            v2,
            v3,
            v4,
            v5,
            v6,
            v7,
            v8,
            v9,
            v10,
            v11,
            {
              "alias": null,
              "args": null,
              "concreteType": "IdentityAccountModel",
              "kind": "LinkedField",
              "name": "adminAccounts",
              "plural": true,
              "selections": v13,
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "IdentityAccountModel",
              "kind": "LinkedField",
              "name": "candidateAccounts",
              "plural": true,
              "selections": v13,
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "IdentityAccountModel",
              "kind": "LinkedField",
              "name": "employerAccounts",
              "plural": true,
              "selections": v13,
              "storageKey": null
            },
            v14
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "IdentityUserDetailsRouteQuery",
      "selections": [
        {
          "alias": "identityUser",
          "args": v1,
          "concreteType": "IdentityUser",
          "kind": "LinkedField",
          "name": "identityUserByCode",
          "plural": false,
          "selections": [
            v2,
            v3,
            v4,
            v5,
            v6,
            v7,
            v8,
            v9,
            v10,
            v11,
            {
              "alias": null,
              "args": null,
              "concreteType": "IdentityAccountModel",
              "kind": "LinkedField",
              "name": "adminAccounts",
              "plural": true,
              "selections": v15,
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "IdentityAccountModel",
              "kind": "LinkedField",
              "name": "candidateAccounts",
              "plural": true,
              "selections": v15,
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "IdentityAccountModel",
              "kind": "LinkedField",
              "name": "employerAccounts",
              "plural": true,
              "selections": v15,
              "storageKey": null
            },
            v14
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "0179d7468245a53d4e84dcd1790bf17b",
      "id": null,
      "metadata": {},
      "name": "IdentityUserDetailsRouteQuery",
      "operationKind": "query",
      "text": "query IdentityUserDetailsRouteQuery(\n  $identityUserCode: Long!\n) {\n  identityUser: identityUserByCode(code: $identityUserCode) {\n    id\n    code\n    identityUserId\n    lastLoggedIn\n    updatedAt\n    createdAt\n    firstName\n    lastName\n    email\n    accountTypes\n    adminAccounts {\n      accountId\n      ...IdentityAccountRow_account\n    }\n    candidateAccounts {\n      accountId\n      ...IdentityAccountRow_account\n    }\n    employerAccounts {\n      accountId\n      ...IdentityAccountRow_account\n    }\n  }\n}\n\nfragment IdentityAccountRow_account on IdentityAccountModel {\n  identityId\n  accountId\n  type\n  email\n  firstName\n  lastName\n  description\n}\n"
    }
  };
}();
node42.hash = "fd37e40ab0fa94c5eebe30d2e592d6f5";
var node52 = function() {
  var v0 = [
    {
      "alias": "account",
      "args": null,
      "concreteType": "EmployerUserSession",
      "kind": "LinkedField",
      "name": "accountsEmployerUserCurrentEmployerAccount",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isCurrent",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "employerId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "employerCode",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "employerName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "userFirstName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "userLastName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "userEmailAddress",
          "storageKey": null
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__id",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": [],
      "kind": "Fragment",
      "metadata": null,
      "name": "EmployerCurrentAccountAtomQuery",
      "selections": v0,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [],
      "kind": "Operation",
      "name": "EmployerCurrentAccountAtomQuery",
      "selections": v0
    },
    "params": {
      "cacheID": "88fca8668adc7a82b77417fd84185fd6",
      "id": null,
      "metadata": {},
      "name": "EmployerCurrentAccountAtomQuery",
      "operationKind": "query",
      "text": "query EmployerCurrentAccountAtomQuery {\n  account: accountsEmployerUserCurrentEmployerAccount {\n    id\n    isCurrent\n    employerId\n    employerCode\n    employerName\n    userFirstName\n    userLastName\n    userEmailAddress\n  }\n}\n"
    }
  };
}();
node52.hash = "ac37438a67be63a03f8e19de9c241880";
var import_oidc_client2 = __toESM2(require_oidc_client_min());
var routingContextAtom = Recoil_index_8({
  key: "routingContext",
  default: {
    user: null,
    session: null
  }
});
var selectRoutingContext = Recoil_index_9({
  key: "selectRoutingContext",
  get: async ({ get }) => {
    const context = get(routingContextAtom);
    return context;
  }
});
var import_oidc_client = __toESM2(require_oidc_client_min());
var currentUserTenantState = Recoil_index_8({
  key: "currentUserTenant",
  default: ""
});
var profileState = Recoil_index_8({
  key: "profile",
  default: ""
});
var profileQuery = Recoil_index_9({
  key: "profileQuery",
  get: async ({ get }) => {
    const profile = get(profileState);
    const userManger = getUserManager();
    if (!userManger) {
      console.log(`profileQuery: userManger initialized ${!!userManger}`);
      return null;
    }
    if (!profile) {
      console.log(`profileQuery: profile is not set`);
      return null;
    }
    const user = await userManger.getUser();
    console.log(`profileQuery: user exists ${!!user}`);
    return user?.profile;
  }
});
var userIsLoggedInQuery = Recoil_index_9({
  key: "userIsLoggedInQuery",
  get: async ({ get }) => {
    const profile = get(profileQuery);
    if (!profile) {
      console.log(`userIsLoggedInQuery: profile exists ${!!profile}`);
      return false;
    }
    const isLoggedIn = !!profile && !!profile.ElevateId;
    return isLoggedIn;
  }
});
var profileDetailsQuery = Recoil_index_9({
  key: "profileDetailsQuery",
  get: async ({ get }) => {
    const profile = get(profileQuery);
    if (!profile) {
      return null;
    }
    return {
      id: profile.ElevateId,
      email: profile.email,
      accountType: profile.ElevateAccountType,
      firstName: profile.given_name,
      lastName: profile.family_name
    };
  }
});
var userManager = null;
var getUserManager = () => {
  return userManager;
};
var node62 = function() {
  var v0 = [
    {
      "alias": "account",
      "args": null,
      "concreteType": "UserSessionContext",
      "kind": "LinkedField",
      "name": "accountsCurrentAccount",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "identityId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "accountType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "code",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "emailAddress",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "userId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "employerId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "employerCode",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "employerName",
          "storageKey": null
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__id",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": [],
      "kind": "Fragment",
      "metadata": null,
      "name": "UserSessionContextAtomQuery",
      "selections": v0,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [],
      "kind": "Operation",
      "name": "UserSessionContextAtomQuery",
      "selections": v0
    },
    "params": {
      "cacheID": "1f587df5dea95ed8568d086da1bedc4a",
      "id": null,
      "metadata": {},
      "name": "UserSessionContextAtomQuery",
      "operationKind": "query",
      "text": "query UserSessionContextAtomQuery {\n  account: accountsCurrentAccount {\n    identityId\n    accountType\n    code\n    emailAddress\n    userId\n    employerId\n    employerCode\n    employerName\n  }\n}\n"
    }
  };
}();
node62.hash = "c2082997a0f82f0a23b92d24ae7cb20c";
var userSessionContextAtom = atom(null);
var AuthContext = createContext(null);
var ElevateAccountTypes = /* @__PURE__ */ ((ElevateAccountTypes2) => {
  ElevateAccountTypes2["Internal"] = "internal";
  ElevateAccountTypes2["Employer"] = "employer";
  ElevateAccountTypes2["Contractor"] = "contractor";
  ElevateAccountTypes2["Supplier"] = "supplier";
  return ElevateAccountTypes2;
})(ElevateAccountTypes || {});
var ElevateScopes = class {
};
ElevateScopes.IdentityScope = "elevate.identity.admin";
ElevateScopes.CandidatesApiScope = "elevate.candidates";
ElevateScopes.EventTrackingApiScope = "elevate.eventtracking";
ElevateScopes.RecruitApiScope = "elevate.recruit";
ElevateScopes.IdentityAdminApiScope = "elevate.identity.admin";
ElevateScopes.IntegrationsAdminApiScope = "elevate.integrations.admin";
ElevateScopes.VaultScope = "elevate.vault";
ElevateScopes.NotificationsScope = "notifications";
ElevateScopes.CompaniesScope = "elevate.companies";
ElevateScopes.EmployersScope = "elevate.employers";
var employerCurrentAccountAtom = atom(null);
var node72 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfElevateIdentityUser",
    "kind": "LinkedField",
    "name": "payload",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "IdentityUser",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          v2,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "identityUserId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastLoggedIn",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "accountTypes",
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v4 = {
    "kind": "InlineFragment",
    "selections": [
      v2,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseIdentityUserAddAccountTypeMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "IdentityUserAddAccountTypePayload",
          "kind": "LinkedField",
          "name": "identityUserAddAccountType",
          "plural": false,
          "selections": [
            v3,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseIdentityUserAddAccountTypeMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "IdentityUserAddAccountTypePayload",
          "kind": "LinkedField",
          "name": "identityUserAddAccountType",
          "plural": false,
          "selections": [
            v3,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "0c1139e0ebaa636fb574a87e75d2911d",
      "id": null,
      "metadata": {},
      "name": "UseIdentityUserAddAccountTypeMutation",
      "operationKind": "mutation",
      "text": "mutation UseIdentityUserAddAccountTypeMutation(\n  $input: IdentityUserAddAccountTypeInput!\n) {\n  data: identityUserAddAccountType(input: $input) {\n    payload {\n      node {\n        id\n        code\n        identityUserId\n        lastLoggedIn\n        firstName\n        lastName\n        email\n        updatedAt\n        createdAt\n        accountTypes\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node72.hash = "7e013662767e8a3efb5e763b24ad6dea";
var node82 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfElevateIdentityUser",
    "kind": "LinkedField",
    "name": "payload",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "IdentityUser",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          v2,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "identityUserId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastLoggedIn",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "accountTypes",
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v4 = {
    "kind": "InlineFragment",
    "selections": [
      v2,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseIdentityUserChangeEmailMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "IdentityUserChangeEmailPayload",
          "kind": "LinkedField",
          "name": "identityUserChangeEmail",
          "plural": false,
          "selections": [
            v3,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseIdentityUserChangeEmailMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "IdentityUserChangeEmailPayload",
          "kind": "LinkedField",
          "name": "identityUserChangeEmail",
          "plural": false,
          "selections": [
            v3,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "8984f71417e02b581bcf12d63829ac1f",
      "id": null,
      "metadata": {},
      "name": "UseIdentityUserChangeEmailMutation",
      "operationKind": "mutation",
      "text": "mutation UseIdentityUserChangeEmailMutation(\n  $input: IdentityUserChangeEmailInput!\n) {\n  data: identityUserChangeEmail(input: $input) {\n    payload {\n      node {\n        id\n        code\n        identityUserId\n        lastLoggedIn\n        firstName\n        lastName\n        email\n        updatedAt\n        createdAt\n        accountTypes\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node82.hash = "977bb21ac1df2108457df804d13c0bed";
var node92 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfElevateIdentityUser",
    "kind": "LinkedField",
    "name": "payload",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "IdentityUser",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          v2,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "identityUserId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastLoggedIn",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "accountTypes",
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v4 = {
    "kind": "InlineFragment",
    "selections": [
      v2,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseIdentityUserChangePasswordMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "IdentityUserChangePasswordPayload",
          "kind": "LinkedField",
          "name": "identityUserChangePassword",
          "plural": false,
          "selections": [
            v3,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseIdentityUserChangePasswordMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "IdentityUserChangePasswordPayload",
          "kind": "LinkedField",
          "name": "identityUserChangePassword",
          "plural": false,
          "selections": [
            v3,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "dd3ffccaa5567e57042cd9fada600a43",
      "id": null,
      "metadata": {},
      "name": "UseIdentityUserChangePasswordMutation",
      "operationKind": "mutation",
      "text": "mutation UseIdentityUserChangePasswordMutation(\n  $input: IdentityUserChangePasswordInput!\n) {\n  data: identityUserChangePassword(input: $input) {\n    payload {\n      node {\n        id\n        code\n        identityUserId\n        lastLoggedIn\n        firstName\n        lastName\n        email\n        updatedAt\n        createdAt\n        accountTypes\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node92.hash = "806f1b7cb845dda4475f62e718671a10";
var node102 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfElevateIdentityUser",
    "kind": "LinkedField",
    "name": "payload",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "IdentityUser",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          v2,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "identityUserId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastLoggedIn",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "accountTypes",
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v4 = {
    "kind": "InlineFragment",
    "selections": [
      v2,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseIdentityUserCreateMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "IdentityUserCreateWithoutPasswordPayload",
          "kind": "LinkedField",
          "name": "identityUserCreateWithoutPassword",
          "plural": false,
          "selections": [
            v3,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseIdentityUserCreateMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "IdentityUserCreateWithoutPasswordPayload",
          "kind": "LinkedField",
          "name": "identityUserCreateWithoutPassword",
          "plural": false,
          "selections": [
            v3,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "1d307655c9bb834bafd0256e9ea1ab58",
      "id": null,
      "metadata": {},
      "name": "UseIdentityUserCreateMutation",
      "operationKind": "mutation",
      "text": "mutation UseIdentityUserCreateMutation(\n  $input: IdentityUserCreateWithoutPasswordInput!\n) {\n  data: identityUserCreateWithoutPassword(input: $input) {\n    payload {\n      node {\n        id\n        code\n        identityUserId\n        lastLoggedIn\n        firstName\n        lastName\n        email\n        updatedAt\n        createdAt\n        accountTypes\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node102.hash = "12489aa7cb83eabd299772a46c35a3d0";
var node112 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfElevateIdentityUser",
    "kind": "LinkedField",
    "name": "payload",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "IdentityUser",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          v2,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "identityUserId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastLoggedIn",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "accountTypes",
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v4 = {
    "kind": "InlineFragment",
    "selections": [
      v2,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseIdentityUserRemoveAccountTypeMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "IdentityUserRemoveAccountTypePayload",
          "kind": "LinkedField",
          "name": "identityUserRemoveAccountType",
          "plural": false,
          "selections": [
            v3,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseIdentityUserRemoveAccountTypeMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "IdentityUserRemoveAccountTypePayload",
          "kind": "LinkedField",
          "name": "identityUserRemoveAccountType",
          "plural": false,
          "selections": [
            v3,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "8e404a50a9d34e8942a9f4802d50ff67",
      "id": null,
      "metadata": {},
      "name": "UseIdentityUserRemoveAccountTypeMutation",
      "operationKind": "mutation",
      "text": "mutation UseIdentityUserRemoveAccountTypeMutation(\n  $input: IdentityUserRemoveAccountTypeInput!\n) {\n  data: identityUserRemoveAccountType(input: $input) {\n    payload {\n      node {\n        id\n        code\n        identityUserId\n        lastLoggedIn\n        firstName\n        lastName\n        email\n        updatedAt\n        createdAt\n        accountTypes\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node112.hash = "edd5cdadc1a3e8d4c69b49f1d64b5ecf";
var node122 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "__typename",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "concreteType": "ImpersonationPayload",
    "kind": "LinkedField",
    "name": "impersonationPayload",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "EdgeOfImpersonationToken",
        "kind": "LinkedField",
        "name": "model",
        "plural": false,
        "selections": [
          v2,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "cursor",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "IdentityImpersonationToken",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "tokenId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasBeenUsed",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isDeleted",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "token",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdById",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdByAccountType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "updatedAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "updatedById",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "updatedByAccountType",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v4 = {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": "name",
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseCreateImpersonationTokenMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "IdentityCreateImpersonationTokenPayload",
          "kind": "LinkedField",
          "name": "identityCreateImpersonationToken",
          "plural": false,
          "selections": [
            v3,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseCreateImpersonationTokenMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "IdentityCreateImpersonationTokenPayload",
          "kind": "LinkedField",
          "name": "identityCreateImpersonationToken",
          "plural": false,
          "selections": [
            v3,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v2,
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "f1e831fac42995db0e91c82ab2e82990",
      "id": null,
      "metadata": {},
      "name": "UseCreateImpersonationTokenMutation",
      "operationKind": "mutation",
      "text": "mutation UseCreateImpersonationTokenMutation(\n  $input: IdentityCreateImpersonationTokenInput!\n) {\n  result: identityCreateImpersonationToken(input: $input) {\n    impersonationPayload {\n      model {\n        __typename\n        cursor\n        node {\n          id\n          tokenId\n          hasBeenUsed\n          isDeleted\n          token\n          createdAt\n          createdById\n          createdByAccountType\n          updatedAt\n          updatedById\n          updatedByAccountType\n        }\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        name: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node122.hash = "4414245fd3e034b1d4f2d863fa71e156";
var UseCreateImpersonationTokenMutation_graphql_default = node122;
var mutationDef62 = UseCreateImpersonationTokenMutation_graphql_default;
function useCreateImpersonationToken() {
  const [commit, isBusy] = useAsyncMutation62(mutationDef62);
  return [commit, isBusy];
}
var node132 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "__typename",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "concreteType": "ImpersonationUseTokenPayload",
    "kind": "LinkedField",
    "name": "impersonationUseTokenPayload",
    "plural": false,
    "selections": [
      v2,
      {
        "alias": null,
        "args": null,
        "concreteType": "EdgeOfImpersonationToken",
        "kind": "LinkedField",
        "name": "model",
        "plural": false,
        "selections": [
          v3,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "cursor",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "IdentityImpersonationToken",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "tokenId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasBeenUsed",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isDeleted",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "token",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdById",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdByAccountType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "updatedAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "updatedById",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "updatedByAccountType",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v5 = {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": "name",
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
      },
      v2,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseUseImpersonationTokenMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "IdentityUseImpersonationTokenPayload",
          "kind": "LinkedField",
          "name": "identityUseImpersonationToken",
          "plural": false,
          "selections": [
            v4,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v5
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseUseImpersonationTokenMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "IdentityUseImpersonationTokenPayload",
          "kind": "LinkedField",
          "name": "identityUseImpersonationToken",
          "plural": false,
          "selections": [
            v4,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v3,
                v5
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "3058feb33abaaefcdb075d6d8b1513f7",
      "id": null,
      "metadata": {},
      "name": "UseUseImpersonationTokenMutation",
      "operationKind": "mutation",
      "text": "mutation UseUseImpersonationTokenMutation(\n  $input: IdentityUseImpersonationTokenInput!\n) {\n  result: identityUseImpersonationToken(input: $input) {\n    impersonationUseTokenPayload {\n      code\n      model {\n        __typename\n        cursor\n        node {\n          id\n          tokenId\n          hasBeenUsed\n          isDeleted\n          token\n          createdAt\n          createdById\n          createdByAccountType\n          updatedAt\n          updatedById\n          updatedByAccountType\n        }\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        name: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node132.hash = "002dd069a04df225d4c74440b6dcbaf3";
var UseUseImpersonationTokenMutation_graphql_default = node132;
var mutationDef72 = UseUseImpersonationTokenMutation_graphql_default;
function useUseImpersonationToken() {
  const [commit, isBusy] = useAsyncMutation72(mutationDef72);
  return [commit, isBusy];
}
var IdentityUserAccountsErrorCodes = class {
};
IdentityUserAccountsErrorCodes.USER_EMAIL_IS_IN_USE = "ACCOUNTS_IDENTITY_USER_EMAIL_IS_IN_USE";
var formSchema = zod3.object({
  email: zod3.string().min(1, { message: "Email is required" }).email({
    message: "Must be a valid email"
  }),
  confirmEmail: zod3.string().min(1, { message: "Email is required" }).email({
    message: "Must be a valid email"
  })
}).refine((data) => data.email === data.confirmEmail, {
  message: "Emails don't match",
  path: ["confirmEmail"]
  // path of error
});
var formSchema2 = zod22.object({
  originalPassword: zod22.string().min(1, { message: "Original Password is required" }),
  password: zod22.string().min(8, { message: "Password is required" }),
  confirmPassword: zod22.string().min(8, { message: "Confirm password is required" })
}).refine((data) => data.password === data.confirmPassword, {
  message: "Passwords don't match",
  path: ["confirmPassword"]
  // path of error
});
var node142 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "IdentityAccountRow_account",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "identityId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "accountId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    }
  ],
  "type": "IdentityAccountModel",
  "abstractKey": null
};
node142.hash = "3a9fa679ab5dff84b3de56e32e0fb89a";
var formSchema3 = zod32.object({
  accountType: zod32.string().min(1, { message: "AccountType is required" }),
  email: zod32.string().min(1, { message: "Email is required" }).email({
    message: "Must be a valid email"
  }),
  sendPasswordResetNotification: zod32.boolean()
});
var node152 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = [
    {
      "kind": "Literal",
      "name": "first",
      "value": 10
    },
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "firstName": "DESC"
        }
      ]
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "IdentityUserListContainerQuery",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "IdentityUserListContainer_list"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "IdentityUserListContainerQuery",
      "selections": [
        {
          "alias": "list",
          "args": v1,
          "concreteType": "IdentityUsersConnection",
          "kind": "LinkedField",
          "name": "identityUsers",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "IdentityUsersEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "IdentityUser",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "identityUserId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "lastLoggedIn",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "firstName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "lastName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "email",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "accountTypes",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "list",
          "args": v1,
          "filters": [
            "order",
            "where"
          ],
          "handle": "connection",
          "key": "IdentityUserListContainer_list",
          "kind": "LinkedHandle",
          "name": "identityUsers"
        }
      ]
    },
    "params": {
      "cacheID": "8a36fda5da116cafb95d03158194dd60",
      "id": null,
      "metadata": {},
      "name": "IdentityUserListContainerQuery",
      "operationKind": "query",
      "text": "query IdentityUserListContainerQuery(\n  $where: IdentityUserFilter!\n) {\n  ...IdentityUserListContainer_list\n}\n\nfragment IdentityUserListContainer_list on Query {\n  list: identityUsers(first: 10, order: [{firstName: DESC}], where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        code\n        identityUserId\n        lastLoggedIn\n        updatedAt\n        createdAt\n        firstName\n        lastName\n        email\n        accountTypes\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node152.hash = "c7e71e666bfab87cb7f9be8354be8e0c";
var node162 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  }, v2 = {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }, v3 = [
    v1,
    v2,
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "firstName": "DESC"
        }
      ]
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "IdentityUsersListPaginationQuery",
      "selections": [
        {
          "args": [
            v1,
            v2
          ],
          "kind": "FragmentSpread",
          "name": "IdentityUserListContainer_list"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "IdentityUsersListPaginationQuery",
      "selections": [
        {
          "alias": "list",
          "args": v3,
          "concreteType": "IdentityUsersConnection",
          "kind": "LinkedField",
          "name": "identityUsers",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "IdentityUsersEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "IdentityUser",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "identityUserId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "lastLoggedIn",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "firstName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "lastName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "email",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "accountTypes",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "list",
          "args": v3,
          "filters": [
            "order",
            "where"
          ],
          "handle": "connection",
          "key": "IdentityUserListContainer_list",
          "kind": "LinkedHandle",
          "name": "identityUsers"
        }
      ]
    },
    "params": {
      "cacheID": "7c9314f0ab3ada67dcd469283f8533eb",
      "id": null,
      "metadata": {},
      "name": "IdentityUsersListPaginationQuery",
      "operationKind": "query",
      "text": "query IdentityUsersListPaginationQuery(\n  $after: String\n  $first: Int = 10\n  $where: IdentityUserFilter\n) {\n  ...IdentityUserListContainer_list_2HEEH6\n}\n\nfragment IdentityUserListContainer_list_2HEEH6 on Query {\n  list: identityUsers(first: $first, after: $after, order: [{firstName: DESC}], where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        code\n        identityUserId\n        lastLoggedIn\n        updatedAt\n        createdAt\n        firstName\n        lastName\n        email\n        accountTypes\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node162.hash = "2191fb28c88edfc41bcfc3b3f6f3695f";
var IdentityUsersListPaginationQuery_graphql_default = node162;
var node172 = function() {
  var v0 = [
    "list"
  ];
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
      },
      {
        "defaultValue": 10,
        "kind": "LocalArgument",
        "name": "first"
      },
      {
        "kind": "RootArgument",
        "name": "where"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": v0
        }
      ],
      "refetch": {
        "connection": {
          "forward": {
            "count": "first",
            "cursor": "after"
          },
          "backward": null,
          "path": v0
        },
        "fragmentPathInResult": [],
        "operation": IdentityUsersListPaginationQuery_graphql_default
      }
    },
    "name": "IdentityUserListContainer_list",
    "selections": [
      {
        "alias": "list",
        "args": [
          {
            "kind": "Literal",
            "name": "order",
            "value": [
              {
                "firstName": "DESC"
              }
            ]
          },
          {
            "kind": "Variable",
            "name": "where",
            "variableName": "where"
          }
        ],
        "concreteType": "IdentityUsersConnection",
        "kind": "LinkedField",
        "name": "__IdentityUserListContainer_list_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "IdentityUsersEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "IdentityUser",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "code",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "identityUserId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lastLoggedIn",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "updatedAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createdAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "firstName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lastName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "email",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "accountTypes",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node172.hash = "2191fb28c88edfc41bcfc3b3f6f3695f";
function useImpersonateUser() {
  const [createToken, isCreatingToken] = useCreateImpersonationToken();
  const [createCode, isCreatingCode] = useUseImpersonationToken();
  const onImpersonate = useCallback122(
    async (accountId, accountType) => {
      const createInput = {
        input: {
          clientMutationId: createClientMutationId52()
        }
      };
      const createResponse = await createToken({ input: createInput });
      const token = createResponse.result.impersonationPayload?.model?.node.token;
      if (!token) {
        return null;
      }
      const useInput = {
        input: {
          input: {
            clientMutationId: createClientMutationId52(),
            token,
            accountId,
            accountType
          }
        }
      };
      const useResponse = await createCode(useInput);
      const code = useResponse.result.impersonationUseTokenPayload?.code;
      return code || null;
    },
    []
  );
  return [onImpersonate, isCreatingToken || isCreatingCode];
}
var AuthCodes = class {
};
AuthCodes.AUTH_NOT_AUTHENTICATED = "AUTH_NOT_AUTHENTICATED";
var node182 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = [
    {
      "alias": "list",
      "args": [
        {
          "kind": "Literal",
          "name": "order",
          "value": [
            {
              "name": "ASC"
            }
          ]
        },
        {
          "kind": "Variable",
          "name": "where",
          "variableName": "where"
        }
      ],
      "concreteType": "CustomDataDocumentTypesConnection",
      "kind": "LinkedField",
      "name": "customDataDocumentTypes",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasPreviousPage",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "startCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "CustomDataDocumentTypesEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "DocumentType",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "documentTypeId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "code",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "sampleUrl",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "generatesDocument",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "canGeneratePdf",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "requiresExpiryDate",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "requiresIssueDate",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "requiresIssueNumber",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__id",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "DocumentTypeSearchBoxQuery",
      "selections": v1,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "DocumentTypeSearchBoxQuery",
      "selections": v1
    },
    "params": {
      "cacheID": "ab46c4e49410eaf914ba9900ea48d8eb",
      "id": null,
      "metadata": {},
      "name": "DocumentTypeSearchBoxQuery",
      "operationKind": "query",
      "text": "query DocumentTypeSearchBoxQuery(\n  $where: DocumentTypeFilter!\n) {\n  list: customDataDocumentTypes(order: [{name: ASC}], where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        documentTypeId\n        code\n        name\n        sampleUrl\n        generatesDocument\n        canGeneratePdf\n        requiresExpiryDate\n        requiresIssueDate\n        requiresIssueNumber\n      }\n    }\n  }\n}\n"
    }
  };
}();
node182.hash = "019868b5346df47460264ebf57f6a0e7";
var node192 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DocumentTypeAddAccess_document",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "documentTypeId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "version",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "code",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    }
  ],
  "type": "DocumentType",
  "abstractKey": null
};
node192.hash = "9476dca2077e96aa85659cd64c4d6496";
var node202 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "where",
    "variableName": "where"
  }, v2 = [
    {
      "kind": "Literal",
      "name": "first",
      "value": 10
    },
    v1
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "OrganisationListContainerQuery",
      "selections": [
        {
          "args": [
            v1
          ],
          "kind": "FragmentSpread",
          "name": "OrganisationListContainer_list"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "OrganisationListContainerQuery",
      "selections": [
        {
          "alias": "list",
          "args": v2,
          "concreteType": "CustomDataOrganisationsConnection",
          "kind": "LinkedField",
          "name": "customDataOrganisations",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "CustomDataOrganisationsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Organisation",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "organisationId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "externalOrganisationName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "status",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "list",
          "args": v2,
          "filters": [],
          "handle": "connection",
          "key": "OrganisationListContainer_list",
          "kind": "LinkedHandle",
          "name": "customDataOrganisations"
        }
      ]
    },
    "params": {
      "cacheID": "855fc28dc465b88b426bc38ef7abcadd",
      "id": null,
      "metadata": {},
      "name": "OrganisationListContainerQuery",
      "operationKind": "query",
      "text": "query OrganisationListContainerQuery(\n  $where: OrganisationFilter!\n) {\n  ...OrganisationListContainer_list_3FC4Qo\n}\n\nfragment OrganisationListContainer_list_3FC4Qo on Query {\n  list: customDataOrganisations(where: $where, first: 10) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        organisationId\n        code\n        updatedAt\n        externalOrganisationName\n        status\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node202.hash = "68762e7252e4558284bc683ac90d0e35";
var node212 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "after",
      "variableName": "after"
    },
    {
      "kind": "Variable",
      "name": "first",
      "variableName": "first"
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "OrganisationListQuery",
      "selections": [
        {
          "args": v1,
          "kind": "FragmentSpread",
          "name": "OrganisationListContainer_list"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "OrganisationListQuery",
      "selections": [
        {
          "alias": "list",
          "args": v1,
          "concreteType": "CustomDataOrganisationsConnection",
          "kind": "LinkedField",
          "name": "customDataOrganisations",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "CustomDataOrganisationsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Organisation",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "organisationId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "externalOrganisationName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "status",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "list",
          "args": v1,
          "filters": [],
          "handle": "connection",
          "key": "OrganisationListContainer_list",
          "kind": "LinkedHandle",
          "name": "customDataOrganisations"
        }
      ]
    },
    "params": {
      "cacheID": "46daefcc09532d98deda66337b2aafb0",
      "id": null,
      "metadata": {},
      "name": "OrganisationListQuery",
      "operationKind": "query",
      "text": "query OrganisationListQuery(\n  $after: String\n  $first: Int = 10\n  $where: OrganisationFilter\n) {\n  ...OrganisationListContainer_list_3sueo6\n}\n\nfragment OrganisationListContainer_list_3sueo6 on Query {\n  list: customDataOrganisations(where: $where, first: $first, after: $after) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        organisationId\n        code\n        updatedAt\n        externalOrganisationName\n        status\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node212.hash = "b7a15ba98291f39b91763c6e94345b44";
var OrganisationListQuery_graphql_default = node212;
var node222 = function() {
  var v0 = [
    "list"
  ];
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
      },
      {
        "defaultValue": 10,
        "kind": "LocalArgument",
        "name": "first"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "where"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": v0
        }
      ],
      "refetch": {
        "connection": {
          "forward": {
            "count": "first",
            "cursor": "after"
          },
          "backward": null,
          "path": v0
        },
        "fragmentPathInResult": [],
        "operation": OrganisationListQuery_graphql_default
      }
    },
    "name": "OrganisationListContainer_list",
    "selections": [
      {
        "alias": "list",
        "args": null,
        "concreteType": "CustomDataOrganisationsConnection",
        "kind": "LinkedField",
        "name": "__OrganisationListContainer_list_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CustomDataOrganisationsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Organisation",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "organisationId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "code",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "updatedAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "externalOrganisationName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "status",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node222.hash = "b7a15ba98291f39b91763c6e94345b44";
var node232 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "OrganisationRow_account",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "organisationId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "code",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "externalOrganisationId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "externalOrganisationName",
      "storageKey": null
    }
  ],
  "type": "Organisation",
  "abstractKey": null
};
node232.hash = "828e50547037b52f7ec5ede1019ef49f";
var node24 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  }, v2 = {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }, v3 = [
    v1,
    v2,
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "externalOrganisationName": "DESC"
        }
      ]
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "OrganisationSearchBoxPaginationQuery",
      "selections": [
        {
          "args": [
            v1,
            v2
          ],
          "kind": "FragmentSpread",
          "name": "OrganisationSearchBox_list"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "OrganisationSearchBoxPaginationQuery",
      "selections": [
        {
          "alias": "list",
          "args": v3,
          "concreteType": "CustomDataOrganisationsConnection",
          "kind": "LinkedField",
          "name": "customDataOrganisations",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "CustomDataOrganisationsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Organisation",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "organisationId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "externalOrganisationId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "externalOrganisationName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "status",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "list",
          "args": v3,
          "filters": [
            "order",
            "where"
          ],
          "handle": "connection",
          "key": "OrganisationSearchBox_list",
          "kind": "LinkedHandle",
          "name": "customDataOrganisations"
        }
      ]
    },
    "params": {
      "cacheID": "3019af94cc291fcef15c5d3edccefe90",
      "id": null,
      "metadata": {},
      "name": "OrganisationSearchBoxPaginationQuery",
      "operationKind": "query",
      "text": "query OrganisationSearchBoxPaginationQuery(\n  $after: String\n  $first: Int = 10\n  $where: OrganisationFilter\n) {\n  ...OrganisationSearchBox_list_2HEEH6\n}\n\nfragment OrganisationRow_account on Organisation {\n  id\n  organisationId\n  code\n  createdAt\n  updatedAt\n  status\n  externalOrganisationId\n  externalOrganisationName\n}\n\nfragment OrganisationSearchBox_list_2HEEH6 on Query {\n  list: customDataOrganisations(first: $first, after: $after, order: [{externalOrganisationName: DESC}], where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        organisationId\n        code\n        externalOrganisationId\n        externalOrganisationName\n        ...OrganisationRow_account\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node24.hash = "ff0beeec3ac7acb4a3c9df398cd28321";
var OrganisationSearchBoxPaginationQuery_graphql_default = node24;
var node25 = function() {
  var v0 = [
    "list"
  ];
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
      },
      {
        "defaultValue": 10,
        "kind": "LocalArgument",
        "name": "first"
      },
      {
        "kind": "RootArgument",
        "name": "where"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": v0
        }
      ],
      "refetch": {
        "connection": {
          "forward": {
            "count": "first",
            "cursor": "after"
          },
          "backward": null,
          "path": v0
        },
        "fragmentPathInResult": [],
        "operation": OrganisationSearchBoxPaginationQuery_graphql_default
      }
    },
    "name": "OrganisationSearchBox_list",
    "selections": [
      {
        "alias": "list",
        "args": [
          {
            "kind": "Literal",
            "name": "order",
            "value": [
              {
                "externalOrganisationName": "DESC"
              }
            ]
          },
          {
            "kind": "Variable",
            "name": "where",
            "variableName": "where"
          }
        ],
        "concreteType": "CustomDataOrganisationsConnection",
        "kind": "LinkedField",
        "name": "__OrganisationSearchBox_list_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CustomDataOrganisationsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Organisation",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "organisationId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "code",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "externalOrganisationId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "externalOrganisationName",
                    "storageKey": null
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "OrganisationRow_account"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node25.hash = "ff0beeec3ac7acb4a3c9df398cd28321";
var node26 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = [
    {
      "kind": "Literal",
      "name": "first",
      "value": 10
    },
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "externalOrganisationName": "DESC"
        }
      ]
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "OrganisationSearchContainerQuery",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "OrganisationSearchBox_list"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "OrganisationSearchContainerQuery",
      "selections": [
        {
          "alias": "list",
          "args": v1,
          "concreteType": "CustomDataOrganisationsConnection",
          "kind": "LinkedField",
          "name": "customDataOrganisations",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "CustomDataOrganisationsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Organisation",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "organisationId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "externalOrganisationId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "externalOrganisationName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "status",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "list",
          "args": v1,
          "filters": [
            "order",
            "where"
          ],
          "handle": "connection",
          "key": "OrganisationSearchBox_list",
          "kind": "LinkedHandle",
          "name": "customDataOrganisations"
        }
      ]
    },
    "params": {
      "cacheID": "42acf38ab27372537cf20a0f492eb351",
      "id": null,
      "metadata": {},
      "name": "OrganisationSearchContainerQuery",
      "operationKind": "query",
      "text": "query OrganisationSearchContainerQuery(\n  $where: OrganisationFilter!\n) {\n  ...OrganisationSearchBox_list\n}\n\nfragment OrganisationRow_account on Organisation {\n  id\n  organisationId\n  code\n  createdAt\n  updatedAt\n  status\n  externalOrganisationId\n  externalOrganisationName\n}\n\nfragment OrganisationSearchBox_list on Query {\n  list: customDataOrganisations(first: 10, order: [{externalOrganisationName: DESC}], where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        organisationId\n        code\n        externalOrganisationId\n        externalOrganisationName\n        ...OrganisationRow_account\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node26.hash = "49235eea666ddeff318b52b523395259";
var node27 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v4 = [
    v2,
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "accountType",
      "storageKey": null
    }
  ], v5 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfOrganisation",
    "kind": "LinkedField",
    "name": "organisation",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Organisation",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          v2,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "organisationId",
            "storageKey": null
          },
          v3,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "version",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountId",
            "kind": "LinkedField",
            "name": "createdBy",
            "plural": false,
            "selections": v4,
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountId",
            "kind": "LinkedField",
            "name": "updatedBy",
            "plural": false,
            "selections": v4,
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "externalOrganisationId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "externalOrganisationName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v6 = {
    "kind": "InlineFragment",
    "selections": [
      v3,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseCustomDataOrganisationCreateMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "CustomDataOrganisationsCreatePayload",
          "kind": "LinkedField",
          "name": "customDataOrganisationsCreate",
          "plural": false,
          "selections": [
            v5,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v6
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseCustomDataOrganisationCreateMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "CustomDataOrganisationsCreatePayload",
          "kind": "LinkedField",
          "name": "customDataOrganisationsCreate",
          "plural": false,
          "selections": [
            v5,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v6
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "ac7734ae62db055d0ff2a5daec148513",
      "id": null,
      "metadata": {},
      "name": "UseCustomDataOrganisationCreateMutation",
      "operationKind": "mutation",
      "text": "mutation UseCustomDataOrganisationCreateMutation(\n  $input: CustomDataOrganisationsCreateInput!\n) {\n  data: customDataOrganisationsCreate(input: $input) {\n    organisation {\n      node {\n        id\n        organisationId\n        code\n        version\n        createdAt\n        createdBy {\n          id\n          accountType\n        }\n        updatedAt\n        updatedBy {\n          id\n          accountType\n        }\n        externalOrganisationId\n        externalOrganisationName\n        status\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node27.hash = "7cd664e944b5560091560e84f1f15dd6";
var node28 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v4 = [
    v2,
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "accountType",
      "storageKey": null
    }
  ], v5 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfDocumentTypeAccess",
    "kind": "LinkedField",
    "name": "documentTypeAccess",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "DocumentTypeAccess",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          v2,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "documentTypeId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "documentTypeAccessId",
            "storageKey": null
          },
          v3,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "version",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountId",
            "kind": "LinkedField",
            "name": "createdBy",
            "plural": false,
            "selections": v4,
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountId",
            "kind": "LinkedField",
            "name": "updatedBy",
            "plural": false,
            "selections": v4,
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "organisationId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v6 = {
    "kind": "InlineFragment",
    "selections": [
      v3,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseDocumentTypeAddAccessMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "CustomDataDocumentTypeAccessCreatePayload",
          "kind": "LinkedField",
          "name": "customDataDocumentTypeAccessCreate",
          "plural": false,
          "selections": [
            v5,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v6
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseDocumentTypeAddAccessMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "CustomDataDocumentTypeAccessCreatePayload",
          "kind": "LinkedField",
          "name": "customDataDocumentTypeAccessCreate",
          "plural": false,
          "selections": [
            v5,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v6
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "c6c48b81a1cde3068e1f94b5e6250892",
      "id": null,
      "metadata": {},
      "name": "UseDocumentTypeAddAccessMutation",
      "operationKind": "mutation",
      "text": "mutation UseDocumentTypeAddAccessMutation(\n  $input: CustomDataDocumentTypeAccessCreateInput!\n) {\n  data: customDataDocumentTypeAccessCreate(input: $input) {\n    documentTypeAccess {\n      node {\n        id\n        documentTypeId\n        documentTypeAccessId\n        code\n        version\n        createdAt\n        createdBy {\n          id\n          accountType\n        }\n        updatedAt\n        updatedBy {\n          id\n          accountType\n        }\n        organisationId\n        status\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node28.hash = "0fe66d3f9abab1e6d85615f50ebbc496";
var node29 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "connections"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "succeeded",
    "storageKey": null
  }, v4 = {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseDocumentTypeRemoveAccessMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "CustomDataDocumentTypeAccessRemovePayload",
          "kind": "LinkedField",
          "name": "customDataDocumentTypeAccessRemove",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "DeleteResultOfDocumentTypeAccess",
              "kind": "LinkedField",
              "name": "result",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "EdgeOfDocumentTypeAccess",
                  "kind": "LinkedField",
                  "name": "edge",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "DocumentTypeAccess",
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        v2
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                v3
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseDocumentTypeRemoveAccessMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "CustomDataDocumentTypeAccessRemovePayload",
          "kind": "LinkedField",
          "name": "customDataDocumentTypeAccessRemove",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "DeleteResultOfDocumentTypeAccess",
              "kind": "LinkedField",
              "name": "result",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "EdgeOfDocumentTypeAccess",
                  "kind": "LinkedField",
                  "name": "edge",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "DocumentTypeAccess",
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        v2,
                        {
                          "alias": null,
                          "args": null,
                          "filters": null,
                          "handle": "deleteEdge",
                          "key": "",
                          "kind": "ScalarHandle",
                          "name": "id",
                          "handleArgs": [
                            {
                              "kind": "Variable",
                              "name": "connections",
                              "variableName": "connections"
                            }
                          ]
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                v3
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "de73ce932997a63590a4c29239010a7f",
      "id": null,
      "metadata": {},
      "name": "UseDocumentTypeRemoveAccessMutation",
      "operationKind": "mutation",
      "text": "mutation UseDocumentTypeRemoveAccessMutation(\n  $input: CustomDataDocumentTypeAccessRemoveInput!\n) {\n  data: customDataDocumentTypeAccessRemove(input: $input) {\n    result {\n      edge {\n        node {\n          id\n        }\n      }\n      succeeded\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node29.hash = "6279c1fede6eef401345bbbc042e6d94";
var node30 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v4 = [
    v2,
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "accountType",
      "storageKey": null
    }
  ], v5 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfDocumentType",
    "kind": "LinkedField",
    "name": "documentType",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "DocumentType",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          v2,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "documentTypeId",
            "storageKey": null
          },
          v3,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "version",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountId",
            "kind": "LinkedField",
            "name": "createdBy",
            "plural": false,
            "selections": v4,
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountId",
            "kind": "LinkedField",
            "name": "updatedBy",
            "plural": false,
            "selections": v4,
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v6 = {
    "kind": "InlineFragment",
    "selections": [
      v3,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseDocumentTypeCreateMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "CustomDataDocumentTypeCreatePayload",
          "kind": "LinkedField",
          "name": "customDataDocumentTypeCreate",
          "plural": false,
          "selections": [
            v5,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v6
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseDocumentTypeCreateMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "CustomDataDocumentTypeCreatePayload",
          "kind": "LinkedField",
          "name": "customDataDocumentTypeCreate",
          "plural": false,
          "selections": [
            v5,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v6
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "802d2117c9f929b6888e133ef638cd33",
      "id": null,
      "metadata": {},
      "name": "UseDocumentTypeCreateMutation",
      "operationKind": "mutation",
      "text": "mutation UseDocumentTypeCreateMutation(\n  $input: CustomDataDocumentTypeCreateInput!\n) {\n  result: customDataDocumentTypeCreate(input: $input) {\n    documentType {\n      node {\n        id\n        documentTypeId\n        code\n        version\n        createdAt\n        createdBy {\n          id\n          accountType\n        }\n        updatedAt\n        updatedBy {\n          id\n          accountType\n        }\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node30.hash = "0d769da3c027444d00494c9e9d431379";
var node31 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "where",
    "variableName": "where"
  }, v2 = [
    {
      "kind": "Literal",
      "name": "first",
      "value": 10
    },
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "updatedAt": "DESC"
        }
      ]
    },
    v1
  ], v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v4 = [
    v3,
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "accountType",
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "DocumentTypeAccessListContainerQuery",
      "selections": [
        {
          "args": [
            v1
          ],
          "kind": "FragmentSpread",
          "name": "DocumentTypeAccessList_list"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "DocumentTypeAccessListContainerQuery",
      "selections": [
        {
          "alias": "list",
          "args": v2,
          "concreteType": "CustomDataDocumentTypesAccessConnection",
          "kind": "LinkedField",
          "name": "customDataDocumentTypesAccess",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "CustomDataDocumentTypesAccessEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DocumentTypeAccess",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v3,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "documentTypeAccessId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "version",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "AccountId",
                      "kind": "LinkedField",
                      "name": "createdBy",
                      "plural": false,
                      "selections": v4,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "AccountId",
                      "kind": "LinkedField",
                      "name": "updatedBy",
                      "plural": false,
                      "selections": v4,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "organisationId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "documentTypeId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "status",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Organisation",
                      "kind": "LinkedField",
                      "name": "organisation",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "externalOrganisationName",
                          "storageKey": null
                        },
                        v3
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "list",
          "args": v2,
          "filters": [],
          "handle": "connection",
          "key": "DocumentTypeAccessList_list",
          "kind": "LinkedHandle",
          "name": "customDataDocumentTypesAccess"
        }
      ]
    },
    "params": {
      "cacheID": "4b1df62cd91a3396194aea6a31d06fa7",
      "id": null,
      "metadata": {},
      "name": "DocumentTypeAccessListContainerQuery",
      "operationKind": "query",
      "text": "query DocumentTypeAccessListContainerQuery(\n  $where: DocumentTypeAccessFilter!\n) {\n  ...DocumentTypeAccessList_list_3FC4Qo\n}\n\nfragment DocumentTypeAccessList_list_3FC4Qo on Query {\n  list: customDataDocumentTypesAccess(first: 10, order: [{updatedAt: DESC}], where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        documentTypeAccessId\n        code\n        version\n        createdAt\n        createdBy {\n          id\n          accountType\n        }\n        updatedAt\n        updatedBy {\n          id\n          accountType\n        }\n        organisationId\n        documentTypeId\n        status\n        organisation {\n          externalOrganisationName\n          id\n        }\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node31.hash = "814aadd0f35303d0b0e97df31a6e0ba8";
var node322 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  }, v2 = {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }, v3 = {
    "kind": "Variable",
    "name": "where",
    "variableName": "where"
  }, v4 = [
    v1,
    v2,
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "updatedAt": "DESC"
        }
      ]
    },
    v3
  ], v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v6 = [
    v5,
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "accountType",
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "DocumentTypeAccessListPaginationQuery",
      "selections": [
        {
          "args": [
            v1,
            v2,
            v3
          ],
          "kind": "FragmentSpread",
          "name": "DocumentTypeAccessList_list"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "DocumentTypeAccessListPaginationQuery",
      "selections": [
        {
          "alias": "list",
          "args": v4,
          "concreteType": "CustomDataDocumentTypesAccessConnection",
          "kind": "LinkedField",
          "name": "customDataDocumentTypesAccess",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "CustomDataDocumentTypesAccessEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DocumentTypeAccess",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v5,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "documentTypeAccessId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "version",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "AccountId",
                      "kind": "LinkedField",
                      "name": "createdBy",
                      "plural": false,
                      "selections": v6,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "AccountId",
                      "kind": "LinkedField",
                      "name": "updatedBy",
                      "plural": false,
                      "selections": v6,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "organisationId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "documentTypeId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "status",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Organisation",
                      "kind": "LinkedField",
                      "name": "organisation",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "externalOrganisationName",
                          "storageKey": null
                        },
                        v5
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "list",
          "args": v4,
          "filters": [],
          "handle": "connection",
          "key": "DocumentTypeAccessList_list",
          "kind": "LinkedHandle",
          "name": "customDataDocumentTypesAccess"
        }
      ]
    },
    "params": {
      "cacheID": "c94a20aa2ca2cd4d9fc944245826569a",
      "id": null,
      "metadata": {},
      "name": "DocumentTypeAccessListPaginationQuery",
      "operationKind": "query",
      "text": "query DocumentTypeAccessListPaginationQuery(\n  $after: String\n  $first: Int = 10\n  $where: DocumentTypeAccessFilter!\n) {\n  ...DocumentTypeAccessList_list_3sueo6\n}\n\nfragment DocumentTypeAccessList_list_3sueo6 on Query {\n  list: customDataDocumentTypesAccess(first: $first, after: $after, order: [{updatedAt: DESC}], where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        documentTypeAccessId\n        code\n        version\n        createdAt\n        createdBy {\n          id\n          accountType\n        }\n        updatedAt\n        updatedBy {\n          id\n          accountType\n        }\n        organisationId\n        documentTypeId\n        status\n        organisation {\n          externalOrganisationName\n          id\n        }\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node322.hash = "44736a4a436444f5d9d937a0edc5a326";
var DocumentTypeAccessListPaginationQuery_graphql_default = node322;
var node33 = function() {
  var v0 = [
    "list"
  ], v1 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v2 = [
    v1,
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "accountType",
      "storageKey": null
    }
  ];
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
      },
      {
        "defaultValue": 10,
        "kind": "LocalArgument",
        "name": "first"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "where"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": v0
        }
      ],
      "refetch": {
        "connection": {
          "forward": {
            "count": "first",
            "cursor": "after"
          },
          "backward": null,
          "path": v0
        },
        "fragmentPathInResult": [],
        "operation": DocumentTypeAccessListPaginationQuery_graphql_default
      }
    },
    "name": "DocumentTypeAccessList_list",
    "selections": [
      {
        "alias": "list",
        "args": null,
        "concreteType": "CustomDataDocumentTypesAccessConnection",
        "kind": "LinkedField",
        "name": "__DocumentTypeAccessList_list_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CustomDataDocumentTypesAccessEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "DocumentTypeAccess",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  v1,
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "documentTypeAccessId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "code",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "version",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createdAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AccountId",
                    "kind": "LinkedField",
                    "name": "createdBy",
                    "plural": false,
                    "selections": v2,
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "updatedAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AccountId",
                    "kind": "LinkedField",
                    "name": "updatedBy",
                    "plural": false,
                    "selections": v2,
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "organisationId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "documentTypeId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "status",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Organisation",
                    "kind": "LinkedField",
                    "name": "organisation",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "externalOrganisationName",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node33.hash = "44736a4a436444f5d9d937a0edc5a326";
var node34 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "idFilter"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "idFilter",
    "variableName": "idFilter"
  }, v2 = {
    "kind": "Variable",
    "name": "where",
    "variableName": "where"
  }, v3 = [
    {
      "kind": "Literal",
      "name": "first",
      "value": 10
    },
    v1,
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "updatedAt": "DESC"
        }
      ]
    },
    v2
  ], v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v5 = [
    v4,
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "accountType",
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "DocumentTypeListContainerQuery",
      "selections": [
        {
          "args": [
            v1,
            v2
          ],
          "kind": "FragmentSpread",
          "name": "DocumentTypeList_list"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "DocumentTypeListContainerQuery",
      "selections": [
        {
          "alias": "list",
          "args": v3,
          "concreteType": "CustomDataDocumentTypesConnection",
          "kind": "LinkedField",
          "name": "customDataDocumentTypes",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "CustomDataDocumentTypesEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DocumentType",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v4,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "documentTypeId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "version",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "AccountId",
                      "kind": "LinkedField",
                      "name": "createdBy",
                      "plural": false,
                      "selections": v5,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "AccountId",
                      "kind": "LinkedField",
                      "name": "updatedBy",
                      "plural": false,
                      "selections": v5,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "canGeneratePdf",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "list",
          "args": v3,
          "filters": [],
          "handle": "connection",
          "key": "DocumentTypeList_list",
          "kind": "LinkedHandle",
          "name": "customDataDocumentTypes"
        }
      ]
    },
    "params": {
      "cacheID": "5c18c67838f18feb1482963001f9a995",
      "id": null,
      "metadata": {},
      "name": "DocumentTypeListContainerQuery",
      "operationKind": "query",
      "text": "query DocumentTypeListContainerQuery(\n  $idFilter: OrganisationOrExternalIdInput\n  $where: DocumentTypeFilter!\n) {\n  ...DocumentTypeList_list_1WRxZe\n}\n\nfragment DocumentTypeList_list_1WRxZe on Query {\n  list: customDataDocumentTypes(idFilter: $idFilter, first: 10, order: [{updatedAt: DESC}], where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        documentTypeId\n        code\n        version\n        createdAt\n        createdBy {\n          id\n          accountType\n        }\n        updatedAt\n        updatedBy {\n          id\n          accountType\n        }\n        canGeneratePdf\n        name\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node34.hash = "b55c7b11452408447f395c68f9c3cc96";
var node35 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "idFilter"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  }, v2 = {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }, v3 = {
    "kind": "Variable",
    "name": "idFilter",
    "variableName": "idFilter"
  }, v4 = {
    "kind": "Variable",
    "name": "where",
    "variableName": "where"
  }, v5 = [
    v1,
    v2,
    v3,
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "updatedAt": "DESC"
        }
      ]
    },
    v4
  ], v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v7 = [
    v6,
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "accountType",
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "DocumentTypeListPaginationQuery",
      "selections": [
        {
          "args": [
            v1,
            v2,
            v3,
            v4
          ],
          "kind": "FragmentSpread",
          "name": "DocumentTypeList_list"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "DocumentTypeListPaginationQuery",
      "selections": [
        {
          "alias": "list",
          "args": v5,
          "concreteType": "CustomDataDocumentTypesConnection",
          "kind": "LinkedField",
          "name": "customDataDocumentTypes",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "CustomDataDocumentTypesEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DocumentType",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v6,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "documentTypeId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "version",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "AccountId",
                      "kind": "LinkedField",
                      "name": "createdBy",
                      "plural": false,
                      "selections": v7,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "AccountId",
                      "kind": "LinkedField",
                      "name": "updatedBy",
                      "plural": false,
                      "selections": v7,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "canGeneratePdf",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "list",
          "args": v5,
          "filters": [],
          "handle": "connection",
          "key": "DocumentTypeList_list",
          "kind": "LinkedHandle",
          "name": "customDataDocumentTypes"
        }
      ]
    },
    "params": {
      "cacheID": "86e57bd1fdd2b0faa268febbee37c4dd",
      "id": null,
      "metadata": {},
      "name": "DocumentTypeListPaginationQuery",
      "operationKind": "query",
      "text": "query DocumentTypeListPaginationQuery(\n  $after: String\n  $first: Int = 10\n  $idFilter: OrganisationOrExternalIdInput\n  $where: DocumentTypeFilter!\n) {\n  ...DocumentTypeList_list_41Y8sq\n}\n\nfragment DocumentTypeList_list_41Y8sq on Query {\n  list: customDataDocumentTypes(idFilter: $idFilter, first: $first, after: $after, order: [{updatedAt: DESC}], where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        documentTypeId\n        code\n        version\n        createdAt\n        createdBy {\n          id\n          accountType\n        }\n        updatedAt\n        updatedBy {\n          id\n          accountType\n        }\n        canGeneratePdf\n        name\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node35.hash = "6dab9eaff0f76628a8ce1c9e98605d7e";
var DocumentTypeListPaginationQuery_graphql_default = node35;
var node36 = function() {
  var v0 = [
    "list"
  ], v1 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v2 = [
    v1,
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "accountType",
      "storageKey": null
    }
  ];
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
      },
      {
        "defaultValue": 10,
        "kind": "LocalArgument",
        "name": "first"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "idFilter"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "where"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": v0
        }
      ],
      "refetch": {
        "connection": {
          "forward": {
            "count": "first",
            "cursor": "after"
          },
          "backward": null,
          "path": v0
        },
        "fragmentPathInResult": [],
        "operation": DocumentTypeListPaginationQuery_graphql_default
      }
    },
    "name": "DocumentTypeList_list",
    "selections": [
      {
        "alias": "list",
        "args": null,
        "concreteType": "CustomDataDocumentTypesConnection",
        "kind": "LinkedField",
        "name": "__DocumentTypeList_list_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CustomDataDocumentTypesEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "DocumentType",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  v1,
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "documentTypeId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "code",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "version",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createdAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AccountId",
                    "kind": "LinkedField",
                    "name": "createdBy",
                    "plural": false,
                    "selections": v2,
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "updatedAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AccountId",
                    "kind": "LinkedField",
                    "name": "updatedBy",
                    "plural": false,
                    "selections": v2,
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "canGeneratePdf",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node36.hash = "6dab9eaff0f76628a8ce1c9e98605d7e";
var formSchema4 = zod4.object({
  name: zod4.string().min(1, { message: "name is required" }),
  description: zod4.string().min(1, { message: "description is required" }),
  organisation: zod4.string().min(1, { message: "organisation is required" }),
  htmlTemplate: zod4.string(),
  sampleUrl: zod4.string().nullable(),
  generatesDocument: zod4.boolean(),
  requiresExpiryDate: zod4.boolean(),
  requiresIssueDate: zod4.boolean(),
  requiresIssueNumber: zod4.boolean()
});
var node37 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FormTemplateAccessContainer_access",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "formTemplateAccessId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "code",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "version",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Organisation",
      "kind": "LinkedField",
      "name": "organisation",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "externalOrganisationName",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "FormTemplateAccess",
  "abstractKey": null
};
node37.hash = "b0df7db19461ca73c7cc4877b680c233";
var node38 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v4 = [
    v2,
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "accountType",
      "storageKey": null
    }
  ], v5 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfFormTemplateAccess",
    "kind": "LinkedField",
    "name": "formTemplateAccess",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "FormTemplateAccess",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          v2,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "formTemplateAccessId",
            "storageKey": null
          },
          v3,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "version",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountId",
            "kind": "LinkedField",
            "name": "createdBy",
            "plural": false,
            "selections": v4,
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountId",
            "kind": "LinkedField",
            "name": "updatedBy",
            "plural": false,
            "selections": v4,
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "organisationId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "formTemplateTypeId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v6 = {
    "kind": "InlineFragment",
    "selections": [
      v3,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseFormTemplateAddAccessMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "CustomDataFormTemplateAccessCreatePayload",
          "kind": "LinkedField",
          "name": "customDataFormTemplateAccessCreate",
          "plural": false,
          "selections": [
            v5,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v6
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseFormTemplateAddAccessMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "CustomDataFormTemplateAccessCreatePayload",
          "kind": "LinkedField",
          "name": "customDataFormTemplateAccessCreate",
          "plural": false,
          "selections": [
            v5,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v6
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "a94828985b139e9b5222458fee58b761",
      "id": null,
      "metadata": {},
      "name": "UseFormTemplateAddAccessMutation",
      "operationKind": "mutation",
      "text": "mutation UseFormTemplateAddAccessMutation(\n  $input: CustomDataFormTemplateAccessCreateInput!\n) {\n  data: customDataFormTemplateAccessCreate(input: $input) {\n    formTemplateAccess {\n      node {\n        id\n        formTemplateAccessId\n        code\n        version\n        createdAt\n        createdBy {\n          id\n          accountType\n        }\n        updatedAt\n        updatedBy {\n          id\n          accountType\n        }\n        organisationId\n        formTemplateTypeId\n        status\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node38.hash = "4d3ef0688a9d75aa4c44ce223f1513a3";
var node39 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "connections"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "succeeded",
    "storageKey": null
  }, v4 = {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseFormTemplateRemoveAccessMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "CustomDataFormTemplateAccessRemovePayload",
          "kind": "LinkedField",
          "name": "customDataFormTemplateAccessRemove",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "DeleteResultOfFormTemplateAccess",
              "kind": "LinkedField",
              "name": "result",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "EdgeOfFormTemplateAccess",
                  "kind": "LinkedField",
                  "name": "edge",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "FormTemplateAccess",
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        v2
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                v3
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseFormTemplateRemoveAccessMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "CustomDataFormTemplateAccessRemovePayload",
          "kind": "LinkedField",
          "name": "customDataFormTemplateAccessRemove",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "DeleteResultOfFormTemplateAccess",
              "kind": "LinkedField",
              "name": "result",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "EdgeOfFormTemplateAccess",
                  "kind": "LinkedField",
                  "name": "edge",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "FormTemplateAccess",
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        v2,
                        {
                          "alias": null,
                          "args": null,
                          "filters": null,
                          "handle": "deleteEdge",
                          "key": "",
                          "kind": "ScalarHandle",
                          "name": "id",
                          "handleArgs": [
                            {
                              "kind": "Variable",
                              "name": "connections",
                              "variableName": "connections"
                            }
                          ]
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                v3
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "bb023c3143782d49ac00abc8edd5e55e",
      "id": null,
      "metadata": {},
      "name": "UseFormTemplateRemoveAccessMutation",
      "operationKind": "mutation",
      "text": "mutation UseFormTemplateRemoveAccessMutation(\n  $input: CustomDataFormTemplateAccessRemoveInput!\n) {\n  data: customDataFormTemplateAccessRemove(input: $input) {\n    result {\n      edge {\n        node {\n          id\n        }\n      }\n      succeeded\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node39.hash = "4802de61bb6f64f7463d75cd419be505";
var node40 = function() {
  var v0 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  };
  return {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "FormTemplateTypeAddAccess_formTemplate",
    "selections": [
      v0,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "formTemplateId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "FormTemplateType",
        "kind": "LinkedField",
        "name": "formTemplateType",
        "plural": false,
        "selections": [
          v0,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "formTemplateTypeId",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "version",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "updatedAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "key",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "description",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "typeId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "allowPreFilling",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "requiresSignature",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "uiSchema",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "dataSchema",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "documentTypeId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "htmlTemplate",
        "storageKey": null
      }
    ],
    "type": "FormTemplate",
    "abstractKey": null
  };
}();
node40.hash = "87ec28245d4e7b96eea152a4e6244a6a";
var node41 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = [
    {
      "kind": "Literal",
      "name": "first",
      "value": 10
    },
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "updatedAt": "DESC"
        }
      ]
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "FormTemplateAccessListContainerQuery",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "FormTemplateAccessList_list"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "FormTemplateAccessListContainerQuery",
      "selections": [
        {
          "alias": "list",
          "args": v1,
          "concreteType": "CustomDataFormTemplateAccessConnection",
          "kind": "LinkedField",
          "name": "customDataFormTemplateAccess",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "CustomDataFormTemplateAccessEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "FormTemplateAccess",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v2,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "formTemplateAccessId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "status",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "version",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Organisation",
                      "kind": "LinkedField",
                      "name": "organisation",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "externalOrganisationName",
                          "storageKey": null
                        },
                        v2
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "list",
          "args": v1,
          "filters": [],
          "handle": "connection",
          "key": "FormTemplateAccessList_list",
          "kind": "LinkedHandle",
          "name": "customDataFormTemplateAccess"
        }
      ]
    },
    "params": {
      "cacheID": "90097c854c4287c7176929f37b35389d",
      "id": null,
      "metadata": {},
      "name": "FormTemplateAccessListContainerQuery",
      "operationKind": "query",
      "text": "query FormTemplateAccessListContainerQuery(\n  $where: FormTemplateAccessFilter!\n) {\n  ...FormTemplateAccessList_list\n}\n\nfragment FormTemplateAccessList_list on Query {\n  list: customDataFormTemplateAccess(first: 10, order: [{updatedAt: DESC}], where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        formTemplateAccessId\n        code\n        createdAt\n        updatedAt\n        status\n        version\n        organisation {\n          externalOrganisationName\n          id\n        }\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node41.hash = "b05af4f54eabb82ba8a1628efc4f2f42";
var node422 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  }, v2 = {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }, v3 = [
    v1,
    v2,
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "updatedAt": "DESC"
        }
      ]
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ], v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "FormTemplateAccessListPaginationQuery",
      "selections": [
        {
          "args": [
            v1,
            v2
          ],
          "kind": "FragmentSpread",
          "name": "FormTemplateAccessList_list"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "FormTemplateAccessListPaginationQuery",
      "selections": [
        {
          "alias": "list",
          "args": v3,
          "concreteType": "CustomDataFormTemplateAccessConnection",
          "kind": "LinkedField",
          "name": "customDataFormTemplateAccess",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "CustomDataFormTemplateAccessEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "FormTemplateAccess",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v4,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "formTemplateAccessId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "status",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "version",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Organisation",
                      "kind": "LinkedField",
                      "name": "organisation",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "externalOrganisationName",
                          "storageKey": null
                        },
                        v4
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "list",
          "args": v3,
          "filters": [],
          "handle": "connection",
          "key": "FormTemplateAccessList_list",
          "kind": "LinkedHandle",
          "name": "customDataFormTemplateAccess"
        }
      ]
    },
    "params": {
      "cacheID": "93821843e924400f8891c3d5d96b8b21",
      "id": null,
      "metadata": {},
      "name": "FormTemplateAccessListPaginationQuery",
      "operationKind": "query",
      "text": "query FormTemplateAccessListPaginationQuery(\n  $after: String\n  $first: Int = 10\n  $where: FormTemplateAccessFilter\n) {\n  ...FormTemplateAccessList_list_2HEEH6\n}\n\nfragment FormTemplateAccessList_list_2HEEH6 on Query {\n  list: customDataFormTemplateAccess(first: $first, after: $after, order: [{updatedAt: DESC}], where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        formTemplateAccessId\n        code\n        createdAt\n        updatedAt\n        status\n        version\n        organisation {\n          externalOrganisationName\n          id\n        }\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node422.hash = "997b9c1a79fa05ff3fafbe9b31c1bcaa";
var FormTemplateAccessListPaginationQuery_graphql_default = node422;
var node43 = function() {
  var v0 = [
    "list"
  ];
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
      },
      {
        "defaultValue": 10,
        "kind": "LocalArgument",
        "name": "first"
      },
      {
        "kind": "RootArgument",
        "name": "where"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": v0
        }
      ],
      "refetch": {
        "connection": {
          "forward": {
            "count": "first",
            "cursor": "after"
          },
          "backward": null,
          "path": v0
        },
        "fragmentPathInResult": [],
        "operation": FormTemplateAccessListPaginationQuery_graphql_default
      }
    },
    "name": "FormTemplateAccessList_list",
    "selections": [
      {
        "alias": "list",
        "args": null,
        "concreteType": "CustomDataFormTemplateAccessConnection",
        "kind": "LinkedField",
        "name": "__FormTemplateAccessList_list_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CustomDataFormTemplateAccessEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "FormTemplateAccess",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "formTemplateAccessId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "code",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createdAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "updatedAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "status",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "version",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Organisation",
                    "kind": "LinkedField",
                    "name": "organisation",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "externalOrganisationName",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node43.hash = "997b9c1a79fa05ff3fafbe9b31c1bcaa";
var node44 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  }, v2 = {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }, v3 = [
    v1,
    v2,
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "name": "ASC"
        }
      ]
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "FormTemplateTypeSearchBoxPaginationQuery",
      "selections": [
        {
          "args": [
            v1,
            v2
          ],
          "kind": "FragmentSpread",
          "name": "FormTemplateTypeSearchBox_list"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "FormTemplateTypeSearchBoxPaginationQuery",
      "selections": [
        {
          "alias": "list",
          "args": v3,
          "concreteType": "CustomDataFormTemplateTypesConnection",
          "kind": "LinkedField",
          "name": "customDataFormTemplateTypes",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "CustomDataFormTemplateTypesEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "FormTemplateType",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "formTemplateTypeId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "key",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "description",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "list",
          "args": v3,
          "filters": [
            "order",
            "where"
          ],
          "handle": "connection",
          "key": "FormTemplateTypeSearchBox_list",
          "kind": "LinkedHandle",
          "name": "customDataFormTemplateTypes"
        }
      ]
    },
    "params": {
      "cacheID": "1892bd75e00d1e324aa69be71b1d13ef",
      "id": null,
      "metadata": {},
      "name": "FormTemplateTypeSearchBoxPaginationQuery",
      "operationKind": "query",
      "text": "query FormTemplateTypeSearchBoxPaginationQuery(\n  $after: String\n  $first: Int = 10\n  $where: FormTemplateTypeFilter\n) {\n  ...FormTemplateTypeSearchBox_list_2HEEH6\n}\n\nfragment FormTemplateTypeRow_account on FormTemplateType {\n  id\n  formTemplateTypeId\n  code\n  createdAt\n  updatedAt\n  key\n  name\n  description\n}\n\nfragment FormTemplateTypeSearchBox_list_2HEEH6 on Query {\n  list: customDataFormTemplateTypes(first: $first, after: $after, order: [{name: ASC}], where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        formTemplateTypeId\n        code\n        key\n        name\n        description\n        ...FormTemplateTypeRow_account\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node44.hash = "9cefb148ea5445480f290143b72512af";
var FormTemplateTypeSearchBoxPaginationQuery_graphql_default = node44;
var node45 = function() {
  var v0 = [
    "list"
  ];
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
      },
      {
        "defaultValue": 10,
        "kind": "LocalArgument",
        "name": "first"
      },
      {
        "kind": "RootArgument",
        "name": "where"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": v0
        }
      ],
      "refetch": {
        "connection": {
          "forward": {
            "count": "first",
            "cursor": "after"
          },
          "backward": null,
          "path": v0
        },
        "fragmentPathInResult": [],
        "operation": FormTemplateTypeSearchBoxPaginationQuery_graphql_default
      }
    },
    "name": "FormTemplateTypeSearchBox_list",
    "selections": [
      {
        "alias": "list",
        "args": [
          {
            "kind": "Literal",
            "name": "order",
            "value": [
              {
                "name": "ASC"
              }
            ]
          },
          {
            "kind": "Variable",
            "name": "where",
            "variableName": "where"
          }
        ],
        "concreteType": "CustomDataFormTemplateTypesConnection",
        "kind": "LinkedField",
        "name": "__FormTemplateTypeSearchBox_list_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CustomDataFormTemplateTypesEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "FormTemplateType",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "formTemplateTypeId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "code",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "key",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "description",
                    "storageKey": null
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "FormTemplateTypeRow_account"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node45.hash = "9cefb148ea5445480f290143b72512af";
var node46 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = [
    {
      "kind": "Literal",
      "name": "first",
      "value": 10
    },
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "name": "ASC"
        }
      ]
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "FormTemplateTypeSearchContainerQuery",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "FormTemplateTypeSearchBox_list"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "FormTemplateTypeSearchContainerQuery",
      "selections": [
        {
          "alias": "list",
          "args": v1,
          "concreteType": "CustomDataFormTemplateTypesConnection",
          "kind": "LinkedField",
          "name": "customDataFormTemplateTypes",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "CustomDataFormTemplateTypesEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "FormTemplateType",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "formTemplateTypeId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "key",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "description",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "list",
          "args": v1,
          "filters": [
            "order",
            "where"
          ],
          "handle": "connection",
          "key": "FormTemplateTypeSearchBox_list",
          "kind": "LinkedHandle",
          "name": "customDataFormTemplateTypes"
        }
      ]
    },
    "params": {
      "cacheID": "1cb45b1838697c31cd9a48155d858634",
      "id": null,
      "metadata": {},
      "name": "FormTemplateTypeSearchContainerQuery",
      "operationKind": "query",
      "text": "query FormTemplateTypeSearchContainerQuery(\n  $where: FormTemplateTypeFilter!\n) {\n  ...FormTemplateTypeSearchBox_list\n}\n\nfragment FormTemplateTypeRow_account on FormTemplateType {\n  id\n  formTemplateTypeId\n  code\n  createdAt\n  updatedAt\n  key\n  name\n  description\n}\n\nfragment FormTemplateTypeSearchBox_list on Query {\n  list: customDataFormTemplateTypes(first: 10, order: [{name: ASC}], where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        formTemplateTypeId\n        code\n        key\n        name\n        description\n        ...FormTemplateTypeRow_account\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node46.hash = "93e6eb470bf68f46a447667867231f50";
var node47 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfFormTemplate",
    "kind": "LinkedField",
    "name": "formTemplate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "FormTemplate",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "formTemplateId",
            "storageKey": null
          },
          v2,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "key",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "uiSchema",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "dataSchema",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v4 = {
    "kind": "InlineFragment",
    "selections": [
      v2,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseFormTemplateCreateMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "CustomDataFormTemplateCreatePayload",
          "kind": "LinkedField",
          "name": "customDataFormTemplateCreate",
          "plural": false,
          "selections": [
            v3,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseFormTemplateCreateMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "CustomDataFormTemplateCreatePayload",
          "kind": "LinkedField",
          "name": "customDataFormTemplateCreate",
          "plural": false,
          "selections": [
            v3,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "8c264c9265e392891eadf0f9ed1a3013",
      "id": null,
      "metadata": {},
      "name": "UseFormTemplateCreateMutation",
      "operationKind": "mutation",
      "text": "mutation UseFormTemplateCreateMutation(\n  $input: CustomDataFormTemplateCreateInput!\n) {\n  result: customDataFormTemplateCreate(input: $input) {\n    formTemplate {\n      node {\n        id\n        formTemplateId\n        code\n        createdAt\n        updatedAt\n        key\n        name\n        description\n        uiSchema\n        dataSchema\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node47.hash = "f3e18f786a99965536b9f47606850b00";
var node48 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfFormTemplate",
    "kind": "LinkedField",
    "name": "formTemplate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "FormTemplate",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "formTemplateId",
            "storageKey": null
          },
          v2,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "key",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "uiSchema",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "dataSchema",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v4 = {
    "kind": "InlineFragment",
    "selections": [
      v2,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseFormTemplateUpdateMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "CustomDataFormTemplateUpdatePayload",
          "kind": "LinkedField",
          "name": "customDataFormTemplateUpdate",
          "plural": false,
          "selections": [
            v3,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseFormTemplateUpdateMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "CustomDataFormTemplateUpdatePayload",
          "kind": "LinkedField",
          "name": "customDataFormTemplateUpdate",
          "plural": false,
          "selections": [
            v3,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "bba1f07e1d70e1cc55969630615a95f0",
      "id": null,
      "metadata": {},
      "name": "UseFormTemplateUpdateMutation",
      "operationKind": "mutation",
      "text": "mutation UseFormTemplateUpdateMutation(\n  $input: CustomDataFormTemplateUpdateInput!\n) {\n  result: customDataFormTemplateUpdate(input: $input) {\n    formTemplate {\n      node {\n        id\n        formTemplateId\n        code\n        createdAt\n        updatedAt\n        key\n        name\n        description\n        uiSchema\n        dataSchema\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node48.hash = "3da9ed543908ff339c1f6deaad7d4f0d";
var FormTemplateErrorCodes = class {
};
FormTemplateErrorCodes.KEY_IN_USE = "CUSTOM_DATA_FORM_TEMPLATE_KEY_IS_IN_USE";
FormTemplateErrorCodes.INVALID_DATA_SCHEMA = "CUSTOM_DATA_FORM_TEMPLATE_INVALID_DATA_SCHEMA";
FormTemplateErrorCodes.INVALID_UI_SCHEMA = "CUSTOM_DATA_FORM_TEMPLATE_KEY_INVALID_UI_SCHEMA";
var node49 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FormTemplateEditor_formTemplate",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "formTemplateId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "version",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "code",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "key",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "typeId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "allowPreFilling",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "requiresSignature",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "uiSchema",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "dataSchema",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "documentTypeId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "htmlTemplate",
      "storageKey": null
    }
  ],
  "type": "FormTemplate",
  "abstractKey": null
};
node49.hash = "97280ab60da4ef418b15e74439cda06b";
var node50 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "idFilter"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "idFilter",
    "variableName": "idFilter"
  }, v2 = {
    "kind": "Variable",
    "name": "where",
    "variableName": "where"
  }, v3 = [
    {
      "kind": "Literal",
      "name": "first",
      "value": 10
    },
    v1,
    v2
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "FormTemplateListContainerQuery",
      "selections": [
        {
          "args": [
            v1,
            v2
          ],
          "kind": "FragmentSpread",
          "name": "FormTemplateListContainer_list"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "FormTemplateListContainerQuery",
      "selections": [
        {
          "alias": "list",
          "args": v3,
          "concreteType": "CustomDataFormTemplatesConnection",
          "kind": "LinkedField",
          "name": "customDataFormTemplates",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "CustomDataFormTemplatesEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "FormTemplate",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "formTemplateId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "key",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "description",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "list",
          "args": v3,
          "filters": [],
          "handle": "connection",
          "key": "FormTemplateListContainer_list",
          "kind": "LinkedHandle",
          "name": "customDataFormTemplates"
        }
      ]
    },
    "params": {
      "cacheID": "bf1bf0f57a9e0f89f9b5cd8043e582ac",
      "id": null,
      "metadata": {},
      "name": "FormTemplateListContainerQuery",
      "operationKind": "query",
      "text": "query FormTemplateListContainerQuery(\n  $idFilter: OrganisationOrExternalIdInput\n  $where: FormTemplateFilter!\n) {\n  ...FormTemplateListContainer_list_1WRxZe\n}\n\nfragment FormTemplateListContainer_list_1WRxZe on Query {\n  list: customDataFormTemplates(idFilter: $idFilter, where: $where, first: 10) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        formTemplateId\n        code\n        updatedAt\n        key\n        name\n        description\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node50.hash = "41744d5b7f78338359cd71ee9e82a613";
var node51 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "idFilter"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "after",
      "variableName": "after"
    },
    {
      "kind": "Variable",
      "name": "first",
      "variableName": "first"
    },
    {
      "kind": "Variable",
      "name": "idFilter",
      "variableName": "idFilter"
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "FormTemplateListQuery",
      "selections": [
        {
          "args": v1,
          "kind": "FragmentSpread",
          "name": "FormTemplateListContainer_list"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "FormTemplateListQuery",
      "selections": [
        {
          "alias": "list",
          "args": v1,
          "concreteType": "CustomDataFormTemplatesConnection",
          "kind": "LinkedField",
          "name": "customDataFormTemplates",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "CustomDataFormTemplatesEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "FormTemplate",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "formTemplateId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "key",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "description",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "list",
          "args": v1,
          "filters": [],
          "handle": "connection",
          "key": "FormTemplateListContainer_list",
          "kind": "LinkedHandle",
          "name": "customDataFormTemplates"
        }
      ]
    },
    "params": {
      "cacheID": "166014f8959744e4ef00f2f06a8b57cc",
      "id": null,
      "metadata": {},
      "name": "FormTemplateListQuery",
      "operationKind": "query",
      "text": "query FormTemplateListQuery(\n  $after: String\n  $first: Int = 10\n  $idFilter: OrganisationOrExternalIdInput\n  $where: FormTemplateFilter\n) {\n  ...FormTemplateListContainer_list_41Y8sq\n}\n\nfragment FormTemplateListContainer_list_41Y8sq on Query {\n  list: customDataFormTemplates(idFilter: $idFilter, where: $where, first: $first, after: $after) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        formTemplateId\n        code\n        updatedAt\n        key\n        name\n        description\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node51.hash = "b93bb3b35789b0378bb9f38aeaca3276";
var FormTemplateListQuery_graphql_default = node51;
var node522 = function() {
  var v0 = [
    "list"
  ];
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
      },
      {
        "defaultValue": 10,
        "kind": "LocalArgument",
        "name": "first"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "idFilter"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "where"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": v0
        }
      ],
      "refetch": {
        "connection": {
          "forward": {
            "count": "first",
            "cursor": "after"
          },
          "backward": null,
          "path": v0
        },
        "fragmentPathInResult": [],
        "operation": FormTemplateListQuery_graphql_default
      }
    },
    "name": "FormTemplateListContainer_list",
    "selections": [
      {
        "alias": "list",
        "args": null,
        "concreteType": "CustomDataFormTemplatesConnection",
        "kind": "LinkedField",
        "name": "__FormTemplateListContainer_list_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CustomDataFormTemplatesEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "FormTemplate",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "formTemplateId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "code",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "updatedAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "key",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "description",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node522.hash = "b93bb3b35789b0378bb9f38aeaca3276";
var node53 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FormTemplateRow_account",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "formTemplateId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "code",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "key",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    }
  ],
  "type": "FormTemplate",
  "abstractKey": null
};
node53.hash = "ea2816ae2bb1a5048706a5bb7bf07d36";
var node54 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "idFilter"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  }, v2 = {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }, v3 = [
    v1,
    v2,
    {
      "kind": "Variable",
      "name": "idFilter",
      "variableName": "idFilter"
    },
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "name": "ASC"
        }
      ]
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "FormTemplateSearchBoxPaginationQuery",
      "selections": [
        {
          "args": [
            v1,
            v2
          ],
          "kind": "FragmentSpread",
          "name": "FormTemplateSearchBox_list"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "FormTemplateSearchBoxPaginationQuery",
      "selections": [
        {
          "alias": "list",
          "args": v3,
          "concreteType": "CustomDataFormTemplatesConnection",
          "kind": "LinkedField",
          "name": "customDataFormTemplates",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "CustomDataFormTemplatesEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "FormTemplate",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "formTemplateId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "key",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "description",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "list",
          "args": v3,
          "filters": [
            "idFilter",
            "where",
            "order"
          ],
          "handle": "connection",
          "key": "FormTemplateSearchBox_list",
          "kind": "LinkedHandle",
          "name": "customDataFormTemplates"
        }
      ]
    },
    "params": {
      "cacheID": "832a326ee247fd9da9ec9244d5fd25a5",
      "id": null,
      "metadata": {},
      "name": "FormTemplateSearchBoxPaginationQuery",
      "operationKind": "query",
      "text": "query FormTemplateSearchBoxPaginationQuery(\n  $after: String\n  $first: Int = 10\n  $idFilter: OrganisationOrExternalIdInput\n  $where: FormTemplateFilter\n) {\n  ...FormTemplateSearchBox_list_2HEEH6\n}\n\nfragment FormTemplateRow_account on FormTemplate {\n  id\n  formTemplateId\n  code\n  createdAt\n  updatedAt\n  key\n  name\n  description\n}\n\nfragment FormTemplateSearchBox_list_2HEEH6 on Query {\n  list: customDataFormTemplates(idFilter: $idFilter, where: $where, first: $first, after: $after, order: [{name: ASC}]) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        formTemplateId\n        code\n        key\n        name\n        description\n        ...FormTemplateRow_account\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node54.hash = "aea68de6264c76b6ebd336dfbd59ac23";
var FormTemplateSearchBoxPaginationQuery_graphql_default = node54;
var node55 = function() {
  var v0 = [
    "list"
  ];
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
      },
      {
        "defaultValue": 10,
        "kind": "LocalArgument",
        "name": "first"
      },
      {
        "kind": "RootArgument",
        "name": "idFilter"
      },
      {
        "kind": "RootArgument",
        "name": "where"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": v0
        }
      ],
      "refetch": {
        "connection": {
          "forward": {
            "count": "first",
            "cursor": "after"
          },
          "backward": null,
          "path": v0
        },
        "fragmentPathInResult": [],
        "operation": FormTemplateSearchBoxPaginationQuery_graphql_default
      }
    },
    "name": "FormTemplateSearchBox_list",
    "selections": [
      {
        "alias": "list",
        "args": [
          {
            "kind": "Variable",
            "name": "idFilter",
            "variableName": "idFilter"
          },
          {
            "kind": "Literal",
            "name": "order",
            "value": [
              {
                "name": "ASC"
              }
            ]
          },
          {
            "kind": "Variable",
            "name": "where",
            "variableName": "where"
          }
        ],
        "concreteType": "CustomDataFormTemplatesConnection",
        "kind": "LinkedField",
        "name": "__FormTemplateSearchBox_list_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CustomDataFormTemplatesEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "FormTemplate",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "formTemplateId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "code",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "key",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "description",
                    "storageKey": null
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "FormTemplateRow_account"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node55.hash = "aea68de6264c76b6ebd336dfbd59ac23";
var node56 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "idFilter"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = [
    {
      "kind": "Literal",
      "name": "first",
      "value": 10
    },
    {
      "kind": "Variable",
      "name": "idFilter",
      "variableName": "idFilter"
    },
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "name": "ASC"
        }
      ]
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "FormTemplateSearchContainerQuery",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "FormTemplateSearchBox_list"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "FormTemplateSearchContainerQuery",
      "selections": [
        {
          "alias": "list",
          "args": v1,
          "concreteType": "CustomDataFormTemplatesConnection",
          "kind": "LinkedField",
          "name": "customDataFormTemplates",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "CustomDataFormTemplatesEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "FormTemplate",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "formTemplateId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "key",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "description",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "list",
          "args": v1,
          "filters": [
            "idFilter",
            "where",
            "order"
          ],
          "handle": "connection",
          "key": "FormTemplateSearchBox_list",
          "kind": "LinkedHandle",
          "name": "customDataFormTemplates"
        }
      ]
    },
    "params": {
      "cacheID": "282cc3cbf7ece5290437a46cf310bdbe",
      "id": null,
      "metadata": {},
      "name": "FormTemplateSearchContainerQuery",
      "operationKind": "query",
      "text": "query FormTemplateSearchContainerQuery(\n  $idFilter: OrganisationOrExternalIdInput\n  $where: FormTemplateFilter!\n) {\n  ...FormTemplateSearchBox_list\n}\n\nfragment FormTemplateRow_account on FormTemplate {\n  id\n  formTemplateId\n  code\n  createdAt\n  updatedAt\n  key\n  name\n  description\n}\n\nfragment FormTemplateSearchBox_list on Query {\n  list: customDataFormTemplates(idFilter: $idFilter, where: $where, first: 10, order: [{name: ASC}]) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        formTemplateId\n        code\n        key\n        name\n        description\n        ...FormTemplateRow_account\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node56.hash = "957ddf8c7502ab17a31ed6d52203034e";
var employerIdAtom = atom("");
var defaultLinkRegistry = class {
  applicationLink(code) {
    return "";
  }
};
var linkRegistryAtom = Recoil_index_8({
  key: "linkRegistry",
  default: new defaultLinkRegistry()
});
var node57 = function() {
  var v0 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "count",
    "storageKey": null
  };
  return {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "MultiFacetContainer_facet",
    "selections": [
      v0,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "key",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "title",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "DefaultAggregationValueModel",
        "kind": "LinkedField",
        "name": "values",
        "plural": true,
        "selections": [
          v0,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isSelected",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "text",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "DefaultAggregationModel",
    "abstractKey": null
  };
}();
node57.hash = "f8e30137c6bb2890b13e270136f140a5";
var node58 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "type",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfCandidateTask",
    "kind": "LinkedField",
    "name": "payload",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "TasksCandidateTask",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          v2,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "candidateTaskId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "version",
            "storageKey": null
          },
          v3,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "title",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "summary",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CandidateTaskSource",
            "kind": "LinkedField",
            "name": "source",
            "plural": false,
            "selections": [
              v2,
              v3
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CandidateTaskGroup",
            "kind": "LinkedField",
            "name": "group",
            "plural": false,
            "selections": [
              v2,
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v5 = {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseCandidateTaskCompleteMutation",
      "selections": [
        {
          "alias": "task",
          "args": v1,
          "concreteType": "CandidateTaskCompletePayload",
          "kind": "LinkedField",
          "name": "candidateTaskComplete",
          "plural": false,
          "selections": [
            v4,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v5
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseCandidateTaskCompleteMutation",
      "selections": [
        {
          "alias": "task",
          "args": v1,
          "concreteType": "CandidateTaskCompletePayload",
          "kind": "LinkedField",
          "name": "candidateTaskComplete",
          "plural": false,
          "selections": [
            v4,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v5
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "47e31546b255221c7436d0c8dd5b472f",
      "id": null,
      "metadata": {},
      "name": "UseCandidateTaskCompleteMutation",
      "operationKind": "mutation",
      "text": "mutation UseCandidateTaskCompleteMutation(\n  $input: CandidateTaskCompleteInput!\n) {\n  task: candidateTaskComplete(input: $input) {\n    payload {\n      node {\n        id\n        candidateTaskId\n        version\n        type\n        title\n        summary\n        description\n        status\n        source {\n          id\n          type\n        }\n        group {\n          id\n          name\n        }\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node58.hash = "f3ce8563c2b9a6c034e606ace6abe7c4";
var node59 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "sourceId"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  }, v2 = {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }, v3 = [
    v1,
    v2,
    {
      "kind": "Variable",
      "name": "sourceId",
      "variableName": "sourceId"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "TaskBySourceListPaginationQuery",
      "selections": [
        {
          "args": [
            v1,
            v2
          ],
          "kind": "FragmentSpread",
          "name": "TaskBySourceList_tasks"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "TaskBySourceListPaginationQuery",
      "selections": [
        {
          "alias": "tasks",
          "args": v3,
          "concreteType": "TasksCandidateTasksBySourceIdConnection",
          "kind": "LinkedField",
          "name": "tasksCandidateTasksBySourceId",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "TasksCandidateTasksBySourceIdEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "TasksCandidateTask",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "candidateTaskId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "priority",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "status",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "type",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "version",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "description",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "title",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "summary",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "tasks",
          "args": v3,
          "filters": [],
          "handle": "connection",
          "key": "TaskBySourceList_tasks",
          "kind": "LinkedHandle",
          "name": "tasksCandidateTasksBySourceId"
        }
      ]
    },
    "params": {
      "cacheID": "3912238aebadaf571b1bc6c2a3903bd7",
      "id": null,
      "metadata": {},
      "name": "TaskBySourceListPaginationQuery",
      "operationKind": "query",
      "text": "query TaskBySourceListPaginationQuery(\n  $after: String\n  $first: Int = 10\n  $sourceId: UUID!\n) {\n  ...TaskBySourceList_tasks_2HEEH6\n}\n\nfragment TaskBySourceList_tasks_2HEEH6 on Query {\n  tasks: tasksCandidateTasksBySourceId(sourceId: $sourceId, first: $first, after: $after) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        candidateTaskId\n        priority\n        status\n        ...TaskItem_task\n        __typename\n      }\n    }\n  }\n}\n\nfragment TaskItem_task on TasksCandidateTask {\n  id\n  candidateTaskId\n  type\n  version\n  description\n  title\n  summary\n  status\n}\n"
    }
  };
}();
node59.hash = "674a30703bca819c85ae1cc8d3d27f3c";
var TaskBySourceListPaginationQuery_graphql_default = node59;
var node60 = function() {
  var v0 = [
    "tasks"
  ];
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
      },
      {
        "defaultValue": 10,
        "kind": "LocalArgument",
        "name": "first"
      },
      {
        "kind": "RootArgument",
        "name": "sourceId"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": v0
        }
      ],
      "refetch": {
        "connection": {
          "forward": {
            "count": "first",
            "cursor": "after"
          },
          "backward": null,
          "path": v0
        },
        "fragmentPathInResult": [],
        "operation": TaskBySourceListPaginationQuery_graphql_default
      }
    },
    "name": "TaskBySourceList_tasks",
    "selections": [
      {
        "alias": "tasks",
        "args": null,
        "concreteType": "TasksCandidateTasksBySourceIdConnection",
        "kind": "LinkedField",
        "name": "__TaskBySourceList_tasks_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "TasksCandidateTasksBySourceIdEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "TasksCandidateTask",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "candidateTaskId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "priority",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "status",
                    "storageKey": null
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "TaskItem_task"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node60.hash = "674a30703bca819c85ae1cc8d3d27f3c";
var node61 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TaskItem_task",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "candidateTaskId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "version",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "summary",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    }
  ],
  "type": "TasksCandidateTask",
  "abstractKey": null
};
node61.hash = "e6a2342a69f56c6dea8f9bb68d4fede6";
var TaskStatusLabel = ({ status }) => {
  if (status === "ACTIVE") {
    return /* @__PURE__ */ jsx60("div", { className: "font-medium", children: /* @__PURE__ */ jsx60("span", { className: "text-primary-500", children: "Active" }) });
  } else if (status === "REMINDER") {
    return /* @__PURE__ */ jsx60("div", { className: "font-medium", children: /* @__PURE__ */ jsx60("span", { className: "text-primary-500", children: "Reminder" }) });
  } else if (status === "DONE") {
    return /* @__PURE__ */ jsx60("div", { className: "font-medium", children: /* @__PURE__ */ jsx60("span", { className: "text-gray-500", children: "Done" }) });
  } else if (status === "IGNORED") {
    return /* @__PURE__ */ jsx60("div", { className: "font-medium", children: /* @__PURE__ */ jsx60("span", { className: "text-success-500", children: "Ignored" }) });
  }
  return /* @__PURE__ */ jsx60(Fragment13, {});
};
var TaskDetailsHeader = ({ title, status, onSelected }) => {
  return /* @__PURE__ */ jsxs36("div", { className: "flex justify-between space-x-3 border-b pb-2", children: [
    /* @__PURE__ */ jsx63("div", { className: "min-w-0 flex-1", children: /* @__PURE__ */ jsx63("a", { onClick: onSelected, className: "block focus:outline-none", children: /* @__PURE__ */ jsx63("p", { className: "truncate text-sm font-medium text-gray-900", children: title }) }) }),
    /* @__PURE__ */ jsx63(TaskStatusLabel, { status })
  ] });
};
var export_Log = import_oidc_client2.Log;
var export_User = import_oidc_client2.User;
var export_UserManager = import_oidc_client2.UserManager;

// src/components/accounts/components/CandidateAccountImpersonate.tsx
import { jsx as jsx64, jsxs as jsxs37 } from "react/jsx-runtime";
var queryDef = CandidateAccountImpersonateRouteQuery_graphql_default;
async function loader(environment, params) {
  const code = params.candidateCode;
  const candidateCode = parseInt(code);
  return loadQuery3(
    environment,
    queryDef,
    {
      candidateCode
    }
  );
}
var CandidateAccountImpersonate = ({
  routeId
}) => {
  const query = useRouteData2(
    queryDef,
    routeId
  );
  const { candidate } = query;
  const [state, copyToClipboard] = useCopyToClipboard();
  const [impersonation, isImpersonating] = useImpersonateUser();
  const [impersonationLink, setImpersonationLink] = useState18();
  const onCreateImpersonationToken = useCallback34(async () => {
    if (candidate === null) {
      return;
    }
    setImpersonationLink(null);
    const token = await impersonation(
      candidate.accountId,
      ElevateAccountTypes.Contractor
    );
    if (!token) {
      return;
    }
    const config = {
      token,
      accountId: candidate.accountId
    };
    const data = encodeURIComponent(JSON.stringify(config));
    const host = `${window.location.protocol}//${window.location.host}`;
    const path = `${host}/portal/candidates/nav?action=impersonate&data=${data}`;
    setImpersonationLink(path);
  }, [impersonation, candidate, setImpersonationLink]);
  if (!candidate) {
    return /* @__PURE__ */ jsx64("div", { className: "m-8 max-w-4xl border bg-white p-4", children: /* @__PURE__ */ jsx64("div", { className: "flex flex-col", children: /* @__PURE__ */ jsx64("h1", { children: "Could Not Load Candidate" }) }) });
  }
  return /* @__PURE__ */ jsx64("div", { className: "m-8 max-w-4xl border bg-white p-4", children: /* @__PURE__ */ jsxs37("div", { className: "flex flex-col", children: [
    state && state.error ? /* @__PURE__ */ jsxs37("div", { className: "flex flex-col gap-3", children: [
      /* @__PURE__ */ jsx64("div", { className: "text-failure-500 text-md p-3 font-medium", children: "Could not copy, please copy manually from below" }),
      /* @__PURE__ */ jsx64("div", { className: "text-primary-500 p-3 text-lg font-bold", children: /* @__PURE__ */ jsxs37("p", { children: [
        "Please note: you ",
        /* @__PURE__ */ jsx64("strong", { children: "must be logged in" }),
        " as admin need to use this link"
      ] }) }),
      /* @__PURE__ */ jsx64("div", { className: "text-info-500 text-md p-3 font-medium", children: impersonationLink })
    ] }) : null,
    state && state.value ? /* @__PURE__ */ jsxs37("div", { className: "flex flex-col gap-3", children: [
      /* @__PURE__ */ jsx64("div", { className: "text-md p-3 font-medium text-green-500", children: "Copied!" }),
      /* @__PURE__ */ jsx64("div", { className: "text-primary-500 p-3 text-lg font-bold", children: /* @__PURE__ */ jsxs37("p", { children: [
        "Please note: you ",
        /* @__PURE__ */ jsx64("strong", { children: "must be logged in" }),
        " as admin need to use this link"
      ] }) })
    ] }) : null,
    impersonationLink ? /* @__PURE__ */ jsxs37("div", { className: "flex items-center space-x-3 p-3", children: [
      /* @__PURE__ */ jsx64(
        "a",
        {
          className: "bg-primary-800 text-md rounded-lg border px-2.5 py-1 font-medium text-white",
          href: impersonationLink,
          target: candidate.code.toString(),
          children: "Impersonate"
        }
      ),
      /* @__PURE__ */ jsx64(
        Button13,
        {
          color: "primary",
          clicked: () => copyToClipboard(impersonationLink),
          children: "Copy Link To Clipboard"
        }
      )
    ] }) : null,
    /* @__PURE__ */ jsx64("div", { className: "p-3", children: impersonationLink ? /* @__PURE__ */ jsx64(
      Button13,
      {
        color: "secondary",
        disabled: isImpersonating,
        clicked: onCreateImpersonationToken,
        children: "Create New Impersonation Link"
      }
    ) : /* @__PURE__ */ jsx64(
      Button13,
      {
        color: "primary",
        disabled: isImpersonating || !!impersonationLink,
        clicked: onCreateImpersonationToken,
        children: "Create Impersonation Link"
      }
    ) })
  ] }) });
};
var createRoute = (routePrefix, environment, context) => {
  const routeId = `${routePrefix}-impersonate`;
  return {
    id: routeId,
    path: "impersonate",
    element: /* @__PURE__ */ jsx64(CandidateAccountImpersonate, { routeId }),
    handle: {
      crumb: () => /* @__PURE__ */ jsx64(Link4, { to: "users", children: "Users" })
    },
    loader: ({ params }) => {
      return loader(environment, params);
    }
  };
};

// src/components/accounts/components/__generated__/CandidateAccountRow_account.graphql.ts
var node63 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CandidateAccountRow_account",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "accountId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "code",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    }
  ],
  "type": "AccountsCandidateAccount",
  "abstractKey": null
};
node63.hash = "dbf29c66046eb19dd118c2f91ae11c3a";
var CandidateAccountRow_account_graphql_default = node63;

// src/components/accounts/components/CandidateAccountRow.tsx
import { useCallback as useCallback35 } from "react";
import { useFragment as useFragment11 } from "react-relay";
import { jsx as jsx65, jsxs as jsxs38 } from "react/jsx-runtime";
var fragment = CandidateAccountRow_account_graphql_default;
var CandidateAccountRow = ({ fragmentRef, onSelect }) => {
  const data = useFragment11(fragment, fragmentRef);
  const select = useCallback35(() => {
    onSelect(data);
  }, []);
  return /* @__PURE__ */ jsxs38("div", { className: "row", onClick: select, children: [
    /* @__PURE__ */ jsx65("div", { className: "item", children: data.firstName }),
    /* @__PURE__ */ jsx65("div", { className: "item", children: data.lastName }),
    /* @__PURE__ */ jsx65("div", { className: "item", children: data.email })
  ] });
};

// src/components/accounts/components/CandidateAccountSearchBox.tsx
var import_lodash = __toESM(require_lodash());
import {
  useCallback as useCallback36,
  useEffect as useEffect11,
  useMemo as useMemo9,
  useState as useState19,
  Suspense as Suspense17
} from "react";
import { ChevronUpDownIcon as ChevronUpDownIcon7 } from "@heroicons/react/24/solid";
import { Combobox as Combobox11 } from "@headlessui/react";

// src/components/accounts/components/__generated__/CandidateAccountSearchOptionsPaginationQuery.graphql.ts
var node64 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  }, v2 = {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }, v3 = [
    v1,
    v2,
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "firstName": "DESC"
        }
      ]
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "CandidateAccountSearchOptionsPaginationQuery",
      "selections": [
        {
          "args": [
            v1,
            v2
          ],
          "kind": "FragmentSpread",
          "name": "CandidateAccountSearchOptions_candidates"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "CandidateAccountSearchOptionsPaginationQuery",
      "selections": [
        {
          "alias": "results",
          "args": v3,
          "concreteType": "AccountCandidateAccountsConnection",
          "kind": "LinkedField",
          "name": "accountCandidateAccounts",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountCandidateAccountsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AccountsCandidateAccount",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "accountId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "firstName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "lastName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "email",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "results",
          "args": v3,
          "filters": [
            "order",
            "where"
          ],
          "handle": "connection",
          "key": "CandidateAccountSearchOptions_results",
          "kind": "LinkedHandle",
          "name": "accountCandidateAccounts"
        }
      ]
    },
    "params": {
      "cacheID": "ff9c4d740d518c77fba2f23997d9fc73",
      "id": null,
      "metadata": {},
      "name": "CandidateAccountSearchOptionsPaginationQuery",
      "operationKind": "query",
      "text": "query CandidateAccountSearchOptionsPaginationQuery(\n  $after: String\n  $first: Int = 10\n  $where: AccountsCandidateAccountFilter\n) {\n  ...CandidateAccountSearchOptions_candidates_2HEEH6\n}\n\nfragment CandidateAccountSearchOptions_candidates_2HEEH6 on Query {\n  results: accountCandidateAccounts(first: $first, after: $after, order: [{firstName: DESC}], where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        accountId\n        code\n        firstName\n        lastName\n        email\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node64.hash = "e6fa94e9e69fe3b6ed3ceff8a6c89391";
var CandidateAccountSearchOptionsPaginationQuery_graphql_default = node64;

// src/components/accounts/components/__generated__/CandidateAccountSearchOptions_candidates.graphql.ts
var node65 = function() {
  var v0 = [
    "results"
  ];
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
      },
      {
        "defaultValue": 10,
        "kind": "LocalArgument",
        "name": "first"
      },
      {
        "kind": "RootArgument",
        "name": "where"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": v0
        }
      ],
      "refetch": {
        "connection": {
          "forward": {
            "count": "first",
            "cursor": "after"
          },
          "backward": null,
          "path": v0
        },
        "fragmentPathInResult": [],
        "operation": CandidateAccountSearchOptionsPaginationQuery_graphql_default
      }
    },
    "name": "CandidateAccountSearchOptions_candidates",
    "selections": [
      {
        "alias": "results",
        "args": [
          {
            "kind": "Literal",
            "name": "order",
            "value": [
              {
                "firstName": "DESC"
              }
            ]
          },
          {
            "kind": "Variable",
            "name": "where",
            "variableName": "where"
          }
        ],
        "concreteType": "AccountCandidateAccountsConnection",
        "kind": "LinkedField",
        "name": "__CandidateAccountSearchOptions_results_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountCandidateAccountsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "AccountsCandidateAccount",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "accountId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "code",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "firstName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lastName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "email",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node65.hash = "e6fa94e9e69fe3b6ed3ceff8a6c89391";
var CandidateAccountSearchOptions_candidates_graphql_default = node65;

// src/components/accounts/components/CandidateAccountSearchOptions.tsx
import { useEffect as useEffect10 } from "react";
import { usePaginationFragment as usePaginationFragment11 } from "react-relay/hooks";
import { Combobox as Combobox10 } from "@headlessui/react";
import { CheckIcon as CheckIcon7 } from "@heroicons/react/24/solid";
import { isNotNull } from "shared-lib";
import { classNames as classNames10 } from "shared-ui";
import { Fragment as Fragment15, jsx as jsx66, jsxs as jsxs39 } from "react/jsx-runtime";
var fragment2 = CandidateAccountSearchOptions_candidates_graphql_default;
var CandidateAccountSearchOptions = ({
  candidates,
  searchTerm
}) => {
  const { data, refetch } = usePaginationFragment11(fragment2, candidates);
  const where = {
    isDeactivated: { eq: false }
  };
  if (searchTerm) {
    where.and = [
      {
        or: [
          { firstName: { startsWith: searchTerm } },
          { lastName: { startsWith: searchTerm } },
          { emailAddress: { startsWith: searchTerm } }
        ]
      },
      { isDeactivated: { eq: false } }
    ];
  }
  useEffect10(() => {
    refetch({ first: 10, where }, { fetchPolicy: "store-or-network" });
  }, [searchTerm]);
  const { results } = data;
  const rows = (results?.edges ?? []).map((edge) => edge.node).filter(isNotNull);
  return /* @__PURE__ */ jsx66(Combobox10.Options, { className: "absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm", children: rows.map((result) => /* @__PURE__ */ jsx66(
    Combobox10.Option,
    {
      value: result,
      className: ({ active }) => classNames10(
        "relative cursor-default select-none py-2 pl-3 pr-9",
        active ? "bg-info-600 text-white" : "text-gray-900"
      ),
      children: ({ active, selected }) => /* @__PURE__ */ jsxs39(Fragment15, { children: [
        /* @__PURE__ */ jsx66("div", { className: "flex", children: /* @__PURE__ */ jsxs39(
          "span",
          {
            className: classNames10(
              "truncate",
              selected ? "font-semibold" : ""
            ),
            children: [
              result.firstName,
              " ",
              result.lastName,
              " - ",
              result.email
            ]
          }
        ) }),
        selected && /* @__PURE__ */ jsx66(
          "span",
          {
            className: classNames10(
              "absolute inset-y-0 right-0 flex items-center pr-4",
              active ? "bg-info-600 text-white" : "text-info-600"
            ),
            children: /* @__PURE__ */ jsx66(CheckIcon7, { className: "h-5 w-5", "aria-hidden": "true" })
          }
        )
      ] })
    },
    result.id
  )) });
};

// src/components/accounts/components/CandidateAccountSearchBox.tsx
import { jsx as jsx67, jsxs as jsxs40 } from "react/jsx-runtime";
var CandidateAccountSearchBox = ({
  onSelected,
  candidates,
  defaultValue
}) => {
  const [selected, setSelected] = useState19(
    defaultValue ?? null
  );
  const [searchTerm, setSearchTerm] = useState19("");
  const onQueryChangeHandler = useMemo9(
    () => (0, import_lodash.debounce)((q) => setSearchTerm(q), 500),
    []
  );
  useEffect11(() => {
    return () => {
      onQueryChangeHandler.cancel();
    };
  }, []);
  const onSetSelected = useCallback36(
    (r) => {
      setSelected(r);
      onSelected(r);
    },
    [selected]
  );
  return /* @__PURE__ */ jsxs40(Combobox11, { as: "div", value: selected, onChange: onSetSelected, children: [
    /* @__PURE__ */ jsx67(Combobox11.Label, { className: "block text-sm font-medium text-gray-700", children: "Candidate" }),
    /* @__PURE__ */ jsxs40("div", { className: "relative mt-2", children: [
      /* @__PURE__ */ jsx67(
        Combobox11.Input,
        {
          className: "focus:border-info-500 focus:ring-info-500 w-full rounded-md border border-gray-300 bg-white py-2 pl-3 pr-10 shadow-sm focus:outline-none focus:ring-1 sm:text-sm",
          onChange: (event) => onQueryChangeHandler(event.target.value),
          displayValue: (result) => {
            if (result) {
              return `${result.firstName} ${result.lastName} (${result.email})`;
            }
            return "";
          },
          autoComplete: "off"
        }
      ),
      /* @__PURE__ */ jsx67(Combobox11.Button, { className: "absolute inset-y-0 right-0 flex items-center rounded-r-md px-2 focus:outline-none", children: /* @__PURE__ */ jsx67(
        ChevronUpDownIcon7,
        {
          className: "h-5 w-5 text-gray-400",
          "aria-hidden": "true"
        }
      ) }),
      /* @__PURE__ */ jsx67(Suspense17, { fallback: "Searching...", children: /* @__PURE__ */ jsx67(
        CandidateAccountSearchOptions,
        {
          candidates,
          searchTerm
        }
      ) })
    ] })
  ] });
};

// src/components/accounts/components/__generated__/CandidateAccountSearchBoxInputQuery.graphql.ts
var node66 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = [
    {
      "kind": "Literal",
      "name": "first",
      "value": 10
    },
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "firstName": "DESC"
        }
      ]
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "CandidateAccountSearchBoxInputQuery",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "CandidateAccountSearchOptions_candidates"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "CandidateAccountSearchBoxInputQuery",
      "selections": [
        {
          "alias": "results",
          "args": v1,
          "concreteType": "AccountCandidateAccountsConnection",
          "kind": "LinkedField",
          "name": "accountCandidateAccounts",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountCandidateAccountsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AccountsCandidateAccount",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "accountId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "firstName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "lastName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "email",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "results",
          "args": v1,
          "filters": [
            "order",
            "where"
          ],
          "handle": "connection",
          "key": "CandidateAccountSearchOptions_results",
          "kind": "LinkedHandle",
          "name": "accountCandidateAccounts"
        }
      ]
    },
    "params": {
      "cacheID": "3c38d50f958e7c01b635616fa3a4bd86",
      "id": null,
      "metadata": {},
      "name": "CandidateAccountSearchBoxInputQuery",
      "operationKind": "query",
      "text": "query CandidateAccountSearchBoxInputQuery(\n  $where: AccountsCandidateAccountFilter!\n) {\n  ...CandidateAccountSearchOptions_candidates\n}\n\nfragment CandidateAccountSearchOptions_candidates on Query {\n  results: accountCandidateAccounts(first: 10, order: [{firstName: DESC}], where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        accountId\n        code\n        firstName\n        lastName\n        email\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node66.hash = "c4b1ff95be0f766353db26b44ecd0270";
var CandidateAccountSearchBoxInputQuery_graphql_default = node66;

// src/components/accounts/components/CandidateAccountSearchBoxInput.tsx
import { Controller as Controller2 } from "react-hook-form";
import { useLazyLoadQuery as useLazyLoadQuery10 } from "react-relay/hooks";
import { jsx as jsx68 } from "react/jsx-runtime";
var graphqlQuery = CandidateAccountSearchBoxInputQuery_graphql_default;
var CandidateAccountSearchBoxInput = ({
  name,
  control,
  defaultValue
}) => {
  const where = {
    isDeactivated: { eq: false }
  };
  const query = useLazyLoadQuery10(
    graphqlQuery,
    { where },
    {
      fetchPolicy: "store-and-network"
    }
  );
  return /* @__PURE__ */ jsx68(
    Controller2,
    {
      control,
      name,
      render: ({ field: { onChange: onControllerChange } }) => /* @__PURE__ */ jsx68(
        CandidateAccountSearchBox,
        {
          onSelected: (result) => {
            onControllerChange(result.id);
          },
          candidates: query,
          defaultValue
        }
      )
    }
  );
};

// src/components/accounts/components/__generated__/CandidateAccountSearchContainerQuery.graphql.ts
var node67 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = [
    {
      "kind": "Literal",
      "name": "first",
      "value": 10
    },
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "firstName": "DESC"
        }
      ]
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "CandidateAccountSearchContainerQuery",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "CandidateAccountSearchOptions_candidates"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "CandidateAccountSearchContainerQuery",
      "selections": [
        {
          "alias": "results",
          "args": v1,
          "concreteType": "AccountCandidateAccountsConnection",
          "kind": "LinkedField",
          "name": "accountCandidateAccounts",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountCandidateAccountsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AccountsCandidateAccount",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "accountId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "firstName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "lastName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "email",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "results",
          "args": v1,
          "filters": [
            "order",
            "where"
          ],
          "handle": "connection",
          "key": "CandidateAccountSearchOptions_results",
          "kind": "LinkedHandle",
          "name": "accountCandidateAccounts"
        }
      ]
    },
    "params": {
      "cacheID": "367b10941d2b8751b174ac262d2f11b3",
      "id": null,
      "metadata": {},
      "name": "CandidateAccountSearchContainerQuery",
      "operationKind": "query",
      "text": "query CandidateAccountSearchContainerQuery(\n  $where: AccountsCandidateAccountFilter!\n) {\n  ...CandidateAccountSearchOptions_candidates\n}\n\nfragment CandidateAccountSearchOptions_candidates on Query {\n  results: accountCandidateAccounts(first: 10, order: [{firstName: DESC}], where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        accountId\n        code\n        firstName\n        lastName\n        email\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node67.hash = "541596ce1daa608db4d87c23f5448c7b";
var CandidateAccountSearchContainerQuery_graphql_default = node67;

// src/components/accounts/components/CandidateAccountSearchContainer.tsx
import { useCallback as useCallback37, useState as useState20 } from "react";
import { useLazyLoadQuery as useLazyLoadQuery11 } from "react-relay/hooks";
import { jsx as jsx69 } from "react/jsx-runtime";
var graphqlQuery2 = CandidateAccountSearchContainerQuery_graphql_default;
var CandidateAccountSearchContainer = ({
  onSearchCompleted
}) => {
  const [selectedResult, setSelectedResult] = useState20();
  const onSetSelected = useCallback37(
    (r) => {
      setSelectedResult(r);
      onSearchCompleted(r);
    },
    [selectedResult]
  );
  const where = {
    isDeactivated: { eq: false }
  };
  const query = useLazyLoadQuery11(
    graphqlQuery2,
    { where },
    {
      fetchPolicy: "store-and-network"
    }
  );
  return /* @__PURE__ */ jsx69(CandidateAccountSearchBox, { onSelected: onSetSelected, candidates: query });
};

// src/components/accounts/components/__generated__/CandidateAccountsListPaginationQuery.graphql.ts
var node68 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 1,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": {
        "updatedAt": "DESC"
      },
      "kind": "LocalArgument",
      "name": "order"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "after",
      "variableName": "after"
    },
    {
      "kind": "Variable",
      "name": "first",
      "variableName": "first"
    },
    {
      "kind": "Variable",
      "name": "order",
      "variableName": "order"
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "CandidateAccountsListPaginationQuery",
      "selections": [
        {
          "args": v1,
          "kind": "FragmentSpread",
          "name": "CandidateAccountsList_candidates"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "CandidateAccountsListPaginationQuery",
      "selections": [
        {
          "alias": "candidates",
          "args": v1,
          "concreteType": "AccountCandidateAccountsConnection",
          "kind": "LinkedField",
          "name": "accountCandidateAccounts",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountCandidateAccountsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AccountsCandidateAccount",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "firstName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "lastName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "email",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "accountId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "candidates",
          "args": v1,
          "filters": [
            "where",
            "order"
          ],
          "handle": "connection",
          "key": "CandidateAccountsList_candidates",
          "kind": "LinkedHandle",
          "name": "accountCandidateAccounts"
        }
      ]
    },
    "params": {
      "cacheID": "8db7d4c18e3f712f7d5975901074838c",
      "id": null,
      "metadata": {},
      "name": "CandidateAccountsListPaginationQuery",
      "operationKind": "query",
      "text": "query CandidateAccountsListPaginationQuery(\n  $after: String\n  $first: Int = 1\n  $order: [AccountsCandidateAccountSort!] = {updatedAt: DESC}\n  $where: AccountsCandidateAccountFilter\n) {\n  ...CandidateAccountsList_candidates_cnSAE\n}\n\nfragment CandidateAccountRow_account on AccountsCandidateAccount {\n  id\n  accountId\n  code\n  firstName\n  lastName\n  email\n}\n\nfragment CandidateAccountsList_candidates_cnSAE on Query {\n  candidates: accountCandidateAccounts(where: $where, first: $first, after: $after, order: $order) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    edges {\n      cursor\n      node {\n        id\n        code\n        firstName\n        lastName\n        updatedAt\n        email\n        ...CandidateAccountRow_account\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node68.hash = "9196389908a5b04cdfaca0eb65543be9";
var CandidateAccountsListPaginationQuery_graphql_default = node68;

// src/components/accounts/components/__generated__/CandidateAccountsList_candidates.graphql.ts
var node69 = function() {
  var v0 = [
    "candidates"
  ];
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
      },
      {
        "defaultValue": 1,
        "kind": "LocalArgument",
        "name": "first"
      },
      {
        "defaultValue": {
          "updatedAt": "DESC"
        },
        "kind": "LocalArgument",
        "name": "order"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "where"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": v0
        }
      ],
      "refetch": {
        "connection": {
          "forward": {
            "count": "first",
            "cursor": "after"
          },
          "backward": null,
          "path": v0
        },
        "fragmentPathInResult": [],
        "operation": CandidateAccountsListPaginationQuery_graphql_default
      }
    },
    "name": "CandidateAccountsList_candidates",
    "selections": [
      {
        "alias": "candidates",
        "args": [
          {
            "kind": "Variable",
            "name": "order",
            "variableName": "order"
          },
          {
            "kind": "Variable",
            "name": "where",
            "variableName": "where"
          }
        ],
        "concreteType": "AccountCandidateAccountsConnection",
        "kind": "LinkedField",
        "name": "__CandidateAccountsList_candidates_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountCandidateAccountsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "AccountsCandidateAccount",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "code",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "firstName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lastName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "updatedAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "email",
                    "storageKey": null
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "CandidateAccountRow_account"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node69.hash = "9196389908a5b04cdfaca0eb65543be9";
var CandidateAccountsList_candidates_graphql_default = node69;

// src/components/accounts/components/CandidateAccountsList.tsx
import { isValidElement, useCallback as useCallback38 } from "react";
import { usePaginationFragment as usePaginationFragment12 } from "react-relay/hooks";
import { formatDistanceToNow as formatDistanceToNow7, parseISO as parseISO7 } from "date-fns";
import { EdButtonLink as EdButtonLink2, ListLayout as ListLayout7 } from "shared-ui";
import { isNotNullOrUndefined as isNotNullOrUndefined8 } from "shared-lib";
import { jsx as jsx70, jsxs as jsxs41 } from "react/jsx-runtime";
var fragment3 = CandidateAccountsList_candidates_graphql_default;
var ItemHeader = ({ section }) => {
  const candidate = section.context.candidate;
  const titleIsElement = isValidElement(section.itemTitle);
  return /* @__PURE__ */ jsxs41("div", { children: [
    /* @__PURE__ */ jsx70("div", { children: /* @__PURE__ */ jsx70("h1", { children: "Candidate" }) }),
    titleIsElement ? section.itemTitle : /* @__PURE__ */ jsx70("div", { className: "font-InterMedium text-info-gray-800 text-3xl font-bold tracking-tight", children: section.itemTitle }),
    /* @__PURE__ */ jsx70("div", { className: "flex items-center space-x-2 sm:justify-end", children: /* @__PURE__ */ jsx70(EdButtonLink2, { name: "View", to: `${candidate.code}` }) })
  ] });
};
var CandidateAccountsList = ({ fragmentRef }) => {
  const { data, loadNext, isLoadingNext } = usePaginationFragment12(fragment3, fragmentRef);
  const onLoadNext = useCallback38(() => {
    loadNext(10);
  }, [loadNext]);
  const { candidates } = data;
  const sections = (candidates?.edges || []).filter(isNotNullOrUndefined8).map((edge) => edge.node).map((candidate) => {
    return {
      key: candidate.code.toString(),
      itemTitle: `${candidate.firstName} ${candidate.lastName}`,
      listTitle: /* @__PURE__ */ jsxs41("div", { className: "flex items-center gap-2", children: [
        /* @__PURE__ */ jsxs41("div", { className: "text-md font-medium uppercase", children: [
          candidate.firstName,
          " ",
          candidate.lastName
        ] }),
        /* @__PURE__ */ jsx70("div", { className: "text-primary-900 text-sm font-medium", children: candidate.code })
      ] }),
      description: `Updated ${formatDistanceToNow7(
        parseISO7(candidate.updatedAt)
      )}`,
      hideIcon: true,
      icon: () => null,
      iconForeground: "text-primary-700",
      iconBackground: "bg-primary-50",
      context: {
        candidate
      },
      element: /* @__PURE__ */ jsx70("div", {})
    };
  });
  const loadMore = useCallback38(() => {
    if (isLoadingNext) {
      return;
    }
    loadNext(5);
  }, [isLoadingNext, loadNext]);
  return /* @__PURE__ */ jsx70(
    ListLayout7,
    {
      title: "Projects",
      sections,
      itemHeader: (s) => /* @__PURE__ */ jsx70(ItemHeader, { section: s }),
      loadMore: onLoadNext,
      isLoading: false,
      showFilters: true
    }
  );
};

// src/components/accounts/components/__generated__/CandidateAccountsListContainerQuery.graphql.ts
var node70 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = [
    {
      "kind": "Literal",
      "name": "first",
      "value": 10
    },
    {
      "kind": "Literal",
      "name": "order",
      "value": {
        "updatedAt": "DESC"
      }
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "CandidateAccountsListContainerQuery",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "CandidateAccountsListContainer_list"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "CandidateAccountsListContainerQuery",
      "selections": [
        {
          "alias": "list",
          "args": v1,
          "concreteType": "AccountCandidateAccountsConnection",
          "kind": "LinkedField",
          "name": "accountCandidateAccounts",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountCandidateAccountsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AccountsCandidateAccount",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "firstName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "lastName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "email",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "accountId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "list",
          "args": v1,
          "filters": [
            "order",
            "where"
          ],
          "handle": "connection",
          "key": "CandidateAccountsList_list",
          "kind": "LinkedHandle",
          "name": "accountCandidateAccounts"
        }
      ]
    },
    "params": {
      "cacheID": "99544ec663a137a8817366e0922afa6e",
      "id": null,
      "metadata": {},
      "name": "CandidateAccountsListContainerQuery",
      "operationKind": "query",
      "text": "query CandidateAccountsListContainerQuery(\n  $where: AccountsCandidateAccountFilter!\n) {\n  ...CandidateAccountsListContainer_list\n}\n\nfragment CandidateAccountRow_account on AccountsCandidateAccount {\n  id\n  accountId\n  code\n  firstName\n  lastName\n  email\n}\n\nfragment CandidateAccountsListContainer_list on Query {\n  list: accountCandidateAccounts(first: 10, order: {updatedAt: DESC}, where: $where) {\n    ...CandidateAccountsListHeader_data\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        code\n        firstName\n        lastName\n        updatedAt\n        email\n        ...CandidateAccountRow_account\n        __typename\n      }\n    }\n  }\n}\n\nfragment CandidateAccountsListHeader_data on AccountCandidateAccountsConnection {\n  pageInfo {\n    hasNextPage\n    hasPreviousPage\n    startCursor\n    endCursor\n  }\n  totalCount\n  edges {\n    cursor\n    node {\n      id\n      code\n      firstName\n      lastName\n      updatedAt\n      email\n      ...CandidateAccountRow_account\n    }\n  }\n}\n"
    }
  };
}();
node70.hash = "12ee4966ffbe214b2488483f93e6e52d";
var CandidateAccountsListContainerQuery_graphql_default = node70;

// src/components/accounts/components/__generated__/CandidateAccountsListContainerPaginationQuery.graphql.ts
var node71 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": {
        "updatedAt": "DESC"
      },
      "kind": "LocalArgument",
      "name": "order"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  }, v2 = {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }, v3 = {
    "kind": "Variable",
    "name": "order",
    "variableName": "order"
  }, v4 = [
    v1,
    v2,
    v3,
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "CandidateAccountsListContainerPaginationQuery",
      "selections": [
        {
          "args": [
            v1,
            v2,
            v3
          ],
          "kind": "FragmentSpread",
          "name": "CandidateAccountsListContainer_list"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "CandidateAccountsListContainerPaginationQuery",
      "selections": [
        {
          "alias": "list",
          "args": v4,
          "concreteType": "AccountCandidateAccountsConnection",
          "kind": "LinkedField",
          "name": "accountCandidateAccounts",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountCandidateAccountsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AccountsCandidateAccount",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "firstName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "lastName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "email",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "accountId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "list",
          "args": v4,
          "filters": [
            "order",
            "where"
          ],
          "handle": "connection",
          "key": "CandidateAccountsList_list",
          "kind": "LinkedHandle",
          "name": "accountCandidateAccounts"
        }
      ]
    },
    "params": {
      "cacheID": "b6146c0c62393aeffe24a11a2271ebc6",
      "id": null,
      "metadata": {},
      "name": "CandidateAccountsListContainerPaginationQuery",
      "operationKind": "query",
      "text": "query CandidateAccountsListContainerPaginationQuery(\n  $after: String\n  $first: Int = 10\n  $order: [AccountsCandidateAccountSort!] = {updatedAt: DESC}\n  $where: AccountsCandidateAccountFilter\n) {\n  ...CandidateAccountsListContainer_list_gOVF5\n}\n\nfragment CandidateAccountRow_account on AccountsCandidateAccount {\n  id\n  accountId\n  code\n  firstName\n  lastName\n  email\n}\n\nfragment CandidateAccountsListContainer_list_gOVF5 on Query {\n  list: accountCandidateAccounts(first: $first, after: $after, order: $order, where: $where) {\n    ...CandidateAccountsListHeader_data\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        code\n        firstName\n        lastName\n        updatedAt\n        email\n        ...CandidateAccountRow_account\n        __typename\n      }\n    }\n  }\n}\n\nfragment CandidateAccountsListHeader_data on AccountCandidateAccountsConnection {\n  pageInfo {\n    hasNextPage\n    hasPreviousPage\n    startCursor\n    endCursor\n  }\n  totalCount\n  edges {\n    cursor\n    node {\n      id\n      code\n      firstName\n      lastName\n      updatedAt\n      email\n      ...CandidateAccountRow_account\n    }\n  }\n}\n"
    }
  };
}();
node71.hash = "a3904eed428564ccd0700eac4fe76fa5";
var CandidateAccountsListContainerPaginationQuery_graphql_default = node71;

// src/components/accounts/components/__generated__/CandidateAccountsListContainer_list.graphql.ts
var node73 = function() {
  var v0 = [
    "list"
  ];
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
      },
      {
        "defaultValue": 10,
        "kind": "LocalArgument",
        "name": "first"
      },
      {
        "defaultValue": {
          "updatedAt": "DESC"
        },
        "kind": "LocalArgument",
        "name": "order"
      },
      {
        "kind": "RootArgument",
        "name": "where"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": v0
        }
      ],
      "refetch": {
        "connection": {
          "forward": {
            "count": "first",
            "cursor": "after"
          },
          "backward": null,
          "path": v0
        },
        "fragmentPathInResult": [],
        "operation": CandidateAccountsListContainerPaginationQuery_graphql_default
      }
    },
    "name": "CandidateAccountsListContainer_list",
    "selections": [
      {
        "alias": "list",
        "args": [
          {
            "kind": "Variable",
            "name": "order",
            "variableName": "order"
          },
          {
            "kind": "Variable",
            "name": "where",
            "variableName": "where"
          }
        ],
        "concreteType": "AccountCandidateAccountsConnection",
        "kind": "LinkedField",
        "name": "__CandidateAccountsList_list_connection",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CandidateAccountsListHeader_data"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountCandidateAccountsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "AccountsCandidateAccount",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "code",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "firstName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lastName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "updatedAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "email",
                    "storageKey": null
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "CandidateAccountRow_account"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node73.hash = "a3904eed428564ccd0700eac4fe76fa5";
var CandidateAccountsListContainer_list_graphql_default = node73;

// src/components/accounts/components/CandidateAccountsListContainer.tsx
import { Suspense as Suspense19, useCallback as useCallback41, useMemo as useMemo10, useTransition } from "react";
import { useLazyLoadQuery as useLazyLoadQuery12, usePaginationFragment as usePaginationFragment13 } from "react-relay";
import { formatDistanceToNow as formatDistanceToNow8, parseISO as parseISO8 } from "date-fns";
import {
  DefaultListLayoutItemHeader as DefaultListLayoutItemHeader7,
  DefaultListLayoutSectionElement as DefaultListLayoutSectionElement7,
  EdSkeleton as EdSkeleton10,
  ListLayout as ListLayout8
} from "shared-ui";
import { isNotNullOrUndefined as isNotNullOrUndefined10 } from "shared-lib";

// src/components/accounts/lib/CandidateSearch.ts
import { formatForApi } from "shared-lib";
var defaultFilter = {};
function isNotNullOrUndefined9(value) {
  return value !== void 0 && value !== null;
}
function isNotNullOrUndefinedOrEmpty(value) {
  return value !== void 0 && value !== null && value !== "";
}
function createCandidateSearchParameters(source, state) {
  if (!state) {
    return defaultFilter;
  }
  const and = [];
  if (isNotNullOrUndefined9(state.isAccountActivated)) {
    and.push({
      isAccountActivated: { eq: state.isAccountActivated }
    });
  }
  if (isNotNullOrUndefined9(state.isAnonymised)) {
    and.push({
      anonymisedOn: { gt: formatForApi(/* @__PURE__ */ new Date("2000-01-01")) }
    });
  }
  if (isNotNullOrUndefined9(state.isDeactivated)) {
    and.push({
      isDeactivated: { eq: state.isDeactivated }
    });
  }
  if (isNotNullOrUndefined9(state.isGdprConsented)) {
    and.push({
      isGdprConsented: { eq: state.isGdprConsented }
    });
  }
  if (isNotNullOrUndefined9(state.isSuspended)) {
    and.push({
      isSuspended: { eq: state.isSuspended }
    });
  }
  if (isNotNullOrUndefined9(state.isTestUser)) {
    and.push({
      isTestUser: { eq: state.isTestUser }
    });
  }
  if (isNotNullOrUndefinedOrEmpty(state.query)) {
    and.push({
      or: [
        { firstName: { startsWith: state.query } },
        { lastName: { startsWith: state.query } },
        { emailAddress: { startsWith: state.query } }
      ]
    });
  }
  const where = {
    and
  };
  console.log(`createCandidateSearchParameters: source: ${source}`);
  console.log(state);
  console.log(where);
  return where;
}

// src/components/accounts/hooks/UseCandidateSearchParameters.ts
import { useCallback as useCallback39 } from "react";
import { useLocalStorage as useLocalStorage3 } from "react-use";
var defaultParameters = {
  query: void 0,
  isAccountActivated: true,
  isAnonymised: void 0,
  isGdprConsented: true,
  isDeactivated: void 0,
  isSuspended: void 0,
  isTestUser: void 0
};
function useCandidateSearchParameters() {
  const [current, set] = useLocalStorage3(
    "CandidateSearchParameters",
    defaultParameters
  );
  const change = useCallback39(
    (change2) => {
      const changed = {
        ...current,
        ...change2
      };
      set(changed);
    },
    [current, set]
  );
  return [current, change];
}
function useResetCandidateSearchParameters() {
  const [_, set] = useCandidateSearchParameters();
  const reset = useCallback39(() => {
    set(defaultParameters);
    return defaultParameters;
  }, [set]);
  return reset;
}

// src/components/accounts/components/__generated__/CandidateAccountsListHeader_data.graphql.ts
var node74 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CandidateAccountsListHeader_data",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PageInfo",
      "kind": "LinkedField",
      "name": "pageInfo",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hasNextPage",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hasPreviousPage",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "startCursor",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "endCursor",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AccountCandidateAccountsEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "cursor",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "AccountsCandidateAccount",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "code",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "firstName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "lastName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "updatedAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "email",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "CandidateAccountRow_account"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__id",
          "storageKey": null
        }
      ]
    }
  ],
  "type": "AccountCandidateAccountsConnection",
  "abstractKey": null
};
node74.hash = "5b6bbceb22cf8c519eb4f1ee468b6ebf";
var CandidateAccountsListHeader_data_graphql_default = node74;

// src/components/accounts/components/CandidateAccountsListHeader.tsx
import { Suspense as Suspense18 } from "react";
import { useFragment as useFragment12 } from "react-relay";
import { Button as Button15, ButtonList as ButtonList9, EdSkeleton as EdSkeleton9 } from "shared-ui";

// src/components/accounts/components/CandidateAccountFilterContainer.tsx
import { useCallback as useCallback40 } from "react";
import { Disclosure } from "@headlessui/react";
import { ChevronUpIcon } from "@heroicons/react/20/solid";
import {
  OptionalCheckBox,
  Button as Button14,
  Size as Size7,
  DebouncedInput as DebouncedInput2
} from "shared-ui";
import { Fragment as Fragment16, jsx as jsx71, jsxs as jsxs43 } from "react/jsx-runtime";
var CandidateAccountFilterContainer = ({ onChange }) => {
  const [searchState, setSearchState] = useCandidateSearchParameters();
  const reset = useResetCandidateSearchParameters();
  const onQueryChange = useCallback40(
    (query) => {
      const newState = {
        ...searchState,
        query
      };
      setSearchState(newState);
      onChange(
        createCandidateSearchParameters(
          "CandidateAccountFilterContainer.onQueryChange",
          newState
        )
      );
    },
    [searchState, setSearchState, onChange]
  );
  const onFilterChange = useCallback40(
    (change) => {
      console.log("CandidateAccountFilterContainer.onFilterChange");
      console.log(`searchState: ${JSON.stringify(searchState)}`);
      console.log(`change: ${JSON.stringify(change)}`);
      const newState = {
        ...searchState,
        ...change
      };
      console.log(`newState: ${JSON.stringify(newState)}`);
      setSearchState(newState);
      const searchParameters = createCandidateSearchParameters(
        "CandidateAccountFilterContainer.onFilterChange",
        newState
      );
      console.log(`searchParameters: ${JSON.stringify(searchParameters)}`);
      onChange(searchParameters);
    },
    [searchState, setSearchState, onChange]
  );
  const onReset = useCallback40(() => {
    const newState = reset();
    setSearchState(newState);
    onChange(
      createCandidateSearchParameters(
        "CandidateAccountFilterContainer.onReset",
        newState
      )
    );
  }, [reset, setSearchState, onChange]);
  return /* @__PURE__ */ jsxs43("div", { className: "flex items-center gap-2", children: [
    /* @__PURE__ */ jsx71(
      CandidateAccountTextFilter,
      {
        onFilterChange: onQueryChange,
        value: searchState?.query
      }
    ),
    /* @__PURE__ */ jsx71(
      CandidateAccountBooleanFilters,
      {
        onFilterChange,
        filters: searchState
      }
    ),
    /* @__PURE__ */ jsx71("div", { children: /* @__PURE__ */ jsx71(
      Button14,
      {
        size: Size7.sm,
        outline: true,
        color: "primary",
        clicked: onReset,
        children: "Reset"
      }
    ) })
  ] });
};
var CandidateAccountTextFilter = ({
  value,
  onFilterChange
}) => {
  return /* @__PURE__ */ jsxs43("div", { className: "flex items-center p-2", children: [
    /* @__PURE__ */ jsx71("label", { className: "mr-4 text-gray-700", htmlFor: "filter", children: "Filter" }),
    /* @__PURE__ */ jsx71("div", { className: "sm:w-64", children: /* @__PURE__ */ jsx71(
      DebouncedInput2,
      {
        placeholder: " Name ",
        value: value ?? void 0,
        onValueChanged: (value2) => onFilterChange(value2)
      },
      "filter"
    ) })
  ] });
};
var CandidateAccountBooleanFilters = ({
  filters,
  onFilterChange
}) => {
  const onToggleAccountActivated = useCallback40(
    (checked) => {
      onFilterChange({
        isAccountActivated: checked
      });
    },
    [onFilterChange]
  );
  const onToggleDeactivated = useCallback40(
    (checked) => {
      onFilterChange({
        isDeactivated: checked
      });
    },
    [onFilterChange]
  );
  const onToggleGdprConsented = useCallback40(
    (checked) => {
      onFilterChange({
        isGdprConsented: checked
      });
    },
    [onFilterChange]
  );
  const onToggleSuspended = useCallback40(
    (checked) => {
      onFilterChange({
        isSuspended: checked
      });
    },
    [onFilterChange]
  );
  const onToggleTestUser = useCallback40(
    (checked) => {
      onFilterChange({
        isTestUser: checked
      });
    },
    [onFilterChange]
  );
  const onToggleAnonymised = useCallback40(
    (checked) => {
      onFilterChange({
        isAnonymised: checked
      });
    },
    [onFilterChange]
  );
  return /* @__PURE__ */ jsx71("div", { className: "p-2", children: /* @__PURE__ */ jsx71(Disclosure, { children: ({ open }) => /* @__PURE__ */ jsxs43(Fragment16, { children: [
    /* @__PURE__ */ jsxs43(Disclosure.Button, { className: "items-top bg-primary-800 hover:bg-primary-500 focus-visible:ring-primary-500/75 flex w-full justify-between gap-2 rounded-lg px-4 py-2 text-left text-sm font-medium focus:outline-none focus-visible:ring", children: [
      /* @__PURE__ */ jsx71("span", { className: "text-white", children: "Filter" }),
      /* @__PURE__ */ jsx71(
        ChevronUpIcon,
        {
          className: `${open ? "rotate-180 transform" : ""} h-5 w-5 text-white`
        }
      )
    ] }),
    /* @__PURE__ */ jsx71(Disclosure.Panel, { className: "px-4 pb-2 pt-4 text-sm text-gray-500", children: /* @__PURE__ */ jsxs43("div", { className: "flex flex-col gap-2", children: [
      /* @__PURE__ */ jsxs43("div", { className: "flex items-center justify-between gap-2", children: [
        /* @__PURE__ */ jsx71("div", { children: "Activated" }),
        /* @__PURE__ */ jsx71(
          OptionalCheckBox,
          {
            value: filters?.isAccountActivated,
            onChanged: onToggleAccountActivated,
            title: "Activated"
          }
        )
      ] }),
      /* @__PURE__ */ jsxs43("div", { className: "flex items-center justify-between gap-2", children: [
        /* @__PURE__ */ jsx71("div", { children: "Gdpr Consented" }),
        /* @__PURE__ */ jsx71(
          OptionalCheckBox,
          {
            value: filters?.isGdprConsented,
            onChanged: onToggleGdprConsented,
            title: "Gdpr Consented"
          }
        )
      ] }),
      /* @__PURE__ */ jsxs43("div", { className: "flex items-center justify-between gap-2", children: [
        /* @__PURE__ */ jsx71("div", { children: "Deactivated" }),
        /* @__PURE__ */ jsx71(
          OptionalCheckBox,
          {
            value: filters?.isDeactivated,
            onChanged: onToggleDeactivated,
            title: "Deactivated"
          }
        )
      ] }),
      /* @__PURE__ */ jsxs43("div", { className: "flex items-center justify-between gap-2", children: [
        /* @__PURE__ */ jsx71("div", { children: "Suspended" }),
        /* @__PURE__ */ jsx71(
          OptionalCheckBox,
          {
            value: filters?.isSuspended,
            onChanged: onToggleSuspended,
            title: "Suspended"
          }
        )
      ] }),
      /* @__PURE__ */ jsxs43("div", { className: "flex items-center justify-between gap-2", children: [
        /* @__PURE__ */ jsx71("div", { children: "Test Users" }),
        /* @__PURE__ */ jsx71(
          OptionalCheckBox,
          {
            value: filters?.isTestUser,
            onChanged: onToggleTestUser,
            title: "Test Users"
          }
        )
      ] }),
      /* @__PURE__ */ jsxs43("div", { className: "flex items-center justify-between gap-2", children: [
        /* @__PURE__ */ jsx71("div", { children: "Anonymised" }),
        /* @__PURE__ */ jsx71(
          OptionalCheckBox,
          {
            value: filters?.isAnonymised,
            onChanged: onToggleAnonymised,
            title: "Anonymised"
          }
        )
      ] })
    ] }) })
  ] }) }) });
};

// src/components/accounts/components/CandidateAccountsListHeader.tsx
import { Fragment as Fragment17, jsx as jsx73, jsxs as jsxs44 } from "react/jsx-runtime";
var fragmentDef10 = CandidateAccountsListHeader_data_graphql_default;
var CandidateAccountsListHeader = ({
  fragmentRef,
  onLoadNext,
  onLoadPrevious,
  onFilter
}) => {
  const data = useFragment12(
    fragmentDef10,
    fragmentRef
  );
  const { pageInfo } = data;
  return /* @__PURE__ */ jsxs44("div", { className: "flex items-center justify-between gap-2 border bg-white p-2", children: [
    /* @__PURE__ */ jsx73("div", { children: /* @__PURE__ */ jsx73(CandidateAccountFilterContainer, { onChange: onFilter }) }),
    /* @__PURE__ */ jsx73("div", { children: /* @__PURE__ */ jsx73(Suspense18, { fallback: /* @__PURE__ */ jsx73(EdSkeleton9, {}), children: /* @__PURE__ */ jsx73(ButtonList9, { children: pageInfo && /* @__PURE__ */ jsxs44(Fragment17, { children: [
      /* @__PURE__ */ jsx73("div", { children: /* @__PURE__ */ jsx73(
        Button15,
        {
          color: "primary",
          clicked: onLoadPrevious,
          disabled: !pageInfo.hasPreviousPage,
          children: "Previous"
        }
      ) }),
      /* @__PURE__ */ jsx73("div", { children: /* @__PURE__ */ jsx73(
        Button15,
        {
          color: "primary",
          clicked: onLoadNext,
          disabled: !pageInfo.hasNextPage,
          children: "Next"
        }
      ) })
    ] }) }) }) })
  ] });
};

// src/components/accounts/components/CandidateAccountsListContainer.tsx
import { jsx as jsx74, jsxs as jsxs45 } from "react/jsx-runtime";
var queryDef2 = CandidateAccountsListContainerQuery_graphql_default;
var fragmentDef11 = CandidateAccountsListContainer_list_graphql_default;
function createLinkTo(section) {
  const code = section.context.code;
  return `../../../view/${code}`;
}
var List = ({ fragmentRef }) => {
  const { data, loadNext, loadPrevious, hasNext, isLoadingNext, refetch } = usePaginationFragment13(fragmentDef11, fragmentRef);
  const [isLoading, startTransition] = useTransition();
  const onLoadNext = useCallback41(() => {
    loadNext(10);
  }, [loadNext]);
  const onLoadPrevious = useCallback41(() => {
    loadPrevious(10);
  }, [loadPrevious]);
  const onFilter = useCallback41(
    (where) => {
      startTransition(() => {
        refetch({ where });
      });
    },
    [refetch]
  );
  const { list } = data;
  const sections = (list?.edges || []).filter(isNotNullOrUndefined10).map((e) => e.node).map((ft) => {
    const name = `${ft.firstName} ${ft.lastName}`;
    return {
      key: ft.code.toString(),
      itemTitle: name,
      listTitle: /* @__PURE__ */ jsx74("div", { className: "flex flex-col gap-2", children: /* @__PURE__ */ jsxs45("div", { className: "flex items-center justify-between gap-2", children: [
        /* @__PURE__ */ jsx74("div", { className: "text-md font-medium uppercase", children: name }),
        /* @__PURE__ */ jsx74("div", { className: "text-md text-blue-500", children: ft.code })
      ] }) }),
      description: /* @__PURE__ */ jsxs45("div", { className: "pt-2 text-sm", children: [
        "Updated ",
        formatDistanceToNow8(parseISO8(ft.updatedAt))
      ] }),
      hideIcon: true,
      icon: () => null,
      iconForeground: "text-primary-700",
      iconBackground: "bg-primary-50",
      context: {
        code: ft.code
      },
      element: /* @__PURE__ */ jsx74(DefaultListLayoutSectionElement7, { children: /* @__PURE__ */ jsx74("div", { className: "grid", children: /* @__PURE__ */ jsx74("div", { children: ft.code }) }) })
    };
  });
  return /* @__PURE__ */ jsxs45("div", { children: [
    list && /* @__PURE__ */ jsx74(
      CandidateAccountsListHeader,
      {
        fragmentRef: list,
        onLoadNext,
        onLoadPrevious,
        onFilter
      }
    ),
    /* @__PURE__ */ jsx74(Suspense19, { fallback: /* @__PURE__ */ jsx74(EdSkeleton10, {}), children: /* @__PURE__ */ jsx74(
      ListLayout8,
      {
        sections,
        itemHeader: (s) => /* @__PURE__ */ jsx74(
          DefaultListLayoutItemHeader7,
          {
            title: "Candidates",
            to: createLinkTo,
            section: s
          }
        ),
        loadMore: onLoadNext,
        isLoading: false
      }
    ) })
  ] });
};
var CandidateAccountsListContainer = () => {
  const [searchState] = useCandidateSearchParameters();
  const where = useMemo10(() => {
    return createCandidateSearchParameters(
      "CandidateAccountsListContainer.init",
      searchState
    );
  }, []);
  const query = useLazyLoadQuery12(
    queryDef2,
    { where },
    {
      fetchPolicy: "store-and-network"
    }
  );
  return /* @__PURE__ */ jsx74("div", { className: "flex flex-col", children: /* @__PURE__ */ jsx74("div", { className: "flex-1", children: /* @__PURE__ */ jsx74(Suspense19, { fallback: /* @__PURE__ */ jsx74(EdSkeleton10, {}), children: /* @__PURE__ */ jsx74(List, { fragmentRef: query }) }) }) });
};

// src/components/accounts/components/__generated__/CandidateAccountsSearchQuery.graphql.ts
var node75 = function() {
  var v0 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "order"
  }, v1 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "where"
  }, v2 = {
    "kind": "Variable",
    "name": "order",
    "variableName": "order"
  }, v3 = {
    "kind": "Variable",
    "name": "where",
    "variableName": "where"
  }, v4 = [
    {
      "kind": "Literal",
      "name": "first",
      "value": 1
    },
    v2,
    v3
  ];
  return {
    "fragment": {
      "argumentDefinitions": [
        v0,
        v1
      ],
      "kind": "Fragment",
      "metadata": null,
      "name": "CandidateAccountsSearchQuery",
      "selections": [
        {
          "args": [
            v2,
            v3
          ],
          "kind": "FragmentSpread",
          "name": "CandidateAccountsList_candidates"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [
        v1,
        v0
      ],
      "kind": "Operation",
      "name": "CandidateAccountsSearchQuery",
      "selections": [
        {
          "alias": "candidates",
          "args": v4,
          "concreteType": "AccountCandidateAccountsConnection",
          "kind": "LinkedField",
          "name": "accountCandidateAccounts",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountCandidateAccountsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AccountsCandidateAccount",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "firstName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "lastName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "email",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "accountId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "candidates",
          "args": v4,
          "filters": [
            "where",
            "order"
          ],
          "handle": "connection",
          "key": "CandidateAccountsList_candidates",
          "kind": "LinkedHandle",
          "name": "accountCandidateAccounts"
        }
      ]
    },
    "params": {
      "cacheID": "3c3027ceb544217703498772fc9ebf37",
      "id": null,
      "metadata": {},
      "name": "CandidateAccountsSearchQuery",
      "operationKind": "query",
      "text": "query CandidateAccountsSearchQuery(\n  $where: AccountsCandidateAccountFilter!\n  $order: [AccountsCandidateAccountSort!]\n) {\n  ...CandidateAccountsList_candidates_28pUDr\n}\n\nfragment CandidateAccountRow_account on AccountsCandidateAccount {\n  id\n  accountId\n  code\n  firstName\n  lastName\n  email\n}\n\nfragment CandidateAccountsList_candidates_28pUDr on Query {\n  candidates: accountCandidateAccounts(where: $where, first: 1, order: $order) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    edges {\n      cursor\n      node {\n        id\n        code\n        firstName\n        lastName\n        updatedAt\n        email\n        ...CandidateAccountRow_account\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node75.hash = "ba263c0a8ac7ce88f88eb128adb59f8d";
var CandidateAccountsSearchQuery_graphql_default = node75;

// src/components/accounts/components/CandidateAccountsSearch.tsx
import { Suspense as Suspense20, useEffect as useEffect12 } from "react";
import {
  usePreloadedQuery as usePreloadedQuery5,
  useQueryLoader as useQueryLoader4
} from "react-relay";
import { useTextDebounce } from "shared-lib";
import { EdSkeleton as EdSkeleton11, Input as Input7 } from "shared-ui";
import { jsx as jsx75, jsxs as jsxs46 } from "react/jsx-runtime";
var queryDef3 = CandidateAccountsSearchQuery_graphql_default;
var order = [
  {
    updatedAt: "DESC"
  }
];
var ListLoader = ({ queryRef }) => {
  const data = usePreloadedQuery5(
    queryDef3,
    queryRef
  );
  return /* @__PURE__ */ jsx75(CandidateAccountsList, { fragmentRef: data });
};
var CandidateAccountsSearch = () => {
  const [queryReference, loadQuery4, disposeQuery] = useQueryLoader4(queryDef3);
  const [firstName, setFirstName] = useTextDebounce();
  const [lastName, setLastName] = useTextDebounce();
  const [email, setEmail] = useTextDebounce();
  useEffect12(() => {
    if (firstName === null && lastName === null && email === null) {
      return;
    }
    const or = [];
    if (firstName) {
      or.push({ firstName: { startsWith: firstName } });
    }
    if (lastName) {
      or.push({ lastName: { startsWith: lastName } });
    }
    if (email) {
      or.push({ emailAddress: { startsWith: email } });
    }
    const where = { or };
    loadQuery4({ where, order }, { fetchPolicy: "network-only" });
  }, [loadQuery4, firstName, lastName, email, order]);
  return /* @__PURE__ */ jsx75(Suspense20, { fallback: /* @__PURE__ */ jsx75(EdSkeleton11, {}), children: /* @__PURE__ */ jsxs46("div", { className: "", children: [
    /* @__PURE__ */ jsx75("div", { className: "border-b bg-white p-4", children: /* @__PURE__ */ jsxs46("div", { className: "flex items-center gap-2", children: [
      /* @__PURE__ */ jsx75("div", { className: "text-primary-500 pr-4", children: "Filter" }),
      /* @__PURE__ */ jsxs46("div", { className: "flex items-center gap-2", children: [
        /* @__PURE__ */ jsx75("label", { htmlFor: "search-first-name", children: "First Name" }),
        /* @__PURE__ */ jsx75(Input7, { name: "search-first-name", onValueChange: setFirstName })
      ] }),
      /* @__PURE__ */ jsxs46("div", { className: "flex items-center gap-2", children: [
        /* @__PURE__ */ jsx75("label", { htmlFor: "search-last-name", children: "Last Name" }),
        /* @__PURE__ */ jsx75(Input7, { name: "search-last-name", onValueChange: setLastName })
      ] }),
      /* @__PURE__ */ jsxs46("div", { className: "flex items-center gap-2", children: [
        /* @__PURE__ */ jsx75("label", { htmlFor: "search-email", children: "Email" }),
        /* @__PURE__ */ jsx75(Input7, { name: "search-email", onValueChange: setEmail })
      ] })
    ] }) }),
    /* @__PURE__ */ jsx75("div", { className: "", children: queryReference && /* @__PURE__ */ jsx75(ListLoader, { queryRef: queryReference }) })
  ] }) });
};

// src/components/rates/RateForm.tsx
import { useForm as useForm5 } from "react-hook-form";
import * as zod5 from "zod";
import { zodResolver as zodResolver5 } from "@hookform/resolvers/zod";
import { useToggle as useToggle2 } from "shared-lib";
import { ActionContainer as ActionContainer8, EditContainer } from "shared-ui";
import {
  ErrorField as ErrorField5,
  FormInputRow as FormInputRow4,
  RateType,
  FormInput as FormInput3,
  RadioListInput as RadioListInput2
} from "shared-ui";
import { GeoCountriesSearchBoxInput } from "feature-data-management";
import { Fragment as Fragment18, jsx as jsx76, jsxs as jsxs47 } from "react/jsx-runtime";
var FormSchema3 = zod5.object({
  min: zod5.number(),
  max: zod5.number(),
  countryCode: zod5.object({
    iso3: zod5.string(),
    name: zod5.string()
  }).optional(),
  payType: zod5.string().nonempty(),
  isPrivate: zod5.boolean().default(false)
});
var payTypesList = [
  {
    id: "PER_DAY",
    label: "Per Day"
  },
  {
    id: "PER_HOUR",
    label: "Per Hour"
  },
  {
    id: "PER_YEAR",
    label: "Per Year"
  }
];
var RateForm = ({ rate, onSave, isBusy }) => {
  const defaultValues = {
    min: rate?.minimumRateOfPay,
    max: rate?.maximumRateOfPay,
    payType: rate?.payType,
    isPrivate: false
  };
  if (rate && rate.currencyCode && rate.countryCode) {
    defaultValues.countryCode = {
      iso3: rate.countryCode,
      name: rate.currencyCode
    };
  }
  const { register, handleSubmit, formState, control } = useForm5({
    resolver: zodResolver5(FormSchema3),
    defaultValues
  });
  const { errors, isValid, isDirty } = formState;
  const onSubmit = handleSubmit(
    (valid) => {
      if (!valid.countryCode) {
        return;
      }
      const payType = valid.payType;
      const input = {
        countryCode: valid.countryCode.iso3,
        isPrivate: false,
        max: valid.max,
        min: valid.min,
        payType
      };
      onSave(isValid, input);
    },
    (invalid) => {
      console.log(invalid);
    }
  );
  let minimumRateOfPay = rate?.minimumRateOfPay.toString();
  let maximumRateOfPay = rate?.maximumRateOfPay.toString();
  if (rate) {
    const currencyFormatter = new Intl.NumberFormat(void 0, {
      style: "currency",
      currency: rate?.currencyCode ?? void 0,
      maximumFractionDigits: 0
    });
    minimumRateOfPay = currencyFormatter.format(rate.minimumRateOfPay);
    maximumRateOfPay = currencyFormatter.format(rate.maximumRateOfPay);
  }
  const [isEditable, toggleEditable] = useToggle2(false);
  return /* @__PURE__ */ jsxs47("div", { className: "xl:container", children: [
    !isEditable && /* @__PURE__ */ jsx76(Fragment18, { children: /* @__PURE__ */ jsx76(
      EditContainer,
      {
        value: /* @__PURE__ */ jsxs47("div", { className: "flex flex-col gap-3 font-medium text-gray-900 ", children: [
          /* @__PURE__ */ jsxs47("div", { className: "flex flex-col gap-1", children: [
            /* @__PURE__ */ jsx76("div", { className: "text-gray-400", children: "Min Rate" }),
            /* @__PURE__ */ jsx76("div", { children: minimumRateOfPay })
          ] }),
          /* @__PURE__ */ jsxs47("div", { className: "flex flex-col gap-1", children: [
            /* @__PURE__ */ jsx76("div", { className: "text-gray-400", children: "Desired Rate" }),
            /* @__PURE__ */ jsx76("div", { children: maximumRateOfPay })
          ] }),
          /* @__PURE__ */ jsxs47("div", { className: "flex flex-col gap-1", children: [
            /* @__PURE__ */ jsx76("div", { className: "text-gray-400", children: "Pay Type" }),
            /* @__PURE__ */ jsx76("div", { children: /* @__PURE__ */ jsx76(RateType, { payType: rate?.payType ?? "PER_DAY" }) })
          ] })
        ] }),
        onClick: toggleEditable
      }
    ) }),
    isEditable && /* @__PURE__ */ jsxs47(
      ActionContainer8,
      {
        onSubmit,
        isDirty,
        isSaving: isBusy,
        showCancel: true,
        onCancel: toggleEditable,
        children: [
          /* @__PURE__ */ jsxs47(FormInputRow4, { name: "min", title: "Min Rate", children: [
            /* @__PURE__ */ jsx76(
              FormInput3,
              {
                className: "mt-1",
                type: "number",
                placeholder: " e.g. \xA350 ",
                name: "min",
                required: true,
                register
              }
            ),
            /* @__PURE__ */ jsx76(ErrorField5, { field: errors.min })
          ] }),
          /* @__PURE__ */ jsxs47(FormInputRow4, { name: "max", title: "Desired Rate", children: [
            /* @__PURE__ */ jsx76(
              FormInput3,
              {
                className: "mt-1",
                type: "number",
                placeholder: " e.g. \xA370 ",
                name: "max",
                required: true,
                register
              }
            ),
            /* @__PURE__ */ jsx76(ErrorField5, { field: errors.max })
          ] }),
          /* @__PURE__ */ jsxs47(FormInputRow4, { name: "payType", title: "Pay Type", children: [
            /* @__PURE__ */ jsx76(
              RadioListInput2,
              {
                name: "payType",
                control,
                list: payTypesList
              }
            ),
            /* @__PURE__ */ jsx76(ErrorField5, { field: errors.payType })
          ] }),
          /* @__PURE__ */ jsxs47(FormInputRow4, { name: "countryCode", title: "Currency", children: [
            /* @__PURE__ */ jsx76(GeoCountriesSearchBoxInput, { name: "countryCode", control }),
            /* @__PURE__ */ jsx76(ErrorField5, { field: errors.countryCode })
          ] })
        ]
      }
    )
  ] });
};

// src/components/tasks/__generated__/AccountTaskLoaderQuery.graphql.ts
var node76 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "taskId"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "id",
      "variableName": "taskId"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "AccountTaskLoaderQuery",
      "selections": [
        {
          "alias": "task",
          "args": v1,
          "concreteType": "TasksCandidateTask",
          "kind": "LinkedField",
          "name": "tasksCandidateTaskById",
          "plural": false,
          "selections": [
            v2,
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "AccountTaskDetails_task"
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "AccountTaskLoaderQuery",
      "selections": [
        {
          "alias": "task",
          "args": v1,
          "concreteType": "TasksCandidateTask",
          "kind": "LinkedField",
          "name": "tasksCandidateTaskById",
          "plural": false,
          "selections": [
            v2,
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "candidateTaskId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "type",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "version",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "description",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "title",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "summary",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountId",
              "kind": "LinkedField",
              "name": "assignedTo",
              "plural": false,
              "selections": [
                v2
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "status",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "cb50180f5bbc1779aa7d6c0652fb0346",
      "id": null,
      "metadata": {},
      "name": "AccountTaskLoaderQuery",
      "operationKind": "query",
      "text": "query AccountTaskLoaderQuery(\n  $taskId: UUID!\n) {\n  task: tasksCandidateTaskById(id: $taskId) {\n    id\n    ...AccountTaskDetails_task\n  }\n}\n\nfragment AccountTaskDetails_task on TasksCandidateTask {\n  id\n  candidateTaskId\n  type\n  version\n  description\n  title\n  summary\n  ...VerifyPhoneCandidateTask_task\n}\n\nfragment VerifyPhoneCandidateTask_task on TasksCandidateTask {\n  id\n  candidateTaskId\n  assignedTo {\n    id\n  }\n  type\n  version\n  description\n  title\n  summary\n  status\n}\n"
    }
  };
}();
node76.hash = "0ac5fe8368af62ccc3be6bf363bfedeb";
var AccountTaskLoaderQuery_graphql_default = node76;

// src/components/tasks/__generated__/AccountTaskLoader_data.graphql.ts
var node77 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AccountTaskLoader_data",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "recruitProfileId",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AccountTaskDetails_profile"
    }
  ],
  "type": "RecruitProfile",
  "abstractKey": null
};
node77.hash = "14004cc75d3edf438e18669a8ead68e0";
var AccountTaskLoader_data_graphql_default = node77;

// src/components/tasks/AccountTaskLoader.tsx
import { useParams } from "react-router-dom";
import { useFragment as useFragment15, useLazyLoadQuery as useLazyLoadQuery13 } from "react-relay";
import { Button as Button16, ButtonList as ButtonList10 } from "shared-ui";

// src/components/tasks/__generated__/AccountTaskDetails_profile.graphql.ts
var node78 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AccountTaskDetails_profile",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "recruitProfileId",
      "storageKey": null
    }
  ],
  "type": "RecruitProfile",
  "abstractKey": null
};
node78.hash = "17e14afa81b88a809dbf6b4cc37658b6";
var AccountTaskDetails_profile_graphql_default = node78;

// src/components/tasks/__generated__/AccountTaskDetails_task.graphql.ts
var node79 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AccountTaskDetails_task",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "candidateTaskId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "version",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "summary",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "VerifyPhoneCandidateTask_task"
    }
  ],
  "type": "TasksCandidateTask",
  "abstractKey": null
};
node79.hash = "5178b2ac3e891b784780591f3b6f72ef";
var AccountTaskDetails_task_graphql_default = node79;

// src/components/tasks/AccountTaskDetails.tsx
import { useFragment as useFragment14 } from "react-relay";

// src/components/tasks/types/__generated__/VerifyPhoneCandidateTask_task.graphql.ts
var node80 = function() {
  var v0 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  };
  return {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "VerifyPhoneCandidateTask_task",
    "selections": [
      v0,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "candidateTaskId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountId",
        "kind": "LinkedField",
        "name": "assignedTo",
        "plural": false,
        "selections": [
          v0
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "type",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "version",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "description",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "title",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "summary",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      }
    ],
    "type": "TasksCandidateTask",
    "abstractKey": null
  };
}();
node80.hash = "f051f185afbb5bbbdde15d7eb17aaa94";
var VerifyPhoneCandidateTask_task_graphql_default = node80;

// src/components/tasks/types/VerifyPhoneCandidateTask.tsx
import { useFragment as useFragment13 } from "react-relay";
import { jsx as jsx77, jsxs as jsxs48 } from "react/jsx-runtime";
var fragmentDef12 = VerifyPhoneCandidateTask_task_graphql_default;
var VerifyPhoneCandidateTask = ({ fragmentRef, onCompleted }) => {
  const data = useFragment13(fragmentDef12, fragmentRef);
  return /* @__PURE__ */ jsxs48("div", { className: "sm:px-6 sm:py-5", children: [
    /* @__PURE__ */ jsx77(
      TaskDetailsHeader,
      {
        title: data.title,
        status: data.status,
        onSelected: onCompleted
      }
    ),
    /* @__PURE__ */ jsx77(
      CandidatePhoneVerify,
      {
        candidateId: data.assignedTo.id,
        onDone: onCompleted,
        onCancel: onCompleted
      }
    )
  ] });
};

// src/components/tasks/AccountTaskDetails.tsx
import { jsx as jsx78 } from "react/jsx-runtime";
var profileFragmentDef = AccountTaskDetails_profile_graphql_default;
var taskFragmentDef = AccountTaskDetails_task_graphql_default;
var AccountTaskDetails = ({
  taskFragmentRef,
  profileFragmentRef,
  onCompleted
}) => {
  const task = useFragment14(taskFragmentDef, taskFragmentRef);
  const profile = useFragment14(profileFragmentDef, profileFragmentRef);
  let taskType = /* @__PURE__ */ jsx78("div", {});
  switch (task.type) {
    case "VerifyPhoneCandidateTask": {
      taskType = /* @__PURE__ */ jsx78(
        VerifyPhoneCandidateTask,
        {
          fragmentRef: task,
          onCompleted
        }
      );
      break;
    }
  }
  return /* @__PURE__ */ jsx78("div", { className: "mt-4 p-2 sm:border sm:bg-white", children: taskType }, task.candidateTaskId);
};

// src/components/tasks/AccountTaskLoader.tsx
import { jsx as jsx79, jsxs as jsxs49 } from "react/jsx-runtime";
var graphqlQuery3 = AccountTaskLoaderQuery_graphql_default;
var fragmentDef13 = AccountTaskLoader_data_graphql_default;
var AccountTaskLoader = ({
  fragmentRef,
  onCompleted,
  onBack
}) => {
  const profile = useFragment15(fragmentDef13, fragmentRef);
  const { taskId } = useParams();
  const data = useLazyLoadQuery13(
    graphqlQuery3,
    { taskId },
    {
      fetchPolicy: "store-and-network"
    }
  );
  const { task } = data;
  if (!task) {
    return /* @__PURE__ */ jsx79("div", { children: "Could Not Load Task" });
  }
  return /* @__PURE__ */ jsxs49("div", { className: "p-2 sm:p-8", children: [
    /* @__PURE__ */ jsx79(ButtonList10, { children: /* @__PURE__ */ jsx79(Button16, { clicked: onBack, children: "Back" }) }),
    /* @__PURE__ */ jsx79(
      AccountTaskDetails,
      {
        taskFragmentRef: task,
        profileFragmentRef: profile,
        onCompleted
      }
    )
  ] });
};
export {
  AccountTaskLoader,
  CandidateAccountChecklist,
  CandidateAccountEmailEditor,
  CandidateAccountEmailVerifyForm,
  CandidateAccountGDPRConsentForm,
  CandidateAccountNameEditor,
  CandidateAccountResetPasswordTerms,
  CandidateAccountRow,
  CandidateAccountSearchBox,
  CandidateAccountSearchBoxInput,
  CandidateAccountSearchContainer,
  CandidateAccountSearchOptions,
  CandidateAccountSendResetPassword,
  CandidateAccountSetupContainer,
  CandidateAccountTermsForm,
  CandidateAccountsList,
  CandidateAccountsListContainer,
  CandidateAccountsSearch,
  CandidatePhoneContainer,
  CandidatePhoneEditor,
  CandidatePhoneVerificationButton,
  CandidatePhoneVerificationResend,
  CandidatePhoneVerificationSend,
  CandidatePhoneVerificationStatusLabel,
  CandidatePhoneVerify,
  PhoneEditingState,
  RateForm,
  candidateAccountHasCompletedRequiredSetup,
  createRoute as createCandidateImpersonateRoute
};
/*! Bundled license information:

oidc-client/lib/oidc-client.min.js:
  (*!
  Copyright (c) 2011, Yahoo! Inc. All rights reserved.
  Code licensed under the BSD License:
  http://developer.yahoo.com/yui/license.html
  version: 2.9.0
  *)
  (*! CryptoJS v3.1.2 core-fix.js
   * code.google.com/p/crypto-js
   * (c) 2009-2013 by Jeff Mott. All rights reserved.
   * code.google.com/p/crypto-js/wiki/License
   * THIS IS FIX of 'core.js' to fix Hmac issue.
   * https://code.google.com/p/crypto-js/issues/detail?id=84
   * https://crypto-js.googlecode.com/svn-history/r667/branches/3.x/src/core.js
   *)
  (*! (c) Tom Wu | http://www-cs-students.stanford.edu/~tjw/jsbn/
   *)
  (*! Mike Samuel (c) 2009 | code.google.com/p/json-sans-eval
   *)
  (*!
   * The buffer module from node.js, for the browser.
   *
   * @author   Feross Aboukhadijeh <http://feross.org>
   * @license  MIT
   *)
  (*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> *)

lodash-es/lodash.js:
  (**
   * @license
   * Lodash (Custom Build) <https://lodash.com/>
   * Build: `lodash modularize exports="es" -o ./`
   * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
   * Released under MIT license <https://lodash.com/license>
   * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
   * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
   *)
*/
/*! Bundled license information:

lodash/lodash.js:
  (**
   * @license
   * Lodash <https://lodash.com/>
   * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
   * Released under MIT license <https://lodash.com/license>
   * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
   * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
   *)
*/
//# sourceMappingURL=index.mjs.map